import * as React from "react";

//#region src/BrandIcon/icons/AppStore.svg
var _path$505;
var _path2$351;
var _path3$181;
function _extends$522() {
	return _extends$522 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$522.apply(null, arguments);
}
var SvgAppStore = function SvgAppStore(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$522({
		xmlns: "http://www.w3.org/2000/svg",
		width: 120,
		height: 40,
		fill: "none",
		viewBox: "0 0 120 40"
	}, props), _path$505 || (_path$505 = /*#__PURE__*/ React.createElement("path", {
		fill: "#A6A6A6",
		d: "M110.135 0H9.535Q8.986 0 8.44.002q-.457.004-.919.013-1.008.012-2.004.177a6.7 6.7 0 0 0-1.9.627A6.44 6.44 0 0 0 .193 5.522a13 13 0 0 0-.179 2.002c-.01.306-.01.614-.015.92V31.56c.005.31.006.611.015.922q.012 1.007.18 2.002c.11.663.32 1.305.624 1.904.303.598.701 1.143 1.179 1.614.473.477 1.019.875 1.618 1.179s1.24.517 1.901.63a13.5 13.5 0 0 0 2.004.178c.31.006.613.01.919.01.366.002.728.002 1.095.002h100.6c.359 0 .724 0 1.084-.002.304 0 .617-.004.922-.01q1.006-.013 2-.177a6.8 6.8 0 0 0 1.908-.631 6.3 6.3 0 0 0 1.617-1.179 6.4 6.4 0 0 0 1.182-1.614c.302-.6.51-1.242.619-1.904a13.6 13.6 0 0 0 .185-2.002c.004-.31.004-.612.004-.922q.01-.542.008-1.094V9.536q.002-.55-.008-1.091.001-.461-.004-.921a13.6 13.6 0 0 0-.185-2.002 6.7 6.7 0 0 0-.619-1.904 6.47 6.47 0 0 0-2.799-2.8 6.8 6.8 0 0 0-1.908-.626q-.993-.166-2-.177c-.305-.005-.618-.01-.922-.013-.36-.002-.725-.002-1.084-.002"
	})), _path2$351 || (_path2$351 = /*#__PURE__*/ React.createElement("path", {
		fill: "#000",
		d: "M8.445 39.125c-.305 0-.602-.004-.904-.01a13 13 0 0 1-1.87-.164 5.9 5.9 0 0 1-1.656-.548 5.4 5.4 0 0 1-1.397-1.016 5.3 5.3 0 0 1-1.02-1.397 5.7 5.7 0 0 1-.544-1.657 12.4 12.4 0 0 1-.166-1.875c-.007-.21-.015-.913-.015-.913v-23.1s.009-.692.015-.895a12.4 12.4 0 0 1 .165-1.872 5.8 5.8 0 0 1 .544-1.662c.26-.518.603-.99 1.015-1.398A5.57 5.57 0 0 1 5.668 1.05Q6.6.9 7.543.887l.902-.012h102.769l.913.013a12.4 12.4 0 0 1 1.858.162 6 6 0 0 1 1.671.548 5.6 5.6 0 0 1 2.415 2.42c.261.52.441 1.076.536 1.65q.155.936.173 1.886c.003.284.003.588.003.89.008.375.008.732.008 1.092v20.929c0 .363 0 .718-.008 1.075 0 .325 0 .623-.004.93q-.017.933-.171 1.853a5.7 5.7 0 0 1-.54 1.67 5.5 5.5 0 0 1-1.015 1.386c-.409.414-.881.76-1.4 1.023a5.9 5.9 0 0 1-1.668.55q-.928.15-1.869.162c-.293.007-.599.011-.897.011l-1.084.002z"
	})), _path3$181 || (_path3$181 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M24.769 20.3a4.95 4.95 0 0 1 2.357-4.151 5.07 5.07 0 0 0-3.992-2.158c-1.679-.176-3.307 1.005-4.163 1.005-.872 0-2.19-.988-3.608-.958a5.32 5.32 0 0 0-4.473 2.727c-1.934 3.349-.491 8.27 1.361 10.977.927 1.325 2.01 2.805 3.428 2.753 1.387-.058 1.905-.885 3.58-.885 1.658 0 2.144.885 3.59.852 1.489-.025 2.426-1.332 3.32-2.67a11 11 0 0 0 1.52-3.092 4.78 4.78 0 0 1-2.92-4.4M22.037 12.211a4.87 4.87 0 0 0 1.115-3.49 4.96 4.96 0 0 0-3.208 1.659 4.64 4.64 0 0 0-1.143 3.361 4.1 4.1 0 0 0 3.236-1.53M42.303 27.14h-4.734l-1.137 3.356h-2.005l4.484-12.418h2.083l4.483 12.418h-2.039zm-4.244-1.55h3.752l-1.85-5.446h-.051zM55.16 25.97c0 2.813-1.506 4.62-3.778 4.62a3.07 3.07 0 0 1-2.849-1.583h-.043v4.484h-1.858V21.443h1.799v1.505h.034a3.21 3.21 0 0 1 2.882-1.6c2.298 0 3.813 1.816 3.813 4.622m-1.91 0c0-1.833-.947-3.038-2.393-3.038-1.42 0-2.375 1.23-2.375 3.038 0 1.824.955 3.046 2.375 3.046 1.446 0 2.393-1.197 2.393-3.046M65.125 25.97c0 2.813-1.506 4.62-3.779 4.62a3.07 3.07 0 0 1-2.848-1.583h-.043v4.484h-1.859V21.443h1.8v1.505h.033a3.21 3.21 0 0 1 2.883-1.6c2.298 0 3.813 1.816 3.813 4.622m-1.91 0c0-1.833-.948-3.038-2.393-3.038-1.42 0-2.375 1.23-2.375 3.038 0 1.824.955 3.046 2.375 3.046 1.445 0 2.393-1.197 2.393-3.046M71.71 27.036c.138 1.232 1.335 2.04 2.97 2.04 1.566 0 2.693-.808 2.693-1.919 0-.964-.68-1.54-2.29-1.936l-1.609-.388c-2.28-.55-3.339-1.617-3.339-3.348 0-2.142 1.868-3.614 4.52-3.614 2.623 0 4.422 1.472 4.483 3.614H77.26c-.112-1.239-1.136-1.987-2.633-1.987s-2.522.757-2.522 1.858c0 .878.654 1.395 2.255 1.79l1.368.336c2.548.603 3.607 1.626 3.607 3.443 0 2.323-1.85 3.778-4.794 3.778-2.754 0-4.614-1.42-4.734-3.667zM83.346 19.3v2.142h1.722v1.472h-1.722v4.991c0 .776.345 1.137 1.102 1.137q.306-.006.611-.043v1.463q-.511.095-1.032.086c-1.833 0-2.548-.689-2.548-2.444v-5.19h-1.316v-1.472h1.316V19.3zM86.065 25.97c0-2.849 1.678-4.639 4.294-4.639 2.625 0 4.295 1.79 4.295 4.639 0 2.856-1.661 4.638-4.295 4.638s-4.294-1.782-4.294-4.638m6.695 0c0-1.954-.895-3.108-2.4-3.108-1.507 0-2.401 1.162-2.401 3.108 0 1.962.894 3.106 2.4 3.106s2.401-1.144 2.401-3.106M96.186 21.442h1.773v1.541h.043a2.16 2.16 0 0 1 2.177-1.635q.323-.002.637.069v1.738a2.6 2.6 0 0 0-.835-.112 1.872 1.872 0 0 0-1.936 2.083v5.37h-1.859zM109.385 27.837c-.25 1.643-1.851 2.771-3.899 2.771-2.634 0-4.268-1.764-4.268-4.595 0-2.84 1.643-4.682 4.19-4.682 2.505 0 4.08 1.72 4.08 4.466v.637h-6.394v.112a2.35 2.35 0 0 0 1.458 2.391c.31.127.643.186.977.173a2.05 2.05 0 0 0 2.091-1.273zm-6.283-2.702h4.527A2.185 2.185 0 0 0 106.284 23a2.2 2.2 0 0 0-.876-.163 2.293 2.293 0 0 0-2.306 2.298M37.826 8.731a2.64 2.64 0 0 1 2.808 2.965c0 1.906-1.03 3.002-2.808 3.002h-2.155V8.731zm-1.228 5.123h1.125a1.875 1.875 0 0 0 1.967-2.146 1.88 1.88 0 0 0-1.967-2.134h-1.125zM41.68 12.445a2.132 2.132 0 1 1 4.248 0 2.135 2.135 0 1 1-4.247 0m3.334 0c0-.976-.439-1.547-1.208-1.547-.773 0-1.207.57-1.207 1.547 0 .983.434 1.55 1.207 1.55.77 0 1.208-.57 1.208-1.55M51.573 14.698h-.922l-.93-3.316h-.07l-.927 3.316h-.913l-1.242-4.503h.902l.806 3.436h.067l.925-3.436h.853l.926 3.436h.07l.803-3.436h.889zM53.854 10.195h.855v.715h.066a1.35 1.35 0 0 1 1.344-.802 1.464 1.464 0 0 1 1.559 1.675v2.915h-.889v-2.692c0-.724-.314-1.084-.972-1.084a1.032 1.032 0 0 0-1.075 1.142v2.634h-.889zM59.094 8.437h.888v6.26h-.888zM61.218 12.445a2.134 2.134 0 1 1 4.247 0 2.132 2.132 0 0 1-3.704 1.64 2.13 2.13 0 0 1-.543-1.64m3.333 0c0-.977-.439-1.547-1.208-1.547-.773 0-1.207.57-1.207 1.547 0 .983.434 1.55 1.207 1.55.77 0 1.208-.57 1.208-1.55M66.4 13.424c0-.81.604-1.277 1.676-1.344l1.22-.07v-.389c0-.475-.315-.744-.922-.744-.497 0-.84.182-.939.5h-.86c.09-.773.818-1.269 1.84-1.269 1.128 0 1.765.562 1.765 1.513v3.077h-.855v-.633h-.07a1.52 1.52 0 0 1-1.353.707 1.36 1.36 0 0 1-1.501-1.348m2.895-.384v-.377l-1.1.07c-.62.042-.9.253-.9.65 0 .405.351.641.834.641a1.06 1.06 0 0 0 1.166-.984M71.348 12.445c0-1.423.732-2.325 1.87-2.325a1.48 1.48 0 0 1 1.38.79h.067V8.437h.888v6.26h-.851v-.71h-.07a1.56 1.56 0 0 1-1.415.785c-1.145 0-1.869-.901-1.869-2.328m.918 0c0 .955.45 1.53 1.203 1.53.75 0 1.212-.584 1.212-1.527 0-.938-.468-1.53-1.212-1.53-.748 0-1.203.58-1.203 1.527M79.23 12.445a2.134 2.134 0 1 1 4.247 0 2.135 2.135 0 1 1-4.247 0m3.333 0c0-.976-.439-1.547-1.208-1.547-.772 0-1.207.57-1.207 1.547 0 .983.435 1.55 1.207 1.55.77 0 1.208-.57 1.208-1.55M84.67 10.195h.855v.715h.066a1.35 1.35 0 0 1 1.344-.802 1.464 1.464 0 0 1 1.559 1.675v2.915h-.889v-2.692c0-.724-.315-1.084-.972-1.084a1.032 1.032 0 0 0-1.075 1.142v2.634h-.889zM93.515 9.074v1.142h.976v.748h-.976v2.315c0 .472.195.679.637.679q.17-.001.339-.02v.74q-.24.042-.484.045c-.988 0-1.382-.348-1.382-1.216v-2.543h-.714v-.749h.715V9.074zM95.705 8.437h.88v2.482h.07a1.39 1.39 0 0 1 1.374-.807 1.485 1.485 0 0 1 1.55 1.679v2.907h-.889V12.01c0-.72-.335-1.084-.963-1.084a1.053 1.053 0 0 0-1.134 1.142v2.63h-.888zM104.761 13.482a1.83 1.83 0 0 1-1.951 1.303 2.04 2.04 0 0 1-2.01-1.447 2 2 0 0 1-.07-.877 2.077 2.077 0 0 1 2.076-2.353c1.253 0 2.009.856 2.009 2.27v.31h-3.18v.05a1.19 1.19 0 0 0 1.199 1.29 1.08 1.08 0 0 0 1.072-.546zm-3.126-1.451h2.275a1.09 1.09 0 0 0-1.109-1.167 1.15 1.15 0 0 0-1.081.718 1.2 1.2 0 0 0-.085.449"
	})));
};

//#endregion
//#region src/BrandIcon/icons/GooglePlay.svg
var _path$504;
var _path2$350;
var _path3$180;
var _path4$66;
var _path5$32;
var _path6$18;
var _path7$14;
var _path8$13;
var _defs$24;
function _extends$521() {
	return _extends$521 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$521.apply(null, arguments);
}
var SvgGooglePlay = function SvgGooglePlay(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$521({
		xmlns: "http://www.w3.org/2000/svg",
		width: 204,
		height: 59,
		fill: "none",
		viewBox: "0 0 204 59"
	}, props), _path$504 || (_path$504 = /*#__PURE__*/ React.createElement("path", {
		fill: "#000",
		d: "M196.396 59H7.554C3.4 59 0 55.68 0 51.625V7.375C0 3.321 3.401 0 7.554 0h188.842c4.153 0 7.554 3.32 7.554 7.375v44.25c0 4.054-3.401 7.375-7.554 7.375"
	})), _path2$350 || (_path2$350 = /*#__PURE__*/ React.createElement("path", {
		fill: "#A6A6A6",
		d: "M196.396 1.182c3.498 0 6.344 2.778 6.344 6.193v44.25c0 3.415-2.846 6.193-6.344 6.193H7.554c-3.498 0-6.344-2.778-6.344-6.193V7.375c0-3.415 2.846-6.193 6.344-6.193zm0-1.182H7.554C3.4 0 0 3.32 0 7.375v44.25C0 55.679 3.401 59 7.554 59h188.842c4.153 0 7.554-3.32 7.554-7.375V7.375c0-4.054-3.401-7.375-7.554-7.375"
	})), _path3$180 || (_path3$180 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		stroke: "#fff",
		strokeMiterlimit: 10,
		strokeWidth: .16,
		d: "M71.636 15.11c0 1.231-.378 2.218-1.122 2.953q-1.286 1.31-3.335 1.311c-1.305 0-2.42-.446-3.333-1.325-.916-.893-1.373-1.988-1.373-3.299q0-1.964 1.373-3.291c.914-.887 2.028-1.333 3.333-1.333.65 0 1.269.13 1.86.374.59.245 1.069.577 1.416.987l-.79.778c-.605-.7-1.43-1.044-2.486-1.044q-1.427-.001-2.478.98-1.04.984-1.04 2.549c0 1.044.347 1.9 1.04 2.557.7.647 1.526.98 2.478.98 1.01 0 1.86-.333 2.53-.987q.661-.649.76-1.794h-3.29V14.44h4.389c.053.23.068.454.068.67ZM78.598 11.415h-4.122v2.802h3.716v1.066h-3.716v2.802h4.122v1.086h-5.29V10.33h5.29zM83.512 19.171h-1.167v-7.756h-2.529v-1.086h6.226v1.086h-2.53zM90.548 19.171V10.33h1.165v8.842zM96.878 19.171h-1.157v-7.756h-2.538v-1.086h6.233v1.086h-2.538zM111.204 18.034q-1.34 1.34-3.32 1.34c-1.328 0-2.434-.446-3.328-1.34q-1.336-1.34-1.335-3.284 0-1.944 1.335-3.284c.894-.894 2-1.34 3.328-1.34 1.312 0 2.419.446 3.312 1.348.899.9 1.343 1.987 1.343 3.276q0 1.944-1.335 3.284Zm-5.784-.741c.672.661 1.489.993 2.464.993.967 0 1.792-.332 2.457-.994.67-.661 1.01-1.511 1.01-2.542s-.34-1.88-1.01-2.543c-.665-.661-1.49-.993-2.457-.993-.975 0-1.792.332-2.464.993-.671.662-1.011 1.512-1.011 2.543 0 1.03.34 1.88 1.011 2.543ZM114.176 19.171V10.33h1.416l4.404 6.877h.051l-.051-1.7v-5.177h1.165v8.842h-1.216l-4.611-7.216h-.051l.051 1.707v5.51z"
	})), _path4$66 || (_path4$66 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M102.934 32.085c-3.548 0-6.447 2.636-6.447 6.274 0 3.608 2.899 6.273 6.447 6.273 3.556 0 6.455-2.664 6.455-6.273 0-3.638-2.899-6.274-6.455-6.274m0 10.076c-1.947 0-3.622-1.569-3.622-3.802 0-2.262 1.675-3.803 3.622-3.803s3.63 1.541 3.63 3.803c0 2.233-1.683 3.802-3.63 3.802M88.867 32.085c-3.556 0-6.447 2.636-6.447 6.274 0 3.608 2.891 6.273 6.447 6.273 3.554 0 6.447-2.664 6.447-6.273 0-3.638-2.893-6.274-6.447-6.274m0 10.076c-1.948 0-3.63-1.569-3.63-3.802 0-2.262 1.682-3.803 3.63-3.803s3.622 1.541 3.622 3.803c0 2.233-1.675 3.802-3.622 3.802m-16.739-8.153v2.666h6.521c-.19 1.49-.7 2.585-1.482 3.348-.952.922-2.434 1.946-5.039 1.946-4.013 0-7.155-3.163-7.155-7.08s3.142-7.08 7.155-7.08c2.17 0 3.749.827 4.914 1.9l1.924-1.878c-1.63-1.52-3.797-2.687-6.838-2.687-5.502 0-10.127 4.372-10.127 9.745s4.625 9.744 10.127 9.744c2.975 0 5.209-.952 6.965-2.736 1.8-1.758 2.36-4.228 2.36-6.223 0-.62-.052-1.19-.147-1.665zm68.448 2.067c-.53-1.403-2.168-3.99-5.503-3.99-3.304 0-6.056 2.542-6.056 6.274 0 3.514 2.723 6.273 6.374 6.273 2.951 0 4.655-1.757 5.355-2.78l-2.19-1.426c-.731 1.044-1.726 1.735-3.165 1.735-1.43 0-2.455-.64-3.112-1.9l8.594-3.473zm-8.762 2.089a3.48 3.48 0 0 1 3.356-3.658c1.121 0 2.073.547 2.39 1.331zm-6.985 6.086h2.825V25.813h-2.825zm-4.627-10.767h-.094c-.635-.734-1.845-1.398-3.379-1.398-3.218 0-6.16 2.758-6.16 6.294 0 3.517 2.942 6.253 6.16 6.253 1.534 0 2.744-.67 3.379-1.425h.094v.9c0 2.398-1.312 3.687-3.429 3.687-1.726 0-2.797-1.217-3.239-2.24l-2.457 1c.708 1.664 2.584 3.71 5.696 3.71 3.312 0 6.107-1.902 6.107-6.532V32.467h-2.678zm-3.231 8.678c-1.947 0-3.577-1.591-3.577-3.782 0-2.21 1.63-3.823 3.577-3.823 1.919 0 3.431 1.613 3.431 3.824 0 2.19-1.512 3.781-3.431 3.781m36.832-16.349h-6.757V44.25h2.818v-6.986h3.939c3.129 0 6.198-2.21 6.198-5.727 0-3.514-3.077-5.724-6.198-5.724m.073 8.887h-4.012v-6.322h4.012c2.104 0 3.305 1.706 3.305 3.16 0 1.427-1.201 3.162-3.305 3.162m17.417-2.65c-2.035 0-4.152.879-5.023 2.824l2.5 1.023c.539-1.023 1.528-1.355 2.574-1.355 1.462 0 2.944.857 2.967 2.37v.194c-.51-.287-1.601-.713-2.944-.713-2.693 0-5.437 1.447-5.437 4.148 0 2.471 2.206 4.062 4.685 4.062 1.896 0 2.943-.835 3.6-1.807h.096v1.425h2.721v-7.072c0-3.27-2.5-5.098-5.739-5.098m-.339 10.105c-.922 0-2.206-.447-2.206-1.562 0-1.427 1.601-1.975 2.987-1.975 1.241 0 1.823.268 2.576.62-.221 1.707-1.726 2.917-3.357 2.917m15.993-9.7-3.239 7.992h-.096l-3.349-7.992h-3.038l5.031 11.17-2.871 6.214h2.944l7.752-17.384zM161.549 44.25h2.825V25.813h-2.825z"
	})), _path5$32 || (_path5$32 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#a)",
		d: "M15.765 11.12c-.444.453-.701 1.16-.701 2.074v32.62c0 .914.257 1.62.7 2.074l.11.1 18.722-18.272v-.432L15.874 11.013z"
	})), _path6$18 || (_path6$18 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#b)",
		d: "m40.83 35.81-6.234-6.094v-.432l6.241-6.093.14.079 7.391 4.106c2.11 1.165 2.11 3.083 0 4.255l-7.391 4.099z"
	})), _path7$14 || (_path7$14 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#c)",
		d: "m40.977 35.73-6.381-6.23-18.831 18.388c.7.719 1.843.805 3.142.086z"
	})), _path8$13 || (_path8$13 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#d)",
		d: "m40.977 23.27-22.07-12.244c-1.3-.712-2.442-.625-3.142.094l18.83 18.38z"
	})), _defs$24 || (_defs$24 = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
		id: "a",
		x1: 32.934,
		x2: 8.187,
		y1: 46.153,
		y2: 20.807,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#00A0FF" }), /*#__PURE__*/ React.createElement("stop", {
		offset: .007,
		stopColor: "#00A1FF"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .26,
		stopColor: "#00BEFF"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .512,
		stopColor: "#00D2FF"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .76,
		stopColor: "#00DFFF"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#00E3FF"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "b",
		x1: 51.115,
		x2: 14.56,
		y1: 29.498,
		y2: 29.498,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#FFE000" }), /*#__PURE__*/ React.createElement("stop", {
		offset: .409,
		stopColor: "#FFBD00"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .775,
		stopColor: "orange"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#FF9C00"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "c",
		x1: 37.507,
		x2: 3.948,
		y1: 26.113,
		y2: -8.259,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#FF3A44" }), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#C31162"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "d",
		x1: 11.024,
		x2: 26.01,
		y1: 58.74,
		y2: 43.392,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#32A071" }), /*#__PURE__*/ React.createElement("stop", {
		offset: .069,
		stopColor: "#2DA771"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .476,
		stopColor: "#15CF74"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .801,
		stopColor: "#06E775"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#00F076"
	})))));
};

//#endregion
//#region src/BrandIcon/icons/MacAppStore.svg
var _path$503;
var _path2$349;
var _path3$179;
function _extends$520() {
	return _extends$520 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$520.apply(null, arguments);
}
var SvgMacAppStore = function SvgMacAppStore(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$520({
		xmlns: "http://www.w3.org/2000/svg",
		width: 157,
		height: 40,
		fill: "none",
		viewBox: "0 0 157 40"
	}, props), _path$503 || (_path$503 = /*#__PURE__*/ React.createElement("path", {
		fill: "#A6A6A6",
		d: "M146.571 0H9.535Q8.986 0 8.44.002q-.457.004-.919.013-1.008.012-2.004.177a6.7 6.7 0 0 0-1.9.627A6.44 6.44 0 0 0 .193 5.522a13 13 0 0 0-.179 2.002c-.01.306-.01.614-.015.92V31.56c.005.31.006.611.015.922q.012 1.007.18 2.002c.11.663.32 1.305.624 1.904.303.598.701 1.143 1.179 1.614.473.477 1.019.875 1.618 1.179a6.7 6.7 0 0 0 1.901.63q.996.165 2.004.177c.31.007.613.011.919.011.366.002.728.002 1.095.002H146.57c.36 0 .725 0 1.084-.002.305 0 .617-.004.922-.01q1.007-.014 2-.177a6.8 6.8 0 0 0 1.908-.631A6.3 6.3 0 0 0 154.103 38a6.4 6.4 0 0 0 1.181-1.614 6.6 6.6 0 0 0 .619-1.904q.168-.994.186-2.002c.004-.311.004-.612.004-.922.008-.364.008-.725.008-1.094V9.536c0-.366 0-.73-.008-1.092q.001-.46-.004-.92a13.4 13.4 0 0 0-.186-2.002 6.6 6.6 0 0 0-.619-1.904 6.46 6.46 0 0 0-2.799-2.8 6.8 6.8 0 0 0-1.908-.627q-.993-.165-2-.176c-.305-.005-.617-.011-.922-.013C147.296 0 146.931 0 146.571 0"
	})), _path2$349 || (_path2$349 = /*#__PURE__*/ React.createElement("path", {
		fill: "#000",
		d: "M8.445 39.125c-.305 0-.602-.004-.904-.01a13 13 0 0 1-1.87-.164 5.9 5.9 0 0 1-1.656-.548 5.4 5.4 0 0 1-1.397-1.016 5.3 5.3 0 0 1-1.02-1.397 5.7 5.7 0 0 1-.544-1.657 12.4 12.4 0 0 1-.166-1.875c-.007-.21-.015-.913-.015-.913v-23.1s.009-.692.015-.895a12.4 12.4 0 0 1 .165-1.872 5.8 5.8 0 0 1 .544-1.662c.26-.518.603-.99 1.015-1.398A5.57 5.57 0 0 1 5.668 1.05Q6.6.9 7.543.887l.902-.012H147.65l.913.013q.935.01 1.859.162a6 6 0 0 1 1.671.548 5.6 5.6 0 0 1 2.415 2.42c.26.52.441 1.076.535 1.649q.156.937.174 1.887c.003.283.003.588.003.89.008.375.008.732.008 1.092v20.929c0 .363 0 .718-.008 1.075 0 .325 0 .623-.004.93q-.018.932-.171 1.853a5.8 5.8 0 0 1-.54 1.67c-.264.513-.606.98-1.016 1.386a5.4 5.4 0 0 1-1.399 1.022 5.9 5.9 0 0 1-1.668.55q-.928.152-1.869.163c-.293.007-.6.011-.898.011l-1.084.002z"
	})), _path3$179 || (_path3$179 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M24.769 20.3a4.95 4.95 0 0 1 2.357-4.152 5.07 5.07 0 0 0-3.992-2.157c-1.679-.176-3.307 1.005-4.163 1.005-.872 0-2.19-.988-3.608-.959a5.32 5.32 0 0 0-4.473 2.728c-1.934 3.349-.491 8.27 1.361 10.976.927 1.326 2.01 2.806 3.428 2.754 1.387-.058 1.905-.885 3.58-.885 1.658 0 2.144.885 3.59.851 1.489-.024 2.426-1.33 3.32-2.669a11 11 0 0 0 1.52-3.092 4.78 4.78 0 0 1-2.92-4.4M22.037 12.21a4.87 4.87 0 0 0 1.115-3.49 4.96 4.96 0 0 0-3.208 1.66 4.64 4.64 0 0 0-1.143 3.361 4.1 4.1 0 0 0 3.236-1.53M46.15 30.496v-9.14h-.061l-3.743 9.045h-1.43l-3.752-9.045h-.06v9.14h-1.756V18.078h2.23l4.018 9.802h.069l4.01-9.802h2.238v12.418zM49.396 27.923c0-1.583 1.213-2.54 3.365-2.668l2.479-.138v-.688c0-1.007-.663-1.576-1.791-1.576a1.73 1.73 0 0 0-1.901 1.275h-1.739c.052-1.636 1.576-2.797 3.692-2.797 2.16 0 3.589 1.179 3.589 2.96v6.205h-1.782v-1.49h-.043a3.24 3.24 0 0 1-2.857 1.645 2.743 2.743 0 0 1-3.012-2.728m5.844-.818v-.697l-2.23.138c-1.11.07-1.738.55-1.738 1.325 0 .792.654 1.309 1.653 1.309a2.17 2.17 0 0 0 2.315-2.075M64.893 24.558a2 2 0 0 0-2.133-1.67c-1.43 0-2.375 1.197-2.375 3.082 0 1.927.955 3.089 2.391 3.089a1.95 1.95 0 0 0 2.117-1.626h1.79a3.62 3.62 0 0 1-3.924 3.175c-2.581 0-4.268-1.764-4.268-4.638 0-2.815 1.687-4.639 4.251-4.639a3.64 3.64 0 0 1 3.925 3.227zM78.76 27.14h-4.734l-1.137 3.356h-2.004l4.483-12.418h2.083l4.483 12.418h-2.039zm-4.244-1.55h3.752l-1.85-5.446h-.051zM91.617 25.97c0 2.813-1.506 4.62-3.778 4.62a3.07 3.07 0 0 1-2.849-1.583h-.043v4.484h-1.858V21.442h1.799v1.506h.034a3.21 3.21 0 0 1 2.882-1.6c2.298 0 3.813 1.816 3.813 4.622m-1.91 0c0-1.833-.947-3.038-2.393-3.038-1.42 0-2.375 1.23-2.375 3.038 0 1.824.955 3.046 2.375 3.046 1.446 0 2.393-1.197 2.393-3.046M101.582 25.97c0 2.813-1.506 4.62-3.778 4.62a3.07 3.07 0 0 1-2.85-1.583h-.042v4.484h-1.859V21.442h1.8v1.506h.034a3.21 3.21 0 0 1 2.882-1.6c2.298 0 3.813 1.816 3.813 4.622m-1.91 0c0-1.833-.948-3.038-2.393-3.038-1.42 0-2.375 1.23-2.375 3.038 0 1.824.955 3.046 2.375 3.046 1.445 0 2.393-1.197 2.393-3.046M108.168 27.036c.137 1.231 1.334 2.04 2.969 2.04 1.566 0 2.693-.809 2.693-1.919 0-.964-.68-1.54-2.289-1.936l-1.61-.388c-2.28-.55-3.338-1.617-3.338-3.348 0-2.142 1.867-3.614 4.518-3.614 2.624 0 4.423 1.472 4.484 3.614h-1.876c-.113-1.239-1.137-1.987-2.634-1.987s-2.522.757-2.522 1.858c0 .878.655 1.395 2.255 1.79l1.368.336c2.548.603 3.607 1.626 3.607 3.443 0 2.323-1.851 3.778-4.794 3.778-2.754 0-4.613-1.42-4.734-3.667zM119.803 19.3v2.142h1.722v1.472h-1.722v4.991c0 .775.345 1.137 1.102 1.137q.306-.006.611-.043v1.463q-.511.095-1.032.086c-1.833 0-2.548-.689-2.548-2.445v-5.19h-1.316v-1.47h1.316V19.3zM122.521 25.97c0-2.849 1.678-4.64 4.294-4.64 2.625 0 4.295 1.79 4.295 4.64 0 2.856-1.661 4.638-4.295 4.638s-4.294-1.782-4.294-4.638m6.696 0c0-1.954-.896-3.108-2.402-3.108s-2.401 1.162-2.401 3.108c0 1.962.895 3.106 2.401 3.106s2.402-1.145 2.402-3.106M132.643 21.442h1.773v1.541h.043a2.16 2.16 0 0 1 2.177-1.636q.323 0 .637.07v1.738a2.6 2.6 0 0 0-.835-.112 1.874 1.874 0 0 0-1.936 2.083v5.37h-1.859zM145.841 27.837c-.25 1.643-1.851 2.771-3.899 2.771-2.634 0-4.268-1.764-4.268-4.595 0-2.84 1.643-4.682 4.19-4.682 2.505 0 4.08 1.72 4.08 4.466v.636h-6.394v.113a2.35 2.35 0 0 0 1.458 2.391c.31.127.643.185.977.173a2.05 2.05 0 0 0 2.091-1.273zm-6.283-2.702h4.527A2.18 2.18 0 0 0 142.74 23a2.2 2.2 0 0 0-.876-.163 2.29 2.29 0 0 0-2.306 2.298M37.826 8.731a2.64 2.64 0 0 1 2.808 2.965c0 1.906-1.03 3.002-2.808 3.002h-2.155V8.73zm-1.228 5.123h1.125a1.875 1.875 0 0 0 1.967-2.146 1.882 1.882 0 0 0-1.967-2.134h-1.125zM41.68 12.444a2.132 2.132 0 1 1 4.248 0 2.134 2.134 0 1 1-4.247 0m3.334 0c0-.976-.439-1.546-1.208-1.546-.773 0-1.207.57-1.207 1.546 0 .984.434 1.55 1.207 1.55.77 0 1.208-.57 1.208-1.55M51.573 14.698h-.922l-.93-3.317h-.07l-.927 3.317h-.913l-1.242-4.503h.902l.806 3.436h.067l.925-3.436h.853l.926 3.436h.07l.803-3.436h.889zM53.854 10.195h.855v.715h.066a1.35 1.35 0 0 1 1.344-.802 1.466 1.466 0 0 1 1.559 1.675v2.915h-.889v-2.692c0-.724-.314-1.084-.972-1.084a1.034 1.034 0 0 0-1.075 1.141v2.635h-.889zM59.094 8.437h.888v6.26h-.888zM61.218 12.444a2.134 2.134 0 1 1 4.247 0 2.134 2.134 0 1 1-4.247 0m3.333 0c0-.976-.439-1.546-1.208-1.546-.773 0-1.207.57-1.207 1.546 0 .984.434 1.55 1.207 1.55.77 0 1.208-.57 1.208-1.55M66.4 13.424c0-.81.604-1.277 1.675-1.344l1.22-.07v-.389c0-.476-.314-.744-.922-.744-.496 0-.84.182-.938.5h-.86c.09-.773.818-1.27 1.84-1.27 1.128 0 1.765.563 1.765 1.514v3.077h-.856v-.633h-.07a1.52 1.52 0 0 1-1.353.707 1.36 1.36 0 0 1-1.5-1.348m2.895-.384v-.377l-1.1.07c-.62.042-.901.253-.901.65 0 .405.352.64.835.64a1.064 1.064 0 0 0 1.166-.983M71.348 12.444c0-1.423.731-2.324 1.869-2.324a1.48 1.48 0 0 1 1.38.79h.067V8.437h.889v6.26H74.7v-.71h-.07a1.56 1.56 0 0 1-1.414.785c-1.146 0-1.87-.901-1.87-2.328m.918 0c0 .955.45 1.53 1.203 1.53.749 0 1.212-.583 1.212-1.526 0-.938-.468-1.53-1.212-1.53-.748 0-1.203.58-1.203 1.526M79.23 12.444a2.133 2.133 0 1 1 4.247 0 2.134 2.134 0 1 1-4.248 0m3.332 0c0-.976-.438-1.546-1.207-1.546-.773 0-1.208.57-1.208 1.546 0 .984.435 1.55 1.207 1.55.77 0 1.209-.57 1.209-1.55M84.67 10.195h.855v.715h.066a1.35 1.35 0 0 1 1.344-.802 1.466 1.466 0 0 1 1.559 1.675v2.915h-.889v-2.692c0-.724-.315-1.084-.972-1.084a1.034 1.034 0 0 0-1.075 1.141v2.635h-.889zM93.515 9.074v1.141h.976v.749h-.976v2.315c0 .472.195.678.637.678q.17 0 .339-.02v.74q-.24.043-.484.046c-.988 0-1.382-.348-1.382-1.216v-2.543h-.714v-.749h.715V9.074zM95.705 8.437h.88v2.482h.07a1.385 1.385 0 0 1 1.374-.807 1.485 1.485 0 0 1 1.55 1.678v2.908h-.889V12.01c0-.72-.335-1.084-.963-1.084a1.05 1.05 0 0 0-1.134 1.142v2.63h-.888zM104.761 13.482a1.83 1.83 0 0 1-1.951 1.303 2.044 2.044 0 0 1-2.08-2.325 2.077 2.077 0 0 1 2.076-2.352c1.253 0 2.009.856 2.009 2.27v.31h-3.18v.05a1.19 1.19 0 0 0 1.199 1.29 1.08 1.08 0 0 0 1.072-.546zm-3.126-1.451h2.275a1.09 1.09 0 0 0-1.109-1.167 1.15 1.15 0 0 0-.829.338 1.16 1.16 0 0 0-.337.829"
	})));
};

//#endregion
//#region src/BrandIcon/icons/Wireguard.svg
var _g$107;
var _defs$23;
function _extends$519() {
	return _extends$519 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$519.apply(null, arguments);
}
var SvgWireguard = function SvgWireguard(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$519({
		xmlns: "http://www.w3.org/2000/svg",
		width: 80,
		height: 80,
		fill: "none",
		viewBox: "0 0 80 80"
	}, props), _g$107 || (_g$107 = /*#__PURE__*/ React.createElement("g", { clipPath: "url(#a)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "#88171A",
		d: "M79.977 0H.023A.023.023 0 0 0 0 .023v79.954q.002.021.023.023h79.954q.021-.002.023-.023V.023A.023.023 0 0 0 79.977 0"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "m37.188 8.281 5.468 1.25v.313c-2.343.312-4.687-.625-7.031-.781 1.719 1.093 3.594 1.718 5.469 2.343-2.969 2.5-5.469-.781-8.75 1.406 3.125 1.563 2.968 1.25 3.281 4.22-1.406.155-3.75 1.562-4.219 2.5 2.032.468 4.375 0 6.407 1.25-.626.468-2.188 1.093-2.813 1.562 1.406.312 3.125-.313 3.906.156 2.969 2.5 8.438 5.938 10 9.375 2.657 5.781-3.437 12.031-9.375 12.969-8.281 1.718-12.968 10.312-10 18.281 2.969 7.813 12.188 11.25 19.532 7.188 10.312-6.25 8.75-16.876 2.5-22.657q-.47-.468-.938 0a50 50 0 0 1-7.031 3.75c5.625 1.25 6.406 5.469 5.781 8.438-2.031 7.5-12.187 5.781-13.281-.625-.469-2.969 1.093-5.938 3.75-7.188 9.218-4.062 13.593-4.687 16.25-15.156.937-5.937-.469-9.062-4.844-12.5-1.719-1.719-5.156-2.812-6.25-5.469-.156-.312.156-.937.469-.937 1.562-.313 7.656-.469 7.656-.157 1.094 1.094 2.031-.625 2.5-1.406-1.562-.312-3.281-.156-4.531-.156-.157 0-.469-.312-.625-.469.156-.156.468-.312.625-.312H57.5c0-1.094-1.406-2.656-2.812-2.969v.469c-1.25.156-2.5-.156-3.75-.625-.626-.469-1.094-1.406-1.72-1.719-2.5-1.406-5.156-2.5-8.437-2.5-1.562 0-2.656.156-3.593.156M48.75 12.97l.469.469-.625.312c-.313.156-.469 0-.625-.156-.313-.469.625-.781.781-.625m-18.75 15c-8.437 5.156-7.969 17.031-.469 21.719.625.312.938.312 1.25-.157 1.875-2.343 3.594-3.437 5.625-4.687-3.906-.625-5.937-2.5-5.781-5.157C30 30.313 43.594 31.25 42.188 40c-.313 1.563-1.25 2.969-2.5 3.906 4.218-.937 7.343-3.281 8.593-7.5.313-1.25.313-2.968-.312-4.062C43.28 25.469 36.25 24.062 30 27.969m-9.687 30.469c2.5-1.094 5.156-1.563 7.656-2.032.156-2.031.781-4.062 2.031-5.625-4.687 0-8.594 3.125-9.687 7.657"
	}))), _defs$23 || (_defs$23 = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", { id: "a" }, /*#__PURE__*/ React.createElement("rect", {
		width: 80,
		height: 80,
		fill: "#fff",
		rx: 16
	})))));
};

//#endregion
//#region src/BrandIcon/index.tsx
const BrandIconSVG = {
	AppStore: SvgAppStore,
	GooglePlay: SvgGooglePlay,
	MacAppStore: SvgMacAppStore,
	Wireguard: SvgWireguard
};

//#endregion
//#region src/Branding/icons/Insignia.svg
var _g$106;
var _g2$16;
var _defs$22;
function _extends$518() {
	return _extends$518 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$518.apply(null, arguments);
}
var SvgInsignia = function SvgInsignia(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$518({
		xmlns: "http://www.w3.org/2000/svg",
		width: 24,
		height: 24,
		fill: "none",
		viewBox: "0 0 24 24"
	}, props), _g$106 || (_g$106 = /*#__PURE__*/ React.createElement("g", {
		fill: "#5461C8",
		fillRule: "evenodd",
		clipRule: "evenodd",
		filter: "url(#a)"
	}, /*#__PURE__*/ React.createElement("path", { d: "M23 12c0 3.752-.256 7.985-1.63 9.365C19.993 22.744 15.07 23 12.031 23s-7.962-.256-9.337-1.636S1 15.753 1 12s.32-7.985 1.695-9.364S8.995 1 12.032 1s7.962.257 9.337 1.636S23 8.248 23 12" }), /*#__PURE__*/ React.createElement("path", { d: "M23 12c0 3.752-.256 7.985-1.63 9.365C19.993 22.744 15.07 23 12.031 23s-7.962-.256-9.337-1.636S1 15.753 1 12s.32-7.985 1.695-9.364S8.995 1 12.032 1s7.962.257 9.337 1.636S23 8.248 23 12" }))), _g2$16 || (_g2$16 = /*#__PURE__*/ React.createElement("g", { filter: "url(#b)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "#EFF1FF",
		d: "M15.535 7.191c1.81 0 2.845 1.087 2.845 2.98v6.639h-1.71v-5.785c0-1.793-.71-2.272-1.66-2.272-1.31 0-2.156 1.418-2.156 3.847v4.21h-1.71v-5.785c0-1.679-.625-2.272-1.671-2.272-1.32 0-2.145 1.533-2.145 3.847v4.21H5.62V7.339h1.71v1.49c.58-1.085 1.524-1.639 2.755-1.639s2.24.656 2.588 1.811c.512-1.109 1.56-1.811 2.862-1.811"
	}))), _defs$22 || (_defs$22 = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("filter", {
		id: "a",
		width: 24,
		height: 24,
		x: 0,
		y: 0,
		colorInterpolationFilters: "sRGB",
		filterUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("feFlood", {
		floodOpacity: 0,
		result: "BackgroundImageFix"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", {
		"in": "SourceAlpha",
		result: "hardAlpha",
		values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
	}), /*#__PURE__*/ React.createElement("feOffset", {
		dx: 1,
		dy: 1
	}), /*#__PURE__*/ React.createElement("feComposite", {
		in2: "hardAlpha",
		operator: "out"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", { values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.12 0" }), /*#__PURE__*/ React.createElement("feBlend", {
		in2: "BackgroundImageFix",
		result: "effect1_dropShadow_5983_27702"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", {
		"in": "SourceAlpha",
		result: "hardAlpha",
		values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
	}), /*#__PURE__*/ React.createElement("feOffset", {
		dx: -1,
		dy: -1
	}), /*#__PURE__*/ React.createElement("feComposite", {
		in2: "hardAlpha",
		operator: "out"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" }), /*#__PURE__*/ React.createElement("feBlend", {
		in2: "effect1_dropShadow_5983_27702",
		result: "effect2_dropShadow_5983_27702"
	}), /*#__PURE__*/ React.createElement("feBlend", {
		"in": "SourceGraphic",
		in2: "effect2_dropShadow_5983_27702",
		result: "shape"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", {
		"in": "SourceAlpha",
		result: "hardAlpha",
		values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
	}), /*#__PURE__*/ React.createElement("feOffset", {
		dx: 1,
		dy: 1
	}), /*#__PURE__*/ React.createElement("feGaussianBlur", { stdDeviation: .5 }), /*#__PURE__*/ React.createElement("feComposite", {
		in2: "hardAlpha",
		k2: -1,
		k3: 1,
		operator: "arithmetic"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", { values: "0 0 0 0 0.168627 0 0 0 0 0.188235 0 0 0 0 0.356863 0 0 0 0.3 0" }), /*#__PURE__*/ React.createElement("feBlend", {
		in2: "shape",
		result: "effect3_innerShadow_5983_27702"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", {
		"in": "SourceAlpha",
		result: "hardAlpha",
		values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
	}), /*#__PURE__*/ React.createElement("feOffset", {
		dx: -1,
		dy: -1
	}), /*#__PURE__*/ React.createElement("feGaussianBlur", { stdDeviation: .5 }), /*#__PURE__*/ React.createElement("feComposite", {
		in2: "hardAlpha",
		k2: -1,
		k3: 1,
		operator: "arithmetic"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", { values: "0 0 0 0 0.937255 0 0 0 0 0.945098 0 0 0 0 1 0 0 0 0.15 0" }), /*#__PURE__*/ React.createElement("feBlend", {
		in2: "effect3_innerShadow_5983_27702",
		result: "effect4_innerShadow_5983_27702"
	})), /*#__PURE__*/ React.createElement("filter", {
		id: "b",
		width: 14.76,
		height: 11.62,
		x: 5.62,
		y: 7.19,
		colorInterpolationFilters: "sRGB",
		filterUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("feFlood", {
		floodOpacity: 0,
		result: "BackgroundImageFix"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", {
		"in": "SourceAlpha",
		result: "hardAlpha",
		values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
	}), /*#__PURE__*/ React.createElement("feOffset", {
		dx: 1,
		dy: 1
	}), /*#__PURE__*/ React.createElement("feGaussianBlur", { stdDeviation: .5 }), /*#__PURE__*/ React.createElement("feComposite", {
		in2: "hardAlpha",
		operator: "out"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", { values: "0 0 0 0 0.168627 0 0 0 0 0.188235 0 0 0 0 0.356863 0 0 0 0.3 0" }), /*#__PURE__*/ React.createElement("feBlend", {
		in2: "BackgroundImageFix",
		result: "effect1_dropShadow_5983_27702"
	}), /*#__PURE__*/ React.createElement("feBlend", {
		"in": "SourceGraphic",
		in2: "effect1_dropShadow_5983_27702",
		result: "shape"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", {
		"in": "SourceAlpha",
		result: "hardAlpha",
		values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
	}), /*#__PURE__*/ React.createElement("feOffset", {
		dx: 1,
		dy: 1
	}), /*#__PURE__*/ React.createElement("feComposite", {
		in2: "hardAlpha",
		k2: -1,
		k3: 1,
		operator: "arithmetic"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", { values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" }), /*#__PURE__*/ React.createElement("feBlend", {
		in2: "shape",
		result: "effect2_innerShadow_5983_27702"
	})))));
};

//#endregion
//#region src/Branding/index.ts
const BrandingSVG = { Insignia: SvgInsignia };

//#endregion
//#region src/FavIcon/icons/FavIcon.svg
var _g$105;
var _defs$21;
function _extends$517() {
	return _extends$517 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$517.apply(null, arguments);
}
var SvgFavIcon = function SvgFavIcon(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$517({
		xmlns: "http://www.w3.org/2000/svg",
		width: 64,
		height: 64,
		fill: "none",
		viewBox: "0 0 64 64"
	}, props), _g$105 || (_g$105 = /*#__PURE__*/ React.createElement("g", { clipPath: "url(#a)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M64 32c0-10.915-.744-23.23-4.744-27.242S40.93 0 32.093 0 8.93.746 4.93 4.758 0 21.085 0 32c0 10.916.93 23.23 4.93 27.242S23.256 64 32.093 64s23.163-.746 27.163-4.758S64 42.916 64 32"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "url(#b)",
		d: "M64 32c0-10.915-.744-23.23-4.744-27.242S40.93 0 32.093 0 8.93.746 4.93 4.758 0 21.085 0 32c0 10.916.93 23.23 4.93 27.242S23.256 64 32.093 64s23.163-.746 27.163-4.758S64 42.916 64 32"
	}), /*#__PURE__*/ React.createElement("g", { filter: "url(#c)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "#5461C8",
		d: "M16 44h3.915v-.422q0-1.297-.004-2.596c-.005-2.175-.01-4.35.017-6.524a31 31 0 0 1 .271-3.676c.22-1.637.755-3.181 1.69-4.563.921-1.36 2.079-2.393 3.795-2.584 1.97-.22 3.618.551 4.098 2.702.176.785.23 1.61.233 2.417.015 3.563.013 7.126.012 10.689q0 2.046 0 4.093.001.156.013.311l.009.143h3.931v-.388q0-1.336-.004-2.673c-.005-2.24-.01-4.479.017-6.717.014-1.193.107-2.394.283-3.573.29-1.948.986-3.748 2.3-5.265 1.073-1.24 2.418-1.877 4.074-1.764 1.364.094 2.382.724 2.939 2.008.391.9.468 1.855.468 2.818a10825 10825 0 0 1 .002 15.154v.405h3.922c.006-.114.016-.212.016-.311l.001-3.794c.003-4.171.005-8.343-.014-12.514-.003-.84-.1-1.696-.282-2.515-.397-1.788-1.329-3.244-3.01-4.092-1.885-.95-3.866-.958-5.848-.363-2.228.669-3.8 2.166-4.98 4.115l-.241.395-.077-.269-.038-.126c-.576-1.857-1.678-3.265-3.52-4.004-1.429-.572-2.915-.63-4.407-.316-2.46.52-4.21 1.995-5.44 4.137l-.17.299-.035-.014-.032-.013v-4.16H16z"
	})))), _defs$21 || (_defs$21 = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
		id: "b",
		x1: 58.372,
		x2: 24.392,
		y1: 2.426,
		y2: 71.878,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", {
		stopColor: "#fff",
		stopOpacity: .03
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .5,
		stopColor: "#EFF1FF",
		stopOpacity: .11
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#EFF1FF",
		stopOpacity: .9
	})), /*#__PURE__*/ React.createElement("clipPath", { id: "a" }, /*#__PURE__*/ React.createElement("rect", {
		width: 64,
		height: 64,
		fill: "#fff",
		rx: 2
	})), /*#__PURE__*/ React.createElement("filter", {
		id: "c",
		width: 32,
		height: 24.5,
		x: 16,
		y: 20,
		colorInterpolationFilters: "sRGB",
		filterUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("feFlood", {
		floodOpacity: 0,
		result: "BackgroundImageFix"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", {
		"in": "SourceAlpha",
		result: "hardAlpha",
		values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
	}), /*#__PURE__*/ React.createElement("feOffset", { dy: .5 }), /*#__PURE__*/ React.createElement("feComposite", {
		in2: "hardAlpha",
		operator: "out"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", { values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" }), /*#__PURE__*/ React.createElement("feBlend", {
		in2: "BackgroundImageFix",
		result: "effect1_dropShadow_2_153"
	}), /*#__PURE__*/ React.createElement("feBlend", {
		"in": "SourceGraphic",
		in2: "effect1_dropShadow_2_153",
		result: "shape"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", {
		"in": "SourceAlpha",
		result: "hardAlpha",
		values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
	}), /*#__PURE__*/ React.createElement("feOffset", { dy: .5 }), /*#__PURE__*/ React.createElement("feComposite", {
		in2: "hardAlpha",
		k2: -1,
		k3: 1,
		operator: "arithmetic"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", { values: "0 0 0 0 0.168715 0 0 0 0 0.189966 0 0 0 0 0.358333 0 0 0 0.11 0" }), /*#__PURE__*/ React.createElement("feBlend", {
		in2: "shape",
		result: "effect2_innerShadow_2_153"
	})))));
};

//#endregion
//#region src/FavIcon/index.ts
const FavIconSVG = { FavIcon: SvgFavIcon };

//#endregion
//#region src/HardwareIcon/icons/AccessPointDetailed.svg
var _path$502;
var _path2$348;
var _path3$178;
var _path4$65;
var _path5$31;
var _path6$17;
var _path7$13;
var _path8$12;
var _path9$10;
function _extends$516() {
	return _extends$516 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$516.apply(null, arguments);
}
var SvgAccessPointDetailed = function SvgAccessPointDetailed(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$516({
		xmlns: "http://www.w3.org/2000/svg",
		width: 40,
		height: 40,
		fill: "none",
		viewBox: "0 0 40 40"
	}, props), _path$502 || (_path$502 = /*#__PURE__*/ React.createElement("path", {
		fill: "#131522",
		fillOpacity: .08,
		fillRule: "evenodd",
		d: "M5.265 6.175c.619-.62 1.587-1.075 2.697-1.419 1.123-.348 2.45-.602 3.843-.787 2.786-.37 5.887-.469 8.244-.469s5.459.1 8.245.469c1.392.185 2.72.439 3.843.787 1.11.344 2.078.798 2.697 1.419.61.61 1.063 1.503 1.41 2.539.35 1.043.603 2.275.788 3.606.37 2.661.468 5.774.468 8.68s-.099 6.019-.468 8.68c-.185 1.33-.439 2.563-.788 3.606-.347 1.036-.8 1.928-1.41 2.54-.619.62-1.588 1.074-2.697 1.418-1.123.348-2.45.602-3.843.787-2.786.37-5.887.469-8.245.469s-5.458-.1-8.244-.469c-1.393-.185-2.72-.439-3.843-.787-1.11-.344-2.078-.798-2.697-1.419-.608-.61-1.068-1.5-1.424-2.535-.359-1.043-.626-2.274-.823-3.605C2.624 27.023 2.5 23.91 2.5 21s.124-6.023.518-8.685c.197-1.33.464-2.562.823-3.605.356-1.036.816-1.926 1.424-2.535",
		clipRule: "evenodd"
	})), _path2$348 || (_path2$348 = /*#__PURE__*/ React.createElement("path", {
		fill: "#131522",
		fillOpacity: .12,
		fillRule: "evenodd",
		d: "M5.265 5.175c.619-.62 1.587-1.075 2.697-1.419 1.123-.348 2.45-.602 3.843-.787 2.786-.37 5.887-.469 8.244-.469s5.459.1 8.245.469c1.392.185 2.72.439 3.843.787 1.11.344 2.078.798 2.697 1.419.61.61 1.063 1.503 1.41 2.539.35 1.043.603 2.275.788 3.606.37 2.661.468 5.774.468 8.68s-.099 6.019-.468 8.68c-.185 1.33-.439 2.563-.788 3.606-.347 1.036-.8 1.928-1.41 2.54-.619.62-1.588 1.074-2.697 1.418-1.123.348-2.45.602-3.843.787-2.786.37-5.887.469-8.245.469s-5.458-.1-8.244-.469c-1.393-.185-2.72-.439-3.843-.787-1.11-.344-2.078-.798-2.697-1.419-.608-.61-1.068-1.5-1.424-2.535-.359-1.043-.626-2.274-.823-3.605C2.624 26.023 2.5 22.91 2.5 20s.124-6.023.518-8.685c.197-1.33.464-2.562.823-3.605.356-1.036.816-1.926 1.424-2.535",
		clipRule: "evenodd"
	})), _path3$178 || (_path3$178 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M37 20c0-5.799-.395-12.341-2.52-14.472S24.744 3 20.05 3c-4.695 0-12.306.397-14.43 2.528C3.493 7.658 3 14.2 3 20s.494 12.341 2.62 14.472C7.743 36.603 15.354 37 20.05 37c4.694 0 12.305-.397 14.43-2.528C36.605 32.342 37 25.8 37 20"
	})), _path4$65 || (_path4$65 = /*#__PURE__*/ React.createElement("path", {
		fill: "#5461C8",
		d: "m21.67 17.052-.002-.027h-.012l-.016.013-.034.027-.126.08q-.221.141-.447.276c-.057.034-.074.07-.073.134q.003.405.002.811v.359h-.73v.627h.73v.078l-.001.577q-.003.78.003 1.56c.002.18.02.365.06.541.09.388.328.661.714.796.245.086.496.084.748.046.142-.022.277-.061.402-.138l-.034-.122-.134-.482a.9.9 0 0 1-.456.136c-.271.01-.47-.122-.545-.379a1.3 1.3 0 0 1-.044-.337q-.004-.865-.002-1.731v-.498l.004-.05h1.11v-.629h-1.114V17.11z"
	})), _path5$31 || (_path5$31 = /*#__PURE__*/ React.createElement("path", {
		fill: "#5461C8",
		fillRule: "evenodd",
		d: "M26.497 20.954h-3.063l.004.024.02.12q.022.154.055.3c.06.25.173.472.352.656a.95.95 0 0 0 .595.277q.288.032.567-.044c.273-.075.456-.262.603-.493q.052-.084.1-.173l.045-.082.607.266-.02.042-.009.016-.003.006-.03.059c-.15.288-.337.546-.602.74a1.6 1.6 0 0 1-.694.272 2.2 2.2 0 0 1-.82-.006 1.65 1.65 0 0 1-1.073-.724 2.4 2.4 0 0 1-.386-1.153c-.04-.491.028-.964.242-1.41.23-.48.587-.815 1.105-.948.541-.138 1.063-.083 1.548.21.344.21.56.525.706.896.108.276.15.566.15.862v.287m-.739-.639c-.084-.496-.426-1.101-1.232-1.047a1 1 0 0 0-.722.35c-.17.2-.269.435-.317.697z",
		clipRule: "evenodd"
	})), _path6$17 || (_path6$17 = /*#__PURE__*/ React.createElement("path", {
		fill: "#5461C8",
		d: "m29.32 18.907-.072.284-.032.132-.01.043-.006.026q-.026-.006-.044-.013c-.492-.198-.892-.1-1.233.297-.21.246-.318.535-.39.84q-.089.384-.088.777l-.001 1.083v.588h-.733v-4.255h.732v.707l.049-.07q.046-.07.095-.128c.313-.361.7-.587 1.202-.584.196.002.387.037.561.131v.025z"
	})), _path7$13 || (_path7$13 = /*#__PURE__*/ React.createElement("path", {
		fill: "#5461C8",
		fillRule: "evenodd",
		d: "M20.436 20.954h-3.05c.015.293.073.567.213.82a1.1 1.1 0 0 0 .35.398c.21.14.443.18.69.167.28-.014.537-.086.74-.298a1.7 1.7 0 0 0 .313-.466l.006-.011.013-.027q.156.068.312.137l.303.132-.033.063-.01.019q-.045.089-.094.173c-.166.28-.37.524-.656.688a1.7 1.7 0 0 1-.657.205c-.24.029-.481.033-.72-.017a1.66 1.66 0 0 1-1.134-.803 2.44 2.44 0 0 1-.335-1.06 2.7 2.7 0 0 1 .24-1.427c.23-.48.588-.815 1.106-.948.543-.139 1.067-.083 1.554.214.341.209.556.523.7.892.107.273.15.558.15.85zm-.733-.638c-.128-.639-.528-1.102-1.258-1.046a.98.98 0 0 0-.707.356c-.166.2-.264.43-.31.69z",
		clipRule: "evenodd"
	})), _path8$12 || (_path8$12 = /*#__PURE__*/ React.createElement("path", {
		fill: "#5461C8",
		d: "M10.65 22.975h.704v-.547q-.004-.591.002-1.182a6 6 0 0 1 .05-.666c.038-.296.135-.576.303-.826.166-.247.374-.434.682-.469.354-.04.651.1.737.49.032.142.042.292.042.438q.004.967.002 1.936v.742q0 .029.003.056l.001.026h.707v-.554q-.003-.61.003-1.217a5 5 0 0 1 .05-.648 1.84 1.84 0 0 1 .414-.953.85.85 0 0 1 .733-.32c.245.017.428.131.528.364.07.163.084.336.084.51v2.819h.706l.003-.056v-.688q.001-1.133-.002-2.267c-.001-.152-.018-.307-.051-.456-.072-.323-.24-.587-.541-.74-.34-.173-.696-.174-1.052-.066-.4.12-.683.392-.896.745l-.043.071-.014-.048-.007-.023c-.103-.337-.301-.591-.633-.725a1.34 1.34 0 0 0-.792-.058c-.443.095-.757.362-.978.75l-.019.032-.012.022-.006-.003-.006-.002v-.754h-.702z"
	})), _path9$10 || (_path9$10 = /*#__PURE__*/ React.createElement("path", {
		fill: "#C5C8D6",
		d: "M23.188 7.462a.85.85 0 1 0 0-1.7.85.85 0 0 0 0 1.7M16.813 7.463a.85.85 0 1 0 0-1.7.85.85 0 0 0 0 1.7M14.475 6.612a.85.85 0 1 1-1.7 0 .85.85 0 0 1 1.7 0M20.85 6.612a.85.85 0 1 1-1.7 0 .85.85 0 0 1 1.7 0M26.375 7.462a.85.85 0 1 0 0-1.7.85.85 0 0 0 0 1.7"
	})));
};

//#endregion
//#region src/HardwareIcon/icons/AccessPointSimple.svg
var _path$501;
var _path2$347;
var _path3$177;
var _path4$64;
var _path5$30;
function _extends$515() {
	return _extends$515 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$515.apply(null, arguments);
}
var SvgAccessPointSimple = function SvgAccessPointSimple(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$515({
		xmlns: "http://www.w3.org/2000/svg",
		width: 40,
		height: 40,
		fill: "none",
		viewBox: "0 0 40 40"
	}, props), _path$501 || (_path$501 = /*#__PURE__*/ React.createElement("path", {
		fill: "#131522",
		fillOpacity: .08,
		fillRule: "evenodd",
		d: "M4.911 5.822c.706-.708 1.77-1.192 2.903-1.543 1.16-.36 2.518-.619 3.925-.806C14.556 3.1 17.682 3 20.05 3s5.494.1 8.31.473c1.408.187 2.766.446 3.926.806 1.134.351 2.197.835 2.903 1.543.688.69 1.172 1.664 1.53 2.733.363 1.083.622 2.348.81 3.696C37.9 14.947 38 18.087 38 21s-.099 6.053-.473 8.749c-.187 1.348-.446 2.613-.809 3.696-.358 1.069-.843 2.044-1.53 2.733-.706.708-1.77 1.192-2.903 1.544-1.16.36-2.518.618-3.925.805-2.817.373-5.943.473-8.31.473s-5.494-.1-8.31-.473c-1.408-.187-2.766-.446-3.926-.806-1.134-.351-2.197-.835-2.903-1.543-.685-.686-1.176-1.657-1.543-2.725-.372-1.082-.645-2.346-.844-3.695C2.124 27.061 2 23.92 2 21s.124-6.06.524-8.758c.2-1.349.472-2.613.844-3.695.367-1.068.858-2.039 1.543-2.725",
		clipRule: "evenodd"
	})), _path2$347 || (_path2$347 = /*#__PURE__*/ React.createElement("path", {
		fill: "#131522",
		fillOpacity: .12,
		fillRule: "evenodd",
		d: "M4.911 4.822c.706-.708 1.77-1.192 2.903-1.543 1.16-.36 2.518-.619 3.925-.806C14.556 2.1 17.682 2 20.05 2s5.494.1 8.31.473c1.408.187 2.766.446 3.926.806 1.134.351 2.197.835 2.903 1.543.688.69 1.172 1.664 1.53 2.733.363 1.083.622 2.348.81 3.696C37.9 13.947 38 17.087 38 20s-.099 6.053-.473 8.749c-.187 1.348-.446 2.613-.809 3.696-.358 1.069-.843 2.044-1.53 2.733-.706.708-1.77 1.192-2.903 1.544-1.16.36-2.518.618-3.925.805-2.817.373-5.943.473-8.31.473s-5.494-.1-8.31-.473c-1.408-.187-2.766-.446-3.926-.806-1.134-.351-2.197-.835-2.903-1.543-.685-.686-1.176-1.657-1.543-2.725-.372-1.082-.645-2.346-.844-3.695C2.124 26.061 2 22.92 2 20s.124-6.06.524-8.758c.2-1.349.472-2.613.844-3.695.367-1.068.858-2.039 1.543-2.725",
		clipRule: "evenodd"
	})), _path3$177 || (_path3$177 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M37 20c0-5.799-.395-12.341-2.52-14.472S24.744 3 20.05 3c-4.695 0-12.306.397-14.43 2.528C3.493 7.658 3 14.2 3 20s.494 12.341 2.62 14.472C7.743 36.603 15.354 37 20.05 37c4.694 0 12.305-.397 14.43-2.528C36.605 32.342 37 25.8 37 20"
	})), _path4$64 || (_path4$64 = /*#__PURE__*/ React.createElement("path", {
		fill: "#5461C8",
		d: "M13.515 24.9h1.587v-.172q0-.53-.002-1.06c-.002-.888-.004-1.776.007-2.664a13 13 0 0 1 .11-1.502 4.3 4.3 0 0 1 .685-1.863c.373-.555.843-.977 1.538-1.055.798-.09 1.466.226 1.661 1.104.072.32.093.657.095.986q.006 2.183.004 4.365v1.672a2 2 0 0 0 .01.185h1.592v-.158l-.001-1.092c-.002-.915-.004-1.829.007-2.743.006-.487.043-.977.114-1.459.118-.795.4-1.53.933-2.15.435-.506.98-.766 1.65-.72.554.039.966.296 1.192.82.159.367.19.757.19 1.15v6.354h1.59q.005-.068.006-.127l.001-1.55c.001-1.702.002-3.406-.006-5.109a5 5 0 0 0-.114-1.027c-.16-.73-.538-1.325-1.22-1.67-.764-.389-1.567-.392-2.37-.15-.903.274-1.54.885-2.019 1.68-.028.049-.057.096-.097.162l-.031-.11-.016-.05c-.233-.76-.68-1.334-1.427-1.636-.579-.234-1.181-.257-1.786-.129-.997.213-1.706.815-2.204 1.69l-.042.072-.028.05-.014-.006-.012-.005v-1.7h-1.583z"
	})), _path5$30 || (_path5$30 = /*#__PURE__*/ React.createElement("path", {
		fill: "#C5C8D6",
		d: "M20 9.9a1.7 1.7 0 1 0 0-3.4 1.7 1.7 0 0 0 0 3.4M15.325 8.2a1.7 1.7 0 1 1-3.4 0 1.7 1.7 0 0 1 3.4 0M28.075 8.2a1.7 1.7 0 1 1-3.4 0 1.7 1.7 0 0 1 3.4 0"
	})));
};

//#endregion
//#region src/HardwareIcon/icons/FirewallDetailed.svg
var _path$500;
var _path2$346;
var _path3$176;
var _path4$63;
var _path5$29;
var _path6$16;
var _path7$12;
var _path8$11;
var _path9$9;
var _path0$9;
var _path1$8;
var _path10$8;
var _path11$7;
var _path12$6;
var _path13$6;
function _extends$514() {
	return _extends$514 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$514.apply(null, arguments);
}
var SvgFirewallDetailed = function SvgFirewallDetailed(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$514({
		xmlns: "http://www.w3.org/2000/svg",
		width: 40,
		height: 40,
		fill: "none",
		viewBox: "0 0 40 40"
	}, props), _path$500 || (_path$500 = /*#__PURE__*/ React.createElement("path", {
		fill: "#131522",
		fillOpacity: .08,
		fillRule: "evenodd",
		d: "M9.226 7.5h21.548c.422 0 .903 0 1.353.154.5.17.92.511 1.27 1.107.168.288.57 1.19 1.067 2.344a359 359 0 0 1 1.735 4.122c1.217 2.936 2.412 5.888 2.582 6.373.337.964.525 1.703.443 2.69l-.5 6a3.5 3.5 0 0 1-3.488 3.21H4.764a3.5 3.5 0 0 1-3.488-3.21l-.5-6c-.082-.987.106-1.726.443-2.69.17-.485 1.365-3.437 2.582-6.373.611-1.473 1.23-2.95 1.735-4.122.496-1.153.899-2.056 1.067-2.344.35-.596.77-.937 1.27-1.107.45-.154.931-.154 1.353-.154",
		clipRule: "evenodd"
	})), _path2$346 || (_path2$346 = /*#__PURE__*/ React.createElement("path", {
		fill: "#131522",
		fillOpacity: .12,
		fillRule: "evenodd",
		d: "M9.226 6.5h21.548c.422 0 .903 0 1.353.154.5.17.92.511 1.27 1.107.168.288.57 1.19 1.067 2.344a359 359 0 0 1 1.735 4.122c1.217 2.936 2.412 5.888 2.582 6.373.337.964.525 1.703.443 2.69l-.5 6a3.5 3.5 0 0 1-3.488 3.21H4.764a3.5 3.5 0 0 1-3.488-3.21l-.5-6c-.082-.987.106-1.726.443-2.69.17-.485 1.365-3.437 2.582-6.373.611-1.473 1.23-2.95 1.735-4.122.496-1.153.899-2.056 1.067-2.344.35-.596.77-.937 1.27-1.107.45-.154.931-.154 1.353-.154",
		clipRule: "evenodd"
	})), _path3$176 || (_path3$176 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M7.035 8.014C7.628 7 8.365 7 9.264 7h21.472c.9 0 1.635 0 2.23 1.014.593 1.014 5.015 11.814 5.343 12.752.328.937.49 1.598.417 2.483l-.5 6A3 3 0 0 1 35.236 32H4.764a3 3 0 0 1-2.99-2.75l-.5-6c-.074-.886.089-1.547.417-2.484S6.441 9.028 7.035 8.014"
	})), _path4$63 || (_path4$63 = /*#__PURE__*/ React.createElement("path", {
		fill: "#131522",
		fillOpacity: .12,
		d: "M38.222 20.533q.06.156.087.233c.328.937.49 1.598.417 2.483l-.5 6A3 3 0 0 1 35.236 32H4.764a3 3 0 0 1-2.99-2.75l-.5-6c-.074-.886.089-1.547.417-2.484q.027-.077.087-.233A3.49 3.49 0 0 1 4.26 19.5h31.48c.975 0 1.85.397 2.482 1.033"
	})), _path5$29 || (_path5$29 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M1.27 23.25A3 3 0 0 1 4.26 20h31.48a3 3 0 0 1 2.99 3.25l-.5 6A3 3 0 0 1 35.24 32H4.76a3 3 0 0 1-2.99-2.75z"
	})), _path6$16 || (_path6$16 = /*#__PURE__*/ React.createElement("path", {
		fill: "#5461C8",
		d: "m32.46 26.813-.001-.013h-.006l-.007.006q-.007.008-.016.013l-.058.037-.205.13c-.026.016-.033.034-.033.064v.55H31.8v.295h.335v1.042q.002.129.029.255a.49.49 0 0 0 .327.375c.112.04.227.04.343.021a.5.5 0 0 0 .184-.065l-.016-.057-.061-.227a.4.4 0 0 1-.209.064c-.124.005-.216-.057-.25-.178a.6.6 0 0 1-.02-.159q-.002-.407-.001-.815v-.234l.002-.024h.508v-.295h-.51v-.759q0-.012-.002-.026"
	})), _path7$12 || (_path7$12 = /*#__PURE__*/ React.createElement("path", {
		fill: "#5461C8",
		fillRule: "evenodd",
		d: "M34.673 28.649h-1.405l.002.011.01.056q.01.073.025.142.04.177.161.308a.43.43 0 0 0 .273.131q.132.015.26-.021a.48.48 0 0 0 .277-.232q.023-.039.045-.081l.02-.039.28.125-.01.02-.004.008-.001.002-.014.028a1 1 0 0 1-.276.348.7.7 0 0 1-.318.129 1 1 0 0 1-.376-.003.76.76 0 0 1-.493-.34 1.16 1.16 0 0 1-.176-.543 1.3 1.3 0 0 1 .11-.664c.106-.226.27-.384.507-.446a.87.87 0 0 1 .71.099.8.8 0 0 1 .323.421c.05.13.07.267.07.406v.135m-.339-.3c-.038-.234-.195-.519-.565-.493a.45.45 0 0 0-.33.164.7.7 0 0 0-.146.328z",
		clipRule: "evenodd"
	})), _path8$11 || (_path8$11 = /*#__PURE__*/ React.createElement("path", {
		fill: "#5461C8",
		d: "m35.968 27.686-.023.089-.01.045q-.008.03-.015.061l-.005.02-.002.013-.02-.006c-.227-.094-.41-.048-.566.14a.9.9 0 0 0-.179.395q-.04.18-.04.366v.786h-.337v-2.003h.336v.333l.022-.033q.021-.033.044-.06c.143-.17.32-.276.551-.275.09.001.177.018.257.062v.012z"
	})), _path9$9 || (_path9$9 = /*#__PURE__*/ React.createElement("path", {
		fill: "#5461C8",
		fillRule: "evenodd",
		d: "M31.894 28.649h-1.399a.9.9 0 0 0 .098.386c.04.074.09.14.16.187a.5.5 0 0 0 .316.079.47.47 0 0 0 .34-.14.8.8 0 0 0 .138-.208l.006-.012.002-.005.006-.013.143.065.139.062-.015.03-.005.008q-.02.042-.043.082a.85.85 0 0 1-.3.324.8.8 0 0 1-.302.096 1 1 0 0 1-.33-.008.76.76 0 0 1-.52-.378 1.2 1.2 0 0 1-.154-.498c-.02-.234.01-.46.11-.672.107-.226.27-.384.508-.446.249-.066.49-.04.712.1a.8.8 0 0 1 .322.42q.072.194.068.4zm-.336-.3c-.06-.3-.242-.519-.578-.493a.45.45 0 0 0-.324.168.7.7 0 0 0-.142.325z",
		clipRule: "evenodd"
	})), _path0$9 || (_path0$9 = /*#__PURE__*/ React.createElement("path", {
		fill: "#5461C8",
		d: "M27.406 29.6h.323v-.257q-.001-.279.001-.556.003-.158.023-.314a.9.9 0 0 1 .139-.389c.076-.116.171-.204.313-.22.162-.019.298.047.338.23a1 1 0 0 1 .019.206v1.261l.003.038h.324v-.834q.003-.153.024-.304a.9.9 0 0 1 .19-.449c.088-.106.2-.16.336-.15a.26.26 0 0 1 .242.17.6.6 0 0 1 .039.241V29.6h.323l.002-.027v-.323l-.001-1.067a1 1 0 0 0-.024-.215.49.49 0 0 0-.248-.349.62.62 0 0 0-.482-.03.73.73 0 0 0-.41.35l-.02.034-.007-.023-.003-.01a.5.5 0 0 0-.29-.342.6.6 0 0 0-.364-.027.67.67 0 0 0-.448.353l-.009.015-.005.01-.003-.001-.003-.001v-.355h-.322z"
	})), _path1$8 || (_path1$8 = /*#__PURE__*/ React.createElement("path", {
		fill: "#9799AD",
		d: "M23.89 27.667a.467.467 0 1 1-.933 0 .467.467 0 0 1 .933 0M22.157 29.533a.467.467 0 1 1-.934 0 .467.467 0 0 1 .934 0M25.623 29.533a.467.467 0 1 1-.933 0 .467.467 0 0 1 .933 0M18.689 27.667a.467.467 0 1 1-.933 0 .467.467 0 0 1 .933 0"
	})), _path10$8 || (_path10$8 = /*#__PURE__*/ React.createElement("path", {
		fill: "#9799AD",
		d: "M23.889 27.667a.467.467 0 1 1-.933 0 .467.467 0 0 1 .933 0M22.156 29.533a.467.467 0 1 1-.934 0 .467.467 0 0 1 .934 0"
	})), _path11$7 || (_path11$7 = /*#__PURE__*/ React.createElement("path", {
		fill: "#1CA733",
		d: "M20.423 27.667a.467.467 0 1 1-.933 0 .467.467 0 0 1 .933 0M22.157 27.667a.467.467 0 1 1-.934 0 .467.467 0 0 1 .934 0M25.623 27.667a.467.467 0 1 1-.933 0 .467.467 0 0 1 .933 0M20.423 29.533a.467.467 0 1 1-.933 0 .467.467 0 0 1 .933 0M23.89 29.533a.467.467 0 1 1-.933 0 .467.467 0 0 1 .933 0"
	})), _path12$6 || (_path12$6 = /*#__PURE__*/ React.createElement("path", {
		fill: "#1CA733",
		d: "M20.422 27.667a.467.467 0 1 1-.933 0 .467.467 0 0 1 .933 0M22.156 27.667a.467.467 0 1 1-.934 0 .467.467 0 0 1 .934 0M18.689 29.533a.467.467 0 1 1-.933 0 .467.467 0 0 1 .933 0M20.422 29.533a.467.467 0 1 1-.933 0 .467.467 0 0 1 .933 0M23.889 29.533a.467.467 0 1 1-.933 0 .467.467 0 0 1 .933 0"
	})), _path13$6 || (_path13$6 = /*#__PURE__*/ React.createElement("path", {
		fill: "#C5C8D6",
		d: "M4.4 22.7a.7.7 0 1 1-1.4 0 .7.7 0 0 1 1.4 0M37 22.7a.7.7 0 1 1-1.4 0 .7.7 0 0 1 1.4 0M5.516 24.381a.1.1 0 0 1-.077-.164l1.943-2.294a.4.4 0 0 1 .306-.142h.796a.1.1 0 0 1 .077.165L6.618 24.24a.4.4 0 0 1-.306.141zM7.516 24.381a.1.1 0 0 1-.077-.164l1.943-2.294a.4.4 0 0 1 .306-.142h.796a.1.1 0 0 1 .077.165L8.618 24.24a.4.4 0 0 1-.306.141zM9.516 24.381a.1.1 0 0 1-.077-.164l1.943-2.294a.4.4 0 0 1 .306-.142h.796a.1.1 0 0 1 .077.165l-1.943 2.294a.4.4 0 0 1-.306.141zM11.516 24.381a.1.1 0 0 1-.077-.164l1.943-2.294a.4.4 0 0 1 .306-.142h.796a.1.1 0 0 1 .077.165l-1.943 2.294a.4.4 0 0 1-.306.141zM13.516 24.381a.1.1 0 0 1-.077-.164l1.943-2.294a.4.4 0 0 1 .306-.142h.796a.1.1 0 0 1 .077.165l-1.943 2.294a.4.4 0 0 1-.306.141zM15.516 24.381a.1.1 0 0 1-.077-.164l1.943-2.294a.4.4 0 0 1 .306-.142h.796a.1.1 0 0 1 .077.165l-1.943 2.294a.4.4 0 0 1-.306.141zM17.516 24.381a.1.1 0 0 1-.077-.164l1.943-2.294a.4.4 0 0 1 .306-.142h.796a.1.1 0 0 1 .077.165l-1.943 2.294a.4.4 0 0 1-.306.141zM19.516 24.381a.1.1 0 0 1-.077-.164l1.943-2.294a.4.4 0 0 1 .306-.142h.796a.1.1 0 0 1 .077.165l-1.943 2.294a.4.4 0 0 1-.306.141zM21.516 24.381a.1.1 0 0 1-.077-.164l1.943-2.294a.4.4 0 0 1 .306-.142h.796a.1.1 0 0 1 .077.165l-1.943 2.294a.4.4 0 0 1-.306.141zM23.516 24.381a.1.1 0 0 1-.077-.164l1.943-2.294a.4.4 0 0 1 .306-.142h.796a.1.1 0 0 1 .077.165l-1.943 2.294a.4.4 0 0 1-.306.141zM25.516 24.381a.1.1 0 0 1-.077-.164l1.943-2.294a.4.4 0 0 1 .306-.142h.796a.1.1 0 0 1 .077.165l-1.943 2.294a.4.4 0 0 1-.306.141zM27.516 24.381a.1.1 0 0 1-.077-.164l1.943-2.294a.4.4 0 0 1 .306-.142h.796a.1.1 0 0 1 .077.165l-1.943 2.294a.4.4 0 0 1-.306.141zM29.516 24.381a.1.1 0 0 1-.077-.164l1.943-2.294a.4.4 0 0 1 .306-.142h.796a.1.1 0 0 1 .077.165l-1.943 2.294a.4.4 0 0 1-.306.141zM31.516 24.381a.1.1 0 0 1-.077-.164l1.943-2.294a.4.4 0 0 1 .306-.142h.796a.1.1 0 0 1 .077.165l-1.943 2.294a.4.4 0 0 1-.306.141zM8.484 29.8a.1.1 0 0 0 .077-.165l-1.943-2.294a.4.4 0 0 0-.306-.141h-.796a.1.1 0 0 0-.077.165l1.943 2.294a.4.4 0 0 0 .306.141zM10.484 29.8a.1.1 0 0 0 .077-.165l-1.943-2.294a.4.4 0 0 0-.306-.141h-.796a.1.1 0 0 0-.077.165l1.943 2.294a.4.4 0 0 0 .306.141zM12.484 29.8a.1.1 0 0 0 .077-.165l-1.943-2.294a.4.4 0 0 0-.306-.141h-.796a.1.1 0 0 0-.077.165l1.943 2.294a.4.4 0 0 0 .306.141zM14.484 29.8a.1.1 0 0 0 .077-.165l-1.943-2.294a.4.4 0 0 0-.306-.141h-.796a.1.1 0 0 0-.077.165l1.943 2.294a.4.4 0 0 0 .306.141zM16.484 29.8a.1.1 0 0 0 .077-.165l-1.943-2.294a.4.4 0 0 0-.306-.141h-.796a.1.1 0 0 0-.077.165l1.943 2.294a.4.4 0 0 0 .306.141z"
	})));
};

//#endregion
//#region src/HardwareIcon/icons/FirewallSimple.svg
var _path$499;
var _path2$345;
var _path3$175;
var _path4$62;
var _path5$28;
var _path6$15;
function _extends$513() {
	return _extends$513 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$513.apply(null, arguments);
}
var SvgFirewallSimple = function SvgFirewallSimple(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$513({
		xmlns: "http://www.w3.org/2000/svg",
		width: 40,
		height: 40,
		fill: "none",
		viewBox: "0 0 40 40"
	}, props), _path$499 || (_path$499 = /*#__PURE__*/ React.createElement("path", {
		fill: "#131522",
		fillOpacity: .08,
		fillRule: "evenodd",
		d: "M3.85 13h32.3c2.274 0 3.85 2.113 3.85 4.36v7.28c0 2.247-1.576 4.36-3.85 4.36H3.85C1.576 29 0 26.887 0 24.64v-7.28C0 15.113 1.576 13 3.85 13",
		clipRule: "evenodd"
	})), _path2$345 || (_path2$345 = /*#__PURE__*/ React.createElement("path", {
		fill: "#131522",
		fillOpacity: .12,
		fillRule: "evenodd",
		d: "M3.85 12h32.3c2.274 0 3.85 2.113 3.85 4.36v7.28c0 2.247-1.576 4.36-3.85 4.36H3.85C1.576 28 0 25.887 0 23.64v-7.28C0 14.113 1.576 12 3.85 12",
		clipRule: "evenodd"
	})), _path3$175 || (_path3$175 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M1 16.36C1 14.504 2.276 13 3.85 13h32.3c1.574 0 2.85 1.504 2.85 3.36v7.28c0 1.856-1.276 3.36-2.85 3.36H3.85C2.276 27 1 25.496 1 23.64z"
	})), _path4$62 || (_path4$62 = /*#__PURE__*/ React.createElement("path", {
		fill: "#5461C8",
		d: "M25.42 23.5h1.142v-.123l-.001-.763q-.005-.949.005-1.897a9 9 0 0 1 .079-1.072 3.1 3.1 0 0 1 .493-1.331c.268-.397.606-.698 1.107-.754.574-.064 1.055.161 1.195.788.052.23.067.47.068.705q.006 1.568.004 3.135v1.177l.003.09.003.042h1.147v-.113q0-.39-.002-.78c-.001-.653-.003-1.306.005-1.959.005-.348.032-.698.083-1.042.085-.568.288-1.093.67-1.536.314-.361.706-.547 1.19-.514.397.027.694.21.857.585.114.263.136.541.136.822V23.5h1.145l.004-.091v-1.11q.004-1.824-.003-3.647a3.5 3.5 0 0 0-.083-.733c-.115-.522-.387-.946-.878-1.194-.55-.277-1.127-.28-1.705-.106-.65.195-1.109.632-1.453 1.2l-.045.073-.025.043-.014-.049-.02-.066c-.168-.542-.49-.953-1.027-1.168a2.2 2.2 0 0 0-1.285-.092c-.718.151-1.228.581-1.587 1.206l-.034.06-.016.027-.02-.007V16.63H25.42z"
	})), _path5$28 || (_path5$28 = /*#__PURE__*/ React.createElement("path", {
		fill: "#1CA733",
		d: "M7.3 22.3a1.4 1.4 0 1 1-2.8 0 1.4 1.4 0 0 1 2.8 0M11.9 17.7a1.4 1.4 0 1 1-2.8 0 1.4 1.4 0 0 1 2.8 0M11.9 22.3a1.4 1.4 0 1 1-2.8 0 1.4 1.4 0 0 1 2.8 0M16.5 17.7a1.4 1.4 0 1 1-2.8 0 1.4 1.4 0 0 1 2.8 0"
	})), _path6$15 || (_path6$15 = /*#__PURE__*/ React.createElement("path", {
		fill: "#9799AD",
		d: "M7.3 17.7a1.4 1.4 0 1 1-2.8 0 1.4 1.4 0 0 1 2.8 0M16.5 22.3a1.4 1.4 0 1 1-2.8 0 1.4 1.4 0 0 1 2.8 0"
	})));
};

//#endregion
//#region src/HardwareIcon/icons/PDUDetailed.svg
var _path$498;
var _path2$344;
var _path3$174;
var _path4$61;
var _path5$27;
var _path6$14;
var _path7$11;
var _path8$10;
var _path9$8;
var _path0$8;
var _path1$7;
var _path10$7;
var _path11$6;
var _path12$5;
var _path13$5;
var _path14$5;
var _path15$5;
function _extends$512() {
	return _extends$512 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$512.apply(null, arguments);
}
var SvgPduDetailed = function SvgPduDetailed(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$512({
		xmlns: "http://www.w3.org/2000/svg",
		width: 40,
		height: 40,
		fill: "none",
		viewBox: "0 0 40 40"
	}, props), _path$498 || (_path$498 = /*#__PURE__*/ React.createElement("path", {
		fill: "#131522",
		fillOpacity: .08,
		fillRule: "evenodd",
		d: "M9.226 7.5h21.548c.422 0 .903 0 1.353.154.5.17.92.511 1.27 1.107.168.288.57 1.19 1.067 2.344a359 359 0 0 1 1.735 4.122c1.217 2.936 2.412 5.888 2.582 6.373.337.964.525 1.703.443 2.69l-.5 6a3.5 3.5 0 0 1-3.488 3.21H4.764a3.5 3.5 0 0 1-3.488-3.21l-.5-6c-.082-.987.106-1.726.443-2.69.17-.485 1.365-3.437 2.582-6.373.611-1.473 1.23-2.95 1.735-4.122.496-1.153.899-2.056 1.067-2.344.35-.596.77-.937 1.27-1.107.45-.154.931-.154 1.353-.154",
		clipRule: "evenodd"
	})), _path2$344 || (_path2$344 = /*#__PURE__*/ React.createElement("path", {
		fill: "#131522",
		fillOpacity: .12,
		fillRule: "evenodd",
		d: "M9.226 6.5h21.548c.422 0 .903 0 1.353.154.5.17.92.511 1.27 1.107.168.288.57 1.19 1.067 2.344a359 359 0 0 1 1.735 4.122c1.217 2.936 2.412 5.888 2.582 6.373.337.964.525 1.703.443 2.69l-.5 6a3.5 3.5 0 0 1-3.488 3.21H4.764a3.5 3.5 0 0 1-3.488-3.21l-.5-6c-.082-.987.106-1.726.443-2.69.17-.485 1.365-3.437 2.582-6.373.611-1.473 1.23-2.95 1.735-4.122.496-1.153.899-2.056 1.067-2.344.35-.596.77-.937 1.27-1.107.45-.154.931-.154 1.353-.154",
		clipRule: "evenodd"
	})), _path3$174 || (_path3$174 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M7.035 8.014C7.628 7 8.365 7 9.264 7h21.472c.9 0 1.635 0 2.23 1.014.593 1.014 5.015 11.814 5.343 12.752.328.937.49 1.598.417 2.483l-.5 6A3 3 0 0 1 35.236 32H4.764a3 3 0 0 1-2.99-2.75l-.5-6c-.074-.886.089-1.547.417-2.484S6.441 9.028 7.035 8.014"
	})), _path4$61 || (_path4$61 = /*#__PURE__*/ React.createElement("path", {
		fill: "#131522",
		fillOpacity: .12,
		d: "M38.222 20.533q.06.156.087.233c.328.937.49 1.598.417 2.483l-.5 6A3 3 0 0 1 35.236 32H4.764a3 3 0 0 1-2.99-2.75l-.5-6c-.074-.886.089-1.547.417-2.484q.027-.077.087-.233A3.49 3.49 0 0 1 4.26 19.5h31.48c.975 0 1.85.397 2.482 1.033"
	})), _path5$27 || (_path5$27 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M1.27 23.25A3 3 0 0 1 4.26 20h31.48a3 3 0 0 1 2.99 3.25l-.5 6A3 3 0 0 1 35.24 32H4.76a3 3 0 0 1-2.99-2.75z"
	})), _path6$14 || (_path6$14 = /*#__PURE__*/ React.createElement("path", {
		fill: "#C5C8D6",
		d: "M35.6 27.7a1.1 1.1 0 1 1-2.2 0 1.1 1.1 0 0 1 2.2 0"
	})), _path7$11 || (_path7$11 = /*#__PURE__*/ React.createElement("path", {
		fill: "#5461C8",
		d: "M33.478 22.013V22h-.006l-.007.006q-.007.008-.016.013l-.058.037q-.102.067-.205.13c-.026.016-.034.034-.033.064v.55h-.334v.295h.334v.308q0 .368.002.734 0 .129.027.255a.49.49 0 0 0 .328.375c.112.04.227.04.343.021a.5.5 0 0 0 .184-.065l-.016-.057-.061-.227a.4.4 0 0 1-.21.064c-.124.005-.215-.057-.25-.178a.6.6 0 0 1-.02-.159v-1.049l.001-.024h.51v-.295h-.511v-.759z"
	})), _path8$10 || (_path8$10 = /*#__PURE__*/ React.createElement("path", {
		fill: "#5461C8",
		fillRule: "evenodd",
		d: "M35.692 23.849h-1.405l.002.011.009.056q.01.073.026.142.04.177.161.308a.43.43 0 0 0 .273.131q.131.015.26-.021a.48.48 0 0 0 .276-.232q.024-.039.046-.081l.02-.039.279.125-.01.02q0 .004-.003.008l-.001.002-.006.012-.008.016a1 1 0 0 1-.276.348.7.7 0 0 1-.319.129 1 1 0 0 1-.375-.003.76.76 0 0 1-.493-.34 1.16 1.16 0 0 1-.177-.543 1.3 1.3 0 0 1 .111-.664c.106-.226.27-.384.507-.446a.87.87 0 0 1 .71.099.8.8 0 0 1 .323.421c.05.13.069.267.07.406v.135m-.34-.3c-.037-.234-.195-.519-.564-.493a.45.45 0 0 0-.331.164.7.7 0 0 0-.145.328z",
		clipRule: "evenodd"
	})), _path9$8 || (_path9$8 = /*#__PURE__*/ React.createElement("path", {
		fill: "#5461C8",
		d: "m36.986 22.886-.022.089-.01.044q-.008.03-.015.062l-.005.02-.003.013-.02-.006c-.226-.093-.41-.048-.565.14a.9.9 0 0 0-.179.395q-.041.18-.04.366l-.001.51v.276h-.336v-2.003h.335v.333l.023-.033q.021-.033.043-.06c.144-.17.322-.276.552-.275.09.001.177.017.257.062v.012z"
	})), _path0$8 || (_path0$8 = /*#__PURE__*/ React.createElement("path", {
		fill: "#5461C8",
		fillRule: "evenodd",
		d: "M32.913 23.849h-1.4a.9.9 0 0 0 .099.386c.04.074.09.14.16.187a.5.5 0 0 0 .316.079.47.47 0 0 0 .34-.14.8.8 0 0 0 .144-.22l.002-.005.006-.013.143.064.139.063-.015.03-.005.008-.043.082a.85.85 0 0 1-.3.324.8.8 0 0 1-.302.096 1 1 0 0 1-.33-.008.76.76 0 0 1-.52-.378 1.2 1.2 0 0 1-.154-.498c-.02-.234.01-.46.11-.672.106-.226.27-.384.507-.446.25-.066.49-.04.713.1a.8.8 0 0 1 .321.42c.05.129.07.263.069.4zm-.337-.3c-.058-.3-.242-.519-.577-.493a.45.45 0 0 0-.324.168.7.7 0 0 0-.142.325z",
		clipRule: "evenodd"
	})), _path1$7 || (_path1$7 = /*#__PURE__*/ React.createElement("path", {
		fill: "#5461C8",
		d: "M28.425 24.8h.323v-.813q.003-.158.023-.314a.9.9 0 0 1 .14-.389c.076-.116.171-.204.313-.22.162-.019.298.047.337.23a1 1 0 0 1 .02.206v1.261l.002.026v.012h.325v-.261q-.002-.286 0-.573.003-.153.024-.304a.9.9 0 0 1 .19-.449c.088-.106.2-.16.336-.15a.265.265 0 0 1 .242.17.6.6 0 0 1 .039.241V24.8h.323l.001-.027v-.323q0-.534 0-1.067 0-.109-.024-.215a.49.49 0 0 0-.248-.349.62.62 0 0 0-.482-.03.73.73 0 0 0-.411.35l-.02.034-.006-.023-.003-.01a.5.5 0 0 0-.29-.342.6.6 0 0 0-.364-.027.67.67 0 0 0-.448.353l-.009.015-.006.01-.002-.001-.003-.001v-.355h-.322z"
	})), _path10$7 || (_path10$7 = /*#__PURE__*/ React.createElement("path", {
		fill: "#C5C8D6",
		fillRule: "evenodd",
		d: "M19.4 27.667v-3.334c0-.736.597-1.333 1.333-1.333h3.334c.736 0 1.333.597 1.333 1.333v3.334c0 .736-.597 1.333-1.333 1.333h-3.334a1.333 1.333 0 0 1-1.333-1.333m.5 0c0 .46.373.833.833.833h3.334c.46 0 .833-.373.833-.833v-3.334a.833.833 0 0 0-.833-.833h-3.334a.833.833 0 0 0-.833.833z",
		clipRule: "evenodd"
	})), _path11$6 || (_path11$6 = /*#__PURE__*/ React.createElement("path", {
		fill: "#C5C8D6",
		d: "M21.25 27.21a.25.25 0 1 1 0-.5h.834a.25.25 0 0 1 0 .5zM21.042 25.29a.25.25 0 0 1 0-.5h1.25a.25.25 0 1 1 0 .5zM23.558 26.5a.5.5 0 1 1 0-1h.392c.06 0 .108.048.108.107v.786c0 .059-.048.107-.108.107z"
	})), _path12$5 || (_path12$5 = /*#__PURE__*/ React.createElement("path", {
		fill: "#C5C8D6",
		fillRule: "evenodd",
		d: "M11.6 27.667v-3.334c0-.736.597-1.333 1.333-1.333h3.334c.736 0 1.333.597 1.333 1.333v3.334c0 .736-.597 1.333-1.333 1.333h-3.334a1.333 1.333 0 0 1-1.333-1.333m.5 0c0 .46.373.833.833.833h3.334c.46 0 .833-.373.833-.833v-3.334a.833.833 0 0 0-.833-.833h-3.334a.833.833 0 0 0-.833.833z",
		clipRule: "evenodd"
	})), _path13$5 || (_path13$5 = /*#__PURE__*/ React.createElement("path", {
		fill: "#C5C8D6",
		d: "M13.45 27.21a.25.25 0 1 1 0-.5h.834a.25.25 0 0 1 0 .5zM13.242 25.29a.25.25 0 0 1 0-.5h1.25a.25.25 0 1 1 0 .5zM15.758 26.5a.5.5 0 1 1 0-1h.392c.06 0 .108.048.108.107v.786c0 .059-.048.107-.108.107z"
	})), _path14$5 || (_path14$5 = /*#__PURE__*/ React.createElement("path", {
		fill: "#C5C8D6",
		fillRule: "evenodd",
		d: "M3.8 27.667v-3.334c0-.736.597-1.333 1.333-1.333h3.334c.736 0 1.333.597 1.333 1.333v3.334C9.8 28.403 9.203 29 8.467 29H5.133A1.333 1.333 0 0 1 3.8 27.667m.5 0c0 .46.373.833.833.833h3.334c.46 0 .833-.373.833-.833v-3.334a.833.833 0 0 0-.833-.833H5.133a.833.833 0 0 0-.833.833z",
		clipRule: "evenodd"
	})), _path15$5 || (_path15$5 = /*#__PURE__*/ React.createElement("path", {
		fill: "#C5C8D6",
		d: "M5.65 27.21a.25.25 0 1 1 0-.5h.834a.25.25 0 0 1 0 .5zM5.442 25.29a.25.25 0 0 1 0-.5h1.25a.25.25 0 1 1 0 .5zM7.958 26.5a.5.5 0 0 1 0-1h.392c.06 0 .108.048.108.107v.786c0 .059-.048.107-.108.107z"
	})));
};

//#endregion
//#region src/HardwareIcon/icons/PDUSimple.svg
var _path$497;
var _path2$343;
var _path3$173;
var _path4$60;
var _path5$26;
var _path6$13;
var _path7$10;
var _path8$9;
function _extends$511() {
	return _extends$511 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$511.apply(null, arguments);
}
var SvgPduSimple = function SvgPduSimple(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$511({
		xmlns: "http://www.w3.org/2000/svg",
		width: 40,
		height: 40,
		fill: "none",
		viewBox: "0 0 40 40"
	}, props), _path$497 || (_path$497 = /*#__PURE__*/ React.createElement("path", {
		fill: "#131522",
		fillOpacity: .08,
		fillRule: "evenodd",
		d: "M3.85 13h32.3c2.274 0 3.85 2.113 3.85 4.36v7.28c0 2.247-1.576 4.36-3.85 4.36H3.85C1.576 29 0 26.887 0 24.64v-7.28C0 15.113 1.576 13 3.85 13",
		clipRule: "evenodd"
	})), _path2$343 || (_path2$343 = /*#__PURE__*/ React.createElement("path", {
		fill: "#131522",
		fillOpacity: .12,
		fillRule: "evenodd",
		d: "M3.85 12h32.3c2.274 0 3.85 2.113 3.85 4.36v7.28c0 2.247-1.576 4.36-3.85 4.36H3.85C1.576 28 0 25.887 0 23.64v-7.28C0 14.113 1.576 12 3.85 12",
		clipRule: "evenodd"
	})), _path3$173 || (_path3$173 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M1 16.36C1 14.504 2.276 13 3.85 13h32.3c1.574 0 2.85 1.504 2.85 3.36v7.28c0 1.856-1.276 3.36-2.85 3.36H3.85C2.276 27 1 25.496 1 23.64z"
	})), _path4$60 || (_path4$60 = /*#__PURE__*/ React.createElement("path", {
		fill: "#5461C8",
		d: "M26.17 23.5h1.142v-.123l-.001-.763q-.005-.949.005-1.897a9 9 0 0 1 .079-1.072 3.1 3.1 0 0 1 .493-1.331c.268-.397.606-.698 1.107-.754.574-.064 1.055.161 1.195.788.052.23.067.47.068.705q.006 1.568.004 3.135v1.177l.003.09.003.042h1.147v-.113q0-.39-.002-.78c-.001-.653-.003-1.306.005-1.959.005-.348.032-.698.083-1.042.085-.568.288-1.093.67-1.536.314-.361.706-.547 1.19-.514.397.027.694.21.857.585.114.263.136.541.136.822V23.5H35.5l.004-.091v-1.11q.004-1.824-.003-3.647a3.5 3.5 0 0 0-.083-.733c-.115-.522-.387-.946-.878-1.194-.55-.277-1.127-.28-1.705-.106-.65.195-1.109.632-1.453 1.2l-.045.073-.025.043-.014-.049-.02-.066c-.168-.542-.49-.953-1.027-1.168a2.2 2.2 0 0 0-1.285-.092c-.718.151-1.228.581-1.587 1.206l-.034.06-.016.027-.02-.007V16.63H26.17z"
	})), _path5$26 || (_path5$26 = /*#__PURE__*/ React.createElement("path", {
		fill: "#C5C8D6",
		fillRule: "evenodd",
		d: "M13.3 21.944v-3.888c0-.86.696-1.556 1.556-1.556h3.888c.86 0 1.556.696 1.556 1.556v3.888c0 .86-.696 1.556-1.556 1.556h-3.888c-.86 0-1.556-.696-1.556-1.556m.583 0c0 .537.436.973.973.973h3.888a.97.97 0 0 0 .973-.973v-3.888a.97.97 0 0 0-.973-.973h-3.888a.97.97 0 0 0-.973.973z",
		clipRule: "evenodd"
	})), _path6$13 || (_path6$13 = /*#__PURE__*/ React.createElement("path", {
		fill: "#C5C8D6",
		d: "M15.459 21.411a.292.292 0 1 1 0-.583h.972a.292.292 0 0 1 0 .583zM15.216 19.172a.292.292 0 0 1 0-.583h1.458a.292.292 0 1 1 0 .583zM18.15 20.583a.583.583 0 1 1 0-1.166h.459c.069 0 .125.056.125.125v.916c0 .07-.056.125-.125.125z"
	})), _path7$10 || (_path7$10 = /*#__PURE__*/ React.createElement("path", {
		fill: "#C5C8D6",
		fillRule: "evenodd",
		d: "M4.5 21.944v-3.888c0-.86.696-1.556 1.556-1.556h3.888c.86 0 1.556.696 1.556 1.556v3.888c0 .86-.696 1.556-1.556 1.556H6.056c-.86 0-1.556-.696-1.556-1.556m.583 0c0 .537.436.973.973.973h3.888a.97.97 0 0 0 .973-.973v-3.888a.97.97 0 0 0-.973-.973H6.056a.97.97 0 0 0-.973.973z",
		clipRule: "evenodd"
	})), _path8$9 || (_path8$9 = /*#__PURE__*/ React.createElement("path", {
		fill: "#C5C8D6",
		d: "M6.659 21.411a.292.292 0 1 1 0-.583h.972a.292.292 0 0 1 0 .583zM6.416 19.172a.292.292 0 0 1 0-.583h1.458a.292.292 0 1 1 0 .583zM9.35 20.583a.583.583 0 1 1 0-1.166h.459c.069 0 .125.056.125.125v.916c0 .07-.056.125-.125.125z"
	})));
};

//#endregion
//#region src/HardwareIcon/icons/SwitchDetailed.svg
var _path$496;
var _path2$342;
var _path3$172;
var _path4$59;
var _path5$25;
var _path6$12;
var _path7$9;
var _path8$8;
var _path9$7;
var _path0$7;
var _path1$6;
var _path10$6;
var _path11$5;
var _path12$4;
var _path13$4;
var _path14$4;
var _path15$4;
var _path16$4;
function _extends$510() {
	return _extends$510 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$510.apply(null, arguments);
}
var SvgSwitchDetailed = function SvgSwitchDetailed(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$510({
		xmlns: "http://www.w3.org/2000/svg",
		width: 40,
		height: 40,
		fill: "none",
		viewBox: "0 0 40 40"
	}, props), _path$496 || (_path$496 = /*#__PURE__*/ React.createElement("path", {
		fill: "#131522",
		fillOpacity: .08,
		fillRule: "evenodd",
		d: "M9.226 7.5h21.548c.422 0 .903 0 1.353.154.5.17.92.511 1.27 1.107.168.288.57 1.19 1.067 2.344a359 359 0 0 1 1.735 4.122c1.217 2.936 2.412 5.888 2.582 6.373.337.964.525 1.703.443 2.69l-.5 6a3.5 3.5 0 0 1-3.488 3.21H4.764a3.5 3.5 0 0 1-3.488-3.21l-.5-6c-.082-.987.106-1.726.443-2.69.17-.485 1.365-3.437 2.582-6.373.611-1.473 1.23-2.95 1.735-4.122.496-1.153.899-2.056 1.067-2.344.35-.596.77-.937 1.27-1.107.45-.154.931-.154 1.353-.154",
		clipRule: "evenodd"
	})), _path2$342 || (_path2$342 = /*#__PURE__*/ React.createElement("path", {
		fill: "#131522",
		fillOpacity: .12,
		fillRule: "evenodd",
		d: "M9.226 6.5h21.548c.422 0 .903 0 1.353.154.5.17.92.511 1.27 1.107.168.288.57 1.19 1.067 2.344a359 359 0 0 1 1.735 4.122c1.217 2.936 2.412 5.888 2.582 6.373.337.964.525 1.703.443 2.69l-.5 6a3.5 3.5 0 0 1-3.488 3.21H4.764a3.5 3.5 0 0 1-3.488-3.21l-.5-6c-.082-.987.106-1.726.443-2.69.17-.485 1.365-3.437 2.582-6.373.611-1.473 1.23-2.95 1.735-4.122.496-1.153.899-2.056 1.067-2.344.35-.596.77-.937 1.27-1.107.45-.154.931-.154 1.353-.154",
		clipRule: "evenodd"
	})), _path3$172 || (_path3$172 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M7.035 8.014C7.628 7 8.365 7 9.264 7h21.472c.9 0 1.635 0 2.23 1.014.593 1.014 5.015 11.814 5.343 12.752.328.937.49 1.598.417 2.483l-.5 6A3 3 0 0 1 35.236 32H4.764a3 3 0 0 1-2.99-2.75l-.5-6c-.074-.886.089-1.547.417-2.484S6.441 9.028 7.035 8.014"
	})), _path4$59 || (_path4$59 = /*#__PURE__*/ React.createElement("path", {
		fill: "#131522",
		fillOpacity: .12,
		d: "M38.222 20.533q.06.156.087.233c.328.937.49 1.598.417 2.483l-.5 6A3 3 0 0 1 35.236 32H4.764a3 3 0 0 1-2.99-2.75l-.5-6c-.074-.886.089-1.547.417-2.484q.027-.077.087-.233A3.49 3.49 0 0 1 4.26 19.5h31.48c.975 0 1.85.397 2.482 1.033"
	})), _path5$25 || (_path5$25 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M1.27 23.25A3 3 0 0 1 4.26 20h31.48a3 3 0 0 1 2.99 3.25l-.5 6A3 3 0 0 1 35.24 32H4.76a3 3 0 0 1-2.99-2.75z"
	})), _path6$12 || (_path6$12 = /*#__PURE__*/ React.createElement("path", {
		fill: "#C5C8D6",
		d: "M23.776 25.4v-1.63h-.624v-.407h-.204V23.2h-1.053v.163h-.204v.407h-.623v1.63zM23.776 26.6v1.63h-.624v.407h-.204v.163h-1.053v-.163h-.204v-.407h-.623V26.6zM27.683 25.4v-1.63h-.623v-.407h-.204V23.2h-1.053v.163h-.204v.407h-.623v1.63zM27.683 26.6v1.63h-.623v.407h-.204v.163h-1.053v-.163h-.204v-.407h-.623V26.6zM31.591 25.4v-1.63h-.623v-.407h-.204V23.2H29.71v.163h-.204v.407h-.624v1.63zM31.591 26.6v1.63h-.623v.407h-.204v.163H29.71v-.163h-.204v-.407h-.624V26.6zM35.499 25.4v-1.63h-.623v-.407h-.204V23.2h-1.053v.163h-.205v.407h-.623v1.63zM35.499 26.6v1.63h-.623v.407h-.204v.163h-1.053v-.163h-.205v-.407h-.623V26.6z"
	})), _path7$9 || (_path7$9 = /*#__PURE__*/ React.createElement("path", {
		fill: "#9799AD",
		d: "M9.683 28.267a.467.467 0 1 1-.933 0 .467.467 0 0 1 .933 0M14.884 30a.467.467 0 1 1-.933 0 .467.467 0 0 1 .933 0M9.683 30a.467.467 0 1 1-.933 0 .467.467 0 0 1 .933 0"
	})), _path8$8 || (_path8$8 = /*#__PURE__*/ React.createElement("path", {
		fill: "#9799AD",
		d: "M14.883 30a.467.467 0 1 1-.933 0 .467.467 0 0 1 .933 0"
	})), _path9$7 || (_path9$7 = /*#__PURE__*/ React.createElement("path", {
		fill: "#1CA733",
		d: "M11.418 28.267a.467.467 0 1 1-.934 0 .467.467 0 0 1 .934 0"
	})), _path0$7 || (_path0$7 = /*#__PURE__*/ React.createElement("path", {
		fill: "#1CA733",
		d: "M11.417 28.267a.467.467 0 1 1-.934 0 .467.467 0 0 1 .934 0M13.151 30a.467.467 0 1 1-.933 0 .467.467 0 0 1 .933 0"
	})), _path1$6 || (_path1$6 = /*#__PURE__*/ React.createElement("path", {
		fill: "#1CA733",
		d: "M13.15 30a.467.467 0 1 1-.933 0 .467.467 0 0 1 .933 0M11.418 30a.467.467 0 1 1-.934 0 .467.467 0 0 1 .934 0"
	})), _path10$6 || (_path10$6 = /*#__PURE__*/ React.createElement("path", {
		fill: "#1CA733",
		d: "M11.417 30a.467.467 0 1 1-.934 0 .467.467 0 0 1 .934 0"
	})), _path11$5 || (_path11$5 = /*#__PURE__*/ React.createElement("path", {
		fill: "#C5C8D6",
		d: "M7.208 30.467v-1.63h-.623v-.407H6.38v-.163H5.327v.163h-.204v.407H4.5v1.63z"
	})), _path12$4 || (_path12$4 = /*#__PURE__*/ React.createElement("path", {
		fill: "#5461C8",
		d: "m7.81 22.11-.001-.01h-.005l-.005.005-.013.01-.045.03-.161.102c-.02.012-.027.026-.026.05v.431h-.263v.232h.263v.243l.001.576q0 .102.022.2a.39.39 0 0 0 .257.295.54.54 0 0 0 .414-.034l-.012-.045-.048-.178a.3.3 0 0 1-.164.05c-.098.004-.17-.045-.197-.14a.5.5 0 0 1-.016-.125v-.843h.4v-.232h-.4v-.596z"
	})), _path13$4 || (_path13$4 = /*#__PURE__*/ React.createElement("path", {
		fill: "#5461C8",
		fillRule: "evenodd",
		d: "M9.548 23.553H8.445l.001.008.007.045q.009.057.02.111a.5.5 0 0 0 .127.242.34.34 0 0 0 .215.103q.104.012.204-.017a.38.38 0 0 0 .217-.182 1 1 0 0 0 .052-.094l.22.098-.008.016-.003.006-.001.002-.005.01-.006.012a.8.8 0 0 1-.217.273.56.56 0 0 1-.25.101.8.8 0 0 1-.295-.002.6.6 0 0 1-.387-.268.9.9 0 0 1-.14-.426c-.014-.182.01-.356.088-.521a.6.6 0 0 1 .398-.35.69.69 0 0 1 .558.077.64.64 0 0 1 .254.33.9.9 0 0 1 .054.347v.079m-.266-.236c-.03-.184-.153-.408-.443-.387a.35.35 0 0 0-.26.129.54.54 0 0 0-.115.258z",
		clipRule: "evenodd"
	})), _path14$4 || (_path14$4 = /*#__PURE__*/ React.createElement("path", {
		fill: "#5461C8",
		d: "m10.566 22.796-.038.154-.003.016-.002.01-.016-.006c-.178-.073-.322-.037-.444.11a.7.7 0 0 0-.141.31q-.032.142-.032.288v.618h-.264v-1.573h.263v.261l.018-.026q.017-.026.034-.047a.55.55 0 0 1 .433-.216q.108-.002.202.049v.009z"
	})), _path15$4 || (_path15$4 = /*#__PURE__*/ React.createElement("path", {
		fill: "#5461C8",
		fillRule: "evenodd",
		d: "M7.365 23.553H6.266c.005.108.026.21.077.303.032.058.07.11.125.147.076.052.16.067.25.062a.37.37 0 0 0 .266-.11.6.6 0 0 0 .113-.173l.002-.004.005-.01.112.05.11.05-.013.023-.003.007-.034.064a.67.67 0 0 1-.236.254.779.779 0 0 1-.496.07.6.6 0 0 1-.41-.297.9.9 0 0 1-.12-.392c-.016-.183.008-.36.087-.527a.6.6 0 0 1 .398-.35.69.69 0 0 1 .56.078.64.64 0 0 1 .252.33.9.9 0 0 1 .054.314zm-.264-.236c-.046-.236-.19-.408-.454-.387a.35.35 0 0 0-.254.132.55.55 0 0 0-.112.255z",
		clipRule: "evenodd"
	})), _path16$4 || (_path16$4 = /*#__PURE__*/ React.createElement("path", {
		fill: "#5461C8",
		d: "M3.839 24.3h.254v-.639q.002-.123.018-.247a.7.7 0 0 1 .11-.305c.06-.091.134-.16.245-.173.128-.015.235.037.266.18a1 1 0 0 1 .015.163l.002 1.01v.01h.255v-.655q.003-.12.02-.239a.7.7 0 0 1 .148-.353.3.3 0 0 1 .264-.118.21.21 0 0 1 .19.135.5.5 0 0 1 .03.188l.001.744v.299h.254l.001-.021v-1.093a1 1 0 0 0-.019-.168.38.38 0 0 0-.195-.274.48.48 0 0 0-.379-.024.57.57 0 0 0-.323.275l-.015.027-.005-.018-.003-.009a.4.4 0 0 0-.228-.268.47.47 0 0 0-.285-.021.52.52 0 0 0-.353.277l-.006.012-.005.008-.002-.001h-.002v-.28h-.253z"
	})));
};

//#endregion
//#region src/HardwareIcon/icons/SwitchSimple.svg
var _path$495;
var _path2$341;
var _path3$171;
var _path4$58;
var _path5$24;
function _extends$509() {
	return _extends$509 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$509.apply(null, arguments);
}
var SvgSwitchSimple = function SvgSwitchSimple(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$509({
		xmlns: "http://www.w3.org/2000/svg",
		width: 40,
		height: 40,
		fill: "none",
		viewBox: "0 0 40 40"
	}, props), _path$495 || (_path$495 = /*#__PURE__*/ React.createElement("path", {
		fill: "#131522",
		fillOpacity: .08,
		fillRule: "evenodd",
		d: "M3.85 13h32.3c2.274 0 3.85 2.113 3.85 4.36v7.28c0 2.247-1.576 4.36-3.85 4.36H3.85C1.576 29 0 26.887 0 24.64v-7.28C0 15.113 1.576 13 3.85 13",
		clipRule: "evenodd"
	})), _path2$341 || (_path2$341 = /*#__PURE__*/ React.createElement("path", {
		fill: "#131522",
		fillOpacity: .12,
		fillRule: "evenodd",
		d: "M3.85 12h32.3c2.274 0 3.85 2.113 3.85 4.36v7.28c0 2.247-1.576 4.36-3.85 4.36H3.85C1.576 28 0 25.887 0 23.64v-7.28C0 14.113 1.576 12 3.85 12",
		clipRule: "evenodd"
	})), _path3$171 || (_path3$171 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M1 16.36C1 14.504 2.276 13 3.85 13h32.3c1.574 0 2.85 1.504 2.85 3.36v7.28c0 1.856-1.276 3.36-2.85 3.36H3.85C2.276 27 1 25.496 1 23.64z"
	})), _path4$58 || (_path4$58 = /*#__PURE__*/ React.createElement("path", {
		fill: "#C5C8D6",
		d: "M22.05 22v-2.963h-1.133v-.74h-.371V18H18.63v.296h-.371v.741h-1.133V22zM28.773 22v-2.963H27.64v-.74h-.371V18h-1.915v.296h-.37v.741H23.85V22zM35.497 22v-2.963h-1.134v-.74h-.37V18h-1.916v.296h-.37v.741h-1.134V22z"
	})), _path5$24 || (_path5$24 = /*#__PURE__*/ React.createElement("path", {
		fill: "#5461C8",
		d: "M4.5 23.5h1.142v-.123l-.001-.763q-.005-.949.005-1.897.007-.539.079-1.072a3.1 3.1 0 0 1 .493-1.331c.268-.397.606-.698 1.107-.754.574-.064 1.055.161 1.195.788.052.23.067.47.068.705q.005 1.568.004 3.135v1.177l.003.09.003.042h1.147v-.113q0-.39-.002-.78c-.001-.653-.003-1.306.005-1.959.005-.348.032-.698.083-1.042.085-.568.288-1.093.67-1.536.314-.361.706-.547 1.19-.514.397.027.694.21.856.585.115.263.137.541.137.822V23.5h1.145l.004-.091v-1.11q.004-1.824-.003-3.647a3.5 3.5 0 0 0-.083-.733c-.115-.522-.387-.946-.877-1.194-.55-.277-1.128-.28-1.706-.106-.65.195-1.109.632-1.453 1.2l-.045.073-.026.043-.033-.115c-.168-.542-.49-.953-1.027-1.168a2.2 2.2 0 0 0-1.285-.092c-.718.151-1.228.581-1.587 1.206l-.034.06-.016.027-.02-.007V16.63H4.5z"
	})));
};

//#endregion
//#region src/HardwareIcon/index.ts
const HardwareIconSVG = {
	AccessPointDetailed: SvgAccessPointDetailed,
	AccessPointSimple: SvgAccessPointSimple,
	FirewallDetailed: SvgFirewallDetailed,
	FirewallSimple: SvgFirewallSimple,
	PDUDetailed: SvgPduDetailed,
	PDUSimple: SvgPduSimple,
	SwitchDetailed: SvgSwitchDetailed,
	SwitchSimple: SvgSwitchSimple
};

//#endregion
//#region src/Icon/icons/AccessControl.svg
var _path$494;
var _path2$340;
function _extends$508() {
	return _extends$508 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$508.apply(null, arguments);
}
var SvgAccessControl = function SvgAccessControl(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$508({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$494 || (_path$494 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M12.623 13.586c.376.376.99.38 1.315-.042a7.5 7.5 0 1 0-11.876 0c.324.421.94.418 1.315.042.269-.268.265-.701.03-1a5.85 5.85 0 1 1 9.186 0c-.235.299-.239.732.03 1",
		opacity: .2
	})), _path2$340 || (_path2$340 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8.255 4.122a.35.35 0 0 0-.51 0l-.496.582c-.137.161-.322.27-.523.336a4.1 4.1 0 1 0 2.547-.001 1.15 1.15 0 0 1-.524-.336zm2.367 6.329a3.028 3.028 0 1 1-5.244-3.029 3.028 3.028 0 0 1 5.244 3.029",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/AccessPoint.svg
var _path$493;
var _path2$339;
var _path3$170;
function _extends$507() {
	return _extends$507 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$507.apply(null, arguments);
}
var SvgAccessPoint = function SvgAccessPoint(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$507({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$493 || (_path$493 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M13.166 2.835c.043.043.147.189.26.528.11.324.2.744.27 1.245.139 1.004.179 2.214.179 3.392s-.04 2.388-.18 3.392a7 7 0 0 1-.268 1.245c-.114.339-.218.485-.261.528a.7.7 0 0 1-.143.089c-.089.045-.224.103-.42.164-.363.113-.83.205-1.363.275-1.064.142-2.276.182-3.22.182-.943 0-2.155-.04-3.22-.182-.533-.07-.999-.162-1.362-.275a3 3 0 0 1-.42-.164.7.7 0 0 1-.143-.089l-.019-.022 2.45-2.45c.059.17.132.321.203.446.164.29.377.551.597.77.222.217.484.424.771.583.267.149.662.315 1.123.315.442 0 .822-.153 1.083-.293.278-.15.532-.343.747-.546.375-.355.86-.961.962-1.697h-.003q.016-.09.021-.178a1.78 1.78 0 0 0 1.05-.609c.257-.306.394-.677.417-1.051a1.78 1.78 0 0 0 1.05-.609 1.82 1.82 0 0 0-.179-2.516l-.01-.01-.011-.009-.098-.084-.013-.012-.305-.24a10 10 0 0 0-1.002-.664l1.456-1.455z",
		opacity: .25
	})), _path2$339 || (_path2$339 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M6.383 9.989a.61.61 0 0 1 .202-.466l.004-.004.118-.096a3 3 0 0 1 .287-.189c.23-.132.59-.292 1.006-.292s.776.16 1.006.292c.12.069.218.137.287.19m-2.91.565v.008c0 .183.07.373.17.55s.24.353.396.507.332.29.51.389c.175.097.364.164.541.164.17 0 .348-.061.516-.15.17-.092.338-.218.489-.36.295-.28.551-.65.598-.99a.62.62 0 0 0-.189-.585l-.119-.097-.002-.002m1.589-1.56c.244.219.27.598.059.85a.58.58 0 0 1-.834.061l-.037-.031-.129-.101a5 5 0 0 0-.483-.318c-.415-.238-.935-.446-1.458-.446s-1.043.208-1.458.446a4.6 4.6 0 0 0-.611.419l-.036.03a.58.58 0 0 1-.835-.06.616.616 0 0 1 .058-.85l.069-.06q.062-.05.173-.136c.145-.11.353-.255.607-.4.205-.117.448-.24.719-.342.389-.148.837-.257 1.314-.257s.927.11 1.317.258c.27.103.511.224.716.34a6 6 0 0 1 .78.537zm1.367-1.746.098.084c.244.219.271.6.06.852a.58.58 0 0 1-.834.06l-.068-.056a7.67 7.67 0 0 0-1.02-.7C9.8 5.964 8.914 5.602 8 5.602s-1.8.362-2.485.753a7.7 7.7 0 0 0-1.02.7l-.068.058a.58.58 0 0 1-.834-.061.616.616 0 0 1 .059-.85l.1-.086a8.843 8.843 0 0 1 1.19-.818c.767-.439 1.86-.906 3.058-.906 1.199 0 2.291.467 3.06.906a9 9 0 0 1 1.189.818",
		clipRule: "evenodd"
	})), _path3$170 || (_path3$170 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M14.565 13.017c-.14.419-.32.764-.55.995-.232.233-.606.412-1.056.552-.453.14-.992.243-1.561.319-1.14.151-2.41.192-3.378.192s-2.238-.04-3.377-.192a10 10 0 0 1-1.561-.32c-.45-.14-.825-.318-1.057-.55-.23-.232-.411-.577-.555-.995a8.3 8.3 0 0 1-.333-1.461C.976 10.47.925 9.195.925 8s.05-2.47.212-3.557c.08-.543.189-1.042.333-1.461.144-.418.325-.763.555-.994.232-.233.606-.412 1.057-.552a10 10 0 0 1 1.56-.319C5.783.966 7.053.925 8.02.925s2.239.04 3.378.192a10 10 0 0 1 1.56.32c.451.14.825.318 1.057.55.23.232.41.577.55.996s.243.917.319 1.46c.15 1.088.191 2.362.191 3.557s-.04 2.47-.191 3.556a8.3 8.3 0 0 1-.32 1.461M2.875 2.835c-.046.046-.153.196-.27.537a7 7 0 0 0-.281 1.247C2.175 5.621 2.125 6.829 2.125 8s.05 2.379.199 3.381c.074.501.169.922.28 1.247.118.34.225.49.271.537.01.01.052.043.142.089.09.045.225.103.42.164.364.112.83.205 1.364.276 1.064.14 2.275.181 3.22.181.943 0 2.155-.04 3.22-.181.533-.071.998-.164 1.362-.276a3 3 0 0 0 .42-.164.7.7 0 0 0 .143-.09c.042-.042.147-.188.26-.527.11-.324.2-.744.269-1.246.14-1.004.18-2.213.18-3.391s-.04-2.387-.18-3.391a7 7 0 0 0-.268-1.246c-.114-.34-.219-.485-.261-.528a.7.7 0 0 0-.143-.089 3 3 0 0 0-.42-.164 8.6 8.6 0 0 0-1.363-.275c-1.064-.142-2.276-.182-3.22-.182s-2.155.04-3.22.182c-.533.07-.999.163-1.362.275-.196.061-.331.119-.42.164a.7.7 0 0 0-.143.09",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/AccessPointBackup.svg
var _path$492;
var _path2$338;
var _path3$169;
var _path4$57;
var _path5$23;
function _extends$506() {
	return _extends$506 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$506.apply(null, arguments);
}
var SvgAccessPointBackup = function SvgAccessPointBackup(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$506({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$492 || (_path$492 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M15.074 8.352 15.075 8c0-1.195-.04-2.47-.191-3.556a8.3 8.3 0 0 0-.32-1.461c-.14-.419-.318-.764-.549-.995-.232-.233-.606-.412-1.056-.552a10 10 0 0 0-1.561-.319C10.258.966 8.988.925 8.02.925s-2.238.04-3.377.192a10 10 0 0 0-1.561.32c-.45.14-.825.318-1.057.55-.23.232-.411.577-.555.995-.144.42-.253.918-.333 1.461C.976 5.53.925 6.805.925 8s.05 2.47.212 3.557a8.3 8.3 0 0 0 .333 1.461c.144.418.325.763.555.994.232.233.606.412 1.057.552.453.14.991.243 1.56.319 1.14.151 2.41.192 3.378.192q.16 0 .332-.002a4.8 4.8 0 0 1-.59-1.199c-.9-.007-1.992-.052-2.961-.18-.534-.071-1-.164-1.363-.276a3 3 0 0 1-.42-.164.7.7 0 0 1-.143-.09c-.046-.045-.153-.195-.27-.536a7 7 0 0 1-.281-1.247C2.176 10.38 2.125 9.171 2.125 8s.05-2.379.199-3.381c.074-.501.169-.922.28-1.247.118-.34.225-.49.271-.537a.7.7 0 0 1 .142-.089c.09-.045.225-.103.42-.164.364-.112.83-.205 1.364-.275 1.064-.142 2.275-.182 3.22-.182.943 0 2.155.04 3.22.182.533.07.998.163 1.362.275a3 3 0 0 1 .42.164c.09.046.132.079.143.09.042.042.147.188.26.527.11.324.2.744.269 1.246.13.936.174 2.05.18 3.153.429.141.832.34 1.199.59"
	})), _path2$338 || (_path2$338 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "m10.787 7.782-.146-.115a6 6 0 0 0-.608-.4 5 5 0 0 0-.716-.341A3.7 3.7 0 0 0 8 6.668c-.477 0-.925.11-1.314.257-.27.103-.514.225-.719.342a6 6 0 0 0-.78.536l-.07.06a.616.616 0 0 0-.057.85.58.58 0 0 0 .835.06l.036-.03.128-.101a5 5 0 0 1 .483-.318c.415-.238.936-.446 1.458-.446.523 0 1.043.208 1.458.446q.064.036.123.073a4.8 4.8 0 0 1 1.206-.615M8.77 9.115A1.9 1.9 0 0 0 8 8.942c-.416 0-.776.16-1.006.292-.12.069-.218.137-.287.19l-.118.095-.004.004a.61.61 0 0 0-.202.466v.008c0 .183.07.373.17.55s.24.353.396.507.332.29.51.389q.067.036.135.067A4.8 4.8 0 0 1 8.77 9.115"
	})), _path3$169 || (_path3$169 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "m12.347 6.2-.098-.083a8.842 8.842 0 0 0-1.19-.818C10.292 4.86 9.2 4.393 8 4.393c-1.198 0-2.291.467-3.06.906a9 9 0 0 0-1.189.818l-.1.085c-.243.22-.27.6-.058.85a.58.58 0 0 0 .835.062l.067-.058q.074-.062.216-.17c.191-.144.467-.337.804-.53.684-.39 1.571-.753 2.485-.753s1.801.362 2.485.753a7.7 7.7 0 0 1 1.02.7l.068.058a.58.58 0 0 0 .834-.061.62.62 0 0 0-.06-.852"
	})), _path4$57 || (_path4$57 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M12.364 10.334c.293 0 .531.238.531.532v1.284l.888.887a.531.531 0 0 1-.752.752l-1.043-1.043a.53.53 0 0 1-.155-.376v-1.504c0-.294.237-.532.531-.532",
		clipRule: "evenodd"
	})), _path5$23 || (_path5$23 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8.72 12.36a3.64 3.64 0 1 1 7.28 0 3.64 3.64 0 0 1-7.28 0m1.154 0a2.487 2.487 0 1 1 4.974 0 2.487 2.487 0 0 1-4.974 0",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/AccessPointCycle.svg
var _path$491;
var _path2$337;
var _path3$168;
function _extends$505() {
	return _extends$505 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$505.apply(null, arguments);
}
var SvgAccessPointCycle = function SvgAccessPointCycle(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$505({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$491 || (_path$491 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M15.012 10.238A36 36 0 0 0 15.075 8c0-1.195-.04-2.47-.191-3.556a8.3 8.3 0 0 0-.32-1.461c-.14-.419-.318-.764-.549-.995-.232-.233-.606-.412-1.056-.552a10 10 0 0 0-1.561-.319C10.258.966 8.988.925 8.02.925s-2.238.04-3.377.192a10 10 0 0 0-1.561.32c-.45.14-.825.318-1.057.55-.23.232-.411.577-.555.995-.144.42-.253.918-.333 1.461C.976 5.53.925 6.805.925 8s.05 2.47.212 3.557a8.3 8.3 0 0 0 .333 1.461c.144.418.325.763.555.994.232.233.606.412 1.057.552.453.14.991.243 1.56.319 1.044.138 2.197.184 3.127.191a4.3 4.3 0 0 1-.494-1.207 24 24 0 0 1-2.474-.174c-.534-.07-1-.163-1.363-.275a3 3 0 0 1-.42-.164.7.7 0 0 1-.143-.09c-.046-.045-.153-.195-.27-.536a7 7 0 0 1-.281-1.247C2.176 10.38 2.125 9.171 2.125 8s.05-2.379.199-3.381c.074-.501.169-.922.28-1.247.118-.34.225-.49.271-.537a.7.7 0 0 1 .142-.089c.09-.045.225-.103.42-.164.364-.112.83-.205 1.364-.275 1.064-.142 2.275-.182 3.22-.182.943 0 2.155.04 3.22.182.533.07.998.163 1.362.275a3 3 0 0 1 .42.164c.09.046.132.079.143.09.042.042.147.188.26.527.11.324.2.744.269 1.246.14 1.004.18 2.213.18 3.391q0 .584-.015 1.164c.446.286.837.65 1.152 1.074"
	})), _path2$337 || (_path2$337 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M11.055 8.504a.62.62 0 0 0-.173-.642l-.07-.06a5.79 5.79 0 0 0-.78-.536 5 5 0 0 0-.715-.34A3.7 3.7 0 0 0 8 6.668c-.477 0-.925.11-1.314.257-.27.103-.514.225-.719.342a6 6 0 0 0-.78.536l-.07.06a.616.616 0 0 0-.057.85.58.58 0 0 0 .835.06l.036-.03.128-.101a5 5 0 0 1 .483-.318c.415-.238.936-.446 1.458-.446.523 0 1.043.208 1.458.446a4.6 4.6 0 0 1 .596.406c.318-.113.654-.19 1-.226M9.036 9.252l-.03-.018c-.23-.132-.59-.292-1.006-.292s-.776.16-1.006.292c-.12.069-.218.137-.287.19l-.118.095-.004.004a.61.61 0 0 0-.202.466v.008c0 .183.07.373.17.55s.24.353.396.507c.137.135.29.257.446.352a4.37 4.37 0 0 1 1.641-2.154"
	})), _path3$168 || (_path3$168 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "m12.347 6.2-.098-.083a8.842 8.842 0 0 0-1.19-.818C10.292 4.86 9.2 4.393 8 4.393c-1.198 0-2.291.467-3.06.906a9 9 0 0 0-1.189.818l-.1.085c-.243.22-.27.6-.058.85a.58.58 0 0 0 .835.062l.067-.058q.074-.062.216-.17c.191-.144.467-.337.804-.53.684-.39 1.571-.753 2.485-.753s1.801.362 2.485.753a7.7 7.7 0 0 1 1.02.7l.068.058a.58.58 0 0 0 .834-.061.62.62 0 0 0-.06-.852M13.428 12.395a1.966 1.966 0 1 0-.8 2.064c.238-.164.585-.198.83.016.25.219.29.63 0 .856a3.16 3.16 0 1 1 1.191-2.886l.283-.233a.68.68 0 0 1 .875.002.535.535 0 0 1 0 .822l-.004.004-1.279 1.035a.66.66 0 0 1-.456.176.66.66 0 0 1-.457-.176l-1.283-1.039a.535.535 0 0 1 0-.822.68.68 0 0 1 .875-.002z"
	})));
};

//#endregion
//#region src/Icon/icons/AccessPointRogue.svg
var _path$490;
var _path2$336;
var _path3$167;
var _path4$56;
function _extends$504() {
	return _extends$504 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$504.apply(null, arguments);
}
var SvgAccessPointRogue = function SvgAccessPointRogue(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$504({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 17,
		fill: "none",
		viewBox: "0 0 16 17"
	}, props), _path$490 || (_path$490 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "m9.245 6.83.024-.02.008-.008.002-.002h.002v-.002a.61.61 0 0 0 .189-.58c-.046-.32-.283-.656-.543-.903a2 2 0 0 0-.442-.324A1.05 1.05 0 0 0 8 4.85c-.173 0-.35.065-.508.153-.162.09-.32.212-.46.35s-.266.295-.358.457c-.09.16-.157.34-.157.517v.007a.61.61 0 0 0 .201.464h.001l.002.002.003.003.007.006a2 2 0 0 0 .099.08c.062.046.15.108.257.17.206.117.532.263.913.263.38 0 .707-.146.913-.264a2.5 2.5 0 0 0 .332-.229"
	})), _path2$336 || (_path2$336 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M10.613 7.39a.583.583 0 0 0-.838-.062l-.005.005a2 2 0 0 1-.134.106 4 4 0 0 1-.41.27c-.355.204-.792.377-1.226.377s-.871-.173-1.226-.376a4 4 0 0 1-.544-.377l-.004-.004a.584.584 0 0 0-.839.061.614.614 0 0 0 .059.849l.002.002.005.004.012.01a3 3 0 0 0 .196.158c.128.096.311.224.536.353.439.25 1.083.53 1.803.53s1.365-.28 1.804-.53a5 5 0 0 0 .73-.51l.014-.012.004-.003.002-.002a.615.615 0 0 0 .059-.849"
	})), _path3$167 || (_path3$167 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M11.886 8.83a.583.583 0 0 0-.84-.06l-.001.001-.01.008a3 3 0 0 1-.23.184c-.163.124-.4.289-.688.454-.588.336-1.344.643-2.117.643s-1.529-.307-2.116-.643a6.6 6.6 0 0 1-.92-.638l-.01-.009a.584.584 0 0 0-.84.06.614.614 0 0 0 .059.849l.001.001.002.002.006.005.017.015.064.054q.081.069.228.18c.195.147.474.342.815.537.672.384 1.634.797 2.694.797s2.022-.413 2.694-.797a8 8 0 0 0 1.107-.771l.018-.016.005-.004.003-.003a.615.615 0 0 0 .059-.848"
	})), _path4$56 || (_path4$56 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M2.505.14C2.463.032 2.35-.007 2.26 0c-.091.007-.198.061-.212.18-.05.417-.106.989-.108 1.502 0 .257.011.501.045.705.03.181.079.339.156.445q-.137.246-.243.555a8 8 0 0 0-.31 1.364C1.437 5.763 1.39 6.95 1.39 8.06c0 1.11.047 2.297.197 3.309.075.506.176.971.311 1.364.135.39.306.717.526.938.222.223.577.392.997.522.424.132.926.228 1.456.298 1.06.141 2.242.179 3.142.179s2.081-.038 3.142-.179a9 9 0 0 0 1.456-.298c.42-.13.775-.299.997-.522.22-.22.39-.548.52-.94a7.7 7.7 0 0 0 .298-1.363c.14-1.012.178-2.198.178-3.308s-.038-2.296-.178-3.308a7.7 7.7 0 0 0-.298-1.364 3.2 3.2 0 0 0-.255-.585c.07-.113.115-.274.142-.457.03-.205.04-.446.039-.698a14 14 0 0 0-.108-1.469c-.014-.118-.12-.172-.212-.178-.091-.007-.203.032-.245.138-.234.598-.827 1.372-1.69 1.592a12 12 0 0 0-.644-.102c-1.06-.141-2.242-.179-3.142-.179s-2.081.038-3.142.179q-.343.045-.666.106C3.34 1.52 2.741.74 2.505.139m.887 3.077a.6.6 0 0 0-.122.076c-.037.036-.134.169-.242.483-.103.299-.19.686-.259 1.15-.137.928-.184 2.047-.184 3.134s.047 2.206.184 3.134c.07.464.156.851.26 1.15.107.314.204.447.24.483.006.006.04.034.123.076.08.04.203.093.383.149.335.104.765.19 1.26.255.985.13 2.108.168 2.984.168s1.998-.037 2.984-.168c.495-.066.925-.151 1.26-.255.18-.056.303-.108.383-.15a.6.6 0 0 0 .122-.075c.033-.033.128-.162.233-.474.1-.298.183-.685.247-1.15.13-.929.167-2.05.167-3.143 0-1.094-.038-2.214-.167-3.144a6.6 6.6 0 0 0-.247-1.149c-.105-.312-.2-.441-.233-.474a.6.6 0 0 0-.122-.076 2.5 2.5 0 0 0-.384-.15 8 8 0 0 0-1.259-.254c-.986-.13-2.108-.168-2.984-.168s-1.999.037-2.985.168c-.494.066-.924.151-1.259.255a2.5 2.5 0 0 0-.383.15",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/AccessPoints.svg
var _path$489;
var _path2$335;
var _path3$166;
var _path4$55;
function _extends$503() {
	return _extends$503 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$503.apply(null, arguments);
}
var SvgAccessPoints = function SvgAccessPoints(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$503({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$489 || (_path$489 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M1.83 10.556c-.19-.19-.33-.464-.435-.771a6 6 0 0 1-.243-1.065C1.036 7.94 1 7.028 1 6.18s.036-1.76.152-2.54a6 6 0 0 1 .243-1.065c.105-.307.245-.58.435-.771.195-.196.494-.333.821-.435a7 7 0 0 1 1.133-.232A19 19 0 0 1 6.194 1c.688 0 1.595.029 2.411.137.408.054.8.13 1.133.232.327.102.625.24.82.435.192.192.33.466.432.773.09.266.157.572.209.9a24 24 0 0 0-1.233-.037 4 4 0 0 0-.122-.48 1.5 1.5 0 0 0-.098-.236 1 1 0 0 0-.04-.063l-.004-.003-.054-.03a2 2 0 0 0-.268-.105 6 6 0 0 0-.934-.188 18 18 0 0 0-2.252-.127c-.663 0-1.51.028-2.251.127-.372.05-.69.113-.934.188-.13.04-.216.078-.269.104l-.053.03-.005.004-.009.012-.034.055q-.042.073-.102.24a5 5 0 0 0-.19.849c-.103.696-.139 1.539-.139 2.363s.036 1.668.139 2.363q.078.523.19.849.06.166.102.24a1 1 0 0 0 .043.067l.005.003q.014.01.053.03c.053.027.139.064.269.105q.189.058.431.106c.002.399.011.817.034 1.234a6 6 0 0 1-.823-.186c-.327-.102-.626-.24-.82-.435"
	})), _path2$335 || (_path2$335 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M5.035 13.425c.105.307.245.58.435.771.195.196.494.333.821.435.333.103.725.178 1.133.232a19 19 0 0 0 2.41.137c.688 0 1.595-.029 2.411-.137a7 7 0 0 0 1.133-.232c.327-.102.625-.24.82-.435.192-.192.33-.466.432-.773.104-.31.179-.675.233-1.065.108-.78.137-1.691.137-2.538s-.029-1.757-.137-2.538a6 6 0 0 0-.233-1.065c-.103-.307-.24-.581-.431-.773-.196-.196-.494-.333-.821-.435a7 7 0 0 0-1.133-.232 19 19 0 0 0-2.41-.137c-.688 0-1.595.029-2.411.137-.408.054-.8.13-1.133.232-.327.102-.626.24-.82.435-.191.19-.33.464-.436.771a6 6 0 0 0-.243 1.065c-.116.78-.152 1.692-.152 2.54s.036 1.76.152 2.54c.058.39.136.755.243 1.065m1.244-7.057q-.042.073-.102.24a5 5 0 0 0-.19.849c-.103.696-.139 1.539-.139 2.363s.036 1.668.139 2.363q.078.523.19.849.06.166.102.24a1 1 0 0 0 .043.067l.005.003q.014.01.053.03c.053.027.139.064.269.105.244.075.562.139.934.188.74.099 1.588.127 2.251.127.664 0 1.511-.028 2.252-.127.372-.05.69-.113.934-.188.13-.04.216-.078.269-.104l.053-.03.004-.004a.4.4 0 0 0 .04-.063q.04-.072.098-.236.109-.324.182-.848c.097-.697.126-1.542.126-2.372s-.029-1.675-.126-2.372a5 5 0 0 0-.182-.848 1.5 1.5 0 0 0-.098-.236.4.4 0 0 0-.04-.063l-.004-.003-.053-.03a2 2 0 0 0-.27-.105 6 6 0 0 0-.933-.188 18 18 0 0 0-2.252-.127c-.663 0-1.51.028-2.251.127-.372.05-.69.113-.934.188-.13.04-.216.078-.269.104l-.053.03-.005.004-.009.012z",
		clipRule: "evenodd"
	})), _path3$166 || (_path3$166 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M4.479 4.456c.439-.44 1.002-.661 1.397-.784l.035-.01c-.736.06-1.4.35-1.883.627a6 6 0 0 0-.837.575l-.07.06a.416.416 0 0 0-.04.574.39.39 0 0 0 .56.042l.003-.003.047-.04a4 4 0 0 1 .18-.141c.138-.301.33-.623.608-.9m3.318 5.282a.415.415 0 0 0-.04.573.39.39 0 0 0 .56.042l.004-.003.025-.021q.03-.026.09-.072c.082-.06.2-.143.344-.226.294-.168.666-.318 1.04-.318s.746.15 1.04.318a3 3 0 0 1 .434.298l.002.002.027.022a.39.39 0 0 0 .56-.042.415.415 0 0 0-.038-.572l-.05-.042v-.001l-.12-.095a4 4 0 0 0-.428-.282 3.6 3.6 0 0 0-.504-.24 2.6 2.6 0 0 0-.923-.18c-.334 0-.648.076-.922.18-.19.072-.36.158-.505.24a4 4 0 0 0-.547.377l-.048.04zM6.76 8.564a.416.416 0 0 0-.04.574.39.39 0 0 0 .56.042l.004-.003.047-.04q.053-.044.153-.12a5 5 0 0 1 .57-.376c.485-.277 1.115-.535 1.766-.535.65 0 1.281.258 1.766.535a5.4 5.4 0 0 1 .723.496l.002.002.048.04a.39.39 0 0 0 .56-.041.417.417 0 0 0-.039-.573l-.07-.06a6.223 6.223 0 0 0-.838-.576c-.541-.31-1.31-.638-2.152-.638s-1.61.328-2.152.638a6 6 0 0 0-.837.575l-.07.06",
		clipRule: "evenodd"
	})), _path4$55 || (_path4$55 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M10.81 10.913c.109.1.152.25.124.387l-.001.01c-.035.233-.211.49-.416.684-.106.1-.224.188-.342.25a.8.8 0 0 1-.355.105.8.8 0 0 1-.373-.114 1.7 1.7 0 0 1-.356-.27 1.7 1.7 0 0 1-.277-.355.8.8 0 0 1-.116-.38v-.007a.41.41 0 0 1 .134-.311l.005-.005.084-.067a2 2 0 0 1 .198-.13 1.44 1.44 0 0 1 .701-.204c.29 0 .54.111.701.204.084.047.152.095.2.132l.003.002z"
	})));
};

//#endregion
//#region src/Icon/icons/AccessPointScan.svg
var _path$488;
var _path2$334;
function _extends$502() {
	return _extends$502 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$502.apply(null, arguments);
}
var SvgAccessPointScan = function SvgAccessPointScan(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$502({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$488 || (_path$488 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M4.276 11.746c-.175-.176-.298-.421-.389-.686a5 5 0 0 1-.208-.912 9 9 0 0 1-.045-.348h1.22l.024.17q.065.435.156.696a1.2 1.2 0 0 0 .097.217l.024.013c.039.02.106.049.21.081.198.062.46.114.769.155.616.082 1.323.106 1.878.106s1.262-.024 1.879-.106c.309-.041.57-.093.768-.155a1.4 1.4 0 0 0 .234-.094l.015-.027q.03-.051.076-.183a4 4 0 0 0 .15-.694l.022-.179h1.22a10 10 0 0 1-.042.345 5 5 0 0 1-.2.913c-.088.264-.21.511-.386.688-.181.181-.45.303-.73.39a6 6 0 0 1-.968.198 16 16 0 0 1-2.038.116c-.58 0-1.346-.024-2.038-.116a6 6 0 0 1-.968-.199c-.28-.086-.549-.208-.73-.39M12.375 6.2a10 10 0 0 0-.041-.345 5 5 0 0 0-.2-.913c-.088-.264-.21-.511-.386-.688-.181-.181-.45-.302-.73-.39a6 6 0 0 0-.968-.198 16 16 0 0 0-2.038-.116c-.58 0-1.346.024-2.038.116-.345.046-.68.11-.968.199-.28.087-.549.208-.73.39-.175.175-.298.42-.389.685-.092.268-.16.58-.208.912q-.025.17-.045.348h1.22l.024-.17q.065-.435.156-.696a1.2 1.2 0 0 1 .097-.217l.024-.013a1.4 1.4 0 0 1 .21-.081c.198-.062.46-.114.769-.155a15 15 0 0 1 1.878-.106c.555 0 1.262.024 1.879.106.309.041.57.093.768.155a1.4 1.4 0 0 1 .234.094l.015.027c.02.035.046.093.076.183q.088.26.15.694l.022.179z"
	})), _path2$334 || (_path2$334 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "m9.975 6.2-.035-.02c-.474-.271-1.167-.571-1.94-.571s-1.466.3-1.94.57l-.035.021zM7.032 9.8h1.933c-.061.082-.13.156-.197.22-.103.097-.22.186-.344.252a.9.9 0 0 1-.424.12.93.93 0 0 1-.443-.13 1.782 1.782 0 0 1-.525-.462M3.974 2.927c-.578 0-1.047.469-1.047 1.047v.805a.564.564 0 1 1-1.127 0v-.805c0-1.2.973-2.174 2.174-2.174h.805a.564.564 0 1 1 0 1.127zM10.657 2.364c0-.312.252-.564.564-.564h.805c1.2 0 2.174.973 2.174 2.174v.805a.564.564 0 1 1-1.127 0v-.805c0-.578-.469-1.047-1.047-1.047h-.805a.564.564 0 0 1-.564-.563M2.364 10.657c.31 0 .563.252.563.564v.805c0 .578.469 1.047 1.047 1.047h.805a.564.564 0 0 1 0 1.127h-.805c-1.2 0-2.174-.973-2.174-2.174v-.805c0-.312.252-.564.564-.564M13.636 10.657c.312 0 .564.252.564.564v.805c0 1.2-.973 2.174-2.174 2.174h-.805a.564.564 0 1 1 0-1.127h.805c.578 0 1.047-.469 1.047-1.047v-.805c0-.312.252-.564.563-.564M1.6 7.4a.6.6 0 0 0 0 1.2h12.8a.6.6 0 1 0 0-1.2z"
	})));
};

//#endregion
//#region src/Icon/icons/AirPlay.svg
var _path$487;
var _path2$333;
function _extends$501() {
	return _extends$501 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$501.apply(null, arguments);
}
var SvgAirPlay = function SvgAirPlay(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$501({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$487 || (_path$487 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "m7.736 9.638-3.805 4.44c-.106.21 0 .422.211.422h7.821c.212 0 .318-.317.212-.423l-3.91-4.439c-.106-.105-.106-.105-.212-.105s-.212.105-.317.105"
	})), _path2$333 || (_path2$333 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M5.094 8.053c0 .845.422 1.585.95 2.22l.106.105h.106s0-.106.106-.106c.105-.105.211-.317.317-.317V9.85c-.529-.423-.846-1.057-.846-1.691 0-1.269.952-2.326 2.114-2.326 1.268 0 2.22 1.057 2.22 2.22 0 .74-.317 1.374-.846 1.69v.107c.106.105.212.317.317.317l.106.105h.106l.105-.105q.951-.793.951-2.22a2.84 2.84 0 0 0-2.853-2.854c-1.586 0-2.96 1.374-2.96 2.96m-1.797 0c0 1.48.634 2.748 1.69 3.593h.106a1.5 1.5 0 0 1 .318-.422l.105-.106v-.106c-.845-.74-1.48-1.797-1.48-3.065a4.014 4.014 0 0 1 4.017-4.016 4.014 4.014 0 0 1 4.016 4.016c0 1.268-.528 2.325-1.48 3.065v.212c.106.105.212.211.317.422h.106c1.057-.845 1.691-2.113 1.691-3.593 0-2.642-2.114-4.65-4.65-4.65S3.297 5.41 3.297 8.052m-1.797 0c0 2.008.951 3.805 2.325 4.967h.106c.106-.211.211-.317.317-.422v-.106C2.98 11.435 2.134 9.85 2.134 8.052c0-3.17 2.642-5.812 5.813-5.812s5.813 2.642 5.813 5.813c0 1.797-.845 3.382-2.114 4.439v.106c.106.105.212.21.423.422h.106c1.374-1.162 2.325-2.959 2.325-4.967 0-3.594-2.96-6.553-6.553-6.553S1.5 4.46 1.5 8.053"
	})));
};

//#endregion
//#region src/Icon/icons/Airtable.svg
var _path$486;
var _path2$332;
function _extends$500() {
	return _extends$500 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$500.apply(null, arguments);
}
var SvgAirtable$1 = function SvgAirtable(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$500({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$486 || (_path$486 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "m7.032 9.041-2.046.988-3.92 1.878c-.249.12-.566-.06-.566-.337V6.35c0-.1.051-.187.12-.251a.4.4 0 0 1 .095-.072.4.4 0 0 1 .34-.026l5.946 2.356c.302.12.325.543.03.685",
		opacity: .5
	})), _path2$332 || (_path2$332 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M7.198 2.302 1.606 4.617a.375.375 0 0 0 .005.694l5.616 2.227a2.08 2.08 0 0 0 1.536 0l5.616-2.227a.375.375 0 0 0 .005-.694L8.792 2.302a2.08 2.08 0 0 0-1.594 0M8.493 8.754v5.563c0 .265.267.446.513.349l6.257-2.43a.375.375 0 0 0 .237-.348V6.326a.375.375 0 0 0-.513-.348L8.73 8.406a.375.375 0 0 0-.237.348"
	})));
};

//#endregion
//#region src/Icon/icons/Allowlist.svg
var _g$104;
var _path$485;
var _path2$331;
function _extends$499() {
	return _extends$499 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$499.apply(null, arguments);
}
var SvgAllowlist = function SvgAllowlist(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$499({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$104 || (_g$104 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .5
	}, /*#__PURE__*/ React.createElement("path", { d: "M8.85 9.988a.6.6 0 0 1 .6-.6h3.856a.6.6 0 1 1 0 1.2H9.45a.6.6 0 0 1-.6-.6M9.45 11.788a.6.6 0 1 0 0 1.2h5.2a.6.6 0 1 0 0-1.2z" }), /*#__PURE__*/ React.createElement("path", {
		fillRule: "evenodd",
		d: "m7.784 9.774-3.869 3.87a.74.74 0 0 1-.532.215.74.74 0 0 1-.532-.216L.966 11.758a.737.737 0 0 1 1.043-1.042l1.374 1.374 3.359-3.358a.737.737 0 1 1 1.042 1.042",
		clipRule: "evenodd"
	}))), _path$485 || (_path$485 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M9.45 2.638a.6.6 0 0 0 0 1.2h5.2a.6.6 0 1 0 0-1.2zM8.85 5.638a.6.6 0 0 1 .6-.6h3.294a.6.6 0 1 1 0 1.2H9.45a.6.6 0 0 1-.6-.6"
	})), _path2$331 || (_path2$331 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M7.784 3.071 3.915 6.94a.74.74 0 0 1-.532.215.74.74 0 0 1-.532-.215L.966 5.055a.737.737 0 1 1 1.043-1.043l1.374 1.375 3.359-3.359a.737.737 0 1 1 1.042 1.043",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Alpha.svg
var _path$484;
function _extends$498() {
	return _extends$498 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$498.apply(null, arguments);
}
var SvgAlpha = function SvgAlpha(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$498({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$484 || (_path$484 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "m10.486 3.94-.05-.079c-.364-.572-.802-.992-1.348-1.27-.547-.279-1.215-.421-2.048-.421-1.522 0-2.7.533-3.503 1.518-.806.99-1.248 2.458-1.248 4.355 0 1.854.437 3.3 1.22 4.28.779.976 1.915 1.507 3.358 1.507.802 0 1.465-.132 2.027-.406.56-.274 1.03-.695 1.437-1.29l.05-.074h.38l.028.136c.115.553.308.956.6 1.222.29.264.698.412 1.284.412.327 0 .68-.078.923-.167.065-.023.115-.094.115-.193v-.697q.002-.065-.066-.119a.25.25 0 0 0-.17-.048 3 3 0 0 1-.241.01c-.287 0-.561-.095-.76-.334q-.293-.349-.295-1.045V6.748c0-1.283.168-3.09.434-4.18.023-.097-.05-.182-.133-.182h-.855a.24.24 0 0 0-.207.107 4.9 4.9 0 0 0-.545 1.32l-.034.127zm-.663 7.596c-.578.742-1.458 1.059-2.632 1.059-1.122 0-1.957-.38-2.503-1.16-.537-.769-.775-1.901-.775-3.37 0-1.504.26-2.662.804-3.448.552-.797 1.38-1.19 2.452-1.19 1.185 0 2.072.317 2.653 1.09.571.761.82 1.93.82 3.57v.086c0 1.522-.25 2.632-.819 3.363",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Anchor.svg
var _path$483;
function _extends$497() {
	return _extends$497 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$497.apply(null, arguments);
}
var SvgAnchor = function SvgAnchor(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$497({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$483 || (_path$483 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M2.19 8.829a.75.75 0 0 1 .566-.038l.013.004 2.24.564c.158.049.272.15.33.277a.53.53 0 0 1-.005.437.79.79 0 0 1-.913.425h-.003l-.893-.198.273.537a4.74 4.74 0 0 0 3.602 2.56V8.752h-1a.6.6 0 0 1 0-1.2h1v-.916a2.701 2.701 0 1 1 1.2 0v.916h1a.6.6 0 0 1 0 1.2h-1v4.645a4.75 4.75 0 0 0 3.602-2.56l.273-.537-.88.194-.016.005a.79.79 0 0 1-.913-.426.53.53 0 0 1-.006-.437.52.52 0 0 1 .331-.277l2.24-.564.013-.004a.75.75 0 0 1 .565.038.75.75 0 0 1 .393.408l.005.013 1.011 2.074.002.004a.53.53 0 0 1 .002.436.53.53 0 0 1-.338.276.79.79 0 0 1-.913-.426l-.001-.004-.358-.772-.452.841-.002.003a6 6 0 0 1-5.157 3.016h-.002a6 6 0 0 1-5.157-3.016l-.002-.003-.452-.84-.356.768-.003.007a.79.79 0 0 1-.913.426.53.53 0 0 1-.338-.276.53.53 0 0 1 .002-.436l.002-.004L1.793 9.25l.005-.013a.75.75 0 0 1 .393-.408M8 5.502a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Antenna.svg
var _path$482;
function _extends$496() {
	return _extends$496 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$496.apply(null, arguments);
}
var SvgAntenna = function SvgAntenna(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$496({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$482 || (_path$482 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M11.268 2H4.732C3.18 2 2.356 3.83 3.384 4.993l3.118 3.525.014.015c.304.337.584.733.584 1.186V13.1a.9.9 0 1 0 1.8 0V9.719c0-.453.28-.85.584-1.186l.014-.015 3.118-3.525C13.644 3.83 12.82 2 11.268 2M4.732 3.2h6.536a.6.6 0 0 1 .45.998L8.599 7.723a.8.8 0 0 1-1.198 0L4.282 4.198a.6.6 0 0 1 .45-.998",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/API.svg
var _g$103;
var _path$481;
var _path2$330;
function _extends$495() {
	return _extends$495 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$495.apply(null, arguments);
}
var SvgApi = function SvgApi(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$495({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$103 || (_g$103 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "m5.18 11.083.043.035.044.032.003.003v-.002c.274.205.59.315.91.334a1.68 1.68 0 0 0 1.47.711 1.24 1.24 0 0 0-.65.452c-.513.69-1.308.724-1.884.39-.475-.277-.808-.81-.721-1.434l.643-.644zM11.397 10.584c-.019.201.01.411.095.614.336.793-.033 1.504-.608 1.84-.576.334-1.371.3-1.885-.39a1.24 1.24 0 0 0-1.026-.502 1.7 1.7 0 0 0 1.05-.805c.547.244 1.2.188 1.706-.19l.001.002.003-.003.045-.032.042-.035zM12.767 6.606c1.327.4 1.333 2.368.017 2.782l.223-.192v.001c.742-.62.743-1.762 0-2.384l-.008-.006-.032-.027zM11.605 4.395a1.6 1.6 0 0 1-.113.407 1.26 1.26 0 0 0-.094.618l-.439-.38z" }))), _path$481 || (_path$481 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M9.394 6.585a.498.498 0 0 1 .64-.76l.002.002 2.169 1.881.032.026a.354.354 0 0 1 0 .543l-2.201 1.897-.003.002a.497.497 0 0 1-.7-.064l-.027-.037-.004-.004a.497.497 0 0 1 .093-.657l1.619-1.409zM6.606 6.585a.498.498 0 0 0-.64-.76l-.002.002-2.169 1.881-.032.026a.354.354 0 0 0 0 .543l2.201 1.897.003.002a.497.497 0 0 0 .7-.064l.027-.037.004-.004a.497.497 0 0 0-.093-.657L4.986 8.005zM7.964 5.402a.486.486 0 1 1 .958.169l-.886 5.027a.486.486 0 1 1-.958-.169z"
	})), _path2$330 || (_path2$330 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M3.376 5.296v.001q0 .001-.003.008l-.005.007h-.002l-.005.001-.059.008-.013.002-.01.001c-3.039.45-3.039 4.903 0 5.352l.01.001.013.002.064.009h.002l.005.007.003.007v.002l-.002.005-.023.054-.005.013-.003.01c-1.135 2.88 2.689 5.107 4.594 2.676l.01-.014.007-.008.033-.044.004-.004v-.001L8 13.39l.008.001h.001l.002.002.002.003q.016.023.033.044l.006.008.011.014c1.905 2.43 5.73.203 4.594-2.677l-.003-.009-.005-.013-.023-.054-.002-.005v-.001q0-.001.003-.008l.005-.007h.004l.003-.001.019-.002.053-.008.01-.001c3.039-.45 3.039-4.903 0-5.352l-.01-.001-.013-.002-.059-.008h-.005l-.002-.001-.005-.007-.003-.008v-.001l.001-.003.001-.002.023-.054.005-.013.003-.01c1.135-2.88-2.689-5.107-4.594-2.676l-.01.014-.007.008-.033.044-.001.002-.003.002v.001L8 2.61h-.007l-.001-.001H7.99l-.004-.005-.03-.04-.006-.008-.007-.008-.007-.01c-1.905-2.43-5.73-.203-4.594 2.677l.003.01.005.012zm1.74-2.333c.576-.335 1.371-.302 1.885.389.5.671 1.498.671 1.998 0 .514-.69 1.31-.724 1.885-.389s.943 1.046.608 1.839a1.262 1.262 0 0 0 1 1.747c1.7.208 1.7 2.694 0 2.902-.826.1-1.327.973-1 1.747.335.793-.033 1.504-.608 1.839-.576.335-1.371.302-1.885-.389a1.243 1.243 0 0 0-1.998 0c-.514.69-1.31.724-1.885.389s-.943-1.046-.608-1.839a1.262 1.262 0 0 0-1-1.747c-1.7-.208-1.7-2.694 0-2.902a1.262 1.262 0 0 0 1-1.747c-.335-.793.033-1.504.608-1.839",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Application.svg
var _path$480;
var _path2$329;
function _extends$494() {
	return _extends$494 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$494.apply(null, arguments);
}
var SvgApplication = function SvgApplication(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$494({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$480 || (_path$480 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M1.357 2.262a1.576 1.576 0 0 0-1.341 1.78l1.128 8.026a1.576 1.576 0 0 0 1.78 1.34l6.089-.855-.914-2.747c-.49-1.477.913-2.88 2.39-2.39l4.297 1.43-.948-6.747a1.576 1.576 0 0 0-1.78-1.341z",
		opacity: .3
	})), _path2$329 || (_path2$329 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "m12.239 14.88.674-2.155a.54.54 0 0 1 .342-.35l2.379-.803a.539.539 0 0 0-.003-1.022l-5.568-1.852a.539.539 0 0 0-.682.681l1.832 5.51c.165.496.87.49 1.026-.01"
	})));
};

//#endregion
//#region src/Icon/icons/Archive.svg
var _g$102;
var _path$479;
var _path2$328;
function _extends$493() {
	return _extends$493 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$493.apply(null, arguments);
}
var SvgArchive = function SvgArchive(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$493({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$102 || (_g$102 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", {
		fillRule: "evenodd",
		d: "M3.4 12.2a.6.6 0 0 0 .6.6h8a.6.6 0 0 0 .6-.6v-6H3.4z",
		clipRule: "evenodd"
	}), /*#__PURE__*/ React.createElement("path", { d: "M6.4 7.8c0-.22.18-.4.4-.4h2.4c.22 0 .4.18.4.4v.8a.4.4 0 0 1-.4.4H6.8a.4.4 0 0 1-.4-.4z" }))), _path$479 || (_path$479 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M12 14a1.8 1.8 0 0 0 1.8-1.8V6.15A1.6 1.6 0 0 0 15 4.6v-1A1.6 1.6 0 0 0 13.4 2H2.6A1.6 1.6 0 0 0 1 3.6v1a1.6 1.6 0 0 0 1.2 1.55v6.05A1.8 1.8 0 0 0 4 14zm-8.6-1.8a.6.6 0 0 0 .6.6h8a.6.6 0 0 0 .6-.6v-6H3.4zm-.8-9a.4.4 0 0 0-.4.4v1c0 .22.18.4.4.4h10.8a.4.4 0 0 0 .4-.4v-1a.4.4 0 0 0-.4-.4z",
		clipRule: "evenodd"
	})), _path2$328 || (_path2$328 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M6.4 7.8c0-.22.18-.4.4-.4h2.4c.22 0 .4.18.4.4v.8a.4.4 0 0 1-.4.4H6.8a.4.4 0 0 1-.4-.4z"
	})));
};

//#endregion
//#region src/Icon/icons/Area.svg
var _path$478;
var _path2$327;
var _path3$165;
function _extends$492() {
	return _extends$492 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$492.apply(null, arguments);
}
var SvgArea = function SvgArea(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$492({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$478 || (_path$478 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M9.472 8a5.1 5.1 0 0 0 .822-2.294q.268-.03.545-.029c1.802 0 3.388.923 4.311 2.323a5.16 5.16 0 0 1-4.856 2.294A5.1 5.1 0 0 0 9.472 8M8 9.472A5.2 5.2 0 0 0 9.472 8 5.2 5.2 0 0 0 8 6.527a5.1 5.1 0 0 1 2.294-.821q.028-.27.028-.545A5.16 5.16 0 0 0 8 .851 5.161 5.161 0 0 1 15.15 8 5.161 5.161 0 0 1 8 15.15a5.16 5.16 0 0 0 2.294-4.857A5.1 5.1 0 0 1 8 9.472m-2.294.822A5.1 5.1 0 0 0 8 9.472 5.2 5.2 0 0 1 6.528 8 5.2 5.2 0 0 1 8 6.527a5.1 5.1 0 0 0-2.294-.821A5.156 5.156 0 0 1 8 .85 5.161 5.161 0 0 0 .85 8 5.161 5.161 0 0 0 8 15.15a5.16 5.16 0 0 1-2.294-4.857m0 0A5.157 5.157 0 0 1 .85 8a5.16 5.16 0 0 1 4.856-2.294A5.1 5.1 0 0 0 6.528 8a5.1 5.1 0 0 0-.822 2.294",
		clipRule: "evenodd",
		opacity: .1
	})), _path2$327 || (_path2$327 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8 .85a5.16 5.16 0 0 0-2.294 4.856A5.156 5.156 0 0 0 .85 8a5.16 5.16 0 0 0 4.856 2.294A5.157 5.157 0 0 0 8 15.149a5.16 5.16 0 0 0 2.294-4.855q.269.028.545.028A5.16 5.16 0 0 0 15.15 8a5.16 5.16 0 0 0-4.856-2.294q.028-.27.028-.545A5.16 5.16 0 0 0 8 .851M9.472 8a5.1 5.1 0 0 1 .822 2.294A5.1 5.1 0 0 1 8 9.472 5.2 5.2 0 0 0 9.472 8M8 6.527a5.1 5.1 0 0 1 2.294-.821A5.1 5.1 0 0 1 9.472 8 5.2 5.2 0 0 0 8 6.527M6.528 8a5.1 5.1 0 0 1-.822-2.294A5.1 5.1 0 0 1 8 6.527 5.2 5.2 0 0 0 6.528 8m0 0A5.2 5.2 0 0 0 8 9.472a5.1 5.1 0 0 1-2.294.822A5.1 5.1 0 0 1 6.528 8",
		clipRule: "evenodd",
		opacity: .25
	})), _path3$165 || (_path3$165 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M11 8c0 1.023-.07 2.178-.445 2.554S8.837 11 8.01 11c-.829 0-2.172-.07-2.547-.446S5 9.024 5 8s.087-2.178.462-2.554S7.18 5 8.01 5c.828 0 2.171.07 2.546.446S11 6.976 11 8",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/ArrowBottom.svg
var _path$477;
function _extends$491() {
	return _extends$491 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$491.apply(null, arguments);
}
var SvgArrowBottom = function SvgArrowBottom(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$491({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$477 || (_path$477 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M3.397 8.064a.996.996 0 0 1 0-1.42 1.025 1.025 0 0 1 1.437 0l2.15 2.128V2.2c0-.555.456-1 1.016-1s1.015.445 1.015 1v6.573l2.152-2.128a1.024 1.024 0 0 1 1.435 0 .996.996 0 0 1 0 1.42l-3.884 3.841a1.024 1.024 0 0 1-1.435 0zM1 14.2a.8.8 0 0 0 .8.8h12.4a.8.8 0 0 0 0-1.6H1.8a.8.8 0 0 0-.8.8"
	})));
};

//#endregion
//#region src/Icon/icons/ArrowDown.svg
var _path$476;
function _extends$490() {
	return _extends$490 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$490.apply(null, arguments);
}
var SvgArrowDown = function SvgArrowDown(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$490({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$476 || (_path$476 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M12.603 9.364a.996.996 0 0 0 0-1.42 1.025 1.025 0 0 0-1.437 0l-2.15 2.129V3.5c0-.555-.456-1-1.016-1s-1.015.445-1.016 1v6.573l-2.15-2.128a1.024 1.024 0 0 0-1.436 0 .996.996 0 0 0 0 1.42l3.884 3.841a1.024 1.024 0 0 0 1.435 0z"
	})));
};

//#endregion
//#region src/Icon/icons/ArrowDownLeft.svg
var _path$475;
function _extends$489() {
	return _extends$489 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$489.apply(null, arguments);
}
var SvgArrowDownLeft = function SvgArrowDownLeft(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$489({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$475 || (_path$475 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M10.319 12.19a.996.996 0 0 0 1.004-1.004 1.025 1.025 0 0 0-1.016-1.015l-3.025-.016 4.647-4.648a1.007 1.007 0 0 0-.011-1.425 1.007 1.007 0 0 0-1.425-.011L5.845 8.719l-.016-3.027a1.023 1.023 0 0 0-1.015-1.015.996.996 0 0 0-1.004 1.004l.03 5.464a1.024 1.024 0 0 0 1.015 1.015z"
	})));
};

//#endregion
//#region src/Icon/icons/ArrowDownRight.svg
var _path$474;
function _extends$488() {
	return _extends$488 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$488.apply(null, arguments);
}
var SvgArrowDownRight = function SvgArrowDownRight(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$488({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$474 || (_path$474 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M5.71 12.19a.996.996 0 0 1-1.004-1.004 1.025 1.025 0 0 1 1.016-1.015l3.025-.016L4.1 5.507a1.007 1.007 0 0 1 .011-1.425 1.007 1.007 0 0 1 1.425-.011l4.648 4.648.016-3.027a1.023 1.023 0 0 1 1.015-1.015.996.996 0 0 1 1.004 1.004l-.03 5.464a1.024 1.024 0 0 1-1.015 1.015z"
	})));
};

//#endregion
//#region src/Icon/icons/ArrowEnd.svg
var _path$473;
function _extends$487() {
	return _extends$487 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$487.apply(null, arguments);
}
var SvgArrowEnd = function SvgArrowEnd(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$487({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$473 || (_path$473 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M8.064 3.397a.996.996 0 0 0-1.42 0 1.025 1.025 0 0 0 0 1.437l2.128 2.15H2.2c-.555 0-1 .456-1 1.016s.445 1.015 1 1.015h6.573l-2.128 2.152a1.024 1.024 0 0 0 0 1.435.996.996 0 0 0 1.42 0l3.841-3.884a1.024 1.024 0 0 0 0-1.435zM14.2 1a.8.8 0 0 1 .8.8v12.4a.8.8 0 0 1-1.6 0V1.8a.8.8 0 0 1 .8-.8"
	})));
};

//#endregion
//#region src/Icon/icons/ArrowLeft.svg
var _path$472;
function _extends$486() {
	return _extends$486 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$486.apply(null, arguments);
}
var SvgArrowLeft = function SvgArrowLeft(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$486({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$472 || (_path$472 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M6.636 3.397a.996.996 0 0 1 1.42 0c.391.397.391 1.04 0 1.437l-2.128 2.15H12.5c.555 0 1 .456 1 1.016s-.445 1.015-1 1.015H5.927l2.128 2.152c.392.396.392 1.039 0 1.435a.996.996 0 0 1-1.42 0L2.795 8.718a1.024 1.024 0 0 1 0-1.435z"
	})));
};

//#endregion
//#region src/Icon/icons/ArrowRight.svg
var _path$471;
function _extends$485() {
	return _extends$485 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$485.apply(null, arguments);
}
var SvgArrowRight = function SvgArrowRight(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$485({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$471 || (_path$471 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M9.364 3.397a.996.996 0 0 0-1.42 0 1.025 1.025 0 0 0 0 1.437l2.128 2.15H3.5c-.555 0-1 .456-1 1.016s.445 1.015 1 1.015h6.573l-2.129 2.152a1.024 1.024 0 0 0 0 1.435.996.996 0 0 0 1.42 0l3.842-3.884a1.024 1.024 0 0 0 0-1.435z"
	})));
};

//#endregion
//#region src/Icon/icons/ArrowsCorners.svg
var _path$470;
function _extends$484() {
	return _extends$484 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$484.apply(null, arguments);
}
var SvgArrowsCorners = function SvgArrowsCorners(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$484({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$470 || (_path$470 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M9.99 15a.996.996 0 0 1-1.004-1.004 1.025 1.025 0 0 1 1.016-1.016l1.525-.016L9.48 10.92a1.01 1.01 0 0 1 .01-1.43 1.013 1.013 0 0 1 1.43-.01l2.044 2.048.016-1.526a1.023 1.023 0 0 1 1.015-1.015A.996.996 0 0 1 15 9.99l-.03 3.963a1.024 1.024 0 0 1-1.016 1.015zM6.009 1a.996.996 0 0 1 1.004 1.004A1.025 1.025 0 0 1 5.997 3.02l-1.525.016L6.52 5.08a1.01 1.01 0 0 1-.01 1.43 1.013 1.013 0 0 1-1.43.01L3.035 4.471 3.019 6a1.02 1.02 0 0 1-1.015 1.01A1 1 0 0 1 1 6l.03-3.954A1.024 1.024 0 0 1 2.045 1.03zM6.009 15a.996.996 0 0 0 1.004-1.004 1.025 1.025 0 0 0-1.016-1.016l-1.525-.016 2.047-2.044a1.01 1.01 0 0 0-.01-1.43 1.013 1.013 0 0 0-1.43-.01l-2.044 2.048-.016-1.526a1.023 1.023 0 0 0-1.015-1.015A.996.996 0 0 0 1 9.99l.03 3.963a1.024 1.024 0 0 0 1.015 1.015zM9.99 1a.996.996 0 0 0-1.004 1.004 1.025 1.025 0 0 0 1.016 1.016l1.525.016L9.48 5.08a1.01 1.01 0 0 0 .01 1.43 1.013 1.013 0 0 0 1.43.01l2.045-2.049.016 1.527a1.023 1.023 0 0 0 1.015 1.015A.996.996 0 0 0 15 6.01l-.03-3.963a1.024 1.024 0 0 0-1.016-1.015z"
	})));
};

//#endregion
//#region src/Icon/icons/ArrowsDiagonal.svg
var _path$469;
function _extends$483() {
	return _extends$483 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$483.apply(null, arguments);
}
var SvgArrowsDiagonal = function SvgArrowsDiagonal(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$483({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$469 || (_path$469 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M8.49 15a.996.996 0 0 1-1.004-1.004 1.025 1.025 0 0 1 1.016-1.016l3.025-.016L8.48 9.92a1.01 1.01 0 0 1 .01-1.43 1.013 1.013 0 0 1 1.43-.01l3.044 3.048.016-3.026a1.023 1.023 0 0 1 1.015-1.015A.996.996 0 0 1 15 8.49l-.03 5.463a1.024 1.024 0 0 1-1.016 1.015zM7.509 1a.996.996 0 0 1 1.004 1.004A1.025 1.025 0 0 1 7.497 3.02l-3.025.016L7.52 6.08a1.01 1.01 0 0 1-.01 1.43 1.013 1.013 0 0 1-1.43.01L3.035 4.471l-.016 3.027a1.024 1.024 0 0 1-1.015 1.015A.996.996 0 0 1 1 7.51l.03-5.463A1.024 1.024 0 0 1 2.045 1.03z"
	})));
};

//#endregion
//#region src/Icon/icons/ArrowsDiagonalReverse.svg
var _path$468;
function _extends$482() {
	return _extends$482 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$482.apply(null, arguments);
}
var SvgArrowsDiagonalReverse = function SvgArrowsDiagonalReverse(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$482({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$468 || (_path$468 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8.468 7.532c-.27-.268-.297-.676-.063-.91l3.784-3.784-2.167-.148a.76.76 0 0 1-.688-.688.547.547 0 0 1 .6-.6l3.688.252a.74.74 0 0 1 .503.221.74.74 0 0 1 .22.503l.253 3.688a.547.547 0 0 1-.6.6.76.76 0 0 1-.688-.688l-.148-2.166-3.783 3.783c-.235.234-.643.206-.911-.063m-.94.94c.27.268.297.676.063.91l-3.783 3.784 2.166.148a.76.76 0 0 1 .689.688.547.547 0 0 1-.6.6l-3.688-.252a.73.73 0 0 1-.503-.222.73.73 0 0 1-.222-.503l-.252-3.688a.547.547 0 0 1 .6-.6.76.76 0 0 1 .688.689l.149 2.166L6.618 8.41c.234-.234.642-.206.91.062",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/ArrowsLeftRight.svg
var _path$467;
function _extends$481() {
	return _extends$481 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$481.apply(null, arguments);
}
var SvgArrowsLeftRight = function SvgArrowsLeftRight(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$481({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$467 || (_path$467 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M5.136 1.897a.996.996 0 0 1 1.42 0c.391.397.391 1.04 0 1.437l-2.128 2.15H7c.555 0 1 .456 1 1.016s-.445 1.015-1 1.015H4.427l2.128 2.152a1.023 1.023 0 0 1 0 1.435.996.996 0 0 1-1.42 0L1.295 7.218a1.024 1.024 0 0 1 0-1.435zM10.865 4.897a.996.996 0 0 0-1.42 0 1.025 1.025 0 0 0 0 1.437l2.127 2.15H9c-.555 0-1 .456-1 1.016s.445 1.015 1 1.015h2.573l-2.128 2.152a1.024 1.024 0 0 0 0 1.435.996.996 0 0 0 1.42 0l3.841-3.884a1.024 1.024 0 0 0 0-1.435z"
	})));
};

//#endregion
//#region src/Icon/icons/ArrowsMove.svg
var _path$466;
function _extends$480() {
	return _extends$480 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$480.apply(null, arguments);
}
var SvgArrowsMove = function SvgArrowsMove(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$480({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$466 || (_path$466 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M7.362 10.167c0-.306.284-.554.635-.554s.636.248.636.554v3.94l1.511-1.317a.7.7 0 0 1 .899 0 .505.505 0 0 1 0 .783L8.47 15.816a.68.68 0 0 1-.473.184.68.68 0 0 1-.472-.184l-2.573-2.243a.505.505 0 0 1 0-.783.7.7 0 0 1 .898 0l1.512 1.317zM8.633 5.833c0 .306-.285.554-.636.554-.35 0-.635-.248-.635-.554v-3.94L5.85 3.21a.7.7 0 0 1-.898 0 .505.505 0 0 1 0-.783L7.524.184A.68.68 0 0 1 7.997 0c.188 0 .357.071.473.184l2.573 2.243a.505.505 0 0 1 0 .783.7.7 0 0 1-.899 0L8.633 1.893zM5.833 7.367c.306 0 .554.284.554.635s-.248.636-.554.636h-3.94l1.317 1.511a.7.7 0 0 1 0 .9.505.505 0 0 1-.783 0L.184 8.474A.68.68 0 0 1 0 8.002c0-.187.071-.356.184-.472l2.243-2.573a.505.505 0 0 1 .783 0 .7.7 0 0 1 0 .899L1.893 7.367zM10.167 8.638c-.306 0-.554-.285-.554-.636 0-.35.248-.635.554-.635h3.94L12.79 5.856a.7.7 0 0 1 0-.9.505.505 0 0 1 .783 0l2.243 2.574a.68.68 0 0 1 .184.472.68.68 0 0 1-.184.473l-2.243 2.573a.505.505 0 0 1-.783 0 .7.7 0 0 1 0-.899l1.317-1.511z"
	})));
};

//#endregion
//#region src/Icon/icons/ArrowsRotate.svg
var _path$465;
function _extends$479() {
	return _extends$479 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$479.apply(null, arguments);
}
var SvgArrowsRotate = function SvgArrowsRotate(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$479({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$465 || (_path$465 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M3.393 5.728 5.18 7.183a.73.73 0 0 1 .253.544.73.73 0 0 1-.258.542.99.99 0 0 1-1.271 0l-.003-.001-.38-.291.006.18c.082 2.433 2.062 4.381 4.494 4.381h.003c.947 0 1.826-.295 2.55-.8.379-.263.882-.285 1.21.005.363.319.376.865.019 1.147a6.08 6.08 0 0 1-3.779 1.312c-3.21 0-5.847-2.488-6.119-5.66v-.007l-.032-.556-.342.288-.003.002a.99.99 0 0 1-1.271 0A.73.73 0 0 1 0 7.727a.72.72 0 0 1 .253-.543l.007-.007 1.79-1.45.002-.002c.163-.16.401-.262.669-.262s.506.103.669.262zm8.752 1.953.38.376-.007-.213c-.081-2.434-2.061-4.382-4.493-4.382h-.003c-.947 0-1.826.295-2.551.8-.378.264-.88.285-1.21-.005-.362-.319-.375-.865-.018-1.147a6.08 6.08 0 0 1 3.779-1.312c3.21 0 5.847 2.488 6.119 5.66v.657l.317-.331.014-.012a.99.99 0 0 1 1.27.001c.165.146.257.34.258.542a.72.72 0 0 1-.252.544l-.008.007-1.743 1.406-.003.003a.95.95 0 0 1-.668.262.95.95 0 0 1-.669-.262l-.002-.002-1.787-1.507a.73.73 0 0 1-.255-.545c0-.203.092-.397.258-.543a.99.99 0 0 1 1.264-.007z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/ArrowStart.svg
var _path$464;
function _extends$478() {
	return _extends$478 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$478.apply(null, arguments);
}
var SvgArrowStart = function SvgArrowStart(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$478({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$464 || (_path$464 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M7.936 3.397a.996.996 0 0 1 1.42 0c.391.397.391 1.04 0 1.437l-2.128 2.15H13.8c.555 0 1 .456 1 1.016s-.445 1.015-1 1.015H7.227l2.128 2.152c.392.396.392 1.039 0 1.435a.996.996 0 0 1-1.42 0L4.095 8.718a1.024 1.024 0 0 1 0-1.435zM1.8 1a.8.8 0 0 0-.8.8v12.4a.8.8 0 0 0 1.6 0V1.8a.8.8 0 0 0-.8-.8"
	})));
};

//#endregion
//#region src/Icon/icons/ArrowsUpDown.svg
var _path$463;
function _extends$477() {
	return _extends$477 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$477.apply(null, arguments);
}
var SvgArrowsUpDown = function SvgArrowsUpDown(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$477({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$463 || (_path$463 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M14.103 10.865a.996.996 0 0 0 0-1.42 1.025 1.025 0 0 0-1.437 0l-2.15 2.127V9c0-.555-.456-1-1.016-1s-1.015.445-1.015 1v2.573L6.333 9.445a1.023 1.023 0 0 0-1.435 0 .996.996 0 0 0 0 1.42l3.884 3.841a1.024 1.024 0 0 0 1.435 0zM11.103 5.136a.996.996 0 0 1 0 1.42 1.025 1.025 0 0 1-1.437 0l-2.15-2.128V7c0 .555-.456 1-1.016 1s-1.015-.445-1.015-1V4.427L3.333 6.555a1.024 1.024 0 0 1-1.435 0 .996.996 0 0 1 0-1.42l3.884-3.841a1.024 1.024 0 0 1 1.435 0z"
	})));
};

//#endregion
//#region src/Icon/icons/ArrowTop.svg
var _path$462;
function _extends$476() {
	return _extends$476 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$476.apply(null, arguments);
}
var SvgArrowTop = function SvgArrowTop(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$476({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$462 || (_path$462 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M3.397 7.936a.996.996 0 0 0 0 1.42c.397.391 1.04.391 1.437 0l2.15-2.128V13.8c0 .555.456 1 1.016 1s1.015-.445 1.015-1V7.227l2.152 2.128c.396.392 1.039.392 1.435 0a.996.996 0 0 0 0-1.42L8.718 4.095a1.024 1.024 0 0 0-1.435 0zM1 1.8a.8.8 0 0 1 .8-.8h12.4a.8.8 0 0 1 0 1.6H1.8a.8.8 0 0 1-.8-.8"
	})));
};

//#endregion
//#region src/Icon/icons/ArrowUp.svg
var _path$461;
function _extends$475() {
	return _extends$475 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$475.apply(null, arguments);
}
var SvgArrowUp = function SvgArrowUp(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$475({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$461 || (_path$461 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M3.397 6.636a.996.996 0 0 0 0 1.42c.397.391 1.04.391 1.437 0l2.15-2.128V12.5c0 .555.456 1 1.016 1s1.015-.445 1.015-1V5.927l2.152 2.128a1.024 1.024 0 0 0 1.435 0 .996.996 0 0 0 0-1.42L8.718 2.795a1.024 1.024 0 0 0-1.435 0z"
	})));
};

//#endregion
//#region src/Icon/icons/ArrowUpLeft.svg
var _path$460;
function _extends$474() {
	return _extends$474 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$474.apply(null, arguments);
}
var SvgArrowUpLeft = function SvgArrowUpLeft(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$474({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$460 || (_path$460 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M10.319 3.78a.996.996 0 0 1 1.004 1.005A1.025 1.025 0 0 1 10.307 5.8l-3.025.016 4.647 4.648c.393.392.385 1.03-.011 1.425a1.007 1.007 0 0 1-1.425.011L5.845 7.252l-.016 3.026a1.023 1.023 0 0 1-1.015 1.016.996.996 0 0 1-1.004-1.004l.03-5.464a1.024 1.024 0 0 1 1.015-1.015z"
	})));
};

//#endregion
//#region src/Icon/icons/ArrowUpRight.svg
var _path$459;
function _extends$473() {
	return _extends$473 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$473.apply(null, arguments);
}
var SvgArrowUpRight = function SvgArrowUpRight(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$473({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$459 || (_path$459 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M5.71 3.78a.996.996 0 0 0-1.004 1.005A1.025 1.025 0 0 0 5.722 5.8l3.025.016L4.1 10.464a1.007 1.007 0 0 0 .011 1.425 1.007 1.007 0 0 0 1.425.011l4.648-4.648.016 3.026a1.023 1.023 0 0 0 1.015 1.016.996.996 0 0 0 1.004-1.004l-.03-5.464a1.024 1.024 0 0 0-1.015-1.015z"
	})));
};

//#endregion
//#region src/Icon/icons/Attach.svg
var _path$458;
function _extends$472() {
	return _extends$472 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$472.apply(null, arguments);
}
var SvgAttach = function SvgAttach(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$472({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$458 || (_path$458 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8.667 1.916a3.4 3.4 0 0 1 2.603-.904l.278.022a3.049 3.049 0 0 1 1.864 5.235l-5.596 5.388a2 2 0 0 1-.335.263l-.064.04A2.058 2.058 0 0 1 4.94 8.693l4.627-4.16a.683.683 0 0 1 .914 1.017l-4.627 4.16a.691.691 0 0 0 .831 1.097l.064-.04a1 1 0 0 0 .118-.093l5.597-5.389a1.682 1.682 0 0 0-1.029-2.887l-.277-.023a2.04 2.04 0 0 0-1.558.541l-5.567 5.2a3.188 3.188 0 0 0 2.177 5.518h.147a3.4 3.4 0 0 0 2.355-.947l3.661-3.515a.684.684 0 0 1 .947.986l-3.661 3.515A4.77 4.77 0 0 1 6.357 15H6.21A4.555 4.555 0 0 1 3.1 7.116z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Attention.svg
var _path$457;
var _path2$326;
var _path3$164;
function _extends$471() {
	return _extends$471 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$471.apply(null, arguments);
}
var SvgAttention = function SvgAttention(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$471({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$457 || (_path$457 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M12.1 3.897A5.8 5.8 0 1 1 3.898 12.1l2.507-2.505a2 2 0 0 0 .084.128 2.03 2.03 0 0 0-.605 1.296l-.01.205.01.206c.043.478.24.944.617 1.301.425.403.973.57 1.5.57s1.075-.167 1.5-.57c.431-.408.627-.959.627-1.507a2.06 2.06 0 0 0-.618-1.504c.21-.294.338-.65.347-1.037l.062-2.602z",
		opacity: .25
	})), _path2$326 || (_path2$326 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M7.997 9.298a.66.66 0 0 1-.66-.645l-.095-3.98a.755.755 0 1 1 1.51 0l-.095 3.98a.66.66 0 0 1-.66.645M8 12.1c-.564 0-.927-.346-.927-.876 0-.536.363-.882.927-.882s.927.346.927.882c0 .53-.363.876-.927.876"
	})), _path3$164 || (_path3$164 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14M8 2.2a5.8 5.8 0 1 1 0 11.6A5.8 5.8 0 0 1 8 2.2",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Attributes.svg
var _path$456;
function _extends$470() {
	return _extends$470 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$470.apply(null, arguments);
}
var SvgAttributes = function SvgAttributes(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$470({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$456 || (_path$456 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M2.8 1h2.8a1.8 1.8 0 0 1 1.8 1.8v2.8a1.8 1.8 0 0 1-1.8 1.8H2.8A1.8 1.8 0 0 1 1 5.6V2.8A1.8 1.8 0 0 1 2.8 1m0 1.2a.6.6 0 0 0-.6.6v2.8a.6.6 0 0 0 .6.6h2.8a.6.6 0 0 0 .6-.6V2.8a.6.6 0 0 0-.6-.6zM15 4.2a3.2 3.2 0 1 1-6.4 0 3.2 3.2 0 0 1 6.4 0m-3.2 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4M9.582 13.497a.2.2 0 0 0 .171.303h4.094a.2.2 0 0 0 .171-.303l-2.046-3.411a.2.2 0 0 0-.343 0zM13 9.468l2.046 3.412a1.4 1.4 0 0 1-1.2 2.12H9.753a1.4 1.4 0 0 1-1.2-2.12L10.6 9.468a1.4 1.4 0 0 1 2.4 0M2.714 10.016l.25-.767c.389-1.198 2.083-1.198 2.472 0l.25.767h.806c1.26 0 1.783 1.612.764 2.352l-.652.474.25.767c.388 1.198-.983 2.194-2.001 1.454l-.653-.475-.653.475c-1.018.74-2.39-.256-2-1.454l.25-.767-.653-.474c-1.02-.74-.496-2.352.764-2.352zm-.806 1.2a.1.1 0 0 0-.059.181l1.3.944a.1.1 0 0 1 .035.112l-.496 1.527a.1.1 0 0 0 .154.112l1.3-.944a.1.1 0 0 1 .083-.016.1.1 0 0 1 .034.016l1.299.944a.1.1 0 0 0 .154-.112l-.496-1.527a.1.1 0 0 1 .036-.112l1.299-.944a.1.1 0 0 0-.059-.18H4.886a.1.1 0 0 1-.095-.07L4.295 9.62a.1.1 0 0 0-.19 0l-.496 1.527a.1.1 0 0 1-.095.07z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Automated.svg
var _path$455;
var _path2$325;
function _extends$469() {
	return _extends$469 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$469.apply(null, arguments);
}
var SvgAutomated = function SvgAutomated(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$469({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$455 || (_path$455 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M11.095 7.709a.335.335 0 0 1 0 .582L6.41 10.956a.335.335 0 0 1-.501-.292V5.336c0-.257.277-.419.501-.292z"
	})), _path2$325 || (_path2$325 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "m3.14 5.82.009.009.01.008c.039.032.061.08.061.13v2.1999999999999997c.087 2.594 2.199 4.675 4.796 4.675h.004c1.01 0 1.95-.316 2.723-.855.328-.228.736-.229.986-.009.288.254.28.662.027.86a6 6 0 0 1-3.736 1.298c-3.174 0-5.784-2.46-6.053-5.6l-.049-.859v-.13l-.692.525a.81.81 0 0 1-1.031 0 .518.518 0 0 1-.007-.804l1.857-1.437.012-.011a.77.77 0 0 1 .541-.21c.222 0 .414.085.541.21M12.897 10.18l-.01-.009-.01-.008a.17.17 0 0 1-.061-.13v-2.1999999999999997c-.087-2.594-2.199-4.675-4.796-4.675h-.004c-1.01 0-1.95.316-2.723.855-.328.228-.736.229-.986.009-.288-.254-.28-.662-.027-.86a6 6 0 0 1 3.736-1.298c3.174 0 5.784 2.46 6.052 5.6l.052.898v.174l.654-.608a.81.81 0 0 1 1.032 0c.257.227.259.576.005.805l-1.82 1.436-.012.011a.77.77 0 0 1-.541.21.77.77 0 0 1-.541-.21"
	})));
};

//#endregion
//#region src/Icon/icons/AutoVPN.svg
var _path$454;
var _path2$324;
var _path3$163;
function _extends$468() {
	return _extends$468 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$468.apply(null, arguments);
}
var SvgAutoVpn$1 = function SvgAutoVpn(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$468({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$454 || (_path$454 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M3.22 3.762a4.03 4.03 0 0 1 3.163-.376l2.196.588a5.24 5.24 0 0 0-2.088 7.804l-2.33-.624A4.04 4.04 0 0 1 3.043 3.87z",
		clipRule: "evenodd",
		opacity: .25
	})), _path2$324 || (_path2$324 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M2.62 2.723a5.23 5.23 0 0 1 4.073-.496l5.337 1.429a5.24 5.24 0 0 1-2.412 10.197l-.151-.033s-5.837-1.462-6.738-1.961c-.9-.5-1.527-1.114-2.026-1.979A5.24 5.24 0 0 1 2.62 2.723m.6 1.039a4.03 4.03 0 0 1 3.163-.376l2.196.588a5.24 5.24 0 0 0-2.088 7.804l-2.33-.624A4.04 4.04 0 0 1 3.043 3.87zm4.206 7.26A4.04 4.04 0 0 1 10.719 4.7l.003-.001a4 4 0 0 1 .902.094c.959.21 1.84.768 2.437 1.618l.009.013q.1.142.188.295a4.04 4.04 0 0 1-6.832 4.302",
		clipRule: "evenodd"
	})), _path3$163 || (_path3$163 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M9.889 7.23a1.742 1.742 0 1 1 1.742 3.019A1.742 1.742 0 0 1 9.889 7.23m.6 1.04a.542.542 0 1 1 .541.938.542.542 0 0 1-.542-.938M11.624 4.793a4.05 4.05 0 0 0 2.446 1.63l-.009-.012a4.03 4.03 0 0 0-2.437-1.618",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Backspace.svg
var _path$453;
var _path2$323;
function _extends$467() {
	return _extends$467 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$467.apply(null, arguments);
}
var SvgBackspace = function SvgBackspace(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$467({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$453 || (_path$453 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "m3.784 12.352-2.55-2.91A2.2 2.2 0 0 1 1.23 6.55L3.78 3.614a2.2 2.2 0 0 1 1.66-.756h7.96a2.2 2.2 0 0 1 2.2 2.2v5.844a2.2 2.2 0 0 1-2.2 2.2H5.438a2.2 2.2 0 0 1-1.654-.75m-1.65-5.016 2.552-2.934a1 1 0 0 1 .755-.344H13.4a1 1 0 0 1 1 1v5.844a1 1 0 0 1-1 1H5.438a1 1 0 0 1-.752-.341l-2.55-2.91a1 1 0 0 1-.002-1.315",
		clipRule: "evenodd"
	})), _path2$323 || (_path2$323 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M7.257 6.68a.604.604 0 0 1 .854-.854L9.38 7.094l1.269-1.268a.604.604 0 1 1 .854.854l-1.269 1.269 1.269 1.268a.604.604 0 1 1-.854.855l-1.27-1.27-1.268 1.27a.604.604 0 1 1-.854-.855L8.526 7.95z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Bell.svg
var _path$452;
var _path2$322;
function _extends$466() {
	return _extends$466 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$466.apply(null, arguments);
}
var SvgBell = function SvgBell(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$466({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$452 || (_path$452 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M10.904 12.957c-.982.082-2.107.137-2.904.137-1.594 0-4.531-.219-4.954-.435l-.12-.062c-.307-.155-.33-.166-.33-.388 0-.123.051-.241.14-.326l.54-.513.008-.008c.247-.237.43-.527.542-.843h.2c1.035-.002 2.604-.006 4.724-.832 1.555-.605 2.658-1.61 3.3-2.33q.002.08.002.161v2.286c0 .588.24 1.15.664 1.558l.008.008.54.513a.45.45 0 0 1 .14.326v.022a.4.4 0 0 1-.022.17c-.035.07-.125.113-.362.226l-.066.031c-.227.109-1.067.218-2.05.3",
		opacity: .25
	})), _path2$322 || (_path2$322 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M9.598 2.37a1.6 1.6 0 0 0-3.196 0c-2.372.685-3.654 2.81-3.654 5.148v2.286a.96.96 0 0 1-.295.693l-.004.003-.002.002-.538.512a1.65 1.65 0 0 0-.512 1.195v.008c0 .06 0 .237.046.426.068.271.21.506.412.69.15.137.312.222.378.258h.002c.044.024.11.058.172.089l.092.046c.206.106.436.159.563.186.163.035.35.066.544.094.392.055.873.105 1.379.147.276.023.564.044.854.062a2.2 2.2 0 0 0 4.322 0c.286-.018.57-.04.843-.062.504-.042.984-.092 1.376-.147.195-.027.382-.058.545-.093.134-.028.35-.078.546-.172l.054-.025c.082-.04.172-.082.243-.12a1.7 1.7 0 0 0 .418-.291c.223-.217.344-.478.391-.736.03-.158.027-.323.026-.355v-.005a1.65 1.65 0 0 0-.512-1.195l-.538-.511-.006-.006v-.001a.96.96 0 0 1-.295-.692V7.518c0-2.333-1.29-4.462-3.654-5.149M6.801 3.502q.092-.025.186-.046s.615-.113 1.02-.113c.407 0 1.006.113 1.006.113q.095.021.186.047c1.703.467 2.72 1.909 2.841 3.66q.012.176.012.354v2.286a2.16 2.16 0 0 0 .664 1.558l.008.008.54.513a.45.45 0 0 1 .14.326v.006c0 .088 0 .142-.022.185-.033.067-.114.109-.32.207l-.042.02-.066.031c-.29.139-1.585.278-2.897.36A35 35 0 0 1 8 13.095c-.572 0-1.318-.028-2.057-.075-1.322-.082-2.626-.222-2.897-.36l-.12-.062c-.307-.155-.33-.166-.33-.388 0-.123.051-.241.14-.326l.54-.513.008-.008c.424-.408.664-.97.664-1.558V7.518c0-1.915 1.03-3.517 2.853-4.015",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/BellCrossed.svg
var _path$451;
var _path2$321;
function _extends$465() {
	return _extends$465 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$465.apply(null, arguments);
}
var SvgBellCrossed = function SvgBellCrossed(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$465({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$451 || (_path$451 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M5.95 13.02c.738.046 1.48.074 2.05.074.797 0 1.922-.055 2.904-.137.983-.082 1.823-.19 2.05-.299l.066-.031c.237-.113.327-.156.362-.227a.4.4 0 0 0 .021-.169v-.022a.45.45 0 0 0-.14-.326l-.539-.513-.008-.008a2.16 2.16 0 0 1-.664-1.558V7.518q0-.08-.002-.16a9 9 0 0 1-2.29 1.851z",
		opacity: .25
	})), _path2$321 || (_path2$321 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M8 .844a1.6 1.6 0 0 1 1.598 1.525q.408.12.771.292l-.92.92a4 4 0 0 0-.436-.124s-.599-.113-1.005-.113-1.021.113-1.021.113q-.095.021-.186.046c-1.823.498-2.853 2.1-2.853 4.015v1.565l-2.1 2.099a2.1 2.1 0 0 0-.355.472c.086-.24.227-.46.416-.64l.538-.511.002-.003.004-.003a.96.96 0 0 0 .295-.693V7.518c0-2.338 1.282-4.463 3.654-5.149A1.6 1.6 0 0 1 8 .844M4.83 14.14l.155.013c.276.023.564.044.854.062a2.2 2.2 0 0 0 4.322 0c.286-.018.57-.04.843-.062.504-.042.984-.092 1.376-.147.195-.027.382-.058.545-.093.134-.028.35-.078.546-.172l.054-.025c.082-.04.172-.082.243-.12a1.7 1.7 0 0 0 .418-.291c.223-.217.344-.478.391-.736.03-.158.027-.323.026-.355v-.005a1.65 1.65 0 0 0-.512-1.195l-.538-.511-.006-.006v-.001a.96.96 0 0 1-.295-.692V7.518c0-.547-.07-1.082-.21-1.59l-1.021 1.021a5 5 0 0 1 .031.57v2.285a2.16 2.16 0 0 0 .664 1.558l.008.008.54.513a.45.45 0 0 1 .14.326v.006c0 .088 0 .142-.022.185-.033.067-.114.109-.32.207l-.108.052c-.29.138-1.585.277-2.897.36-.738.046-1.483.075-2.057.075-.57 0-1.312-.028-2.05-.074zM2.697 13.303a.9.9 0 0 1 0-1.273l9.334-9.333a.9.9 0 1 1 1.272 1.273L3.97 13.303a.9.9 0 0 1-1.273 0"
	})));
};

//#endregion
//#region src/Icon/icons/BellFilled.svg
var _path$450;
var _path2$320;
function _extends$464() {
	return _extends$464 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$464.apply(null, arguments);
}
var SvgBellFilled = function SvgBellFilled(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$464({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$450 || (_path$450 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M6.801 3.503q.092-.025.186-.046s.615-.113 1.02-.113c.407 0 1.006.113 1.006.113q.095.021.186.047c1.703.467 2.72 1.909 2.841 3.66q.012.176.012.354v2.286a2.16 2.16 0 0 0 .664 1.558l.008.008.54.513a.45.45 0 0 1 .14.326v.006c0 .088 0 .142-.022.185-.033.067-.114.109-.32.207l-.042.02-.066.031c-.29.139-1.585.278-2.897.36-.738.047-1.483.076-2.057.076-.572 0-1.318-.028-2.057-.075-1.322-.082-2.626-.222-2.897-.36l-.12-.062c-.307-.155-.33-.166-.33-.388 0-.123.051-.241.14-.326l.54-.513.008-.008c.424-.408.664-.97.664-1.558V7.518c0-1.915 1.03-3.517 2.853-4.015",
		clipRule: "evenodd",
		opacity: .5
	})), _path2$320 || (_path2$320 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M9.598 2.37a1.6 1.6 0 0 0-3.196 0c-2.372.685-3.654 2.81-3.654 5.148v2.286a.96.96 0 0 1-.295.693l-.004.003-.002.002-.538.512a1.65 1.65 0 0 0-.512 1.195v.008c0 .06 0 .237.046.426.068.271.21.506.412.69.15.137.312.222.378.258h.002c.044.024.11.058.172.089l.092.046c.206.106.436.159.563.186.163.035.35.066.544.094.392.055.873.105 1.379.147.276.023.564.044.854.062a2.2 2.2 0 0 0 4.322 0c.286-.018.57-.04.843-.062.504-.042.984-.092 1.376-.147.195-.027.382-.058.545-.093.134-.028.35-.078.546-.172l.054-.025c.082-.04.172-.082.243-.12a1.7 1.7 0 0 0 .418-.291c.223-.217.344-.478.391-.736.03-.158.027-.323.026-.355v-.005a1.65 1.65 0 0 0-.512-1.195l-.538-.511-.006-.006v-.001a.96.96 0 0 1-.295-.692V7.518c0-2.333-1.29-4.462-3.654-5.149M6.801 3.502q.092-.025.186-.046s.615-.113 1.02-.113c.407 0 1.006.113 1.006.113q.095.021.186.047c1.703.467 2.72 1.909 2.841 3.66q.012.176.012.354v2.286a2.16 2.16 0 0 0 .664 1.558l.008.008.54.513a.45.45 0 0 1 .14.326v.006c0 .088 0 .142-.022.185-.033.067-.114.109-.32.207l-.042.02-.066.031c-.29.139-1.585.278-2.897.36A35 35 0 0 1 8 13.095c-.572 0-1.318-.028-2.057-.075-1.322-.082-2.626-.222-2.897-.36l-.12-.062c-.307-.155-.33-.166-.33-.388 0-.123.051-.241.14-.326l.54-.513.008-.008c.424-.408.664-.97.664-1.558V7.518c0-1.915 1.03-3.517 2.853-4.015",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/BestPath.svg
var _g$101;
var _g2$15;
var _path$449;
var _path2$319;
function _extends$463() {
	return _extends$463 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$463.apply(null, arguments);
}
var SvgBestPath = function SvgBestPath(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$463({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$101 || (_g$101 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M10.8 12.593H5.2v-.985h5.6zM2.4 7.448q.1.014.2.015h1V10h-1q-.1 0-.2.014zM13.6 10.014a2 2 0 0 0-.2-.014h-1V7.463h1q.101-.002.2-.015z" }))), _g2$15 || (_g2$15 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		fillRule: "evenodd",
		clipRule: "evenodd",
		opacity: .5
	}, /*#__PURE__*/ React.createElement("path", { d: "M13.4 10a1.6 1.6 0 0 1 1.6 1.6v1a1.6 1.6 0 0 1-1.6 1.6h-1a1.6 1.6 0 0 1-1.6-1.6v-1c0-.883.717-1.6 1.6-1.6zm-1.08 2.992a.4.4 0 0 1-.312-.311L12 12.6v-1a.4.4 0 0 1 .32-.393l.08-.008h1l.08.008a.4.4 0 0 1 .32.393v1l-.008.08a.4.4 0 0 1-.312.311L13.4 13h-1zM3.6 10a1.6 1.6 0 0 1 1.6 1.6v1a1.6 1.6 0 0 1-1.6 1.6h-1A1.6 1.6 0 0 1 1 12.6v-1c0-.883.717-1.6 1.6-1.6zm-1.08 2.992a.4.4 0 0 1-.312-.311L2.2 12.6v-1a.4.4 0 0 1 .32-.393l.08-.008h1l.08.008a.4.4 0 0 1 .32.393v1l-.008.08a.4.4 0 0 1-.311.311L3.6 13h-1z" }))), _path$449 || (_path$449 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M8 1.8a5.38 5.38 0 0 1 3.81 1.576 1.6 1.6 0 0 0-.868.828 4.18 4.18 0 0 0-2.726-1.198L8 3a4.18 4.18 0 0 0-2.942 1.206 1.6 1.6 0 0 0-.869-.83A5.38 5.38 0 0 1 8 1.8"
	})), _path2$319 || (_path2$319 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M3.6 3.263a1.6 1.6 0 0 1 1.6 1.6v1a1.6 1.6 0 0 1-1.6 1.6h-1a1.6 1.6 0 0 1-1.6-1.6v-1c0-.884.717-1.6 1.6-1.6zM2.52 6.255a.4.4 0 0 1-.312-.312l-.008-.08v-1a.4.4 0 0 1 .32-.392l.08-.008h1l.08.008a.4.4 0 0 1 .32.392v1l-.008.08a.4.4 0 0 1-.311.312l-.08.008h-1zM13.4 3.263a1.6 1.6 0 0 1 1.6 1.6v1a1.6 1.6 0 0 1-1.6 1.6h-1a1.6 1.6 0 0 1-1.6-1.6v-1c0-.884.717-1.6 1.6-1.6zm-1.08 2.992a.4.4 0 0 1-.312-.312L12 5.863v-1a.4.4 0 0 1 .32-.392l.08-.008h1l.08.008a.4.4 0 0 1 .32.392v1l-.008.08a.4.4 0 0 1-.312.312l-.08.008h-1z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Beta.svg
var _path$448;
function _extends$462() {
	return _extends$462 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$462.apply(null, arguments);
}
var SvgBeta = function SvgBeta(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$462({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$448 || (_path$448 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "m9.477 7.091.03-.013c.957-.41 1.54-1.289 1.54-2.312V4.75c0-.899-.331-1.635-.914-2.146C9.55 2.09 8.71 1.8 7.687 1.8c-1.13 0-2.01.352-2.608 1.014-.6.663-.922 1.643-.922 2.91v9.118c0 .267.216.483.483.483h.612a.483.483 0 0 0 .483-.483v-2.549h.205l.014.029c.4.837 1.285 1.378 2.483 1.378 1.009 0 1.86-.35 2.458-.95.598-.602.948-1.459.948-2.48v-.015c0-.783-.2-1.425-.59-1.918-.388-.493-.97-.842-1.738-1.033l-.038-.01zm.757 3.134c0 1.247-.886 2.16-2.06 2.16-.735 0-1.349-.258-1.778-.736s-.669-1.172-.669-2.035V5.709c0-.848.163-1.5.497-1.942.336-.444.84-.667 1.502-.667.551 0 1.01.175 1.33.492.32.316.498.768.498 1.313v.015c0 .568-.178 1.016-.52 1.321-.34.305-.837.461-1.463.461h-.094a.483.483 0 0 0-.482.483v.303c0 .267.216.483.482.483h.102c.853 0 1.517.189 1.97.566.453.38.685.942.685 1.672z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/BGP.svg
var _g$100;
var _path$447;
function _extends$461() {
	return _extends$461 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$461.apply(null, arguments);
}
var SvgBgp = function SvgBgp(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$461({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$100 || (_g$100 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .5
	}, /*#__PURE__*/ React.createElement("path", { d: "m6.21 9.07-.345.268V6.813l1.601-1.235zM10.526 3.25 9.284 6.703l-1.765 1.36L8.775 4.57l1.723-1.328zM11.772 2.414a1 1 0 0 1 1.066.58l-.481 1.339-1.765 1.36z" }))), _path$447 || (_path$447 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M14.1 15H1.9a.9.9 0 0 1-.9-.9c0-.497.378-.9.875-.9V2.8a1.8 1.8 0 0 1 1.8-1.8h.387a1.8 1.8 0 0 1 1.8 1.8v2.499l4.72-3.639.185-.129a2.2 2.2 0 0 1 2.501 3.614l-7.406 5.708V13.2H14.1a.9.9 0 1 1 0 1.8M3.075 2.8a.6.6 0 0 1 .6-.6h.387l.121.012a.6.6 0 0 1 .479.588v10.4H3.075zm8.24-.19a1 1 0 0 1 1.22 1.584L5.863 9.338V6.813z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/BillOfMaterials.svg
var _path$446;
var _path2$318;
var _path3$162;
function _extends$460() {
	return _extends$460 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$460.apply(null, arguments);
}
var SvgBillOfMaterials = function SvgBillOfMaterials(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$460({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$446 || (_path$446 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M8.695 12.851c0 .155.086.298.222.371l2.235 1.203V12.13a.42.42 0 0 0-.216-.368l-2.24-1.24z",
		opacity: .25
	})), _path2$318 || (_path2$318 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M7.344 1a.8.8 0 0 1 .565.234l4.704 4.704-.027-.013a1.98 1.98 0 0 0-1.784.056l-1.523.832H7.697c-.331 0-.6-.269-.6-.6v-2.96L7.096 2.6a.2.2 0 0 0-.2-.2h-2.39a.2.2 0 0 0-.2.2v10.8a.2.2 0 0 0 .2.2h1.81c.073.57.39 1.082.87 1.4h-2.68a1.6 1.6 0 0 1-1.6-1.6V2.6a1.6 1.6 0 0 1 1.6-1.6z"
	})), _path3$162 || (_path3$162 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M11.377 7.035a.78.78 0 0 1 .746 0l3.473 1.897c.249.137.404.398.404.682v3.738a.78.78 0 0 1-.41.685l-3.472 1.87a.78.78 0 0 1-.736 0l-3.473-1.87a.78.78 0 0 1-.409-.685V9.614c0-.284.155-.545.404-.682zM8.695 12.85c0 .155.086.298.222.371l2.235 1.203V12.13a.42.42 0 0 0-.216-.368l-2.24-1.24zm3.87-1.089a.42.42 0 0 0-.217.368v2.295l2.235-1.203a.42.42 0 0 0 .222-.37v-2.33zm-.613-3.459a.42.42 0 0 0-.404 0L9.337 9.51l2.209 1.224a.42.42 0 0 0 .408 0l2.208-1.224z"
	})));
};

//#endregion
//#region src/Icon/icons/Block.svg
var _path$445;
var _path2$317;
var _path3$161;
function _extends$459() {
	return _extends$459 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$459.apply(null, arguments);
}
var SvgBlock = function SvgBlock(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$459({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$445 || (_path$445 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M13.428 5.271c.24.245.374.576.372.92l-.032 3.718-.008.128a1.3 1.3 0 0 1-.38.785l-2.653 2.606c-.244.24-.575.375-.918.372l-3.718-.032a1.3 1.3 0 0 1-.913-.388l-1.269-1.29.58-.58.38.38c.679.68 1.78.68 2.458 0L8 11.219l.673.673a1.737 1.737 0 0 0 2.457 0l.76-.761a1.737 1.737 0 0 0 0-2.457L11.219 8l.673-.673a1.74 1.74 0 0 0 0-2.458l-.381-.38.58-.58z",
		opacity: .25
	})), _path2$317 || (_path2$317 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "m10.282 4.958.76.76c.21.21.21.55 0 .76L9.523 8l1.52 1.521c.21.21.21.55 0 .76l-.76.761c-.21.21-.55.21-.76 0L8 9.523l-1.521 1.52c-.21.21-.55.21-.76 0l-.761-.76a.54.54 0 0 1 0-.76L6.478 8l-1.52-1.521a.54.54 0 0 1 0-.76l.76-.761c.21-.21.55-.21.76 0L8 6.478l1.521-1.52c.21-.21.55-.21.76 0"
	})), _path3$161 || (_path3$161 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M9.92 1.033c.66.006 1.294.272 1.758.745l2.606 2.652c.405.413.654.952.706 1.524L15 6.2l-.032 3.719a2.5 2.5 0 0 1-.748 1.758l-2.652 2.606a2.5 2.5 0 0 1-1.77.716l-3.718-.032a2.5 2.5 0 0 1-1.577-.58l-.18-.168-2.607-2.652A2.5 2.5 0 0 1 1 9.798l.033-3.718c.006-.66.273-1.293.745-1.758L4.43 1.716l.185-.165A2.5 2.5 0 0 1 6.201 1zM6.19 2.2a1.3 1.3 0 0 0-.919.371L2.62 5.178c-.245.24-.384.57-.387.913L2.2 9.808l.005.128c.027.297.156.577.366.791l2.607 2.653c.24.245.57.384.913.387l3.717.033c.344.003.674-.132.92-.373l2.652-2.605c.214-.21.347-.489.38-.785l.007-.128.033-3.719a1.3 1.3 0 0 0-.373-.919L10.823 2.62a1.3 1.3 0 0 0-.785-.38l-.128-.007z"
	})));
};

//#endregion
//#region src/Icon/icons/Blocklist.svg
var _g$99;
var _path$444;
var _path2$316;
function _extends$458() {
	return _extends$458 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$458.apply(null, arguments);
}
var SvgBlocklist = function SvgBlocklist(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$458({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$99 || (_g$99 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .5
	}, /*#__PURE__*/ React.createElement("path", { d: "M8.85 9.988a.6.6 0 0 1 .6-.6h3.856a.6.6 0 1 1 0 1.2H9.45a.6.6 0 0 1-.6-.6M9.45 11.788a.6.6 0 1 0 0 1.2h5.2a.6.6 0 1 0 0-1.2z" }), /*#__PURE__*/ React.createElement("path", {
		fillRule: "evenodd",
		d: "M2.2 11.863a2.158 2.158 0 0 1 2.726-2.725c.22.073.26.343.113.49l-2.35 2.348c-.146.147-.416.108-.488-.113m3.575.85a2.16 2.16 0 0 1-2.2.524c-.222-.073-.26-.343-.114-.49l2.35-2.348c.146-.147.416-.108.488.113a2.16 2.16 0 0 1-.524 2.2M2.03 8.967a3.14 3.14 0 1 0 4.44 4.44 3.14 3.14 0 0 0-4.44-4.44",
		clipRule: "evenodd"
	}))), _path$444 || (_path$444 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M9.45 2.638a.6.6 0 0 0 0 1.2h5.2a.6.6 0 1 0 0-1.2zM8.85 5.638a.6.6 0 0 1 .6-.6h3.294a.6.6 0 1 1 0 1.2H9.45a.6.6 0 0 1-.6-.6"
	})), _path2$316 || (_path2$316 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M2.2 5.113a2.158 2.158 0 0 1 2.726-2.725c.22.073.26.343.113.49l-2.35 2.348c-.146.147-.416.108-.488-.113m3.575.85a2.16 2.16 0 0 1-2.2.524c-.222-.073-.26-.343-.114-.49l2.35-2.348c.146-.147.416-.108.488.113a2.16 2.16 0 0 1-.524 2.201M2.03 2.217a3.14 3.14 0 1 0 4.44 4.44 3.14 3.14 0 0 0-4.44-4.44",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Bookmark.svg
var _path$443;
function _extends$457() {
	return _extends$457 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$457.apply(null, arguments);
}
var SvgBookmark = function SvgBookmark(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$457({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$443 || (_path$443 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8.488 11.008a.8.8 0 0 0-.98 0L4.185 13.58a.3.3 0 0 1-.484-.237V3.154a.8.8 0 0 1 .8-.8h7a.8.8 0 0 1 .8.8v10.19a.3.3 0 0 1-.484.237zM4.5 1.154h7a2 2 0 0 1 2 2v10.19c0 1.245-1.431 1.948-2.417 1.186l-2.84-2.195a.4.4 0 0 0-.49 0L4.919 14.53c-.986.763-2.418.06-2.418-1.186V3.154a2 2 0 0 1 2-2",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/BookmarkFilled.svg
var _path$442;
var _path2$315;
function _extends$456() {
	return _extends$456 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$456.apply(null, arguments);
}
var SvgBookmarkFilled = function SvgBookmarkFilled(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$456({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$442 || (_path$442 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8.488 11.008a.8.8 0 0 0-.98 0L4.185 13.58a.3.3 0 0 1-.484-.237V3.154a.8.8 0 0 1 .8-.8h7a.8.8 0 0 1 .8.8v10.19a.3.3 0 0 1-.483.237z",
		clipRule: "evenodd",
		opacity: .5
	})), _path2$315 || (_path2$315 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8.488 11.008a.8.8 0 0 0-.98 0L4.185 13.58a.3.3 0 0 1-.484-.237V3.154a.8.8 0 0 1 .8-.8h7a.8.8 0 0 1 .8.8v10.19a.3.3 0 0 1-.484.237zM4.5 1.154h7a2 2 0 0 1 2 2v10.19c0 1.245-1.431 1.948-2.417 1.186l-2.84-2.195a.4.4 0 0 0-.49 0L4.919 14.53c-.986.763-2.418.06-2.418-1.186V3.154a2 2 0 0 1 2-2",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/BookmarkOne.svg
var _path$441;
var _path2$314;
function _extends$455() {
	return _extends$455 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$455.apply(null, arguments);
}
var SvgBookmarkOne = function SvgBookmarkOne(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$455({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$441 || (_path$441 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8.488 11.008a.8.8 0 0 0-.98 0L4.185 13.58a.3.3 0 0 1-.484-.237V3.154a.8.8 0 0 1 .8-.8h7a.8.8 0 0 1 .8.8v10.19a.3.3 0 0 1-.484.237zM4.5 1.154h7a2 2 0 0 1 2 2v10.19c0 1.245-1.431 1.948-2.417 1.186l-2.84-2.195a.4.4 0 0 0-.49 0L4.919 14.53c-.986.763-2.418.06-2.418-1.186V3.154a2 2 0 0 1 2-2",
		clipRule: "evenodd"
	})), _path2$314 || (_path2$314 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M7.996 9.706a.3.3 0 0 1-.3-.3V5.488a.1.1 0 0 0-.158-.082l-.995.704a.2.2 0 0 1-.316-.163V4.805a.3.3 0 0 1 .128-.246l1.472-1.035A.3.3 0 0 1 8 3.47h1.004a.3.3 0 0 1 .3.3v5.636a.3.3 0 0 1-.3.3z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/BookmarkThree.svg
var _path$440;
var _path2$313;
function _extends$454() {
	return _extends$454 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$454.apply(null, arguments);
}
var SvgBookmarkThree = function SvgBookmarkThree(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$454({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$440 || (_path$440 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8.488 11.008a.8.8 0 0 0-.98 0L4.185 13.58a.3.3 0 0 1-.484-.237V3.154a.8.8 0 0 1 .8-.8h7a.8.8 0 0 1 .8.8v10.19a.3.3 0 0 1-.484.237zM4.5 1.154h7a2 2 0 0 1 2 2v10.19c0 1.245-1.431 1.948-2.417 1.186l-2.84-2.195a.4.4 0 0 0-.49 0L4.919 14.53c-.986.763-2.418.06-2.418-1.186V3.154a2 2 0 0 1 2-2",
		clipRule: "evenodd"
	})), _path2$313 || (_path2$313 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M9.35 6.456c.186.079.352.186.49.321.277.271.43.643.43 1.082v.008a1.73 1.73 0 0 1-.646 1.369c-.406.332-.97.515-1.62.515-.638 0-1.184-.179-1.584-.501a1.85 1.85 0 0 1-.686-1.32l-.004-.046a.2.2 0 0 1 .2-.217h.965a.2.2 0 0 1 .199.182l.003.041c.038.346.345.637.907.637.277 0 .488-.08.627-.2a.62.62 0 0 0 .216-.487v-.008c0-.245-.085-.415-.224-.528-.144-.118-.372-.194-.69-.194H7.39a.3.3 0 0 1-.3-.3v-.55a.3.3 0 0 1 .3-.3h.521c.263 0 .464-.076.596-.19a.58.58 0 0 0 .204-.454V5.31c0-.213-.068-.36-.174-.455-.109-.099-.284-.166-.54-.166-.249 0-.442.069-.574.177a.65.65 0 0 0-.235.462v.002l-.004.039a.2.2 0 0 1-.199.18h-.937a.2.2 0 0 1-.2-.218l.005-.043c.045-.537.276-.992.656-1.31s.893-.49 1.488-.49c.604 0 1.12.16 1.49.458.374.3.585.729.585 1.23v.009c0 .579-.293 1.013-.72 1.272",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/BookmarkTwo.svg
var _path$439;
var _path2$312;
function _extends$453() {
	return _extends$453 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$453.apply(null, arguments);
}
var SvgBookmarkTwo = function SvgBookmarkTwo(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$453({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$439 || (_path$439 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8.488 11.008a.8.8 0 0 0-.98 0L4.185 13.58a.3.3 0 0 1-.484-.237V3.154a.8.8 0 0 1 .8-.8h7a.8.8 0 0 1 .8.8v10.19a.3.3 0 0 1-.484.237zM4.5 1.154h7a2 2 0 0 1 2 2v10.19c0 1.245-1.431 1.948-2.417 1.186l-2.84-2.195a.4.4 0 0 0-.49 0L4.919 14.53c-.986.763-2.418.06-2.418-1.186V3.154a2 2 0 0 1 2-2",
		clipRule: "evenodd"
	})), _path2$312 || (_path2$312 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M7.758 6.785c.377-.389.603-.64.736-.844a.85.85 0 0 0 .165-.51V5.42a.7.7 0 0 0-.183-.502c-.113-.115-.284-.193-.52-.193a.75.75 0 0 0-.551.21.72.72 0 0 0-.19.368c-.022.108-.11.199-.22.199h-.94a.187.187 0 0 1-.191-.201c.047-.494.26-.92.602-1.233.387-.354.924-.551 1.541-.551 1.162 0 2.048.733 2.048 1.817v.012c0 .73-.362 1.289-1.36 2.278L8 8.322a.08.08 0 0 0 .057.136h1.78a.3.3 0 0 1 .3.3v.636a.3.3 0 0 1-.3.3H6.213a.3.3 0 0 1-.3-.3v-.42a.6.6 0 0 1 .164-.413z"
	})));
};

//#endregion
//#region src/Icon/icons/Bug.svg
var _path$438;
var _path2$311;
function _extends$452() {
	return _extends$452 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$452.apply(null, arguments);
}
var SvgBug = function SvgBug(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$452({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$438 || (_path$438 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M8 13.8a3.4 3.4 0 0 0 3.4-3.4V5.875a.476.476 0 0 0-.476-.475H8z",
		opacity: .25
	})), _path2$311 || (_path2$311 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M13.291 13.7a.6.6 0 1 0 1.2 0v-2.748L12.6 9.06v-.835l.936.468 1.43 1.431a.6.6 0 0 0 .85-.848l-1.57-1.57-1.646-.822V6.38l1.891-1.892V1.739a.6.6 0 1 0-1.2 0v2.252l-.966.965a1.7 1.7 0 0 0-.734-.618 3.6 3.6 0 0 0-7.182 0c-.3.13-.556.347-.734.618l-.966-.965V1.739a.6.6 0 0 0-1.2 0v2.749L3.4 6.378v.506l-1.646.823L.185 9.276a.6.6 0 0 0 .849.848l1.43-1.43.936-.469v.836l-1.89 1.89V13.7a.6.6 0 1 0 1.2 0v-2.251l.703-.704a4.6 4.6 0 0 0 9.174 0l.704.704zM4.6 5.875V10.4a3.4 3.4 0 1 0 6.8 0V5.875a.476.476 0 0 0-.476-.475H5.076a.476.476 0 0 0-.475.475M8 2.2a2.4 2.4 0 0 0-2.367 2h4.734A2.4 2.4 0 0 0 8 2.2",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Calculator.svg
var _g$98;
var _g2$14;
var _path$437;
function _extends$451() {
	return _extends$451 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$451.apply(null, arguments);
}
var SvgCalculator = function SvgCalculator(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$451({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$98 || (_g$98 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M4.2 8.2c0-.22.18-.4.4-.4h1.6c.22 0 .4.18.4.4v1.2a.4.4 0 0 1-.4.4H4.6a.4.4 0 0 1-.4-.4zM7.1 8.2c0-.22.18-.4.4-.4h1.6c.22 0 .4.18.4.4v1.2a.4.4 0 0 1-.4.4H7.5a.4.4 0 0 1-.4-.4zM4.2 11c0-.22.18-.4.4-.4h1.6c.22 0 .4.18.4.4v1.2a.4.4 0 0 1-.4.4H4.6a.4.4 0 0 1-.4-.4zM7.1 11c0-.22.18-.4.4-.4h1.6c.22 0 .4.18.4.4v1.2a.4.4 0 0 1-.4.4H7.5a.4.4 0 0 1-.4-.4z" }))), _g2$14 || (_g2$14 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .5
	}, /*#__PURE__*/ React.createElement("path", { d: "M10 8.2c0-.22.18-.4.4-.4h1c.22 0 .4.18.4.4v4a.4.4 0 0 1-.4.4h-1a.4.4 0 0 1-.4-.4zM4.2 4a.6.6 0 0 1 .6-.6h6.4a.6.6 0 0 1 .6.6v2a.6.6 0 0 1-.6.6H4.8a.6.6 0 0 1-.6-.6z" }))), _path$437 || (_path$437 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M12.2 1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3.8a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zM3.8 13.8A.8.8 0 0 1 3 13V3a.8.8 0 0 1 .8-.8h8.4l.082.004A.8.8 0 0 1 13 3v10a.8.8 0 0 1-.718.796l-.082.004z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Calendar.svg
var _g$97;
var _path$436;
var _path2$310;
function _extends$450() {
	return _extends$450 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$450.apply(null, arguments);
}
var SvgCalendar = function SvgCalendar(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$450({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$97 || (_g$97 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M3.4 3.2a1.2 1.2 0 0 0-1.2 1.2V6h11.6V4.4a1.2 1.2 0 0 0-1.2-1.2zM3.4 8.598c0-.22.18-.4.4-.4h1.6c.22 0 .4.18.4.4v.4a.4.4 0 0 1-.4.4H3.8a.4.4 0 0 1-.4-.4zM6.8 8.598c0-.22.18-.4.4-.4h1.6c.22 0 .4.18.4.4v.4a.4.4 0 0 1-.4.4H7.2a.4.4 0 0 1-.4-.4zM10.2 8.598c0-.22.18-.4.4-.4h1.6c.22 0 .4.18.4.4v.4a.4.4 0 0 1-.4.4h-1.6a.4.4 0 0 1-.4-.4zM3.4 10.998c0-.22.18-.4.4-.4h1.6c.22 0 .4.18.4.4v.4a.4.4 0 0 1-.4.4H3.8a.4.4 0 0 1-.4-.4zM6.8 10.998c0-.22.18-.4.4-.4h1.6c.22 0 .4.18.4.4v.4a.4.4 0 0 1-.4.4H7.2a.4.4 0 0 1-.4-.4zM10.2 10.998c0-.22.18-.4.4-.4h1.6c.22 0 .4.18.4.4v.4a.4.4 0 0 1-.4.4h-1.6a.4.4 0 0 1-.4-.4z" }))), _path$436 || (_path$436 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M6.4 4.6a.9.9 0 1 1-1.8 0 .9.9 0 0 1 1.8 0M11.4 4.6a.9.9 0 1 1-1.8 0 .9.9 0 0 1 1.8 0"
	})), _path2$310 || (_path2$310 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M3.4 2h9.2A2.4 2.4 0 0 1 15 4.4v7.2a2.4 2.4 0 0 1-2.4 2.4H3.4A2.4 2.4 0 0 1 1 11.6V4.4A2.4 2.4 0 0 1 3.4 2m0 10.8a1.2 1.2 0 0 1-1.2-1.2V7.2h11.6v4.4a1.2 1.2 0 0 1-1.2 1.2zm0-9.6a1.2 1.2 0 0 0-1.2 1.2V6h11.6V4.4a1.2 1.2 0 0 0-1.2-1.2zm3 1.4a.9.9 0 1 1-1.8 0 .9.9 0 0 1 1.8 0m5 0a.9.9 0 1 1-1.8 0 .9.9 0 0 1 1.8 0",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/CaptivePortal.svg
var _g$96;
var _path$435;
var _path2$309;
var _path3$160;
function _extends$449() {
	return _extends$449 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$449.apply(null, arguments);
}
var SvgCaptivePortal = function SvgCaptivePortal(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$449({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$96 || (_g$96 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M6.133 13.386c-.776 0-1.442-1.368-1.723-3.313v-.003h3.447c-.281 1.947-.947 3.316-1.724 3.316M7.857 5.93c-.281-1.947-.947-3.316-1.724-3.316-.776 0-1.442 1.368-1.723 3.313v.003z" }))), _path$435 || (_path$435 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M10.214 8.959h1.916l-1.998 2.28a1.06 1.06 0 0 0 0 1.355.77.77 0 0 0 1.188 0l3.401-3.88A1.02 1.02 0 0 0 15 8a1.02 1.02 0 0 0-.279-.713l-3.4-3.881a.77.77 0 0 0-1.188 0 1.06 1.06 0 0 0 0 1.355l1.997 2.28h-1.916a18 18 0 0 1 0 1.918"
	})), _path2$309 || (_path2$309 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M6.848 7.041H1.84c-.464 0-.84.43-.84.959 0 .53.376.959.84.959h5.008a14 14 0 0 0 0-1.918",
		clipRule: "evenodd"
	})), _path3$160 || (_path3$160 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M6.133 14.5c-.731 0-1.264-.43-1.594-.833-.338-.412-.592-.941-.784-1.495a11 11 0 0 1-.476-2.1h1.13c.282 1.946.948 3.314 1.724 3.314C7.164 13.386 8 10.974 8 8s-.836-5.386-1.867-5.386c-.776 0-1.442 1.368-1.723 3.313H3.28c.103-.777.264-1.49.475-2.099.192-.554.446-1.083.784-1.495.33-.403.863-.833 1.594-.833s1.264.43 1.595.833c.338.412.592.941.784 1.495C8.9 4.948 9.12 6.423 9.12 8s-.22 3.052-.608 4.172c-.192.554-.446 1.083-.784 1.495-.33.403-.863.833-1.595.833"
	})));
};

//#endregion
//#region src/Icon/icons/Cards.svg
var _path$434;
function _extends$448() {
	return _extends$448 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$448.apply(null, arguments);
}
var SvgCards = function SvgCards(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$448({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$434 || (_path$434 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M3.2 1h2a2.2 2.2 0 0 1 2.2 2.2v2a2.2 2.2 0 0 1-2.2 2.2h-2A2.2 2.2 0 0 1 1 5.2v-2A2.2 2.2 0 0 1 3.2 1m0 1.2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1zM10.8 1h2A2.2 2.2 0 0 1 15 3.2v2a2.2 2.2 0 0 1-2.2 2.2h-2a2.2 2.2 0 0 1-2.2-2.2v-2A2.2 2.2 0 0 1 10.8 1m0 1.2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1zM3.2 8.6h2a2.2 2.2 0 0 1 2.2 2.2v2A2.2 2.2 0 0 1 5.2 15h-2A2.2 2.2 0 0 1 1 12.8v-2a2.2 2.2 0 0 1 2.2-2.2m0 1.2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Cellular.svg
var _g$95;
var _g2$13;
var _path$433;
var _path2$308;
function _extends$447() {
	return _extends$447 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$447.apply(null, arguments);
}
var SvgCellular$1 = function SvgCellular(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$447({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$95 || (_g$95 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M13.166 2.835c.043.043.147.189.26.528.11.324.2.744.27 1.245.139 1.004.179 2.214.179 3.392s-.04 2.388-.18 3.392a7 7 0 0 1-.268 1.245c-.114.339-.218.485-.261.528a.7.7 0 0 1-.143.089c-.089.045-.224.103-.42.164-.363.113-.83.205-1.363.275-.79.105-1.663.154-2.446.172.389-.192.698-.52.866-.922a1.799 1.799 0 0 0 2.71-2.202l-.436-.932c.195-.094.378-.239.527-.445a5.48 5.48 0 0 0 .24-6.067l.464-.463zM3.667 12.331a1.798 1.798 0 0 0 2.67.611c.167.402.475.729.862.921-.77-.019-1.623-.067-2.398-.17-.534-.07-1-.162-1.364-.275a3 3 0 0 1-.42-.164.7.7 0 0 1-.142-.089l-.019-.022z" }), /*#__PURE__*/ React.createElement("path", {
		fillRule: "evenodd",
		d: "M8 5.25a.9.9 0 0 1 .9.9l-.006.092A.9.9 0 0 1 8 7.05l-.093-.005A.9.9 0 0 1 8 5.25",
		clipRule: "evenodd"
	}))), _g2$13 || (_g2$13 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .5
	}, /*#__PURE__*/ React.createElement("path", { d: "M11.097 3.586c.06-.131.235-.156.323-.042a4.28 4.28 0 0 1 .88 2.605c0 .939-.301 1.806-.812 2.513-.085.119-.264.095-.325-.037l-.389-.838a.32.32 0 0 1 .007-.274c.18-.366.294-.772.316-1.203l.004-.16c0-.53-.137-1.027-.371-1.463a.32.32 0 0 1-.013-.283zM5.278 4.409a.32.32 0 0 1-.011.283 3.08 3.08 0 0 0-.052 2.817.32.32 0 0 1 .006.273l-.389.836c-.062.133-.24.156-.326.037A4.28 4.28 0 0 1 3.7 6.15c0-.976.327-1.876.876-2.598.087-.115.262-.09.323.04z" }))), _path$433 || (_path$433 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8 12.852a.6.6 0 0 1-.6-.6V11.4l-1.241-.403-.353.756a.6.6 0 1 1-1.088-.507L6.44 7.556a2.1 2.1 0 0 1-.529-1.192L5.9 6.15l.01-.214A2.1 2.1 0 0 1 8 4.05l.214.01a2.1 2.1 0 0 1 1.345 3.496l1.722 3.693a.6.6 0 1 1-1.087.507l-.358-.767-1.237.402v.86a.6.6 0 0 1-.6.6M8 5.25a.9.9 0 0 1 .9.9l-.006.092A.9.9 0 0 1 8 7.05l-.093-.005A.9.9 0 0 1 8 5.25m-.6 3.087v1.802l-.73-.237zm1.2 1.792V8.337l.725 1.557z",
		clipRule: "evenodd"
	})), _path2$308 || (_path2$308 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M14.565 13.017c-.14.419-.32.764-.55.995-.232.233-.606.412-1.056.552-.453.14-.992.243-1.561.319-1.14.151-2.41.192-3.378.192s-2.238-.04-3.377-.192a10 10 0 0 1-1.561-.32c-.45-.14-.825-.318-1.057-.55-.23-.232-.411-.577-.555-.995a8.3 8.3 0 0 1-.333-1.461C.976 10.47.925 9.195.925 8s.05-2.47.212-3.557c.08-.543.189-1.042.333-1.461.144-.418.325-.763.555-.994.232-.233.606-.412 1.057-.552a10 10 0 0 1 1.56-.319C5.783.966 7.053.925 8.02.925s2.239.04 3.378.192c.57.076 1.108.179 1.56.32.451.14.825.318 1.057.55.23.232.41.577.55.996s.243.917.319 1.46c.15 1.088.191 2.362.191 3.557s-.04 2.47-.191 3.556a8.3 8.3 0 0 1-.32 1.461M2.875 2.835c-.046.046-.153.196-.27.537a7 7 0 0 0-.281 1.247C2.176 5.621 2.125 6.829 2.125 8s.05 2.379.199 3.381c.074.501.169.922.28 1.247.118.34.225.49.271.537.01.01.052.043.142.089a3 3 0 0 0 .42.164c.364.112.83.205 1.364.276 1.064.14 2.275.181 3.22.181.943 0 2.155-.04 3.22-.181.533-.071.998-.164 1.362-.276a3 3 0 0 0 .42-.164.7.7 0 0 0 .143-.09c.042-.042.147-.188.26-.527.11-.324.2-.744.269-1.246.14-1.004.18-2.213.18-3.391s-.04-2.387-.18-3.391a7 7 0 0 0-.268-1.246c-.114-.34-.219-.485-.261-.528a.7.7 0 0 0-.143-.089 3 3 0 0 0-.42-.164 8.6 8.6 0 0 0-1.363-.275c-1.064-.142-2.276-.182-3.22-.182s-2.155.04-3.22.182c-.533.07-.999.163-1.362.275-.196.061-.331.119-.42.164a.7.7 0 0 0-.143.09",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Changelog.svg
var _path$432;
var _path2$307;
var _path3$159;
function _extends$446() {
	return _extends$446 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$446.apply(null, arguments);
}
var SvgChangelog = function SvgChangelog(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$446({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$432 || (_path$432 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M13.67 6.381c.162.162.253.381.253.61v.176A5.2 5.2 0 0 0 12 6.8c-.764 0-1.49.165-2.142.46H8.313a.646.646 0 0 1-.646-.646V3.427l-.002-.704a.215.215 0 0 0-.215-.215H3.8a.215.215 0 0 0-.215.215v10.554c0 .119.096.215.215.215h2.428l1.039.841v.004h.005l.07.057c.23.207.51.35.808.422q0 .092.013.184H3.8a1.723 1.723 0 0 1-1.723-1.723V2.723C2.077 1.771 2.848 1 3.8 1h4.132c.229 0 .448.09.61.252z"
	})), _path2$307 || (_path2$307 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M12 16a4 4 0 1 0-3.836-2.863h.91l.246-.214q-.152-.437-.153-.923a2.833 2.833 0 1 1 1.226 2.334c-.257-.178-.61-.199-.845.007-.251.219-.272.607-.01.813.68.53 1.534.846 2.462.846"
	})), _path3$159 || (_path3$159 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "m9.174 11.902.711-.576a.696.696 0 0 1 .89 0 .5.5 0 0 1 0 .775l-1.712 1.385a.67.67 0 0 1-.468.182.67.67 0 0 1-.468-.182l-1.711-1.385a.5.5 0 0 1 0-.775.696.696 0 0 1 .889 0l.698.576z"
	})));
};

//#endregion
//#region src/Icon/icons/Channel.svg
var _path$431;
function _extends$445() {
	return _extends$445 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$445.apply(null, arguments);
}
var SvgChannel = function SvgChannel(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$445({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$431 || (_path$431 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M1 4a.8.8 0 0 1 .8-.8h.55a.8.8 0 0 1 .8.8v.4a.8.8 0 0 1-.8.8H1.8a.8.8 0 0 1-.8-.8zM4.95 4a.8.8 0 0 1 .8-.8h.55a.8.8 0 0 1 .8.8v.4a.8.8 0 0 1-.8.8h-.55a.8.8 0 0 1-.8-.8zM8.9 4a.8.8 0 0 1 .8-.8h.55a.8.8 0 0 1 .8.8v.4a.8.8 0 0 1-.8.8H9.7a.8.8 0 0 1-.8-.8zM12.85 4a.8.8 0 0 1 .8-.8h.55a.8.8 0 0 1 .8.8v.4a.8.8 0 0 1-.8.8h-.55a.8.8 0 0 1-.8-.8zM1 7.8a.8.8 0 0 1 .8-.8h4.5a.8.8 0 0 1 .8.8v.4a.8.8 0 0 1-.8.8H1.8a.8.8 0 0 1-.8-.8zM8.9 7.8a.8.8 0 0 1 .8-.8h4.5a.8.8 0 0 1 .8.8v.4a.8.8 0 0 1-.8.8H9.7a.8.8 0 0 1-.8-.8zM1 11.6a.8.8 0 0 1 .8-.8h12.4a.8.8 0 0 1 .8.8v.4a.8.8 0 0 1-.8.8H1.8A.8.8 0 0 1 1 12z"
	})));
};

//#endregion
//#region src/Icon/icons/ChannelCycle.svg
var _path$430;
function _extends$444() {
	return _extends$444 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$444.apply(null, arguments);
}
var SvgChannelCycle = function SvgChannelCycle(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$444({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$430 || (_path$430 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M1 4a.8.8 0 0 1 .8-.8h.55a.8.8 0 0 1 .8.8v.4a.8.8 0 0 1-.8.8H1.8a.8.8 0 0 1-.8-.8zM4.95 4a.8.8 0 0 1 .8-.8h.55a.8.8 0 0 1 .8.8v.4a.8.8 0 0 1-.8.8h-.55a.8.8 0 0 1-.8-.8zM9.7 3.2a.8.8 0 0 0-.8.8v.4a.8.8 0 0 0 .8.8h.55a.8.8 0 0 0 .8-.8V4a.8.8 0 0 0-.8-.8zM12.85 4a.8.8 0 0 1 .8-.8h.55a.8.8 0 0 1 .8.8v.4a.8.8 0 0 1-.8.8h-.55a.8.8 0 0 1-.8-.8zM1.8 7a.8.8 0 0 0-.8.8v.4a.8.8 0 0 0 .8.8h4.5a.8.8 0 0 0 .8-.8v-.4a.8.8 0 0 0-.8-.8zM8.9 7.8a.8.8 0 0 1 .8-.8h4.5a.8.8 0 0 1 .8.8v.4a.8.8 0 0 1-.8.8h-.621a4.34 4.34 0 0 0-2.067-.52c-.728 0-1.414.178-2.017.494A.8.8 0 0 1 8.9 8.2zM7.658 10.8H1.8a.8.8 0 0 0-.8.8v.4a.8.8 0 0 0 .8.8h5.352a4.34 4.34 0 0 1 .506-2M13.426 12.395a1.966 1.966 0 1 0-.8 2.064c.238-.164.585-.198.83.016.25.219.29.63 0 .856a3.16 3.16 0 1 1 1.191-2.886l.283-.233a.68.68 0 0 1 .875.002.535.535 0 0 1 0 .822l-.004.004-1.279 1.035a.66.66 0 0 1-.456.176.66.66 0 0 1-.457-.176l-1.283-1.039a.535.535 0 0 1 0-.822.68.68 0 0 1 .875-.002z"
	})));
};

//#endregion
//#region src/Icon/icons/ChartBar.svg
var _g$94;
var _path$429;
function _extends$443() {
	return _extends$443 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$443.apply(null, arguments);
}
var SvgChartBar = function SvgChartBar(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$443({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$94 || (_g$94 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .5
	}, /*#__PURE__*/ React.createElement("path", { d: "M8.914 6.743v6.514a.914.914 0 0 0 1.829 0V6.743a.914.914 0 0 0-1.829 0M3.429 8.114a.914.914 0 1 0-1.829 0v5.143a.914.914 0 0 0 1.829 0zM5.257 11.772v1.485a.914.914 0 0 0 1.829 0v-1.485a.914.914 0 1 0-1.829 0M14.4 9.943a.914.914 0 1 0-1.828 0v3.314a.914.914 0 0 0 1.828 0z" }))), _path$429 || (_path$429 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M9.829 1.829a.914.914 0 0 0-.915.914v4a.914.914 0 1 1 1.829 0v-4a.914.914 0 0 0-.914-.914M1.6 4.114a.914.914 0 1 1 1.829 0v4a.914.914 0 1 0-1.829 0zM6.172 6.857a.914.914 0 0 0-.915.914v4a.914.914 0 1 1 1.829 0v-4a.914.914 0 0 0-.914-.914M12.572 5.943a.914.914 0 0 1 1.828 0v4a.914.914 0 1 0-1.828 0z"
	})));
};

//#endregion
//#region src/Icon/icons/ChartLine.svg
var _path$428;
var _path2$306;
var _path3$158;
function _extends$442() {
	return _extends$442 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$442.apply(null, arguments);
}
var SvgChartLine = function SvgChartLine(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$442({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$428 || (_path$428 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "m6.725 8.053 3.21-4.488 2.992 2.662.07 6.84h-9.94l.007-7.61 2.688 2.677a.64.64 0 0 0 .973-.081",
		opacity: .25
	})), _path2$306 || (_path2$306 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M9.936 3.565 6.725 8.053a.64.64 0 0 1-.972.081L3.065 5.456l-.008 7.611h9.94l-.07-6.84zm-.597-1.052a.64.64 0 0 1 .946-.105l3.523 3.134a.64.64 0 0 1 .214.471l.077 7.505a.64.64 0 0 1-.64.646H2.6a.64.64 0 0 1-.64-.64l.007-9.168a.64.64 0 0 1 1.092-.454l3.087 3.075z",
		clipRule: "evenodd",
		opacity: .5
	})), _path3$158 || (_path3$158 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M3.429 4.121a.914.914 0 1 1-1.829 0 .914.914 0 0 1 1.829 0M7.086 7.779a.914.914 0 1 1-1.829 0 .914.914 0 0 1 1.829 0M10.743 2.75a.914.914 0 1 1-1.829 0 .914.914 0 0 1 1.829 0M14.4 5.95a.914.914 0 1 1-1.828 0 .914.914 0 0 1 1.828 0"
	})));
};

//#endregion
//#region src/Icon/icons/Chat.svg
var _path$427;
var _path2$305;
function _extends$441() {
	return _extends$441 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$441.apply(null, arguments);
}
var SvgChat = function SvgChat(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$441({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$427 || (_path$427 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M.667 7.167A5.667 5.667 0 0 1 6.333 1.5h3.334a5.667 5.667 0 0 1 5.666 5.667v5.666c0 .92-.746 1.667-1.666 1.667H6.333A5.667 5.667 0 0 1 .667 8.833zm1.124 0a4.54 4.54 0 0 1 4.542-4.543h3.334a4.54 4.54 0 0 1 4.542 4.543v5.666c0 .3-.243.543-.542.543H6.333a4.54 4.54 0 0 1-4.542-4.543z",
		clipRule: "evenodd"
	})), _path2$305 || (_path2$305 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M5.98 8a.9.9 0 1 1-1.8 0 .9.9 0 0 1 1.8 0M8.9 8a.9.9 0 1 1-1.8 0 .9.9 0 0 1 1.8 0M10.92 8.9a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8"
	})));
};

//#endregion
//#region src/Icon/icons/Checkmark.svg
var _path$426;
function _extends$440() {
	return _extends$440 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$440.apply(null, arguments);
}
var SvgCheckmark = function SvgCheckmark(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$440({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$426 || (_path$426 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M5.975 12.86a.9.9 0 0 0 .656-.265l7.915-7.915a.902.902 0 0 0-1.275-1.275l-6.994 6.994a.433.433 0 0 1-.612 0L2.729 7.463a.902.902 0 0 0-1.275 1.275l3.857 3.857c.18.18.419.269.656.264z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/CheckmarkCircle.svg
var _path$425;
var _path2$304;
var _path3$157;
function _extends$439() {
	return _extends$439 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$439.apply(null, arguments);
}
var SvgCheckmarkCircle = function SvgCheckmarkCircle(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$439({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$425 || (_path$425 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M13.396 5.873a5.8 5.8 0 0 1-9.498 6.228l.948-.948.54.54c.4.4.926.599 1.447.6v.002l.018-.001h.017v-.001a2.05 2.05 0 0 0 1.447-.6l4.483-4.482c.372-.372.57-.851.598-1.338",
		opacity: .25
	})), _path2$304 || (_path2$304 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "m11.95 6.363-4.482 4.482a.85.85 0 0 1-.617.25.85.85 0 0 1-.617-.25L4.05 8.661a.854.854 0 0 1 1.208-1.208l1.593 1.593 3.89-3.891a.854.854 0 1 1 1.209 1.208",
		clipRule: "evenodd"
	})), _path3$157 || (_path3$157 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14M8 2.2a5.8 5.8 0 1 1 0 11.6A5.8 5.8 0 0 1 8 2.2",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/ChevronDown.svg
var _path$424;
function _extends$438() {
	return _extends$438 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$438.apply(null, arguments);
}
var SvgChevronDown = function SvgChevronDown(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$438({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$424 || (_path$424 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M12.232 4.36a1 1 0 0 1 1.536 1.284l-5.324 6.139a.6.6 0 0 1-.922-.002L2.23 5.641a1 1 0 0 1 1.54-1.277l4.14 4.754a.1.1 0 0 0 .153 0z"
	})));
};

//#endregion
//#region src/Icon/icons/ChevronLeft.svg
var _path$423;
function _extends$437() {
	return _extends$437 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$437.apply(null, arguments);
}
var SvgChevronLeft = function SvgChevronLeft(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$437({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$423 || (_path$423 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M11.64 12.232a1 1 0 0 1-1.284 1.535L4.218 8.444a.6.6 0 0 1 .001-.922l6.14-5.292a1 1 0 0 1 1.277 1.54L6.882 7.91a.1.1 0 0 0 0 .153z"
	})));
};

//#endregion
//#region src/Icon/icons/ChevronRight.svg
var _path$422;
function _extends$436() {
	return _extends$436 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$436.apply(null, arguments);
}
var SvgChevronRight = function SvgChevronRight(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$436({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$422 || (_path$422 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M4.361 12.232a1 1 0 0 0 1.283 1.535l6.139-5.323a.6.6 0 0 0-.002-.922L5.641 2.23a1 1 0 0 0-1.277 1.54l4.754 4.14a.1.1 0 0 1 0 .153z"
	})));
};

//#endregion
//#region src/Icon/icons/ChevronsHorizontal.svg
var _path$421;
function _extends$435() {
	return _extends$435 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$435.apply(null, arguments);
}
var SvgChevronsHorizontal = function SvgChevronsHorizontal(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$435({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$421 || (_path$421 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M8.957 5.122a1.013 1.013 0 0 1 1.303-1.548l.003.004v-.001l4.414 3.829.066.054a.72.72 0 0 1 0 1.103l-4.48 3.86-.006.005a1.01 1.01 0 0 1-1.424-.131l-.055-.075-.007-.008c-.285-.424-.208-1.001.19-1.336l3.292-2.868zM7.043 5.122A1.013 1.013 0 0 0 5.74 3.574l-.003.004v-.001L1.322 7.406l-.065.054a.72.72 0 0 0 0 1.103l4.478 3.86.007.005c.43.357 1.067.298 1.424-.131l.055-.075.007-.008c.285-.424.208-1.001-.19-1.336L3.748 8.01z"
	})));
};

//#endregion
//#region src/Icon/icons/ChevronsVertical.svg
var _path$420;
function _extends$434() {
	return _extends$434 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$434.apply(null, arguments);
}
var SvgChevronsVertical = function SvgChevronsVertical(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$434({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$420 || (_path$420 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M10.878 8.957a1.013 1.013 0 0 1 1.548 1.303l-.004.003.001.001-3.829 4.413-.054.066a.72.72 0 0 1-1.103 0l-3.86-4.479-.005-.007a1.01 1.01 0 0 1 .131-1.424l.075-.055.008-.007c.424-.285 1.001-.208 1.336.19l2.868 3.292zM10.878 7.043a1.013 1.013 0 0 0 1.548-1.303l-.004-.003h.001L8.594 1.322l-.054-.065a.72.72 0 0 0-1.103 0l-3.86 4.478-.005.007a1.01 1.01 0 0 0 .131 1.424l.075.055.008.007c.424.285 1.001.208 1.336-.19L7.99 3.748z"
	})));
};

//#endregion
//#region src/Icon/icons/ChevronUp.svg
var _path$419;
function _extends$433() {
	return _extends$433 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$433.apply(null, arguments);
}
var SvgChevronUp = function SvgChevronUp(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$433({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$419 || (_path$419 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M12.233 11.64a1 1 0 0 0 1.535-1.284L8.444 4.217a.6.6 0 0 0-.922.002l-5.291 6.14a1 1 0 0 0 1.539 1.277l4.14-4.754a.1.1 0 0 1 .153 0z"
	})));
};

//#endregion
//#region src/Icon/icons/Client.svg
var _g$93;
var _path$418;
var _path2$303;
function _extends$432() {
	return _extends$432 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$432.apply(null, arguments);
}
var SvgClient = function SvgClient(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$432({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$93 || (_g$93 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M3 2.7h10a.8.8 0 0 1 .775.6H11a3.2 3.2 0 0 0-3.2 3.2v4.8H2.2V3.5a.8.8 0 0 1 .8-.8" }), /*#__PURE__*/ React.createElement("path", {
		fillRule: "evenodd",
		d: "M11 5.7h3a.8.8 0 0 1 .8.8v6a.8.8 0 0 1-.8.8h-3a.8.8 0 0 1-.8-.8v-6a.8.8 0 0 1 .8-.8m1.5 6.8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1",
		clipRule: "evenodd"
	}))), _path$418 || (_path$418 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M13 2.7H3a.8.8 0 0 0-.8.8v7.8h5.6v1.2H.6a.6.6 0 1 1 0-1.2H1V3.5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 1.96 3.2 3.2 0 0 0-1-.16h-.225A.8.8 0 0 0 13 2.7M13 12a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
	})), _path2$303 || (_path2$303 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M11 4.5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zm3 1.2h-3a.8.8 0 0 0-.8.8v6a.8.8 0 0 0 .8.8h3a.8.8 0 0 0 .8-.8v-6a.8.8 0 0 0-.8-.8",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/ClientVPN.svg
var _g$92;
var _path$417;
var _path2$302;
function _extends$431() {
	return _extends$431 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$431.apply(null, arguments);
}
var SvgClientVpn = function SvgClientVpn(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$431({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$92 || (_g$92 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M3 2.7h10a.8.8 0 0 1 .8.8v2.703l-.929-.35A2.4 2.4 0 0 0 12.1 5.7h-.098a2.4 2.4 0 0 0-.772.153l-2.72 1.026a2.38 2.38 0 0 0-1.522 1.953 13 13 0 0 0-.05 2.468H2.2V3.5a.797.797 0 0 1 .8-.8M12.05 14.669q.13 0 .25-.06c1.315-.673 2.127-1.64 2.333-2.806.147-.834.13-1.687.085-2.281a.584.584 0 0 0-.378-.496l-1.937-.732a1 1 0 0 0-.353-.064z" }))), _path$417 || (_path$417 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M5.402 12.5H.6a.6.6 0 1 1 0-1.2H1V3.5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v3.156l-1.2-.453V3.5a.8.8 0 0 0-.8-.8H3a.8.8 0 0 0-.8.8v7.8h4.737q.035.456.118.93.024.136.054.27z"
	})), _path2$302 || (_path2$302 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8.18 8.969c-.07.603-.16 1.825.056 3.052.316 1.787 1.62 3.093 3.37 3.88q.204.092.427.098l.017.001h.017c.146-.005.292-.038.428-.1 1.75-.786 3.053-2.092 3.369-3.88.217-1.226.126-2.448.057-3.051a1.18 1.18 0 0 0-.755-.967l-2.718-1.027a1.2 1.2 0 0 0-.383-.075h-.03q-.197.006-.383.075L8.934 8.002a1.18 1.18 0 0 0-.755.967m6.538.553c.045.595.062 1.447-.085 2.281-.206 1.166-1.018 2.133-2.334 2.806a.55.55 0 0 1-.498 0c-1.316-.673-2.128-1.64-2.334-2.806a7 7 0 0 1-.04-.255 9.8 9.8 0 0 1-.045-2.026.58.58 0 0 1 .378-.496l1.937-.731a1 1 0 0 1 .706 0l1.937.731a.58.58 0 0 1 .378.496",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Clock.svg
var _g$91;
var _path$416;
var _path2$301;
function _extends$430() {
	return _extends$430 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$430.apply(null, arguments);
}
var SvgClock = function SvgClock(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$430({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$91 || (_g$91 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M4.627 5.403a.6.6 0 0 1 .849-.849l.424.425a.6.6 0 1 1-.849.848zM5.403 11.373a.6.6 0 0 1-.849-.849l.425-.424a.6.6 0 0 1 .848.848zM3.8 8.6a.6.6 0 0 1 0-1.2h.6a.6.6 0 0 1 0 1.2zM7.4 11.6a.6.6 0 1 1 1.2 0v.6a.6.6 0 1 1-1.2 0zM8.6 3.8a.6.6 0 0 0-.6-.6 4.8 4.8 0 0 1 3.506 8.078.6.6 0 0 0-.121-.673L8.659 7.879a.2.2 0 0 1-.059-.142z" }))), _path$416 || (_path$416 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8 2.2a5.8 5.8 0 1 0 0 11.6A5.8 5.8 0 0 0 8 2.2M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1",
		clipRule: "evenodd"
	})), _path2$301 || (_path2$301 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M8.6 3.8a.6.6 0 0 0-1.2 0v4.269a.6.6 0 0 0 .176.424l2.96 2.96a.6.6 0 0 0 .848-.848L8.66 7.879a.2.2 0 0 1-.059-.142z"
	})));
};

//#endregion
//#region src/Icon/icons/Cloud.svg
var _path$415;
var _path2$300;
function _extends$429() {
	return _extends$429 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$429.apply(null, arguments);
}
var SvgCloud = function SvgCloud(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$429({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$415 || (_path$415 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M12.463 6.941a6.001 6.001 0 0 1-10.367.974c-.284.42-.454.936-.472 1.48 0 1.656 1.32 3 2.976 3h6.8a2.98 2.98 0 0 0 2.976-3c-.039-1.197-.816-2.257-1.913-2.454",
		opacity: .25
	})), _path2$300 || (_path2$300 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M10.083 3.388c-.833-.828-1.965-1.383-3.28-1.383-2.352 0-4.039 1.686-4.635 3.705C.819 6.426.033 7.94.001 9.395H0v.094a4.6 4.6 0 0 0 4.6 4.506h6.8A4.6 4.6 0 0 0 16 9.49v-.094h-.001c-.034-1.533-.902-3.128-2.385-3.79-.691-1.224-1.93-2.173-3.531-2.217m4.293 6.007c-.039-1.203-.825-2.269-1.932-2.456-.373-1.099-1.315-1.93-2.478-1.93q-.299 0-.58.072c-.583-.869-1.511-1.454-2.582-1.454-1.728 0-3.061 1.496-3.231 3.309-1.116.18-1.91 1.25-1.949 2.46 0 1.656 1.32 3 2.976 3h6.8a2.98 2.98 0 0 0 2.976-3",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/CloudCheckmark.svg
var _g$90;
var _path$414;
var _path2$299;
function _extends$428() {
	return _extends$428 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$428.apply(null, arguments);
}
var SvgCloudCheckmark = function SvgCloudCheckmark(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$428({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$90 || (_g$90 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M12 8a4 4 0 1 1 0 8 4 4 0 0 1 0-8M2.096 7.915A6 6 0 0 0 7 10.457h.032a5.2 5.2 0 0 0-.216 1.938H4.6a2.98 2.98 0 0 1-2.976-3c.018-.544.188-1.06.472-1.48" }))), _path$414 || (_path$414 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M6.804 2.005c1.314 0 2.446.555 3.279 1.384 1.6.044 2.84.992 3.531 2.215 1.214.543 2.015 1.71 2.284 2.957a5.19 5.19 0 0 0-3.5-1.746c-.4-1.036-1.313-1.806-2.431-1.806q-.3 0-.58.072c-.584-.869-1.513-1.454-2.583-1.454-1.728 0-3.061 1.496-3.232 3.309-1.115.179-1.909 1.25-1.948 2.46 0 1.656 1.319 3 2.976 3h2.216c.043.562.173 1.1.38 1.6H4.6C2.09 13.994.05 11.985 0 9.487v-.092C.032 7.94.82 6.426 2.168 5.71c.596-2.019 2.283-3.705 4.636-3.705"
	})), _path2$299 || (_path2$299 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M13.646 10.194a.596.596 0 0 1 .842.842l-2.77 2.77a.6.6 0 0 1-.428.174.6.6 0 0 1-.429-.174l-1.35-1.35a.596.596 0 1 1 .844-.842l.793.795a.2.2 0 0 0 .284 0z"
	})));
};

//#endregion
//#region src/Icon/icons/CloudCross.svg
var _g$89;
var _path$413;
var _path2$298;
function _extends$427() {
	return _extends$427 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$427.apply(null, arguments);
}
var SvgCloudCross = function SvgCloudCross(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$427({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$89 || (_g$89 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M2.096 7.915A6 6 0 0 0 7 10.457h.032a5.2 5.2 0 0 0-.216 1.938H4.6a2.98 2.98 0 0 1-2.976-3c.018-.544.188-1.06.472-1.48" }), /*#__PURE__*/ React.createElement("path", {
		fillRule: "evenodd",
		d: "M8 12a4 4 0 1 1 8 0 4 4 0 0 1-8 0",
		clipRule: "evenodd"
	}))), _path$413 || (_path$413 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M6.804 2.005c1.314 0 2.446.555 3.279 1.384 1.6.044 2.84.992 3.531 2.215 1.214.543 2.015 1.71 2.284 2.957a5.19 5.19 0 0 0-3.5-1.746c-.4-1.036-1.313-1.806-2.431-1.806q-.3 0-.58.072c-.584-.869-1.513-1.454-2.583-1.454-1.728 0-3.061 1.496-3.232 3.309-1.115.179-1.909 1.25-1.948 2.46 0 1.656 1.319 3 2.976 3h2.216c.043.562.173 1.1.38 1.6H4.6C2.09 13.994.05 11.985 0 9.487v-.092C.032 7.94.82 6.426 2.168 5.71c.596-2.019 2.283-3.705 4.636-3.705"
	})), _path2$298 || (_path2$298 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M9.927 10.78a.603.603 0 1 1 .853-.853l1.079 1.078a.2.2 0 0 0 .282 0l1.079-1.078a.603.603 0 0 1 .853.853l-1.078 1.079a.2.2 0 0 0 0 .282l1.078 1.079a.604.604 0 0 1-.853.853l-1.079-1.078a.2.2 0 0 0-.282 0l-1.079 1.078a.604.604 0 0 1-.853-.853l1.078-1.079a.2.2 0 0 0 0-.282z"
	})));
};

//#endregion
//#region src/Icon/icons/CloudDown.svg
var _g$88;
var _path$412;
var _path2$297;
function _extends$426() {
	return _extends$426 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$426.apply(null, arguments);
}
var SvgCloudDown = function SvgCloudDown(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$426({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$88 || (_g$88 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M2.096 7.915A6 6 0 0 0 7 10.457h.032a5.2 5.2 0 0 0-.216 1.938H4.6a2.98 2.98 0 0 1-2.976-3c.018-.544.188-1.06.472-1.48" }), /*#__PURE__*/ React.createElement("path", {
		fillRule: "evenodd",
		d: "M8 12a4 4 0 1 1 8 0 4 4 0 0 1-8 0",
		clipRule: "evenodd"
	}))), _path$412 || (_path$412 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M6.804 2.005c1.314 0 2.446.555 3.279 1.384 1.6.044 2.84.992 3.531 2.215 1.214.543 2.015 1.71 2.284 2.957a5.19 5.19 0 0 0-3.5-1.746c-.4-1.036-1.313-1.806-2.431-1.806q-.3 0-.58.072c-.584-.869-1.513-1.454-2.583-1.454-1.728 0-3.061 1.496-3.232 3.309-1.115.179-1.909 1.25-1.948 2.46 0 1.656 1.319 3 2.976 3h2.216c.043.562.173 1.1.38 1.6H4.6C2.09 13.994.05 11.985 0 9.487v-.092C.032 7.94.82 6.426 2.168 5.71c.596-2.019 2.283-3.705 4.636-3.705"
	})), _path2$297 || (_path2$297 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M12.604 9.705c0-.318-.289-.545-.604-.545s-.604.227-.605.545v3.304l-.873-.761a.654.654 0 0 0-.84 0 .51.51 0 0 0 0 .783l1.88 1.64a.64.64 0 0 0 .438.169c.17 0 .326-.063.437-.17l1.881-1.639a.51.51 0 0 0 0-.783.654.654 0 0 0-.84 0l-.874.762z"
	})));
};

//#endregion
//#region src/Icon/icons/Cloudflare.svg
var _path$411;
var _path2$296;
function _extends$425() {
	return _extends$425 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$425.apply(null, arguments);
}
var SvgCloudflare$1 = function SvgCloudflare(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$425({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$411 || (_path$411 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M12.847 7.436h-.166c-.034 0-.067.033-.1.066l-.232.797c-.1.332-.067.664.1.863.165.199.398.332.696.365l1.229.066c.033 0 .066.034.1.034q.048.05 0 .1c-.034.066-.067.099-.134.099l-1.261.066c-.697.033-1.428.598-1.693 1.261l-.066.3c-.034.033 0 .099.066.099h4.382q.1 0 .1-.1c.066-.265.132-.564.132-.863a3.174 3.174 0 0 0-3.153-3.153",
		opacity: .5
	})), _path2$296 || (_path2$296 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M11.02 11.154c.1-.332.067-.664-.099-.864a1.03 1.03 0 0 0-.697-.365L4.448 9.86c-.033 0-.066-.033-.1-.033q-.05-.05 0-.1c.034-.066.067-.1.133-.1l5.81-.066c.697-.033 1.427-.597 1.692-1.261l.332-.863c0-.034.034-.067 0-.1a3.774 3.774 0 0 0-3.684-2.954 3.77 3.77 0 0 0-3.585 2.556 1.8 1.8 0 0 0-1.195-.332c-.797.066-1.428.73-1.527 1.527-.034.199 0 .398.033.597A2.424 2.424 0 0 0 0 11.153c0 .133 0 .233.033.366 0 .066.067.1.1.1h10.655c.067 0 .133-.034.133-.1z"
	})));
};

//#endregion
//#region src/Icon/icons/CloudPending.svg
var _g$87;
var _path$410;
var _path2$295;
function _extends$424() {
	return _extends$424 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$424.apply(null, arguments);
}
var SvgCloudPending = function SvgCloudPending(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$424({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$87 || (_g$87 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M2.096 7.915A6 6 0 0 0 7 10.457h.032a5.2 5.2 0 0 0-.216 1.938H4.6a2.98 2.98 0 0 1-2.976-3c.018-.544.188-1.06.472-1.48" }), /*#__PURE__*/ React.createElement("path", {
		fillRule: "evenodd",
		d: "M8 12a4 4 0 1 1 8 0 4 4 0 0 1-8 0",
		clipRule: "evenodd"
	}))), _path$410 || (_path$410 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M6.804 2.005c1.314 0 2.446.555 3.279 1.384 1.6.044 2.84.992 3.531 2.215 1.214.543 2.015 1.71 2.284 2.957a5.19 5.19 0 0 0-3.5-1.746c-.4-1.036-1.313-1.806-2.431-1.806q-.3 0-.58.072c-.584-.869-1.513-1.454-2.583-1.454-1.728 0-3.061 1.496-3.232 3.309-1.115.179-1.909 1.25-1.948 2.46 0 1.656 1.319 3 2.976 3h2.216c.043.562.173 1.1.38 1.6H4.6C2.09 13.994.05 11.985 0 9.487v-.092C.032 7.94.82 6.426 2.168 5.71c.596-2.019 2.283-3.705 4.636-3.705"
	})), _path2$295 || (_path2$295 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M9.778 11.105c.495 0 .898.4.898.895a.896.896 0 0 1-.898.895A.896.896 0 0 1 8.88 12c0-.495.402-.895.898-.895m2.222 0c.495 0 .898.4.898.895a.896.896 0 0 1-.898.895.896.896 0 0 1-.898-.895c0-.495.403-.895.898-.895m2.222 0c.496 0 .898.4.898.895a.896.896 0 0 1-.898.895.896.896 0 0 1-.897-.895c0-.495.402-.895.897-.895",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/CloudUp.svg
var _g$86;
var _path$409;
var _path2$294;
function _extends$423() {
	return _extends$423 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$423.apply(null, arguments);
}
var SvgCloudUp = function SvgCloudUp(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$423({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$86 || (_g$86 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M2.096 7.915A6 6 0 0 0 7 10.457h.032a5.2 5.2 0 0 0-.216 1.938H4.6a2.98 2.98 0 0 1-2.976-3c.018-.544.188-1.06.472-1.48" }), /*#__PURE__*/ React.createElement("path", {
		fillRule: "evenodd",
		d: "M8 12a4 4 0 1 1 8 0 4 4 0 0 1-8 0",
		clipRule: "evenodd"
	}))), _path$409 || (_path$409 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M6.804 2.005c1.314 0 2.446.555 3.279 1.384 1.6.044 2.84.992 3.531 2.215 1.214.543 2.015 1.71 2.284 2.957a5.19 5.19 0 0 0-3.5-1.746c-.4-1.036-1.313-1.806-2.431-1.806q-.3 0-.58.072c-.584-.869-1.513-1.454-2.583-1.454-1.728 0-3.061 1.496-3.232 3.309-1.115.179-1.909 1.25-1.948 2.46 0 1.656 1.319 3 2.976 3h2.216c.043.562.173 1.1.38 1.6H4.6C2.09 13.994.05 11.985 0 9.487v-.092C.032 7.94.82 6.426 2.168 5.71c.596-2.019 2.283-3.705 4.636-3.705"
	})), _path2$294 || (_path2$294 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M12.604 14.295c0 .318-.289.545-.604.545s-.604-.227-.605-.545V10.99l-.873.761a.654.654 0 0 1-.84 0 .51.51 0 0 1 0-.783l1.88-1.64A.64.64 0 0 1 12 9.16c.17 0 .326.063.437.17l1.881 1.639a.51.51 0 0 1 0 .783.654.654 0 0 1-.84 0l-.874-.762z"
	})));
};

//#endregion
//#region src/Icon/icons/Code.svg
var _path$408;
var _path2$293;
function _extends$422() {
	return _extends$422 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$422.apply(null, arguments);
}
var SvgCode = function SvgCode(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$422({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$408 || (_path$408 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M.207 8.497a.7.7 0 0 1 0-.994L3.53 4.205a.71.71 0 0 1 .997 0 .7.7 0 0 1 0 .994L1.732 7.974a.036.036 0 0 0 0 .052L4.527 10.8a.7.7 0 0 1 0 .995.71.71 0 0 1-.997 0zM15.793 8.497a.7.7 0 0 0 0-.994L12.47 4.205a.71.71 0 0 0-.997 0 .7.7 0 0 0 0 .994l2.795 2.775a.036.036 0 0 1 0 .052L11.473 10.8a.7.7 0 0 0 0 .995.71.71 0 0 0 .997 0z",
		clipRule: "evenodd"
	})), _path2$293 || (_path2$293 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M9.155 2.78a.7.7 0 0 1 1.316.479l-3.626 9.96a.7.7 0 0 1-1.315-.478z"
	})));
};

//#endregion
//#region src/Icon/icons/Cog.svg
var _path$407;
var _path2$292;
function _extends$421() {
	return _extends$421 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$421.apply(null, arguments);
}
var SvgCog = function SvgCog(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$421({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$407 || (_path$407 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M10.4 8a2.4 2.4 0 1 1-4.8 0 2.4 2.4 0 0 1 4.8 0M8 9.2a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4",
		clipRule: "evenodd"
	})), _path2$292 || (_path2$292 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M3.376 5.296v.001q0 .001-.003.008l-.005.007h-.002l-.005.001-.059.008-.013.002-.01.001c-3.039.45-3.039 4.903 0 5.352l.01.001.013.002.064.009h.002l.005.007.003.007v.002l-.002.005-.023.054-.005.013-.003.01c-1.135 2.88 2.689 5.107 4.594 2.676l.01-.014.007-.008.033-.044.004-.004v-.001L8 13.39l.008.001h.001l.002.002.002.003q.016.023.033.044l.006.008.011.014c1.905 2.43 5.73.203 4.594-2.677l-.003-.009-.005-.013-.023-.054-.002-.005v-.001q0-.001.003-.008l.005-.007h.004l.003-.001.019-.002.053-.008.01-.001c3.039-.45 3.039-4.903 0-5.352l-.01-.001-.013-.002-.059-.008h-.005l-.002-.001-.005-.007-.003-.008v-.001l.001-.003.001-.002.023-.054.005-.013.003-.01c1.135-2.88-2.689-5.107-4.594-2.676l-.01.014-.007.008-.033.044-.001.002-.003.002v.001L8 2.61h-.007l-.001-.001H7.99l-.004-.005-.03-.04-.006-.008-.007-.008-.007-.01c-1.905-2.43-5.73-.203-4.594 2.677l.003.01.005.012zm1.74-2.333c.576-.335 1.371-.302 1.885.389.5.671 1.498.671 1.998 0 .514-.69 1.31-.724 1.885-.389s.943 1.046.608 1.839a1.262 1.262 0 0 0 1 1.747c1.7.208 1.7 2.694 0 2.902-.826.1-1.327.973-1 1.747.335.793-.033 1.504-.608 1.839-.576.335-1.371.302-1.885-.389a1.243 1.243 0 0 0-1.998 0c-.514.69-1.31.724-1.885.389s-.943-1.046-.608-1.839a1.262 1.262 0 0 0-1-1.747c-1.7-.208-1.7-2.694 0-2.902a1.262 1.262 0 0 0 1-1.747c-.335-.793.033-1.504.608-1.839",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Columns.svg
var _path$406;
var _path2$291;
function _extends$420() {
	return _extends$420 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$420.apply(null, arguments);
}
var SvgColumns = function SvgColumns(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$420({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$406 || (_path$406 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M3.2 3.2a1 1 0 0 0-1 1v1.198h3.198V3.2zm10.6 1a1 1 0 0 0-1-1h-2.202v2.198L13.8 5.4zm-4.402-1v2.198h-2.8V3.2z",
		clipRule: "evenodd",
		opacity: .25
	})), _path2$291 || (_path2$291 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M12.8 2H3.2A2.2 2.2 0 0 0 1 4.2v7.6A2.2 2.2 0 0 0 3.2 14h9.6a2.2 2.2 0 0 0 2.2-2.2V4.2A2.2 2.2 0 0 0 12.8 2M3.2 3.2a1 1 0 0 0-1 1v1.198h3.198V3.2zm9.6 9.6a1 1 0 0 0 1-1V6.598h-3.202V12.8zm1-8.6a1 1 0 0 0-1-1h-2.202v2.198L13.8 5.4zM2.204 11.887a1 1 0 0 0 .996.913h2.198V6.598H2.2V11.8q0 .044.004.087m4.394.913h2.8V6.598h-2.8zm2.8-9.6v2.198h-2.8V3.2z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Command.svg
var _path$405;
function _extends$419() {
	return _extends$419 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$419.apply(null, arguments);
}
var SvgCommand$1 = function SvgCommand(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$419({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$405 || (_path$405 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M6.022 2.36c0-.212-.18-.378-.39-.354q-.135.014-.269.032c-.453.06-.906.146-1.305.27-.377.117-.806.298-1.115.608-.293.293-.477.679-.603 1.044-.13.377-.22.804-.285 1.241-.13.875-.168 1.88-.168 2.799 0 .918.038 1.924.168 2.799.065.437.156.864.285 1.24.126.366.31.752.603 1.045.31.31.738.491 1.115.609.399.123.852.208 1.305.268q.135.018.269.033c.21.024.39-.142.39-.353v-.943c0-.185-.14-.339-.324-.361l-.117-.015a6.5 6.5 0 0 1-1.033-.21 2 2 0 0 1-.32-.124 1 1 0 0 1-.107-.066l-.005-.004-.002-.002c-.038-.038-.12-.155-.21-.414a5.4 5.4 0 0 1-.213-.946c-.112-.758-.15-1.671-.15-2.556s.038-1.798.15-2.557c.057-.379.128-.698.213-.945.09-.259.172-.376.21-.414l.002-.002.005-.004.02-.016a1 1 0 0 1 .086-.05q.116-.06.321-.125a6.5 6.5 0 0 1 1.15-.224.37.37 0 0 0 .324-.361zm3.956 10.342c0-.185.14-.34.325-.362l.147-.018a6.5 6.5 0 0 0 1.033-.21q.205-.064.32-.124a1 1 0 0 0 .107-.066l.005-.004.002-.002c.036-.036.116-.15.202-.408a5.4 5.4 0 0 0 .204-.944c.105-.76.136-1.674.136-2.564s-.03-1.804-.136-2.564a5.4 5.4 0 0 0-.204-.945c-.086-.257-.167-.372-.203-.408l-.006-.005-.021-.016a1 1 0 0 0-.085-.05 2 2 0 0 0-.321-.125 6.5 6.5 0 0 0-1.033-.209l-.147-.018a.37.37 0 0 1-.325-.362v-.942c0-.21.18-.377.39-.354l.3.036c.452.06.906.146 1.305.27.377.117.806.298 1.115.608.295.295.477.684.6 1.05.126.378.213.806.273 1.243.121.874.152 1.878.152 2.791s-.03 1.917-.152 2.791c-.06.437-.147.865-.273 1.242-.123.367-.305.756-.6 1.051-.31.31-.738.491-1.115.609a8 8 0 0 1-1.306.268l-.3.037a.353.353 0 0 1-.39-.354z"
	})));
};

//#endregion
//#region src/Icon/icons/Company.svg
var _path$404;
var _path2$290;
function _extends$418() {
	return _extends$418 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$418.apply(null, arguments);
}
var SvgCompany = function SvgCompany(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$418({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$404 || (_path$404 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M5.842 2.023a.6.6 0 0 1 .609-.102l5.968 2.339a.6.6 0 0 1 .381.559V14.3h-2.3v-3.1a.8.8 0 0 0-.8-.8H6.3a.8.8 0 0 0-.8.8v3.1H3.2V4.554a.6.6 0 0 1 .21-.457z",
		clipRule: "evenodd",
		opacity: .25
	})), _path2$290 || (_path2$290 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M2 14.3V4.554a1.8 1.8 0 0 1 .632-1.37L5.064 1.11A1.8 1.8 0 0 1 6.888.804l5.969 2.339A1.8 1.8 0 0 1 14 4.819V14.3h1.4a.6.6 0 1 1 0 1.2h-5.1a1 1 0 0 1-1-1v-2.9H6.7v2.9a1 1 0 0 1-1 1H.6a.6.6 0 1 1 0-1.2zM5.842 2.023a.6.6 0 0 1 .609-.102l5.968 2.339a.6.6 0 0 1 .381.559V14.3h-2.3v-3.1a.8.8 0 0 0-.8-.8H6.3a.8.8 0 0 0-.8.8v3.1H3.2V4.554a.6.6 0 0 1 .21-.457z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/CompanyCam.svg
var _path$403;
function _extends$417() {
	return _extends$417 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$417.apply(null, arguments);
}
var SvgCompanyCam = function SvgCompanyCam(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$417({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$403 || (_path$403 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M9.478 1.538c.205 0 .407.045.592.13l.18.097.163.123q.154.135.265.307l.097.18.367.812a.14.14 0 0 0 .128.082h2.102a1.427 1.427 0 0 1 1.423 1.424v1.073a.642.642 0 0 1-.284.535l-.112.06a.642.642 0 0 1-.887-.595V4.694L13.5 4.64a.143.143 0 0 0-.13-.087H11.27a1.43 1.43 0 0 1-1.298-.837l-.366-.812a.14.14 0 0 0-.052-.06.14.14 0 0 0-.077-.023H6.504l-.04.006a.14.14 0 0 0-.088.074l-.395.836a1.43 1.43 0 0 1-1.286.816H2.624a.143.143 0 0 0-.14.14v1.878h1.954a3.9 3.9 0 0 1 .671-1.053l.14-.148a3.88 3.88 0 0 1 4.33-.808c.498.222.942.547 1.306.953l.12.14q.342.422.555.916h2.593a.64.64 0 0 1 .647.642v4.95a1.425 1.425 0 0 1-1.423 1.423H8.94l-.41.598a.64.64 0 0 1-.533.277h-.002v.001a.64.64 0 0 1-.478-.216l-.048-.062-.41-.598H2.627a1.426 1.426 0 0 1-1.424-1.422V8.846a.643.643 0 0 1 .997-.532l.099.08c.12.119.188.282.188.452v3.318a.14.14 0 0 0 .141.14h3.552L4.8 10.293a3.87 3.87 0 0 1-.672-2.438H1.842a.645.645 0 0 1-.642-.644v-2.52l.007-.14A1.426 1.426 0 0 1 2.623 3.27h2.071l.04-.006a.1.1 0 0 0 .036-.015.14.14 0 0 0 .051-.059l.394-.836a1.43 1.43 0 0 1 1.287-.815zm-1.48 3.97a2.6 2.6 0 0 0-1.74.672l-.192.195a2.59 2.59 0 0 0-.208 3.194l2.14 3.114 2.137-3.114.116-.184a2.59 2.59 0 0 0-.322-3.01 2.6 2.6 0 0 0-1.932-.867m3.87 2.348a3.87 3.87 0 0 1-.67 2.435L9.82 12.302l3.557.001.054-.01a.142.142 0 0 0 .087-.129V7.856zM7.975 6.053a1.956 1.956 0 0 0-.748 3.758 1.95 1.95 0 0 0 1.496 0 2 2 0 0 0 .632-.425.343.343 0 0 0-.24-.583.34.34 0 0 0-.242.1 1.272 1.272 0 0 1-2.167-.898 1.27 1.27 0 0 1 2.167-.897.344.344 0 0 0 .482 0 .344.344 0 0 0 0-.483 1.96 1.96 0 0 0-1.38-.572"
	})));
};

//#endregion
//#region src/Icon/icons/Compass.svg
var _g$85;
var _path$402;
var _path2$289;
function _extends$416() {
	return _extends$416 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$416.apply(null, arguments);
}
var SvgCompass = function SvgCompass(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$416({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$85 || (_g$85 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .5
	}, /*#__PURE__*/ React.createElement("path", { d: "M8 15a7 7 0 0 0 6.756-8.84c-.072-.263-.421-.266-.519-.01l-1.52 4-.03.059a5.6 5.6 0 0 1-2.609 2.571l-.062.03-3.932 1.406c-.26.093-.262.444.002.52.608.172 1.25.264 1.914.264M1.234 9.802c.071.267.425.267.518.006l1.35-3.756.03-.064a5.6 5.6 0 0 1 2.593-2.607l.059-.028 4.164-1.56c.256-.096.257-.444-.005-.52a7 7 0 0 0-8.709 8.528" }))), _path$402 || (_path$402 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "m11.896 9.776-.024.048a4.63 4.63 0 0 1-2.155 2.125l-.052.025-4.13 1.477c-1.918.855-3.888-1.12-3.027-3.035L3.954 6.39l.025-.053A4.63 4.63 0 0 1 6.12 4.185l.049-.024 4.274-1.601c1.933-.887 3.933 1.124 3.036 3.053zm.543-4.609c.493-.997-.557-2.052-1.556-1.565l-4.267 1.6a3.5 3.5 0 0 0-1.618 1.626l-1.443 4.017c-.477.992.56 2.031 1.553 1.558l4.122-1.475a3.5 3.5 0 0 0 1.628-1.605z",
		clipRule: "evenodd"
	})), _path2$289 || (_path2$289 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M9.2 8a1.2 1.2 0 1 1-2.4 0 1.2 1.2 0 0 1 2.4 0"
	})));
};

//#endregion
//#region src/Icon/icons/Connect.svg
var _path$401;
var _path2$288;
function _extends$415() {
	return _extends$415 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$415.apply(null, arguments);
}
var SvgConnect$1 = function SvgConnect(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$415({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$401 || (_path$401 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M11.999 11.834h.877c.303 0 .549-.25.549-.56v-1.181c0-.31-.246-.56-.549-.56H12a.277.277 0 0 1-.274-.28V7.628c0-.432-.459-.7-.824-.484L5.74 10.2a.566.566 0 0 0 0 .968l5.16 3.056a.549.549 0 0 0 .824-.485v-1.625c0-.154.122-.28.274-.28",
		opacity: .25
	})), _path2$288 || (_path2$288 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "m11.9 9.533-.053-.006a.28.28 0 0 1-.209-.218l-.005-.056V7.628c0-.432-.447-.701-.803-.485L5.796 10.2a.574.574 0 0 0 0 .969l5.033 3.055c.334.204.747-.02.798-.405l.005-.079v-1.625c0-.135.092-.248.214-.274l.053-.005h.857l.107-.012a.555.555 0 0 0 .427-.549v-1.181a.554.554 0 0 0-.427-.55l-.107-.01zM3.196 2.261C3.196.984 4.508.089 5.656.682l.111.062L10.8 3.8c.757.46 1 1.37.734 2.124.71.2 1.27.87 1.27 1.704v.707c.94.026 1.658.824 1.658 1.758v1.181c0 .934-.717 1.731-1.659 1.757v.708c0 1.318-1.397 2.229-2.57 1.517L5.201 12.2c-.758-.46-1.002-1.372-.736-2.125a1.764 1.764 0 0 1-1.269-1.703v-.708c-.94-.026-1.658-.824-1.658-1.757V4.725c0-.933.717-1.731 1.658-1.757zm1.171 1.625-.006.056a.27.27 0 0 1-.207.218l-.055.006h-.855l-.109.01a.555.555 0 0 0-.426.55v1.181c0 .27.183.497.426.549l.109.012h.855c.148 0 .268.124.268.279v1.625c0 .431.446.7.803.484l5.033-3.055a.574.574 0 0 0 0-.97L5.17 1.777c-.357-.216-.803.053-.803.485z"
	})));
};

//#endregion
//#region src/Icon/icons/Connection.svg
var _path$400;
var _path2$287;
var _path3$156;
var _path4$54;
function _extends$414() {
	return _extends$414 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$414.apply(null, arguments);
}
var SvgConnection = function SvgConnection(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$414({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$400 || (_path$400 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "m12.104 6.089-.002-.002.205-.563A3.2 3.2 0 0 0 6.43 3.01l1.138.414a2 2 0 0 1 3.61 1.688L9.521 9.668l1.128.41 1.042-2.863.003.001z"
	})), _path2$287 || (_path2$287 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "m12.993 6.433-.414 1.139a2 2 0 0 1-1.546 3.654l-.002.005-4.699-1.71-.41 1.128 2.863 1.042-.001.003 1.127.41.002-.002.563.205a3.2 3.2 0 0 0 2.517-5.874"
	})), _path3$156 || (_path3$156 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "m9.567 12.993-1.139-.414a2 2 0 0 1-3.657-1.537l-.006-.002.054-.149.002-.004 1.658-4.555-1.128-.41-.82 2.255.002.002-.886 2.433a3.2 3.2 0 0 0 5.92 2.381"
	})), _path4$54 || (_path4$54 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "m3.012 9.57.415-1.139a2 2 0 0 1 1.54-3.657l.002-.005 4.699 1.71.41-1.128-2.246-.818v.002l-2.41-.877a3.2 3.2 0 0 0-2.41 5.912"
	})));
};

//#endregion
//#region src/Icon/icons/ConnectionConnected.svg
var _path$399;
var _path2$286;
var _path3$155;
var _path4$53;
var _path5$22;
function _extends$413() {
	return _extends$413 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$413.apply(null, arguments);
}
var SvgConnectionConnected = function SvgConnectionConnected(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$413({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$399 || (_path$399 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8 12a4 4 0 1 1 8 0 4 4 0 0 1-8 0",
		clipRule: "evenodd",
		opacity: .2
	})), _path2$286 || (_path2$286 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "m12.102 6.087.002.002-.26.713a5.2 5.2 0 0 0-1.36.223l.695-1.912a2 2 0 0 0-3.61-1.688l-1.138-.414a3.2 3.2 0 0 1 5.876 2.513zM7.26 9.859l-.928-.338-.41 1.128.973.354q.118-.601.365-1.144"
	})), _path3$155 || (_path3$155 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M7.033 13.543q.184.594.499 1.118a3.2 3.2 0 0 1-3.884-4.05l.885-2.433H4.53l.821-2.256 1.128.41-1.658 4.555-.002.004-.054.149.006.002a2 2 0 0 0 2.262 2.501M13.977 7.189a5.2 5.2 0 0 0-1.142-.322l.158-.434c.383.19.715.449.984.756"
	})), _path4$53 || (_path4$53 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M3.427 8.431 3.012 9.57a3.2 3.2 0 0 1 2.41-5.912l2.41.877v-.002l2.246.818-.41 1.128-4.699-1.71-.002.005a2 2 0 0 0-1.54 3.657"
	})), _path5$22 || (_path5$22 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M14.488 10.194a.596.596 0 0 1 0 .842l-2.769 2.77a.6.6 0 0 1-.429.174.6.6 0 0 1-.429-.174l-1.35-1.35a.595.595 0 1 1 .843-.842l.795.795a.2.2 0 0 0 .283 0l2.214-2.215a.595.595 0 0 1 .842 0m-3.197 3.786h-.002z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/ConnectionDisassociated.svg
var _path$398;
var _path2$285;
var _path3$154;
var _path4$52;
var _path5$21;
function _extends$412() {
	return _extends$412 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$412.apply(null, arguments);
}
var SvgConnectionDisassociated = function SvgConnectionDisassociated(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$412({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$398 || (_path$398 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8 12a4 4 0 1 1 8 0 4 4 0 0 1-8 0",
		clipRule: "evenodd",
		opacity: .2
	})), _path2$285 || (_path2$285 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "m12.102 6.087.002.002-.26.713a5.2 5.2 0 0 0-1.36.223l.695-1.912a2 2 0 0 0-3.61-1.688l-1.138-.414a3.2 3.2 0 0 1 5.876 2.513zM7.26 9.859l-.928-.338-.41 1.128.973.354q.118-.601.365-1.144"
	})), _path3$154 || (_path3$154 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M7.033 13.543q.184.594.499 1.118a3.2 3.2 0 0 1-3.884-4.05l.885-2.433H4.53l.821-2.256 1.128.41-1.658 4.555-.002.004-.054.149.006.002a2 2 0 0 0 2.262 2.501M13.977 7.189a5.2 5.2 0 0 0-1.142-.322l.158-.434c.383.19.715.449.984.756"
	})), _path4$52 || (_path4$52 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M3.427 8.431 3.012 9.57a3.2 3.2 0 0 1 2.41-5.912l2.41.877v-.002l2.246.818-.41 1.128-4.699-1.71-.002.005a2 2 0 0 0-1.54 3.657"
	})), _path5$21 || (_path5$21 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M9.778 11.105c.495 0 .898.4.898.895a.896.896 0 0 1-.898.895A.896.896 0 0 1 8.88 12c0-.495.402-.895.898-.895m2.222 0c.495 0 .898.4.898.895a.896.896 0 0 1-.898.895.896.896 0 0 1-.898-.895c0-.495.403-.895.898-.895m2.222 0c.496 0 .898.4.898.895a.896.896 0 0 1-.898.895.896.896 0 0 1-.897-.895c0-.495.402-.895.897-.895",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/ConnectionFailed.svg
var _path$397;
var _path2$284;
var _path3$153;
var _path4$51;
function _extends$411() {
	return _extends$411 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$411.apply(null, arguments);
}
var SvgConnectionFailed = function SvgConnectionFailed(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$411({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$397 || (_path$397 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8 12a4 4 0 1 1 8 0 4 4 0 0 1-8 0",
		clipRule: "evenodd",
		opacity: .2
	})), _path2$284 || (_path2$284 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "m12.102 6.087.002.002-.26.713a5.2 5.2 0 0 0-1.36.223l.695-1.912a2 2 0 0 0-3.61-1.688l-1.138-.414a3.2 3.2 0 0 1 5.876 2.513zM7.26 9.859l-.928-.338-.41 1.128.973.354q.118-.601.365-1.144"
	})), _path3$153 || (_path3$153 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M7.033 13.543q.184.594.499 1.118a3.2 3.2 0 0 1-3.884-4.05l.885-2.433H4.53l.821-2.256 1.128.41-1.658 4.555-.002.004-.054.149.006.002a2 2 0 0 0 2.262 2.501M13.977 7.189a5.2 5.2 0 0 0-1.142-.322l.158-.434c.383.19.715.449.984.756"
	})), _path4$51 || (_path4$51 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M3.427 8.431 3.012 9.57a3.2 3.2 0 0 1 2.41-5.912l2.41.877v-.002l2.246.818-.41 1.128-4.699-1.71-.002.005a2 2 0 0 0-1.54 3.657M9.927 10.78a.603.603 0 1 1 .853-.853l1.079 1.078a.2.2 0 0 0 .282 0l1.079-1.078a.603.603 0 0 1 .853.853l-1.078 1.079a.2.2 0 0 0 0 .282l1.078 1.079a.604.604 0 0 1-.853.853l-1.079-1.078a.2.2 0 0 0-.282 0l-1.079 1.078a.603.603 0 0 1-.853-.853l1.078-1.079a.2.2 0 0 0 0-.282z"
	})));
};

//#endregion
//#region src/Icon/icons/Console.svg
var _path$396;
var _path2$283;
var _path3$152;
var _path4$50;
var _path5$20;
function _extends$410() {
	return _extends$410 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$410.apply(null, arguments);
}
var SvgConsole = function SvgConsole(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$410({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$396 || (_path$396 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M3.4 3.2a1.2 1.2 0 0 0-1.2 1.2V5h11.6v-.6a1.2 1.2 0 0 0-1.2-1.2z",
		opacity: .25
	})), _path2$283 || (_path2$283 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M6.489 9.305a.6.6 0 0 0-.165-.309L4.497 7.183a.6.6 0 0 0-.845 0 .595.595 0 0 0 0 .845l1.402 1.39-1.402 1.392a.595.595 0 0 0 0 .845.6.6 0 0 0 .845 0L6.324 9.84a.6.6 0 0 0 .165-.536",
		clipRule: "evenodd"
	})), _path3$152 || (_path3$152 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M6.875 11.084a.6.6 0 0 1 .6-.6h4.519a.6.6 0 1 1 0 1.2H7.475a.6.6 0 0 1-.6-.6"
	})), _path4$50 || (_path4$50 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M3.4 2h9.2A2.4 2.4 0 0 1 15 4.4v7.2a2.4 2.4 0 0 1-2.4 2.4H3.4A2.4 2.4 0 0 1 1 11.6V4.4A2.4 2.4 0 0 1 3.4 2m0 1.2a1.2 1.2 0 0 0-1.2 1.2v7.2a1.2 1.2 0 0 0 1.2 1.2h9.2a1.2 1.2 0 0 0 1.2-1.2V4.4a1.2 1.2 0 0 0-1.2-1.2z",
		clipRule: "evenodd"
	})), _path5$20 || (_path5$20 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M2.2 5h11.6v1.2H2.2z"
	})));
};

//#endregion
//#region src/Icon/icons/Context.svg
var _g$84;
var _g2$12;
var _path$395;
function _extends$409() {
	return _extends$409 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$409.apply(null, arguments);
}
var SvgContext = function SvgContext(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$409({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$84 || (_g$84 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M5.201 13.2c.228.526.6.974 1.069 1.292a.4.4 0 0 1-.39.308H1.4a.4.4 0 0 1-.4-.4v-.8c0-.22.18-.4.4-.4zM14.6 13.2c.22 0 .4.18.4.4v.8a.4.4 0 0 1-.4.4h-1.746a3 3 0 0 0 1.655-1.6zM3.365 10.2c.221 0 .4.18.4.4v.8a.4.4 0 0 1-.4.4H1.4a.4.4 0 0 1-.4-.4v-.8c0-.22.18-.4.4-.4zM14.755 10.23c.144.06.245.204.245.37v.8a.4.4 0 0 1-.245.369zM1.256 7.228c.319.716.91 1.283 1.642 1.572H1.4a.4.4 0 0 1-.4-.4v-.8a.4.4 0 0 1 .256-.372M14.6 7.2c.22 0 .4.18.4.4v.8a.4.4 0 0 1-.4.4h-.092a3 3 0 0 0-1.657-1.6zM14.598 4.2c.22 0 .4.18.4.4v.8a.4.4 0 0 1-.4.4h-1.92a.4.4 0 0 1-.4-.4v-.8a.4.4 0 0 1 .4-.4zM10.797 4.22a.4.4 0 0 1 .281.38v.8c0 .18-.119.328-.281.38zM14.6 1.2c.22 0 .4.18.4.4v.8a.4.4 0 0 1-.4.4H13.28a.4.4 0 0 1-.4-.4v-.8c0-.22.18-.4.4-.4zM11.281 1.2a.4.4 0 0 1 .4.4v.8a.4.4 0 0 1-.4.4h-.731a3 3 0 0 0-1.517-1.541.4.4 0 0 1 .207-.059zM2.896 1.2a3 3 0 0 0-1.64 1.571.4.4 0 0 1-.256-.37v-.8c0-.221.18-.4.4-.4z" }))), _g2$12 || (_g2$12 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .5
	}, /*#__PURE__*/ React.createElement("path", { d: "M11.281 10.2a.4.4 0 0 1 .4.4v.8a.4.4 0 0 1-.4.4H8.428a.4.4 0 0 1-.4-.4v-.8a.4.4 0 0 1 .4-.4zM7.256 4.2c.22 0 .4.18.4.4v.8a.4.4 0 0 1-.4.4H4.49a.4.4 0 0 1-.4-.4v-.8a.4.4 0 0 1 .4-.4z" }))), _path$395 || (_path$395 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M7.797 2.19a1.8 1.8 0 0 1 1.8 1.8v2.02a1.8 1.8 0 0 1-1.8 1.8h-3.8a1.8 1.8 0 0 1-1.8-1.8V3.99a1.8 1.8 0 0 1 1.8-1.8zm-3.8 4.42a.6.6 0 0 1-.588-.48l-.012-.12V3.99a.6.6 0 0 1 .6-.6h3.8l.12.013a.6.6 0 0 1 .48.587v2.02l-.012.12a.6.6 0 0 1-.468.468l-.12.012zM11.755 8.191a1.8 1.8 0 0 1 1.8 1.8v2.02a1.8 1.8 0 0 1-1.8 1.8h-3.8a1.8 1.8 0 0 1-1.8-1.8V9.99a1.8 1.8 0 0 1 1.8-1.8zm-3.8 4.419a.6.6 0 0 1-.589-.48l-.011-.12V9.99a.6.6 0 0 1 .6-.599h3.8l.12.012a.6.6 0 0 1 .48.588v2.02l-.012.12a.6.6 0 0 1-.468.467l-.12.012z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Copy.svg
var _path$394;
var _path2$282;
function _extends$408() {
	return _extends$408 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$408.apply(null, arguments);
}
var SvgCopy = function SvgCopy(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$408({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$394 || (_path$394 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M9.485 4.085h1.23V3.8A2.89 2.89 0 0 0 7.825.91H3.8A2.89 2.89 0 0 0 .91 3.8v4.025a2.89 2.89 0 0 0 2.89 2.89h.285v-1.23H3.8a1.66 1.66 0 0 1-1.66-1.66V3.8c0-.917.743-1.66 1.66-1.66h4.025c.917 0 1.66.743 1.66 1.66z"
	})), _path2$282 || (_path2$282 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M12.2 5.285H8.175a2.89 2.89 0 0 0-2.89 2.89V12.2a2.89 2.89 0 0 0 2.89 2.89H12.2a2.89 2.89 0 0 0 2.89-2.89V8.175a2.89 2.89 0 0 0-2.89-2.89m-4.025 1.23a1.66 1.66 0 0 0-1.66 1.66V12.2c0 .917.743 1.66 1.66 1.66H12.2a1.66 1.66 0 0 0 1.66-1.66V8.175a1.66 1.66 0 0 0-1.66-1.66z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Cross.svg
var _path$393;
function _extends$407() {
	return _extends$407 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$407.apply(null, arguments);
}
var SvgCross = function SvgCross(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$407({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$393 || (_path$393 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M3.117 4.404a.91.91 0 1 1 1.287-1.287l3.172 3.172a.6.6 0 0 0 .848 0l3.172-3.172a.91.91 0 1 1 1.287 1.287L9.711 7.576a.6.6 0 0 0 0 .848l3.172 3.172a.91.91 0 1 1-1.287 1.287L8.424 9.711a.6.6 0 0 0-.848 0l-3.172 3.172a.91.91 0 0 1-1.287-1.287l3.172-3.172a.6.6 0 0 0 0-.848z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/CrossCircle.svg
var _path$392;
var _path2$281;
var _path3$151;
function _extends$406() {
	return _extends$406 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$406.apply(null, arguments);
}
var SvgCrossCircle = function SvgCrossCircle(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$406({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$392 || (_path$392 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M12.568 4.43a5.8 5.8 0 0 1-8.139 8.139l.06-.06c.757.35 1.683.216 2.307-.408L8 10.895l1.204 1.206a2.049 2.049 0 0 0 2.897-2.897L10.895 8l1.206-1.204c.624-.624.758-1.55.409-2.307z",
		opacity: .25
	})), _path2$281 || (_path2$281 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M4.748 5.947a.848.848 0 1 1 1.2-1.199l1.92 1.92a.19.19 0 0 0 .265 0l1.92-1.92a.848.848 0 1 1 1.199 1.2l-1.92 1.92a.19.19 0 0 0 0 .265l1.92 1.92a.848.848 0 1 1-1.2 1.199l-1.92-1.92a.19.19 0 0 0-.265 0l-1.92 1.92a.848.848 0 0 1-1.199-1.2l1.92-1.92a.19.19 0 0 0 0-.265z",
		clipRule: "evenodd"
	})), _path3$151 || (_path3$151 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14M8 2.2a5.8 5.8 0 1 1 0 11.6A5.8 5.8 0 0 1 8 2.2",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Crown.svg
var _path$391;
var _path2$280;
var _path3$150;
function _extends$405() {
	return _extends$405 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$405.apply(null, arguments);
}
var SvgCrown = function SvgCrown(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$405({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$391 || (_path$391 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M2.52 13.532a.4.4 0 0 1-.32-.391v-2h11.6v2a.4.4 0 0 1-.32.391l-.08.009H2.6z",
		clipRule: "evenodd",
		opacity: .25
	})), _path2$280 || (_path2$280 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M1 11.14V3.689c0-1.647 2.16-2.193 2.967-.834l.074.137 1.058 2.19 1.46-3.018C7.142.96 8.858.96 9.44 2.163l1.46 3.02 1.06-2.192.073-.137C12.841 1.494 15 2.04 15 3.688v9.452a1.6 1.6 0 0 1-1.6 1.6H2.6a1.6 1.6 0 0 1-1.6-1.6zm12.04-7.627c.185-.382.76-.25.76.175V9.94H2.2V3.688c0-.425.575-.557.76-.175l1.6 3.31.045.08a.6.6 0 0 0 .99 0l.045-.08 2-4.137a.4.4 0 0 1 .72 0l2 4.137.045.08a.6.6 0 0 0 .99 0l.045-.08zM2.52 13.533a.4.4 0 0 1-.32-.392v-2h11.6v2a.4.4 0 0 1-.32.391l-.08.009H2.6z",
		clipRule: "evenodd"
	})), _path3$150 || (_path3$150 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M6.93 7.21a.2.2 0 0 1 0-.24l.91-1.221a.2.2 0 0 1 .32 0l.91 1.221a.2.2 0 0 1 0 .24l-.91 1.22a.2.2 0 0 1-.32 0z"
	})));
};

//#endregion
//#region src/Icon/icons/Cut.svg
var _path$390;
var _path2$279;
var _path3$149;
function _extends$404() {
	return _extends$404 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$404.apply(null, arguments);
}
var SvgCut = function SvgCut(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$404({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$390 || (_path$390 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M7.787 8.787a1 1 0 0 1 1-1h2.8a1 1 0 0 1 1 1v2.8a1 1 0 0 1-1 1h-2.8a1 1 0 0 1-1-1z",
		opacity: .25
	})), _path2$279 || (_path2$279 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M9.485 4.085h1.23V3.8A2.89 2.89 0 0 0 7.825.91H3.8A2.89 2.89 0 0 0 .91 3.8v4.025a2.89 2.89 0 0 0 2.89 2.89h.285v-1.23H3.8a1.66 1.66 0 0 1-1.66-1.66V3.8c0-.917.743-1.66 1.66-1.66h4.025c.917 0 1.66.743 1.66 1.66zM14.433 11.368a.6.6 0 0 0 .6-.6v-1.18a.6.6 0 1 0-1.2 0v1.18a.6.6 0 0 0 .6.6"
	})), _path3$149 || (_path3$149 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M5.908 11.368a.6.6 0 0 1-.6-.6v-1.18a.6.6 0 1 1 1.2 0v1.18a.6.6 0 0 1-.6.6M8.175 14.47c0 .331-.272.606-.596.538a2.89 2.89 0 0 1-2.232-2.232c-.068-.325.207-.596.538-.596h.03c.331 0 .59.277.707.587.168.445.521.798.966.966.31.117.587.376.587.707zM12.16 14.491c0 .332.272.607.596.539a2.89 2.89 0 0 0 2.233-2.233c.067-.324-.208-.596-.539-.596h-.03c-.331 0-.59.277-.707.587a1.67 1.67 0 0 1-.966.966c-.31.117-.587.376-.587.707zM8.98 14.44a.6.6 0 0 0 .6.6h1.18a.6.6 0 1 0 0-1.2H9.58a.6.6 0 0 0-.6.6M8.175 5.885c0-.331-.272-.606-.596-.538a2.89 2.89 0 0 0-2.232 2.232c-.068.324.207.596.538.596h.03c.331 0 .59-.277.707-.587.168-.445.521-.798.966-.966.31-.117.587-.376.587-.707zM12.16 5.864c0-.331.272-.607.596-.539a2.89 2.89 0 0 1 2.233 2.233c.067.324-.208.596-.539.596h-.03c-.331 0-.59-.277-.707-.587a1.67 1.67 0 0 0-.966-.966c-.31-.117-.587-.376-.587-.707zM8.98 5.915a.6.6 0 0 1 .6-.6h1.18a.6.6 0 1 1 0 1.2H9.58a.6.6 0 0 1-.6-.6"
	})));
};

//#endregion
//#region src/Icon/icons/Data.svg
var _path$389;
var _path2$278;
function _extends$403() {
	return _extends$403 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$403.apply(null, arguments);
}
var SvgData = function SvgData(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$403({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$389 || (_path$389 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "m3.484 10.987-.042-.02zM12.558 10.967l-.042.02zM3.484 7.74l-.042-.02zM12.516 7.74l.042-.02z"
	})), _path2$278 || (_path2$278 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M3.556 1.575C4.474 1.248 5.895 1 8 1s3.526.248 4.445.575c.458.164.814.355 1.068.565.225.185.487.482.487.869v9.199c0 .476-.16 1.037-.652 1.407C12.59 14.185 10.978 15 8 15s-4.59-.814-5.348-1.385C2.16 13.245 2 12.68 2 12.207V3.009c0-.387.262-.684.487-.87.254-.209.61-.4 1.069-.564m8.824 1.513.162-.095-.169-.083q-.149-.074-.366-.152c-.73-.26-1.99-.5-4.007-.5s-3.277.24-4.007.5a4 4 0 0 0-.366.152l-.17.083.163.095q.074.045.166.09c.61.304 1.838.663 4.214.663s3.605-.359 4.214-.663q.093-.045.166-.09m.34 2.913L12.72 4.34l-.142.062C11.7 4.784 10.289 5.1 8 5.1S4.3 4.784 3.423 4.4l-.142-.062-.002 1.662.036.03c.142.12.382.294.746.473.726.358 1.965.745 3.939.745s3.214-.387 3.939-.745c.364-.179.604-.353.746-.472zm0 6.207v-1.479l-.214.15c-.924.453-2.362.875-4.506.875s-3.582-.422-4.506-.875l-.213-.15v1.478c0 .23.076.354.15.41.513.386 1.843 1.125 4.569 1.125s4.056-.74 4.57-1.126c.073-.056.15-.179.15-.408M3.28 7.441l-.002 1.807.036.03c.142.12.382.294.746.473.726.357 1.965.745 3.939.745s3.214-.388 3.939-.745c.364-.18.604-.353.746-.473l.036-.03-.002-1.807-.219.194c-.924.452-2.36.872-4.5.872s-3.576-.42-4.5-.872z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/DataCycle.svg
var _path$388;
var _path2$277;
function _extends$402() {
	return _extends$402 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$402.apply(null, arguments);
}
var SvgDataCycle = function SvgDataCycle(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$402({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$388 || (_path$388 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8 1c-2.105 0-3.526.248-4.444.575-.459.164-.815.355-1.07.565-.224.185-.486.482-.486.869v9.198c0 .474.16 1.037.652 1.408.734.553 2.269 1.334 5.07 1.383a4.3 4.3 0 0 1-.48-1.276c-2.22-.121-3.348-.757-3.811-1.106-.074-.055-.15-.18-.15-.41V10.73l.213.15c.819.401 2.04.778 3.798.859.117-.446.302-.865.544-1.243-1.879-.02-3.07-.397-3.775-.744a3.7 3.7 0 0 1-.746-.473l-.036-.03.002-1.807.219.194c.924.452 2.36.872 4.5.872s3.576-.42 4.5-.872l.219-.194.001 1.209a4.3 4.3 0 0 1 1.28.61V3.008c0-.387-.262-.684-.487-.87-.254-.209-.61-.4-1.069-.564C11.527 1.248 10.106 1 8 1m4.542 1.993-.162.095q-.074.045-.166.09c-.61.304-1.838.663-4.214.663s-3.605-.359-4.214-.663a3 3 0 0 1-.166-.09l-.162-.095.169-.083q.149-.074.366-.152c.73-.26 1.99-.5 4.007-.5s3.277.24 4.007.5q.218.078.366.152zm.177 1.346.002 1.662-.036.03c-.142.12-.382.294-.746.473-.726.358-1.965.745-3.939.745s-3.213-.387-3.939-.745a3.7 3.7 0 0 1-.746-.472l-.036-.03.002-1.663.142.062C4.3 4.784 5.711 5.1 8 5.1s3.7-.315 4.577-.698z",
		clipRule: "evenodd"
	})), _path2$277 || (_path2$277 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M13.426 12.395a1.966 1.966 0 1 0-.8 2.064c.238-.164.585-.198.83.016.25.219.29.63 0 .856a3.16 3.16 0 1 1 1.191-2.886l.283-.233a.68.68 0 0 1 .875.002.535.535 0 0 1 0 .822l-.004.004-1.279 1.035a.66.66 0 0 1-.456.176.66.66 0 0 1-.457-.176l-1.283-1.039a.535.535 0 0 1 0-.822.68.68 0 0 1 .875-.002z"
	})));
};

//#endregion
//#region src/Icon/icons/Deliverable.svg
var _g$83;
var _g2$11;
var _path$387;
function _extends$401() {
	return _extends$401 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$401.apply(null, arguments);
}
var SvgDeliverable = function SvgDeliverable(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$401({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$83 || (_g$83 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .2
	}, /*#__PURE__*/ React.createElement("path", { d: "M1 5.6a.8.8 0 0 1 .8-.8H4v1.6H1.8a.8.8 0 0 1-.8-.8M0 8a.8.8 0 0 1 .8-.8H4v1.6H.8A.8.8 0 0 1 0 8M1 10.4a.8.8 0 0 1 .8-.8H4v1.6H1.8a.8.8 0 0 1-.8-.8" }))), _g2$11 || (_g2$11 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .5
	}, /*#__PURE__*/ React.createElement("path", { d: "M13.1 10.91c0 .263-.215.47-.474.47a.473.473 0 0 1-.476-.47v-.841l-.32.316a.48.48 0 0 1-.596.06l-.074-.06a.47.47 0 0 1 0-.669l1.13-1.118.075-.06c.184-.12.433-.1.595.06l1.13 1.118a.47.47 0 0 1 0 .67.48.48 0 0 1-.595.06l-.075-.06-.32-.317zM8.8 3.969h2.4v4L10 7.266l-1.2.703z" }))), _path$387 || (_path$387 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M14.2 2.769a1.8 1.8 0 0 1 1.8 1.8v6.8a1.8 1.8 0 0 1-1.8 1.8H5.8a1.8 1.8 0 0 1-1.8-1.8v-6.8a1.8 1.8 0 0 1 1.8-1.8zm-8.4 9.2a.6.6 0 0 1-.588-.48l-.012-.12v-6.8a.6.6 0 0 1 .6-.6h8.4a.6.6 0 0 1 .6.6v6.8l-.012.12a.6.6 0 0 1-.588.48z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Description.svg
var _g$82;
var _path$386;
function _extends$400() {
	return _extends$400 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$400.apply(null, arguments);
}
var SvgDescription = function SvgDescription(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$400({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$82 || (_g$82 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .5
	}, /*#__PURE__*/ React.createElement("path", { d: "M4.6 10.257a.7.7 0 0 1 .7-.7h5.2a.7.7 0 0 1 0 1.4H5.3a.7.7 0 0 1-.7-.7M4.6 7.787a.7.7 0 0 1 .7-.7h4a.7.7 0 0 1 0 1.4h-4a.7.7 0 0 1-.7-.7M4.6 5.319a.7.7 0 0 1 .7-.7h5.4a.7.7 0 1 1 0 1.4H5.3a.7.7 0 0 1-.7-.7" }))), _path$386 || (_path$386 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M4.9 2.1h6.2a2.8 2.8 0 0 1 2.8 2.8v6.2a2.8 2.8 0 0 1-2.8 2.8H4.9a2.8 2.8 0 0 1-2.8-2.8v-.242L.618 9.199a1.8 1.8 0 0 1 0-2.398L2.1 5.142V4.9a2.8 2.8 0 0 1 2.8-2.8m0 1.2a1.6 1.6 0 0 0-1.6 1.6v.471a.6.6 0 0 1-.153.4L1.513 7.6a.6.6 0 0 0 0 .799l1.634 1.83a.6.6 0 0 1 .153.399v.471a1.6 1.6 0 0 0 1.6 1.6h6.2a1.6 1.6 0 0 0 1.6-1.6V4.9a1.6 1.6 0 0 0-1.6-1.6z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Design.svg
var _path$385;
var _path2$276;
function _extends$399() {
	return _extends$399 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$399.apply(null, arguments);
}
var SvgDesign = function SvgDesign(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$399({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$385 || (_path$385 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8.781 13.448a.3.3 0 0 0 .424 0l4.243-4.243a.3.3 0 0 0 0-.424l-.92-.92-4.666 4.668z",
		clipRule: "evenodd",
		opacity: .25
	})), _path2$276 || (_path2$276 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "m9.77 1.953-6.745-.68a1.6 1.6 0 0 0-1.753 1.752l.681 6.744a2 2 0 0 0 1.225 1.647l3.2 1.326 1.555 1.554a1.5 1.5 0 0 0 2.12 0l4.243-4.242a1.5 1.5 0 0 0 0-2.121l-1.554-1.555-1.326-3.2A2 2 0 0 0 9.77 1.953M3.146 9.649a.8.8 0 0 0 .49.659l3.358 1.39 4.703-4.703-1.39-3.358a.8.8 0 0 0-.66-.49l-6.287-.635 2.248 2.249a2.201 2.201 0 1 1-.848.848L2.512 3.361zm2.828-3.674a1 1 0 1 0 1.414 1.414 1 1 0 0 0-1.414-1.414m2.806 7.473a.3.3 0 0 0 .424 0l4.243-4.243a.3.3 0 0 0 0-.424l-.92-.92-4.666 4.668z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Detection.svg
var _path$384;
var _path2$275;
var _path3$148;
function _extends$398() {
	return _extends$398 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$398.apply(null, arguments);
}
var SvgDetection = function SvgDetection(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$398({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$384 || (_path$384 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M3.3 8a4.7 4.7 0 1 1 9.4 0 4.7 4.7 0 0 1-9.4 0",
		clipRule: "evenodd",
		opacity: .2
	})), _path2$275 || (_path2$275 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M3.974 2.927c-.578 0-1.047.469-1.047 1.047v.805a.564.564 0 0 1-1.127 0v-.805c0-1.2.973-2.174 2.174-2.174h.805a.564.564 0 1 1 0 1.127zM10.657 2.364c0-.312.252-.564.564-.564h.805c1.2 0 2.174.973 2.174 2.174v.805a.564.564 0 1 1-1.127 0v-.805c0-.578-.469-1.047-1.047-1.047h-.805a.564.564 0 0 1-.564-.563M2.364 10.657c.31 0 .563.252.563.564v.805c0 .578.469 1.047 1.047 1.047h.805a.564.564 0 0 1 0 1.127h-.805c-1.2 0-2.174-.973-2.174-2.174v-.805c0-.312.252-.564.564-.564M13.636 10.657c.312 0 .564.252.564.564v.805c0 1.2-.973 2.174-2.174 2.174h-.805a.564.564 0 0 1 0-1.127h.805c.578 0 1.047-.469 1.047-1.047v-.805c0-.312.252-.564.563-.564"
	})), _path3$148 || (_path3$148 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M7.516 10.467a.66.66 0 0 1-.197-.482c0-.187.066-.35.2-.477a.68.68 0 0 1 .484-.194.65.65 0 0 1 .472.194.63.63 0 0 1 .206.477.65.65 0 0 1-.206.484.66.66 0 0 1-.472.188.7.7 0 0 1-.482-.186zm.497-5.124c.334 0 .602.276.595.61l-.064 2.67a.545.545 0 0 1-1.089 0l-.069-2.669a.595.595 0 0 1 .595-.61z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/DetectionNetwork.svg
var _g$81;
var _g2$10;
var _path$383;
var _path2$274;
function _extends$397() {
	return _extends$397 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$397.apply(null, arguments);
}
var SvgDetectionNetwork = function SvgDetectionNetwork(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$397({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$81 || (_g$81 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		fillRule: "evenodd",
		clipRule: "evenodd",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M9.842 11.845c.087.027.19.046.3.061.218.029.462.037.648.037.185 0 .429-.008.648-.037.109-.014.212-.034.299-.061a.5.5 0 0 0 .203-.106.5.5 0 0 0 .105-.19q.04-.123.061-.281c.03-.209.037-.453.037-.682s-.008-.474-.037-.682a1.6 1.6 0 0 0-.061-.28.5.5 0 0 0-.105-.192.5.5 0 0 0-.203-.105 2 2 0 0 0-.3-.062 5 5 0 0 0-.647-.036c-.186 0-.43.007-.648.036-.11.015-.213.035-.3.062a.5.5 0 0 0-.202.105.5.5 0 0 0-.107.191 1.6 1.6 0 0 0-.064.28c-.03.209-.04.453-.04.683 0 .229.01.473.04.682q.023.158.064.28a.5.5 0 0 0 .107.191.5.5 0 0 0 .202.106M4.27 11.845c.088.027.191.046.3.061.219.029.462.037.648.037s.43-.008.648-.037a2 2 0 0 0 .3-.061.5.5 0 0 0 .202-.106.5.5 0 0 0 .106-.19q.039-.123.06-.281a5 5 0 0 0 .037-.682c0-.23-.007-.474-.036-.682a1.6 1.6 0 0 0-.061-.28.5.5 0 0 0-.106-.192.5.5 0 0 0-.203-.105 2 2 0 0 0-.299-.062 5 5 0 0 0-.648-.036c-.186 0-.43.007-.648.036-.109.015-.212.035-.3.062a.5.5 0 0 0-.202.105.5.5 0 0 0-.106.191 1.6 1.6 0 0 0-.064.28 5 5 0 0 0-.04.683c0 .229.009.473.04.682q.022.158.064.28a.5.5 0 0 0 .106.191.5.5 0 0 0 .203.106" }))), _g2$10 || (_g2$10 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .5
	}, /*#__PURE__*/ React.createElement("path", { d: "M10.182 5.71a3.01 3.01 0 0 1 .786 2.664c.176.004.383.015.582.042.1.013.21.031.32.059q.059-.33.059-.675A3.93 3.93 0 0 0 10.2 4.546c.01.163.013.325.013.468 0 .21-.006.458-.032.696M8.676 11.67a3 3 0 0 1-.055-.276 5 5 0 0 1-.048-.626 3 3 0 0 1-1.146 0 5 5 0 0 1-.043.618q-.019.136-.055.286a4 4 0 0 0 1.347-.001M4.13 8.477c.113-.029.226-.048.328-.061.196-.026.4-.038.574-.042a3.012 3.012 0 0 1 .788-2.667 7.016 7.016 0 0 1-.02-1.162 3.93 3.93 0 0 0-1.67 3.932" }))), _path$383 || (_path$383 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M3.174 2.127c-.578 0-1.047.469-1.047 1.047v.805A.564.564 0 1 1 1 3.98v-.805C1 1.974 1.973 1 3.174 1h.805a.564.564 0 1 1 0 1.127zM11.46 1.564c0-.312.252-.564.564-.564h.805c1.2 0 2.174.973 2.174 2.174v.805a.564.564 0 0 1-1.127 0v-.805c0-.578-.47-1.047-1.047-1.047h-.805a.564.564 0 0 1-.564-.563M14.436 11.457c.312 0 .564.252.564.564v.805c0 1.2-.973 2.174-2.174 2.174h-.805a.564.564 0 0 1 0-1.127h.805c.578 0 1.047-.469 1.047-1.047v-.805c0-.312.252-.564.563-.564M1.564 11.457c.31 0 .563.252.563.564v.805c0 .578.469 1.047 1.047 1.047h.805a.564.564 0 0 1 0 1.127h-.805C1.974 15 1 14.027 1 12.826v-.805c0-.312.252-.564.564-.564"
	})), _path2$274 || (_path2$274 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M9.588 12.663a3 3 0 0 0 .441.093c.272.036.558.044.76.044.204 0 .49-.008.761-.044.135-.018.29-.046.44-.093.128-.04.363-.124.557-.319.178-.179.265-.387.31-.524.05-.148.08-.3.098-.434.037-.268.045-.56.045-.8 0-.241-.008-.533-.045-.8a2.4 2.4 0 0 0-.097-.435 1.34 1.34 0 0 0-.311-.524 1.34 1.34 0 0 0-.556-.319 3 3 0 0 0-.44-.092 6 6 0 0 0-.761-.045c-.203 0-.49.009-.761.045-.135.018-.29.045-.44.092-.128.04-.362.125-.556.32a1.35 1.35 0 0 0-.31.516c-.051.148-.082.3-.102.434-.04.269-.05.561-.05.808 0 .246.01.539.05.808.02.134.05.286.102.433.046.135.134.341.31.517.194.195.428.28.555.32m.254-.818c.087.027.19.046.3.061.218.029.462.037.648.037.185 0 .429-.008.648-.037.109-.014.212-.034.299-.061a.5.5 0 0 0 .203-.106.5.5 0 0 0 .105-.19q.04-.123.061-.281c.03-.209.037-.453.037-.682s-.008-.474-.037-.682a1.6 1.6 0 0 0-.061-.28.5.5 0 0 0-.105-.192.5.5 0 0 0-.203-.105 2 2 0 0 0-.3-.062 5 5 0 0 0-.647-.036c-.186 0-.43.007-.648.036-.11.015-.213.035-.3.062a.5.5 0 0 0-.202.105.5.5 0 0 0-.107.191 1.6 1.6 0 0 0-.064.28c-.03.209-.04.453-.04.683 0 .229.01.473.04.682q.023.158.064.28a.5.5 0 0 0 .107.191.5.5 0 0 0 .202.106M4.017 12.663c.15.047.306.075.44.093.272.036.558.044.761.044s.49-.008.76-.044c.136-.018.291-.046.441-.093.128-.04.362-.124.556-.319.178-.179.266-.387.311-.524.05-.148.08-.3.098-.434.037-.268.045-.56.045-.8 0-.241-.008-.533-.045-.8a2.4 2.4 0 0 0-.098-.435 1.34 1.34 0 0 0-.31-.524 1.34 1.34 0 0 0-.556-.319 3 3 0 0 0-.441-.092 6 6 0 0 0-.76-.045c-.204 0-.49.009-.761.045-.135.018-.29.045-.441.092-.128.04-.362.125-.556.32a1.35 1.35 0 0 0-.31.516c-.05.148-.081.3-.101.434-.04.269-.05.561-.05.808 0 .246.01.539.05.808.02.134.05.286.101.433.047.135.135.341.31.517.194.195.428.28.556.32m.254-.818c.087.027.19.046.3.061.218.029.461.037.647.037s.43-.008.648-.037a2 2 0 0 0 .3-.061.5.5 0 0 0 .202-.106.5.5 0 0 0 .106-.19q.039-.123.06-.281c.03-.209.037-.453.037-.682s-.007-.474-.036-.682a1.6 1.6 0 0 0-.061-.28.5.5 0 0 0-.106-.192.5.5 0 0 0-.203-.105 2 2 0 0 0-.299-.062 5 5 0 0 0-.648-.036c-.186 0-.43.007-.648.036-.109.015-.212.035-.3.062a.5.5 0 0 0-.202.105.5.5 0 0 0-.106.191 1.6 1.6 0 0 0-.064.28c-.031.209-.04.453-.04.683 0 .229.009.473.04.682q.022.158.064.28a.5.5 0 0 0 .106.191.5.5 0 0 0 .203.106M6.803 7.092c.15.047.305.074.44.092.272.036.558.045.76.045.204 0 .49-.009.762-.045.134-.018.29-.045.44-.092.128-.04.362-.125.556-.32.178-.178.265-.387.311-.523.05-.149.079-.3.097-.435.038-.267.045-.559.045-.8 0-.24-.007-.532-.045-.8a2.4 2.4 0 0 0-.097-.434 1.34 1.34 0 0 0-.311-.524 1.34 1.34 0 0 0-.556-.32 3 3 0 0 0-.44-.092 6 6 0 0 0-.761-.044c-.203 0-.489.008-.76.044-.136.018-.291.046-.441.093-.128.04-.362.124-.556.319a1.35 1.35 0 0 0-.31.517c-.05.147-.081.299-.101.433-.04.27-.05.562-.05.808 0 .247.01.54.05.808.02.135.05.286.1.434.047.135.135.34.311.517.194.194.428.28.556.319m.254-.819c.086.027.19.047.299.062.219.029.462.036.648.036s.43-.007.648-.036c.109-.015.212-.035.3-.062a.5.5 0 0 0 .202-.105.5.5 0 0 0 .105-.191c.027-.08.047-.176.061-.28.03-.209.037-.453.037-.683 0-.229-.008-.473-.037-.682a1.6 1.6 0 0 0-.06-.28.5.5 0 0 0-.106-.191.5.5 0 0 0-.203-.106 2 2 0 0 0-.3-.061 5 5 0 0 0-.647-.037c-.186 0-.43.008-.648.037-.11.014-.213.034-.3.061a.5.5 0 0 0-.202.106.5.5 0 0 0-.107.19 1.6 1.6 0 0 0-.063.281 5 5 0 0 0-.041.682c0 .23.01.474.04.683.016.104.037.2.064.28a.5.5 0 0 0 .107.19.5.5 0 0 0 .203.106",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/DetectionWireless.svg
var _path$382;
var _path2$273;
function _extends$396() {
	return _extends$396 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$396.apply(null, arguments);
}
var SvgDetectionWireless = function SvgDetectionWireless(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$396({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$382 || (_path$382 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M3.174 2.127c-.578 0-1.047.469-1.047 1.047v.805A.564.564 0 1 1 1 3.98v-.805C1 1.974 1.973 1 3.174 1h.805a.564.564 0 1 1 0 1.127zM11.46 1.564c0-.312.252-.564.564-.564h.805c1.2 0 2.174.973 2.174 2.174v.805a.564.564 0 0 1-1.127 0v-.805c0-.578-.47-1.047-1.047-1.047h-.805a.564.564 0 0 1-.564-.563M14.436 11.457c.312 0 .564.252.564.564v.805c0 1.2-.973 2.174-2.174 2.174h-.805a.564.564 0 0 1 0-1.127h.805c.578 0 1.047-.469 1.047-1.047v-.805c0-.312.252-.564.563-.564M1.564 11.457c.31 0 .563.252.563.564v.805c0 .578.469 1.047 1.047 1.047h.805a.564.564 0 0 1 0 1.127h-.805C1.974 15 1 14.027 1 12.826v-.805c0-.312.252-.564.564-.564M9.398 9.645H9.4l.131.107c.166.15.23.375.187.582l-.001.005c-.05.354-.321.754-.645 1.06a2.5 2.5 0 0 1-.53.39c-.181.098-.368.16-.54.16-.181 0-.379-.069-.569-.174a2.6 2.6 0 0 1-.553-.422 2.6 2.6 0 0 1-.43-.55 1.2 1.2 0 0 1-.179-.576v-.024c0-.166.068-.333.2-.452l.133-.107a3 3 0 0 1 .312-.205c.251-.144.64-.316 1.085-.316.446 0 .834.172 1.086.316a3 3 0 0 1 .312.206M4.778 8.748a.614.614 0 0 1 .057-.847l.076-.065q.067-.057.19-.15c.16-.12.389-.28.67-.44.225-.13.492-.264.79-.377.428-.162.919-.282 1.44-.282s1.013.12 1.442.283c.296.113.562.247.788.375a6.4 6.4 0 0 1 .858.59l.077.066a.615.615 0 0 1 .057.847.574.574 0 0 1-.826.061h-.001l-.042-.036a5.206 5.206 0 0 0-.692-.475C9.194 8.03 8.601 7.79 8 7.79c-.6 0-1.193.24-1.661.507a5 5 0 0 0-.692.474l-.04.035-.002.001a.575.575 0 0 1-.827-.06"
	})), _path2$273 || (_path2$273 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M3.142 6.897A.615.615 0 0 1 3.2 6.05l.11-.094a9.79 9.79 0 0 1 1.315-.904C5.477 4.565 6.682 4.05 8 4.05s2.524.514 3.375 1a10 10 0 0 1 1.316.905l.108.093c.242.218.27.598.06.848a.574.574 0 0 1-.827.061l-.002-.001-.075-.065a8.623 8.623 0 0 0-1.148-.788c-.768-.438-1.77-.85-2.807-.85s-2.038.412-2.806.85a8.6 8.6 0 0 0-1.148.788l-.076.065-.001.001a.574.574 0 0 1-.827-.06"
	})));
};

//#endregion
//#region src/Icon/icons/DHCP.svg
var _path$381;
var _path2$272;
var _path3$147;
function _extends$395() {
	return _extends$395 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$395.apply(null, arguments);
}
var SvgDhcp = function SvgDhcp(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$395({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$381 || (_path$381 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M9.436 11.2a.4.4 0 0 0-.4.4v3.2h5.2v-3.2a.4.4 0 0 0-.4-.4z",
		clipRule: "evenodd",
		opacity: .25
	})), _path2$272 || (_path2$272 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8 1c-2.105 0-3.526.248-4.444.575-.459.164-.815.355-1.07.565-.224.185-.486.482-.486.869v9.198c0 .474.16 1.037.652 1.408.583.439 1.67 1.022 3.496 1.268.092-.306.262-.578.488-.791v-.418c-1.822-.192-2.786-.742-3.205-1.058-.074-.055-.15-.18-.15-.41V10.73l.213.15c.713.35 1.73.68 3.142.813V11.1q.001-.347.097-.662c-1.258-.122-2.116-.414-2.672-.687a3.7 3.7 0 0 1-.746-.473l-.036-.03.002-1.807.219.194c.924.452 2.36.872 4.5.872s3.576-.42 4.5-.872l.219-.194.001 1.359H14V3.009c0-.387-.262-.684-.487-.87-.254-.209-.61-.4-1.069-.564C11.527 1.248 10.106 1 8 1m4.542 1.993-.162.095q-.074.045-.166.09c-.61.304-1.838.663-4.214.663s-3.605-.359-4.214-.663a3 3 0 0 1-.166-.09l-.162-.095.169-.083q.149-.074.366-.152c.73-.26 1.99-.5 4.007-.5s3.277.24 4.007.5q.218.078.366.152zm.177 1.346.002 1.662-.036.03c-.142.12-.382.294-.746.473-.726.358-1.965.745-3.939.745s-3.213-.387-3.939-.745a3.7 3.7 0 0 1-.746-.472l-.036-.03.002-1.663.142.062C4.3 4.784 5.711 5.1 8 5.1s3.7-.315 4.577-.698z",
		clipRule: "evenodd"
	})), _path3$147 || (_path3$147 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8.936 10a1.1 1.1 0 0 0-1.1 1.1v3.701A.6.6 0 0 0 7.873 16H15.4a.6.6 0 0 0 .036-1.199V11.1a1.1 1.1 0 0 0-1.1-1.1zm.5 1.2a.4.4 0 0 0-.4.4v3.2h5.2v-3.2a.4.4 0 0 0-.4-.4z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Diagnostics.svg
var _path$380;
var _path2$271;
var _path3$146;
function _extends$394() {
	return _extends$394 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$394.apply(null, arguments);
}
var SvgDiagnostics = function SvgDiagnostics(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$394({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$380 || (_path$380 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M3.2 2h9.6A2.2 2.2 0 0 1 15 4.2v5.6a2.2 2.2 0 0 1-2.2 2.2H3.2A2.2 2.2 0 0 1 1 9.8V4.2A2.2 2.2 0 0 1 3.2 2m0 1.2a1 1 0 0 0-1 1v5.6a1 1 0 0 0 1 1h9.6a1 1 0 0 0 1-1V4.2a1 1 0 0 0-1-1z",
		clipRule: "evenodd"
	})), _path2$271 || (_path2$271 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M4.312 7.002c0-.275.224-.499.499-.499h.997a.499.499 0 1 1 0 .997h-.997a.5.5 0 0 1-.499-.498M9.693 7.002c0-.275.223-.499.499-.499h.997a.499.499 0 0 1 0 .997h-.997a.5.5 0 0 1-.499-.498M6.765 4.04a.5.5 0 0 1 .655.263l2.132 4.99a.499.499 0 1 1-.917.392l-2.132-4.99a.5.5 0 0 1 .262-.655"
	})), _path3$146 || (_path3$146 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M8.889 9.957a.5.5 0 0 1-.253-.658l1.11-2.493a.499.499 0 0 1 .911.405l-1.11 2.493a.5.5 0 0 1-.658.253M5.643 7.45a.5.5 0 0 1-.253-.657L6.5 4.3a.499.499 0 0 1 .911.405l-1.11 2.493a.5.5 0 0 1-.658.253M3.4 14.1a.9.9 0 0 1 .9-.9h7.4a.9.9 0 0 1 0 1.8H4.3a.9.9 0 0 1-.9-.9"
	})));
};

//#endregion
//#region src/Icon/icons/Digest.svg
var _g$80;
var _path$379;
function _extends$393() {
	return _extends$393 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$393.apply(null, arguments);
}
var SvgDigest = function SvgDigest(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$393({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$80 || (_g$80 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .5
	}, /*#__PURE__*/ React.createElement("path", { d: "M3.525 5.6a.6.6 0 0 1 .6-.6h4.206a.6.6 0 0 1 0 1.2H4.125a.6.6 0 0 1-.6-.6M3.525 8a.6.6 0 0 1 .6-.6h3.019a.6.6 0 0 1 0 1.2H4.125a.6.6 0 0 1-.6-.6M3.525 10.4a.6.6 0 0 1 .6-.6h4.769a.6.6 0 0 1 0 1.2H4.125a.6.6 0 0 1-.6-.6" }))), _path$379 || (_path$379 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M11.1 14H3a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h7.3a2 2 0 0 1 2 2v8.05a.65.65 0 0 0 1.3 0V6.3a.7.7 0 1 1 1.4 0v6.5a1.2 1.2 0 0 1-1.2 1.2h-2.7m-.8-10.6H3a.6.6 0 0 0-.6.6v8a.6.6 0 0 0 .6.6h7.3a.6.6 0 0 0 .6-.6V4a.6.6 0 0 0-.6-.6",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Disable.svg
var _path$378;
var _path2$270;
var _path3$145;
function _extends$392() {
	return _extends$392 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$392.apply(null, arguments);
}
var SvgDisable = function SvgDisable(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$392({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$378 || (_path$378 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M12.86 4.836a5.8 5.8 0 0 1-8.023 8.023l.267-.266a1.8 1.8 0 0 0 2.047-.35l5.091-5.092a1.8 1.8 0 0 0 .35-2.047z",
		opacity: .25
	})), _path2$270 || (_path2$270 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M4.606 10.546a.6.6 0 0 1 0-.849l5.091-5.091a.6.6 0 0 1 .849 0l.848.848a.6.6 0 0 1 0 .849l-5.091 5.091a.6.6 0 0 1-.849 0z"
	})), _path3$145 || (_path3$145 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14M8 2.2a5.8 5.8 0 1 1 0 11.6A5.8 5.8 0 0 1 8 2.2",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/DNS.svg
var _path$377;
var _path2$269;
function _extends$391() {
	return _extends$391 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$391.apply(null, arguments);
}
var SvgDns = function SvgDns(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$391({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$377 || (_path$377 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M5.405 7.108h5.19v1.784h-5.19z",
		clipRule: "evenodd",
		opacity: .25
	})), _path2$269 || (_path2$269 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M4.913 4.893a.619.619 0 1 0 0-1.238.619.619 0 0 0 0 1.238m6.174 7.452a.619.619 0 1 0 0-1.238.619.619 0 0 0 0 1.238m-6.88-5.237v1.784h-.252c-1.036 0-1.876.84-1.876 1.876v1.916c0 1.036.84 1.876 1.876 1.876h8.09c1.036 0 1.876-.84 1.876-1.876v-1.916c0-1.036-.84-1.876-1.876-1.876h-.253V7.108h.253c1.036 0 1.876-.84 1.876-1.876V3.316c0-1.036-.84-1.876-1.876-1.876h-8.09c-1.036 0-1.876.84-1.876 1.876v1.916c0 1.036.84 1.876 1.876 1.876zm1.198 0h5.19v1.784h-5.19zM3.276 3.316c0-.375.304-.679.679-.679h8.09c.375 0 .679.304.679.68v1.915a.68.68 0 0 1-.679.679h-8.09a.68.68 0 0 1-.679-.679zm0 7.452c0-.375.304-.679.679-.679h8.09c.375 0 .679.304.679.679v1.916a.68.68 0 0 1-.679.679h-8.09a.68.68 0 0 1-.679-.68z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/DNSGenerateMaps.svg
var _path$376;
var _g$79;
var _path2$268;
var _path3$144;
var _path4$49;
function _extends$390() {
	return _extends$390 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$390.apply(null, arguments);
}
var SvgDnsGenerateMaps = function SvgDnsGenerateMaps(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$390({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$376 || (_path$376 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M10.595 7.53c-.19.147-.35.344-.464.589l-.051.125-.24.647H5.405V7.108h5.19z",
		opacity: .25
	})), _g$79 || (_g$79 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .5
	}, /*#__PURE__*/ React.createElement("path", { d: "M14.588 7.241a.156.156 0 0 1 .292 0l.25.676c.016.043.05.076.092.092l.677.25a.155.155 0 0 1 0 .292l-.677.25a.16.16 0 0 0-.092.093l-.25.676a.156.156 0 0 1-.292 0l-.25-.676a.16.16 0 0 0-.091-.092l-.677-.25a.155.155 0 0 1 0-.292l.676-.25a.16.16 0 0 0 .092-.093zM8.26 13.57a.156.156 0 0 1 .292 0l.25.676c.015.043.049.076.091.092l.677.25a.155.155 0 0 1 0 .292l-.677.25a.16.16 0 0 0-.092.092l-.25.676a.156.156 0 0 1-.292 0l-.25-.675a.16.16 0 0 0-.091-.092l-.677-.251a.155.155 0 0 1 0-.291l.677-.251a.16.16 0 0 0 .092-.092z" }))), _path2$268 || (_path2$268 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M4.913 3.656a.619.619 0 1 1 0 1.237.619.619 0 0 1 0-1.237"
	})), _path3$144 || (_path3$144 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M12.046 1.44c1.035 0 1.875.84 1.876 1.876v1.916c0 1.036-.84 1.876-1.876 1.876h-.253v.114a1.6 1.6 0 0 0-1.198.309v-.423h-5.19v1.783H9.84l-.256.693-1.341.497-.02.008H3.954a.68.68 0 0 0-.679.68v1.915a.68.68 0 0 0 .679.679h3.102l-.006.017-.226.083a1.33 1.33 0 0 0-.873 1.097H3.955a1.876 1.876 0 0 1-1.876-1.876v-1.916c0-1.036.84-1.877 1.876-1.877h.253V7.108h-.253a1.876 1.876 0 0 1-1.876-1.876V3.316c0-1.036.84-1.876 1.876-1.876zM3.955 2.637a.68.68 0 0 0-.679.679v1.916c0 .375.304.679.679.679h8.09a.68.68 0 0 0 .68-.679V3.316a.68.68 0 0 0-.68-.679z",
		clipRule: "evenodd"
	})), _path4$49 || (_path4$49 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M11.205 8.66a.39.39 0 0 1 .73 0l.624 1.69c.04.106.124.19.23.229l1.691.627a.388.388 0 0 1 0 .728l-1.69.627a.39.39 0 0 0-.23.23l-.625 1.69a.39.39 0 0 1-.73 0l-.625-1.69a.39.39 0 0 0-.23-.23l-1.69-.627a.388.388 0 0 1 0-.728l1.69-.627a.39.39 0 0 0 .23-.23z"
	})));
};

//#endregion
//#region src/Icon/icons/DNSSecurity.svg
var _path$375;
var _path2$267;
var _path3$143;
var _path4$48;
function _extends$389() {
	return _extends$389 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$389.apply(null, arguments);
}
var SvgDnsSecurity = function SvgDnsSecurity(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$389({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$375 || (_path$375 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M10.39 7.108a3.4 3.4 0 0 0-1.2 1.784H5.404V7.108z",
		opacity: .25
	})), _path2$267 || (_path2$267 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M5.532 4.274a.619.619 0 1 1-1.238 0 .619.619 0 0 1 1.238 0"
	})), _path3$143 || (_path3$143 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M4.208 8.892V7.108h-.253a1.876 1.876 0 0 1-1.876-1.876V3.316c0-1.036.84-1.876 1.876-1.876h8.09c1.036 0 1.876.84 1.876 1.876v1.916c0 .504-.198.96-.52 1.298a3.4 3.4 0 0 0-3.012.578H5.405v1.784H9.19a3.4 3.4 0 0 0-.113.65 2.8 2.8 0 0 0-.66.547H3.954a.68.68 0 0 0-.679.679v1.916c0 .375.304.679.679.679h3.778v1.104q0 .046.002.093h-3.78a1.876 1.876 0 0 1-1.876-1.876v-1.916c0-1.036.84-1.876 1.876-1.876zm-.253-6.255a.68.68 0 0 0-.679.68v1.915c0 .375.304.679.679.679h8.09a.68.68 0 0 0 .679-.679V3.316a.68.68 0 0 0-.679-.679z",
		clipRule: "evenodd"
	})), _path4$48 || (_path4$48 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M10.267 10.375V9.8a2.2 2.2 0 1 1 4.4 0v.575A1.534 1.534 0 0 1 16 11.895v2.572c0 .846-.687 1.533-1.533 1.533h-4a1.533 1.533 0 0 1-1.534-1.533v-2.572c0-.779.581-1.422 1.334-1.52m3.2-.013V9.8a1 1 0 0 0-2 0v.562zm-3 1.2a.333.333 0 0 0-.334.333v2.572c0 .184.15.333.334.333h4c.184 0 .333-.15.333-.333v-2.572a.333.333 0 0 0-.333-.333zm2.465 1.616a.728.728 0 0 0-.465-1.292.73.73 0 0 0-.465 1.292v.586a.465.465 0 0 0 .93 0z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Dock.svg
var _g$78;
var _path$374;
function _extends$388() {
	return _extends$388 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$388.apply(null, arguments);
}
var SvgDock = function SvgDock(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$388({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$78 || (_g$78 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M13 1a1 1 0 0 1 1 1v8.469a2 2 0 0 0-1-.269H3a2 2 0 0 0-1 .269V2a1 1 0 0 1 1-1zM2.2 13a.8.8 0 0 0 .718.796L3 13.8h10l.082-.005A.8.8 0 0 0 13.8 13z" }))), _path$374 || (_path$374 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M13 10.2a2 2 0 0 1 2 2v.8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-.8a2 2 0 0 1 2-2zM2.918 13.796A.8.8 0 0 1 2.2 13v-.8a.8.8 0 0 1 .8-.8h10a.8.8 0 0 1 .8.8v.8a.8.8 0 0 1-.718.796L13 13.8H3z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Document.svg
var _path$373;
function _extends$387() {
	return _extends$387 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$387.apply(null, arguments);
}
var SvgDocument = function SvgDocument(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$387({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$373 || (_path$373 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M13.406 6.563a.8.8 0 0 0-.234-.566L8.409 1.234A.8.8 0 0 0 7.844 1H5.006a1.6 1.6 0 0 0-1.6 1.6v10.8a1.6 1.6 0 0 0 1.6 1.6h6.8a1.6 1.6 0 0 0 1.6-1.6zM7.596 2.6a.2.2 0 0 0-.2-.2h-2.39a.2.2 0 0 0-.2.2v10.8c0 .11.09.2.2.2h6.8a.2.2 0 0 0 .2-.2V7.213a.4.4 0 0 0-.4-.4h-3.41a.6.6 0 0 1-.6-.6V2.6",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Documentation.svg
var _path$372;
var _g$77;
function _extends$386() {
	return _extends$386 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$386.apply(null, arguments);
}
var SvgDocumentation = function SvgDocumentation(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$386({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$372 || (_path$372 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M4.762 12.863c.88-.007 1.882.33 2.155.43.373.138.678.307 1.109.307s.663-.13 1.057-.275c.273-.1 1.275-.437 2.155-.431.476.003.982.1 1.4.213 1.088.292 2.362-.473 2.362-1.777V3.606c0-.687-.406-1.387-1.151-1.652a8 8 0 0 0-2.602-.46c-1.526 0-2.827.508-3.072.608a1 1 0 0 0-.15.073 1.3 1.3 0 0 0-.2-.104c-.245-.1-1.546-.609-3.072-.609a8 8 0 0 0-2.602.46A1.74 1.74 0 0 0 1 3.576v7.724c0 1.304 1.274 2.069 2.361 1.777.42-.113.925-.21 1.4-.213m-.009-1.2a6.6 6.6 0 0 1 1.447.174l.033.007a10 10 0 0 1 1.099.324.05.05 0 0 0 .068-.048V3.227a.05.05 0 0 0-.03-.046c-.196-.08-1.325-.519-2.617-.519-.942 0-1.757.234-2.2.391a.54.54 0 0 0-.353.522v7.724c0 .427.438.729.85.618.472-.127 1.086-.25 1.703-.255m6.494.03a6.6 6.6 0 0 0-1.447.175l-.033.008a10 10 0 0 0-1.099.323.05.05 0 0 1-.068-.048V3.258q.001-.032.03-.046c.196-.08 1.325-.518 2.617-.518.942 0 1.757.233 2.2.39.218.078.353.29.353.522v7.724c0 .427-.438.729-.85.618-.472-.127-1.086-.25-1.703-.254",
		clipRule: "evenodd"
	})), _g$77 || (_g$77 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M4.774 14.062h-.012c-.476.004-.982.101-1.4.214a1.8 1.8 0 0 1-.562.06c-.92-.043-1.8-.754-1.8-1.837v1.2c0 1.304 1.274 2.069 2.361 1.777.42-.113.925-.21 1.4-.214.881-.006 1.883.331 2.156.432q.116.044.227.089c.28.112.542.217.882.217.35 0 .57-.086.852-.196q.096-.038.205-.079c.273-.1 1.275-.437 2.155-.431.476.003.982.1 1.4.213 1.088.292 2.362-.473 2.362-1.777v-1.2c0 1.084-.88 1.795-1.8 1.837a1.825 1.825 0 0 1-.561-.06 5.8 5.8 0 0 0-1.4-.213h-.04c-.871.004-1.847.332-2.116.431q-.109.041-.205.079c-.282.11-.502.196-.852.196-.34 0-.603-.105-.882-.217l-.227-.09c-.269-.098-1.245-.427-2.116-.43" }), /*#__PURE__*/ React.createElement("path", {
		fillRule: "evenodd",
		d: "M11.247 11.694a6.6 6.6 0 0 0-1.447.174l-.033.008a10 10 0 0 0-1.099.323.05.05 0 0 1-.068-.048V3.258q.001-.032.03-.046c.196-.08 1.325-.518 2.617-.518.942 0 1.757.233 2.2.39.218.078.353.29.353.522v7.724c0 .427-.438.729-.85.618-.472-.127-1.086-.25-1.703-.254",
		clipRule: "evenodd"
	}))));
};

//#endregion
//#region src/Icon/icons/DocumentCSV.svg
var _path$371;
var _path2$266;
var _path3$142;
var _path4$47;
function _extends$385() {
	return _extends$385 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$385.apply(null, arguments);
}
var SvgDocumentCsv = function SvgDocumentCsv(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$385({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$371 || (_path$371 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M5.438 1a.8.8 0 0 1 .565.234l4.763 4.763a.8.8 0 0 1 .234.566v.636H5.98a3.4 3.4 0 0 0-3.4 3.4v3.2c0 .423.078.828.219 1.201h-.2A1.6 1.6 0 0 1 1 13.4V2.6A1.6 1.6 0 0 1 2.6 1z",
		opacity: .25
	})), _path2$266 || (_path2$266 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M13.8 8.4a2.2 2.2 0 0 1 2.2 2.2v3.2a2.2 2.2 0 0 1-2.2 2.2H5.98a2.2 2.2 0 0 1-2.2-2.2v-3.2a2.2 2.2 0 0 1 2.2-2.2zm-7.922 6.395a1 1 0 0 1-.893-.894L4.98 13.8v-3.2a1 1 0 0 1 1-1h7.82l.102.004a1 1 0 0 1 .899.996v3.2l-.006.101a1 1 0 0 1-.893.894l-.101.005H5.98z",
		clipRule: "evenodd"
	})), _path3$142 || (_path3$142 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M7.188 13.256c.318 0 .516-.222.523-.58h.614c0 .697-.435 1.124-1.135 1.124-.76 0-1.208-.476-1.208-1.286v-.629c0-.81.447-1.285 1.208-1.285.708 0 1.128.424 1.132 1.15h-.614c-.006-.368-.215-.607-.528-.607-.373 0-.57.256-.57.742v.63c0 .487.197.741.578.741M8.672 12.877h.571c.028.266.246.42.595.42.333 0 .544-.16.544-.41 0-.209-.137-.32-.493-.399l-.32-.074c-.556-.126-.829-.42-.829-.876 0-.574.425-.938 1.09-.938.643 0 1.076.36 1.095.91h-.57c-.024-.254-.218-.41-.519-.41-.305 0-.495.143-.495.374 0 .217.137.336.47.409l.315.073c.595.132.855.398.855.87 0 .607-.435.974-1.153.974-.698 0-1.135-.348-1.156-.924M12.552 13.135l.642-2.474h.605l-.923 3.077h-.716l-.923-3.077h.654l.633 2.473z"
	})), _path4$47 || (_path4$47 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M5.438 1a.8.8 0 0 1 .565.234l4.763 4.763a.8.8 0 0 1 .234.566v.636H9.599a.4.4 0 0 0-.399-.386H5.791c-.331 0-.6-.269-.6-.6v-2.96L5.188 2.6a.2.2 0 0 0-.2-.2H2.6a.2.2 0 0 0-.199.2v10.8c0 .104.08.188.18.198v.202c0 .422.078.827.219 1.2h-.2A1.6 1.6 0 0 1 1 13.4V2.6A1.6 1.6 0 0 1 2.6 1z"
	})));
};

//#endregion
//#region src/Icon/icons/DocumentPNG.svg
var _path$370;
var _path2$265;
var _path3$141;
var _path4$46;
function _extends$384() {
	return _extends$384 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$384.apply(null, arguments);
}
var SvgDocumentPng = function SvgDocumentPng(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$384({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$370 || (_path$370 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M4.99 2.4a.2.2 0 0 1 .2.2v3.613c0 .331.27.6.601.6h3.41c.215 0 .39.172.398.386H5.98a3.4 3.4 0 0 0-3.4 3.4v2.999a.2.2 0 0 1-.18-.198V2.6a.2.2 0 0 1 .2-.2z",
		opacity: .25
	})), _path2$265 || (_path2$265 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M5.438 1a.8.8 0 0 1 .565.234l4.763 4.763a.8.8 0 0 1 .234.566v.636H9.599a.4.4 0 0 0-.399-.386H5.791c-.331 0-.6-.269-.6-.6v-2.96L5.188 2.6a.2.2 0 0 0-.2-.2H2.6a.2.2 0 0 0-.199.2v10.8c0 .104.08.188.18.198v.202c0 .422.078.827.219 1.2h-.2A1.6 1.6 0 0 1 1 13.4V2.6A1.6 1.6 0 0 1 2.6 1z"
	})), _path3$141 || (_path3$141 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M13.8 8.4a2.2 2.2 0 0 1 2.2 2.2v3.2a2.2 2.2 0 0 1-2.2 2.2H5.98a2.2 2.2 0 0 1-2.2-2.2v-3.2a2.2 2.2 0 0 1 2.2-2.2zm-7.922 6.395a1 1 0 0 1-.893-.894L4.98 13.8v-3.2a1 1 0 0 1 1-1h7.82l.102.004a1 1 0 0 1 .899.996v3.2l-.006.101a1 1 0 0 1-.893.894l-.101.005H5.98z",
		clipRule: "evenodd"
	})), _path4$46 || (_path4$46 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M13.082 12.73v-.171h-.574v-.456h1.19v.64c0 .641-.448 1.057-1.128 1.057-.759 0-1.202-.471-1.202-1.286v-.629c0-.814.443-1.285 1.202-1.285.68 0 1.108.407 1.126 1.079h-.617c-.014-.325-.226-.536-.526-.536-.375 0-.57.252-.57.742v.63c0 .492.197.741.578.741.325 0 .52-.196.52-.527M9.26 13.738h-.525v-3.076h.539l1.057 2.044h.037v-2.044h.524v3.076h-.537l-1.06-2.057H9.26zM6.083 10.662h1.125c.646 0 1.055.407 1.055 1.053 0 .64-.422 1.047-1.085 1.047h-.49v.976h-.605zm.605.496v1.105h.367q.594.002.595-.553 0-.552-.595-.552z"
	})));
};

//#endregion
//#region src/Icon/icons/Documents.svg
var _path$369;
var _path2$264;
var _path3$140;
function _extends$383() {
	return _extends$383 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$383.apply(null, arguments);
}
var SvgDocuments = function SvgDocuments(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$383({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$369 || (_path$369 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M3.807 2.4H2.6a.2.2 0 0 0-.2.2v10.8c0 .11.09.2.2.2h1.207a3 3 0 0 1-.007-.2V2.6q0-.1.007-.2",
		opacity: .25
	})), _path2$264 || (_path2$264 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M4.302 1H2.6A1.6 1.6 0 0 0 1 2.6v10.8A1.6 1.6 0 0 0 2.6 15h1.702a2.8 2.8 0 0 1-.495-1.4H2.6a.2.2 0 0 1-.2-.2V2.6c0-.11.09-.2.2-.2h1.207c.037-.518.214-.998.495-1.4"
	})), _path3$140 || (_path3$140 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M15 6.563a.8.8 0 0 0-.234-.566l-4.763-4.763A.8.8 0 0 0 9.437 1H6.6A1.6 1.6 0 0 0 5 2.6v10.8A1.6 1.6 0 0 0 6.6 15h6.8a1.6 1.6 0 0 0 1.6-1.6zM9.19 2.6a.2.2 0 0 0-.2-.2H6.6a.2.2 0 0 0-.2.2v10.8c0 .11.09.2.2.2h6.8a.2.2 0 0 0 .2-.2V7.213a.4.4 0 0 0-.4-.4H9.79a.6.6 0 0 1-.6-.6V2.6",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Download.svg
var _path$368;
var _path2$263;
function _extends$382() {
	return _extends$382 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$382.apply(null, arguments);
}
var SvgDownload = function SvgDownload(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$382({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$368 || (_path$368 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M2.678 12.585c-.05-.05-.162-.209-.283-.56a6 6 0 0 1-.202-.777.625.625 0 0 0-.677-.506.585.585 0 0 0-.515.687c.17.883.43 1.613.825 2.008.236.237.62.421 1.084.565a10 10 0 0 0 1.61.33c1.176.156 2.488.198 3.489.198s2.312-.042 3.488-.198a10 10 0 0 0 1.61-.33c.465-.144.848-.328 1.085-.565.394-.396.646-1.125.808-2.008a.585.585 0 0 0-.521-.682.624.624 0 0 0-.673.512 6 6 0 0 1-.194.774c-.118.352-.227.506-.274.553a.7.7 0 0 1-.151.095 3 3 0 0 1-.437.17c-.377.117-.86.213-1.412.286-1.101.146-2.354.188-3.33.188a32 32 0 0 1-1.798-.049 21 21 0 0 1-1.531-.139 9 9 0 0 1-1.412-.286 2.7 2.7 0 0 1-.447-.18 2 2 0 0 1-.134-.08l-.006-.005z",
		clipRule: "evenodd"
	})), _path2$263 || (_path2$263 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M7.14 2.22c0-.414.385-.75.86-.75s.86.336.86.75v6.688l2.046-1.784a.95.95 0 0 1 1.217 0 .684.684 0 0 1 0 1.06L8.64 11.222a.92.92 0 0 1-.64.249.92.92 0 0 1-.64-.249L3.877 8.185a.684.684 0 0 1 0-1.061.95.95 0 0 1 1.217 0L7.14 8.908z"
	})));
};

//#endregion
//#region src/Icon/icons/DragHorizontal.svg
var _path$367;
function _extends$381() {
	return _extends$381 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$381.apply(null, arguments);
}
var SvgDragHorizontal = function SvgDragHorizontal(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$381({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$367 || (_path$367 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M2.815 3.608c1.002 0 1.815.81 1.815 1.808 0 .999-.813 1.808-1.815 1.808A1.81 1.81 0 0 1 1 5.416c0-.999.813-1.808 1.815-1.808M8 3.608c1.002 0 1.815.81 1.815 1.808 0 .999-.813 1.808-1.815 1.808a1.81 1.81 0 0 1-1.815-1.808c0-.999.813-1.808 1.815-1.808M15 5.416c0-.999-.812-1.808-1.815-1.808s-1.815.81-1.815 1.808c0 .999.813 1.808 1.815 1.808S15 6.414 15 5.416M2.815 8.776c1.002 0 1.815.81 1.815 1.808 0 .999-.813 1.809-1.815 1.809A1.81 1.81 0 0 1 1 10.584c0-.999.813-1.808 1.815-1.808M8 8.776c1.002 0 1.815.81 1.815 1.808 0 .999-.813 1.809-1.815 1.809a1.81 1.81 0 0 1-1.815-1.809c0-.999.813-1.808 1.815-1.808M15 10.584c0-.999-.812-1.808-1.815-1.808s-1.815.81-1.815 1.808c0 .999.813 1.809 1.815 1.809S15 11.583 15 10.584"
	})));
};

//#endregion
//#region src/Icon/icons/DragVertical.svg
var _path$366;
function _extends$380() {
	return _extends$380 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$380.apply(null, arguments);
}
var SvgDragVertical = function SvgDragVertical(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$380({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$366 || (_path$366 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M3.607 13.185c0-1.002.81-1.815 1.809-1.815s1.808.813 1.808 1.815S6.414 15 5.416 15a1.81 1.81 0 0 1-1.809-1.815M3.607 8c0-1.002.81-1.815 1.809-1.815S7.224 6.998 7.224 8s-.81 1.815-1.808 1.815A1.81 1.81 0 0 1 3.607 8M5.416 1c-.999 0-1.809.813-1.809 1.815s.81 1.815 1.809 1.815 1.808-.813 1.808-1.815S6.414 1 5.416 1M8.776 13.185c0-1.002.81-1.815 1.808-1.815.999 0 1.809.813 1.809 1.815S11.583 15 10.584 15a1.81 1.81 0 0 1-1.808-1.815M8.776 8c0-1.002.81-1.815 1.808-1.815.999 0 1.809.813 1.809 1.815s-.81 1.815-1.809 1.815A1.81 1.81 0 0 1 8.776 8M10.584 1c-.999 0-1.808.813-1.808 1.815s.81 1.815 1.808 1.815c.999 0 1.809-.813 1.809-1.815S11.583 1 10.584 1"
	})));
};

//#endregion
//#region src/Icon/icons/DynamicVLAN.svg
var _path$365;
var _path2$262;
var _path3$139;
var _path4$45;
function _extends$379() {
	return _extends$379 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$379.apply(null, arguments);
}
var SvgDynamicVlan = function SvgDynamicVlan(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$379({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$365 || (_path$365 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M8.005 6.6c-.167 0-.38-.005-.605-.021V8H1.6a.6.6 0 1 0 0 1.2h.7v1.48c.222-.024.443-.03.603-.03s.377.005.597.028V9.2h3.9v1.474l.356-.275c.154-.135.329-.242.516-.319.046-.258.153-.51.328-.734V9.2h.127q.084-.086.184-.165a4.5 4.5 0 0 1 2.797-.971c1.123 0 2.146.409 2.936 1.084A.6.6 0 0 0 14.4 8H8.6V6.58c-.221.016-.431.02-.595.02M9.6 3.8c0 .546-.037 1.162-.237 1.362s-.916.238-1.358.238-1.158-.037-1.358-.238S6.4 4.346 6.4 3.8s.047-1.161.247-1.362c.2-.2.916-.238 1.358-.238s1.158.037 1.358.238.237.816.237 1.362",
		opacity: .25
	})), _path2$262 || (_path2$262 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M5.797 6.01a1.8 1.8 0 0 1-.408-.678 3 3 0 0 1-.128-.546A7 7 0 0 1 5.2 3.8c0-.297.012-.654.061-.986.025-.166.063-.357.128-.546.059-.171.174-.443.408-.677.259-.26.569-.371.728-.421.191-.06.386-.094.552-.116.334-.044.682-.054.928-.054.245 0 .593.01.927.054.166.022.36.057.552.116.16.05.47.16.729.42.237.239.351.515.41.688.063.19.1.382.122.547.046.33.055.686.055.975 0 .29-.01.645-.055.975-.023.165-.06.357-.123.547a1.75 1.75 0 0 1-.41.687c-.259.26-.568.371-.728.421l-.552.116a7 7 0 0 1-.927.054c-.246 0-.594-.01-.928-.054a3.4 3.4 0 0 1-.552-.116c-.16-.05-.469-.16-.728-.42M9.6 3.8c0 .546-.037 1.162-.237 1.362s-.916.238-1.358.238-1.159-.037-1.359-.238S6.4 4.346 6.4 3.8s.046-1.162.246-1.362.917-.238 1.359-.238 1.158.037 1.358.238.237.816.237 1.362M1.772 10.78c-.124.04-.37.127-.578.335a1.4 1.4 0 0 0-.323.537 2.4 2.4 0 0 0-.1.422 5 5 0 0 0-.046.751c0 .224.009.497.047.75.019.128.048.276.099.423.046.134.136.35.323.537.208.208.454.296.578.334.149.046.3.073.426.09.255.034.52.041.705.041s.449-.007.703-.04l.433-.092c.124-.039.368-.127.574-.333.19-.19.28-.41.325-.544.05-.149.077-.298.095-.424.035-.253.042-.524.042-.742s-.007-.49-.042-.742a2.4 2.4 0 0 0-.095-.424 1.4 1.4 0 0 0-.325-.544 1.4 1.4 0 0 0-.578-.334 2.6 2.6 0 0 0-.426-.09 6 6 0 0 0-.706-.041c-.185 0-.45.008-.705.041a2.6 2.6 0 0 0-.426.09m2.253 2.045c0 .204-.007.417-.032.598q-.02.137-.051.234a.35.35 0 0 1-.073.137.4.4 0 0 1-.145.072 1.6 1.6 0 0 1-.253.052 5 5 0 0 1-.568.032 5 5 0 0 1-.567-.032 1.6 1.6 0 0 1-.253-.052.4.4 0 0 1-.145-.072.4.4 0 0 1-.074-.137 1.4 1.4 0 0 1-.054-.235 4 4 0 0 1-.035-.597c0-.203.009-.417.035-.597q.02-.136.054-.235a.4.4 0 0 1 .074-.137.4.4 0 0 1 .145-.072q.108-.034.253-.052a5 5 0 0 1 .567-.032c.165 0 .378.007.568.032q.145.02.253.052.108.035.145.072.04.038.073.137.032.098.051.234c.025.18.032.394.032.598",
		clipRule: "evenodd"
	})), _path3$139 || (_path3$139 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M6.294 11.115c.208-.208.454-.296.578-.334a2.6 2.6 0 0 1 .52-.101l-.56.434-.043.038c-.354.32-.593.791-.589 1.326a1.77 1.77 0 0 0 .606 1.316c.188.166.402.286.626.363q.157.444.396.84a5 5 0 0 1-.53-.038 2.6 2.6 0 0 1-.426-.09 1.4 1.4 0 0 1-.578-.334 1.4 1.4 0 0 1-.323-.537 2.4 2.4 0 0 1-.1-.422 5 5 0 0 1-.046-.751c0-.224.01-.496.047-.75a2.4 2.4 0 0 1 .099-.423 1.4 1.4 0 0 1 .323-.537"
	})), _path4$45 || (_path4$45 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M9.475 11.323c.086.073.135.18.135.292v1.09a2.11 2.11 0 0 0 2.098 2.048h.002c.442 0 .852-.138 1.19-.374.25-.174.61-.205.863.017.265.233.294.66 0 .89A3.3 3.3 0 0 1 11.71 16c-1.729 0-3.149-1.326-3.32-3.023a.71.71 0 0 1-.791-.084.57.57 0 0 1-.199-.424.57.57 0 0 1 .193-.426l.009-.007.923-.715A.7.7 0 0 1 9 11.137c.185 0 .355.07.476.186m5.552.954c-.175-1.692-1.593-3.013-3.319-3.013-.774 0-1.488.266-2.054.713-.293.231-.264.657.001.89.252.223.613.191.863.017a2.08 2.08 0 0 1 1.19-.373h.002a2.11 2.11 0 0 1 2.098 2.047v1.09c0 .113.05.22.135.293a.69.69 0 0 0 .476.186.7.7 0 0 0 .474-.184l.906-.715.007-.007a.57.57 0 0 0 .194-.426.57.57 0 0 0-.199-.424.71.71 0 0 0-.774-.094",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Email.svg
var _path$364;
var _path2$261;
function _extends$378() {
	return _extends$378 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$378.apply(null, arguments);
}
var SvgEmail = function SvgEmail(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$378({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$364 || (_path$364 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M12 3.7H4a1.8 1.8 0 0 0-1.8 1.8v5A1.8 1.8 0 0 0 4 12.3h8a1.8 1.8 0 0 0 1.8-1.8v-5A1.8 1.8 0 0 0 12 3.7M4 2.5a3 3 0 0 0-3 3v5a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-5a3 3 0 0 0-3-3z",
		clipRule: "evenodd"
	})), _path2$261 || (_path2$261 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M12.759 5.508 14 4.208 12.684 3.7 8.386 7.203a.53.53 0 0 1-.772 0L3.316 3.7 2 4.208l5.356 4.61a.88.88 0 0 0 1.286 0l4.116-3.31"
	})));
};

//#endregion
//#region src/Icon/icons/EthernetConfig.svg
var _path$363;
var _path2$260;
var _path3$138;
function _extends$377() {
	return _extends$377 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$377.apply(null, arguments);
}
var SvgEthernetConfig = function SvgEthernetConfig(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$377({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$363 || (_path$363 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M9.354 2.107c.856 0 1.555.67 1.602 1.514.324.157.587.42.744.743h.814c1.135 0 2.056.92 2.056 2.056v.923a3.1 3.1 0 0 0-1.223-.464v-.46a.833.833 0 0 0-.833-.832H10.98a.34.34 0 0 1-.341-.34v-.18a.38.38 0 0 0-.382-.382h-.18a.34.34 0 0 1-.342-.341v-.632c0-.21-.17-.382-.38-.382h-2.71c-.21 0-.38.171-.38.382v.973h-.522a.38.38 0 0 0-.382.381v.18a.34.34 0 0 1-.34.34H3.486a.833.833 0 0 0-.833.834v5.417c0 .46.373.833.833.833H3.6v-.972a.8.8 0 0 1 1.6 0v.972H6v-.972a.8.8 0 0 1 .485-.736c-.347.967-.202 2.103.432 2.93h-3.43a2.056 2.056 0 0 1-2.057-2.055V6.42c0-1.136.92-2.056 2.056-2.056H4.3c.157-.323.42-.586.744-.743a1.604 1.604 0 0 1 1.602-1.514z"
	})), _path2$260 || (_path2$260 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M14.716 10.305c.453-1.713-1.705-3-2.966-1.728-1.26-1.271-3.42.016-2.967 1.728-1.71.463-1.71 2.99 0 3.453-.454 1.713 1.707 3 2.967 1.729 1.26 1.272 3.421-.016 2.967-1.729 1.71-.462 1.71-2.991 0-3.453m-2.194-.78a.55.55 0 0 1 .75-.155.565.565 0 0 1 .243.737.972.972 0 0 0 .772 1.345c.678.082.678 1.078 0 1.16a.972.972 0 0 0-.772 1.345.564.564 0 0 1-.243.737.55.55 0 0 1-.75-.155.96.96 0 0 0-1.543 0 .55.55 0 0 1-.75.155.564.564 0 0 1-.243-.737.972.972 0 0 0-.772-1.344c-.678-.083-.678-1.079 0-1.161a.972.972 0 0 0 .772-1.345.565.565 0 0 1 .243-.737.55.55 0 0 1 .75.155.96.96 0 0 0 1.543 0",
		clipRule: "evenodd"
	})), _path3$138 || (_path3$138 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M12.55 12.032a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0"
	})));
};

//#endregion
//#region src/Icon/icons/EthernetDown.svg
var _path$362;
function _extends$376() {
	return _extends$376 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$376.apply(null, arguments);
}
var SvgEthernetDown = function SvgEthernetDown(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$376({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$362 || (_path$362 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M9.354 13.893c.856 0 1.555-.67 1.602-1.514.324-.157.587-.42.744-.743h.814c1.135 0 2.056-.92 2.056-2.056V4.163c0-1.135-.92-2.056-2.056-2.056H3.486c-1.135 0-2.056.92-2.056 2.056V9.58c0 1.135.92 2.056 2.056 2.056H4.3c.157.323.42.586.744.743a1.605 1.605 0 0 0 1.602 1.514zM5.2 3.33v.972a.8.8 0 0 1-1.6 0V3.33h-.114a.833.833 0 0 0-.833.833V9.58c0 .46.373.833.833.833h1.535a.34.34 0 0 1 .34.34v.181c0 .21.171.381.382.381h.521v.973c0 .21.171.382.382.382h2.708c.21 0 .382-.171.382-.382v-.632a.34.34 0 0 1 .34-.34h.18c.212 0 .382-.171.382-.382v-.18a.34.34 0 0 1 .341-.341h1.535c.46 0 .833-.373.833-.833V4.163a.833.833 0 0 0-.833-.833H12.4v.972a.8.8 0 0 1-1.6 0V3.33H10v.972a.8.8 0 1 1-1.6 0V3.33h-.8v.972a.8.8 0 0 1-1.6 0V3.33z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/EthernetDownCycle.svg
var _path$361;
var _path2$259;
function _extends$375() {
	return _extends$375 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$375.apply(null, arguments);
}
var SvgEthernetDownCycle = function SvgEthernetDownCycle(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$375({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$361 || (_path$361 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M7.282 13.893h-.636c-.856 0-1.555-.67-1.602-1.514a1.6 1.6 0 0 1-.744-.743h-.814A2.056 2.056 0 0 1 1.43 9.58V4.163c0-1.135.92-2.056 2.056-2.056h9.028c1.135 0 2.056.92 2.056 2.056V9.58q0 .073-.005.146a4.4 4.4 0 0 0-1.218-.843v-4.72a.833.833 0 0 0-.833-.833H12.4v.972a.8.8 0 0 1-1.6 0V3.33H10v.972a.8.8 0 0 1-1.6 0V3.33h-.8v.972a.8.8 0 0 1-1.6 0V3.33h-.8v.972a.8.8 0 0 1-1.6 0V3.33h-.114a.833.833 0 0 0-.833.833V9.58c0 .46.373.833.833.833h1.535a.34.34 0 0 1 .34.34v.181c0 .21.171.381.382.381h.521v.973c0 .21.171.382.382.382h.511a4.4 4.4 0 0 0 .125 1.223"
	})), _path2$259 || (_path2$259 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M13.428 12.395a1.966 1.966 0 1 0-.8 2.064c.238-.164.585-.198.83.016.25.219.29.63 0 .856a3.16 3.16 0 1 1 1.191-2.886l.283-.233a.68.68 0 0 1 .875.002.535.535 0 0 1 0 .822l-.004.004-1.279 1.035a.66.66 0 0 1-.456.176.66.66 0 0 1-.457-.176l-1.283-1.039a.535.535 0 0 1 0-.822.68.68 0 0 1 .875-.002z"
	})));
};

//#endregion
//#region src/Icon/icons/EthernetFlipped.svg
var _path$360;
var _path2$258;
function _extends$374() {
	return _extends$374 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$374.apply(null, arguments);
}
var SvgEthernetFlipped = function SvgEthernetFlipped(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$374({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$360 || (_path$360 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M10.888 12.333a1.535 1.535 0 0 1-1.534 1.49H6.646c-.833 0-1.51-.663-1.534-1.49a1.54 1.54 0 0 1-.768-.767h-.858A1.986 1.986 0 0 1 1.5 9.58V4.163c0-1.097.89-1.986 1.986-1.986h9.028c1.097 0 1.986.89 1.986 1.986V9.58c0 1.097-.89 1.986-1.986 1.986h-.858a1.54 1.54 0 0 1-.768.767m-1.082-.045c0 .25-.203.452-.452.452H6.646a.45.45 0 0 1-.452-.452v-.903h-.45a.45.45 0 0 1-.452-.451v-.18a.27.27 0 0 0-.271-.271H3.486a.903.903 0 0 1-.903-.903V4.163c0-.498.405-.903.903-.903h9.028c.498 0 .903.405.903.903V9.58a.903.903 0 0 1-.903.903h-1.535a.27.27 0 0 0-.27.27v.181c0 .25-.203.451-.452.451h-.18a.27.27 0 0 0-.271.271z",
		clipRule: "evenodd"
	})), _path2$258 || (_path2$258 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M6.736 4.073a.542.542 0 1 1-1.083 0V3.26h1.083zM10.347 4.073a.542.542 0 1 1-1.083 0V3.26h1.083zM12.153 4.073a.542.542 0 1 1-1.084 0V3.26h1.084zM4.93 4.073a.542.542 0 0 1-1.083 0V3.26h1.084zM8 4.615c.3 0 .542-.243.542-.542V3.26H7.458v.813c0 .3.243.542.542.542"
	})));
};

//#endregion
//#region src/Icon/icons/EthernetUp.svg
var _path$359;
function _extends$373() {
	return _extends$373 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$373.apply(null, arguments);
}
var SvgEthernetUp = function SvgEthernetUp(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$373({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$359 || (_path$359 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M9.354 2.107c.856 0 1.555.67 1.602 1.514.324.157.587.42.744.743h.814c1.135 0 2.056.92 2.056 2.056v5.417c0 1.135-.92 2.056-2.056 2.056H3.486a2.056 2.056 0 0 1-2.056-2.056V6.42c0-1.135.92-2.056 2.056-2.056H4.3c.157-.323.42-.586.744-.743a1.605 1.605 0 0 1 1.602-1.514zM5.2 12.67v-.972a.8.8 0 0 0-1.6 0v.972h-.114a.833.833 0 0 1-.833-.833V6.42c0-.46.373-.833.833-.833h1.535a.34.34 0 0 0 .34-.34v-.181c0-.21.171-.381.382-.381h.521v-.973c0-.21.171-.382.382-.382h2.708c.21 0 .382.171.382.382v.632c0 .188.152.34.34.34h.18c.212 0 .382.171.382.382v.18c0 .189.153.341.341.341h1.535c.46 0 .833.373.833.833v5.417c0 .46-.373.833-.833.833H12.4v-.972a.8.8 0 0 0-1.6 0v.972H10v-.972a.8.8 0 0 0-1.6 0v.972h-.8v-.972a.8.8 0 0 0-1.6 0v.972z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/EthernetUpCycle.svg
var _path$358;
var _path2$257;
function _extends$372() {
	return _extends$372 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$372.apply(null, arguments);
}
var SvgEthernetUpCycle = function SvgEthernetUpCycle(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$372({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$358 || (_path$358 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M10.956 3.621a1.605 1.605 0 0 0-1.602-1.514H6.646c-.856 0-1.555.67-1.602 1.514-.324.157-.587.42-.744.743h-.814c-1.135 0-2.056.92-2.056 2.056v5.417c0 1.135.92 2.056 2.056 2.056h3.796a4.37 4.37 0 0 1 .174-2.652.8.8 0 0 0-1.456.457v.972h-.8v-.972a.8.8 0 0 0-1.6 0v.972h-.114a.833.833 0 0 1-.833-.833V6.42c0-.46.373-.833.833-.833h1.535a.34.34 0 0 0 .34-.34v-.181c0-.21.171-.381.382-.381h.521v-.973c0-.21.171-.382.382-.382h2.708c.21 0 .382.171.382.382v.632c0 .188.152.34.34.34h.18c.212 0 .382.171.382.382v.18c0 .189.153.341.341.341h1.535c.46 0 .833.373.833.833v2.463c.456.211.869.5 1.223.848V6.42c0-1.136-.92-2.057-2.056-2.057H11.7a1.6 1.6 0 0 0-.744-.743"
	})), _path2$257 || (_path2$257 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M13.428 12.395a1.966 1.966 0 1 0-.8 2.064c.238-.164.585-.198.83.016.25.219.29.63 0 .856a3.16 3.16 0 1 1 1.191-2.886l.283-.233a.68.68 0 0 1 .875.002.535.535 0 0 1 0 .822l-.004.004-1.279 1.035a.66.66 0 0 1-.456.176.66.66 0 0 1-.457-.176l-1.283-1.039a.535.535 0 0 1 0-.822.68.68 0 0 1 .875-.002z"
	})));
};

//#endregion
//#region src/Icon/icons/EthernetUsage.svg
var _path$357;
var _path2$256;
var _path3$137;
function _extends$371() {
	return _extends$371 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$371.apply(null, arguments);
}
var SvgEthernetUsage = function SvgEthernetUsage(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$371({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$357 || (_path$357 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M5.2 11.698v.972H6v-.972a.8.8 0 0 1 1.09-.745c.258-.144.555-.226.87-.226h.05l.83-1.865a1.78 1.78 0 0 1 .934-.918 1.78 1.78 0 0 1 2.34.938l.973 2.277q.12-.104.26-.186V6.42a.833.833 0 0 0-.833-.833h-1.535a.34.34 0 0 1-.34-.34v-.181c0-.21-.171-.381-.382-.381h-.18a.34.34 0 0 1-.341-.341v-.632c0-.21-.171-.382-.382-.382H6.646c-.21 0-.382.171-.382.382v.973h-.521c-.21 0-.381.17-.381.381v.18a.34.34 0 0 1-.341.341H3.486a.833.833 0 0 0-.833.833v5.417c0 .46.373.833.833.833H3.6v-.972a.8.8 0 0 1 1.6 0",
		opacity: .25
	})), _path2$256 || (_path2$256 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M10.956 3.621a1.605 1.605 0 0 0-1.602-1.514H6.646c-.856 0-1.555.67-1.602 1.514-.324.157-.587.42-.744.743h-.814c-1.135 0-2.056.92-2.056 2.056v5.417c0 1.135.92 2.056 2.056 2.056h3.35a1.782 1.782 0 0 1 .255-2.94.8.8 0 0 0-1.09.745v.972h-.801v-.972a.8.8 0 0 0-1.6 0v.972h-.114a.833.833 0 0 1-.833-.833V6.42c0-.46.373-.833.833-.833h1.535a.34.34 0 0 0 .34-.34v-.181c0-.21.171-.381.382-.381h.521v-.973c0-.21.171-.382.382-.382h2.708c.21 0 .382.171.382.382v.632c0 .188.152.34.34.34h.18c.212 0 .382.171.382.382v.18c0 .189.153.341.341.341h1.535c.46 0 .833.373.833.833v4.553a1.78 1.78 0 0 1 .905-.246h.318V6.42c0-1.135-.92-2.056-2.056-2.056H11.7a1.6 1.6 0 0 0-.744-.743M10.377 13.893l-.024-.057q-.033.03-.067.057z"
	})), _path3$137 || (_path3$137 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M9.127 13.092H7.96a.583.583 0 0 1 0-1.165h.828L9.935 9.35a.58.58 0 0 1 .31-.303.58.58 0 0 1 .765.307l1.97 4.61.746-1.707.037-.066a.59.59 0 0 1 .488-.264h1.166a.583.583 0 0 1 0 1.165h-.772l-1.147 2.577a.5.5 0 0 1-.255.266l-.046.018a.583.583 0 0 1-.765-.307l-1.97-4.61-.76 1.703a.58.58 0 0 1-.452.34.6.6 0 0 1-.123.013"
	})));
};

//#endregion
//#region src/Icon/icons/Export.svg
var _path$356;
var _path2$255;
var _path3$136;
function _extends$370() {
	return _extends$370 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$370.apply(null, arguments);
}
var SvgExport = function SvgExport(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$370({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$356 || (_path$356 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M12.8 8a1 1 0 0 1 1 1v3.8a1 1 0 0 1-1 1H3.2a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h2.64v1.846C5.842 11.155 6.996 11.9 8 11.9l.19-.008c.953-.087 1.969-.818 1.97-2.046V8z",
		opacity: .25
	})), _path2$255 || (_path2$255 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M12.8 6.8A2.2 2.2 0 0 1 15 9v3.8a2.2 2.2 0 0 1-2.2 2.2H3.2A2.2 2.2 0 0 1 1 12.8V9a2.2 2.2 0 0 1 2.2-2.2h2.64V8H3.2l-.102.005A1 1 0 0 0 2.2 9v3.8a1 1 0 0 0 .898.995l.102.005h9.6a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-2.642V6.8z"
	})), _path3$136 || (_path3$136 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M8.959 9.846c0 .49-.45.854-.96.854-.509 0-.957-.364-.957-.854V3.888l-1.675 1.46a1.045 1.045 0 0 1-1.341 0 .792.792 0 0 1 0-1.222l3.273-2.855c.177-.168.427-.27.7-.271.274 0 .524.103.7.271l3.275 2.855a.793.793 0 0 1 0 1.223 1.045 1.045 0 0 1-1.34 0l-1.675-1.46z"
	})));
};

//#endregion
//#region src/Icon/icons/EyeClosed.svg
var _g$76;
var _path$355;
function _extends$369() {
	return _extends$369 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$369.apply(null, arguments);
}
var SvgEyeClosed = function SvgEyeClosed(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$369({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$76 || (_g$76 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M7.013 11.957q.476.114.975.116c.824 0 1.585-.213 2.28-.539a4.2 4.2 0 0 0 1.79-4.621zM8.97 4.06a5 5 0 0 0-.982-.102c-.906 0-1.74.274-2.498.677a4.2 4.2 0 0 0-1.547 4.452z" }))), _path$355 || (_path$355 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M5.858 13.112c.668.224 1.38.357 2.13.357 4.255 0 6.973-3.691 7.856-4.929a.82.82 0 0 0 .004-.955c-.367-.526-1.055-1.484-2.04-2.424l-1.072 1.073q.186.166.361.326c.354.323.773.797 1.053 1.124a.56.56 0 0 1-.005.74 13 13 0 0 1-1.026 1.069c-1.23 1.098-2.962 2.58-5.131 2.58q-.498-.002-.975-.116zM8.97 4.06a5 5 0 0 0-.982-.102c-2.098 0-3.811 1.467-5.074 2.608-.339.306-.747.754-1.027 1.074a.565.565 0 0 0 .013.764c.297.317.732.766 1.088 1.072l.305.261-1.08 1.08C1.272 9.94.578 9.062.184 8.564A.83.83 0 0 1 .161 7.55c.932-1.288 3.689-4.987 7.827-4.987.766 0 1.483.122 2.149.33zM2.697 13.303a.9.9 0 0 1 0-1.273l9.334-9.333a.9.9 0 0 1 1.272 1.273L3.97 13.303a.9.9 0 0 1-1.273 0"
	})));
};

//#endregion
//#region src/Icon/icons/EyeOpen.svg
var _path$354;
var _path2$254;
var _path3$135;
function _extends$368() {
	return _extends$368 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$368.apply(null, arguments);
}
var SvgEyeOpen = function SvgEyeOpen(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$368({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$354 || (_path$354 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M10.267 11.534a4.197 4.197 0 0 0 .206-6.926c-.75-.388-1.58-.65-2.485-.65-.906 0-1.74.274-2.498.677a4.197 4.197 0 0 0-.113 6.643c.804.466 1.68.795 2.61.795.825 0 1.586-.213 2.28-.539",
		opacity: .25
	})), _path2$254 || (_path2$254 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M7.988 2.563c-4.138 0-6.895 3.7-7.827 4.987a.83.83 0 0 0 .023 1.013c.989 1.253 3.876 4.906 7.804 4.906 4.255 0 6.973-3.691 7.856-4.929a.82.82 0 0 0 .004-.955c-.882-1.263-3.616-5.022-7.86-5.022M2.914 6.566c-.339.306-.747.754-1.027 1.074a.565.565 0 0 0 .013.764c.297.317.732.766 1.088 1.072 1.314 1.13 3.033 2.597 5 2.597 2.17 0 3.9-1.482 5.131-2.58.343-.306.751-.755 1.026-1.069a.56.56 0 0 0 .005-.74c-.28-.327-.7-.8-1.053-1.124-1.239-1.132-2.967-2.602-5.11-2.602-2.097 0-3.81 1.467-5.073 2.608",
		clipRule: "evenodd"
	})), _path3$135 || (_path3$135 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M9.8 8c0 .992-.808 1.8-1.8 1.8S6.2 8.992 6.2 8 7.008 6.2 8 6.2s1.8.808 1.8 1.8",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Filter.svg
var _path$353;
var _path2$253;
function _extends$367() {
	return _extends$367 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$367.apply(null, arguments);
}
var SvgFilter = function SvgFilter(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$367({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$353 || (_path$353 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M12.965 2.868c.334.38.37 1.001-.072 1.405L9.64 7.757c-.346.37-.538.859-.538 1.365v2.705a.6.6 0 0 1-.197.445l-1.17 1.062a.5.5 0 0 1-.837-.37V9.122a2 2 0 0 0-.232-.933q.316-.084.628-.19a9.7 9.7 0 0 0 5.67-5.13",
		opacity: .25
	})), _path2$253 || (_path2$253 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M12.22 1.333c1.979 0 2.936 2.399 1.543 3.764l-3.246 3.48a.8.8 0 0 0-.215.545v2.706a1.8 1.8 0 0 1-.59 1.332L8.54 14.221c-1.093.992-2.842.216-2.842-1.259v-3.84a.8.8 0 0 0-.216-.546l-3.24-3.474C.84 3.738 1.798 1.333 3.78 1.333zM9.1 9.123v2.705l-.012.125a.6.6 0 0 1-.184.319l-1.17 1.062-.062.048a.5.5 0 0 1-.775-.419v-3.84c0-.507-.192-.995-.538-1.366L3.107 4.273c-.675-.616-.24-1.74.674-1.74h8.438l.165.013c.798.126 1.142 1.15.51 1.727L9.638 7.757c-.345.37-.538.859-.538 1.365",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Fingerprint.svg
var _g$75;
var _path$352;
function _extends$366() {
	return _extends$366 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$366.apply(null, arguments);
}
var SvgFingerprint = function SvgFingerprint(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$366({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$75 || (_g$75 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .5
	}, /*#__PURE__*/ React.createElement("path", { d: "M9.878 14.898c-.477.092-.96.121-1.435.09L4.498 8.155a3.2 3.2 0 0 1-.375-1.039c-.068-.405.333-.687.73-.58.28.075.468.33.553.608q.06.2.17.389l2.547 4.413zM13.83 11.878c-.204.414-.46.805-.765 1.162l-2.306-3.993a.622.622 0 0 1 1.078-.622zM6.258 4.983a1.866 1.866 0 0 1 2.55.683l.924 1.602a.622.622 0 0 0 1.078-.622l-.925-1.602a3.11 3.11 0 0 0-5.186-.307c-.237.317-.03.74.352.842.292.078.591-.064.802-.28q.176-.183.405-.316" }))), _path$352 || (_path$352 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M3.148 8.218a4.355 4.355 0 0 1 4.714-5.921c.348.054.704-.137.795-.477.086-.323-.099-.66-.427-.722a5.58 5.58 0 0 0-3.838.653 5.6 5.6 0 0 0-2.326 7.102c.142.307.521.405.816.235.297-.172.394-.552.266-.87M3.131 10.764l.83 1.437a5.58 5.58 0 0 0 2.836 2.424l-2.583-4.473a.622.622 0 0 0-1.083.612M11.605 14.25a6 6 0 0 1-.553.28L9.83 12.415a.622.622 0 1 1 1.078-.622l1.222 2.116a6 6 0 0 1-.52.34zM13.658 6.604a5.58 5.58 0 0 1 .681 3.667l-3.377-5.849a4.3 4.3 0 0 0-1.226-1.358c-.238-.17-.368-.465-.292-.749.104-.388.538-.587.872-.362a5.6 5.6 0 0 1 1.72 1.84zM6.88 6.06a.62.62 0 0 1 .85.228L9.873 10a.622.622 0 0 1-1.078.622l-2.142-3.71a.62.62 0 0 1 .227-.85"
	})));
};

//#endregion
//#region src/Icon/icons/Firewall.svg
var _g$74;
var _path$351;
var _path2$252;
function _extends$365() {
	return _extends$365 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$365.apply(null, arguments);
}
var SvgFirewall = function SvgFirewall(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$365({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$74 || (_g$74 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M3.826 12.172a4.56 4.56 0 0 0 1.677 1.598 17 17 0 0 1-.702-.077c-.534-.07-1-.162-1.364-.275a3 3 0 0 1-.42-.164.7.7 0 0 1-.142-.089l-.019-.022zM13.166 2.835c.043.043.147.189.26.528.11.324.2.744.27 1.245.139 1.004.179 2.214.179 3.392s-.04 2.388-.18 3.392a7 7 0 0 1-.268 1.245c-.114.339-.218.485-.261.528a.7.7 0 0 1-.143.089c-.089.045-.224.103-.42.164-.363.113-.83.205-1.363.275q-.24.032-.489.057c.232-.142.456-.311.666-.518.206-.203.615-.614.944-1.239.341-.648.54-1.41.54-2.295 0-.746-.2-1.481-.392-2.043a15 15 0 0 0-.692-1.65 9 9 0 0 1-.452-1.372l1.8-1.799zM9.126 6.775c-.669.988-.585 1.577-.585 1.792 0 .685.213.813.084 1.519-.084.46-.71.696-1.094.508-.398-.305-.435-.442-.593-.973-.144-.705-.077-1.178-.1-1.396a.006.006 0 0 0-.011-.002c-.088.165-.503.874-.572 1.02-.21.444-.213.61-.2.991.015.473.355 1.221.772 1.438.396.26.691.39 1.203.39.549 0 .887-.104 1.097-.31.208-.205.548-.58.74-1.26.14-.496.121-1.169-.192-1.806-.313-.745-.435-1.351-.536-1.909-.002-.005-.01-.006-.013-.002" }))), _path$351 || (_path$351 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M7.776 3.348c.543-.801 1.978-.718 2.193.46.151.832.32 1.66.749 2.68.244.502.479 1.038.656 1.556.177.517.328 1.104.328 1.654 0 .698-.156 1.268-.402 1.737a3.8 3.8 0 0 1-.725.943c-.66.65-1.58.822-2.528.822-1.055 0-1.986-.347-2.665-.998-.679-.65-1.05-1.551-1.082-2.555-.029-.882.317-1.824.659-2.547.083-.176.58-1.26.731-1.545l.06-.102a1.13 1.13 0 0 1 1.201-.526c.17-.472.431-.998.825-1.58m.994.673c-1.03 1.519-.902 2.426-.902 2.756 0 1.055.372 1.174.372 1.89 0 .552-.604.895-.844.673-.186-.171-.23-.256-.473-1.073-.222-1.084-.119-1.813-.154-2.148a.01.01 0 0 0-.018-.003c-.134.254-.6 1.273-.706 1.496-.323.684-.565 1.41-.546 1.996.024.727.286 1.319.713 1.728S7.258 12 8.047 12c.843 0 1.365-.16 1.686-.477.322-.317.769-.802.769-1.825 0-.708-.406-1.757-.888-2.738-.482-1.146-.67-2.078-.826-2.937-.002-.008-.014-.01-.018-.002"
	})), _path2$252 || (_path2$252 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M14.015 14.012c.23-.231.41-.576.55-.995s.243-.917.319-1.46c.15-1.088.191-2.362.191-3.557s-.04-2.47-.191-3.556a8.3 8.3 0 0 0-.32-1.461c-.14-.419-.318-.764-.549-.995-.232-.233-.606-.412-1.056-.552a10 10 0 0 0-1.561-.319C10.258.966 8.988.925 8.02.925s-2.238.04-3.377.192a10 10 0 0 0-1.561.32c-.45.14-.825.318-1.057.55-.23.232-.411.577-.555.995a8.3 8.3 0 0 0-.333 1.461C.976 5.53.925 6.805.925 8s.05 2.47.212 3.557a8.3 8.3 0 0 0 .333 1.461c.144.418.325.763.555.994.232.233.606.412 1.057.552.453.14.991.243 1.56.319 1.14.151 2.41.192 3.378.192s2.239-.04 3.378-.192a10 10 0 0 0 1.56-.32c.451-.14.825-.318 1.057-.55M2.875 2.835c-.046.046-.153.196-.27.537a7 7 0 0 0-.281 1.247C2.175 5.62 2.125 6.829 2.125 8s.05 2.379.199 3.381c.074.501.169.922.28 1.247.118.34.225.49.271.537.01.01.052.043.142.089.09.045.225.103.42.164.364.112.83.205 1.364.275 1.064.142 2.275.182 3.22.182.943 0 2.155-.04 3.22-.182.533-.07.998-.163 1.362-.275a3 3 0 0 0 .42-.164.7.7 0 0 0 .143-.09c.042-.042.147-.188.26-.527.109-.324.2-.744.269-1.246.14-1.004.18-2.213.18-3.391s-.04-2.387-.18-3.391a7 7 0 0 0-.268-1.246c-.114-.34-.219-.485-.261-.528a.7.7 0 0 0-.143-.089 3 3 0 0 0-.42-.164 8.6 8.6 0 0 0-1.363-.275c-1.064-.142-2.276-.182-3.22-.182s-2.155.04-3.22.182c-.533.07-.999.163-1.362.275-.196.061-.331.119-.42.164a.7.7 0 0 0-.143.09",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Flag.svg
var _path$350;
var _path2$251;
var _path3$134;
var _path4$44;
function _extends$364() {
	return _extends$364 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$364.apply(null, arguments);
}
var SvgFlag = function SvgFlag(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$364({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$350 || (_path$350 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M1.269 1.7a.7.7 0 0 1 1.4 0v12.6a.7.7 0 1 1-1.4 0z"
	})), _path2$251 || (_path2$251 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M8.469 2.119h-7v8.2h4.693v-1.2H2.67v-5.8h5.8c.22 0 .4.179.4.4v.537h1.2v-.537a1.6 1.6 0 0 0-1.6-1.6"
	})), _path3$134 || (_path3$134 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M7.762 11.256a.4.4 0 0 1-.4-.4v-5c0-.221.18-.4.4-.4h5.717a.05.05 0 0 1 .044.073l-1.367 2.569a.5.5 0 0 0-.001.466l1.369 2.619a.05.05 0 0 1-.044.073zm0-7h5.717a1.25 1.25 0 0 1 1.104 1.837l-1.194 2.243 1.198 2.29a1.25 1.25 0 0 1-1.107 1.83H7.762a1.6 1.6 0 0 1-1.6-1.6v-5a1.6 1.6 0 0 1 1.6-1.6",
		clipRule: "evenodd"
	})), _path4$44 || (_path4$44 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M8.835 2.848a.6.6 0 0 1 .776.915L7.475 5.574a.6.6 0 1 1-.776-.915z"
	})));
};

//#endregion
//#region src/Icon/icons/FloorPlan.svg
var _path$349;
var _path2$250;
function _extends$363() {
	return _extends$363 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$363.apply(null, arguments);
}
var SvgFloorPlan = function SvgFloorPlan(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$363({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$349 || (_path$349 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M3.8 13.88a1.68 1.68 0 0 1-1.68-1.68V8.07H6.6c.445 0 .805.36.805.805v5.005z",
		clipRule: "evenodd",
		opacity: .25
	})), _path2$250 || (_path2$250 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M11.239 5.073V1.35a.42.42 0 0 1 .42-.42h.716a2.695 2.695 0 0 1 2.695 2.695v8.75a2.695 2.695 0 0 1-2.695 2.695h-8.75A2.695 2.695 0 0 1 .93 12.375v-8.75A2.695 2.695 0 0 1 3.625.93h4.558a.42.42 0 0 1 .42.42v.758a3.26 3.26 0 0 0 2.636 2.965m.961 8.807a1.68 1.68 0 0 0 1.68-1.68v-1.75H8.595v3.43zm-8.4 0a1.68 1.68 0 0 1-1.68-1.68V8.07H6.6c.445 0 .805.36.805.805v5.005zm8.033-7.56h-.008a4.445 4.445 0 0 1-4.413-4.2H3.625c-.831 0-1.505.674-1.505 1.505V6.88H6.6c1.102 0 1.995.893 1.995 1.995v.375h5.285V3.625c0-.813-.645-1.476-1.451-1.504v3.604a.596.596 0 0 1-.596.595",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Folder.svg
var _path$348;
var _path2$249;
var _path3$133;
function _extends$362() {
	return _extends$362 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$362.apply(null, arguments);
}
var SvgFolder = function SvgFolder(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$362({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$348 || (_path$348 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M3.9 2.2a1 1 0 0 0-1 1v1.442q.21-.041.433-.042h9.334q.223 0 .433.042V4.2a1 1 0 0 0-1-1H8.472a2 2 0 0 1-.894-.211L6.21 2.306a1 1 0 0 0-.447-.106z",
		clipRule: "evenodd",
		opacity: .25
	})), _path2$249 || (_path2$249 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M14.3 5.2v-1A2.2 2.2 0 0 0 12.1 2H8.472a.8.8 0 0 1-.358-.084l-1.366-.684A2.2 2.2 0 0 0 5.764 1H3.9a2.2 2.2 0 0 0-2.2 2.2v2q0 .061.003.122a2.2 2.2 0 0 0-.553 1.75l.75 6A2.2 2.2 0 0 0 4.083 15h7.834a2.2 2.2 0 0 0 2.183-1.927l.75-6a2.2 2.2 0 0 0-.553-1.751q.003-.06.003-.122m-10.4-3a1 1 0 0 0-1 1v1.442q.21-.041.433-.042h9.334q.223 0 .433.042V4.2a1 1 0 0 0-1-1H8.472a2 2 0 0 1-.894-.211L6.21 2.306a1 1 0 0 0-.447-.106zM2.34 6.924l.75 6a1 1 0 0 0 .993.876h7.834a1 1 0 0 0 .992-.876l.75-6q.012-.09.007-.179a1 1 0 0 0-.999-.945H3.333q-.111 0-.215.023a1 1 0 0 0-.778 1.101",
		clipRule: "evenodd"
	})), _path3$133 || (_path3$133 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M5 7.617c0-.332.27-.601.602-.601h4.796a.602.602 0 1 1 0 1.203H5.602A.6.6 0 0 1 5 7.617"
	})));
};

//#endregion
//#region src/Icon/icons/Gateway.svg
var _g$73;
var _path$347;
var _path2$248;
function _extends$361() {
	return _extends$361 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$361.apply(null, arguments);
}
var SvgGateway = function SvgGateway(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$361({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$73 || (_g$73 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M13.166 2.835c.043.043.147.189.26.528.11.324.2.744.27 1.245.139 1.004.179 2.214.179 3.392s-.04 2.388-.18 3.392a7 7 0 0 1-.268 1.245c-.114.339-.218.485-.261.528a.7.7 0 0 1-.143.089c-.089.045-.224.103-.42.164-.363.113-.83.205-1.363.275-1.064.142-2.276.182-3.22.182-.943 0-2.155-.04-3.22-.182-.533-.07-.999-.162-1.362-.275a3 3 0 0 1-.42-.164.7.7 0 0 1-.143-.089l-.019-.022 1.026-1.027a5.8 5.8 0 0 0 2.632 1.394l-.01.017.028-.013a5.83 5.83 0 0 0 7.129-5.683c0-1.524-.586-2.91-1.545-3.95l1.049-1.047z" }), /*#__PURE__*/ React.createElement("path", { d: "M4.455 8.43a3.43 3.43 0 0 0 2.105 2.585L5.795 8.43zm2.403 0c.1.897.422 1.774.972 2.539.55-.765.873-1.641.973-2.538zm3.153 0c-.08.871-.33 1.729-.756 2.52a3.43 3.43 0 0 0 1.951-2.52z" }))), _path$347 || (_path$347 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M7.831 3.2a4.631 4.631 0 1 1-.002 9.262A4.631 4.631 0 0 1 7.83 3.2M4.455 8.43a3.43 3.43 0 0 0 2.105 2.585L5.795 8.43zm2.403 0c.1.897.422 1.774.972 2.539.55-.765.873-1.641.973-2.538zm3.153 0c-.08.871-.33 1.729-.756 2.52a3.43 3.43 0 0 0 1.951-2.52zM6.406 4.71a3.43 3.43 0 0 0-1.95 2.52H5.65c.08-.87.33-1.729.756-2.52m1.424-.019a5.36 5.36 0 0 0-.972 2.54h1.945a5.36 5.36 0 0 0-.973-2.54m1.425.02c.426.79.676 1.649.756 2.52h1.195a3.43 3.43 0 0 0-1.951-2.52"
	})), _path2$248 || (_path2$248 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M14.015 14.012c.23-.231.41-.576.55-.995s.243-.917.319-1.46c.15-1.088.191-2.362.191-3.557s-.04-2.47-.191-3.556a8.3 8.3 0 0 0-.32-1.461c-.14-.419-.318-.764-.549-.995-.232-.233-.606-.412-1.056-.552a10 10 0 0 0-1.561-.319C10.258.966 8.988.925 8.02.925s-2.238.04-3.377.192a10 10 0 0 0-1.561.32c-.45.14-.825.318-1.057.55-.23.232-.411.577-.555.995a8.3 8.3 0 0 0-.333 1.461C.976 5.53.925 6.805.925 8s.05 2.47.212 3.557a8.3 8.3 0 0 0 .333 1.461c.144.418.325.763.555.994.232.233.606.412 1.057.552.453.14.991.243 1.56.319 1.14.151 2.41.192 3.378.192s2.239-.04 3.378-.192a10 10 0 0 0 1.56-.32c.451-.14.825-.318 1.057-.55M2.875 2.835c-.046.046-.153.196-.27.537a7 7 0 0 0-.281 1.247C2.175 5.62 2.125 6.829 2.125 8s.05 2.379.199 3.381c.074.501.169.922.28 1.247.118.34.225.49.271.537.01.01.052.043.142.089.09.045.225.103.42.164.364.112.83.205 1.364.275 1.064.142 2.275.182 3.22.182.943 0 2.155-.04 3.22-.182.533-.07.998-.163 1.362-.275a3 3 0 0 0 .42-.164.7.7 0 0 0 .143-.09c.042-.042.147-.188.26-.527.109-.324.2-.744.269-1.246.14-1.004.18-2.213.18-3.391s-.04-2.387-.18-3.391a7 7 0 0 0-.268-1.246c-.114-.34-.219-.485-.261-.528a.7.7 0 0 0-.143-.089 3 3 0 0 0-.42-.164 8.6 8.6 0 0 0-1.363-.275c-1.064-.142-2.276-.182-3.22-.182s-2.155.04-3.22.182c-.533.07-.999.163-1.362.275-.196.061-.331.119-.42.164a.7.7 0 0 0-.143.09",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Gavel.svg
var _path$346;
var _path2$247;
function _extends$360() {
	return _extends$360 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$360.apply(null, arguments);
}
var SvgGavel = function SvgGavel(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$360({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$346 || (_path$346 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M9.03 6.26 6.876 4.106l-2.77 2.77L6.26 9.03z",
		clipRule: "evenodd",
		opacity: .25
	})), _path2$247 || (_path2$247 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M14.724 14.724a2.65 2.65 0 0 1-3.967-.247L7.215 9.922l-.301.301a2.067 2.067 0 0 1-3.5 1.807L1.106 9.724a2.067 2.067 0 0 1 1.807-3.5l3.31-3.31a2.067 2.067 0 0 1 3.5-1.808l2.308 2.309a2.067 2.067 0 0 1-1.808 3.5l-.3.301 4.554 3.542a2.65 2.65 0 0 1 .247 3.967M9.03 6.26 6.876 4.106l-2.77 2.77L6.26 9.03zm4.77 7.54a1.345 1.345 0 0 0-.125-2.012L8.992 8.145l-.847.847 3.643 4.683c.497.639 1.44.697 2.012.125M7.722 2.03a.76.76 0 0 0 0 1.077l2.308 2.308a.762.762 0 1 0 1.078-1.077L8.799 2.029a.76.76 0 0 0-1.077 0M2.03 7.722a.76.76 0 0 0 0 1.077l2.308 2.309a.762.762 0 1 0 1.077-1.078L3.106 7.722a.76.76 0 0 0-1.077 0",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Globe.svg
var _path$345;
var _path2$246;
function _extends$359() {
	return _extends$359 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$359.apply(null, arguments);
}
var SvgGlobe = function SvgGlobe(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$359({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$345 || (_path$345 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8.078 13.529A8.94 8.94 0 0 0 9.954 8.7a.1.1 0 0 0-.102-.109H6.148c-.06 0-.107.05-.102.109.134 1.716.76 3.4 1.876 4.827.04.051.116.051.156 0m1.61.074a5.86 5.86 0 0 0 4.12-4.9.1.1 0 0 0-.1-.11h-2.46a.106.106 0 0 0-.106.1 10.13 10.13 0 0 1-1.558 4.755.11.11 0 0 0 .001.12.09.09 0 0 0 .104.035m-4.83-4.91a.106.106 0 0 0-.106-.1h-2.46a.1.1 0 0 0-.1.11 5.86 5.86 0 0 0 4.12 4.9",
		clipRule: "evenodd",
		opacity: .25
	})), _path2$246 || (_path2$246 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8.078 13.529A8.94 8.94 0 0 0 9.954 8.7a.1.1 0 0 0-.102-.109H6.148c-.06 0-.107.05-.102.109.134 1.716.759 3.4 1.876 4.827.04.051.116.051.156 0m1.61.074a5.86 5.86 0 0 0 4.12-4.9.1.1 0 0 0-.1-.11h-2.46a.106.106 0 0 0-.106.1 10.13 10.13 0 0 1-1.558 4.755.11.11 0 0 0 .001.12.09.09 0 0 0 .104.035M6.047 7.299a.1.1 0 0 0 .102.109h3.704c.06 0 .107-.05.102-.109a8.94 8.94 0 0 0-1.876-4.828.098.098 0 0 0-.156 0A8.94 8.94 0 0 0 6.046 7.3M4.858 8.692a.106.106 0 0 0-.106-.1h-2.46a.1.1 0 0 0-.1.111 5.86 5.86 0 0 0 4.12 4.9M15.035 8A7.035 7.035 0 1 1 .965 8a7.035 7.035 0 0 1 14.07 0m-1.327-.592a.1.1 0 0 0 .1-.111 5.86 5.86 0 0 0-4.12-4.9.09.09 0 0 0-.103.035.105.105 0 0 0-.001.12 10.13 10.13 0 0 1 1.558 4.756c.004.056.05.1.106.1zm-8.956 0a.106.106 0 0 0 .106-.1 10.1 10.1 0 0 1 1.558-4.756.105.105 0 0 0-.001-.12.09.09 0 0 0-.104-.035 5.86 5.86 0 0 0-4.12 4.9.1.1 0 0 0 .101.11z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/GlobeOne.svg
var _g$72;
var _path$344;
var _path2$245;
function _extends$358() {
	return _extends$358 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$358.apply(null, arguments);
}
var SvgGlobeOne = function SvgGlobeOne(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$358({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$72 || (_g$72 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .2
	}, /*#__PURE__*/ React.createElement("path", { d: "M6.946 8.592h-.798c-.06 0-.107.05-.102.109a9 9 0 0 0 .218 1.388c.154-.536.385-1.04.682-1.497M4.752 8.592c.055 0 .102.044.106.1l1.454 4.911a5.86 5.86 0 0 1-4.12-4.9.1.1 0 0 1 .1-.11zM16 11.625a4.375 4.375 0 1 1-8.75 0 4.375 4.375 0 0 1 8.75 0" }))), _path$344 || (_path$344 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M6.264 10.09a5.6 5.6 0 0 0-.214 1.535 5.55 5.55 0 0 0 1.128 3.363 7.036 7.036 0 1 1 7.81-7.81 5.6 5.6 0 0 0-1.352-.754 5.86 5.86 0 0 0-3.947-4.027.09.09 0 0 0-.104.035.105.105 0 0 0-.001.12 10.1 10.1 0 0 1 1.4 3.534q-.6.07-1.156.26a8.93 8.93 0 0 0-1.75-3.875.098.098 0 0 0-.156 0A8.94 8.94 0 0 0 6.046 7.3a.1.1 0 0 0 .102.109h1.83a5.6 5.6 0 0 0-1.032 1.184h-.798c-.06 0-.107.05-.102.109a9 9 0 0 0 .218 1.388M4.752 8.592c.055 0 .102.044.106.1l1.454 4.91a5.86 5.86 0 0 1-4.12-4.899.1.1 0 0 1 .1-.11zm.106-1.284a.106.106 0 0 1-.106.1h-2.46a.1.1 0 0 1-.1-.111 5.86 5.86 0 0 1 4.12-4.9.09.09 0 0 1 .103.035.105.105 0 0 1 .001.12 10.1 10.1 0 0 0-1.558 4.756",
		clipRule: "evenodd"
	})), _path2$245 || (_path2$245 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M11.549 14.443h1.008V8.807h-1.004L10.08 9.842v.949l1.402-.992h.067z"
	})));
};

//#endregion
//#region src/Icon/icons/GlobeThree.svg
var _g$71;
var _path$343;
var _path2$244;
function _extends$357() {
	return _extends$357 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$357.apply(null, arguments);
}
var SvgGlobeThree = function SvgGlobeThree(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$357({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$71 || (_g$71 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .2
	}, /*#__PURE__*/ React.createElement("path", { d: "M6.946 8.592h-.798c-.06 0-.107.05-.102.109a9 9 0 0 0 .218 1.388c.154-.536.385-1.04.682-1.497M4.752 8.592c.055 0 .102.044.106.1l1.454 4.911a5.86 5.86 0 0 1-4.12-4.9.1.1 0 0 1 .1-.11zM16 11.625a4.375 4.375 0 1 1-8.75 0 4.375 4.375 0 0 1 8.75 0" }))), _path$343 || (_path$343 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M6.264 10.09a5.6 5.6 0 0 0-.214 1.535 5.55 5.55 0 0 0 1.128 3.363 7.036 7.036 0 1 1 7.81-7.81 5.6 5.6 0 0 0-1.352-.754 5.86 5.86 0 0 0-3.947-4.027.09.09 0 0 0-.104.035.105.105 0 0 0-.001.12 10.1 10.1 0 0 1 1.401 3.534q-.601.07-1.157.26a8.93 8.93 0 0 0-1.75-3.875.098.098 0 0 0-.156 0A8.94 8.94 0 0 0 6.046 7.3a.1.1 0 0 0 .102.109h1.83a5.6 5.6 0 0 0-1.032 1.184h-.798c-.06 0-.107.05-.102.109a9 9 0 0 0 .218 1.388M4.752 8.592c.055 0 .102.044.106.1l1.454 4.91a5.86 5.86 0 0 1-4.12-4.899.1.1 0 0 1 .1-.11zm.106-1.284a.106.106 0 0 1-.106.1h-2.46a.1.1 0 0 1-.1-.111 5.86 5.86 0 0 1 4.12-4.9.09.09 0 0 1 .103.035.105.105 0 0 1 .001.12 10.1 10.1 0 0 0-1.558 4.756",
		clipRule: "evenodd"
	})), _path2$244 || (_path2$244 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M11.633 14.557c1.25 0 2.105-.692 2.105-1.684v-.008c0-.781-.55-1.273-1.379-1.351v-.02c.676-.14 1.18-.605 1.18-1.304v-.008c0-.883-.754-1.489-1.914-1.489-1.137 0-1.906.641-1.992 1.617l-.004.043h.937l.004-.038c.051-.504.461-.82 1.055-.82.602 0 .95.304.95.82v.007c0 .493-.415.844-1.036.844h-.644v.75h.664c.722 0 1.16.328 1.16.922v.008c0 .523-.434.886-1.086.886-.66 0-1.102-.34-1.156-.816l-.004-.043h-.961l.004.047c.074.965.882 1.637 2.117 1.637"
	})));
};

//#endregion
//#region src/Icon/icons/GlobeTwo.svg
var _g$70;
var _path$342;
var _path2$243;
function _extends$356() {
	return _extends$356 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$356.apply(null, arguments);
}
var SvgGlobeTwo = function SvgGlobeTwo(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$356({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$70 || (_g$70 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .2
	}, /*#__PURE__*/ React.createElement("path", { d: "M6.946 8.592h-.798c-.06 0-.107.05-.102.109a9 9 0 0 0 .218 1.388c.154-.536.385-1.04.682-1.497M4.752 8.592c.055 0 .102.044.106.1l1.454 4.911a5.86 5.86 0 0 1-4.12-4.9.1.1 0 0 1 .1-.11zM16 11.625a4.375 4.375 0 1 1-8.75 0 4.375 4.375 0 0 1 8.75 0" }))), _path$342 || (_path$342 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M6.264 10.09a5.6 5.6 0 0 0-.214 1.535 5.55 5.55 0 0 0 1.128 3.363 7.036 7.036 0 1 1 7.81-7.81 5.6 5.6 0 0 0-1.352-.754 5.86 5.86 0 0 0-3.947-4.027.09.09 0 0 0-.104.035.105.105 0 0 0-.001.12 10.1 10.1 0 0 1 1.4 3.534q-.6.07-1.156.26a8.93 8.93 0 0 0-1.75-3.875.098.098 0 0 0-.156 0A8.94 8.94 0 0 0 6.046 7.3a.1.1 0 0 0 .102.109h1.83a5.6 5.6 0 0 0-1.032 1.184h-.798c-.06 0-.107.05-.102.109a9 9 0 0 0 .218 1.388M4.752 8.592c.055 0 .102.044.106.1l1.454 4.91a5.86 5.86 0 0 1-4.12-4.899.1.1 0 0 1 .1-.11zm.106-1.284a.106.106 0 0 1-.106.1h-2.46a.1.1 0 0 1-.1-.111 5.86 5.86 0 0 1 4.12-4.9.09.09 0 0 1 .103.035.105.105 0 0 1 .001.12 10.1 10.1 0 0 0-1.558 4.756",
		clipRule: "evenodd"
	})), _path2$243 || (_path2$243 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M9.708 14.514h3.914v-.836H11.07v-.082l1.129-1.094c1.027-.988 1.336-1.496 1.336-2.137v-.011c0-.95-.79-1.618-1.887-1.618-1.176 0-1.996.735-1.996 1.785l.004.012.938.004.003-.016c0-.582.403-.976 1-.976.586 0 .942.375.942.895v.011c0 .434-.215.719-.98 1.492l-1.852 1.891z"
	})));
};

//#endregion
//#region src/Icon/icons/Group.svg
var _g$69;
var _path$341;
var _path2$242;
var _path3$132;
function _extends$355() {
	return _extends$355 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$355.apply(null, arguments);
}
var SvgGroup = function SvgGroup(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$355({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$69 || (_g$69 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M8.28 12.09a4 4 0 0 1-.274.01h-.002a5 5 0 0 1-.728-.058 8 8 0 0 1-.413-.072c-.22-.045-.447-.1-.672-.16a15 15 0 0 1-.488-.141c-.465-.143-.94-.311-1.398-.486q-.246.11-.486.224c.34.16.723.328 1.122.493.667.277 1.369.543 1.998.736q.473.145.795.21.165.032.236.04l.024.002.013-.002q.073-.007.261-.048c.239-.052.533-.133.866-.238a25 25 0 0 0 1.903-.705c.35-.145.746-.317 1.116-.493q-.235-.11-.49-.221c-.397.15-.83.304-1.262.441q-.244.078-.49.148c-.238.067-.478.13-.713.18q-.216.048-.432.083-.242.04-.486.057M8.28 8.69q-.136.01-.274.01h-.002c-.243 0-.49-.023-.728-.058a8 8 0 0 1-.413-.072c-.22-.045-.447-.1-.672-.16a15 15 0 0 1-.488-.141c-.465-.143-.94-.311-1.398-.486q-.246.11-.486.224c.34.16.723.328 1.122.493.667.277 1.369.543 1.998.737q.473.143.795.209.165.032.236.04l.024.002.013-.002q.073-.007.261-.048c.239-.052.533-.133.866-.238a25 25 0 0 0 1.903-.705c.35-.145.746-.317 1.116-.493q-.235-.11-.49-.221c-.397.15-.83.304-1.262.441q-.244.078-.49.148c-.238.067-.478.13-.713.18q-.216.048-.432.083-.242.04-.486.057" }))), _path$341 || (_path$341 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M11.662 11.18q.257.113.49.222c-.369.176-.764.348-1.115.493-.536.222-1.237.493-1.903.705-.333.105-.627.186-.866.238a3 3 0 0 1-.26.048l-.014.002-.024-.003a3 3 0 0 1-.236-.04 9 9 0 0 1-.795-.209c-.63-.193-1.33-.46-1.998-.736a25 25 0 0 1-1.122-.493q.24-.114.486-.224a31 31 0 0 1-.906-.36 30 30 0 0 1-1.037-.451 12 12 0 0 0-.596.32 5 5 0 0 0-.32.2q-.086.06-.157.116c-.181.142-.295.276-.294.388v.002c.002.111.097.238.255.372.12.102.279.21.464.321q.093.056.194.112.236.132.51.267c.443.218.946.439 1.44.644q.244.1.496.2c.557.222 1.143.436 1.701.608q.228.07.449.13.31.083.597.142.178.037.348.061.297.044.556.045.093 0 .192-.007.18-.013.379-.045a7 7 0 0 0 .366-.07q.31-.068.642-.163.226-.063.454-.137a25 25 0 0 0 2.081-.77c.407-.168.893-.38 1.348-.6a13 13 0 0 0 .756-.4q.176-.102.32-.2.086-.06.157-.115c.181-.143.295-.277.295-.389v-.003c-.002-.11-.1-.236-.26-.37a4 4 0 0 0-.469-.318l-.197-.112a12 12 0 0 0-.456-.235 29 29 0 0 1-1.55.66z"
	})), _path2$242 || (_path2$242 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M11.662 7.78q.257.113.49.222c-.369.176-.764.348-1.115.493-.536.222-1.237.493-1.903.705-.333.105-.627.186-.866.238a3 3 0 0 1-.26.048l-.014.002-.024-.003a3 3 0 0 1-.236-.04 9 9 0 0 1-.795-.208A23 23 0 0 1 4.94 8.5a25 25 0 0 1-1.122-.493q.24-.114.486-.224a32 32 0 0 1-.906-.36 30 30 0 0 1-1.037-.451 13 13 0 0 0-.596.32 5 5 0 0 0-.32.2q-.086.06-.157.115c-.181.143-.295.277-.294.389v.002c.002.112.097.238.255.372.12.102.279.21.464.321q.093.056.194.112.236.132.51.267c.443.218.946.439 1.44.644q.244.1.496.2c.557.222 1.143.436 1.701.608q.228.07.449.13.31.083.597.142.178.036.348.061.297.044.556.045.093 0 .192-.007.18-.013.379-.045a7 7 0 0 0 .366-.07q.31-.068.642-.163.226-.063.454-.137a25 25 0 0 0 2.081-.77c.407-.168.893-.38 1.348-.6a13 13 0 0 0 .756-.4 5 5 0 0 0 .32-.2q.086-.06.157-.115c.181-.143.295-.277.295-.389v-.003c-.002-.11-.1-.236-.26-.37a3.6 3.6 0 0 0-.469-.318L14.07 7.2a12 12 0 0 0-.456-.235 29 29 0 0 1-1.55.66z"
	})), _path3$132 || (_path3$132 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M14.995 4.601v.003c0 .112-.114.246-.295.389a3 3 0 0 1-.157.114 5 5 0 0 1-.32.201 13.47 13.47 0 0 1-.757.4 25 25 0 0 1-1.843.801c-.48.19-1.035.395-1.585.57q-.228.073-.454.136-.332.095-.642.163a7 7 0 0 1-.366.07 4 4 0 0 1-.379.045q-.1.007-.191.007h-.001q-.26 0-.556-.045a7 7 0 0 1-.348-.061 10 10 0 0 1-.597-.143q-.22-.06-.449-.13a23 23 0 0 1-1.7-.606 35 35 0 0 1-.497-.201 25 25 0 0 1-1.44-.644 11 11 0 0 1-.704-.379 3.6 3.6 0 0 1-.464-.32c-.158-.135-.253-.261-.255-.372v-.003c0-.112.113-.246.294-.389q.072-.056.157-.114.145-.099.32-.201.118-.069.247-.139c.16-.087.333-.174.51-.26a25 25 0 0 1 1.843-.802c.48-.19 1.036-.395 1.585-.57q.23-.072.455-.136.332-.095.641-.163.189-.041.367-.07a4 4 0 0 1 .378-.045q.1-.007.191-.007h.002q.256 0 .547.045.171.025.353.063.283.058.585.142.223.061.453.133c.553.174 1.134.39 1.689.611q.252.101.495.202c.496.206 1.004.426 1.452.643a12 12 0 0 1 .707.374c.187.11.347.217.469.318.16.134.258.26.26.37m-3.958.494a24 24 0 0 0 1.116-.493c-.342-.16-.728-.326-1.128-.492-.676-.28-1.373-.55-1.998-.745a8 8 0 0 0-.786-.211 3 3 0 0 0-.23-.04l-.017-.002-.012.002q-.074.007-.26.048c-.24.052-.533.133-.867.238-.666.212-1.367.483-1.903.705-.356.147-.758.323-1.133.502.34.16.723.328 1.122.493.667.277 1.369.543 1.998.737q.473.144.795.209.165.032.236.04l.024.002.013-.002q.073-.007.261-.048c.239-.052.533-.133.866-.238a25 25 0 0 0 1.903-.705",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Hamina.svg
var _path$340;
function _extends$354() {
	return _extends$354 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$354.apply(null, arguments);
}
var SvgHamina = function SvgHamina(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$354({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$340 || (_path$340 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "m12.65 7.052 1.803-.214a.2.2 0 0 0 .132-.076.2.2 0 0 0 .042-.15l-.06-.56-.223-.138-.034-.02a1.16 1.16 0 0 0-.51-.23 6 6 0 0 0-1.126.089h-.072l-.309.04.13 1.077a.2.2 0 0 0 .143.177.2.2 0 0 0 .079.005zm-2.66 4.615a.2.2 0 0 0 .135-.077l.65-.833a.22.22 0 0 0 .043-.154.2.2 0 0 0-.078-.14L9.141 9.189l-.226.264a.14.14 0 0 1-.083.047l-.209.038a.14.14 0 0 0-.092.055.15.15 0 0 0-.028.106l.22 1.907a.2.2 0 0 0 .076.138.2.2 0 0 0 .148.044zm-.14-3.688a.14.14 0 0 0-.092.051.15.15 0 0 0-.033.102v.22a.14.14 0 0 1-.03.093l-.196.28 1.596 1.281a.2.2 0 0 0 .225.021.2.2 0 0 0 .06-.053l.653-.833a.21.21 0 0 0 .04-.156l-.123-1.05a.199.199 0 0 0-.22-.18zm-3.338-.912L4.911 5.785a.2.2 0 0 0-.286.035l-.653.833a.21.21 0 0 0-.043.156l.126 1.047a.2.2 0 0 0 .076.137q.03.025.07.036.038.011.078.006l1.879-.223a.14.14 0 0 0 .092-.051.15.15 0 0 0 .034-.102v-.217q-.001-.051.028-.094zm3.03-.1a.15.15 0 0 1 .051.09l.032.212q.01.058.056.091a.14.14 0 0 0 .1.03l1.88-.226a.2.2 0 0 0 .134-.076.2.2 0 0 0 .044-.15l-.118-1.05a.2.2 0 0 0-.077-.138l-.82-.663a.2.2 0 0 0-.227-.019.2.2 0 0 0-.06.054L9.273 6.744zM7.873 4.122l.22 1.906a.15.15 0 0 0 .052.095.14.14 0 0 0 .1.034l.212-.014a.13.13 0 0 1 .094.029l.286.205 1.261-1.616a.2.2 0 0 0 .046-.154.2.2 0 0 0-.077-.14l-.838-.656a.19.19 0 0 0-.146-.044l-1.041.126a.2.2 0 0 0-.13.08.21.21 0 0 0-.039.149m-1.093 7.861a.2.2 0 0 0 .15.041l1.037-.126a.197.197 0 0 0 .133-.077.2.2 0 0 0 .042-.152l-.22-1.906a.15.15 0 0 0-.05-.095.14.14 0 0 0-.1-.034h-.22a.15.15 0 0 1-.091-.027l-.272-.202-1.261 1.628a.21.21 0 0 0 .031.293zM4.37 10.044l.821.657a.2.2 0 0 0 .226.021.2.2 0 0 0 .06-.053L6.73 9.047l-.26-.229a.15.15 0 0 1-.046-.085l-.037-.214a.15.15 0 0 0-.057-.091.14.14 0 0 0-.1-.03l-1.883.232a.2.2 0 0 0-.168.15.2.2 0 0 0-.007.08l.12 1.052c.009.053.037.1.078.132m1.662-5.917a.19.19 0 0 0-.132.077l-.65.83a.2.2 0 0 0-.045.153.2.2 0 0 0 .077.14l1.591 1.28.217-.265a.15.15 0 0 1 .089-.05l.209-.035a.14.14 0 0 0 .092-.055.15.15 0 0 0 .028-.106l-.206-1.907a.2.2 0 0 0-.074-.138.2.2 0 0 0-.146-.044zm2.002 8.364-1.281.146a.2.2 0 0 1-.146-.044l-1.021-.81a.2.2 0 0 0-.15-.042.2.2 0 0 0-.136.078l-1.144 1.45a.21.21 0 0 0 .031.293l1.736 1.393A.2.2 0 0 0 6.07 15l2.194-.264a.2.2 0 0 0 .134-.075.2.2 0 0 0 .043-.15l-.209-1.834a.2.2 0 0 0-.064-.13.2.2 0 0 0-.133-.055m3.476-1.4a.2.2 0 0 0-.15-.045.2.2 0 0 0-.136.078l-.799 1.027a.22.22 0 0 1-.131.076l-1.276.15a.2.2 0 0 0-.134.077.2.2 0 0 0-.043.151l.212 1.834a.2.2 0 0 0 .075.138.2.2 0 0 0 .148.044l2.196-.258a.2.2 0 0 0 .135-.077l1.37-1.76a.21.21 0 0 0-.032-.293zm-6.688.071-1.001-.81a.2.2 0 0 1-.078-.135l-.16-1.293a.203.203 0 0 0-.143-.173.2.2 0 0 0-.077-.006l-1.813.214a.2.2 0 0 0-.134.075.2.2 0 0 0-.04.15l.25 2.227a.2.2 0 0 0 .078.138l1.733 1.394q.032.026.07.038a.2.2 0 0 0 .156-.017.2.2 0 0 0 .06-.054l1.145-1.466a.21.21 0 0 0-.046-.282m9.917-3.553a.21.21 0 0 0-.145-.173.2.2 0 0 0-.078-.006l-1.81.212a.2.2 0 0 0-.133.076.2.2 0 0 0-.042.15l.14 1.3a.22.22 0 0 1-.043.152l-.792 1.02a.2.2 0 0 0-.044.154.22.22 0 0 0 .075.14l1.43 1.147a.2.2 0 0 0 .286-.032l1.373-1.76A.2.2 0 0 0 15 9.836zm-11.442.54a.2.2 0 0 0 .135-.077.2.2 0 0 0 .043-.152l-.143-1.293a.2.2 0 0 1 .04-.15l.798-1.024a.21.21 0 0 0 .018-.231.2.2 0 0 0-.053-.062l-1.43-1.15a.2.2 0 0 0-.15-.046.2.2 0 0 0-.136.078l-1.376 1.76A.22.22 0 0 0 1 5.955l.258 2.223a.2.2 0 0 0 .075.138c.042.034.095.05.148.044zm1.207-3.447a.2.2 0 0 0 .15.046.2.2 0 0 0 .136-.078l.796-1.027a.2.2 0 0 1 .131-.076L7 3.409a.2.2 0 0 0 .134-.077.2.2 0 0 0 .04-.152l-.209-1.834a.2.2 0 0 0-.073-.136.2.2 0 0 0-.147-.043l-2.2.256a.2.2 0 0 0-.131.076L3.04 3.259a.21.21 0 0 0-.018.232.2.2 0 0 0 .052.061zm3.253-1.58-.21-1.826a.2.2 0 0 1 .04-.15.2.2 0 0 1 .133-.078l.44-.065a.18.18 0 0 1 .143.035c.587.434.635 1.062.684 1.725l.017.211a.2.2 0 0 1-.043.15.2.2 0 0 1-.132.076l-.858.1a.2.2 0 0 1-.143-.044.2.2 0 0 1-.071-.135"
	})));
};

//#endregion
//#region src/Icon/icons/Hardware.svg
var _g$68;
var _path$339;
var _path2$241;
var _path3$131;
function _extends$353() {
	return _extends$353 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$353.apply(null, arguments);
}
var SvgHardware = function SvgHardware(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$353({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$68 || (_g$68 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M13.166 2.835c.043.043.147.189.26.528.11.324.2.744.27 1.245.139 1.004.179 2.214.179 3.392s-.04 2.388-.18 3.392a7 7 0 0 1-.268 1.245c-.114.339-.218.485-.261.528a.7.7 0 0 1-.143.089c-.089.045-.224.103-.42.164-.363.113-.83.205-1.363.275-1.064.142-2.276.182-3.22.182-.943 0-2.155-.04-3.22-.182-.533-.07-.999-.162-1.362-.275a3 3 0 0 1-.42-.164.7.7 0 0 1-.143-.089l-.019-.022 1.648-1.649q.245.247.546.427v.071c0 .874.709 1.583 1.583 1.583.245 0 .476-.058.683-.158.208.1.439.158.684.158s.476-.058.684-.158c.207.1.438.158.683.158.874 0 1.583-.709 1.583-1.583v-.071c.399-.24.732-.572.97-.97h.072c.874 0 1.583-.71 1.583-1.584 0-.245-.058-.476-.158-.683.1-.208.158-.439.158-.684s-.058-.476-.158-.684c.1-.207.158-.438.158-.683 0-.874-.709-1.583-1.583-1.583h-.071q-.18-.3-.426-.546l1.67-1.67z" }), /*#__PURE__*/ React.createElement("path", { d: "M6.975 8.875c0 .083.067.15.15.15h1.75a.15.15 0 0 0 .15-.15v-1.75a.15.15 0 0 0-.15-.15h-1.75a.15.15 0 0 0-.15.15z" }))), _path$339 || (_path$339 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M6.25 11.992a.383.383 0 0 0 .766 0v-.601H6.25zM7.617 11.992a.383.383 0 0 0 .766 0v-.601h-.766zM8.984 11.992a.383.383 0 0 0 .766 0v-.601h-.766zM11.992 7.016a.383.383 0 0 0 0-.766h-.601v.766zM11.992 8.383a.383.383 0 0 0 0-.766h-.601v.766zM11.992 9.75a.383.383 0 0 0 0-.766h-.601v.766zM4.008 7.016a.383.383 0 0 1 0-.766h.601v.766zM4.008 8.383a.383.383 0 0 1 0-.766h.601v.766zM4.008 9.75a.383.383 0 0 1 0-.766h.601v.766zM6.25 4.008a.383.383 0 0 1 .766 0v.601H6.25zM7.617 4.008a.383.383 0 0 1 .766 0v.601h-.766zM8.984 4.008a.383.383 0 0 1 .766 0v.601h-.766z"
	})), _path2$241 || (_path2$241 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M4.875 6.5c0-.897.728-1.625 1.625-1.625h3c.898 0 1.625.728 1.625 1.625v3c0 .898-.727 1.625-1.625 1.625h-3A1.625 1.625 0 0 1 4.875 9.5zm1.19 0c0-.24.195-.435.435-.435h3c.24 0 .435.195.435.435v3c0 .24-.195.435-.435.435h-3a.434.434 0 0 1-.435-.435z",
		clipRule: "evenodd"
	})), _path3$131 || (_path3$131 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M14.015 14.012c.23-.231.41-.576.55-.995s.243-.917.319-1.46c.15-1.088.191-2.362.191-3.557s-.04-2.47-.191-3.556a8.3 8.3 0 0 0-.32-1.461c-.14-.419-.318-.764-.549-.995-.232-.233-.606-.412-1.056-.552a10 10 0 0 0-1.561-.319C10.258.966 8.988.925 8.02.925s-2.238.04-3.377.192a10 10 0 0 0-1.561.32c-.45.14-.825.318-1.057.55-.23.232-.411.577-.555.995-.144.42-.253.918-.333 1.461C.976 5.53.925 6.805.925 8s.05 2.47.212 3.557a8.3 8.3 0 0 0 .333 1.461c.144.418.325.763.555.994.232.233.606.412 1.057.552.453.14.991.243 1.56.319 1.14.151 2.41.192 3.378.192s2.239-.04 3.378-.192a10 10 0 0 0 1.56-.32c.451-.14.825-.318 1.057-.55M2.875 2.835c-.046.046-.153.196-.27.537a7 7 0 0 0-.281 1.247C2.176 5.62 2.125 6.829 2.125 8s.05 2.379.199 3.381c.074.501.169.922.28 1.247.118.34.225.49.271.537.01.01.052.043.142.089a3 3 0 0 0 .42.164c.364.112.83.205 1.364.275 1.064.142 2.275.182 3.22.182.943 0 2.155-.04 3.22-.182.533-.07.998-.163 1.362-.275a3 3 0 0 0 .42-.164.7.7 0 0 0 .143-.09c.042-.042.147-.188.26-.527.11-.324.2-.744.269-1.246.14-1.004.18-2.213.18-3.391s-.04-2.387-.18-3.391a7 7 0 0 0-.268-1.246c-.114-.34-.219-.485-.261-.528a.7.7 0 0 0-.143-.089 3 3 0 0 0-.42-.164 8.6 8.6 0 0 0-1.363-.275c-1.064-.142-2.276-.182-3.22-.182s-2.155.04-3.22.182c-.533.07-.999.163-1.362.275-.196.061-.331.119-.42.164a.7.7 0 0 0-.143.09",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Heart.svg
var _path$338;
function _extends$352() {
	return _extends$352 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$352.apply(null, arguments);
}
var SvgHeart = function SvgHeart(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$352({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$338 || (_path$338 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M9.697 3.746c-.394.234-.683.499-.791.606a1.296 1.296 0 0 1-1.818 0 4.4 4.4 0 0 0-.791-.606c-.4-.238-.835-.4-1.257-.404-1.156-.012-2.654.966-2.737 2.563-.055 1.057.083 1.535.285 1.896.216.387.534.719 1.13 1.338l.35.365c1.195 1.253 2.764 2.353 3.718 2.97a.39.39 0 0 0 .422 0c.954-.617 2.523-1.717 3.718-2.97l.457-.475c.537-.555.832-.86 1.039-1.224.199-.35.338-.817.27-1.886-.106-1.645-1.59-2.588-2.738-2.577-.422.004-.857.166-1.257.404m-1.626-.244a.106.106 0 0 1-.149 0c-.298-.294-1.458-1.338-2.87-1.352-1.644-.016-3.814 1.318-3.938 3.693-.115 2.194.483 2.814 1.763 4.141l.33.343c1.465 1.537 3.412 2.828 4.304 3.384a.91.91 0 0 0 .971 0c.893-.556 2.84-1.848 4.305-3.384q.21-.22.401-.416c1.236-1.273 1.832-1.887 1.692-4.068-.155-2.406-2.295-3.709-3.938-3.693-1.412.014-2.572 1.058-2.87 1.352",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/HeartFilled.svg
var _path$337;
var _path2$240;
function _extends$351() {
	return _extends$351 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$351.apply(null, arguments);
}
var SvgHeartFilled = function SvgHeartFilled(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$351({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$337 || (_path$337 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M9.697 3.746c-.394.234-.683.499-.791.606a1.296 1.296 0 0 1-1.818 0 4.4 4.4 0 0 0-.791-.606c-.4-.238-.835-.4-1.257-.404-1.156-.012-2.654.966-2.737 2.563-.055 1.057.083 1.535.285 1.896.216.387.534.719 1.13 1.338l.35.365c1.195 1.253 2.764 2.353 3.718 2.97a.39.39 0 0 0 .422 0c.954-.617 2.523-1.717 3.718-2.97l.457-.475c.537-.555.832-.86 1.039-1.224.199-.35.338-.817.27-1.886-.106-1.645-1.59-2.588-2.738-2.577-.422.004-.857.166-1.257.404",
		clipRule: "evenodd",
		opacity: .25
	})), _path2$240 || (_path2$240 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M9.697 3.746c-.394.234-.683.499-.791.606a1.296 1.296 0 0 1-1.818 0 4.4 4.4 0 0 0-.791-.606c-.4-.238-.835-.4-1.257-.404-1.156-.012-2.654.966-2.737 2.563-.055 1.057.083 1.535.285 1.896.216.387.534.719 1.13 1.338l.35.365c1.195 1.253 2.764 2.353 3.718 2.97a.39.39 0 0 0 .422 0c.954-.617 2.523-1.717 3.718-2.97l.457-.475c.537-.555.832-.86 1.039-1.224.199-.35.338-.817.27-1.886-.106-1.645-1.59-2.588-2.738-2.577-.422.004-.857.166-1.257.404m-1.626-.244a.106.106 0 0 1-.149 0c-.298-.294-1.458-1.338-2.87-1.352-1.644-.016-3.814 1.318-3.938 3.693-.115 2.194.483 2.814 1.763 4.141l.33.343c1.465 1.537 3.412 2.828 4.304 3.384a.91.91 0 0 0 .971 0c.893-.556 2.84-1.848 4.305-3.384q.21-.22.401-.416c1.236-1.273 1.832-1.887 1.692-4.068-.155-2.406-2.295-3.709-3.938-3.693-1.412.014-2.572 1.058-2.87 1.352",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/HeartHalf.svg
var _g$67;
var _path$336;
function _extends$350() {
	return _extends$350 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$350.apply(null, arguments);
}
var SvgHeartHalf = function SvgHeartHalf(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$350({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$67 || (_g$67 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M7.4 3.054c-.535-.403-1.383-.894-2.349-.904-1.643-.016-3.813 1.318-3.937 3.693-.115 2.194.483 2.814 1.763 4.141l.33.343c1.407 1.475 3.257 2.724 4.193 3.314z" }), /*#__PURE__*/ React.createElement("path", {
		fillRule: "evenodd",
		d: "M13.692 5.92c-.106-1.646-1.59-2.59-2.738-2.578-.386.003-.783.14-1.154.344v7.676c.713-.538 1.475-1.175 2.126-1.858l.457-.475c.537-.555.832-.86 1.039-1.224.199-.35.338-.817.27-1.886",
		clipRule: "evenodd"
	}))), _path$336 || (_path$336 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8.6 13.637c.938-.591 2.783-1.838 4.187-3.31q.21-.22.401-.416c1.236-1.273 1.832-1.887 1.692-4.068-.155-2.406-2.295-3.709-3.938-3.693-.962.01-1.807.497-2.342.9zm5.092-7.718c-.106-1.645-1.59-2.588-2.738-2.577-.386.003-.783.14-1.154.344v7.676c.713-.538 1.475-1.175 2.126-1.858l.457-.475c.537-.555.832-.86 1.039-1.224.199-.35.338-.817.27-1.886",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/HighAvailability.svg
var _path$335;
var _path2$239;
var _path3$130;
function _extends$349() {
	return _extends$349 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$349.apply(null, arguments);
}
var SvgHighAvailability = function SvgHighAvailability(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$349({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$335 || (_path$335 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M5.416 12.29c.04.273.095.558.173.833l-.329.003c-.527 0-1.193-.023-1.775-.1a4.6 4.6 0 0 1-.727-.147 1.3 1.3 0 0 1-.215-.085l-.014-.024a1 1 0 0 1-.073-.173 4 4 0 0 1-.148-.659c-.081-.548-.11-1.216-.11-1.873s.029-1.326.11-1.874q.062-.412.147-.658a1 1 0 0 1 .088-.197l.018-.01c.035-.018.098-.045.197-.076.186-.058.433-.108.727-.147a14 14 0 0 1 2.104-.097c-.078.276-.133.56-.173.834-.107.717-.136 1.52-.136 2.225s.03 1.507.136 2.225",
		opacity: .25
	})), _path2$239 || (_path2$239 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M2.105 6.216c.302.43.791.723 1.312.781.958.107 1.682-.513 1.986-1.192.232.002.489.008.755.021a3.1 3.1 0 0 0-.49.927 5 5 0 0 0-.08.253l-.328-.003c-.527 0-1.193.023-1.775.1a4.6 4.6 0 0 0-.727.147 1.3 1.3 0 0 0-.215.086l-.014.023a1 1 0 0 0-.073.174 4 4 0 0 0-.148.658c-.081.548-.11 1.217-.11 1.874s.029 1.325.11 1.873q.061.412.148.659a1 1 0 0 0 .087.197l.018.01c.035.017.098.044.197.075.186.058.433.108.727.147a14 14 0 0 0 2.104.097q.036.129.078.254c.094.272.242.615.49.926-.321.016-.63.021-.897.022-.551 0-1.277-.024-1.932-.111a6 6 0 0 1-.926-.19c-.267-.083-.528-.2-.704-.377-.17-.17-.289-.408-.376-.66a5 5 0 0 1-.2-.873C1.03 11.48 1 10.746 1 10.064c0-.68.029-1.416.123-2.048a5 5 0 0 1 .2-.873c.086-.253.205-.49.375-.661.11-.11.251-.196.407-.266M8.308 5.998q-.226.045-.426.107c-.267.083-.528.2-.704.377-.17.17-.289.408-.376.661a5 5 0 0 0-.2.873c-.093.632-.122 1.368-.122 2.049s.029 1.416.123 2.049c.046.316.11.615.2.872.086.253.205.49.375.661.176.177.437.294.704.377.276.085.596.146.926.19.655.087 1.38.11 1.932.11.551 0 1.277-.023 1.932-.11.33-.044.65-.105.926-.19.267-.083.528-.2.704-.377.17-.17.289-.408.376-.66.088-.258.152-.557.2-.873.092-.628.121-1.356.122-2.033v-.033c0-.676-.03-1.405-.123-2.032a5 5 0 0 0-.2-.873c-.086-.253-.205-.49-.375-.661-.176-.177-.437-.294-.704-.377l-.122-.035a1.98 1.98 0 0 1-1.335.992q.19.018.374.041c.293.04.541.09.727.147a1.3 1.3 0 0 1 .215.086l.014.023q.028.05.073.174.086.246.148.658c.081.548.11 1.217.11 1.874s-.029 1.325-.11 1.873q-.061.412-.148.659a1 1 0 0 1-.087.197l-.018.01a1.3 1.3 0 0 1-.197.075 4.6 4.6 0 0 1-.727.147c-.582.077-1.248.1-1.775.1s-1.193-.023-1.775-.1a4.6 4.6 0 0 1-.727-.147 1.3 1.3 0 0 1-.215-.085l-.014-.024a1 1 0 0 1-.073-.173 4 4 0 0 1-.148-.659c-.081-.548-.11-1.216-.11-1.873s.029-1.326.11-1.874q.061-.412.148-.658a1 1 0 0 1 .087-.197l.018-.01q.05-.028.197-.076c.186-.058.433-.108.727-.147.526-.07 1.121-.095 1.62-.1l-.896-.08-.015-.001a1.77 1.77 0 0 1-1.366-.924"
	})), _path3$130 || (_path3$130 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "m10.144 4.46.413.07-.1-.133c-1.146-1.524-3.29-1.885-4.85-.793l-.003.002a3.5 3.5 0 0 0-1.276 1.659c-.124.338-.437.578-.778.54-.376-.042-.63-.387-.527-.728.299-.995.92-1.898 1.834-2.538 2.06-1.442 4.868-1.03 6.467.882l.004.005.291.416.054-.354.004-.015a.775.775 0 0 1 .815-.57c.171.02.317.103.409.233s.121.294.082.462l-.002.007-.486 1.685v.003a.75.75 0 0 1-.312.468.75.75 0 0 1-.546.133h-.002l-1.823-.165a.57.57 0 0 1-.408-.234.57.57 0 0 1-.079-.465.776.776 0 0 1 .808-.571z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Home.svg
var _g$66;
var _path$334;
var _path2$238;
function _extends$348() {
	return _extends$348 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$348.apply(null, arguments);
}
var SvgHome = function SvgHome(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$348({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$66 || (_g$66 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "m12.536 6.83.004.002q.03.014.06.026v1.204l-.06-.027-.004-.002L8 5.896 3.465 8.033l-.004.002-.06.027V6.858l.06-.026.004-.002L8 4.693zM9.08 8.417a.4.4 0 0 1 .32.393v4.4H6.6v-4.4a.4.4 0 0 1 .32-.393L7 8.41h2z" }))), _path$334 || (_path$334 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M13.8 12.61a1.8 1.8 0 0 1-1.8 1.8H4a1.8 1.8 0 0 1-1.8-1.8V6.93a1.8 1.8 0 0 1-.264-3.36l5.128-2.41.227-.09a2.2 2.2 0 0 1 1.419 0l.225.09 5.13 2.41a1.799 1.799 0 0 1-.264 3.36zm-9.8.599a.6.6 0 0 1-.6-.6V6.86l.06-.027.005-.002L8 4.693l4.536 2.137.004.002.06.027v5.75l-.012.121a.6.6 0 0 1-.588.479h-1.4v-4.4A1.6 1.6 0 0 0 9 7.21H7c-.883 0-1.6.717-1.6 1.6v4.4zM7.575 2.246a1 1 0 0 1 .85 0l5.13 2.41a.6.6 0 0 1 .29.798l-.062.103v.001a.6.6 0 0 1-.736.186L8.426 3.569a1 1 0 0 0-.852 0l-4.62 2.175-.114.04H2.84a.6.6 0 0 1-.683-.33.6.6 0 0 1 .29-.798zM9.08 8.417a.4.4 0 0 1 .319.393v4.4H6.6v-4.4a.4.4 0 0 1 .32-.393L7 8.41h2z",
		clipRule: "evenodd"
	})), _path2$238 || (_path2$238 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M13.844 5.454a.6.6 0 0 1-.061.103zm-10.89.29a.6.6 0 0 1-.114.04zm-.405.037",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Honeypot.svg
var _path$333;
var _path2$237;
var _path3$129;
function _extends$347() {
	return _extends$347 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$347.apply(null, arguments);
}
var SvgHoneypot = function SvgHoneypot(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$347({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$333 || (_path$333 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M2.605 3.372c.117-.34.224-.49.27-.537a.7.7 0 0 1 .142-.089c.09-.045.225-.103.42-.164.364-.112.83-.205 1.364-.275 1.064-.142 2.275-.182 3.22-.182.943 0 2.155.04 3.22.182.533.07.998.163 1.362.275a3 3 0 0 1 .42.164c.09.046.132.079.143.09.042.042.147.188.26.527.11.324.2.744.269 1.246.14 1.004.18 2.213.18 3.391s-.04 2.387-.18 3.391c-.07.502-.16.922-.268 1.246-.114.34-.219.485-.261.528a.7.7 0 0 1-.143.089 3 3 0 0 1-.42.164c-.364.112-.83.205-1.363.276-1.064.14-2.276.181-3.22.181s-2.155-.04-3.22-.181c-.533-.071-.999-.164-1.362-.276a3 3 0 0 1-.42-.164.7.7 0 0 1-.143-.09c-.046-.045-.153-.195-.27-.536a7 7 0 0 1-.281-1.247C2.175 10.38 2.125 9.171 2.125 8s.05-2.379.199-3.381c.074-.501.169-.922.28-1.247M6.44 4.747l1.13.346q.026.007.051.017l.039-.038.864-.806a1.29 1.29 0 0 1 1.256-.29l1.13.346c.44.135.775.494.879.942l.266 1.152c.103.449-.04.918-.377 1.232l-.864.806-.04.036.013.054.266 1.151c.104.449-.04.919-.377 1.233l-.864.806a1.29 1.29 0 0 1-1.256.29l-1.13-.346a1.29 1.29 0 0 1-.879-.942l-.266-1.152-.011-.054-.052-.015-1.13-.345a1.29 1.29 0 0 1-.879-.943l-.266-1.151c-.103-.449.04-.919.377-1.233l.864-.806a1.29 1.29 0 0 1 1.256-.29",
		clipRule: "evenodd",
		opacity: .25
	})), _path2$237 || (_path2$237 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M14.565 13.017c-.14.419-.32.764-.55.995-.232.233-.606.412-1.056.552-.453.14-.992.243-1.561.319-1.14.151-2.41.192-3.378.192s-2.238-.04-3.377-.192a10 10 0 0 1-1.561-.32c-.45-.14-.825-.318-1.057-.55-.23-.232-.411-.577-.555-.995a8.3 8.3 0 0 1-.333-1.461C.976 10.47.925 9.195.925 8s.05-2.47.212-3.557a8.3 8.3 0 0 1 .333-1.461c.144-.418.325-.763.555-.994.232-.233.606-.412 1.057-.552a10 10 0 0 1 1.56-.319C5.783.966 7.053.925 8.02.925s2.239.04 3.378.192c.57.076 1.108.179 1.56.32.451.14.825.318 1.057.55.23.232.41.577.55.996s.243.917.319 1.46c.15 1.088.191 2.362.191 3.557s-.04 2.47-.191 3.556a8.3 8.3 0 0 1-.32 1.461M2.875 2.835c-.046.046-.153.196-.27.537a7 7 0 0 0-.281 1.247C2.175 5.621 2.125 6.829 2.125 8s.05 2.379.199 3.381c.074.501.169.922.28 1.247.118.34.225.49.271.537.01.01.052.043.142.089.09.045.225.103.42.164.364.112.83.205 1.364.276 1.064.14 2.275.181 3.22.181.943 0 2.155-.04 3.22-.181.533-.071.998-.164 1.362-.276a3 3 0 0 0 .42-.164.7.7 0 0 0 .143-.09c.042-.042.147-.188.26-.527.109-.324.2-.744.269-1.246.14-1.004.18-2.213.18-3.391s-.04-2.387-.18-3.391a7 7 0 0 0-.268-1.246c-.114-.34-.219-.485-.261-.528a.7.7 0 0 0-.143-.089 3 3 0 0 0-.42-.164 8.6 8.6 0 0 0-1.363-.275c-1.064-.142-2.276-.182-3.22-.182s-2.155.04-3.22.182c-.533.07-.999.163-1.362.275-.196.061-.331.119-.42.164a.7.7 0 0 0-.143.09",
		clipRule: "evenodd"
	})), _path3$129 || (_path3$129 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "m7.571 5.093-1.13-.346a1.29 1.29 0 0 0-1.256.29l-.864.806c-.337.314-.48.784-.377 1.233l.266 1.151c.104.449.439.808.879.943l1.13.345q.026.008.052.015l.011.054.266 1.152c.104.448.439.807.879.942l1.13.346c.44.134.92.024 1.256-.29l.864-.806c.337-.314.48-.784.377-1.233l-.266-1.151-.013-.054.04-.036.864-.806c.337-.314.48-.783.377-1.232l-.266-1.152a1.29 1.29 0 0 0-.879-.942l-1.13-.346a1.29 1.29 0 0 0-1.256.29l-.864.806-.039.038zm-1.48.798a.1.1 0 0 0-.09.02l-.864.807a.1.1 0 0 0-.027.089l.265 1.151a.09.09 0 0 0 .064.068l1.13.346c.032.01.066.001.09-.021l.865-.806a.1.1 0 0 0 .027-.089l-.266-1.152a.1.1 0 0 0-.063-.067zm3.34-.77a.1.1 0 0 0-.09.02l-.865.806a.1.1 0 0 0-.027.089l.266 1.151a.1.1 0 0 0 .063.068l1.13.346c.032.01.067.001.09-.021l.865-.806a.1.1 0 0 0 .027-.089l-.266-1.152a.1.1 0 0 0-.063-.067zM8.429 8.398a.1.1 0 0 0-.09.021l-.864.806a.1.1 0 0 0-.028.089l.266 1.152a.1.1 0 0 0 .064.067l1.13.346c.032.01.066.002.09-.02l.865-.807a.1.1 0 0 0 .027-.089l-.266-1.151a.1.1 0 0 0-.063-.068z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Hose.svg
var _path$332;
var _path2$236;
function _extends$346() {
	return _extends$346 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$346.apply(null, arguments);
}
var SvgHose = function SvgHose(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$346({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$332 || (_path$332 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8 9.703a2.2 2.2 0 1 0 0-4.4 2.2 2.2 0 0 0 0 4.4",
		clipRule: "evenodd",
		opacity: .25
	})), _path2$236 || (_path2$236 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M4.2 15.14a1.6 1.6 0 0 0 1.6-1.6v-.025a6.4 6.4 0 0 0 2.2.388c.773 0 1.514-.137 2.2-.388v.025a1.6 1.6 0 0 0 1.6 1.6h1a1.6 1.6 0 0 0 1.6-1.6V7.903q0-.068-.005-.133.005-.133.005-.267a6.4 6.4 0 1 0-12.795.267 2 2 0 0 0-.005.133v5.637a1.6 1.6 0 0 0 1.6 1.6zm-1.4-1.6c0 .221.18.4.4.4h1a.4.4 0 0 0 .4-.4v-.614a6.4 6.4 0 0 1-1.8-1.691zM8 2.303a5.2 5.2 0 1 0 2.2 9.913v-2.12a3.4 3.4 0 1 1 1.2-2.592v6.036c0 .221.18.4.4.4h1a.4.4 0 0 0 .4-.4V7.503q-.001-.61-.134-1.178A5.2 5.2 0 0 0 8 2.303m0 7.4a2.2 2.2 0 1 0 0-4.4 2.2 2.2 0 0 0 0 4.4",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/HostMonitoring.svg
var _path$331;
var _path2$235;
var _path3$128;
var _path4$43;
var _path5$19;
function _extends$345() {
	return _extends$345 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$345.apply(null, arguments);
}
var SvgHostMonitoring = function SvgHostMonitoring(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$345({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$331 || (_path$331 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M10.528 9.66c.796 0 1.506.318 2.124.733a2.79 2.79 0 0 1-.07 3.74c-.6.385-1.285.678-2.054.678-.623 0-1.214-.233-1.762-.565a7 7 0 0 1-.416-.276 2.788 2.788 0 0 1 .05-3.553c.624-.427 1.335-.757 2.128-.757m.008 1.235c-.733 0-1.33.596-1.33 1.33 0 .733.597 1.33 1.33 1.33s1.33-.597 1.33-1.33-.596-1.33-1.33-1.33",
		clipRule: "evenodd",
		opacity: .25
	})), _path2$235 || (_path2$235 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M3.603 2.9c.11 0 .2.09.2.2v.399a.2.2 0 0 1-.2.2h-.4a.2.2 0 0 1-.2-.2v-.4c0-.11.09-.2.2-.2zM4.803 2.9c.11 0 .2.09.2.2v.399a.2.2 0 0 1-.2.2h-.4a.2.2 0 0 1-.2-.2v-.4c0-.11.09-.2.2-.2zM6.003 2.9c.11 0 .2.09.2.2v.399a.2.2 0 0 1-.2.2h-.4a.2.2 0 0 1-.2-.2v-.4a.2.2 0 0 1 .2-.2z"
	})), _path3$128 || (_path3$128 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M13 1a2 2 0 0 1 2 2v.6c0 .545-.219 1.04-.572 1.4.353.36.572.855.572 1.4V7c0 .545-.219 1.04-.572 1.4q.211.216.35.486a7.7 7.7 0 0 0-1.758-1.087l.062-.003a.8.8 0 0 0 .714-.715L13.8 7v-.6a.8.8 0 0 0-.8-.8H3a.8.8 0 0 0-.8.8V7l.004.081a.8.8 0 0 0 .714.715L3 7.8h5.06a7.8 7.8 0 0 0-1.786 1.112q-.052.045-.102.088H3a.8.8 0 0 0-.8.8v.6l.004.081a.8.8 0 0 0 .714.715L3 11.2h1.196a1.88 1.88 0 0 0-.315 1.2H3a2 2 0 0 1-2-2v-.6c0-.545.218-1.039.571-1.4A2 2 0 0 1 1 7v-.6c0-.545.218-1.04.571-1.4A2 2 0 0 1 1 3.6V3a2 2 0 0 1 2-2zM3 2.2a.8.8 0 0 0-.8.8v.6l.004.082a.8.8 0 0 0 .714.714L3 4.4h10l.082-.004a.8.8 0 0 0 .714-.714L13.8 3.6V3a.8.8 0 0 0-.8-.8z",
		clipRule: "evenodd"
	})), _path4$43 || (_path4$43 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M3.603 9.701c.11 0 .2.09.2.2v.4a.2.2 0 0 1-.2.2h-.4a.2.2 0 0 1-.2-.2v-.4c0-.11.09-.2.2-.2zM4.803 9.701c.11 0 .2.09.2.2v.263q-.15.176-.278.337h-.322a.2.2 0 0 1-.2-.2v-.4c0-.11.09-.2.2-.2zM3.603 6.3c.11 0 .2.09.2.2v.4a.2.2 0 0 1-.2.2h-.4a.2.2 0 0 1-.2-.2v-.4c0-.11.09-.2.2-.2zM4.803 6.3c.11 0 .2.09.2.2v.4a.2.2 0 0 1-.2.2h-.4a.2.2 0 0 1-.2-.2v-.4c0-.11.09-.2.2-.2zM6.003 6.3c.11 0 .2.09.2.2v.4a.2.2 0 0 1-.2.2h-.4a.2.2 0 0 1-.2-.2v-.4a.2.2 0 0 1 .2-.2z"
	})), _path5$19 || (_path5$19 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M14.073 9.858c-.898-.743-2.09-1.388-3.545-1.388-1.42 0-2.597.635-3.493 1.37s-1.518 1.578-1.83 2.009a.68.68 0 0 0 .019.83c.33.419.984 1.247 1.888 1.97.902.723 2.066 1.351 3.416 1.351 1.458 0 2.649-.632 3.544-1.362.896-.73 1.505-1.563 1.8-1.978a.68.68 0 0 0 .003-.787c-.295-.423-.906-1.271-1.803-2.015m-3.537 3.697c.734 0 1.33-.597 1.33-1.33s-.596-1.33-1.33-1.33c-.733 0-1.33.596-1.33 1.33 0 .733.597 1.33 1.33 1.33m3.327-.432c-.825.736-1.945 1.688-3.335 1.688-.622 0-1.213-.233-1.762-.565-.55-.332-1.047-.758-1.486-1.136a11 11 0 0 1-.715-.705.247.247 0 0 1-.006-.335 10 10 0 0 1 .675-.705C8.08 10.6 9.187 9.66 10.528 9.66c1.372 0 2.49.942 3.319 1.7.23.21.504.52.69.739.081.094.08.23-.002.323-.183.209-.45.503-.672.701",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Hotspot20.svg
var _path$330;
var _path2$234;
var _path3$127;
function _extends$344() {
	return _extends$344 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$344.apply(null, arguments);
}
var SvgHotspot20 = function SvgHotspot20(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$344({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$330 || (_path$330 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M4.546 2.464C5.423 1.963 6.656 1.438 8 1.438s2.577.525 3.454 1.026a10 10 0 0 1 1.35.928q.052.042.08.067l.022.02.007.005.002.002-.333.398c.334-.397.333-.398.333-.398a.54.54 0 0 1 .051.744.5.5 0 0 1-.268.167 5 5 0 0 0-.345-.042.5.5 0 0 1-.104-.073l-.004-.003-.014-.012-.064-.055a9.046 9.046 0 0 0-1.206-.828c-.803-.458-1.86-.894-2.96-.894s-2.158.436-2.962.895a9 9 0 0 0-1.205.827q-.044.037-.064.055l-.015.012-.003.003a.5.5 0 0 1-.075.056q-.24 0-.478.022a.5.5 0 0 1-.165-.13.54.54 0 0 1 .05-.743l.042.05.292.347-.334-.397.002-.001.002-.002.006-.006.022-.019.08-.067q.104-.089.294-.233c.252-.19.614-.443 1.056-.695"
	})), _path2$234 || (_path2$234 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M8 4.07c.85 0 1.624.315 2.184.624a3.8 3.8 0 0 0-1.02.672A3.2 3.2 0 0 0 8 5.122c-.481 0-.954.142-1.368.33a3.6 3.6 0 0 0-.955-.679l.057-.033C6.3 4.417 7.11 4.07 8 4.07M8 6.701q.105 0 .203.012-.03.065-.057.13l-.002.004c-.318.754-.457 1.607-.46 2.527a2 2 0 0 1-.41-.22q.023-.047.041-.095a3.4 3.4 0 0 0 .119-2.268c.172-.053.363-.09.566-.09M1.074 13.172v-1.147L3.77 9.542q.344-.33.577-.595.237-.265.358-.519a1.3 1.3 0 0 0 .122-.555q0-.33-.151-.57a1 1 0 0 0-.414-.372 1.3 1.3 0 0 0-.596-.132q-.347 0-.606.14a.97.97 0 0 0-.4.4q-.14.262-.14.622H1q0-.739.337-1.283.336-.545.943-.843.606-.298 1.397-.298.814 0 1.417.287.606.284.943.787t.336 1.155q0 .426-.17.842-.166.416-.595.923-.43.505-1.21 1.21L3.294 11.82v.051h3.18v1.302zM7.944 13.268a.87.87 0 0 1-.628-.258.86.86 0 0 1-.26-.625.84.84 0 0 1 .26-.618.87.87 0 0 1 .628-.257q.356 0 .621.257a.83.83 0 0 1 .267.618q0 .243-.126.445a.95.95 0 0 1-.322.32.85.85 0 0 1-.44.118"
	})), _path3$127 || (_path3$127 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M10.3 12.87q.688.464 1.642.468.954 0 1.638-.464.684-.463 1.05-1.342.37-.879.37-2.118.003-1.232-.366-2.097-.37-.868-1.058-1.324-.683-.456-1.634-.456t-1.639.457q-.684.451-1.054 1.32-.366.867-.366 2.1-.003 1.235.363 2.114.37.88 1.054 1.342m2.68-1.504q-.387.651-1.038.651-.433 0-.755-.287-.32-.29-.499-.867-.174-.581-.174-1.45.004-1.282.392-1.926.389-.645 1.036-.644.432 0 .75.287.322.287.496.857.177.57.177 1.427.004 1.3-.384 1.952",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Hourglass.svg
var _g$65;
var _path$329;
function _extends$343() {
	return _extends$343 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$343.apply(null, arguments);
}
var SvgHourglass = function SvgHourglass(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$343({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$65 || (_g$65 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M11.705 11.301q.096.273.161.565.136.599.136 1.253H3.998q0-.654.136-1.253.065-.292.16-.565A6.24 6.24 0 0 1 8 10.09a6.24 6.24 0 0 1 3.705 1.212M9.493 7.26a1 1 0 0 1 .334-.284c.875-.454 1.526-1.268 1.878-2.277A6.24 6.24 0 0 1 8 5.91 6.24 6.24 0 0 1 4.295 4.7l.022.061c.357.981.999 1.771 1.856 2.216.13.068.245.165.334.284l1.198 1.198a.42.42 0 0 0 .59 0z" }))), _path$329 || (_path$329 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M5.497 8c-1.674.983-2.616 2.963-2.616 5.12v.097A.94.94 0 0 0 3.299 15h9.403a.94.94 0 0 0 .417-1.783v-.098c0-2.156-.942-4.136-2.616-5.119 1.674-.983 2.616-2.963 2.616-5.12v-.097A.94.94 0 0 0 12.701 1H3.3a.94.94 0 0 0-.418 1.783v.098c0 2.156.942 4.136 2.616 5.119m4.33 1.024c1.033.536 1.754 1.573 2.04 2.842q.134.599.135 1.253H3.998q0-.654.136-1.253c.285-1.269 1.006-2.306 2.04-2.842a.97.97 0 0 0 .523-.848v-.352a.97.97 0 0 0-.524-.848C5.14 6.44 4.42 5.403 4.133 4.134a5.7 5.7 0 0 1-.135-1.253h8.005q-.001.654-.137 1.253c-.285 1.269-1.006 2.306-2.04 2.842a.97.97 0 0 0-.523.848v.352c0 .372.223.691.524.848",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Hub.svg
var _path$328;
var _path2$233;
function _extends$342() {
	return _extends$342 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$342.apply(null, arguments);
}
var SvgHub$1 = function SvgHub(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$342({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$328 || (_path$328 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M2.44.837a1.6 1.6 0 0 0-1.6 1.6v2.4a1.6 1.6 0 0 0 1.6 1.6h1.004c.067-.43.21-.834.416-1.2H2.44a.4.4 0 0 1-.4-.4v-2.4c0-.22.18-.4.4-.4h2.4c.22 0 .4.18.4.4V3.86c.365-.205.77-.349 1.2-.416V2.437a1.6 1.6 0 0 0-1.6-1.6zM3.443 9.56H2.44a1.6 1.6 0 0 0-1.6 1.6v2.4a1.6 1.6 0 0 0 1.6 1.6h2.4a1.6 1.6 0 0 0 1.6-1.6v-1.003a3.6 3.6 0 0 1-1.2-.416v1.419a.4.4 0 0 1-.4.4h-2.4a.4.4 0 0 1-.4-.4v-2.4c0-.221.18-.4.4-.4h1.419a3.6 3.6 0 0 1-.416-1.2M9.56 12.557v1.003a1.6 1.6 0 0 0 1.6 1.6h2.4a1.6 1.6 0 0 0 1.6-1.6v-2.4a1.6 1.6 0 0 0-1.6-1.6h-1.003c-.067.43-.21.835-.416 1.2h1.419c.22 0 .4.179.4.4v2.4a.4.4 0 0 1-.4.4h-2.4a.4.4 0 0 1-.4-.4V12.14c-.365.205-.77.348-1.2.416M12.556 6.437h1.004a1.6 1.6 0 0 0 1.6-1.6v-2.4a1.6 1.6 0 0 0-1.6-1.6h-2.4a1.6 1.6 0 0 0-1.6 1.6v1.006c.43.067.835.21 1.2.416V2.437c0-.22.18-.4.4-.4h2.4c.22 0 .4.18.4.4v2.4a.4.4 0 0 1-.4.4h-1.42c.205.366.349.77.416 1.2"
	})), _path2$233 || (_path2$233 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M4.4 7A2.6 2.6 0 0 1 7 4.4h2A2.6 2.6 0 0 1 11.6 7v2A2.6 2.6 0 0 1 9 11.6H7A2.6 2.6 0 0 1 4.4 9zM7 5.6A1.4 1.4 0 0 0 5.6 7v2A1.4 1.4 0 0 0 7 10.4h2A1.4 1.4 0 0 0 10.4 9V7A1.4 1.4 0 0 0 9 5.6z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Inbox.svg
var _path$327;
var _path2$232;
function _extends$341() {
	return _extends$341 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$341.apply(null, arguments);
}
var SvgInbox = function SvgInbox(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$341({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$327 || (_path$327 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M2.2 10.9a.8.8 0 0 1 .8-.8h2.365c.081 0 .155.05.195.12.188.34.852 1.28 2.44 1.28s2.252-.94 2.44-1.28a.23.23 0 0 1 .195-.12H13a.8.8 0 0 1 .8.8v1.6l-.004.081a.8.8 0 0 1-.714.715L13 13.3H3l-.082-.004a.8.8 0 0 1-.714-.715l-.004-.08z",
		clipRule: "evenodd",
		opacity: .25
	})), _path2$232 || (_path2$232 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M13.104 2.937A2.2 2.2 0 0 0 11.04 1.5H4.96a2.2 2.2 0 0 0-2.063 1.437l-.056.174-1.793 5.455q-.045.162-.045.322L1 8.899V12.5a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8.9l-.002-.012q0-.16-.045-.322L13.16 3.111zm-9.107.496A1 1 0 0 1 4.96 2.7h6.08a1 1 0 0 1 .964.733l1.655 4.96a.4.4 0 0 1-.386.507H10c-.22 0-.403.182-.468.393C9.405 9.707 9.042 10.3 8 10.3c-1.041 0-1.405-.593-1.532-1.007C6.403 9.082 6.221 8.9 6 8.9H2.727a.4.4 0 0 1-.386-.507zM2.2 10.899a.8.8 0 0 1 .8-.8h2.365c.081 0 .155.05.195.121.188.34.852 1.28 2.44 1.28s2.252-.94 2.44-1.28a.23.23 0 0 1 .195-.12H13a.8.8 0 0 1 .8.8v1.6l-.004.081a.8.8 0 0 1-.714.715L13 13.3H3l-.082-.004a.8.8 0 0 1-.714-.715L2.2 12.5z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/InboxUnread.svg
var _g$64;
var _path$326;
var _path2$231;
function _extends$340() {
	return _extends$340 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$340.apply(null, arguments);
}
var SvgInboxUnread = function SvgInboxUnread(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$340({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$64 || (_g$64 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M13.6 3.8a1.4 1.4 0 1 0-2.8.001 1.4 1.4 0 0 0 2.8-.001M5.365 10.1c.082 0 .155.05.195.12.188.34.852 1.28 2.44 1.28s2.252-.94 2.44-1.28a.23.23 0 0 1 .195-.12H13a.8.8 0 0 1 .8.8v1.6l-.004.081a.8.8 0 0 1-.714.715L13 13.3H3l-.082-.004a.8.8 0 0 1-.714-.715l-.004-.08V10.9a.8.8 0 0 1 .8-.8z" }))), _path$326 || (_path$326 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M7.76 1.5a5 5 0 0 0-.437 1.2H4.96a1 1 0 0 0-.963.733l-1.656 4.96a.4.4 0 0 0 .386.508H6c.22 0 .403.181.468.392.127.414.49 1.007 1.532 1.007 1.041 0 1.405-.593 1.532-1.007.065-.21.247-.392.468-.392h3.273a.4.4 0 0 0 .392-.32 5 5 0 0 0 1.126-.506l.162.492q.045.162.045.32L15 8.9v3.6a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8.9l.003-.012q0-.16.045-.321L2.84 3.112l.056-.175A2.2 2.2 0 0 1 4.96 1.5zM3 10.1a.8.8 0 0 0-.8.8v1.6l.004.081a.8.8 0 0 0 .714.715L3 13.3h10l.082-.004a.8.8 0 0 0 .714-.715l.004-.08V10.9a.8.8 0 0 0-.8-.8h-2.365a.23.23 0 0 0-.195.12c-.188.34-.852 1.28-2.44 1.28s-2.252-.94-2.44-1.28a.23.23 0 0 0-.195-.12z",
		clipRule: "evenodd"
	})), _path2$231 || (_path2$231 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M14.8 3.8a2.6 2.6 0 1 0-2.866 2.587l.266.013a2.6 2.6 0 0 0 2.587-2.334zm1.2 0a3.801 3.801 0 0 1-7.6 0 3.8 3.8 0 0 1 7.6 0"
	})));
};

//#endregion
//#region src/Icon/icons/Information.svg
var _path$325;
var _path2$230;
var _path3$126;
function _extends$339() {
	return _extends$339 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$339.apply(null, arguments);
}
var SvgInformation = function SvgInformation(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$339({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$325 || (_path$325 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M12.1 3.897a5.8 5.8 0 1 1-8.202 8.204l2.033-2.032v1.314a1.8 1.8 0 0 0 1.8 1.8h.534a1.8 1.8 0 0 0 1.8-1.8V7.147c0-.346-.1-.669-.27-.943z",
		opacity: .25
	})), _path2$230 || (_path2$230 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M8 5.82a.907.907 0 0 1-.918-.899A.91.91 0 0 1 8 4.018c.503 0 .918.4.918.903A.907.907 0 0 1 8 5.82m-.27 6.162a.6.6 0 0 1-.6-.6V7.147a.6.6 0 0 1 .6-.6h.534a.6.6 0 0 1 .6.6v4.235a.6.6 0 0 1-.6.6z"
	})), _path3$126 || (_path3$126 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14M8 2.2a5.8 5.8 0 1 1 0 11.6A5.8 5.8 0 0 1 8 2.2",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Insights.svg
var _path$324;
var _path2$229;
var _path3$125;
function _extends$338() {
	return _extends$338 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$338.apply(null, arguments);
}
var SvgInsights = function SvgInsights(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$338({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$324 || (_path$324 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M5.556 11.545c-.827.158-1.638-.015-2.42-.515l-.082-.054a5 5 0 0 1-.655-.525c-.096-.09-.254-.02-.254.103v2.495c0 .185.15.335.334.335H13.52c.185 0 .334-.15.334-.335v-2.615a.86.86 0 0 0-.25-.618c-.875-.847-1.786-1.241-2.713-1.196-.929.045-1.886.531-2.85 1.472-.828.808-1.662 1.295-2.486 1.453",
		clipRule: "evenodd",
		opacity: .25
	})), _path2$229 || (_path2$229 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M1.558 2.95C2.6 1.941 3.819 1.351 5.167 1.417c1.323.064 2.544.75 3.632 1.813.838.817 1.549 1.127 2.117 1.163.542.035 1.16-.166 1.864-.823a1.39 1.39 0 0 1 1.437-.264c.47.18.843.613.843 1.248v3.33a7.3 7.3 0 0 0-1.205-.887V4.554c0-.123-.158-.193-.254-.103a5.107 5.107 0 0 1-.737.579c-.782.5-1.593.673-2.42.515-.824-.158-1.658-.645-2.486-1.453-.964-.94-1.921-1.427-2.85-1.472-.927-.045-1.838.35-2.712 1.196a.86.86 0 0 0-.251.618V8.02a2.66 2.66 0 0 0-1.205.374v-3.96c0-.522.193-1.073.618-1.484"
	})), _path3$125 || (_path3$125 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M10.833 7.417c1.348-.066 2.567.524 3.61 1.533.424.411.617.962.617 1.484v2.615c0 .85-.689 1.54-1.539 1.54H2.48c-.85 0-1.539-.69-1.539-1.54v-2.495c0-.635.372-1.068.843-1.248a1.39 1.39 0 0 1 1.437.264c.705.657 1.322.858 1.864.823.568-.036 1.279-.346 2.117-1.163C8.29 8.168 9.51 7.48 10.833 7.417m-5.277 4.128c-.827.158-1.638-.015-2.42-.515l-.082-.054a5 5 0 0 1-.655-.525c-.096-.09-.254-.02-.254.103v2.495c0 .185.15.335.334.335H13.52c.185 0 .334-.15.334-.335v-2.615a.86.86 0 0 0-.25-.618c-.875-.847-1.786-1.241-2.713-1.196-.929.045-1.886.531-2.85 1.472-.828.808-1.662 1.295-2.486 1.453",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Inspector.svg
var _path$323;
var _path2$228;
var _path3$124;
function _extends$337() {
	return _extends$337 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$337.apply(null, arguments);
}
var SvgInspector = function SvgInspector(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$337({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$323 || (_path$323 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "m4.251 6.793-1.165-.646a.193.193 0 0 0-.286.169v3.906c0 .354.194.68.507.849l3.734 2.01a.193.193 0 0 0 .284-.17v-2.96a5.83 5.83 0 0 1-3.074-3.158",
		opacity: .2
	})), _path2$228 || (_path2$228 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M8.675 10.35a5.8 5.8 0 0 1-1.35-.399v2.96a.193.193 0 0 1-.284.17l-3.734-2.01a.96.96 0 0 1-.507-.85V6.317c0-.147.157-.24.286-.169l1.165.646a5.8 5.8 0 0 1-.407-1.769l-.012-.007a.193.193 0 0 1-.002-.336v-.067c0-.552.077-1.085.22-1.591L1.952 4.169a.96.96 0 0 0-.502.846v6.013c0 .355.195.68.507.849l5.586 3.008a.96.96 0 0 0 .914 0l5.586-3.008.015-.008a2 2 0 0 1-.325-.265l-.759-.762a1 1 0 0 1-.28.229l-3.735 2.01a.193.193 0 0 1-.284-.17z"
	})), _path3$124 || (_path3$124 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M9.633 9.228a4.57 4.57 0 0 0 2.615-.817l2.339 2.346a.826.826 0 0 0 1.17 0 .83.83 0 0 0 0-1.175L13.42 7.236a4.6 4.6 0 0 0 .814-2.622A4.607 4.607 0 0 0 9.634 0c-2.54 0-4.6 2.066-4.6 4.614a4.607 4.607 0 0 0 4.6 4.614m0-1.661a2.95 2.95 0 0 0 2.944-2.953 2.95 2.95 0 0 0-2.944-2.953A2.95 2.95 0 0 0 6.69 4.614a2.95 2.95 0 0 0 2.944 2.953",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Integrations.svg
var _path$322;
var _path2$227;
var _path3$123;
function _extends$336() {
	return _extends$336 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$336.apply(null, arguments);
}
var SvgIntegrations = function SvgIntegrations(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$336({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$322 || (_path$322 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M4.362 11.705c.737.734 1.522 1.454 2.238 1.986.364.27.686.472.955.604.284.139.427.157.458.157.015-.003.156-.024.458-.183.296-.155.645-.389 1.028-.682.764-.585 1.558-1.328 2.16-1.929.6-.6 1.343-1.395 1.928-2.159.293-.382.527-.732.682-1.027.16-.303.18-.444.182-.458v-.001c0-.026-.016-.164-.156-.446a6.3 6.3 0 0 0-.611-.945 19 19 0 0 0-1.38-1.593L9.247 8.084l-.632-.633z",
		opacity: .25
	})), _path2$227 || (_path2$227 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M9.392 6.608a1.987 1.987 0 1 1-2.81 2.81 1.987 1.987 0 0 1 2.81-2.81"
	})), _path3$123 || (_path3$123 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M10.972 3.697a19 19 0 0 0-1.594-1.381 6.3 6.3 0 0 0-.945-.611c-.282-.14-.42-.157-.446-.157-.015.003-.156.024-.458.183a7.6 7.6 0 0 0-1.028.682c-.764.585-1.558 1.328-2.16 1.929-.6.6-1.343 1.395-1.928 2.159a7.6 7.6 0 0 0-.682 1.027c-.16.303-.18.444-.183.458v.001c0 .03.018.174.157.458q.2.407.604.955c.54.727 1.274 1.525 2.02 2.271s1.544 1.48 2.271 2.02c.364.27.686.472.955.604.284.139.428.157.458.157.015-.003.156-.024.459-.183.295-.155.645-.389 1.027-.682.764-.585 1.558-1.328 2.16-1.929.6-.6 1.343-1.395 1.928-2.159.293-.382.527-.732.682-1.027.16-.303.18-.444.182-.458v-.001c0-.026-.016-.164-.156-.446a6.3 6.3 0 0 0-.611-.945 19 19 0 0 0-1.38-1.593L9.247 8.084 7.916 6.752zm4.53 3.269c.181.365.297.72.298 1.045 0 .329-.136.706-.338 1.089a9 9 0 0 1-.804 1.219c-.636.83-1.426 1.672-2.046 2.293-.62.62-1.463 1.41-2.293 2.045a9 9 0 0 1-1.22.805c-.382.202-.759.338-1.088.338-.323 0-.68-.114-1.048-.293a7.7 7.7 0 0 1-1.166-.734c-.805-.596-1.656-1.383-2.422-2.148-.765-.766-1.551-1.617-2.148-2.422a7.7 7.7 0 0 1-.733-1.166C.314 8.67.2 8.312.2 7.989c0-.329.136-.706.338-1.089.204-.387.487-.804.805-1.219.636-.83 1.425-1.673 2.045-2.293s1.463-1.41 2.293-2.045c.415-.318.832-.601 1.22-.805C7.283.336 7.66.2 7.989.2c.324 0 .68.117 1.045.298.367.183.759.441 1.158.743.797.603 1.642 1.396 2.407 2.16.764.765 1.557 1.61 2.16 2.407.302.4.56.79.743 1.158",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Intercom.svg
var _path$321;
function _extends$335() {
	return _extends$335 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$335.apply(null, arguments);
}
var SvgIntercom = function SvgIntercom(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$335({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$321 || (_path$321 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M14 8.82a.55.55 0 0 1-.544.55.54.54 0 0 1-.545-.55V3.92a.542.542 0 1 1 1.089 0zm-.189 3.397c-.072.073-2.097 1.773-5.809 1.773S2.28 12.3 2.193 12.226a.54.54 0 0 1-.164-.577.544.544 0 0 1 .867-.243c.03.022 1.84 1.5 5.102 1.5s5.084-1.487 5.102-1.5a.55.55 0 0 1 .77.058.543.543 0 0 1-.054.758zM2 3.92a.546.546 0 0 1 .576-.521.543.543 0 0 1 .513.52v4.894a.55.55 0 0 1-.545.548A.55.55 0 0 1 2 8.811zM4.731 2.83a.546.546 0 0 1 .576-.521.543.543 0 0 1 .513.521v7.256a.542.542 0 1 1-1.089 0zm2.745-.272a.55.55 0 0 1 .544-.548c.145 0 .283.057.385.16a.55.55 0 0 1 .16.388v7.89a.55.55 0 0 1-.16.389.542.542 0 0 1-.93-.388zm2.7.272a.542.542 0 1 1 1.089 0v7.256a.542.542 0 1 1-1.089 0z"
	})));
};

//#endregion
//#region src/Icon/icons/Interface.svg
var _path$320;
var _path2$226;
var _path3$122;
var _path4$42;
function _extends$334() {
	return _extends$334 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$334.apply(null, arguments);
}
var SvgInterface = function SvgInterface(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$334({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$320 || (_path$320 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M4.682 3.27a1 1 0 0 1 1.544 0l.22.267L4.76 5.584a3.8 3.8 0 0 0 0 4.832l1.684 2.046-.219.268-.079.085c-.412.399-1.09.37-1.465-.085L1.519 8.89a1.4 1.4 0 0 1 0-1.78z",
		opacity: .25
	})), _path2$226 || (_path2$226 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M8.63 7.491a.8.8 0 0 0 0 1.018l1.608 1.951a.4.4 0 0 0 .617 0l1.608-1.951a.8.8 0 0 0 0-1.018L10.856 5.54a.4.4 0 0 0-.618 0z",
		opacity: .5
	})), _path3$122 || (_path3$122 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M3.929 2.32a2.2 2.2 0 0 1 3.223.188l.07.086-.777.943-.22-.266a1 1 0 0 0-1.543 0L1.52 7.109a1.4 1.4 0 0 0 0 1.78l3.162 3.84a1 1 0 0 0 1.466.087l.078-.086.22-.268.777.943-.07.087a2.2 2.2 0 0 1-3.397 0L.593 9.653a2.6 2.6 0 0 1 0-3.306l3.163-3.84z"
	})), _path4$42 || (_path4$42 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M9.022 2.32a2.2 2.2 0 0 1 3.224.188l3.162 3.84a2.6 2.6 0 0 1 0 3.304l-3.162 3.84a2.2 2.2 0 0 1-3.396 0L5.687 9.654a2.6 2.6 0 0 1 0-3.306l3.163-3.84zm.754.95L6.613 7.11a1.4 1.4 0 0 0 0 1.78l3.163 3.84a1 1 0 0 0 1.465.085l.079-.085 3.16-3.84a1.4 1.4 0 0 0 0-1.78l-3.16-3.84a1 1 0 0 0-1.544 0"
	})));
};

//#endregion
//#region src/Icon/icons/InterVLAN.svg
var _path$319;
var _path2$225;
function _extends$333() {
	return _extends$333 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$333.apply(null, arguments);
}
var SvgInterVlan = function SvgInterVlan(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$333({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$319 || (_path$319 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M9.421 8.6a8 8 0 0 1 0-1.2h-.792V1.6a.6.6 0 0 0-1.2 0v5.8h-.85a8 8 0 0 1 0 1.2h.85v5.8a.6.6 0 1 0 1.2 0V8.6z",
		opacity: .25
	})), _path2$225 || (_path2$225 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M5.332 10.611c.171-.059.443-.174.677-.408.26-.259.371-.569.421-.728.06-.191.094-.386.116-.552.044-.334.054-.682.054-.928 0-.245-.01-.593-.054-.927l-.116-.552c-.05-.16-.16-.47-.42-.729a1.75 1.75 0 0 0-.688-.41 3 3 0 0 0-.547-.122A7 7 0 0 0 3.8 5.2c-.29 0-.645.01-.975.055a3 3 0 0 0-.547.123 1.75 1.75 0 0 0-.687.41c-.26.259-.371.568-.421.728-.06.191-.094.386-.116.552A7 7 0 0 0 1 7.995c0 .246.01.594.054.928.022.166.057.36.116.552.05.16.16.469.42.728.235.234.507.35.678.408.189.065.38.103.546.128.332.049.69.061.986.061s.654-.012.986-.061c.166-.025.357-.063.546-.128m-.17-3.974c-.2-.2-.816-.237-1.362-.237s-1.162.037-1.362.237-.238.917-.238 1.358.037 1.158.238 1.359c.2.2.816.246 1.362.246s1.162-.046 1.362-.246.238-.917.238-1.359-.037-1.158-.238-1.358M10.668 10.611a1.8 1.8 0 0 1-.677-.408 1.76 1.76 0 0 1-.421-.728 3.4 3.4 0 0 1-.116-.552 7 7 0 0 1-.054-.928c0-.245.01-.593.054-.927l.116-.552c.05-.16.16-.47.42-.729.239-.237.515-.351.688-.41.19-.063.381-.1.547-.122.33-.046.686-.055.975-.055.29 0 .645.01.975.055.165.023.357.06.547.123.173.058.449.172.687.41.26.259.371.568.421.728.06.191.094.386.116.552.044.334.054.682.054.927 0 .246-.01.594-.054.928-.022.166-.057.36-.116.552-.05.16-.16.469-.42.728a1.8 1.8 0 0 1-.678.408c-.189.065-.38.103-.546.128a7 7 0 0 1-.986.061 7 7 0 0 1-.986-.061 3 3 0 0 1-.546-.128m.17-3.974c.2-.2.816-.237 1.362-.237s1.162.037 1.362.237.238.917.238 1.358-.037 1.158-.238 1.359c-.2.2-.816.246-1.362.246s-1.161-.046-1.362-.246c-.2-.2-.238-.917-.238-1.359s.037-1.158.238-1.358",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/IPAddress.svg
var _path$318;
var _path2$224;
function _extends$332() {
	return _extends$332 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$332.apply(null, arguments);
}
var SvgIpAddress = function SvgIpAddress(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$332({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$318 || (_path$318 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M12.058 13.445q-.152.036-.321.067c-.931.177-2.26.288-3.737.288-1.476 0-2.806-.11-3.737-.288a8 8 0 0 1-.32-.067c-.655-.151-1.043-.34-1.043-.545s.388-.394 1.043-.545q.15-.035.32-.068.396-.075.879-.133L4.087 11.1c-.46.085-.896.195-1.248.342a2.3 2.3 0 0 0-.62.368c-.196.17-.519.532-.519 1.09 0 .557.323.92.52 1.09.204.176.435.291.619.368.377.157.85.273 1.346.36C5.195 14.896 6.544 15 8 15s2.804-.104 3.815-.282c.495-.087.969-.203 1.346-.36.184-.077.415-.192.62-.368.196-.17.519-.533.519-1.09 0-.558-.323-.92-.52-1.09a2.3 2.3 0 0 0-.619-.368c-.352-.147-.788-.257-1.248-.342 0 0-1.376 1.016-1.055 1.055q.483.058.879.133.17.031.32.067c.655.151 1.043.34 1.043.545s-.388.394-1.043.545"
	})), _path2$224 || (_path2$224 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M7.293 12.608 4.366 9.681l-.07-.075a5.1 5.1 0 1 1 7.408 0l-.07.075-2.927 2.927a1 1 0 0 1-1.414 0M9.1 6.94l.03-.213H6.869l.03.213a6 6 0 0 0 .946 2.489L8 9.662l.155-.233a6 6 0 0 0 .946-2.49M6.507 9.698l-.525-.324A3.85 3.85 0 0 1 4.25 6.955l-.052-.228h1.413l.018.167a7.3 7.3 0 0 0 .62 2.243zM6.25 3.063l.258-.561-.526.324a3.85 3.85 0 0 0-1.73 2.419l-.053.228h1.413l.018-.167c.084-.769.29-1.527.62-2.243m.62 2.41.03-.213a6 6 0 0 1 .946-2.489L8 2.538l.155.233a6 6 0 0 1 .946 2.49l.03.212zm3.15-2.647-.526-.324.258.561c.33.716.536 1.474.62 2.243l.018.167h1.413l-.052-.228a3.85 3.85 0 0 0-1.731-2.419m1.783 3.901-.052.228a3.85 3.85 0 0 1-1.731 2.419l-.526.324.258-.561c.33-.716.536-1.475.62-2.243l.018-.167z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/IPForward.svg
var _path$317;
var _path2$223;
var _path3$121;
function _extends$331() {
	return _extends$331 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$331.apply(null, arguments);
}
var SvgIpForward = function SvgIpForward(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$331({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$317 || (_path$317 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M5.142 12.154q-.483.058-.88.133-.168.032-.32.067c-.654.152-1.042.341-1.042.546s.389.394 1.042.545q.152.035.32.068c.643.122 1.474.21 2.412.255.25.136.54.218.869.218h3.486a2.03 2.03 0 0 0-.374.888C9.86 14.954 8.953 15 8 15c-1.456 0-2.804-.104-3.814-.282-.496-.088-.97-.203-1.347-.36a2.3 2.3 0 0 1-.62-.368c-.196-.17-.519-.532-.519-1.09 0-.557.323-.92.52-1.09a2.3 2.3 0 0 1 .619-.368c.352-.147.788-.257 1.248-.342z"
	})), _path2$223 || (_path2$223 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8 1a5.1 5.1 0 0 1 5.04 5.88 1.8 1.8 0 0 0-1.295.092l.005-.017.052-.227h-1.413l-.018.166a7.3 7.3 0 0 1-.62 2.243l-.258.561.526-.324q.33-.205.61-.47c.023.395.157.783.4 1.11H7.543c-.833 0-1.423.512-1.703 1.141L4.366 9.682l-.07-.077A5.1 5.1 0 0 1 8 1M4.25 6.955a3.85 3.85 0 0 0 1.731 2.419l.526.324-.258-.561a7.3 7.3 0 0 1-.62-2.243l-.018-.166H4.198zM6.9 6.94a6 6 0 0 0 .945 2.49L8 9.662l.155-.233a6 6 0 0 0 .946-2.49l.03-.211H6.869zM5.98 2.826c-.863.534-1.5 1.4-1.731 2.42l-.052.227h1.413l.018-.166a7.3 7.3 0 0 1 .62-2.244l.258-.561zm1.864-.055a6 6 0 0 0-.946 2.489l-.03.213h2.262L9.1 5.26a6 6 0 0 0-.946-2.489L8 2.538zm1.906.292c.329.716.536 1.475.62 2.244l.018.166h1.413l-.052-.228a3.85 3.85 0 0 0-1.731-2.419l-.526-.324z",
		clipRule: "evenodd"
	})), _path3$121 || (_path3$121 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M7.543 12.787c-.379 0-.686-.353-.686-.787s.307-.787.686-.787h6.114l-1.63-1.87a.87.87 0 0 1 0-1.113.625.625 0 0 1 .97 0l2.775 3.185A.84.84 0 0 1 16 12a.84.84 0 0 1-.227.585l-2.777 3.185a.625.625 0 0 1-.97 0 .87.87 0 0 1 0-1.113l1.631-1.87z"
	})));
};

//#endregion
//#region src/Icon/icons/IPSecTunnel.svg
var _path$316;
var _path2$222;
var _path3$120;
var _path4$41;
function _extends$330() {
	return _extends$330 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$330.apply(null, arguments);
}
var SvgIpSecTunnel = function SvgIpSecTunnel(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$330({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$316 || (_path$316 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M1.859 4.93C1.639 5.663 1.5 6.767 1.5 8s.14 2.336.359 3.07v.002c.174.58.397.928.641.928s.467-.349.64-.928l.001-.002c.22-.734.359-1.837.359-3.07s-.14-2.337-.359-3.07v-.002C2.966 4.348 2.743 4 2.5 4s-.467.349-.64.928zm-.022-.034q0-.002.017.025-.017-.024-.017-.025m1.326 0q0 .001-.017.025.017-.027.017-.025m0 6.208q0 .002-.017-.025zm-1.326 0q0-.001.017-.025-.017.027-.017.025m2.085 1.192c-.156.265-.598.904-1.422.904s-1.266-.64-1.422-.904c-.204-.345-.346-.764-.45-1.176C.419 10.276.3 9.173.3 8s.118-2.275.329-3.12c.103-.412.245-.831.449-1.176.156-.265.598-.904 1.422-.904s1.266.64 1.422.904c.204.345.346.764.45 1.177.21.844.328 1.946.328 3.119s-.118 2.275-.329 3.12c-.103.412-.245.831-.449 1.176",
		clipRule: "evenodd",
		opacity: .2
	})), _path2$222 || (_path2$222 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M13.5 13.2c.824 0 1.266-.64 1.422-.904.204-.345.346-.764.45-1.176.21-.844.328-1.947.328-3.12s-.118-2.275-.329-3.12c-.103-.412-.245-.831-.449-1.176-.156-.265-.598-.904-1.422-.904h-11c-.824 0-1.266.64-1.422.904-.204.345-.346.764-.45 1.177C.419 5.725.3 6.827.3 8s.118 2.275.329 3.12c.103.412.245.831.449 1.176.156.265.598.904 1.422.904z",
		clipRule: "evenodd",
		opacity: .1
	})), _path3$120 || (_path3$120 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M6.376 9.623c-.163 0-.294-.151-.294-.337s.131-.337.294-.337h2.62l-.699-.802a.37.37 0 0 1 0-.477.268.268 0 0 1 .416 0l1.19 1.365a.36.36 0 0 1 .097.25c0 .1-.038.19-.098.252L8.713 10.9a.268.268 0 0 1-.415 0 .37.37 0 0 1 0-.476l.699-.802zM7.624 6.377c.163 0 .294.151.294.337s-.131.337-.294.337h-2.62l.699.802a.37.37 0 0 1 0 .477.268.268 0 0 1-.416 0l-1.19-1.365A.36.36 0 0 1 4 6.715c0-.1.038-.19.098-.252L5.288 5.1a.268.268 0 0 1 .415 0 .37.37 0 0 1 0 .476l-.7.802z"
	})), _path4$41 || (_path4$41 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M12.859 4.93c-.22.733-.359 1.837-.359 3.07s.14 2.336.359 3.07v.002c.174.58.397.928.641.928s.467-.349.64-.928l.001-.002c.22-.734.359-1.837.359-3.07s-.14-2.337-.359-3.07v-.002C13.967 4.348 13.744 4 13.5 4s-.467.349-.64.928zm-.022-.034q0-.002.017.025-.018-.024-.017-.025m1.326 0q0 .001-.017.025.017-.027.017-.025m0 6.208q0 .002-.017-.025zm-1.326 0q0-.001.017-.025zm2.085 1.192c-.156.265-.598.904-1.422.904s-1.266-.64-1.422-.904c-.204-.345-.346-.764-.45-1.176-.21-.844-.328-1.947-.328-3.12s.118-2.275.329-3.12c.103-.412.245-.831.449-1.176.156-.265.598-.904 1.422-.904s1.266.64 1.422.904c.204.345.346.764.45 1.177.21.844.328 1.946.328 3.119s-.118 2.275-.329 3.12c-.103.412-.245.831-.449 1.176",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Issue.svg
var _g$63;
var _g2$9;
var _path$315;
var _path2$221;
function _extends$329() {
	return _extends$329 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$329.apply(null, arguments);
}
var SvgIssue = function SvgIssue(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$329({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$63 || (_g$63 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M10.596 10.472q.364 0 .622.26.27.246.27.622 0 .375-.27.634a.87.87 0 0 1-.622.246.93.93 0 0 1-.49-.13 2.23 2.23 0 0 0 .003-1.497.9.9 0 0 1 .487-.135M10.613 3.766c.421 0 .76.348.75.77l-.106 4.508a.667.667 0 0 1-1.271.267 2 2 0 0 0 .022-.234l.106-4.51a2 2 0 0 0-.073-.592.75.75 0 0 1 .517-.21z" }))), _g2$9 || (_g2$9 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .5
	}, /*#__PURE__*/ React.createElement("path", { d: "M8.01 10.472q.364 0 .621.26.27.246.27.622 0 .375-.27.634a.87.87 0 0 1-.621.246.93.93 0 0 1-.496-.135 2.23 2.23 0 0 0 .002-1.486.9.9 0 0 1 .494-.14M8.026 3.766c.422 0 .761.348.751.77L8.67 9.044a.668.668 0 0 1-1.277.255q.016-.11.02-.222l.106-4.51c.005-.202-.022-.399-.072-.586a.75.75 0 0 1 .525-.215z" }))), _path$315 || (_path$315 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M5.43 3.766c.423 0 .762.348.752.77l-.107 4.509a.667.667 0 0 1-1.333.001l-.116-4.508a.75.75 0 0 1 .75-.773zM5.415 12.234a.92.92 0 0 1-.645-.247.86.86 0 0 1-.258-.634q0-.376.258-.622a.9.9 0 0 1 .645-.259q.364 0 .621.259.27.246.27.622 0 .375-.27.634a.87.87 0 0 1-.621.247"
	})), _path2$221 || (_path2$221 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M13.348 14.909H2.652l-.252-.013a2.45 2.45 0 0 1-2.187-2.189l-.013-.25V3.543c0-1.27.964-2.313 2.2-2.439l.252-.013h10.696A2.45 2.45 0 0 1 15.8 3.543v8.914l-.013.25a2.45 2.45 0 0 1-2.187 2.189zm0-1.338H2.652a1.114 1.114 0 0 1-1.115-1.114V3.543c0-.616.5-1.114 1.115-1.114h10.696c.616 0 1.115.498 1.115 1.114v8.914c0 .615-.5 1.114-1.115 1.114",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Jitter.svg
var _g$62;
var _path$314;
function _extends$328() {
	return _extends$328 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$328.apply(null, arguments);
}
var SvgJitter = function SvgJitter(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$328({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$62 || (_g$62 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M4.008 14.417a.114.114 0 0 0 .094.177h1.425c.093 0 .148-.106.1-.186a2.73 2.73 0 0 1-.395-1.44q0-.096.006-.19c.004-.054-.082-.083-.111-.039zM10.364 14.407c-.05.08.005.187.099.187h1.435c.09 0 .144-.101.094-.177l-1.119-1.678c-.03-.044-.115-.015-.111.038q.005.095.005.19a2.7 2.7 0 0 1-.403 1.44M11.967 1.62a.114.114 0 0 0-.095-.176h-1.518c-.09 0-.146.1-.103.18.195.367.302.789.291 1.235v.012l-.013.394c-.005.13.225.183.294.074q.024-.04.05-.078zM5.73 1.624c.043-.08-.012-.18-.102-.18h-1.5a.114.114 0 0 0-.095.177l1.094 1.64.039.06c.069.108.292.054.287-.075l-.014-.382a2.5 2.5 0 0 1 .292-1.24M6.052 11.014q-.255.245-.43.53c.17-.85.005-1.753-.495-2.503l-.652-.978a.11.11 0 0 1 0-.126l.652-.978q.086-.129.158-.263c.062-.114.288-.075.293.054l.073 2.056c.02.677.324 1.282.798 1.699a.126.126 0 0 1-.012.197 3 3 0 0 0-.385.312M9.927 11.014a3 3 0 0 0-.372-.31.126.126 0 0 1-.01-.196 2.35 2.35 0 0 0 .802-1.707l.068-2.053c.004-.13.236-.17.298-.055q.073.136.16.266l.652.978a.11.11 0 0 1 0 .126l-.652.978a3.33 3.33 0 0 0-.56 1.885c.002.127-.243.228-.333.139z" }))), _path$314 || (_path$314 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M1.137 2.672a.815.815 0 0 1 1.357-.904l1.499 2.249a1.97 1.97 0 0 1 0 2.187L3.135 7.49a.92.92 0 0 0 0 1.02l.858 1.286a1.97 1.97 0 0 1 0 2.187l-1.5 2.25a.815.815 0 0 1-1.356-.905L2.422 11.4a.92.92 0 0 0 0-1.02l-.858-1.287a1.97 1.97 0 0 1 0-2.186l.858-1.287a.92.92 0 0 0 0-1.02zM6.995 13.958a1.34 1.34 0 0 1-.4-.99c0-.398.134-.715.4-.97a1.4 1.4 0 0 1 1.016-.407c.38 0 .7.133.97.404l.007.007c.279.255.417.571.417.966 0 .394-.139.72-.42.99a1.35 1.35 0 0 1-.974.386c-.399 0-.733-.129-1.016-.386M9.18 2.826c.015-.642-.5-1.17-1.14-1.17h-.098c-.641 0-1.157.53-1.14 1.173l.21 5.934a.988.988 0 0 0 1.973-.002zM14.863 2.672a.815.815 0 0 0-1.357-.904l-1.499 2.249a1.97 1.97 0 0 0 0 2.187l.858 1.286a.92.92 0 0 1 0 1.02l-.858 1.286a1.97 1.97 0 0 0 0 2.187l1.5 2.25a.815.815 0 1 0 1.356-.905L13.578 11.4a.92.92 0 0 1 0-1.02l.857-1.287a1.97 1.97 0 0 0 0-2.186l-.857-1.287a.92.92 0 0 1 0-1.02z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Key.svg
var _path$313;
var _path2$220;
var _path3$119;
function _extends$327() {
	return _extends$327 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$327.apply(null, arguments);
}
var SvgKey = function SvgKey(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$327({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$313 || (_path$313 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M6.417 3.866A2.993 2.993 0 1 0 3.424 9.05a2.993 2.993 0 0 0 2.993-5.184",
		clipRule: "evenodd",
		opacity: .25
	})), _path2$220 || (_path2$220 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M14.36 8.984a2.187 2.187 0 0 1 .801 2.988l-.69 1.196a1.496 1.496 0 0 1-2.044.548l-.306-.176a1.5 1.5 0 0 1-.72-1.006l-.027-.139-.058.024a1.43 1.43 0 0 1-1.95-.991c-.383.108-.8.06-1.153-.145l-1.47-.848a4.374 4.374 0 1 1 2.532-4.386zm-1.823 2.172a.575.575 0 0 0-.789-.419l-.97.41a.05.05 0 0 1-.067-.038l-.138-.975a.576.576 0 0 0-.84-.427l-.718.382a.12.12 0 0 1-.111-.002L8 9.566a4.4 4.4 0 0 0 1.151-1.994l4.52 2.609a.806.806 0 0 1 .294 1.1l-.69 1.197a.115.115 0 0 1-.158.042l-.305-.176a.12.12 0 0 1-.055-.078zm-6.12-7.29A2.993 2.993 0 1 0 3.424 9.05a2.993 2.993 0 0 0 2.993-5.184",
		clipRule: "evenodd"
	})), _path3$119 || (_path3$119 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M6.02 6.458a1.1 1.1 0 1 1-2.2 0 1.1 1.1 0 0 1 2.2 0"
	})));
};

//#endregion
//#region src/Icon/icons/Keyboard.svg
var _path$312;
var _g$61;
var _path2$219;
function _extends$326() {
	return _extends$326 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$326.apply(null, arguments);
}
var SvgKeyboard = function SvgKeyboard(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$326({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$312 || (_path$312 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M1.2 5.339c0-.491.448-.889 1-.889h11.6c.552 0 1 .398 1 .889v.711H1.2z",
		opacity: .25
	})), _g$61 || (_g$61 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .5
	}, /*#__PURE__*/ React.createElement("path", { d: "M2.4 7.45c0-.11.09-.2.2-.2h.8c.11 0 .2.09.2.2v.8a.2.2 0 0 1-.2.2h-.8a.2.2 0 0 1-.2-.2zM4.4 7.45c0-.11.09-.2.2-.2h.8c.11 0 .2.09.2.2v.8a.2.2 0 0 1-.2.2h-.8a.2.2 0 0 1-.2-.2zM6.4 7.45c0-.11.09-.2.2-.2h.8c.11 0 .2.09.2.2v.8a.2.2 0 0 1-.2.2h-.8a.2.2 0 0 1-.2-.2zM8.4 7.45c0-.11.09-.2.2-.2h.8c.11 0 .2.09.2.2v.8a.2.2 0 0 1-.2.2h-.8a.2.2 0 0 1-.2-.2zM10.4 7.45c0-.11.09-.2.2-.2h.8c.11 0 .2.09.2.2v.8a.2.2 0 0 1-.2.2h-.8a.2.2 0 0 1-.2-.2zM12.4 7.45c0-.11.09-.2.2-.2h.8c.11 0 .2.09.2.2v.8a.2.2 0 0 1-.2.2h-.8a.2.2 0 0 1-.2-.2zM2.4 9.45c0-.11.09-.2.2-.2h.8c.11 0 .2.09.2.2v.8a.2.2 0 0 1-.2.2h-.8a.2.2 0 0 1-.2-.2zM4.4 9.45c0-.11.09-.2.2-.2h.8c.11 0 .2.09.2.2v.8a.2.2 0 0 1-.2.2h-.8a.2.2 0 0 1-.2-.2zM6.4 9.45c0-.11.09-.2.2-.2h.8c.11 0 .2.09.2.2v.8a.2.2 0 0 1-.2.2h-.8a.2.2 0 0 1-.2-.2zM8.4 9.45c0-.11.09-.2.2-.2h.8c.11 0 .2.09.2.2v.8a.2.2 0 0 1-.2.2h-.8a.2.2 0 0 1-.2-.2zM10.4 9.45c0-.11.09-.2.2-.2h.8c.11 0 .2.09.2.2v.8a.2.2 0 0 1-.2.2h-.8a.2.2 0 0 1-.2-.2zM12.4 9.45c0-.11.09-.2.2-.2h.8c.11 0 .2.09.2.2v.8a.2.2 0 0 1-.2.2h-.8a.2.2 0 0 1-.2-.2zM3.456 12.05c0-.22.18-.4.4-.4h8.288c.22 0 .4.18.4.4v.8a.4.4 0 0 1-.4.4H3.856a.4.4 0 0 1-.4-.4z" }))), _path2$219 || (_path2$219 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M16 5.45a2.2 2.2 0 0 0-2.2-2.2l-4.4-.003v-.8a.4.4 0 0 0-.4-.4h-.4V1.53a.2.2 0 0 1 .313-.165l.498.34c.93.634 2.189-.032 2.189-1.157a.533.533 0 0 0-.532-.532h-.135a.533.533 0 0 0-.533.532.2.2 0 0 1-.313.165L9.59.373C8.66-.26 7.4.405 7.4 1.53v.517H7a.4.4 0 0 0-.4.4v.8l-4.4.003A2.2 2.2 0 0 0 0 5.45v7.8a2.2 2.2 0 0 0 2.2 2.2h11.6a2.2 2.2 0 0 0 2.2-2.2zm-13.8-1a1 1 0 0 0-1 1v7.8a1 1 0 0 0 1 1h11.6a1 1 0 0 0 1-1v-7.8a1 1 0 0 0-1-1z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/KeyboardSpacebar.svg
var _path$311;
var _g$60;
var _path2$218;
var _path3$118;
var _path4$40;
function _extends$325() {
	return _extends$325 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$325.apply(null, arguments);
}
var SvgKeyboardSpacebar = function SvgKeyboardSpacebar(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$325({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$311 || (_path$311 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M1.2 5.339c0-.491.448-.889 1-.889h11.6c.552 0 1 .398 1 .889v.711H1.2z",
		opacity: .25
	})), _g$60 || (_g$60 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .5
	}, /*#__PURE__*/ React.createElement("path", { d: "M2.4 7.45c0-.11.09-.2.2-.2h.8c.11 0 .2.09.2.2v.8a.2.2 0 0 1-.2.2h-.8a.2.2 0 0 1-.2-.2zM4.4 7.45c0-.11.09-.2.2-.2h.8c.11 0 .2.09.2.2v.8a.2.2 0 0 1-.2.2h-.8a.2.2 0 0 1-.2-.2zM6.4 7.45c0-.11.09-.2.2-.2h.8c.11 0 .2.09.2.2v.8a.2.2 0 0 1-.2.2h-.8a.2.2 0 0 1-.2-.2zM8.4 7.45c0-.11.09-.2.2-.2h.8c.11 0 .2.09.2.2v.8a.2.2 0 0 1-.2.2h-.8a.2.2 0 0 1-.2-.2zM10.4 7.45c0-.11.09-.2.2-.2h.8c.11 0 .2.09.2.2v.8a.2.2 0 0 1-.2.2h-.8a.2.2 0 0 1-.2-.2zM12.4 7.45c0-.11.09-.2.2-.2h.8c.11 0 .2.09.2.2v.8a.2.2 0 0 1-.2.2h-.8a.2.2 0 0 1-.2-.2zM2.4 9.45c0-.11.09-.2.2-.2h.8c.11 0 .2.09.2.2v.8a.2.2 0 0 1-.2.2h-.8a.2.2 0 0 1-.2-.2zM4.4 9.45c0-.11.09-.2.2-.2h.8c.11 0 .2.09.2.2v.8a.2.2 0 0 1-.2.2h-.8a.2.2 0 0 1-.2-.2zM6.4 9.45c0-.11.09-.2.2-.2h.8c.11 0 .2.09.2.2v.8a.2.2 0 0 1-.2.2h-.8a.2.2 0 0 1-.2-.2zM8.4 9.45c0-.11.09-.2.2-.2h.8c.11 0 .2.09.2.2v.8a.2.2 0 0 1-.2.2h-.8a.2.2 0 0 1-.2-.2zM10.4 9.45c0-.11.09-.2.2-.2h.8c.11 0 .2.09.2.2v.8a.2.2 0 0 1-.2.2h-.8a.2.2 0 0 1-.2-.2zM12.4 9.45c0-.11.09-.2.2-.2h.8c.11 0 .2.09.2.2v.8a.2.2 0 0 1-.2.2h-.8a.2.2 0 0 1-.2-.2z" }))), _path2$218 || (_path2$218 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M3.456 12.05c0-.22.18-.4.4-.4h8.288c.22 0 .4.18.4.4v.8a.4.4 0 0 1-.4.4H3.856a.4.4 0 0 1-.4-.4z"
	})), _path3$118 || (_path3$118 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M16 5.45a2.2 2.2 0 0 0-2.2-2.2l-4.4-.003v-.8a.4.4 0 0 0-.4-.4h-.4V1.53a.2.2 0 0 1 .313-.165l.498.34c.93.634 2.189-.032 2.189-1.157a.533.533 0 0 0-.532-.532h-.135a.533.533 0 0 0-.533.532.2.2 0 0 1-.313.165L9.59.373C8.66-.26 7.4.405 7.4 1.53v.517H7a.4.4 0 0 0-.4.4v.8l-4.4.003A2.2 2.2 0 0 0 0 5.45v7.8a2.2 2.2 0 0 0 2.2 2.2h11.6a2.2 2.2 0 0 0 2.2-2.2zm-13.8-1a1 1 0 0 0-1 1v7.8a1 1 0 0 0 1 1h11.6a1 1 0 0 0 1-1v-7.8a1 1 0 0 0-1-1z",
		clipRule: "evenodd"
	})), _path4$40 || (_path4$40 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M3.856 11.65h8.288c.22 0 .4.18.4.4v.8a.4.4 0 0 1-.4.4H3.856a.4.4 0 0 1-.4-.4v-.8c0-.22.18-.4.4-.4",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Layer3.svg
var _g$59;
var _path$310;
var _path2$217;
var _path3$117;
function _extends$324() {
	return _extends$324 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$324.apply(null, arguments);
}
var SvgLayer3 = function SvgLayer3(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$324({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$59 || (_g$59 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "m5.875 12-1.483.54-1.025-.36a.5.5 0 0 1-.148-.074q-.083-.066-.06-.136.02-.058.114-.11l.094-.04 1.026-.36zM12.633 11.82l.094.04q.087.046.11.1a.1.1 0 0 1 .009.042.1.1 0 0 1-.025.065.4.4 0 0 1-.188.113l-1.026.36-1.482-.54 1.481-.54zM6.782 7.054c.234.082.465.13.68.16L4.708 8.216 3.77 7.89c-.259-.09-.259-.238 0-.329L6 6.78z" }))), _path$310 || (_path$310 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M13.113 10.449c.168.059.407.162.63.354.223.193.557.594.557 1.198 0 .603-.334 1.003-.557 1.196a2 2 0 0 1-.63.356l-4.118 1.44c-.343.12-.703.157-.995.157s-.652-.036-.995-.156l-4.118-1.44a2 2 0 0 1-.63-.357A1.58 1.58 0 0 1 1.7 12c0-.604.334-1.005.557-1.198.223-.192.462-.295.63-.354l.272-.096 3.536 1.237c.48.168.952.21 1.305.21s.826-.042 1.305-.21l3.535-1.237zm-6.552 2.848.924.325c.285.1.745.1 1.03 0l.924-.325L8 12.773zM3.367 11.82l-.094.04q-.094.052-.114.11-.023.07.06.136a.5.5 0 0 0 .148.074l1.026.36L5.875 12l-1.481-.54zm6.758.18 1.482.54 1.026-.36a.4.4 0 0 0 .188-.113.1.1 0 0 0 .025-.065.1.1 0 0 0-.01-.041q-.022-.054-.11-.101l-.093-.04-1.027-.36z",
		clipRule: "evenodd"
	})), _path2$217 || (_path2$217 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M12.667 6.31c.153.053.37.147.574.322s.509.543.509 1.093-.305.916-.509 1.092a1.8 1.8 0 0 1-.574.325l-3.759 1.316c-.313.11-.642.142-.908.142s-.595-.033-.908-.142L3.333 9.142a1.8 1.8 0 0 1-.574-.325 1.44 1.44 0 0 1-.509-1.092c0-.55.305-.917.509-1.093.203-.175.42-.27.574-.323l.66-.231 2.006.702-2.228.78c-.259.091-.259.238 0 .33l.937.327 2.754-1.004q.299.04.538.038c.328 0 .769-.04 1.218-.197l2.789-.976zM6.686 8.908l.844.296c.26.09.68.09.94 0l3.627-1.27.132-.046c.226-.08.254-.202.085-.292l-.085-.037-.938-.328z",
		clipRule: "evenodd"
	})), _path3$117 || (_path3$117 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M8 .85c.18 0 .393.017.607.067l.214.062 3.4 1.19c.138.049.335.134.52.293.183.16.46.49.46.989 0 .498-.277.828-.46.987-.185.159-.382.245-.52.294l-3.4 1.19c-.283.098-.58.128-.821.128-.24 0-.538-.03-.821-.129l-3.4-1.19a1.6 1.6 0 0 1-.52-.293 1.3 1.3 0 0 1-.46-.987c0-.499.277-.83.46-.989a1.6 1.6 0 0 1 .52-.293L7.18.98l.214-.062C7.607.867 7.819.85 8 .85m.425 1.262a1.5 1.5 0 0 0-.85 0l-3.4 1.19c-.234.081-.234.215 0 .297l3.4 1.19c.235.082.615.082.85 0l3.28-1.149.12-.041c.204-.072.23-.183.076-.265l-.077-.033z"
	})));
};

//#endregion
//#region src/Icon/icons/LED.svg
var _path$309;
var _path2$216;
var _path3$116;
function _extends$323() {
	return _extends$323 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$323.apply(null, arguments);
}
var SvgLed = function SvgLed(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$323({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$309 || (_path$309 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M12.963 6.6q.037.296.037.6v6a.6.6 0 0 1-.034.2h-9.93A.6.6 0 0 1 3 13.2v-6q0-.294.033-.579l.003-.02a5 5 0 0 0 9.927-.001",
		opacity: .25
	})), _path2$216 || (_path2$216 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M10.555 4.388a3.8 3.8 0 0 0-1.957-.94C8.27 3.394 8 3.668 8 4s.272.593.595.669a2.6 2.6 0 0 1 1.643 1.207c.194.328.617.513.947.322.237-.136.348-.425.228-.67a3.8 3.8 0 0 0-.858-1.14",
		opacity: .5
	})), _path3$116 || (_path3$116 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8 1a6.2 6.2 0 0 1 6.2 6.2v6q0 .102-.012.2h.212a.6.6 0 0 1 .6.6v.4a.6.6 0 0 1-.6.6H1.6a.6.6 0 0 1-.6-.6V14a.6.6 0 0 1 .6-.6h.212a2 2 0 0 1-.012-.2v-6A6.2 6.2 0 0 1 8 1m5 12.2q0 .106-.034.2h-9.93A.6.6 0 0 1 3 13.2v-6a5 5 0 1 1 10 0z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/LEDFlash.svg
var _g$58;
var _g2$8;
var _path$308;
function _extends$322() {
	return _extends$322 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$322.apply(null, arguments);
}
var SvgLedFlash = function SvgLedFlash(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$322({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$58 || (_g$58 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M12.963 6.6q.037.296.037.6v6a.6.6 0 0 1-.034.2h-9.93A.6.6 0 0 1 3 13.2v-6q0-.294.033-.579l.003-.02a5 5 0 0 0 9.927-.001M1.926 5.597q.04.004.08.011A6.2 6.2 0 0 0 1.8 7.2v1.375a1 1 0 0 1-1-1V7.2q0-.356.034-.705a1 1 0 0 1 1.092-.898m12.148 0a1 1 0 0 1 1.092.898q.034.349.034.705v.375a1 1 0 0 1-1 1V7.2c0-.55-.072-1.084-.207-1.592q.04-.007.081-.011M3.432 1.635a1 1 0 0 1 1.456.203 6.2 6.2 0 0 0-2.25 2.25l-.066-.049a1 1 0 0 1-.137-1.407q.45-.547.997-.997m7.73.137a1 1 0 0 1 1.406-.137q.547.45.997.997a1 1 0 0 1-.204 1.456 6.2 6.2 0 0 0-2.25-2.25zM8 0q.357 0 .705.034a1 1 0 0 1 .899 1.092q-.005.04-.013.08A6.2 6.2 0 0 0 8 1a6.2 6.2 0 0 0-1.592.206l-.012-.08A1 1 0 0 1 7.295.034 7 7 0 0 1 8 0" }))), _g2$8 || (_g2$8 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .5
	}, /*#__PURE__*/ React.createElement("path", { d: "M10.555 4.388a3.8 3.8 0 0 0-1.957-.94C8.27 3.394 8 3.668 8 4s.272.593.595.669a2.6 2.6 0 0 1 1.643 1.207c.194.328.617.513.947.322.237-.136.348-.425.228-.67a3.8 3.8 0 0 0-.858-1.14M.976 1.024a.6.6 0 1 1 .848-.848l.849.848a.6.6 0 1 1-.849.849zM14.174 1.873a.6.6 0 1 1-.848-.849l.848-.848a.6.6 0 1 1 .849.848z" }))), _path$308 || (_path$308 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8 1a6.2 6.2 0 0 1 6.2 6.2v6q0 .102-.012.2h.212a.6.6 0 0 1 .6.6v.4a.6.6 0 0 1-.6.6H1.6a.6.6 0 0 1-.6-.6V14a.6.6 0 0 1 .6-.6h.212a2 2 0 0 1-.012-.2v-6A6.2 6.2 0 0 1 8 1m5 12.2q0 .106-.034.2h-9.93A.6.6 0 0 1 3 13.2v-6a5 5 0 1 1 10 0z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/LifeRing.svg
var _g$57;
var _g2$7;
var _path$307;
function _extends$321() {
	return _extends$321 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$321.apply(null, arguments);
}
var SvgLifeRing = function SvgLifeRing(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$321({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$57 || (_g$57 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M10.898 13.18a5.928 5.928 0 0 1-4.804.441 8 8 0 0 0 2.446-1.188 4.4 4.4 0 0 0 1.263-.347zM13.172 5.089c.485.86.765 1.853.765 2.911 0 1.064-.282 2.06-.772 2.924l-1.092-1.092.03-.066.045-.11.028-.072.034-.092.044-.13.021-.069a4.5 4.5 0 0 0 .131-.564l.012-.07a4.5 4.5 0 0 0 .04-.924q-.004-.057-.009-.113l-.017-.167-.011-.086a4 4 0 0 0-.108-.531l-.011-.037a4.5 4.5 0 0 0-.222-.62z" }))), _g2$7 || (_g2$7 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .5
	}, /*#__PURE__*/ React.createElement("path", { d: "M8 3.533a4.467 4.467 0 1 1 0 8.934 4.467 4.467 0 0 1 0-8.934m0 1.2a3.267 3.267 0 1 0 0 6.534 3.267 3.267 0 0 0 0-6.534" }), /*#__PURE__*/ React.createElement("path", {
		fillRule: "evenodd",
		d: "M15.13 8A7.13 7.13 0 1 1 .87 8a7.13 7.13 0 0 1 14.26 0M8 2.063a5.936 5.936 0 1 1 0 11.873A5.936 5.936 0 0 1 8 2.063",
		clipRule: "evenodd"
	}))), _path$307 || (_path$307 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M4.683 9.055c.18-.18.488-.121.616.1A4.3 4.3 0 0 0 6.846 10.7c.22.128.28.436.1.616L4.3 13.961a.556.556 0 0 1-.703.081 6.1 6.1 0 0 1-1.64-1.64.556.556 0 0 1 .08-.703zM9.033 11.317c-.18-.18-.12-.488.1-.616a4.3 4.3 0 0 0 1.547-1.547c.128-.22.436-.28.616-.1L13.94 11.7c.189.188.23.482.081.703a6.1 6.1 0 0 1-1.64 1.64.556.556 0 0 1-.704-.08zM11.296 6.967c-.18.18-.488.12-.616-.1A4.3 4.3 0 0 0 9.133 5.32c-.22-.128-.28-.436-.1-.616l2.644-2.644a.556.556 0 0 1 .704-.081 6.1 6.1 0 0 1 1.676 1.694.48.48 0 0 1-.072.604zM4.683 6.967c.18.18.488.12.616-.1A4.3 4.3 0 0 1 6.846 5.32c.22-.128.28-.436.1-.616l-2.69-2.69a.48.48 0 0 0-.605-.07 6.1 6.1 0 0 0-1.693 1.675.556.556 0 0 0 .08.704z"
	})));
};

//#endregion
//#region src/Icon/icons/Lightbulb.svg
var _path$306;
var _g$56;
var _path2$215;
function _extends$320() {
	return _extends$320 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$320.apply(null, arguments);
}
var SvgLightbulb = function SvgLightbulb(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$320({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$306 || (_path$306 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M6.32 12.605a.37.37 0 0 0-.37.369v.552c0 .204.166.369.37.369h3.36a.37.37 0 0 0 .37-.369v-.552a.37.37 0 0 0-.37-.369z",
		clipRule: "evenodd",
		opacity: .25
	})), _g$56 || (_g$56 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .5
	}, /*#__PURE__*/ React.createElement("path", { d: "M9.988 5.964C9.75 4.837 8.82 3.924 7.64 3.924c-.203 0-.401.068-.592.155a.58.58 0 0 1-.743-.216c-.186-.306-.073-.742.25-.896.27-.13.61-.243 1.085-.243 1.689 0 3.034.949 3.468 2.557.074.274.095.488.097.68.003.315-.273.57-.588.57-.316 0-.565-.258-.63-.567M.6 5.6a.6.6 0 0 1 .6-.6H2a.6.6 0 0 1 0 1.2h-.8a.6.6 0 0 1-.6-.6M15.4 5.6a.6.6 0 0 0-.6-.6H14a.6.6 0 1 0 0 1.2h.8a.6.6 0 0 0 .6-.6M1.364 9.179a.6.6 0 0 1 .304-.793l.73-.325a.6.6 0 1 1 .489 1.096l-.731.326a.6.6 0 0 1-.792-.304M14.636 9.179a.6.6 0 0 0-.304-.793l-.73-.325a.6.6 0 0 0-.489 1.096l.731.326a.6.6 0 0 0 .792-.304M1.364 2.022a.6.6 0 0 1 .792-.304l.73.325A.6.6 0 0 1 2.4 3.14l-.731-.325a.6.6 0 0 1-.304-.792M14.636 2.022a.6.6 0 0 0-.792-.304l-.73.325A.6.6 0 1 0 13.6 3.14l.731-.325a.6.6 0 0 0 .304-.792" }))), _path2$215 || (_path2$215 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M6.32 11.5h3.3599999999999994zM11.155 13.526v-.552c0-.35-.122-.67-.324-.922.205-.255.326-.578.33-.921.004-.432.035-.912.097-1.114.158-.513.39-.964.66-1.48l.04-.076c.362-.69.832-1.586.832-2.672a4.79 4.79 0 0 0-9.58 0c0 1.087.47 1.981.831 2.672l.04.077c.27.515.503.966.66 1.48.063.2.094.68.098 1.113.004.343.125.666.33.92a1.47 1.47 0 0 0-.324.923v.552c0 .814.66 1.474 1.474 1.474h3.362c.814 0 1.474-.66 1.474-1.474M9.68 11.5H6.319a.38.38 0 0 1-.374-.38c-.004-.407-.03-1.048-.147-1.428-.192-.624-.472-1.16-.737-1.666-.389-.744-.745-1.426-.745-2.237a3.684 3.684 0 1 1 7.368 0c0 .811-.356 1.493-.745 2.237-.265.506-.545 1.042-.737 1.666-.117.38-.143 1.02-.147 1.429a.38.38 0 0 1-.374.379m-3.362 1.105a.37.37 0 0 0-.368.369v.552c0 .204.165.369.368.369h3.362a.37.37 0 0 0 .368-.369v-.552a.37.37 0 0 0-.368-.369z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Lightning.svg
var _path$305;
function _extends$319() {
	return _extends$319 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$319.apply(null, arguments);
}
var SvgLightning = function SvgLightning(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$319({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$305 || (_path$305 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M9.456 1.213 3.55 6.737c-.836.781-.561 2.191.54 2.578l1.76.618-1.555 3.135a1.48 1.48 0 0 0 .421 1.834c.49.38 1.292.475 1.898-.077l5.822-5.306c.84-.767.592-2.169-.49-2.579l-1.743-.66 1.595-3.343c.661-1.386-1.074-2.91-2.342-1.724m2.172 7.419a.34.34 0 0 0-.107-.57L8.76 7.017a.2.2 0 0 1-.107-.271l2.063-4.325c.134-.28-.214-.542-.44-.33L4.37 7.613a.34.34 0 0 0 .118.57l2.83.993c.112.04.164.169.11.276l-2.057 4.15c-.138.278.206.545.435.336z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/LightningCycle.svg
var _path$304;
var _path2$214;
function _extends$318() {
	return _extends$318 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$318.apply(null, arguments);
}
var SvgLightningCycle = function SvgLightningCycle(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$318({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$304 || (_path$304 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M9.904 7.5c2.173 0 3.968 1.59 4.262 3.654l.333-.271a.97.97 0 0 1 1.228.005.743.743 0 0 1 0 1.151l-.007.006-1.734 1.386a.94.94 0 0 1-.632.237.94.94 0 0 1-.633-.237l-1.735-1.386-.006-.006a.743.743 0 0 1 0-1.151.97.97 0 0 1 1.225-.006l.22.175a2.61 2.61 0 0 0-2.52-1.89c-1.445 0-2.617 1.156-2.617 2.583s1.171 2.583 2.616 2.583c.552 0 1.063-.168 1.485-.455.33-.225.82-.274 1.166.024.353.304.411.88-.001 1.199-.73.563-1.651.899-2.65.899C7.527 16 5.6 14.097 5.6 11.75S7.527 7.5 9.904 7.5M4.482 12.69c.166.948.58 1.81 1.17 2.52a1.5 1.5 0 0 1-.936-.308 1.48 1.48 0 0 1-.421-1.834z"
	})), _path2$214 || (_path2$214 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M9.455 1.213c1.269-1.186 3.004.338 2.343 1.723L10.203 6.28l.086.032a5.6 5.6 0 0 0-1.477.095l1.903-3.987c.134-.28-.213-.541-.44-.33L4.37 7.613a.34.34 0 0 0 .117.57l.979.342q-.364.49-.613 1.057l-.763-.268c-1.1-.386-1.375-1.795-.54-2.577z"
	})));
};

//#endregion
//#region src/Icon/icons/LightningDisabled.svg
var _path$303;
var _path2$213;
var _path3$115;
var _path4$39;
function _extends$317() {
	return _extends$317 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$317.apply(null, arguments);
}
var SvgLightningDisabled = function SvgLightningDisabled(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$317({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$303 || (_path$303 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M14.815 11.75a3.065 3.065 0 0 1-3.065 3.065l-.054-.002q.057-.047.11-.098l2.909-2.91q.051-.052.098-.109z",
		opacity: .25
	})), _path2$213 || (_path2$213 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M9.455 1.213c1.27-1.186 3.004.338 2.343 1.724L10.204 6.28l.382.145a5.4 5.4 0 0 0-1.651.657l-.176-.066a.2.2 0 0 1-.107-.27l2.063-4.326c.134-.28-.213-.541-.44-.33L4.37 7.613a.34.34 0 0 0 .117.57l2.52.883a5.4 5.4 0 0 0-.707 2.658l-.93 1.878c-.138.278.206.544.435.336l.715-.653c.12.413.29.805.499 1.17l-.405.37c-.606.552-1.407.456-1.898.077a1.48 1.48 0 0 1-.42-1.834L5.85 9.933l-1.76-.618c-1.1-.387-1.376-1.796-.54-2.578z"
	})), _path3$115 || (_path3$115 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M13.382 9.634a.593.593 0 0 0-.839 0l-2.91 2.909a.593.593 0 0 0 0 .839l.485.484a.593.593 0 0 0 .839 0l2.91-2.909a.593.593 0 0 0 0-.839zM11.75 16a4.25 4.25 0 1 0 0-8.5 4.25 4.25 0 0 0 0 8.5m0-7.314a3.065 3.065 0 1 1 0 6.129 3.065 3.065 0 0 1 0-6.13"
	})), _path4$39 || (_path4$39 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M13.382 9.634a.593.593 0 0 0-.839 0l-2.91 2.909a.593.593 0 0 0 0 .839l.485.484a.593.593 0 0 0 .839 0l2.91-2.909a.593.593 0 0 0 0-.839z"
	})));
};

//#endregion
//#region src/Icon/icons/LightningFilled.svg
var _path$302;
var _path2$212;
function _extends$316() {
	return _extends$316 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$316.apply(null, arguments);
}
var SvgLightningFilled = function SvgLightningFilled(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$316({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$302 || (_path$302 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M11.628 8.632a.34.34 0 0 0-.107-.57L8.76 7.017a.2.2 0 0 1-.107-.271l2.063-4.325c.134-.28-.214-.542-.44-.33L4.37 7.613a.34.34 0 0 0 .118.57l2.83.993c.112.04.164.169.11.276l-2.057 4.15c-.138.278.206.545.435.336z",
		clipRule: "evenodd",
		opacity: .5
	})), _path2$212 || (_path2$212 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M9.456 1.213 3.55 6.737c-.836.781-.561 2.191.54 2.578l1.76.618-1.555 3.135a1.48 1.48 0 0 0 .421 1.834c.49.38 1.292.475 1.898-.077l5.822-5.306c.84-.767.592-2.169-.49-2.579l-1.743-.66 1.595-3.343c.661-1.386-1.074-2.91-2.342-1.724m2.172 7.419a.34.34 0 0 0-.107-.57L8.76 7.017a.2.2 0 0 1-.107-.271l2.063-4.325c.134-.28-.214-.542-.44-.33L4.37 7.613a.34.34 0 0 0 .118.57l2.83.993c.112.04.164.169.11.276l-2.057 4.15c-.138.278.206.545.435.336z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/List.svg
var _g$55;
var _path$301;
function _extends$315() {
	return _extends$315 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$315.apply(null, arguments);
}
var SvgList = function SvgList(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$315({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$55 || (_g$55 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .5
	}, /*#__PURE__*/ React.createElement("path", { d: "M4.484 11.4a1.1 1.1 0 0 1 1.1-1.1H13.7a1.1 1.1 0 0 1 0 2.2H5.584a1.1 1.1 0 0 1-1.1-1.1M4.484 8a1.1 1.1 0 0 1 1.1-1.1H13.7a1.1 1.1 0 0 1 0 2.2H5.584a1.1 1.1 0 0 1-1.1-1.1M4.484 4.6a1.1 1.1 0 0 1 1.1-1.1H13.7a1.1 1.1 0 0 1 0 2.2H5.584a1.1 1.1 0 0 1-1.1-1.1" }))), _path$301 || (_path$301 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M3.32 12.18a.4.4 0 0 1-.085.155.4.4 0 0 1-.164.085 1.5 1.5 0 0 1-.243.05c-.177.024-.374.03-.525.03-.15 0-.348-.006-.525-.03a1.5 1.5 0 0 1-.243-.05.4.4 0 0 1-.164-.085.4.4 0 0 1-.086-.155 1.3 1.3 0 0 1-.052-.227A4 4 0 0 1 1.2 11.4c0-.186.008-.384.033-.553q.018-.129.052-.227a.4.4 0 0 1 .086-.155.4.4 0 0 1 .164-.085 1.5 1.5 0 0 1 .243-.05c.177-.024.375-.03.525-.03s.348.006.525.03c.089.012.173.028.243.05.07.021.128.05.164.085q.054.056.086.155.032.1.05.227c.023.17.029.367.029.553s-.006.384-.03.553a1.3 1.3 0 0 1-.05.227M3.32 8.78a.4.4 0 0 1-.085.155.4.4 0 0 1-.164.085 1.5 1.5 0 0 1-.243.05 4 4 0 0 1-.525.03 4 4 0 0 1-.525-.03 1.5 1.5 0 0 1-.243-.05.4.4 0 0 1-.164-.085.4.4 0 0 1-.086-.155 1.3 1.3 0 0 1-.052-.227A4 4 0 0 1 1.2 8c0-.186.008-.384.033-.553q.018-.128.052-.227a.4.4 0 0 1 .086-.155.4.4 0 0 1 .164-.086 1.5 1.5 0 0 1 .243-.05 4 4 0 0 1 .525-.029c.15 0 .348.006.525.03.089.012.173.028.243.05.07.021.128.05.164.085q.054.056.086.155.032.1.05.227c.023.17.029.367.029.553s-.006.384-.03.553a1.3 1.3 0 0 1-.05.227M3.32 5.38a.4.4 0 0 1-.085.155.4.4 0 0 1-.164.085 1.5 1.5 0 0 1-.243.05c-.177.024-.374.03-.525.03-.15 0-.348-.006-.525-.03a1.5 1.5 0 0 1-.243-.05.4.4 0 0 1-.164-.085.4.4 0 0 1-.086-.155 1.3 1.3 0 0 1-.052-.227A4 4 0 0 1 1.2 4.6c0-.186.008-.384.033-.553q.018-.128.052-.227a.4.4 0 0 1 .086-.155.4.4 0 0 1 .164-.086 1.5 1.5 0 0 1 .243-.05c.177-.023.375-.029.525-.029s.348.006.525.03c.089.012.173.028.243.05.07.021.128.05.164.085q.054.056.086.155.032.1.05.227c.023.17.029.367.029.553s-.006.384-.03.553a1.3 1.3 0 0 1-.05.227",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Location.svg
var _path$300;
var _path2$211;
var _path3$114;
function _extends$314() {
	return _extends$314 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$314.apply(null, arguments);
}
var SvgLocation = function SvgLocation(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$314({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$300 || (_path$300 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M12.058 13.445q-.152.036-.321.067c-.931.177-2.26.288-3.737.288-1.476 0-2.806-.11-3.737-.288a8 8 0 0 1-.32-.067c-.655-.151-1.043-.34-1.043-.545s.388-.394 1.043-.545q.15-.035.32-.068.396-.075.879-.133L4.087 11.1c-.46.085-.896.195-1.248.342a2.3 2.3 0 0 0-.62.368c-.196.17-.519.532-.519 1.09 0 .557.323.92.52 1.09.204.176.435.291.619.368.377.157.85.273 1.346.36C5.195 14.896 6.544 15 8 15s2.804-.104 3.815-.282c.495-.087.969-.203 1.346-.36.184-.077.415-.192.62-.368.196-.17.519-.533.519-1.09 0-.558-.323-.92-.52-1.09a2.3 2.3 0 0 0-.619-.368c-.352-.147-.788-.257-1.248-.342 0 0-1.376 1.016-1.055 1.055q.483.058.879.133.17.031.32.067c.654.151 1.043.34 1.043.545s-.389.394-1.043.545"
	})), _path2$211 || (_path2$211 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M7.293 12.608 4.366 9.681l-.07-.075a5.1 5.1 0 1 1 7.408 0l-.07.075-2.927 2.927a1 1 0 0 1-1.414 0m.957-1.436c.873-.816 3.65-3.258 3.65-5.072a3.9 3.9 0 0 0-7.8 0c0 1.814 2.757 4.256 3.63 5.072a.38.38 0 0 0 .52 0",
		clipRule: "evenodd"
	})), _path3$114 || (_path3$114 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M9.6 6.1a1.6 1.6 0 1 1-3.2 0 1.6 1.6 0 0 1 3.2 0"
	})));
};

//#endregion
//#region src/Icon/icons/Locations.svg
var _path$299;
var _path2$210;
var _path3$113;
function _extends$313() {
	return _extends$313 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$313.apply(null, arguments);
}
var SvgLocations = function SvgLocations(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$313({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$299 || (_path$299 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M6.2 11.212a.38.38 0 0 1-.47-.04l-.174-.161C4.54 10.068 2.1 7.806 2.1 6.1a3.9 3.9 0 0 1 2.84-3.754c.38-.511.835-.963 1.35-1.338a5.1 5.1 0 0 0-3.993 8.598l.069.075 2.927 2.927a1 1 0 0 0 1.414 0l.444-.444z"
	})), _path2$210 || (_path2$210 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M9.293 12.608 6.366 9.681l-.07-.075a5.1 5.1 0 1 1 7.408 0l-.07.075-2.927 2.927a1 1 0 0 1-1.414 0m.957-1.436c.873-.816 3.65-3.258 3.65-5.072a3.9 3.9 0 0 0-7.8 0c0 1.814 2.757 4.256 3.63 5.072a.38.38 0 0 0 .52 0",
		clipRule: "evenodd"
	})), _path3$113 || (_path3$113 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M11.6 6.1a1.6 1.6 0 1 1-3.2 0 1.6 1.6 0 0 1 3.2 0M12.058 13.445q-.152.036-.321.067c-.931.177-2.26.288-3.737.288-1.476 0-2.806-.11-3.737-.288a8 8 0 0 1-.32-.067c-.655-.151-1.043-.34-1.043-.545 0-.15.207-.29.573-.415l-.91-.91c-.115.063-.233.14-.343.235-.197.17-.52.532-.52 1.09 0 .557.323.92.52 1.09.204.176.435.291.619.368.377.157.85.273 1.346.36C5.195 14.896 6.544 15 8 15s2.804-.104 3.815-.282c.495-.087.969-.203 1.346-.36.184-.077.415-.192.62-.368.196-.17.519-.533.519-1.09 0-.558-.323-.92-.52-1.09a2 2 0 0 0-.342-.235l-.91.91c.365.124.572.265.572.415 0 .205-.389.394-1.043.545"
	})));
};

//#endregion
//#region src/Icon/icons/Log.svg
var _g$54;
var _g2$6;
var _path$298;
function _extends$312() {
	return _extends$312 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$312.apply(null, arguments);
}
var SvgLog = function SvgLog(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$312({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$54 || (_g$54 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M8.697 7.6H10.9a.6.6 0 1 0 0-1.2H9.191a2.2 2.2 0 0 1-.494 1.2M9.191 5.2H10.9a.6.6 0 1 0 0-1.2H8.697c.274.332.453.746.494 1.2M6.88 11.19c.136.49.438.912.842 1.2H5.1a.6.6 0 1 1 0-1.2zM7.04 8.8c-.153.3-.24.64-.24 1v.2H5.1a.6.6 0 0 1 0-1.2z" }))), _g2$6 || (_g2$6 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .5
	}, /*#__PURE__*/ React.createElement("path", { d: "M8 9.8a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v.8a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1zM1 5.4a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v.8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1z" }))), _path$298 || (_path$298 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M11.8 1H4.2A2.2 2.2 0 0 0 2 3.2h1.2a1 1 0 0 1 1-1h7.6a1 1 0 0 1 1 1v4.4H14V3.2A2.2 2.2 0 0 0 11.8 1M14 12.8h-1.2a1 1 0 0 1-1 1H4.2a1 1 0 0 1-1-1V8.4H2v4.4A2.2 2.2 0 0 0 4.2 15h7.6a2.2 2.2 0 0 0 2.2-2.2"
	})));
};

//#endregion
//#region src/Icon/icons/MACAddress.svg
var _g$53;
var _path$297;
var _path2$209;
function _extends$311() {
	return _extends$311 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$311.apply(null, arguments);
}
var SvgMacAddress = function SvgMacAddress(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$311({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$53 || (_g$53 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M8.9 6.1a.9.9 0 1 1-1.8 0 .9.9 0 0 1 1.8 0M8.9 9.9a.9.9 0 1 1-1.8 0 .9.9 0 0 1 1.8 0" }), /*#__PURE__*/ React.createElement("path", {
		fillRule: "evenodd",
		d: "M1.8 3h2.26a1.8 1.8 0 0 1 1.8 1.8v6.4a1.8 1.8 0 0 1-1.8 1.8H1.8A1.8 1.8 0 0 1 0 11.2V4.8A1.8 1.8 0 0 1 1.8 3M11.94 3h2.26A1.8 1.8 0 0 1 16 4.8v6.4a1.8 1.8 0 0 1-1.8 1.8h-2.26a1.8 1.8 0 0 1-1.8-1.8V4.8a1.8 1.8 0 0 1 1.8-1.8",
		clipRule: "evenodd"
	}))), _path$297 || (_path$297 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M8.9 6.1a.9.9 0 1 1-1.8 0 .9.9 0 0 1 1.8 0M8.9 9.9a.9.9 0 1 1-1.8 0 .9.9 0 0 1 1.8 0"
	})), _path2$209 || (_path2$209 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M1.8 3h2.26a1.8 1.8 0 0 1 1.8 1.8v6.4a1.8 1.8 0 0 1-1.8 1.8H1.8A1.8 1.8 0 0 1 0 11.2V4.8A1.8 1.8 0 0 1 1.8 3m0 1.2a.6.6 0 0 0-.6.6v6.4a.6.6 0 0 0 .6.6h2.26a.6.6 0 0 0 .6-.6V4.8a.6.6 0 0 0-.6-.6zM11.94 3h2.26A1.8 1.8 0 0 1 16 4.8v6.4a1.8 1.8 0 0 1-1.8 1.8h-2.26a1.8 1.8 0 0 1-1.8-1.8V4.8a1.8 1.8 0 0 1 1.8-1.8m0 1.2a.6.6 0 0 0-.6.6v6.4a.6.6 0 0 0 .6.6h2.26a.6.6 0 0 0 .6-.6V4.8a.6.6 0 0 0-.6-.6z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Magnet.svg
var _path$296;
var _path2$208;
function _extends$310() {
	return _extends$310 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$310.apply(null, arguments);
}
var SvgMagnet = function SvgMagnet(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$310({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$296 || (_path$296 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M12.958 7.889a.434.434 0 0 0-.613 0l-1.399 1.397 1.341 1.34 1.397-1.397.03-.033a.43.43 0 0 0 .026-.512l-.056-.068zM7.384 2.315a.434.434 0 0 0-.614 0L5.373 3.713l1.34 1.34L8.11 3.655l.03-.032a.435.435 0 0 0 .029-.509l-.059-.072z",
		opacity: .5
	})), _path2$208 || (_path2$208 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M5.93 1.475a1.623 1.623 0 0 1 2.294 0l.728.728a1.62 1.62 0 0 1 0 2.292L5.801 7.646A1.805 1.805 0 0 0 8.353 10.2l3.152-3.151a1.623 1.623 0 0 1 2.293 0l.727.728c.633.634.633 1.66 0 2.293l-3.15 3.15A6.077 6.077 0 1 1 2.78 4.626zm-2.31 3.99a4.89 4.89 0 0 0 6.914 6.915l.913-.913-1.34-1.341-.913.913a2.994 2.994 0 0 1-4.233-4.233l.912-.913-1.34-1.34zm9.338 2.424a.434.434 0 0 0-.613 0l-1.399 1.397 1.341 1.34 1.397-1.397.03-.033a.435.435 0 0 0 .026-.512l-.056-.068zM7.384 2.315a.434.434 0 0 0-.614 0L5.373 3.713l1.34 1.34L8.11 3.655l.03-.032a.435.435 0 0 0 .029-.509l-.059-.072z"
	})));
};

//#endregion
//#region src/Icon/icons/Map.svg
var _path$295;
var _path2$207;
var _path3$112;
function _extends$309() {
	return _extends$309 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$309.apply(null, arguments);
}
var SvgMap = function SvgMap(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$309({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$295 || (_path$295 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M6.14 3.482v7.225c0 .295.162.566.422.706l1.465.792A4.754 4.754 0 0 1 9.86 6.431V5.294a.8.8 0 0 0-.422-.707l-2.701-1.46a.404.404 0 0 0-.597.355",
		opacity: .25
	})), _path2$207 || (_path2$207 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M0 5.294c0-.74.406-1.42 1.056-1.772l2.85-1.54a3.42 3.42 0 0 1 3.259 0l2.849 1.54.105.051c.227.11.494.106.719-.01l.076-.04 2.704-1.461A1.615 1.615 0 0 1 16 3.482V7.27a4.8 4.8 0 0 0-1.21-.98V3.482a.404.404 0 0 0-.597-.355l-2.701 1.46a.8.8 0 0 0-.422.707v.577c-.433.13-.84.32-1.21.56V5.294a.8.8 0 0 0-.422-.707l-2.701-1.46a.404.404 0 0 0-.597.355v7.225c0 .295.162.566.422.706l1.465.792c.224.556.55 1.06.954 1.488l.057.063.565.565a3.4 3.4 0 0 1-.76-.3l-.155-.083-2.702-1.46-.083-.043a.8.8 0 0 0-.734 0l-.083.042-2.704 1.461A1.615 1.615 0 0 1 0 12.518zm1.632-.707a.8.8 0 0 0-.421.707v7.224c0 .306.327.501.596.355l2.702-1.46a.8.8 0 0 0 .42-.706V3.482a.404.404 0 0 0-.596-.355z",
		clipRule: "evenodd"
	})), _path3$112 || (_path3$112 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "m9.857 12.874.046.05 1.971 1.971a.8.8 0 0 0 1.135 0l1.968-1.967.05-.054a3.558 3.558 0 1 0-5.17 0m4.792-1.539c.179-.324.284-.633.284-.907a2.492 2.492 0 0 0-4.983 0c0 .274.105.583.283.908.177.323.421.652.686.964.468.55.992 1.036 1.312 1.333l.118.11c.049.046.123.046.172 0l.133-.123c.322-.299.84-.778 1.304-1.32a6 6 0 0 0 .69-.965m-2.207.299a1.205 1.205 0 1 0 0-2.411 1.205 1.205 0 0 0 0 2.41",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Megaphone.svg
var _path$294;
function _extends$308() {
	return _extends$308 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$308.apply(null, arguments);
}
var SvgMegaphone = function SvgMegaphone(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$308({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$294 || (_path$294 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M11.134 2.318a1.789 1.789 0 0 1 3.447.67v9.538a1.788 1.788 0 0 1-3.436.695l-3.01-.94-2.311 2.378a1.784 1.784 0 1 1-2.551-2.495l1.056-1.073-1-.312a2.722 2.722 0 0 1-.234-5.111zm1.658.074a.596.596 0 0 0-.596.596v9.538a.596.596 0 0 0 1.193 0V2.987a.596.596 0 0 0-.597-.596M5.602 11.5 4.121 13a.592.592 0 1 0 .847.828l1.887-1.94zm-2.049-4.73 7.404-3.085v8.23L3.685 9.64a1.53 1.53 0 0 1-.132-2.872",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Menu.svg
var _path$293;
function _extends$307() {
	return _extends$307 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$307.apply(null, arguments);
}
var SvgMenu = function SvgMenu(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$307({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$293 || (_path$293 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M1.2 4a1.1 1.1 0 0 1 1.1-1.1h11.4a1.1 1.1 0 0 1 0 2.2H2.3A1.1 1.1 0 0 1 1.2 4M1.2 8a1.1 1.1 0 0 1 1.1-1.1h11.4a1.1 1.1 0 0 1 0 2.2H2.3A1.1 1.1 0 0 1 1.2 8M1.2 12a1.1 1.1 0 0 1 1.1-1.1h11.4a1.1 1.1 0 0 1 0 2.2H2.3A1.1 1.1 0 0 1 1.2 12"
	})));
};

//#endregion
//#region src/Icon/icons/Meter.svg
var _g$52;
var _path$292;
function _extends$306() {
	return _extends$306 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$306.apply(null, arguments);
}
var SvgMeter$1 = function SvgMeter(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$306({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$52 || (_g$52 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		fillRule: "evenodd",
		clipRule: "evenodd",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M15 8c0 2.388-.163 5.082-1.038 5.96-.875.877-4.008 1.04-5.942 1.04-1.933 0-5.066-.163-5.942-1.04C1.203 13.081 1 10.387 1 8s.203-5.082 1.078-5.96C2.954 1.164 6.088 1 8.02 1c1.934 0 5.067.163 5.942 1.04C14.837 2.919 15 5.613 15 8" }), /*#__PURE__*/ React.createElement("path", { d: "M15 8c0 2.388-.163 5.082-1.038 5.96-.875.877-4.008 1.04-5.942 1.04-1.933 0-5.066-.163-5.942-1.04C1.203 13.081 1 10.387 1 8s.203-5.082 1.078-5.96C2.954 1.164 6.088 1 8.02 1c1.934 0 5.067.163 5.942 1.04C14.837 2.919 15 5.613 15 8" }))), _path$292 || (_path$292 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M4 11h.979v-.106l-.001-.653q-.005-.814.004-1.627c.004-.306.027-.615.068-.919a2.6 2.6 0 0 1 .422-1.14c.23-.34.52-.598.949-.646.492-.055.904.138 1.025.675.044.197.057.403.058.605a594 594 0 0 1 .003 3.695l.003.078.002.035h.983V10.9l-.001-.669c-.001-.56-.003-1.119.004-1.678q.005-.449.071-.893c.073-.487.247-.937.575-1.316.268-.31.604-.47 1.018-.441.341.023.596.18.735.501.098.226.117.464.117.705v3.89h.981l.002-.027.002-.051v-.952q.003-1.562-.003-3.125c0-.21-.025-.424-.07-.629-.1-.447-.333-.81-.753-1.022-.471-.238-.966-.24-1.462-.091-.557.167-.95.541-1.245 1.028l-.06.099-.029-.099c-.144-.464-.42-.816-.88-1a1.87 1.87 0 0 0-1.102-.08c-.615.13-1.052.5-1.36 1.035l-.029.05-.013.024-.017-.006v-1.04H4z"
	})));
};

//#endregion
//#region src/Icon/icons/Microchip.svg
var _path$291;
var _path2$206;
var _path3$111;
function _extends$305() {
	return _extends$305 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$305.apply(null, arguments);
}
var SvgMicrochip = function SvgMicrochip(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$305({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$291 || (_path$291 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M10.4 5.4H5.6a.2.2 0 0 0-.2.2v4.8c0 .11.09.2.2.2h4.8a.2.2 0 0 0 .2-.2V5.6a.2.2 0 0 0-.2-.2",
		clipRule: "evenodd",
		opacity: .5
	})), _path2$206 || (_path2$206 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M5.2 14.388a.612.612 0 1 0 1.225 0v-.963H5.2zM7.387 14.388a.612.612 0 1 0 1.225 0v-.963H7.387zM9.575 14.388a.612.612 0 1 0 1.225 0v-.963H9.575zM14.388 6.425a.612.612 0 1 0 0-1.225h-.963v1.225zM14.388 8.612a.612.612 0 1 0 0-1.225h-.963v1.225zM14.388 10.8a.612.612 0 1 0 0-1.225h-.963V10.8zM1.613 6.425a.613.613 0 0 1 0-1.225h.962v1.225zM1.613 8.612a.612.612 0 1 1 0-1.225h.962v1.225zM1.613 10.8a.612.612 0 1 1 0-1.225h.962V10.8zM5.2 1.613a.612.612 0 1 1 1.225 0v.962H5.2zM7.388 1.613a.613.613 0 0 1 1.225 0v.962H7.388zM9.575 1.613a.613.613 0 0 1 1.225 0v.962H9.575z"
	})), _path3$111 || (_path3$111 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M10.4 4.2H5.6a1.4 1.4 0 0 0-1.4 1.4v4.8a1.4 1.4 0 0 0 1.4 1.4h4.8a1.4 1.4 0 0 0 1.4-1.4V5.6a1.4 1.4 0 0 0-1.4-1.4M5.6 3A2.6 2.6 0 0 0 3 5.6v4.8A2.6 2.6 0 0 0 5.6 13h4.8a2.6 2.6 0 0 0 2.6-2.6V5.6A2.6 2.6 0 0 0 10.4 3z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/MicrochipCheckmark.svg
var _path$290;
var _path2$205;
var _path3$110;
var _path4$38;
function _extends$304() {
	return _extends$304 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$304.apply(null, arguments);
}
var SvgMicrochipCheckmark = function SvgMicrochipCheckmark(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$304({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$290 || (_path$290 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8 12a4 4 0 1 1 8 0 4 4 0 0 1-8 0",
		clipRule: "evenodd",
		opacity: .25
	})), _path2$205 || (_path2$205 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M5.6 5.4h4.8c.11 0 .2.09.2.2v1.39a5.21 5.21 0 0 0-3.61 3.61H5.6a.2.2 0 0 1-.2-.2V5.6c0-.11.09-.2.2-.2",
		opacity: .5
	})), _path3$110 || (_path3$110 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M5.2 1.613a.612.612 0 1 1 1.225 0v.962H5.2zM1 5.812c0 .339.274.613.613.613h.962V5.2h-.963A.61.61 0 0 0 1 5.812M14.388 6.425a.612.612 0 1 0 0-1.225h-.963v1.225zM5.2 14.388a.612.612 0 1 0 1.225 0v-.963H5.2zM13 6.896V5.6A2.6 2.6 0 0 0 10.4 3H5.6A2.6 2.6 0 0 0 3 5.6v4.8A2.6 2.6 0 0 0 5.6 13h1.296a5.2 5.2 0 0 1-.092-1.2H5.6a1.4 1.4 0 0 1-1.4-1.4V5.6a1.4 1.4 0 0 1 1.4-1.4h4.8a1.4 1.4 0 0 1 1.4 1.4v1.204a5.3 5.3 0 0 1 1.2.092M14.404 7.388q.267.14.516.308a.61.61 0 0 0-.516-.308M7.696 14.92a.61.61 0 0 1-.308-.516q.14.267.308.515M1.613 8.612a.612.612 0 1 1 0-1.225h.962v1.225zM1 10.187c0 .339.274.613.613.613h.962V9.575h-.963a.613.613 0 0 0-.612.612M8 1a.613.613 0 0 0-.612.613v.962h1.225v-.963A.61.61 0 0 0 8 1M9.575 1.613a.613.613 0 0 1 1.225 0v.962H9.575z"
	})), _path4$38 || (_path4$38 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M14.488 10.194a.596.596 0 0 1 0 .842l-2.769 2.77a.6.6 0 0 1-.429.174.6.6 0 0 1-.429-.174l-1.35-1.35a.595.595 0 0 1 .843-.842l.795.795a.2.2 0 0 0 .283 0l2.214-2.215a.596.596 0 0 1 .842 0m-3.197 3.786h-.002z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/MicrochipClock.svg
var _path$289;
var _path2$204;
var _path3$109;
var _path4$37;
function _extends$303() {
	return _extends$303 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$303.apply(null, arguments);
}
var SvgMicrochipClock = function SvgMicrochipClock(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$303({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$289 || (_path$289 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M5.6 5.4h4.8c.11 0 .2.09.2.2v2.25a4.86 4.86 0 0 0-2.75 2.75H5.6a.2.2 0 0 1-.2-.2V5.6c0-.11.09-.2.2-.2",
		opacity: .5
	})), _path2$204 || (_path2$204 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M5.2 1.613a.612.612 0 1 1 1.225 0v.962H5.2zM1 5.812c0 .339.274.613.613.613h.962V5.2h-.963A.61.61 0 0 0 1 5.812M14.388 6.425a.612.612 0 1 0 0-1.225h-.963v1.225zM5.2 14.388a.612.612 0 1 0 1.225 0v-.963H5.2zM7.387 14.388a.612.612 0 0 0 .877.552 4.8 4.8 0 0 1-.626-1.515h-.25zM13 7.562V5.6A2.6 2.6 0 0 0 10.4 3H5.6A2.6 2.6 0 0 0 3 5.6v4.8A2.6 2.6 0 0 0 5.6 13h1.962a5 5 0 0 1-.01-1.2H5.6a1.4 1.4 0 0 1-1.4-1.4V5.6a1.4 1.4 0 0 1 1.4-1.4h4.8a1.4 1.4 0 0 1 1.4 1.4v1.952a5 5 0 0 1 1.2.01M14.94 8.264a4.8 4.8 0 0 0-1.515-.626v-.25h.962a.612.612 0 0 1 .553.876M1.613 8.612a.612.612 0 1 1 0-1.225h.962v1.225zM1 10.187c0 .339.274.613.613.613h.962V9.575h-.963a.613.613 0 0 0-.612.612M8 1a.613.613 0 0 0-.612.613v.962h1.225v-.963A.61.61 0 0 0 8 1M9.575 1.613a.613.613 0 0 1 1.225 0v.962H9.575z"
	})), _path3$109 || (_path3$109 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M12.364 10.334c.293 0 .531.238.531.532v1.284l.888.887a.531.531 0 0 1-.752.752l-1.043-1.043a.53.53 0 0 1-.155-.376v-1.504c0-.294.237-.532.531-.532",
		clipRule: "evenodd"
	})), _path4$37 || (_path4$37 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8.72 12.36a3.64 3.64 0 1 1 7.28 0 3.64 3.64 0 0 1-7.28 0m1.154 0a2.487 2.487 0 1 1 4.974 0 2.487 2.487 0 0 1-4.974 0",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/MicrochipCross.svg
var _path$288;
var _path2$203;
var _path3$108;
var _path4$36;
function _extends$302() {
	return _extends$302 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$302.apply(null, arguments);
}
var SvgMicrochipCross = function SvgMicrochipCross(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$302({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$288 || (_path$288 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8 12a4 4 0 1 1 8 0 4 4 0 0 1-8 0",
		clipRule: "evenodd",
		opacity: .25
	})), _path2$203 || (_path2$203 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M5.6 5.4h4.8c.11 0 .2.09.2.2v1.39a5.21 5.21 0 0 0-3.61 3.61H5.6a.2.2 0 0 1-.2-.2V5.6c0-.11.09-.2.2-.2",
		opacity: .5
	})), _path3$108 || (_path3$108 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M5.2 1.613a.612.612 0 1 1 1.225 0v.962H5.2zM1 5.812c0 .339.274.613.613.613h.962V5.2h-.963A.61.61 0 0 0 1 5.812M14.388 6.425a.612.612 0 1 0 0-1.225h-.963v1.225zM5.2 14.388a.612.612 0 1 0 1.225 0v-.963H5.2zM13 6.896V5.6A2.6 2.6 0 0 0 10.4 3H5.6A2.6 2.6 0 0 0 3 5.6v4.8A2.6 2.6 0 0 0 5.6 13h1.296a5.2 5.2 0 0 1-.092-1.2H5.6a1.4 1.4 0 0 1-1.4-1.4V5.6a1.4 1.4 0 0 1 1.4-1.4h4.8a1.4 1.4 0 0 1 1.4 1.4v1.204a5.3 5.3 0 0 1 1.2.092M14.404 7.388q.267.14.516.308a.61.61 0 0 0-.516-.308M7.696 14.92a.61.61 0 0 1-.308-.516q.14.267.308.515M1.613 8.612a.612.612 0 1 1 0-1.225h.962v1.225zM1 10.187c0 .339.274.613.613.613h.962V9.575h-.963a.613.613 0 0 0-.612.612M8 1a.613.613 0 0 0-.612.613v.962h1.225v-.963A.61.61 0 0 0 8 1M9.575 1.613a.613.613 0 0 1 1.225 0v.962H9.575z"
	})), _path4$36 || (_path4$36 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M9.927 10.78a.603.603 0 1 1 .853-.853l1.079 1.078a.2.2 0 0 0 .282 0l1.079-1.078a.603.603 0 0 1 .853.853l-1.078 1.079a.2.2 0 0 0 0 .282l1.078 1.079a.604.604 0 0 1-.853.853l-1.079-1.078a.2.2 0 0 0-.282 0l-1.079 1.078a.604.604 0 0 1-.853-.853l1.078-1.079a.2.2 0 0 0 0-.282z"
	})));
};

//#endregion
//#region src/Icon/icons/MicrochipUpgrade.svg
var _path$287;
var _path2$202;
var _path3$107;
function _extends$301() {
	return _extends$301 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$301.apply(null, arguments);
}
var SvgMicrochipUpgrade = function SvgMicrochipUpgrade(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$301({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$287 || (_path$287 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M5.6 5.4h4.8c.11 0 .2.09.2.2v.939q-.26.124-.475.322L8.01 8.705a1.85 1.85 0 0 0-.577 1.895H5.6a.2.2 0 0 1-.2-.2V5.6c0-.11.09-.2.2-.2",
		opacity: .5
	})), _path2$202 || (_path2$202 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M5.2 1.613a.612.612 0 1 1 1.225 0v.962H5.2zM1 5.812c0 .339.274.613.613.613h.962V5.2h-.963A.61.61 0 0 0 1 5.812M14.388 6.425a.612.612 0 1 0 0-1.225h-.963v1.225zM5.2 14.388a.612.612 0 0 0 .802.582 6 6 0 0 1-.218-.828 1.8 1.8 0 0 1 .006-.717H5.2zM9.152 13a1.8 1.8 0 0 0-3.21 0H5.6A2.6 2.6 0 0 1 3 10.4V5.6A2.6 2.6 0 0 1 5.6 3h4.8A2.6 2.6 0 0 1 13 5.6v1.412l-.173-.15a2 2 0 0 0-1.027-.496V5.6a1.4 1.4 0 0 0-1.4-1.4H5.6a1.4 1.4 0 0 0-1.4 1.4v4.8a1.4 1.4 0 0 0 1.4 1.4h2.851c.334.16.706.222 1.068.187V13zM14.722 8.513 13.43 7.387h.957a.612.612 0 0 1 .335 1.126M1.613 8.612a.612.612 0 1 1 0-1.225h.962v1.225zM1 10.187c0 .339.274.613.613.613h.962V9.575h-.963a.613.613 0 0 0-.612.612M8 1a.613.613 0 0 0-.612.613v.962h1.225v-.963A.61.61 0 0 0 8 1M9.575 1.613a.613.613 0 0 1 1.225 0v.962H9.575zM8.26 14.16c.051.15.095.22.112.246l.038.022c.047.024.124.06.235.094a5 5 0 0 0 .827.167c.294.039.609.066.92.083.385.022.762.03 1.089.03.593 0 1.35-.026 2.01-.113.33-.044.612-.1.826-.167a1.5 1.5 0 0 0 .27-.11 1 1 0 0 0 .108-.244q.06-.182.111-.444a.61.61 0 0 1 .662-.5.59.59 0 0 1 .522.688c-.1.544-.264 1.055-.559 1.35-.185.186-.463.313-.759.404a6.4 6.4 0 0 1-1.024.21c-.735.098-1.55.124-2.167.124s-1.432-.026-2.167-.123a6.4 6.4 0 0 1-1.024-.21c-.296-.092-.574-.219-.76-.404-.293-.295-.462-.804-.568-1.349a.59.59 0 0 1 .516-.693.613.613 0 0 1 .666.493q.053.264.116.446"
	})), _path3$107 || (_path3$107 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M11.476 14.126c-.388 0-.757-.28-.757-.69v-3.59l-.872.76a.81.81 0 0 1-1.048 0 .65.65 0 0 1 0-.997l2.13-1.856a.8.8 0 0 1 .547-.213c.21 0 .407.079.547.213l2.13 1.856c.31.271.31.726 0 .996a.81.81 0 0 1-1.048 0l-.872-.76v3.591c0 .41-.37.69-.757.69"
	})));
};

//#endregion
//#region src/Icon/icons/Minus.svg
var _path$286;
function _extends$300() {
	return _extends$300 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$300.apply(null, arguments);
}
var SvgMinus = function SvgMinus(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$300({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$286 || (_path$286 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M2 8a.9.9 0 0 1 .9-.9h10.2a.9.9 0 1 1 0 1.8H2.9A.9.9 0 0 1 2 8"
	})));
};

//#endregion
//#region src/Icon/icons/MinusCircle.svg
var _path$285;
var _path2$201;
var _path3$106;
function _extends$299() {
	return _extends$299 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$299.apply(null, arguments);
}
var SvgMinusCircle = function SvgMinusCircle(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$299({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$285 || (_path$285 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M12.102 3.898a5.8 5.8 0 1 1-8.203 8.203L5.9 10.1h5.67a2.1 2.1 0 0 0 0-4.2H10.1z",
		opacity: .25
	})), _path2$201 || (_path2$201 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M4.43 7.1h7.14a.9.9 0 1 1 0 1.8H4.43a.9.9 0 0 1 0-1.8",
		clipRule: "evenodd"
	})), _path3$106 || (_path3$106 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14M8 2.2a5.8 5.8 0 1 1 0 11.6A5.8 5.8 0 0 1 8 2.2",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/MoneyBag.svg
var _path$284;
var _g$51;
var _path2$200;
var _path3$105;
var _path4$35;
var _path5$18;
function _extends$298() {
	return _extends$298 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$298.apply(null, arguments);
}
var SvgMoneyBag = function SvgMoneyBag(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$298({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$284 || (_path$284 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "m11.08 7.514.133.14.129.148a4.34 4.34 0 0 1 1.012 2.792l-.005.224c-.117 2.3-2.02 3.13-4.349 3.13l-.224-.005c-1.63-.083-3.022-.526-3.696-1.631a8 8 0 0 0 6.568-5.218h.011z",
		opacity: .25
	})), _g$51 || (_g$51 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		fillRule: "evenodd",
		clipRule: "evenodd",
		opacity: .5
	}, /*#__PURE__*/ React.createElement("path", { d: "M5.322 5.103a.4.4 0 0 1 .078-.008zm5.67.47L11 5.495a.4.4 0 0 1-.008.078M5.4 5.895a.4.4 0 0 1-.08-.007z" }), /*#__PURE__*/ React.createElement("path", { d: "M5.322 5.103a.4.4 0 0 1 .078-.008zM11 5.495a.4.4 0 0 1-.008.078zm-5.6.4a.4.4 0 0 1-.08-.007z" }), /*#__PURE__*/ React.createElement("path", { d: "M5.4 5.095h5.2a.4.4 0 0 1 .393.478v.003a.4.4 0 0 1-.393.32H5.4a.398.398 0 0 1-.4-.4.4.4 0 0 1 .32-.393h.002a.4.4 0 0 1 .078-.008" }))), _path2$200 || (_path2$200 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M5.322 5.103a.4.4 0 0 1 .078-.008zm5.67.47L11 5.495a.4.4 0 0 1-.008.078M5.4 5.895a.4.4 0 0 1-.08-.007z",
		clipRule: "evenodd"
	})), _path3$105 || (_path3$105 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M5.322 5.103a.4.4 0 0 1 .078-.008zM11 5.495a.4.4 0 0 1-.008.078zm-5.6.4a.4.4 0 0 1-.08-.007z",
		clipRule: "evenodd"
	})), _path4$35 || (_path4$35 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M4.644 3.187C3.893 2.27 4.66.909 5.832 1.075l.773.11c.222.031.795.038 1.014-.014l.265-.062c.643-.153 1.588-.129 2.23.027l.469.113a1.4 1.4 0 0 1 .734 2.272l-.4.406a1.602 1.602 0 0 1 .783 2.73l.127.127.007.008.134.139.015.017a5.39 5.39 0 0 1 1.417 3.646c0 2.982-2.418 4.4-5.4 4.4s-5.4-1.418-5.4-4.4c0-1.356.502-2.599 1.328-3.547l.012-.013.012-.013.204-.22.013-.013.131-.13a1.6 1.6 0 0 1-.491-1l-.01-.162.01-.164a1.6 1.6 0 0 1 1.51-1.435zm5.656-.772a.2.2 0 0 1 .106.325l-1.14 1.155H6.967L5.572 2.426l-.016-.028a.1.1 0 0 1 .108-.135l.091.014.681.096c.371.053 1.096.053 1.46-.034l.265-.062c.46-.11 1.212-.086 1.67.025zm-5.379 5.1-.205.219a4.34 4.34 0 0 0-1.07 2.86l.005.224c.113 2.227 1.898 3.012 4.125 3.125l.224.006c2.33 0 4.232-.83 4.349-3.131l.006-.224c0-1.062-.381-2.036-1.013-2.792l-.13-.148-.133-.14-.42-.42-.06.001H5.342zm.479-2.42h5.2a.4.4 0 0 1 .392.478v.003a.4.4 0 0 1-.392.32H5.4a.398.398 0 0 1-.4-.4.4.4 0 0 1 .32-.393h.002a.4.4 0 0 1 .078-.008",
		clipRule: "evenodd"
	})), _path5$18 || (_path5$18 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M7.757 12.833a.1.1 0 0 0 .1.1h.384a.1.1 0 0 0 .1-.1v-.383q.35-.03.62-.137.38-.148.583-.433.204-.284.206-.694a1.3 1.3 0 0 0-.078-.439 1 1 0 0 0-.23-.361 1.4 1.4 0 0 0-.404-.283 2.6 2.6 0 0 0-.593-.193l-.343-.073q-.15-.03-.257-.069a1 1 0 0 1-.088-.036 1 1 0 0 1-.09-.05.3.3 0 0 1-.101-.107.27.27 0 0 1-.027-.136.28.28 0 0 1 .055-.163.35.35 0 0 1 .163-.111.8.8 0 0 1 .288-.043.8.8 0 0 1 .296.047.4.4 0 0 1 .222.206c.044.094.125.178.23.178h.598c.167 0 .306-.137.27-.3a1.2 1.2 0 0 0-.172-.413 1.3 1.3 0 0 0-.57-.476 1.9 1.9 0 0 0-.578-.153v-.378a.1.1 0 0 0-.1-.1h-.384a.1.1 0 0 0-.1.1v.378a2 2 0 0 0-.591.151 1.4 1.4 0 0 0-.598.466 1.14 1.14 0 0 0-.212.692q-.002.488.316.77.32.28.875.4l.416.09q.232.05.37.11a.5.5 0 0 1 .195.13q.061.07.063.166a.3.3 0 0 1-.065.18.4.4 0 0 1-.185.125.9.9 0 0 1-.304.044 1 1 0 0 1-.28-.034 1 1 0 0 1-.094-.033.53.53 0 0 1-.304-.332c-.032-.1-.115-.186-.222-.186h-.586c-.166 0-.304.136-.28.3q.049.324.203.557.225.333.629.494.291.115.654.148z"
	})));
};

//#endregion
//#region src/Icon/icons/Moon.svg
var _path$283;
var _path2$199;
var _path3$104;
function _extends$297() {
	return _extends$297 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$297.apply(null, arguments);
}
var SvgMoon = function SvgMoon(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$297({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$283 || (_path$283 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M2.634 6.095a7 7 0 0 0 6.687 4.92c1.615 0 3.1-.55 4.285-1.469.047.016.08.065.064.12a5.8 5.8 0 1 1-11.036-3.57",
		opacity: .25
	})), _path2$199 || (_path2$199 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M12.068 2.001a.2.2 0 0 1 .376 0l.59 1.597a.2.2 0 0 0 .118.118l1.597.59a.2.2 0 0 1 0 .376l-1.597.59a.2.2 0 0 0-.118.119l-.59 1.596a.2.2 0 0 1-.376 0l-.59-1.596a.2.2 0 0 0-.119-.119l-1.596-.59a.2.2 0 0 1 0-.375l1.596-.591a.2.2 0 0 0 .118-.118z",
		opacity: .5
	})), _path3$104 || (_path3$104 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M7.358 1.026C8.567.895 9.17 2.256 8.532 3.1 7.202 4.863 7.09 6.61 7.8 7.664c.8 1.185 2.839 1.729 5.3.765l.179-.055c.898-.208 1.853.602 1.54 1.64a7 7 0 0 1-6.404 4.963l-.295.006a7 7 0 0 1-.762-13.957M2.32 7.983a5.8 5.8 0 0 0 11.278 1.903l.071-.22c.024-.08-.056-.15-.133-.12-2.711 1.062-5.48.645-6.732-1.212-1.11-1.646-.726-3.974.77-5.956.052-.069-.001-.168-.087-.159A5.8 5.8 0 0 0 2.32 7.983"
	})));
};

//#endregion
//#region src/Icon/icons/Mouse.svg
var _path$282;
var _path2$198;
function _extends$296() {
	return _extends$296 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$296.apply(null, arguments);
}
var SvgMouse = function SvgMouse(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$296({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$282 || (_path$282 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M3.125 8c0 1.171.05 2.379.199 3.381.074.501.169.922.28 1.247.118.34.225.49.271.537a.7.7 0 0 0 .142.089c.09.045.225.103.42.164.364.112.83.205 1.364.276l.26.034c.847.113 1.098.147 1.96.147s1.112-.034 1.96-.147l.26-.034c.533-.071.998-.164 1.362-.276a3 3 0 0 0 .42-.164.7.7 0 0 0 .143-.09c.042-.042.147-.188.26-.527.11-.324.2-.744.269-1.246.14-1.004.18-2.213.18-3.391l-.001-.331H3.126z",
		clipRule: "evenodd",
		opacity: .25
	})), _path2$198 || (_path2$198 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M13.015 14.012c.23-.231.41-.576.55-.995s.243-.917.319-1.46c.15-1.088.191-2.362.191-3.557s-.04-2.47-.191-3.556a8.3 8.3 0 0 0-.32-1.461c-.14-.419-.318-.764-.549-.995-.232-.233-.606-.412-1.056-.552a10 10 0 0 0-1.561-.319l-.123-.016C9.238.963 8.953.925 8.02.925s-1.217.038-2.255.176l-.122.016a10 10 0 0 0-1.561.32c-.45.14-.825.318-1.057.55-.23.232-.411.577-.555.995a8.3 8.3 0 0 0-.333 1.461C1.976 5.53 1.925 6.805 1.925 8s.05 2.47.212 3.557a8.3 8.3 0 0 0 .333 1.461c.144.418.325.763.555.994.232.233.606.412 1.057.552.453.14.991.243 1.56.319l.123.016c1.038.138 1.323.176 2.255.176.933 0 1.218-.038 2.255-.176l.123-.016a10 10 0 0 0 1.56-.32c.451-.14.825-.318 1.057-.55M3.125 8c0 1.171.05 2.379.199 3.381.074.501.169.922.28 1.247.118.34.225.49.271.537.01.01.052.043.142.089.09.045.225.103.42.164.364.112.83.205 1.364.275l.26.035c.846.113 1.098.147 1.96.147s1.112-.034 1.96-.147l.26-.035c.533-.07.998-.163 1.362-.275a3 3 0 0 0 .42-.164.7.7 0 0 0 .143-.09c.042-.042.147-.188.26-.527.109-.324.2-.744.269-1.246.14-1.004.18-2.213.18-3.391l-.001-.331H3.126zm.48-4.628c.117-.34.224-.49.27-.537a.7.7 0 0 1 .142-.089c.09-.045.225-.103.42-.164.364-.112.83-.205 1.364-.275l.26-.035c.603-.08.904-.121 1.339-.138V6.47H3.158c.03-.653.082-1.284.166-1.85.074-.501.169-.922.28-1.247m9.09 1.237a7 7 0 0 0-.268-1.246c-.114-.34-.219-.485-.261-.528a.7.7 0 0 0-.143-.089 3 3 0 0 0-.42-.164 8.6 8.6 0 0 0-1.363-.275l-.26-.035c-.622-.083-.923-.124-1.38-.139v4.336h4.247a19 19 0 0 0-.152-1.86",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/MouseLeftClick.svg
var _path$281;
var _path2$197;
var _path3$103;
function _extends$295() {
	return _extends$295 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$295.apply(null, arguments);
}
var SvgMouseLeftClick = function SvgMouseLeftClick(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$295({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$281 || (_path$281 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M3.125 8c0 1.171.05 2.379.199 3.381.074.501.169.922.28 1.247.118.34.225.49.271.537a.7.7 0 0 0 .142.089c.09.045.225.103.42.164.364.112.83.205 1.364.276l.26.034c.847.113 1.098.147 1.96.147s1.112-.034 1.96-.147l.26-.034c.533-.071.998-.164 1.362-.276a3 3 0 0 0 .42-.164.7.7 0 0 0 .143-.09c.042-.042.147-.188.26-.527.11-.324.2-.744.269-1.246.14-1.004.18-2.213.18-3.391l-.001-.331H3.126z",
		clipRule: "evenodd",
		opacity: .25
	})), _path2$197 || (_path2$197 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M3.605 3.372c.117-.34.224-.49.27-.537a.7.7 0 0 1 .142-.089c.09-.045.225-.103.42-.164.364-.112.83-.205 1.364-.275l.26-.035c.603-.08.904-.121 1.339-.138V6.47H3.158c.03-.653.082-1.284.166-1.85.074-.501.169-.922.28-1.247",
		clipRule: "evenodd",
		opacity: .5
	})), _path3$103 || (_path3$103 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M13.015 14.012c.23-.231.41-.576.55-.995s.243-.917.319-1.46c.15-1.088.191-2.362.191-3.557s-.04-2.47-.191-3.556a8.3 8.3 0 0 0-.32-1.461c-.14-.419-.318-.764-.549-.995-.232-.233-.606-.412-1.056-.552a10 10 0 0 0-1.561-.319l-.123-.016C9.238.963 8.953.925 8.02.925s-1.217.038-2.255.176l-.122.016a10 10 0 0 0-1.561.32c-.45.14-.825.318-1.057.55-.23.232-.411.577-.555.995a8.3 8.3 0 0 0-.333 1.461C1.976 5.53 1.925 6.805 1.925 8s.05 2.47.212 3.557a8.3 8.3 0 0 0 .333 1.461c.144.418.325.763.555.994.232.233.606.412 1.057.552.453.14.991.243 1.56.319l.123.016c1.038.138 1.323.176 2.255.176.933 0 1.218-.038 2.255-.176l.123-.016a10 10 0 0 0 1.56-.32c.451-.14.825-.318 1.057-.55M3.125 8c0 1.171.05 2.379.199 3.381.074.501.169.922.28 1.247.118.34.225.49.271.537.01.01.052.043.142.089.09.045.225.103.42.164.364.112.83.205 1.364.275l.26.035c.846.113 1.098.147 1.96.147s1.112-.034 1.96-.147l.26-.035c.533-.07.998-.163 1.362-.275a3 3 0 0 0 .42-.164.7.7 0 0 0 .143-.09c.042-.042.147-.188.26-.527.109-.324.2-.744.269-1.246.14-1.004.18-2.213.18-3.391l-.001-.331H3.126zm.48-4.628c.117-.34.224-.49.27-.537a.7.7 0 0 1 .142-.089c.09-.045.225-.103.42-.164.364-.112.83-.205 1.364-.275l.26-.035c.603-.08.904-.121 1.339-.138V6.47H3.158c.03-.653.082-1.284.166-1.85.074-.501.169-.922.28-1.247m9.09 1.237a7 7 0 0 0-.268-1.246c-.114-.34-.219-.485-.261-.528a.7.7 0 0 0-.143-.089 3 3 0 0 0-.42-.164 8.6 8.6 0 0 0-1.363-.275l-.26-.035c-.622-.083-.923-.124-1.38-.139v4.336h4.247a19 19 0 0 0-.152-1.86",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/MouseRightClick.svg
var _path$280;
var _path2$196;
var _path3$102;
function _extends$294() {
	return _extends$294 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$294.apply(null, arguments);
}
var SvgMouseRightClick = function SvgMouseRightClick(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$294({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$280 || (_path$280 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M3.125 8c0 1.171.05 2.379.199 3.381.074.501.169.922.28 1.247.118.34.225.49.271.537a.7.7 0 0 0 .142.089c.09.045.225.103.42.164.364.112.83.205 1.364.276l.26.034c.847.113 1.098.147 1.96.147s1.112-.034 1.96-.147l.26-.034c.533-.071.998-.164 1.362-.276a3 3 0 0 0 .42-.164.7.7 0 0 0 .143-.09c.042-.042.147-.188.26-.527.11-.324.2-.744.269-1.246.14-1.004.18-2.213.18-3.391l-.001-.331H3.126z",
		clipRule: "evenodd",
		opacity: .25
	})), _path2$196 || (_path2$196 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M12.695 4.609a7 7 0 0 0-.268-1.246c-.114-.34-.219-.485-.261-.528a.7.7 0 0 0-.143-.089 3 3 0 0 0-.42-.164 8.6 8.6 0 0 0-1.363-.275l-.26-.035c-.622-.083-.923-.124-1.38-.139v4.336h4.247a19 19 0 0 0-.152-1.86",
		clipRule: "evenodd",
		opacity: .5
	})), _path3$102 || (_path3$102 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M13.015 14.012c.23-.231.41-.576.55-.995s.243-.917.319-1.46c.15-1.088.191-2.362.191-3.557s-.04-2.47-.191-3.556a8.3 8.3 0 0 0-.32-1.461c-.14-.419-.318-.764-.549-.995-.232-.233-.606-.412-1.056-.552a10 10 0 0 0-1.561-.319l-.123-.016C9.238.963 8.953.925 8.02.925s-1.217.038-2.255.176l-.122.016a10 10 0 0 0-1.561.32c-.45.14-.825.318-1.057.55-.23.232-.411.577-.555.995a8.3 8.3 0 0 0-.333 1.461C1.976 5.53 1.925 6.805 1.925 8s.05 2.47.212 3.557a8.3 8.3 0 0 0 .333 1.461c.144.418.325.763.555.994.232.233.606.412 1.057.552.453.14.991.243 1.56.319l.123.016c1.038.138 1.323.176 2.255.176.933 0 1.218-.038 2.255-.176l.123-.016a10 10 0 0 0 1.56-.32c.451-.14.825-.318 1.057-.55M3.125 8c0 1.171.05 2.379.199 3.381.074.501.169.922.28 1.247.118.34.225.49.271.537.01.01.052.043.142.089.09.045.225.103.42.164.364.112.83.205 1.364.275l.26.035c.846.113 1.098.147 1.96.147s1.112-.034 1.96-.147l.26-.035c.533-.07.998-.163 1.362-.275a3 3 0 0 0 .42-.164.7.7 0 0 0 .143-.09c.042-.042.147-.188.26-.527.109-.324.2-.744.269-1.246.14-1.004.18-2.213.18-3.391l-.001-.331H3.126zm.48-4.628c.117-.34.224-.49.27-.537a.7.7 0 0 1 .142-.089c.09-.045.225-.103.42-.164.364-.112.83-.205 1.364-.275l.26-.035c.603-.08.904-.121 1.339-.138V6.47H3.158c.03-.653.082-1.284.166-1.85.074-.501.169-.922.28-1.247m9.09 1.237a7 7 0 0 0-.268-1.246c-.114-.34-.219-.485-.261-.528a.7.7 0 0 0-.143-.089 3 3 0 0 0-.42-.164 8.6 8.6 0 0 0-1.363-.275l-.26-.035c-.622-.083-.923-.124-1.38-.139v4.336h4.247a19 19 0 0 0-.152-1.86",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/MouseWheel.svg
var _path$279;
var _path2$195;
var _path3$101;
function _extends$293() {
	return _extends$293 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$293.apply(null, arguments);
}
var SvgMouseWheel = function SvgMouseWheel(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$293({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$279 || (_path$279 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M3.125 8c0 1.171.05 2.379.199 3.381.074.501.169.922.28 1.247.118.34.225.49.271.537a.7.7 0 0 0 .142.089c.09.045.225.103.42.164.364.112.83.205 1.364.276l.26.034c.847.113 1.098.147 1.96.147s1.112-.034 1.96-.147l.26-.034c.533-.071.998-.164 1.362-.276a3 3 0 0 0 .42-.164.7.7 0 0 0 .143-.09c.042-.042.147-.188.26-.527.11-.324.2-.744.269-1.246.14-1.004.18-2.213.18-3.391l-.001-.331H3.126z",
		clipRule: "evenodd",
		opacity: .25
	})), _path2$195 || (_path2$195 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M13.565 13.017c-.14.419-.32.764-.55.995-.232.233-.606.412-1.056.552-.453.14-.992.243-1.561.319l-.123.016c-1.037.138-1.322.176-2.255.176s-1.217-.038-2.255-.176l-.122-.016a10 10 0 0 1-1.561-.32c-.45-.14-.825-.318-1.057-.55-.23-.232-.411-.577-.555-.995a8.3 8.3 0 0 1-.333-1.461C1.976 10.47 1.925 9.195 1.925 8s.05-2.47.212-3.557a8.3 8.3 0 0 1 .333-1.461c.144-.418.325-.763.555-.994.232-.233.606-.412 1.057-.552.453-.14.991-.243 1.56-.319l.123-.016C6.803.963 7.088.925 8.02.925c.933 0 1.218.038 2.255.176l.123.016c.57.076 1.108.179 1.56.32.451.14.825.318 1.057.55.23.232.41.577.55.996s.243.917.319 1.46c.15 1.088.191 2.362.191 3.557s-.04 2.47-.191 3.556a8.3 8.3 0 0 1-.32 1.461M3.324 11.381c-.149-1.002-.199-2.21-.199-3.381l.001-.331h9.748l.001.331c0 1.178-.04 2.387-.18 3.391-.07.502-.16.922-.268 1.246-.114.34-.219.485-.261.528a.7.7 0 0 1-.143.089 3 3 0 0 1-.42.164c-.364.112-.83.205-1.363.275l-.26.035c-.847.113-1.098.147-1.96.147s-1.113-.034-1.96-.147l-.26-.035c-.533-.07-.999-.163-1.362-.275a3 3 0 0 1-.42-.164.7.7 0 0 1-.143-.09c-.046-.045-.153-.195-.27-.536a7 7 0 0 1-.281-1.247m.551-8.546c-.046.046-.153.196-.27.537a7 7 0 0 0-.281 1.247 19 19 0 0 0-.166 1.85h9.69a19 19 0 0 0-.153-1.86 7 7 0 0 0-.268-1.246c-.114-.34-.219-.485-.261-.528a.7.7 0 0 0-.143-.089 3 3 0 0 0-.42-.164 8.6 8.6 0 0 0-1.363-.275l-.26-.035c-.622-.083-.923-.124-1.38-.139l-1.2.001c-.435.017-.736.057-1.34.138l-.26.035c-.533.07-.999.163-1.362.275-.196.061-.331.119-.42.164a.7.7 0 0 0-.143.09",
		clipRule: "evenodd"
	})), _path3$101 || (_path3$101 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M7.4 3.53v1.54a.6.6 0 0 0 1.2 0V3.53a.6.6 0 0 0-1.2 0"
	})));
};

//#endregion
//#region src/Icon/icons/Move.svg
var _path$278;
function _extends$292() {
	return _extends$292 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$292.apply(null, arguments);
}
var SvgMove = function SvgMove(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$292({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$278 || (_path$278 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M10.304 8.083a.805.805 0 0 0 .793.724l.835-.002.87-.003-.716.84-.009.012-.01.01a.816.816 0 0 0 0 1.143c.289.292.745.31 1.055.054l.06-.054 2.183-2.236h.002a.815.815 0 0 0 0-1.142l-.002-.001-2.183-2.236a.78.78 0 0 0-1.116.001.815.815 0 0 0-.054 1.08l.054.061.01.01.01.012.718.842-.87-.003-.837-.004a.81.81 0 0 0-.798.809zM8 10.3a.81.81 0 0 0-.809.798l.004.835.003.869-.662-.564-.179-.151-.011-.01-.011-.01a.816.816 0 0 0-1.08-.055l-.062.054a.78.78 0 0 0-.002 1.115l2.238 2.185v.001c.316.311.828.311 1.142 0h.001l2.236-2.186a.78.78 0 0 0-.001-1.115.815.815 0 0 0-1.142 0l-.01.011-.011.01-.18.152-.662.565.006-1.706A.807.807 0 0 0 8 10.3M8 5.7a.81.81 0 0 0 .809-.797l-.004-.836-.003-.87.84.716.012.009.011.01c.315.312.827.312 1.142 0l.054-.059a.78.78 0 0 0-.054-1.056L8.57.634V.632a.815.815 0 0 0-1.142 0l-.001.002-2.236 2.184a.78.78 0 0 0 .001 1.115c.315.31.827.31 1.142 0l.01-.01.011-.01.842-.718-.006 1.708A.807.807 0 0 0 8 5.7M5.696 7.917a.807.807 0 0 0-.794-.726l-.836.004-.87.003.718-.842.01-.011.01-.011a.814.814 0 0 0 0-1.14.78.78 0 0 0-1.116 0v-.002L.634 7.428H.633a.816.816 0 0 0-.055 1.08l.055.062.002.001 2.182 2.236a.783.783 0 0 0 1.117 0 .816.816 0 0 0 0-1.143l-.011-.01-.009-.011-.716-.841.87.003.834.002c.435 0 .8-.36.8-.807z"
	})));
};

//#endregion
//#region src/Icon/icons/MulticastDNS.svg
var _path$277;
var _path2$194;
function _extends$291() {
	return _extends$291 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$291.apply(null, arguments);
}
var SvgMulticastDns = function SvgMulticastDns(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$291({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$277 || (_path$277 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M9.5 6.1h-3a.4.4 0 0 0-.4.4v3c0 .22.18.4.4.4h3a.4.4 0 0 0 .4-.4v-3a.4.4 0 0 0-.4-.4m-3-1.2a1.6 1.6 0 0 0-1.6 1.6v3a1.6 1.6 0 0 0 1.6 1.6h3a1.6 1.6 0 0 0 1.6-1.6v-3a1.6 1.6 0 0 0-1.6-1.6z",
		clipRule: "evenodd"
	})), _path2$194 || (_path2$194 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M8.554 3.9H7.442V2.656L6.119 3.81a.615.615 0 0 1-.786 0 .442.442 0 0 1 0-.686l2.25-1.962A.6.6 0 0 1 7.999 1c.164 0 .312.062.413.16l2.252 1.963a.442.442 0 0 1 0 .686.615.615 0 0 1-.787 0L8.554 2.656zM12.1 8.558V7.446h1.244L12.19 6.124a.615.615 0 0 1 0-.787.442.442 0 0 1 .685 0l1.963 2.251c.099.102.161.25.161.414a.6.6 0 0 1-.16.414l-1.963 2.251a.442.442 0 0 1-.686 0 .615.615 0 0 1 0-.786l1.153-1.323zM7.442 12.1h1.112v1.244l1.322-1.153c.217-.19.57-.19.787 0a.442.442 0 0 1 0 .685L8.41 14.84a.6.6 0 0 1-.413.161.6.6 0 0 1-.414-.16l-2.251-1.963a.442.442 0 0 1 0-.686c.217-.19.569-.19.786 0l1.323 1.153zM3.9 7.446v1.112H2.656L3.81 9.881c.19.217.19.569 0 .786a.442.442 0 0 1-.686 0L1.161 8.416A.6.6 0 0 1 1 8.002c0-.164.062-.312.16-.414l1.963-2.25a.442.442 0 0 1 .686 0c.19.216.19.568 0 .786L2.656 7.446zM8.6 8a.6.6 0 1 1-1.2 0 .6.6 0 0 1 1.2 0"
	})));
};

//#endregion
//#region src/Icon/icons/NAT.svg
var _path$276;
function _extends$290() {
	return _extends$290 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$290.apply(null, arguments);
}
var SvgNat = function SvgNat(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$290({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$276 || (_path$276 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M10.5 8.657a6.52 6.52 0 0 1-5.931 5.84c-.367.032-.659-.27-.659-.626 0-.362.293-.642.64-.678a5.221 5.221 0 0 0 0-10.386c-.347-.036-.64-.316-.64-.678 0-.357.292-.658.659-.627a6.52 6.52 0 0 1 5.93 5.841h2.562l-1.01-1.158a.716.716 0 0 1 0-.919.543.543 0 0 1 .837 0l1.963 2.252A.7.7 0 0 1 15.04 8c0 .188-.071.36-.188.482l-1.963 2.252a.543.543 0 0 1-.837 0 .716.716 0 0 1 0-.92l1.01-1.157zM6.522 7.35a2.21 2.21 0 1 0 0 1.3h1.16a.65.65 0 0 0 0-1.3z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/NetworkIDS.svg
var _g$50;
var _g2$5;
var _path$275;
function _extends$289() {
	return _extends$289 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$289.apply(null, arguments);
}
var SvgNetworkIds = function SvgNetworkIds(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$289({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$50 || (_g$50 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .5
	}, /*#__PURE__*/ React.createElement("path", { d: "M3.04 8.862c-.141.019-.3.045-.459.085a5.494 5.494 0 0 1 2.34-5.505c-.016.229-.021.455-.021.658 0 .296.01.64.049.97a4.22 4.22 0 0 0-1.104 3.733c-.244.006-.53.022-.804.059M7.168 12.74q.104.38.252.73-.18-.02-.359-.05c.035-.139.059-.275.076-.4a6 6 0 0 0 .031-.28M13.101 5.94l-.23-.087A2.4 2.4 0 0 0 12.1 5.7h-.098q-.21.005-.418.05a4.3 4.3 0 0 0-.528-.677A9 9 0 0 0 11.1 4.1c0-.201-.004-.427-.018-.656a5.5 5.5 0 0 1 2.019 2.495" }))), _g2$5 || (_g2$5 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M3.198 13.748a2.6 2.6 0 0 1-.419-.085.7.7 0 0 1-.283-.148.7.7 0 0 1-.15-.267 2.2 2.2 0 0 1-.09-.393A7 7 0 0 1 2.2 11.9c0-.321.014-.663.057-.955.022-.146.05-.28.09-.393a.7.7 0 0 1 .149-.267.7.7 0 0 1 .283-.148c.122-.037.266-.065.42-.085.305-.041.647-.052.906-.052.26 0 .602.011.908.052.152.02.297.048.419.085a.7.7 0 0 1 .283.148q.092.097.148.268c.038.112.065.246.086.392.04.292.051.634.051.955s-.01.663-.051.955c-.02.146-.048.28-.086.392a.7.7 0 0 1-.148.268.7.7 0 0 1-.283.148 2.6 2.6 0 0 1-.42.085 7 7 0 0 1-.907.052 7 7 0 0 1-.907-.052M12.05 14.669q.13 0 .25-.06c1.315-.673 2.127-1.64 2.333-2.806.147-.834.13-1.687.085-2.281a.584.584 0 0 0-.378-.496l-1.937-.732a1 1 0 0 0-.353-.064z" }))), _path$275 || (_path$275 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M6.94 7.138a4 4 0 0 1-.616-.13 1.9 1.9 0 0 1-.778-.446 1.9 1.9 0 0 1-.434-.724 3.4 3.4 0 0 1-.142-.607A8 8 0 0 1 4.9 4.1c0-.345.014-.754.07-1.131.028-.188.07-.4.142-.607.065-.19.188-.477.434-.724.271-.272.6-.391.778-.447a4 4 0 0 1 .617-.129C7.32 1.012 7.72 1 8.005 1s.685.012 1.065.062c.19.025.407.064.617.13.179.055.507.174.778.446.25.25.372.543.436.734.07.208.11.42.136.608.052.375.063.783.063 1.12s-.01.745-.063 1.12c-.026.187-.067.4-.136.608a2 2 0 0 1-.066.173L8.51 6.88q-.317.121-.585.32a8 8 0 0 1-.984-.061m.158-1.19a2.6 2.6 0 0 1-.419-.085.7.7 0 0 1-.283-.148.7.7 0 0 1-.15-.267 2.2 2.2 0 0 1-.09-.393A7 7 0 0 1 6.1 4.1c0-.321.014-.663.057-.955.022-.146.05-.28.09-.393a.7.7 0 0 1 .149-.267.7.7 0 0 1 .283-.148 2.6 2.6 0 0 1 .42-.085c.305-.041.646-.052.906-.052s.602.011.908.052c.152.02.297.048.419.085a.7.7 0 0 1 .283.148q.092.096.148.268c.038.112.065.246.086.392.04.292.051.634.051.955s-.01.663-.051.955c-.02.146-.048.28-.086.392a.7.7 0 0 1-.148.268.7.7 0 0 1-.283.148 2.6 2.6 0 0 1-.42.085C8.608 5.99 8.266 6 8.006 6s-.6-.011-.907-.052M6.907 9.934a1.8 1.8 0 0 0-.342-.496 1.9 1.9 0 0 0-.778-.447 4 4 0 0 0-.617-.129c-.38-.05-.78-.062-1.065-.062s-.684.011-1.064.062a4 4 0 0 0-.617.13 1.9 1.9 0 0 0-.778.446 1.9 1.9 0 0 0-.434.724 3.4 3.4 0 0 0-.142.607A8 8 0 0 0 1 11.9c0 .345.014.755.07 1.131.028.188.07.4.142.607.065.19.188.477.434.724.271.272.6.391.778.447.21.065.428.104.617.129.38.05.78.062 1.064.062a8 8 0 0 0 1.065-.062c.19-.025.407-.064.617-.13.179-.055.507-.174.778-.446.25-.25.372-.543.436-.734.07-.208.11-.42.136-.608a6 6 0 0 0 .031-.28 6 6 0 0 1-.113-.51 11.3 11.3 0 0 1-.148-2.296m-4.128 3.729c.122.037.266.065.42.085.305.041.646.052.906.052s.602-.011.908-.052c.152-.02.297-.048.419-.085a.7.7 0 0 0 .283-.148.7.7 0 0 0 .148-.268c.038-.112.065-.246.086-.392.04-.292.051-.634.051-.955s-.01-.663-.051-.955a2.2 2.2 0 0 0-.086-.392.7.7 0 0 0-.148-.268.7.7 0 0 0-.283-.148 2.6 2.6 0 0 0-.42-.085A7 7 0 0 0 4.106 10c-.26 0-.6.011-.907.052-.153.02-.297.048-.419.085a.7.7 0 0 0-.283.148.7.7 0 0 0-.15.267 2.2 2.2 0 0 0-.09.393 7 7 0 0 0-.056.955c0 .321.014.663.057.955.022.146.05.28.09.393a.7.7 0 0 0 .149.267c.062.062.162.11.283.148M8.18 8.969c-.07.603-.16 1.825.056 3.052.316 1.787 1.62 3.093 3.37 3.88q.204.092.427.098l.017.001h.017c.146-.005.292-.038.428-.1 1.75-.786 3.053-2.092 3.369-3.88.217-1.226.126-2.448.057-3.051a1.18 1.18 0 0 0-.755-.967l-2.718-1.027a1.2 1.2 0 0 0-.383-.075h-.03q-.197.006-.383.075L8.934 8.002a1.18 1.18 0 0 0-.755.967m6.538.553c.045.595.062 1.447-.085 2.281-.206 1.166-1.018 2.133-2.334 2.806a.55.55 0 0 1-.498 0c-1.316-.673-2.128-1.64-2.334-2.806a7 7 0 0 1-.04-.255 9.8 9.8 0 0 1-.045-2.026.58.58 0 0 1 .378-.496l1.937-.731a1 1 0 0 1 .706 0l1.937.731a.58.58 0 0 1 .378.496",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/NetworkWide.svg
var _g$49;
var _g2$4;
var _path$274;
function _extends$288() {
	return _extends$288 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$288.apply(null, arguments);
}
var SvgNetworkWide = function SvgNetworkWide(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$288({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$49 || (_g$49 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		fillRule: "evenodd",
		clipRule: "evenodd",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M10.58 13.663c.12.037.265.065.418.085.306.041.648.052.908.052s.6-.011.906-.052c.154-.02.298-.048.42-.085a.7.7 0 0 0 .283-.148.7.7 0 0 0 .148-.268c.038-.112.065-.246.086-.392.04-.292.051-.634.051-.955s-.01-.663-.051-.955a2.2 2.2 0 0 0-.086-.392.7.7 0 0 0-.148-.268.7.7 0 0 0-.283-.148 2.6 2.6 0 0 0-.42-.085 7 7 0 0 0-.906-.052c-.26 0-.602.011-.908.052-.152.02-.297.048-.419.085a.7.7 0 0 0-.284.148.7.7 0 0 0-.149.267 2.2 2.2 0 0 0-.09.393A7 7 0 0 0 10 11.9c0 .321.014.663.057.955.021.146.05.28.09.393a.7.7 0 0 0 .149.267c.062.062.162.11.283.148M2.78 13.663c.12.037.265.065.418.085.306.041.648.052.907.052.26 0 .602-.011.908-.052.152-.02.297-.048.419-.085a.7.7 0 0 0 .283-.148.7.7 0 0 0 .148-.268c.038-.112.065-.246.086-.392.04-.292.051-.634.051-.955s-.01-.663-.051-.955a2.2 2.2 0 0 0-.086-.392.7.7 0 0 0-.148-.268.7.7 0 0 0-.283-.148 2.6 2.6 0 0 0-.42-.085A7 7 0 0 0 4.106 10c-.26 0-.6.011-.907.052-.153.02-.297.048-.419.085a.7.7 0 0 0-.283.148.7.7 0 0 0-.15.267 2.2 2.2 0 0 0-.09.393 7 7 0 0 0-.056.955c0 .321.014.663.057.955.022.146.05.28.09.393a.7.7 0 0 0 .149.267c.062.062.162.11.283.148" }))), _g2$4 || (_g2$4 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .5
	}, /*#__PURE__*/ React.createElement("path", { d: "M11.055 5.073a4.22 4.22 0 0 1 1.1 3.73c.246.006.536.022.815.059.14.018.294.044.45.083q.079-.461.08-.945a5.5 5.5 0 0 0-2.418-4.556c.014.23.018.455.018.656 0 .294-.008.641-.045.973M8.946 13.419a4 4 0 0 1-.076-.388 7 7 0 0 1-.067-.876 4.3 4.3 0 0 1-1.605 0 8 8 0 0 1-.06.865 4 4 0 0 1-.077.4 5.5 5.5 0 0 0 1.885-.001M2.581 8.947c.16-.04.318-.066.46-.085.275-.037.56-.053.804-.059A4.217 4.217 0 0 1 4.948 5.07 9 9 0 0 1 4.9 4.1c0-.203.005-.43.02-.658a5.49 5.49 0 0 0-2.339 5.505" }))), _path$274 || (_path$274 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M10.224 14.809c.21.065.428.104.617.129.38.05.78.062 1.065.062s.684-.011 1.064-.062c.19-.025.407-.064.617-.13.179-.055.507-.174.778-.446.25-.25.372-.543.436-.734.07-.208.11-.42.136-.608.052-.375.063-.782.063-1.12s-.01-.745-.063-1.12a3.4 3.4 0 0 0-.136-.608 1.9 1.9 0 0 0-.436-.734 1.9 1.9 0 0 0-.778-.447 4 4 0 0 0-.617-.129c-.38-.05-.78-.062-1.065-.062s-.684.011-1.064.062a4 4 0 0 0-.617.13 1.9 1.9 0 0 0-.778.446 1.9 1.9 0 0 0-.434.724 3.4 3.4 0 0 0-.142.607A8 8 0 0 0 8.8 11.9c0 .345.014.755.07 1.131.028.188.07.4.142.607.065.19.188.477.434.724.271.272.6.391.778.447m.355-1.146c.122.037.266.065.42.085.305.041.646.052.906.052s.602-.011.908-.052c.152-.02.297-.048.419-.085a.7.7 0 0 0 .283-.148.7.7 0 0 0 .148-.268c.038-.112.065-.246.086-.392.04-.292.051-.634.051-.955s-.01-.663-.051-.955a2.2 2.2 0 0 0-.086-.392.7.7 0 0 0-.148-.268.7.7 0 0 0-.283-.148 2.6 2.6 0 0 0-.42-.085 7 7 0 0 0-.906-.052c-.26 0-.602.011-.908.052-.152.02-.297.048-.419.085a.7.7 0 0 0-.284.148.7.7 0 0 0-.149.267 2.2 2.2 0 0 0-.09.393A7 7 0 0 0 10 11.9c0 .321.014.663.057.955.021.146.05.28.09.393a.7.7 0 0 0 .149.267c.062.062.162.11.283.148M2.424 14.809c.21.065.428.104.617.129.38.05.78.062 1.064.062a8 8 0 0 0 1.065-.062c.19-.025.407-.064.617-.13.179-.055.507-.174.778-.446.25-.25.372-.543.436-.734.07-.208.11-.42.136-.608.052-.375.063-.783.063-1.12s-.01-.745-.063-1.12a3.4 3.4 0 0 0-.136-.608 1.9 1.9 0 0 0-.436-.734 1.9 1.9 0 0 0-.778-.447 4 4 0 0 0-.617-.129c-.38-.05-.78-.062-1.065-.062s-.684.011-1.064.062a4 4 0 0 0-.617.13 1.9 1.9 0 0 0-.778.446 1.9 1.9 0 0 0-.434.724 3.4 3.4 0 0 0-.142.607A8 8 0 0 0 1 11.9c0 .345.014.755.07 1.131.028.188.07.4.142.607.065.19.188.477.434.724.271.272.6.391.778.447m.355-1.146c.122.037.266.065.42.085.305.041.646.052.906.052s.602-.011.908-.052c.152-.02.297-.048.419-.085a.7.7 0 0 0 .283-.148.7.7 0 0 0 .148-.268c.038-.112.065-.246.086-.392.04-.292.051-.634.051-.955s-.01-.663-.051-.955a2.2 2.2 0 0 0-.086-.392.7.7 0 0 0-.148-.268.7.7 0 0 0-.283-.148 2.6 2.6 0 0 0-.42-.085A7 7 0 0 0 4.106 10c-.26 0-.6.011-.907.052-.153.02-.297.048-.419.085a.7.7 0 0 0-.283.148.7.7 0 0 0-.15.267 2.2 2.2 0 0 0-.09.393 7 7 0 0 0-.056.955c0 .321.014.663.057.955.022.146.05.28.09.393a.7.7 0 0 0 .149.267c.062.062.162.11.283.148M6.324 7.009c.21.065.428.104.617.129.38.05.78.062 1.064.062s.685-.011 1.065-.062a4 4 0 0 0 .617-.13c.179-.055.507-.174.778-.446.25-.25.372-.543.436-.734.07-.208.11-.42.136-.608A8 8 0 0 0 11.1 4.1c0-.337-.01-.745-.063-1.12a3.4 3.4 0 0 0-.136-.608 1.9 1.9 0 0 0-.436-.734 1.9 1.9 0 0 0-.778-.447 4 4 0 0 0-.617-.129C8.69 1.012 8.29 1 8.005 1s-.684.012-1.064.062a4 4 0 0 0-.617.13 1.9 1.9 0 0 0-.778.446 1.9 1.9 0 0 0-.434.724 3.4 3.4 0 0 0-.142.607c-.056.377-.07.786-.07 1.131s.014.754.07 1.131c.028.188.07.4.142.607.065.19.188.477.434.724.271.272.6.391.778.447m.355-1.146c.122.037.266.065.42.085.305.041.646.052.906.052s.602-.011.908-.052a2.6 2.6 0 0 0 .419-.085.7.7 0 0 0 .283-.148.7.7 0 0 0 .148-.268c.038-.112.065-.246.086-.392.04-.292.051-.634.051-.955s-.01-.663-.051-.955a2.2 2.2 0 0 0-.086-.392.7.7 0 0 0-.148-.268.7.7 0 0 0-.283-.148 2.6 2.6 0 0 0-.42-.085 7 7 0 0 0-.907-.052c-.26 0-.6.011-.907.052a2.6 2.6 0 0 0-.419.085.7.7 0 0 0-.283.148.7.7 0 0 0-.15.267 2.2 2.2 0 0 0-.09.393A7 7 0 0 0 6.1 4.1c0 .321.014.663.057.955.022.146.05.28.09.393a.7.7 0 0 0 .149.267c.062.062.162.11.283.148",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Noise.svg
var _path$273;
function _extends$287() {
	return _extends$287 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$287.apply(null, arguments);
}
var SvgNoise = function SvgNoise(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$287({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$273 || (_path$273 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M7.1 2.9a.9.9 0 1 1 1.8 0v10.2a.9.9 0 1 1-1.8 0zM10.1 4.9a.9.9 0 1 1 1.8 0v6.2a.9.9 0 1 1-1.8 0zM13.1 6.9a.9.9 0 1 1 1.8 0v2.2a.9.9 0 1 1-1.8 0zM4.1 6.9a.9.9 0 1 1 1.8 0v2.2a.9.9 0 0 1-1.8 0zM1.1 4.9a.9.9 0 1 1 1.8 0v6.2a.9.9 0 1 1-1.8 0z"
	})));
};

//#endregion
//#region src/Icon/icons/Note.svg
var _g$48;
var _path$272;
var _path2$193;
var _path3$100;
function _extends$286() {
	return _extends$286 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$286.apply(null, arguments);
}
var SvgNote = function SvgNote(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$286({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$48 || (_g$48 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .5
	}, /*#__PURE__*/ React.createElement("path", { d: "M4.5 4.6a.6.6 0 0 1 .6-.6h5.8a.6.6 0 1 1 0 1.2H5.1a.6.6 0 0 1-.6-.6M4.5 7a.6.6 0 0 1 .6-.6h5.625l-1.2 1.2H5.1a.6.6 0 0 1-.6-.6M8.325 8.8H5.1a.6.6 0 0 0 0 1.2h2.025z" }))), _path$272 || (_path$272 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M11.8 1H4.2A2.2 2.2 0 0 0 2 3.2v9.6A2.2 2.2 0 0 0 4.2 15h.605a2.4 2.4 0 0 1 .064-.704l.12-.496H4.2a1 1 0 0 1-1-1V3.2a1 1 0 0 1 1-1h7.6a1 1 0 0 1 1 1v1.734c.39-.112.797-.154 1.2-.125V3.2A2.2 2.2 0 0 0 11.8 1"
	})), _path2$193 || (_path2$193 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "m15.342 9.836-5.15 5.15c-.266.266-.6.453-.964.542l-1.804.438a1.15 1.15 0 0 1-1.39-1.387l.438-1.805c.088-.366.276-.7.542-.966l5.15-5.15a2.247 2.247 0 1 1 3.178 3.178m-5.789 4.512 3.735-3.735-1.901-1.9-3.734 3.733a1.15 1.15 0 0 0-.304.54l-.436 1.805a.247.247 0 0 0 .298.298l1.803-.438c.204-.05.39-.155.54-.303m3.25-7.051-.637.636 1.901 1.9.636-.635a1.344 1.344 0 0 0-1.9-1.901",
		clipRule: "evenodd"
	})), _path3$100 || (_path3$100 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M9.258 15.086h.883v-1.563a.44.44 0 0 0-.441-.442h-.535a.147.147 0 0 1-.147-.147V12.4a.44.44 0 0 0-.441-.44H7.013v.882h.975c.082 0 .147.065.148.147v.535c0 .243.198.44.441.44h.534c.082 0 .147.067.147.148z"
	})));
};

//#endregion
//#region src/Icon/icons/Observer.svg
var _g$47;
var _path$271;
var _path2$192;
function _extends$285() {
	return _extends$285 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$285.apply(null, arguments);
}
var SvgObserver = function SvgObserver(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$285({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$47 || (_g$47 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M13.864 8.942c-.019.865-.066 1.713-.169 2.45a7 7 0 0 1-.268 1.245c-.114.339-.218.485-.261.528a.7.7 0 0 1-.143.089c-.089.045-.224.103-.42.164-.363.113-.83.205-1.363.275-1.064.142-2.276.182-3.22.182-.943 0-2.155-.04-3.22-.182-.533-.07-.999-.162-1.362-.275a3 3 0 0 1-.42-.164.7.7 0 0 1-.143-.089l-.019-.022 1.71-1.711c.881.624 2.044 1.181 3.426 1.181 1.676 0 3.004-.73 3.936-1.49.927-.756 1.545-1.608 1.82-1.993q.064-.091.116-.188M13.166 2.835c.043.043.147.189.26.528.11.324.2.744.27 1.245.104.758.153 1.632.17 2.522a2 2 0 0 0-.108-.176 10.6 10.6 0 0 0-1.49-1.737l-.333-.292-.368-.287q-.06-.044-.122-.085l1.72-1.719z" }), /*#__PURE__*/ React.createElement("path", {
		fillRule: "evenodd",
		d: "M7.992 5.825c.78 0 1.464.36 2.052.795a2.45 2.45 0 0 1-.047 2.825c-.575.412-1.243.749-2.005.749-.527 0-1.032-.198-1.508-.486a7 7 0 0 1-.573-.397 2.455 2.455 0 0 1 .03-2.672c.595-.446 1.279-.814 2.051-.814M6.742 8A1.258 1.258 0 1 1 8 9.258 1.26 1.26 0 0 1 6.742 8",
		clipRule: "evenodd"
	}))), _path$271 || (_path$271 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M14.565 13.017c-.14.419-.32.764-.55.995-.232.233-.606.412-1.056.552-.453.14-.992.243-1.561.319-1.14.151-2.41.192-3.378.192s-2.238-.04-3.377-.192a10 10 0 0 1-1.561-.32c-.45-.14-.825-.318-1.057-.55-.23-.232-.411-.577-.555-.995a8.3 8.3 0 0 1-.333-1.461C.976 10.47.925 9.195.925 8s.05-2.47.212-3.557a8.3 8.3 0 0 1 .333-1.461c.144-.418.325-.763.555-.994.232-.233.606-.412 1.057-.552.453-.14.991-.243 1.56-.319C5.783.966 7.053.925 8.02.925s2.239.04 3.378.192c.57.076 1.108.179 1.56.32.451.14.825.318 1.057.55.23.232.41.577.55.996s.243.917.319 1.46c.15 1.088.191 2.362.191 3.557s-.04 2.47-.191 3.556a8.3 8.3 0 0 1-.32 1.461M2.875 2.835c-.046.046-.153.196-.27.537a7 7 0 0 0-.281 1.247C2.175 5.62 2.125 6.829 2.125 8s.05 2.379.199 3.381c.074.501.169.922.28 1.247.118.34.225.49.271.537.01.01.052.043.142.089.09.045.225.103.42.164.364.112.83.205 1.364.275 1.064.142 2.275.182 3.22.182.943 0 2.155-.04 3.22-.182.533-.07.998-.163 1.362-.275a3 3 0 0 0 .42-.164.7.7 0 0 0 .143-.09c.042-.042.147-.188.26-.527.109-.324.2-.744.269-1.246.14-1.004.18-2.213.18-3.391s-.04-2.387-.18-3.391a7 7 0 0 0-.268-1.246c-.114-.34-.219-.485-.261-.528a.7.7 0 0 0-.143-.089 3 3 0 0 0-.42-.164 8.6 8.6 0 0 0-1.363-.275c-1.064-.142-2.276-.182-3.22-.182s-2.155.04-3.22.182c-.533.07-.999.163-1.362.275-.196.061-.331.119-.42.164a.7.7 0 0 0-.143.09",
		clipRule: "evenodd"
	})), _path2$192 || (_path2$192 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M11.17 5.848c-.8-.663-1.869-1.243-3.178-1.243-1.277 0-2.333.572-3.131 1.227-.799.655-1.353 1.406-1.628 1.787a.686.686 0 0 0 .018.835c.291.369.872 1.106 1.677 1.75.803.643 1.848 1.209 3.064 1.209 1.311 0 2.38-.569 3.178-1.22.798-.65 1.34-1.393 1.602-1.76.17-.239.17-.551.003-.792-.262-.374-.806-1.13-1.605-1.793M8 9.258a1.258 1.258 0 1 0-.002-2.513A1.258 1.258 0 0 0 8 9.257m2.874-.53c-.73.652-1.694 1.465-2.882 1.465-.527 0-1.032-.197-1.508-.485-.477-.289-.91-.66-1.298-.992-.2-.173-.45-.43-.624-.616a.13.13 0 0 1-.003-.18c.164-.186.398-.443.588-.615.75-.677 1.701-1.48 2.845-1.48 1.172 0 2.134.806 2.868 1.477.197.18.437.45.601.642a.13.13 0 0 1 0 .174c-.162.184-.395.44-.587.61",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Onboarding.svg
var _path$270;
var _path2$191;
var _path3$99;
function _extends$284() {
	return _extends$284 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$284.apply(null, arguments);
}
var SvgOnboarding = function SvgOnboarding(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$284({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$270 || (_path$270 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M7.674 9.204A2.34 2.34 0 0 0 9.3 10.74a2.02 2.02 0 0 0 2.535-1.752l.31-2.753.49-.325a.8.8 0 0 1 1.242.666v6.74a.8.8 0 0 1-.8.8H2.927c-.792 0-1.102-1.028-.442-1.466z",
		opacity: .25
	})), _path2$191 || (_path2$191 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M7.622 7.798 1.821 11.65c-1.65 1.096-.874 3.666 1.106 3.666h10.15a2 2 0 0 0 2-2v-6.74c0-1.46-1.49-2.383-2.762-1.85l-.17 1.509.489-.325a.8.8 0 0 1 1.242.667v6.74a.8.8 0 0 1-.8.8H2.927c-.792 0-1.102-1.029-.442-1.467l5.19-3.446c-.101-.305-.14-.632-.103-.962z"
	})), _path3$99 || (_path3$99 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M2.528 9.702c-.41.283-1.003.132-1.328-.337-.324-.47-.255-1.079.154-1.361L7.955 3.44 4.8 2.638a1.14 1.14 0 0 1-.83-1.201.82.82 0 0 1 1.046-.724L10.39 2.08c.258.052.51.212.683.463.173.25.234.541.19.801l-.62 5.51a.82.82 0 0 1-1.047.724 1.14 1.14 0 0 1-.83-1.201l.364-3.237z"
	})));
};

//#endregion
//#region src/Icon/icons/Operator.svg
var _path$269;
var _path2$190;
var _path3$98;
function _extends$283() {
	return _extends$283 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$283.apply(null, arguments);
}
var SvgOperator$1 = function SvgOperator(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$283({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$269 || (_path$269 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M4 2.304h8a1 1 0 0 1 1 1v6.331a1 1 0 0 1-.315.73 5.3 5.3 0 0 0-1.406-1.725c.23-.48.36-1.019.36-1.587 0-2.02-1.628-3.659-3.639-3.659-2.01 0-3.638 1.64-3.638 3.659 0 .568.13 1.107.36 1.587a5.3 5.3 0 0 0-1.407 1.724A1 1 0 0 1 3 9.635V3.305a1 1 0 0 1 1-1",
		clipRule: "evenodd",
		opacity: .25
	})), _path2$190 || (_path2$190 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M8.607 13.49a1 1 0 0 1-1.215 0l-3.107-2.377a4.1 4.1 0 0 1 2.204-2.13c.415.33.94.527 1.511.527.57 0 1.096-.197 1.511-.528a4.1 4.1 0 0 1 2.204 2.13z",
		opacity: .5
	})), _path3$98 || (_path3$98 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "m13.337 11.383-4 3.06a2.2 2.2 0 0 1-2.674 0l-4-3.06A2.2 2.2 0 0 1 1.8 9.635V3.304a2.2 2.2 0 0 1 2.2-2.2h8a2.2 2.2 0 0 1 2.2 2.2v6.331a2.2 2.2 0 0 1-.863 1.748M7.392 13.49a1 1 0 0 0 1.215 0l3.108-2.378a4.1 4.1 0 0 0-1.978-2.03l-.002-.001a4 4 0 0 0-.224-.099q.096-.075.184-.161l.008-.008a2.46 2.46 0 0 0 .738-1.76A2.45 2.45 0 0 0 8 4.597a2.45 2.45 0 0 0-2.442 2.456 2.46 2.46 0 0 0 .747 1.768l.015.014q.08.077.169.147-.115.046-.226.1l-.013.006a4.105 4.105 0 0 0-1.965 2.025zM4 2.304h8a1 1 0 0 1 1 1v6.331a1 1 0 0 1-.315.73 5.3 5.3 0 0 0-1.406-1.725c.23-.48.359-1.019.359-1.587 0-2.02-1.627-3.66-3.638-3.66-2.01 0-3.638 1.64-3.638 3.66 0 .568.13 1.107.36 1.587a5.3 5.3 0 0 0-1.407 1.724A1 1 0 0 1 3 9.635V3.304a1 1 0 0 1 1-1",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Outlet.svg
var _path$268;
var _path2$189;
function _extends$282() {
	return _extends$282 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$282.apply(null, arguments);
}
var SvgOutlet$1 = function SvgOutlet(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$282({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$268 || (_path$268 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M4.959 2.865C3.205 3.9 2.108 5.821 2.108 8s1.097 4.1 2.85 5.135a.43.43 0 0 0 .218.046h5.648a.43.43 0 0 0 .218-.046c1.753-1.034 2.85-2.956 2.85-5.135s-1.097-4.1-2.85-5.135a.43.43 0 0 0-.218-.046H5.176a.43.43 0 0 0-.217.046m6.702-1.05a1.64 1.64 0 0 0-.837-.215H5.176c-.292 0-.582.065-.837.215C2.2 3.077.89 5.407.89 8s1.311 4.923 3.45 6.185c.255.15.545.215.837.215h5.648c.292 0 .583-.065.837-.215 2.14-1.262 3.45-3.592 3.45-6.185s-1.31-4.923-3.45-6.185",
		clipRule: "evenodd"
	})), _path2$189 || (_path2$189 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M10.95 10.864a.61.61 0 0 1-1.22 0V8.832a.61.61 0 0 1 1.22 0zM6.27 11.371a.61.61 0 1 1-1.22 0V8.324a.61.61 0 1 1 1.22 0zM9.22 5.238a1.22 1.22 0 0 1-2.439 0V4.28c0-.144.117-.261.261-.261h1.916c.144 0 .261.117.261.261z"
	})));
};

//#endregion
//#region src/Icon/icons/OverflowHorizontal.svg
var _path$267;
function _extends$281() {
	return _extends$281 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$281.apply(null, arguments);
}
var SvgOverflowHorizontal = function SvgOverflowHorizontal(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$281({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$267 || (_path$267 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M3.556 6.45c.859 0 1.555.694 1.555 1.55s-.696 1.55-1.555 1.55C2.696 9.55 2 8.856 2 8s.696-1.55 1.556-1.55M8 6.45c.86 0 1.556.694 1.556 1.55S8.859 9.55 8 9.55 6.444 8.856 6.444 8 7.141 6.45 8 6.45M14 8c0-.856-.697-1.55-1.556-1.55S10.89 7.144 10.89 8s.696 1.55 1.555 1.55C13.304 9.55 14 8.856 14 8"
	})));
};

//#endregion
//#region src/Icon/icons/OverflowHorizontalCircle.svg
var _path$266;
var _path2$188;
var _path3$97;
function _extends$280() {
	return _extends$280 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$280.apply(null, arguments);
}
var SvgOverflowHorizontalCircle = function SvgOverflowHorizontalCircle(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$280({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$266 || (_path$266 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M12.1 3.897A5.8 5.8 0 1 1 3.898 12.1l2.136-2.134a2.3 2.3 0 0 0 .39-.293 2.3 2.3 0 0 0 3.154 0A2.303 2.303 0 0 0 13.457 8c0-1.193-.909-2.17-2.067-2.287l-.236-.012c-.435 0-.84.123-1.188.333z",
		opacity: .25
	})), _path2$188 || (_path2$188 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M4.846 6.9c.61 0 1.104.492 1.104 1.1s-.494 1.1-1.104 1.1S3.742 8.608 3.742 8s.494-1.1 1.104-1.1M8 6.9c.61 0 1.104.492 1.104 1.1S8.61 9.1 8 9.1 6.896 8.608 6.896 8 7.39 6.9 8 6.9M12.258 8c0-.608-.494-1.1-1.104-1.1S10.05 7.392 10.05 8s.494 1.1 1.104 1.1 1.104-.492 1.104-1.1"
	})), _path3$97 || (_path3$97 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14M8 2.2a5.8 5.8 0 1 1 0 11.6A5.8 5.8 0 0 1 8 2.2",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/OverflowVertical.svg
var _path$265;
function _extends$279() {
	return _extends$279 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$279.apply(null, arguments);
}
var SvgOverflowVertical = function SvgOverflowVertical(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$279({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$265 || (_path$265 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M6.45 12.444c0-.859.694-1.555 1.55-1.555s1.55.696 1.55 1.555C9.55 13.304 8.856 14 8 14s-1.55-.696-1.55-1.556M6.45 8c0-.86.694-1.556 1.55-1.556S9.55 7.141 9.55 8 8.856 9.556 8 9.556 6.45 8.859 6.45 8M8 2c-.856 0-1.55.696-1.55 1.556 0 .859.694 1.555 1.55 1.555s1.55-.696 1.55-1.555C9.55 2.696 8.856 2 8 2"
	})));
};

//#endregion
//#region src/Icon/icons/OverflowVerticalCircle.svg
var _path$264;
var _path2$187;
var _path3$96;
function _extends$278() {
	return _extends$278 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$278.apply(null, arguments);
}
var SvgOverflowVerticalCircle = function SvgOverflowVerticalCircle(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$278({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$264 || (_path$264 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M12.1 3.897A5.8 5.8 0 1 1 3.898 12.1l2.136-2.134a2.3 2.3 0 0 0-.321.953l-.012.235c0 1.19.902 2.174 2.065 2.292l.235.012.236-.012a2.304 2.304 0 0 0 1.437-3.869 2.3 2.3 0 0 0 0-3.154q.167-.18.293-.39z",
		opacity: .25
	})), _path2$187 || (_path2$187 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M6.9 11.154c0-.61.492-1.104 1.1-1.104s1.1.494 1.1 1.104-.492 1.104-1.1 1.104-1.1-.494-1.1-1.104M6.9 8c0-.61.492-1.104 1.1-1.104S9.1 7.39 9.1 8 8.608 9.104 8 9.104 6.9 8.61 6.9 8M8 3.742c-.608 0-1.1.494-1.1 1.104S7.392 5.95 8 5.95s1.1-.494 1.1-1.104S8.608 3.742 8 3.742"
	})), _path3$96 || (_path3$96 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0M2.2 8a5.8 5.8 0 1 1 11.6 0A5.8 5.8 0 0 1 2.2 8",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/PacketCapture.svg
var _path$263;
var _path2$186;
var _path3$95;
function _extends$277() {
	return _extends$277 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$277.apply(null, arguments);
}
var SvgPacketCapture = function SvgPacketCapture(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$277({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$263 || (_path$263 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M5.248 7.224V9.27c0 .121.067.233.174.291l1.972 1.062V8.608a.33.33 0 0 0-.17-.29z",
		clipRule: "evenodd",
		opacity: .25
	})), _path2$186 || (_path2$186 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M5.248 7.224V9.27c0 .121.067.233.174.291l1.972 1.062V8.608a.33.33 0 0 0-.17-.29zm3.358 3.399 1.972-1.062a.33.33 0 0 0 .174-.291V7.224L8.776 8.318a.33.33 0 0 0-.17.29zM10.1 6.2 8.159 5.14a.33.33 0 0 0-.318 0L5.9 6.2l1.94 1.074c.1.056.222.056.321 0zM8.37 3.874l3.192 1.744a.77.77 0 0 1 .4.676V9.73a.77.77 0 0 1-.405.68l-3.192 1.718a.77.77 0 0 1-.73 0l-3.193-1.719a.77.77 0 0 1-.405-.679V6.294c0-.282.154-.541.401-.676L7.63 3.874a.77.77 0 0 1 .74 0",
		clipRule: "evenodd"
	})), _path3$95 || (_path3$95 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M5.792 14.156c.378.149.763-.147.763-.553a.66.66 0 0 0-.42-.603 5.82 5.82 0 0 1-3.14-3.14.66.66 0 0 0-.603-.42c-.406 0-.702.385-.553.763a7.02 7.02 0 0 0 3.953 3.953M14.156 10.203c.149-.378-.147-.763-.553-.763a.66.66 0 0 0-.603.42A5.82 5.82 0 0 1 9.86 13a.66.66 0 0 0-.42.604c0 .405.385.7.763.552a7.02 7.02 0 0 0 3.953-3.953M9.44 2.392c0 .267.173.5.42.603A5.82 5.82 0 0 1 13 6.135c.102.247.336.42.604.42.405 0 .7-.385.552-.762a7.02 7.02 0 0 0-3.953-3.954c-.378-.149-.763.147-.763.553M6.555 2.392c0-.406-.385-.702-.763-.553A7.02 7.02 0 0 0 1.84 5.793c-.149.377.147.762.553.762a.66.66 0 0 0 .603-.42 5.82 5.82 0 0 1 3.14-3.14.66.66 0 0 0 .42-.603M7.4 1.6a.6.6 0 0 1 1.2 0v1a.6.6 0 0 1-1.2 0zM7.4 13.4a.6.6 0 1 1 1.2 0v1a.6.6 0 1 1-1.2 0zM1.6 8.6a.6.6 0 0 1 0-1.2h1a.6.6 0 0 1 0 1.2zM13.4 8.6a.6.6 0 1 1 0-1.2h1a.6.6 0 1 1 0 1.2z"
	})));
};

//#endregion
//#region src/Icon/icons/Padlock.svg
var _path$262;
var _path2$185;
function _extends$276() {
	return _extends$276 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$276.apply(null, arguments);
}
var SvgPadlock = function SvgPadlock(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$276({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$262 || (_path$262 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M8.927 9.427a.93.93 0 0 1-.463.803v1.206a.464.464 0 0 1-.928 0V10.23a.927.927 0 1 1 1.391-.803"
	})), _path2$185 || (_path2$185 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M4.5 4.5v1.333a2.333 2.333 0 0 0-2.333 2.334v4.5A2.333 2.333 0 0 0 4.5 15h7a2.333 2.333 0 0 0 2.333-2.333v-4.5A2.333 2.333 0 0 0 11.5 5.833V4.5a3.5 3.5 0 1 0-7 0m5.6 1.333V4.5a2.1 2.1 0 1 0-4.2 0v1.333zM3.567 8.167c0-.516.418-.934.933-.934h7c.515 0 .933.418.933.934v4.5a.933.933 0 0 1-.933.933h-7a.933.933 0 0 1-.933-.933z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/PadlockContent.svg
var _path$261;
var _path2$184;
function _extends$275() {
	return _extends$275 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$275.apply(null, arguments);
}
var SvgPadlockContent = function SvgPadlockContent(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$275({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$261 || (_path$261 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M.6 2.6a2 2 0 0 1 2-2h10.8a2 2 0 0 1 2 2v8.8a2 2 0 0 1-1.987 2l.003-.133v-3.15a2.93 2.93 0 0 0-1.647-2.633C11.733 5.434 10.05 3.8 8 3.8S4.267 5.434 4.231 7.484a2.93 2.93 0 0 0-1.647 2.633v3.15q0 .067.003.133a2 2 0 0 1-1.987-2z",
		opacity: .25
	})), _path2$184 || (_path2$184 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M5.43 8.386V7.55A2.56 2.56 0 0 1 8 5a2.56 2.56 0 0 1 2.57 2.55v.836a1.74 1.74 0 0 1 1.646 1.73v3.15A1.74 1.74 0 0 1 10.47 15H5.53a1.74 1.74 0 0 1-1.746-1.733v-3.15c0-.925.73-1.68 1.646-1.73m3.952-.003V7.55c0-.756-.618-1.37-1.382-1.37s-1.382.614-1.382 1.37v.833zM5.53 9.563a.556.556 0 0 0-.558.554v3.15c0 .305.25.553.558.553h4.94c.309 0 .558-.248.558-.553v-3.15a.556.556 0 0 0-.558-.554zm2.897 2.054A.747.747 0 0 0 8 10.25a.747.747 0 0 0-.427 1.367v.788c0 .236.192.425.427.425s.427-.19.427-.425z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/PaneBottom.svg
var _path$260;
var _path2$183;
function _extends$274() {
	return _extends$274 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$274.apply(null, arguments);
}
var SvgPaneBottom = function SvgPaneBottom(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$274({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$260 || (_path$260 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M2.2 3.2a1 1 0 0 1 1-1h9.6a1 1 0 0 1 1 1v5.4H2.2z",
		opacity: .25
	})), _path2$183 || (_path2$183 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M3.2 1h9.6A2.2 2.2 0 0 1 15 3.2v9.6a2.2 2.2 0 0 1-2.2 2.2H3.2A2.2 2.2 0 0 1 1 12.8V3.2A2.2 2.2 0 0 1 3.2 1m0 12.8a1 1 0 0 1-1-1v-3h11.6v3a1 1 0 0 1-1 1zm0-11.6a1 1 0 0 0-1 1v5.4h11.6V3.2a1 1 0 0 0-1-1z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/PaneEnd.svg
var _path$259;
var _path2$182;
function _extends$273() {
	return _extends$273 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$273.apply(null, arguments);
}
var SvgPaneEnd = function SvgPaneEnd(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$273({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$259 || (_path$259 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M3.2 13.8a1 1 0 0 1-1-1V3.2a1 1 0 0 1 1-1h5.4v11.6z",
		opacity: .25
	})), _path2$182 || (_path2$182 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M1 12.8V3.2A2.2 2.2 0 0 1 3.2 1h9.6A2.2 2.2 0 0 1 15 3.2v9.6a2.2 2.2 0 0 1-2.2 2.2H3.2A2.2 2.2 0 0 1 1 12.8m2.2 1a1 1 0 0 1-1-1V3.2a1 1 0 0 1 1-1h5.4v11.6zm9.6 0a1 1 0 0 0 1-1V3.2a1 1 0 0 0-1-1h-3v11.6z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/PaneEndCollapse.svg
var _path$258;
var _path2$181;
var _path3$94;
function _extends$272() {
	return _extends$272 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$272.apply(null, arguments);
}
var SvgPaneEndCollapse = function SvgPaneEndCollapse(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$272({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$258 || (_path$258 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M3.2 2.2a1 1 0 0 0-1 1v9.6a1 1 0 0 0 1 1h5.4v-1.665l-.934.927a1.855 1.855 0 0 1-2.612 0 1.844 1.844 0 0 1 0-2.62L7.514 8l-2.46-2.442a1.844 1.844 0 0 1 0-2.62 1.856 1.856 0 0 1 2.612 0l.934.926V2.2z",
		opacity: .25
	})), _path2$181 || (_path2$181 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M3.2 1A2.2 2.2 0 0 0 1 3.2v9.6A2.2 2.2 0 0 0 3.2 15h9.6a2.2 2.2 0 0 0 2.2-2.2V3.2A2.2 2.2 0 0 0 12.8 1zm9.6 1.2a1 1 0 0 1 1 1v9.6a1 1 0 0 1-1 1h-3v-2.857l-1.2 1.192V13.8H3.2a1 1 0 0 1-1-1V3.2a1 1 0 0 1 1-1h5.4v1.663l1.2 1.192V2.2z",
		clipRule: "evenodd"
	})), _path3$94 || (_path3$94 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M5.899 11.295a.644.644 0 0 0 0 .915.655.655 0 0 0 .921 0l3.781-3.752a.644.644 0 0 0 0-.916l-3.78-3.753a.655.655 0 0 0-.922 0 .644.644 0 0 0 0 .916L9.08 7.864a.19.19 0 0 1 0 .274z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/PaneEndExpand.svg
var _path$257;
var _path2$180;
var _path3$93;
function _extends$271() {
	return _extends$271 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$271.apply(null, arguments);
}
var SvgPaneEndExpand = function SvgPaneEndExpand(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$271({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$257 || (_path$257 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M3.2 2.2a1 1 0 0 0-1 1v9.6a1 1 0 0 0 1 1h5.4v-1.964L6.054 9.31a1.85 1.85 0 0 1-.512-1.664l.03-.131c.083-.304.245-.59.482-.826L8.6 4.162V2.2z",
		opacity: .25
	})), _path2$180 || (_path2$180 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M3.2 1A2.2 2.2 0 0 0 1 3.2v9.6A2.2 2.2 0 0 0 3.2 15h9.6a2.2 2.2 0 0 0 2.2-2.2V3.2A2.2 2.2 0 0 0 12.8 1zm9.6 1.2a1 1 0 0 1 1 1v9.6a1 1 0 0 1-1 1h-3v-.773l-1.2-1.191V13.8H3.2a1 1 0 0 1-1-1V3.2a1 1 0 0 1 1-1h5.4v1.962l1.2-1.191V2.2z",
		clipRule: "evenodd"
	})), _path3$93 || (_path3$93 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M11.601 11.295a.644.644 0 0 1 0 .915.655.655 0 0 1-.921 0L6.9 8.459a.644.644 0 0 1 0-.916l3.78-3.753a.655.655 0 0 1 .921 0 .644.644 0 0 1 0 .916l-3.18 3.158a.19.19 0 0 0 0 .274z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/PaneStart.svg
var _path$256;
var _path2$179;
function _extends$270() {
	return _extends$270 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$270.apply(null, arguments);
}
var SvgPaneStart = function SvgPaneStart(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$270({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$256 || (_path$256 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M12.8 13.8a1 1 0 0 0 1-1V3.2a1 1 0 0 0-1-1H7.4v11.6z",
		opacity: .25
	})), _path2$179 || (_path2$179 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M15 12.8V3.2A2.2 2.2 0 0 0 12.8 1H3.2A2.2 2.2 0 0 0 1 3.2v9.6A2.2 2.2 0 0 0 3.2 15h9.6a2.2 2.2 0 0 0 2.2-2.2m-2.2 1a1 1 0 0 0 1-1V3.2a1 1 0 0 0-1-1H7.4v11.6zm-9.6 0a1 1 0 0 1-1-1V3.2a1 1 0 0 1 1-1h3v11.6z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/PaneStartCollapse.svg
var _path$255;
var _path2$178;
var _path3$92;
function _extends$269() {
	return _extends$269 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$269.apply(null, arguments);
}
var SvgPaneStartCollapse = function SvgPaneStartCollapse(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$269({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$255 || (_path$255 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M12.8 2.2a1 1 0 0 1 1 1v9.6a1 1 0 0 1-1 1H7.4v-1.665l.934.927c.722.717 1.89.717 2.612 0a1.845 1.845 0 0 0 0-2.62L8.486 8l2.46-2.442a1.845 1.845 0 0 0 0-2.62 1.856 1.856 0 0 0-2.612 0l-.934.926V2.2z",
		opacity: .25
	})), _path2$178 || (_path2$178 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M12.8 1A2.2 2.2 0 0 1 15 3.2v9.6a2.2 2.2 0 0 1-2.2 2.2H3.2A2.2 2.2 0 0 1 1 12.8V3.2A2.2 2.2 0 0 1 3.2 1zM3.2 2.2a1 1 0 0 0-1 1v9.6a1 1 0 0 0 1 1h3v-2.857l1.2 1.192V13.8h5.4a1 1 0 0 0 1-1V3.2a1 1 0 0 0-1-1H7.4v1.663L6.2 5.055V2.2z",
		clipRule: "evenodd"
	})), _path3$92 || (_path3$92 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M10.101 11.295a.644.644 0 0 1 0 .915.655.655 0 0 1-.921 0L5.399 8.459a.644.644 0 0 1 0-.916l3.78-3.753a.655.655 0 0 1 .922 0 .644.644 0 0 1 0 .916L6.92 7.864a.19.19 0 0 0 0 .274z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/PaneStartExpand.svg
var _path$254;
var _path2$177;
var _path3$91;
function _extends$268() {
	return _extends$268 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$268.apply(null, arguments);
}
var SvgPaneStartExpand = function SvgPaneStartExpand(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$268({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$254 || (_path$254 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M12.8 2.2a1 1 0 0 1 1 1v9.6a1 1 0 0 1-1 1H7.4v-1.964L9.946 9.31a1.85 1.85 0 0 0 .512-1.664l-.03-.131a1.85 1.85 0 0 0-.482-.826L7.4 4.162V2.2z",
		opacity: .25
	})), _path2$177 || (_path2$177 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M12.8 1A2.2 2.2 0 0 1 15 3.2v9.6a2.2 2.2 0 0 1-2.2 2.2H3.2A2.2 2.2 0 0 1 1 12.8V3.2A2.2 2.2 0 0 1 3.2 1zM3.2 2.2a1 1 0 0 0-1 1v9.6a1 1 0 0 0 1 1h3v-.773l1.2-1.191V13.8h5.4a1 1 0 0 0 1-1V3.2a1 1 0 0 0-1-1H7.4v1.962L6.2 2.971V2.2z",
		clipRule: "evenodd"
	})), _path3$91 || (_path3$91 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M4.399 11.295a.644.644 0 0 0 0 .915.655.655 0 0 0 .921 0L9.1 8.459a.644.644 0 0 0 0-.916L5.32 3.789a.655.655 0 0 0-.921 0 .644.644 0 0 0 0 .916l3.18 3.158a.19.19 0 0 1 0 .274z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/PaneTop.svg
var _path$253;
var _path2$176;
function _extends$267() {
	return _extends$267 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$267.apply(null, arguments);
}
var SvgPaneTop = function SvgPaneTop(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$267({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$253 || (_path$253 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M1.7 12.8a1 1 0 0 0 1 1h9.6a1 1 0 0 0 1-1V7.4H1.7z",
		opacity: .25
	})), _path2$176 || (_path2$176 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M2.7 15h9.6a2.2 2.2 0 0 0 2.2-2.2V3.2A2.2 2.2 0 0 0 12.3 1H2.7A2.2 2.2 0 0 0 .5 3.2v9.6A2.2 2.2 0 0 0 2.7 15m0-12.8a1 1 0 0 0-1 1v3h11.6v-3a1 1 0 0 0-1-1zm0 11.6a1 1 0 0 1-1-1V7.4h11.6v5.4a1 1 0 0 1-1 1z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Parts.svg
var _g$46;
var _path$252;
var _path2$175;
var _path3$90;
var _path4$34;
function _extends$266() {
	return _extends$266 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$266.apply(null, arguments);
}
var SvgParts = function SvgParts(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$266({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$46 || (_g$46 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		fillRule: "evenodd",
		clipRule: "evenodd",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M2.6 13.8a.4.4 0 0 1-.4-.4v-3.2c0-.22.18-.4.4-.4h.7a.9.9 0 0 1 1.8 0h.7c.22 0 .4.18.4.4v.7a.9.9 0 1 0 0 1.8v.7a.4.4 0 0 1-.4.4zM13.4 2.2c.22 0 .4.18.4.4v3.2a.4.4 0 0 1-.4.4h-.7a.9.9 0 0 1-1.8 0h-.7a.4.4 0 0 1-.4-.4v-.7a.9.9 0 0 0 0-1.8v-.7c0-.22.18-.4.4-.4z" }))), _path$252 || (_path$252 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M1 5.8a1.6 1.6 0 0 0 1.6 1.6h3.2a1.6 1.6 0 0 0 1.595-1.473 2.098 2.098 0 0 0 0-3.454A1.6 1.6 0 0 0 5.8 1H2.6A1.6 1.6 0 0 0 1 2.6zm1.2-3.2c0-.22.18-.4.4-.4h3.2c.22 0 .4.18.4.4v.7a.9.9 0 0 1 0 1.8v.7a.4.4 0 0 1-.4.4h-.7a.9.9 0 0 0-1.8 0h-.7a.4.4 0 0 1-.4-.4z",
		clipRule: "evenodd"
	})), _path2$175 || (_path2$175 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M5.8 15a1.6 1.6 0 0 0 1.6-1.6v-3.2a1.6 1.6 0 0 0-1.473-1.595 2.098 2.098 0 0 0-3.454 0A1.6 1.6 0 0 0 1 10.2v3.2A1.6 1.6 0 0 0 2.6 15zm-3.2-1.2a.4.4 0 0 1-.4-.4v-3.2c0-.22.18-.4.4-.4h.7a.9.9 0 0 1 1.8 0h.7c.22 0 .4.18.4.4v.7a.9.9 0 1 0 0 1.8v.7a.4.4 0 0 1-.4.4z",
		clipRule: "evenodd"
	})), _path3$90 || (_path3$90 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M15 10.2a1.6 1.6 0 0 0-1.6-1.6h-3.2a1.6 1.6 0 0 0-1.595 1.473 2.098 2.098 0 0 0 0 3.454A1.6 1.6 0 0 0 10.2 15h3.2a1.6 1.6 0 0 0 1.6-1.6zm-1.2 3.2a.4.4 0 0 1-.4.4h-3.2a.4.4 0 0 1-.4-.4v-.7a.9.9 0 0 1 0-1.8v-.7c0-.22.18-.4.4-.4h.7a.9.9 0 0 0 1.8 0h.7c.22 0 .4.18.4.4z",
		clipRule: "evenodd"
	})), _path4$34 || (_path4$34 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M10.2 1a1.6 1.6 0 0 0-1.6 1.6v3.2a1.6 1.6 0 0 0 1.473 1.595 2.098 2.098 0 0 0 3.454 0A1.6 1.6 0 0 0 15 5.8V2.6A1.6 1.6 0 0 0 13.4 1zm3.2 1.2c.22 0 .4.18.4.4v3.2a.4.4 0 0 1-.4.4h-.7a.9.9 0 0 1-1.8 0h-.7a.4.4 0 0 1-.4-.4v-.7a.9.9 0 0 0 0-1.8v-.7c0-.22.18-.4.4-.4z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Paste.svg
var _path$251;
var _path2$174;
var _path3$89;
function _extends$265() {
	return _extends$265 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$265.apply(null, arguments);
}
var SvgPaste = function SvgPaste(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$265({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$251 || (_path$251 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8.175 6.515a1.66 1.66 0 0 0-1.66 1.66V12.2c0 .917.743 1.66 1.66 1.66H12.2a1.66 1.66 0 0 0 1.66-1.66V8.175a1.66 1.66 0 0 0-1.66-1.66z",
		clipRule: "evenodd",
		opacity: .5
	})), _path2$174 || (_path2$174 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M9.485 4.085h1.23V3.8A2.89 2.89 0 0 0 7.825.91H3.8A2.89 2.89 0 0 0 .91 3.8v4.025a2.89 2.89 0 0 0 2.89 2.89h.285v-1.23H3.8a1.66 1.66 0 0 1-1.66-1.66V3.8c0-.917.743-1.66 1.66-1.66h4.025c.917 0 1.66.743 1.66 1.66z"
	})), _path3$89 || (_path3$89 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M12.2 5.285H8.175a2.89 2.89 0 0 0-2.89 2.89V12.2a2.89 2.89 0 0 0 2.89 2.89H12.2a2.89 2.89 0 0 0 2.89-2.89V8.175a2.89 2.89 0 0 0-2.89-2.89m-4.025 1.23a1.66 1.66 0 0 0-1.66 1.66V12.2c0 .917.743 1.66 1.66 1.66H12.2a1.66 1.66 0 0 0 1.66-1.66V8.175a1.66 1.66 0 0 0-1.66-1.66z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Patching.svg
var _g$45;
var _path$250;
function _extends$264() {
	return _extends$264 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$264.apply(null, arguments);
}
var SvgPatching = function SvgPatching(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$264({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$45 || (_g$45 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		fillRule: "evenodd",
		clipRule: "evenodd",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M3.354 10.217c.21 0 .38-.17.38-.38v-.218h1.052v.207c0 .216.175.39.39.39h.008v.009c0 .215.175.39.391.39h.678c.07 0 .127.057.128.127v2.392c0 .07-.058.127-.128.127h-.28v-.189a.593.593 0 0 0-1.187 0v.189H3.92v-.189a.593.593 0 0 0-1.187 0v.189h-.466a.127.127 0 0 1-.127-.127v-2.392c0-.07.057-.127.127-.127h.678a.39.39 0 0 0 .39-.39v-.008zM10.834 3.337c.21 0 .38-.17.38-.38v-.218h1.052v.207c0 .216.175.39.39.39h.008v.009c0 .215.175.39.391.39h.678c.07 0 .127.057.128.127v2.392c0 .07-.058.127-.128.127h-.28v-.189a.593.593 0 0 0-1.187 0v.189H11.4v-.189a.593.593 0 0 0-1.187 0v.189h-.466a.127.127 0 0 1-.127-.127V3.862c0-.07.057-.127.127-.127h.678a.39.39 0 0 0 .39-.39v-.008z" }))), _path$250 || (_path$250 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M13.266 9.36a.95.95 0 0 0-.928-.761h-1.195a.95.95 0 0 0-.93.761 1 1 0 0 0-.242.235h-.224c-.633 0-1.147.514-1.147 1.147v2.392c0 .633.514 1.147 1.147 1.147h3.986c.633 0 1.147-.514 1.147-1.147v-2.392c0-.633-.514-1.147-1.147-1.147h-.224a1 1 0 0 0-.243-.236m-2.432.857c.21 0 .38-.17.38-.38v-.218h1.052v.207c0 .216.175.39.39.39h.008v.009c0 .215.175.39.391.39h.678c.07 0 .127.057.128.127v2.392c0 .07-.058.127-.128.127h-.28v-.189a.593.593 0 0 0-1.187 0v.189H11.4v-.189a.593.593 0 0 0-1.187 0v.189h-.466a.127.127 0 0 1-.127-.127v-2.392c0-.07.057-.127.127-.127h.678a.39.39 0 0 0 .39-.39v-.008zM5.786 9.36a.95.95 0 0 0-.928-.761H3.663a.95.95 0 0 0-.93.761 1 1 0 0 0-.242.235h-.224c-.633 0-1.147.514-1.147 1.147v2.392c0 .633.514 1.147 1.147 1.147h3.986c.633 0 1.147-.514 1.147-1.147v-2.392c0-.633-.514-1.147-1.147-1.147h-.224a1 1 0 0 0-.243-.236m-2.432.857c.21 0 .38-.17.38-.38v-.218h1.052v.207c0 .216.175.39.39.39h.008v.009c0 .215.175.39.391.39h.678c.07 0 .127.057.128.127v2.392c0 .07-.058.127-.128.127h-.28v-.189a.593.593 0 0 0-1.187 0v.189H3.92v-.189a.593.593 0 0 0-1.187 0v.189h-.466a.127.127 0 0 1-.127-.127v-2.392c0-.07.057-.127.127-.127h.678a.39.39 0 0 0 .39-.39v-.008zM13.266 2.48a.95.95 0 0 0-.928-.761h-1.195a.95.95 0 0 0-.93.761 1 1 0 0 0-.242.235h-.224c-.633 0-1.147.514-1.147 1.147v2.392c0 .633.514 1.147 1.147 1.147h3.986c.633 0 1.147-.514 1.147-1.147V3.862c0-.633-.514-1.147-1.147-1.147h-.224a1 1 0 0 0-.243-.236m-2.432.857c.21 0 .38-.17.38-.38v-.218h1.052v.207c0 .216.175.39.39.39h.008v.009c0 .215.175.39.391.39h.678c.07 0 .127.057.128.127v2.392c0 .07-.058.127-.128.127h-.28v-.189a.593.593 0 0 0-1.187 0v.189H11.4v-.189a.593.593 0 0 0-1.187 0v.189h-.466a.127.127 0 0 1-.127-.127V3.862c0-.07.057-.127.127-.127h.678a.39.39 0 0 0 .39-.39v-.008zM5.786 2.48a.95.95 0 0 0-.928-.761H3.663a.95.95 0 0 0-.93.761 1 1 0 0 0-.242.235h-.224c-.633 0-1.147.514-1.147 1.147v2.392c0 .633.514 1.147 1.147 1.147h3.986c.633 0 1.147-.514 1.147-1.147V3.862c0-.633-.514-1.147-1.147-1.147h-.224a1 1 0 0 0-.243-.236m-2.432.857c.21 0 .38-.17.38-.38v-.218h1.052v.207c0 .216.175.39.39.39h.008v.009c0 .215.175.39.391.39h.678c.07 0 .127.057.128.127v2.392c0 .07-.058.127-.128.127h-.28v-.189a.593.593 0 0 0-1.187 0v.189H3.92v-.189a.593.593 0 0 0-1.187 0v.189h-.466a.127.127 0 0 1-.127-.127V3.862c0-.07.057-.127.127-.127h.678a.39.39 0 0 0 .39-.39v-.008z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Pattern.svg
var _path$249;
var _path2$173;
var _path3$88;
function _extends$263() {
	return _extends$263 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$263.apply(null, arguments);
}
var SvgPattern = function SvgPattern(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$263({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$249 || (_path$249 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8.959 7.376c.226.102.527.101.87.01.64-.169 1.425-.651 2.138-1.364 1.222-1.222 1.766-2.658 1.217-3.208-.55-.55-1.987-.005-3.208 1.217-.714.713-1.196 1.5-1.365 2.14-.09.343-.09.644.011.87a.67.67 0 0 0 .337.335",
		clipRule: "evenodd",
		opacity: .25
	})), _path2$173 || (_path2$173 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8.624 8.959c-.102.226-.101.527-.01.87.169.64.651 1.425 1.364 2.138 1.222 1.222 2.658 1.766 3.208 1.217.55-.55.005-1.987-1.217-3.208-.713-.714-1.5-1.196-2.14-1.365-.343-.09-.644-.09-.87.011a.67.67 0 0 0-.335.337",
		clipRule: "evenodd",
		opacity: .5
	})), _path3$88 || (_path3$88 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M4.594 14.364c-.658.25-1.81.487-2.626-.33-.817-.817-.579-1.968-.33-2.626.294-.773.844-1.576 1.547-2.279.446-.446.933-.83 1.426-1.127a7.5 7.5 0 0 1-1.428-1.13C2.48 6.171 1.93 5.368 1.636 4.595c-.25-.658-.487-1.81.33-2.626.817-.817 1.968-.579 2.626-.33.773.294 1.576.844 2.279 1.547.446.446.83.933 1.127 1.426a7.5 7.5 0 0 1 1.129-1.428c.703-.703 1.506-1.253 2.279-1.547.657-.25 1.81-.487 2.626.33.817.817.579 1.968.33 2.626-.294.773-.844 1.576-1.547 2.279-.446.446-.933.83-1.426 1.127.494.297.982.682 1.428 1.129.703.703 1.253 1.506 1.547 2.279.25.657.487 1.81-.33 2.626-.817.817-1.968.579-2.626.33-.773-.294-1.576-.844-2.279-1.547a7.5 7.5 0 0 1-1.127-1.426 7.5 7.5 0 0 1-1.129 1.428c-.703.703-1.506 1.253-2.279 1.547m2.795-4.535c-.169.64-.651 1.427-1.365 2.14-1.221 1.222-2.658 1.767-3.208 1.217S2.811 11.2 4.033 9.978c.713-.713 1.498-1.195 2.139-1.364.342-.091.643-.092.87.01a.67.67 0 0 1 .336.336c.102.225.101.526.011.869m1.235-.87c-.102.226-.101.527-.01.87.169.64.651 1.425 1.364 2.138 1.222 1.222 2.658 1.766 3.208 1.217.55-.55.005-1.987-1.217-3.208-.713-.714-1.5-1.196-2.14-1.365-.343-.09-.644-.09-.87.011a.67.67 0 0 0-.335.337m.335-1.583c.226.102.527.101.87.01.64-.169 1.425-.651 2.138-1.364 1.222-1.222 1.766-2.658 1.217-3.208-.55-.55-1.987-.005-3.208 1.217-.714.713-1.196 1.5-1.365 2.14-.09.343-.09.644.011.87a.67.67 0 0 0 .337.335m-1.583-.335c.102-.226.101-.527.01-.87-.169-.64-.651-1.425-1.364-2.138C4.8 2.811 3.364 2.267 2.814 2.816c-.55.55-.005 1.987 1.217 3.208.713.714 1.5 1.196 2.14 1.365.343.09.644.09.87-.011a.67.67 0 0 0 .335-.337",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Pause.svg
var _g$44;
var _path$248;
function _extends$262() {
	return _extends$262 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$262.apply(null, arguments);
}
var SvgPause = function SvgPause(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$262({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$44 || (_g$44 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M3.4 12.7a1.1 1.1 0 0 0 2.194.112L5.6 12.7V3.3a1.1 1.1 0 0 0-2.2 0zM10.4 12.7a1.1 1.1 0 0 0 2.194.112l.006-.112V3.3a1.1 1.1 0 0 0-2.2 0z" }))), _path$248 || (_path$248 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M3.4 12.7a1.1 1.1 0 0 0 2.194.112L5.6 12.7V3.3a1.1 1.1 0 0 0-2.2 0zm3.4 0a2.3 2.3 0 0 1-4.6 0V3.3A2.3 2.3 0 0 1 4.5 1l.235.012A2.3 2.3 0 0 1 6.8 3.3zM10.4 12.7a1.1 1.1 0 0 0 2.194.112l.006-.112V3.3a1.1 1.1 0 0 0-2.2 0zm3.4 0a2.3 2.3 0 0 1-4.6 0V3.3A2.3 2.3 0 0 1 11.5 1l.235.012A2.3 2.3 0 0 1 13.8 3.3z"
	})));
};

//#endregion
//#region src/Icon/icons/PDU.svg
var _path$247;
var _path2$172;
var _path3$87;
function _extends$261() {
	return _extends$261 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$261.apply(null, arguments);
}
var SvgPdu = function SvgPdu(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$261({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$247 || (_path$247 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M13.166 2.835c.043.043.147.189.26.528.11.324.2.744.27 1.245.139 1.004.179 2.214.179 3.392s-.04 2.388-.18 3.392a7 7 0 0 1-.268 1.245c-.114.339-.218.485-.261.528a.7.7 0 0 1-.143.089c-.089.045-.224.103-.42.164-.363.113-.83.205-1.363.275-1.064.142-2.276.182-3.22.182-.943 0-2.155-.04-3.22-.182-.533-.07-.999-.162-1.362-.275a3 3 0 0 1-.42-.164.7.7 0 0 1-.143-.089l-.019-.022.967-.968c.344.349.735.658 1.168.914.415.244.855.33 1.244.33h3.53c.39 0 .83-.086 1.245-.33 1.786-1.054 2.855-2.986 2.855-5.089a5.93 5.93 0 0 0-1.69-4.177l.99-.989z",
		opacity: .25
	})), _path2$172 || (_path2$172 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8.86 9.62V8.352a.601.601 0 0 1 1.202 0v1.27a.6.6 0 0 1-1.202 0m-2.906.347V8.062a.6.6 0 1 1 1.202 0v1.905a.601.601 0 0 1-1.202 0m1.084-3.543v-.598c0-.212.172-.384.384-.384h1.197c.212 0 .383.172.383.384v.598a.982.982 0 1 1-1.964 0m-.834-1.44C5.182 5.591 4.537 6.716 4.537 8s.645 2.409 1.667 3.015l.031.003h3.53l.032-.003c1.021-.606 1.665-1.731 1.665-3.015s-.644-2.41-1.666-3.016l-.031-.002h-3.53zm3.56-1.204c.215 0 .437.048.636.165 1.407.83 2.264 2.36 2.264 4.055 0 1.696-.857 3.225-2.264 4.055-.199.117-.42.165-.635.165h-3.53c-.214 0-.436-.048-.635-.165-1.406-.83-2.264-2.36-2.264-4.055 0-1.696.858-3.225 2.264-4.055.199-.117.42-.165.635-.165z",
		clipRule: "evenodd"
	})), _path3$87 || (_path3$87 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M14.565 13.017c-.14.419-.32.764-.55.995-.232.233-.606.412-1.056.552-.453.14-.992.243-1.561.319-1.14.151-2.41.192-3.378.192s-2.238-.04-3.377-.192a10 10 0 0 1-1.561-.32c-.45-.14-.825-.318-1.057-.55-.23-.232-.411-.577-.555-.995a8.3 8.3 0 0 1-.333-1.461C.976 10.47.925 9.195.925 8s.05-2.47.212-3.557a8.3 8.3 0 0 1 .333-1.461c.144-.418.325-.763.555-.994.232-.233.606-.412 1.057-.552.453-.14.991-.243 1.56-.319C5.783.966 7.053.925 8.02.925s2.239.04 3.378.192c.57.076 1.108.179 1.56.32.451.14.825.318 1.057.55.23.232.41.577.55.996s.243.917.319 1.46c.15 1.088.191 2.362.191 3.557s-.04 2.47-.191 3.556a8.3 8.3 0 0 1-.32 1.461M2.875 2.835c-.046.046-.153.196-.27.537a7 7 0 0 0-.281 1.247C2.175 5.62 2.125 6.829 2.125 8s.05 2.379.199 3.381c.074.501.169.922.28 1.247.118.34.225.49.271.537.01.01.052.043.142.089.09.045.225.103.42.164.364.112.83.205 1.364.275 1.064.142 2.275.182 3.22.182.943 0 2.155-.04 3.22-.182.533-.07.998-.163 1.362-.275a3 3 0 0 0 .42-.164.7.7 0 0 0 .143-.09c.042-.042.147-.188.26-.527.109-.324.2-.744.269-1.246.14-1.004.18-2.213.18-3.391s-.04-2.387-.18-3.391a7 7 0 0 0-.268-1.246c-.114-.34-.219-.485-.261-.528a.7.7 0 0 0-.143-.089 3 3 0 0 0-.42-.164 8.6 8.6 0 0 0-1.363-.275c-1.064-.142-2.276-.182-3.22-.182s-2.155.04-3.22.182c-.533.07-.999.163-1.362.275-.196.061-.331.119-.42.164a.7.7 0 0 0-.143.09",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Pencil.svg
var _path$246;
var _path2$171;
function _extends$260() {
	return _extends$260 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$260.apply(null, arguments);
}
var SvgPencil = function SvgPencil(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$260({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$246 || (_path$246 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "m8.54 4.797 2.662 2.661-4.406 4.406v-.333a.62.62 0 0 0-.618-.617H5.43a.206.206 0 0 1-.206-.206v-.749a.62.62 0 0 0-.618-.617h-.61z",
		opacity: .25
	})), _path2$171 || (_path2$171 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M9.628 1.922a3.146 3.146 0 0 1 4.45 4.449l-7.21 7.21a2.87 2.87 0 0 1-1.351.759l-2.524.614a1.61 1.61 0 0 1-1.945-1.944l.611-2.526c.124-.512.387-.98.76-1.352zM2.277 13.308l.611-2.527q.026-.105.064-.204h.83c.114 0 .206.092.207.206v.749c.001.34.277.617.618.617h.748c.113 0 .206.093.206.206v.63a1.6 1.6 0 0 1-.342.126l-2.525.614a.346.346 0 0 1-.417-.417m2.329-3.966h-.61L8.54 4.798l2.662 2.66-4.406 4.406v-.332a.62.62 0 0 0-.618-.618H5.43a.206.206 0 0 1-.206-.206v-.75a.62.62 0 0 0-.618-.616m5.916-6.526a1.883 1.883 0 0 1 2.662 2.661l-.89.89-2.662-2.661z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Phone.svg
var _path$245;
var _path2$170;
function _extends$259() {
	return _extends$259 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$259.apply(null, arguments);
}
var SvgPhone = function SvgPhone(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$259({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$245 || (_path$245 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M8.534 12.504a.534.534 0 1 1-1.067-.002.534.534 0 0 1 1.067.002"
	})), _path2$170 || (_path2$170 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M5.669.8A2.37 2.37 0 0 0 3.3 3.167v9.666A2.37 2.37 0 0 0 5.669 15.2h4.662a2.37 2.37 0 0 0 2.369-2.367V3.167A2.37 2.37 0 0 0 10.331.8zM4.5 12.833c0 .645.523 1.167 1.169 1.167h4.662c.646 0 1.169-.522 1.169-1.167V3.167C11.5 2.522 10.977 2 10.331 2H5.67C5.023 2 4.5 2.522 4.5 3.167z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Picker.svg
var _g$43;
var _path$244;
function _extends$258() {
	return _extends$258 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$258.apply(null, arguments);
}
var SvgPicker = function SvgPicker(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$258({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$43 || (_g$43 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", {
		fillRule: "evenodd",
		d: "m9.836 3.044.064.058.594.594a.4.4 0 0 0 .566 0l.835-.835a.837.837 0 0 1 1.183 1.183l-.835.835a.4.4 0 0 0 0 .566l.682.681.057.064a.837.837 0 0 1-.057 1.12l-.064.058a.837.837 0 0 1-1.12-.058L8.717 4.286l-.058-.065a.837.837 0 0 1 1.177-1.177",
		clipRule: "evenodd"
	}), /*#__PURE__*/ React.createElement("path", { d: "M5.855 12.444c-.508.508-1.217.65-1.817.324-.22.055-1.238.715-1.348.606-.127-.127.564-1.204.603-1.401-.27-.553-.175-1.183.238-1.67l.088-.095 1.365-1.364s.703.968 1.782.531c1.078-.438 2.69-.531 2.69-.531z" }))), _path$244 || (_path$244 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M4.038 13.93c.9.241 1.899.01 2.606-.697l4.784-4.784a1.953 1.953 0 0 0 2.286-3.112.25.25 0 0 1 0-.35l.153-.153c.715-.715.76-1.847.134-2.614l-.133-.148c-.763-.763-2-.763-2.763 0l-.24.241a.124.124 0 0 1-.175 0 1.954 1.954 0 0 0-2.614-.134l-.149.134-.133.148a1.955 1.955 0 0 0-.19 2.186L2.83 9.42a2.69 2.69 0 0 0-.71 2.553l-.039.067-.055.094a7 7 0 0 0-.286.509c-.04.08-.102.217-.14.374-.02.077-.049.219-.038.392A1.157 1.157 0 0 0 2.729 14.5c.17-.002.306-.04.374-.061.143-.044.269-.11.343-.149a8 8 0 0 0 .543-.33zm-.418-3.722-.088.096c-.414.486-.51 1.116-.239 1.669-.014.073-.118.266-.236.487-.202.377-.447.834-.367.914.068.068.485-.16.844-.356.221-.12.42-.23.504-.25.6.326 1.309.183 1.816-.324l4.721-4.72L8.34 5.488zm6.216-7.164.064.058.594.594a.4.4 0 0 0 .566 0l.835-.835a.838.838 0 0 1 1.183 1.184l-.835.834a.4.4 0 0 0 0 .566l.682.681.057.064a.84.84 0 0 1-.057 1.12l-.064.058a.837.837 0 0 1-1.12-.058L8.717 4.286l-.058-.065a.837.837 0 0 1 1.177-1.177",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Pin.svg
var _path$243;
var _path2$169;
function _extends$257() {
	return _extends$257 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$257.apply(null, arguments);
}
var SvgPin = function SvgPin(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$257({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$243 || (_path$243 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M3.683 6.183c1.15.778 2.63 1.443 4.302 1.875.897.232 1.78.376 2.617.443v.002c-.14.453-.238 1.095-.308 1.75a37 37 0 0 0-.149 2.017.19.19 0 0 1-.124.166c-.075.03-.14.016-.189-.032L3.707 6.397q-.077-.073-.038-.186z",
		opacity: .25
	})), _path2$169 || (_path2$169 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8.544 1.702a1.747 1.747 0 0 1 2.467-.002l3.23 3.23c.68.681.68 1.784 0 2.464l-.117.118a1.58 1.58 0 0 1-1.816.295c-.148.149-.375.454-.56 1.052-.104.333-.191.875-.26 1.521-.068.635-.114 1.33-.145 1.95-.058 1.166-1.49 1.774-2.35.93l-1.857-1.82-4.605 3.206-.139.084c-.701.341-1.48-.495-.99-1.19l3.17-4.613-1.706-1.673c-.848-.832-.3-2.254.847-2.365 1.174-.113 2.57-.291 3.29-.526.65-.213 1.019-.471 1.214-.65l.002-.003a1.74 1.74 0 0 1 .325-2.008m.458 2.916c-.33.297-.844.63-1.626.885-.87.284-2.4.47-3.547.58a.2.2 0 0 0-.097.04.2.2 0 0 0-.063.088c-.027.074-.01.138.038.186l6.126 6.006q.037.036.085.046a.2.2 0 0 0 .103-.013c.076-.03.12-.09.124-.166.032-.63.078-1.352.15-2.018q.025-.246.057-.485c.042-.319.092-.623.152-.892q.045-.202.098-.373c.22-.709.513-1.177.799-1.484z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Ping.svg
var _path$242;
function _extends$256() {
	return _extends$256 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$256.apply(null, arguments);
}
var SvgPing = function SvgPing(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$256({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$242 || (_path$242 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M5.333 2.9c0-.497.462-.9 1.032-.9s1.032.403 1.032.9v8.057c0 1.747-.001 2.49-.264 2.744-.264.256-.463.299-.768.299s-.579-.115-.768-.299l-4.18-3.643a.82.82 0 0 1 0-1.273 1.14 1.14 0 0 1 1.46 0l2.456 2.14zM10.667 13.1c0 .497-.462.9-1.032.9s-1.032-.403-1.032-.9V5.043c0-1.747.001-2.49.264-2.744C9.13 2.043 9.33 2 9.635 2s.579.115.768.299l4.18 3.643a.82.82 0 0 1 0 1.273 1.14 1.14 0 0 1-1.46 0l-2.456-2.14z"
	})));
};

//#endregion
//#region src/Icon/icons/PingPong.svg
var _g$42;
var _path$241;
var _path2$168;
function _extends$255() {
	return _extends$255 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$255.apply(null, arguments);
}
var SvgPingPong = function SvgPingPong(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$255({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$42 || (_g$42 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M6.44 3.69c1.748-1.747 4.479-1.851 6.1-.231 1.12 1.12 1.414 2.771.912 4.262a4.396 4.396 0 0 0-5.345 1.687L5.095 6.394A4.68 4.68 0 0 1 6.439 3.69M13.505 10.76c.185.303.295.658.295 1.04a2 2 0 0 1-3.801.867 5 5 0 0 0 3.506-1.907" }))), _path$241 || (_path$241 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M5.513 2.764C7.705.572 11.268.336 13.465 2.533c1.587 1.587 1.903 3.886 1.13 5.868a4.4 4.4 0 0 0-1.143-.68c.502-1.49.206-3.141-.914-4.262-1.62-1.62-4.35-1.516-6.099.232-1.43 1.43-1.76 3.52-.945 5.119l-2.832 2.832a1.201 1.201 0 0 0 1.607 1.78l.092-.082 2.834-2.834q.173.087.354.156a4.4 4.4 0 0 0-.135 1.477l-2.126 2.128a2.513 2.513 0 0 1-3.553-3.552l2.228-2.228c-.57-1.952-.005-4.169 1.55-5.723"
	})), _path2$168 || (_path2$168 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M13.8 11.8a2 2 0 1 0-4 0 2 2 0 0 0 4 0m1.2 0a3.2 3.2 0 1 1-6.4 0 3.2 3.2 0 0 1 6.4 0"
	})));
};

//#endregion
//#region src/Icon/icons/Placeholder.svg
var _path$240;
function _extends$254() {
	return _extends$254 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$254.apply(null, arguments);
}
var SvgPlaceholder = function SvgPlaceholder(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$254({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$240 || (_path$240 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8 13.6A5.6 5.6 0 1 0 8 2.4a5.6 5.6 0 0 0 0 11.2M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Play.svg
var _path$239;
var _path2$167;
function _extends$253() {
	return _extends$253 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$253.apply(null, arguments);
}
var SvgPlay = function SvgPlay(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$253({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$239 || (_path$239 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M12.505 7.478a.6.6 0 0 1 0 1.044l-8.382 4.767a.6.6 0 0 1-.896-.521V3.232a.6.6 0 0 1 .896-.521z",
		opacity: .25
	})), _path2$167 || (_path2$167 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "m13.098 9.565-8.381 4.767c-1.2.683-2.69-.184-2.69-1.564V3.232c0-1.38 1.49-2.247 2.69-1.564l8.381 4.767c1.214.69 1.214 2.44 0 3.13m-.593-1.043a.6.6 0 0 0 0-1.044L4.123 2.711a.6.6 0 0 0-.896.521v9.536a.6.6 0 0 0 .896.521z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Plus.svg
var _path$238;
function _extends$252() {
	return _extends$252 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$252.apply(null, arguments);
}
var SvgPlus = function SvgPlus(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$252({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$238 || (_path$238 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M8 2a.9.9 0 0 0-.9.9v4.2H2.9a.9.9 0 0 0 0 1.8h4.2v4.2a.9.9 0 1 0 1.8 0V8.9h4.2a.9.9 0 1 0 0-1.8H8.9V2.9A.9.9 0 0 0 8 2"
	})));
};

//#endregion
//#region src/Icon/icons/PlusCircle.svg
var _path$237;
var _path2$166;
var _path3$86;
function _extends$251() {
	return _extends$251 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$251.apply(null, arguments);
}
var SvgPlusCircle = function SvgPlusCircle(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$251({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$237 || (_path$237 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M12.102 3.898a5.8 5.8 0 1 1-8.203 8.203l2.075-2.075v1.248a2.027 2.027 0 0 0 4.052 0v-1.248h1.248a2.027 2.027 0 0 0 0-4.052h-1.248z",
		opacity: .25
	})), _path2$166 || (_path2$166 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M7.174 4.726a.826.826 0 1 1 1.651 0v2.448h2.45a.826.826 0 0 1 0 1.651h-2.45v2.45a.826.826 0 0 1-1.65 0v-2.45h-2.45a.826.826 0 1 1 0-1.65h2.45z",
		clipRule: "evenodd"
	})), _path3$86 || (_path3$86 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0M2.2 8a5.8 5.8 0 1 1 11.6 0A5.8 5.8 0 0 1 2.2 8",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Policy.svg
var _g$41;
var _path$236;
var _path2$165;
var _path3$85;
function _extends$250() {
	return _extends$250 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$250.apply(null, arguments);
}
var SvgPolicy = function SvgPolicy(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$250({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$41 || (_g$41 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M6.312 13.58a.2.2 0 0 0 .088.02h6.8a.2.2 0 0 0 .2-.2V7.213a.4.4 0 0 0-.4-.4H9.59a.6.6 0 0 1-.54-.338v1.643q0 .159-.026.312l.912 2.602.012.046a1.54 1.54 0 0 1-.436 1.523c-.407.375-1.1.564-1.734.183l-.01-.007-.429-.193-.387.454c-.165.25-.389.432-.64.541M8.99 5.024a1.88 1.88 0 0 0-.885-1.161L6.2 2.768V2.6c0-.11.09-.2.2-.2h2.39c.11 0 .199.09.2.2v2.424" }))), _path$236 || (_path$236 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M14.566 5.997a.8.8 0 0 1 .234.566V13.4a1.6 1.6 0 0 1-1.6 1.6H6.4a1.6 1.6 0 0 1-1.597-1.5q.05-.029.097-.061a1.46 1.46 0 0 0 1.412.14.2.2 0 0 0 .088.021h6.8a.2.2 0 0 0 .2-.2V7.213a.4.4 0 0 0-.4-.4H9.59a.6.6 0 0 1-.54-.338v-.98q0-.244-.06-.47V2.6a.2.2 0 0 0-.2-.2H6.4a.2.2 0 0 0-.2.2v.168l-.378-.217a1.9 1.9 0 0 0-.994-.25A1.6 1.6 0 0 1 6.4 1h2.837a.8.8 0 0 1 .566.234zM1.729 9.345l-.717 2.038c-.072.274.183.498.391.373l.022-.014a1 1 0 0 1 .062-.035l1.136-.514q.018-.008.035-.02l.015-.009c.071-.041.16-.018.208.055l.006.009q.01.017.024.034l.887 1.04q.024.03.043.061l.007.012c.142.22.461.137.495-.15l.234-1.324a1.5 1.5 0 0 1-.45-.17L1.843 9.417a2 2 0 0 1-.115-.073"
	})), _path2$165 || (_path2$165 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "m5.222 10.893.235 1.333c.034.286.353.369.495.149l.007-.012q.02-.031.043-.06l.887-1.041q.014-.016.024-.034l.006-.01c.049-.072.137-.095.208-.054l.015.01.035.02 1.136.513q.033.016.062.035l.022.014c.208.125.463-.099.39-.373l-.722-2.06a2 2 0 0 1-.146.095l-2.284 1.313q-.197.113-.413.162"
	})), _path3$85 || (_path3$85 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M5.224 3.591a.69.69 0 0 0-.686 0L2.255 4.903a.68.68 0 0 0-.343.591v2.624c0 .244.13.47.343.591l2.283 1.312a.69.69 0 0 0 .686 0L7.508 8.71a.68.68 0 0 0 .342-.59V5.493c0-.243-.13-.469-.342-.59zm-2.09 2.214v2.003l1.747 1.003 1.747-1.003V5.805L4.88 4.8z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/PortForward.svg
var _path$235;
var _path2$164;
var _path3$84;
var _path4$33;
function _extends$249() {
	return _extends$249 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$249.apply(null, arguments);
}
var SvgPortForward = function SvgPortForward(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$249({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$235 || (_path$235 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M3.224 5.646c.03-.358.067-.703.115-1.027q.039-.261.085-.493.018.014.034.032L6.895 7.57a.606.606 0 0 1 0 .862l-3.437 3.41-.034.033a10 10 0 0 1-.085-.493 16 16 0 0 1-.115-1.027l2.26-2.244a.155.155 0 0 0 0-.22z",
		opacity: .25
	})), _path2$164 || (_path2$164 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "m7.458 4.158 3.437 3.411a.606.606 0 0 1 0 .862l-3.437 3.41a.615.615 0 0 1-.865 0 .606.606 0 0 1 0-.86l2.892-2.87a.155.155 0 0 0 0-.221L6.593 5.02a.606.606 0 0 1 0-.862.615.615 0 0 1 .865 0",
		clipRule: "evenodd",
		opacity: .5
	})), _path3$84 || (_path3$84 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M14.015 14.012c.23-.231.41-.576.55-.995s.243-.917.319-1.46q.052-.382.088-.789c.024-.273-.303-.422-.498-.228l-.767.76-.012.091c-.07.502-.16.922-.268 1.246-.114.34-.219.485-.261.528a.7.7 0 0 1-.143.089 3 3 0 0 1-.42.164c-.364.112-.83.205-1.363.275-1.064.142-2.276.182-3.22.182s-2.155-.04-3.22-.182c-.533-.07-.999-.163-1.362-.275a3 3 0 0 1-.42-.164.7.7 0 0 1-.143-.09c-.046-.045-.153-.195-.27-.536a7 7 0 0 1-.281-1.247c-.148-1.002-.199-2.21-.199-3.381s.05-2.379.199-3.381c.074-.501.169-.922.28-1.247.118-.34.225-.49.271-.537a.7.7 0 0 1 .142-.089c.09-.045.225-.103.42-.164.364-.112.83-.205 1.364-.275 1.064-.142 2.275-.182 3.22-.182.943 0 2.155.04 3.22.182.533.07.998.163 1.362.275.196.061.331.119.42.164.09.046.132.079.143.09.042.042.147.188.26.527a7 7 0 0 1 .281 1.336l.767.761c.195.194.522.045.498-.228q-.036-.407-.088-.788a8.3 8.3 0 0 0-.32-1.461c-.14-.419-.318-.764-.549-.995-.232-.233-.606-.412-1.056-.552a10 10 0 0 0-1.561-.319C10.258.966 8.988.925 8.02.925s-2.238.04-3.377.192a10 10 0 0 0-1.561.32c-.45.14-.825.318-1.057.55-.23.232-.411.577-.555.995-.144.42-.253.918-.333 1.461C.976 5.53.925 6.805.925 8s.05 2.47.212 3.557a8.3 8.3 0 0 0 .333 1.461c.144.418.325.763.555.994.232.233.606.412 1.057.552.453.14.991.243 1.56.319 1.14.151 2.41.192 3.378.192s2.239-.04 3.378-.192a10 10 0 0 0 1.56-.32c.451-.14.825-.318 1.057-.55"
	})), _path4$33 || (_path4$33 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "m11.459 4.158 3.436 3.411a.605.605 0 0 1 0 .862l-3.436 3.41a.616.616 0 0 1-.867 0 .606.606 0 0 1 0-.86l2.893-2.87a.155.155 0 0 0 0-.221l-2.892-2.87a.606.606 0 0 1 0-.862.616.616 0 0 1 .866 0",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Power.svg
var _path$234;
var _path2$163;
function _extends$248() {
	return _extends$248 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$248.apply(null, arguments);
}
var SvgPower = function SvgPower(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$248({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$234 || (_path$234 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M8 1.38a.83.83 0 0 0-.828.827v5.586a.828.828 0 0 0 1.656 0V2.207A.83.83 0 0 0 8 1.379"
	})), _path2$163 || (_path2$163 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M5.025 3.409c.522-.299 1.113.124 1.113.726 0 .341-.201.646-.488.83a4.345 4.345 0 1 0 4.701 0c-.288-.184-.489-.489-.489-.83 0-.602.59-1.025 1.113-.726a6 6 0 1 1-5.95 0"
	})));
};

//#endregion
//#region src/Icon/icons/PowerCycle.svg
var _path$233;
function _extends$247() {
	return _extends$247 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$247.apply(null, arguments);
}
var SvgPowerCycle = function SvgPowerCycle(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$247({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$233 || (_path$233 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M7.172 2.207a.828.828 0 0 1 1.656 0v5.586a.828.828 0 0 1-1.656 0zM6.138 4.135c0-.602-.59-1.025-1.113-.726a6 6 0 0 0 2.5 11.193 4.3 4.3 0 0 1-.371-1.719A4.346 4.346 0 0 1 5.65 4.966c.287-.185.488-.49.488-.831M12.344 8.559a4.3 4.3 0 0 1 1.625.677q.03-.303.031-.615a6 6 0 0 0-3.025-5.212c-.522-.299-1.113.124-1.113.726 0 .341.201.646.489.83a4.34 4.34 0 0 1 1.993 3.594M13.428 12.395a1.966 1.966 0 1 0-.8 2.064c.238-.164.585-.198.83.016.25.219.29.63 0 .856a3.16 3.16 0 1 1 1.191-2.886l.283-.233a.68.68 0 0 1 .875.002.535.535 0 0 1 0 .822l-.004.004-1.279 1.035a.66.66 0 0 1-.456.176.66.66 0 0 1-.457-.176l-1.283-1.039a.535.535 0 0 1 0-.822.68.68 0 0 1 .875-.002z"
	})));
};

//#endregion
//#region src/Icon/icons/PowerHistory.svg
var _path$232;
var _path2$162;
var _path3$83;
function _extends$246() {
	return _extends$246 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$246.apply(null, arguments);
}
var SvgPowerHistory = function SvgPowerHistory(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$246({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$232 || (_path$232 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M7.172 2.207a.828.828 0 0 1 1.656 0v5.586a.828.828 0 0 1-1.656 0zM6.138 4.135c0-.602-.59-1.025-1.113-.726A6 6 0 0 0 8.08 14.62a4.8 4.8 0 0 1-.524-1.677A4.345 4.345 0 0 1 5.65 4.966c.287-.185.488-.49.488-.831M12.205 7.522l.155-.002c.554 0 1.086.093 1.582.265a6 6 0 0 0-2.967-4.376c-.522-.299-1.113.124-1.113.726 0 .341.201.646.489.83a4.35 4.35 0 0 1 1.854 2.557"
	})), _path2$162 || (_path2$162 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M12.364 10.334c.293 0 .531.238.531.532v1.284l.888.887a.531.531 0 0 1-.752.752l-1.043-1.043a.53.53 0 0 1-.155-.376v-1.504c0-.294.237-.532.531-.532",
		clipRule: "evenodd"
	})), _path3$83 || (_path3$83 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8.72 12.36a3.64 3.64 0 1 1 7.28 0 3.64 3.64 0 0 1-7.28 0m1.154 0a2.487 2.487 0 1 1 4.974 0 2.487 2.487 0 0 1-4.974 0",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Preferences.svg
var _g$40;
var _path$231;
function _extends$245() {
	return _extends$245 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$245.apply(null, arguments);
}
var SvgPreferences = function SvgPreferences(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$245({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$40 || (_g$40 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .5
	}, /*#__PURE__*/ React.createElement("path", { d: "M10.054 7.2q-.104.012-.212.016a3.5 3.5 0 0 1 0 1.568q.107.005.212.016H13.2a.8.8 0 0 0 0-1.6zM6.054 4.52q.105-.011.212-.016a3.5 3.5 0 0 1 .003-1.584H2.8a.8.8 0 0 0 0 1.6zM13.086 4.52h.114a.8.8 0 0 0 0-1.6h-.114a3.5 3.5 0 0 1 0 1.6M3.022 8.8a3.5 3.5 0 0 1 0-1.6H2.8a.8.8 0 0 0 0 1.6zM6.054 11.48q.104.012.212.016a3.5 3.5 0 0 0 .003 1.584H2.8a.8.8 0 1 1 0-1.6zM13.086 13.08a3.5 3.5 0 0 0 0-1.6h.114a.8.8 0 0 1 0 1.6z" }))), _path$231 || (_path$231 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M11.978 3.72a2.3 2.3 0 1 1-4.6 0 2.3 2.3 0 0 1 4.6 0m-2.3 1.1a1.1 1.1 0 1 0 0-2.2 1.1 1.1 0 0 0 0 2.2M8.73 8a2.3 2.3 0 1 1-4.6 0 2.3 2.3 0 0 1 4.6 0m-2.3 1.1a1.1 1.1 0 1 0 0-2.2 1.1 1.1 0 0 0 0 2.2M11.978 12.28a2.3 2.3 0 1 1-4.6 0 2.3 2.3 0 0 1 4.6 0m-2.3 1.1a1.1 1.1 0 1 0 0-2.2 1.1 1.1 0 0 0 0 2.2",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Printer.svg
var _path$230;
var _path2$161;
function _extends$244() {
	return _extends$244 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$244.apply(null, arguments);
}
var SvgPrinter = function SvgPrinter(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$244({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$230 || (_path$230 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M3.59 6.13h8.82c.711 0 1.287.577 1.287 1.287V9.99c0 .71-.576 1.287-1.286 1.287h-.46v-.908a.5.5 0 0 0-.5-.5H4.55a.5.5 0 0 0-.5.5v.908h-.46c-.71 0-1.286-.576-1.286-1.287V7.417c0-.71.576-1.286 1.286-1.286",
		clipRule: "evenodd",
		opacity: .25
	})), _path2$161 || (_path2$161 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M4.049 12.38h-.46A2.39 2.39 0 0 1 1.2 9.99V7.417a2.39 2.39 0 0 1 2.39-2.39h.459V3.375c0-1.117.905-2.022 2.021-2.022h3.86c1.116 0 2.021.905 2.021 2.022v1.654h.46a2.39 2.39 0 0 1 2.389 2.39V9.99a2.39 2.39 0 0 1-2.39 2.39h-.459v.246a2.02 2.02 0 0 1-2.021 2.022H6.07a2.02 2.02 0 0 1-2.021-2.022zm-.46-6.25h8.822c.71 0 1.286.577 1.286 1.287V9.99c0 .71-.576 1.287-1.286 1.287h-.46v-.908a.5.5 0 0 0-.5-.5H4.55a.5.5 0 0 0-.5.5v.908h-.46c-.71 0-1.286-.576-1.286-1.287V7.417c0-.71.576-1.286 1.286-1.286m7.26-2.756v1.654H5.15V3.374c0-.508.412-.92.92-.92H9.93c.507 0 .919.412.919.92M6.07 13.545a.92.92 0 0 1-.919-.919v-1.454c0-.11.09-.2.2-.2h5.298c.11 0 .2.09.2.2v1.454a.92.92 0 0 1-.92.92z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/PriorityHigh.svg
var _path$229;
var _path2$160;
function _extends$243() {
	return _extends$243 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$243.apply(null, arguments);
}
var SvgPriorityHigh = function SvgPriorityHigh(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$243({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$229 || (_path$229 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M14 1a.8.8 0 0 0-.8.8v12.4a.8.8 0 0 0 1.6 0V1.8A.8.8 0 0 0 14 1",
		opacity: .2
	})), _path2$160 || (_path2$160 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M10.2 4.6a.8.8 0 0 1 1.6 0v9.6a.8.8 0 0 1-1.6 0zM8 6.6a.8.8 0 0 0-.8.8v6.8a.8.8 0 0 0 1.6 0V7.4a.8.8 0 0 0-.8-.8M4.2 10.2a.8.8 0 1 1 1.6 0v4a.8.8 0 0 1-1.6 0zM1.2 13a.8.8 0 0 1 1.6 0v1.2a.8.8 0 0 1-1.6 0z"
	})));
};

//#endregion
//#region src/Icon/icons/PriorityHighest.svg
var _path$228;
function _extends$242() {
	return _extends$242 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$242.apply(null, arguments);
}
var SvgPriorityHighest = function SvgPriorityHighest(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$242({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$228 || (_path$228 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M14 1a.8.8 0 0 0-.8.8v12.4a.8.8 0 0 0 1.6 0V1.8A.8.8 0 0 0 14 1M10.2 4.6a.8.8 0 0 1 1.6 0v9.6a.8.8 0 0 1-1.6 0zM8 6.6a.8.8 0 0 0-.8.8v6.8a.8.8 0 0 0 1.6 0V7.4a.8.8 0 0 0-.8-.8M4.2 10.2a.8.8 0 1 1 1.6 0v4a.8.8 0 0 1-1.6 0zM1.2 13a.8.8 0 0 1 1.6 0v1.2a.8.8 0 0 1-1.6 0z"
	})));
};

//#endregion
//#region src/Icon/icons/PriorityLow.svg
var _g$39;
var _path$227;
function _extends$241() {
	return _extends$241 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$241.apply(null, arguments);
}
var SvgPriorityLow = function SvgPriorityLow(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$241({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$39 || (_g$39 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .2
	}, /*#__PURE__*/ React.createElement("path", { d: "M14 1a.8.8 0 0 0-.8.8v12.4a.8.8 0 1 0 1.6 0V1.8A.8.8 0 0 0 14 1M10.2 4.6a.8.8 0 1 1 1.6 0v9.6a.8.8 0 0 1-1.6 0zM7.2 7.4a.8.8 0 1 1 1.6 0v6.8a.8.8 0 0 1-1.6 0z" }))), _path$227 || (_path$227 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M4.2 10.2a.8.8 0 1 1 1.6 0v4a.8.8 0 0 1-1.6 0zM1.2 13a.8.8 0 0 1 1.6 0v1.2a.8.8 0 0 1-1.6 0z"
	})));
};

//#endregion
//#region src/Icon/icons/PriorityLowest.svg
var _g$38;
var _path$226;
function _extends$240() {
	return _extends$240 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$240.apply(null, arguments);
}
var SvgPriorityLowest = function SvgPriorityLowest(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$240({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$38 || (_g$38 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .2
	}, /*#__PURE__*/ React.createElement("path", { d: "M14 1a.8.8 0 0 0-.8.8v12.4a.8.8 0 1 0 1.6 0V1.8A.8.8 0 0 0 14 1M10.2 4.6a.8.8 0 1 1 1.6 0v9.6a.8.8 0 0 1-1.6 0zM7.2 7.4a.8.8 0 1 1 1.6 0v6.8a.8.8 0 0 1-1.6 0zM5 9.4a.8.8 0 0 0-.8.8v4a.8.8 0 0 0 1.6 0v-4a.8.8 0 0 0-.8-.8" }))), _path$226 || (_path$226 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M1.2 13a.8.8 0 0 1 1.6 0v1.2a.8.8 0 0 1-1.6 0z"
	})));
};

//#endregion
//#region src/Icon/icons/PriorityMedium.svg
var _g$37;
var _path$225;
function _extends$239() {
	return _extends$239 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$239.apply(null, arguments);
}
var SvgPriorityMedium = function SvgPriorityMedium(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$239({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$37 || (_g$37 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .2
	}, /*#__PURE__*/ React.createElement("path", { d: "M13.2 1.8a.8.8 0 0 1 1.6 0v12.4a.8.8 0 0 1-1.6 0zM11 3.8a.8.8 0 0 0-.8.8v9.6a.8.8 0 0 0 1.6 0V4.6a.8.8 0 0 0-.8-.8" }))), _path$225 || (_path$225 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M8 6.6a.8.8 0 0 0-.8.8v6.8a.8.8 0 0 0 1.6 0V7.4a.8.8 0 0 0-.8-.8M4.2 10.2a.8.8 0 1 1 1.6 0v4a.8.8 0 0 1-1.6 0zM1.2 13a.8.8 0 0 1 1.6 0v1.2a.8.8 0 0 1-1.6 0z"
	})));
};

//#endregion
//#region src/Icon/icons/Probe.svg
var _path$224;
var _path2$159;
var _path3$82;
function _extends$238() {
	return _extends$238 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$238.apply(null, arguments);
}
var SvgProbe = function SvgProbe(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$238({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$224 || (_path$224 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M12.7 3.873c.437.56.698 1.262.698 2.026l-.004.169A3.3 3.3 0 0 1 10.1 9.197l-.17-.004a3 3 0 0 1-.25-.023l.628-.627a2 2 0 0 0 .27-2.49q.031-.018.062-.036a5.8 5.8 0 0 0 2.06-2.144",
		opacity: .25
	})), _path2$159 || (_path2$159 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M4.442 5.223a5.73 5.73 0 0 0 .049 1.685L1.704 7.922a.8.8 0 1 1-.547-1.502zM9.757 14.866a.8.8 0 0 1-1.503-.548l1.011-2.782a5.8 5.8 0 0 0 1.704-.005zM10.1 1.4a4.499 4.499 0 1 1-1.418 8.768l1-1q.123.016.248.025l.17.004a3.3 3.3 0 0 0 3.294-3.129l.004-.169a3.3 3.3 0 0 0-3.13-3.295L10.1 2.6A3.3 3.3 0 0 0 6.8 5.9l.004.169q.008.147.028.291l-.992.992A4.5 4.5 0 0 1 10.1 1.4"
	})), _path3$82 || (_path3$82 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M2.379 13.644a.8.8 0 0 1 0-1.132l5.95-5.95A.8.8 0 1 1 9.46 7.694l-5.95 5.95a.8.8 0 0 1-1.131 0"
	})));
};

//#endregion
//#region src/Icon/icons/Project.svg
var _g$36;
var _path$223;
var _path2$158;
function _extends$237() {
	return _extends$237 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$237.apply(null, arguments);
}
var SvgProject = function SvgProject(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$237({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$36 || (_g$36 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", {
		fillRule: "evenodd",
		d: "M2 10.112V2.8a1.6 1.6 0 0 1 2.274-1.451.35.35 0 0 1 .19.323v7.991c0 .136-.132.232-.265.203a2.783 2.783 0 0 0-2.039.333c-.069.042-.16-.006-.16-.087",
		clipRule: "evenodd"
	}), /*#__PURE__*/ React.createElement("path", { d: "M8.354 11.658h.073c.326 0 .591.264.592.59v.533h.531c.288 0 .526.206.58.478l2.796-2.797-1.69-1.688z" }))), _path$223 || (_path$223 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M3.6 0c.716 0 1.37.269 1.865.71.127.114.2.277.2.448V3.2H13.2c.989 0 1.806.718 1.968 1.66a3.6 3.6 0 0 0-1.58-.359.8.8 0 0 0-.388-.1H5.665v6.558l-.002.023q-.196.245-.344.519a.59.59 0 0 1-.654-.095A1.6 1.6 0 1 0 3.601 14.2h.955a2.5 2.5 0 0 0 .046 1.2h-1.01A2.796 2.796 0 0 1 .8 12.6V2.8A2.8 2.8 0 0 1 3.6 0m0 1.2c-.883 0-1.6.716-1.6 1.6v7.312c0 .08.091.129.16.087a2.79 2.79 0 0 1 2.04-.333c.132.03.265-.067.265-.203V1.672a.35.35 0 0 0-.192-.323 1.6 1.6 0 0 0-.672-.15",
		clipRule: "evenodd"
	})), _path2$158 || (_path2$158 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M15.2 13.4a2 2 0 0 1-2 2H11.39l1.2-1.2h.611a.8.8 0 0 0 .796-.719L14 13.4v-.612l1.2-1.2zM11.908 6.402a2.397 2.397 0 0 1 3.39 3.39l-5.15 5.15a2.2 2.2 0 0 1-1.035.582l-1.803.438a1.3 1.3 0 0 1-1.57-1.57l.437-1.804c.095-.392.296-.75.581-1.036zm-4.562 6.47-.437 1.804a.097.097 0 0 0 .117.117l1.803-.438a1 1 0 0 0 .13-.043v-.349h-.531a.59.59 0 0 1-.59-.59l-.002-.533h-.48q-.006.015-.01.031m1.008-1.214h.073c.326 0 .591.264.592.59v.533h.531a.59.59 0 0 1 .579.478l2.797-2.797-1.69-1.688zm6.093-4.405a1.194 1.194 0 0 0-1.688 0l-.53.529 1.688 1.689.531-.53a1.195 1.195 0 0 0 0-1.688"
	})));
};

//#endregion
//#region src/Icon/icons/Protect.svg
var _path$222;
var _path2$157;
var _path3$81;
var _path4$32;
function _extends$236() {
	return _extends$236 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$236.apply(null, arguments);
}
var SvgProtect = function SvgProtect(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$236({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$222 || (_path$222 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8.351 7.115 8 6.034l-.351 1.081H6.51l.92.669-.351 1.081.92-.668.92.668-.351-1.081.92-.669z",
		clipRule: "evenodd",
		opacity: .25
	})), _path2$157 || (_path2$157 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M8 13.68a.6.6 0 0 0 .25-.059c2.412-1.18 4.425-2.996 4.796-5.09.281-1.594.22-3.227.126-4.268a.59.59 0 0 0-.38-.495l-4.439-1.39A1 1 0 0 0 8 2.315z",
		opacity: .25
	})), _path3$81 || (_path3$81 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M1.65 3.68c-.117 1.018-.266 3.05.09 5.064.48 2.719 3.004 4.877 5.876 6.167q.186.084.384.089.198-.006.384-.089c2.872-1.29 5.387-3.448 5.868-6.167.356-2.014.209-4.046.092-5.064a1.1 1.1 0 0 0-.704-.901L8.356 1.07A1.1 1.1 0 0 0 8 1q-.181.005-.356.07L2.35 2.78a1.09 1.09 0 0 0-.7.901M8.353 2.38a1 1 0 0 0-.706 0L3.2 3.768a.59.59 0 0 0-.38.495c-.094 1.041-.152 2.674.13 4.267.37 2.095 2.388 3.91 4.8 5.091a.57.57 0 0 0 .5 0c2.412-1.18 4.425-2.996 4.796-5.09.282-1.594.22-3.227.126-4.268a.59.59 0 0 0-.38-.495z",
		clipRule: "evenodd"
	})), _path4$32 || (_path4$32 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8.351 7.115 8 6.034l-.351 1.081H6.51l.92.669-.351 1.081.92-.668.92.668-.351-1.081.92-.669zm.872-1.2-.636-1.957c-.185-.569-.99-.569-1.174 0l-.636 1.957H4.719c-.598 0-.847.766-.363 1.117l1.665 1.21-.636 1.957c-.185.57.466 1.042.95.69L8 9.68l1.665 1.21c.484.351 1.135-.122.95-.69L9.98 8.242l1.665-1.21c.484-.351.236-1.117-.363-1.117z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Pulse.svg
var _path$221;
function _extends$235() {
	return _extends$235 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$235.apply(null, arguments);
}
var SvgPulse = function SvgPulse(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$235({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$221 || (_path$221 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M3.84 8.95H1.945a.946.946 0 1 1 0-1.893H3.29l1.863-4.183a.94.94 0 0 1 .324-.392.95.95 0 0 1 1.074-.02c.149.1.272.241.347.418l3.2 7.485 1.21-2.772.06-.106a.95.95 0 0 1 .793-.43h1.893a.946.946 0 0 1 0 1.893h-1.255l-1.862 4.183a.83.83 0 0 1-.414.433l-.075.029a.946.946 0 0 1-1.242-.498l-3.2-7.487-1.23 2.766a.95.95 0 0 1-.736.553 1 1 0 0 1-.2.021"
	})));
};

//#endregion
//#region src/Icon/icons/QRCode.svg
var _path$220;
var _path2$156;
var _path3$80;
function _extends$234() {
	return _extends$234 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$234.apply(null, arguments);
}
var SvgQrCode = function SvgQrCode(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$234({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$220 || (_path$220 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M5.2 0h-3A2.2 2.2 0 0 0 0 2.2v3a2.2 2.2 0 0 0 2.2 2.2h3a2.2 2.2 0 0 0 2.2-2.2v-3A2.2 2.2 0 0 0 5.2 0m-4 2.2a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1z",
		clipRule: "evenodd"
	})), _path2$156 || (_path2$156 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M11.1 10a1.1 1.1 0 1 1-2.2 0 1.1 1.1 0 0 1 2.2 0M15.7 10a1.1 1.1 0 1 1-2.2 0 1.1 1.1 0 0 1 2.2 0M15.7 14.6a1.1 1.1 0 1 1-2.2 0 1.1 1.1 0 0 1 2.2 0M13.4 12.3a1.1 1.1 0 1 1-2.2 0 1.1 1.1 0 0 1 2.2 0"
	})), _path3$80 || (_path3$80 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M2.2 8.6h3a2.2 2.2 0 0 1 2.2 2.2v3A2.2 2.2 0 0 1 5.2 16h-3A2.2 2.2 0 0 1 0 13.8v-3a2.2 2.2 0 0 1 2.2-2.2m0 1.2a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1zM13.8 0h-3a2.2 2.2 0 0 0-2.2 2.2v3a2.2 2.2 0 0 0 2.2 2.2h3A2.2 2.2 0 0 0 16 5.2v-3A2.2 2.2 0 0 0 13.8 0m-4 2.2a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Question.svg
var _path$219;
var _path2$155;
var _path3$79;
function _extends$233() {
	return _extends$233 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$233.apply(null, arguments);
}
var SvgQuestion = function SvgQuestion(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$233({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$219 || (_path$219 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M12.102 3.898A5.8 5.8 0 1 1 3.898 12.1L6.17 9.829q.017.036.037.071c-.301.366-.45.81-.45 1.275 0 .542.2 1.048.594 1.442l.02.02.019.018c.396.363.89.546 1.415.546.53 0 1.023-.192 1.412-.564v-.001c.407-.39.623-.902.623-1.461 0-.465-.152-.899-.445-1.256a1.9 1.9 0 0 0 .22-.544l.017-.073.012-.056.01-.006c.916-.462 2.177-1.57 2.016-3.435a3.2 3.2 0 0 0-.321-1.154z",
		opacity: .25
	})), _path2$155 || (_path2$155 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M7.986 4c-1.459 0-2.206.89-2.434 1.545a.654.654 0 0 0 .402.833c.34.119.663-.054.833-.402.14-.287.444-.835 1.248-.835.435 0 .62.061.804.19.221.155.352.441.375.697.05.575-.231.914-.573 1.112-.473.274-.77.47-1.043.79a1.9 1.9 0 0 0-.42.856l-.008.035a.654.654 0 0 0 1.276.288c.047-.205.056-.263.112-.399s.17-.347.556-.542c.687-.347 1.464-1.08 1.362-2.261a1.94 1.94 0 0 0-.845-1.458C9.17 4.127 8.588 4 7.986 4M7.201 11.769q.253.231.605.231a.81.81 0 0 0 .583-.231.8.8 0 0 0 .252-.595.76.76 0 0 0-.252-.584.8.8 0 0 0-.583-.242.84.84 0 0 0-.605.242.77.77 0 0 0-.241.584q0 .352.241.595"
	})), _path3$79 || (_path3$79 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0M2.2 8a5.8 5.8 0 1 1 11.6 0A5.8 5.8 0 0 1 2.2 8",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Rack.svg
var _path$218;
var _path2$154;
var _path3$78;
var _path4$31;
function _extends$232() {
	return _extends$232 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$232.apply(null, arguments);
}
var SvgRack = function SvgRack(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$232({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$218 || (_path$218 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M3.898 9.043a.51.51 0 0 1 .51-.51h7.184a.51.51 0 0 1 .51.51v2.34a.51.51 0 0 1-.51.51H4.408a.51.51 0 0 1-.51-.51zm.5.52a.53.53 0 0 1 1.06 0v1.3a.53.53 0 0 1-1.06 0zm7.204 1.3a.53.53 0 1 1-1.06 0 .53.53 0 0 1 1.06 0m-1.17 0a.53.53 0 1 1-1.06 0 .53.53 0 0 1 1.06 0m-1.17 0a.53.53 0 1 1-1.06 0 .53.53 0 0 1 1.06 0",
		clipRule: "evenodd",
		opacity: .25
	})), _path2$154 || (_path2$154 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M3.333 2.073a1.26 1.26 0 0 0-1.26 1.26v9.334c0 .696.564 1.26 1.26 1.26h.934a.607.607 0 1 1 0 1.213h-.934A2.473 2.473 0 0 1 .86 12.667V3.333A2.473 2.473 0 0 1 3.333.86h.934a.607.607 0 0 1 0 1.213zM11.127 1.467c0-.335.271-.607.606-.607h.934a2.473 2.473 0 0 1 2.473 2.473v9.334a2.473 2.473 0 0 1-2.473 2.473h-.934a.607.607 0 0 1 0-1.213h.934a1.26 1.26 0 0 0 1.26-1.26V3.333a1.26 1.26 0 0 0-1.26-1.26h-.934a.607.607 0 0 1-.606-.606"
	})), _path3$78 || (_path3$78 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M11.592 3.047H4.408a1.57 1.57 0 0 0-1.57 1.57v2.34c0 .4.15.766.396 1.043a1.57 1.57 0 0 0-.396 1.043v2.34c0 .867.703 1.57 1.57 1.57h7.184a1.57 1.57 0 0 0 1.57-1.57v-2.34c0-.4-.15-.766-.396-1.043.246-.277.396-.642.396-1.043v-2.34a1.57 1.57 0 0 0-1.57-1.57m-7.184 1.06a.51.51 0 0 0-.51.51v2.34c0 .282.228.51.51.51h7.184a.51.51 0 0 0 .51-.51v-2.34a.51.51 0 0 0-.51-.51zm0 4.426a.51.51 0 0 0-.51.51v2.34c0 .281.228.51.51.51h7.184a.51.51 0 0 0 .51-.51v-2.34a.51.51 0 0 0-.51-.51z",
		clipRule: "evenodd"
	})), _path4$31 || (_path4$31 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M4.928 9.033a.53.53 0 0 0-.53.53v1.3a.53.53 0 0 0 1.06 0v-1.3a.53.53 0 0 0-.53-.53M8.732 11.393a.53.53 0 1 0 0-1.06.53.53 0 0 0 0 1.06M9.902 11.393a.53.53 0 1 0 0-1.06.53.53 0 0 0 0 1.06M11.072 11.393a.53.53 0 1 0 0-1.06.53.53 0 0 0 0 1.06M9.775 5.82a.586.586 0 0 0 0 1.172h.891a.586.586 0 0 0 0-1.171zM7.546 5.82a.586.586 0 0 0 0 1.172h.892a.586.586 0 1 0 0-1.171zM5.318 5.82a.586.586 0 0 0 0 1.172h.891a.586.586 0 1 0 0-1.171z"
	})));
};

//#endregion
//#region src/Icon/icons/Radar.svg
var _path$217;
var _path2$153;
var _path3$77;
function _extends$231() {
	return _extends$231 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$231.apply(null, arguments);
}
var SvgRadar = function SvgRadar(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$231({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$217 || (_path$217 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M7.957 7.883a.05.05 0 0 1-.07.062l-4.92-2.402a.195.195 0 0 1-.09-.266 5.82 5.82 0 0 1 2.92-2.644.195.195 0 0 1 .256.115z",
		opacity: .25
	})), _path2$153 || (_path2$153 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M11.4 8a3.4 3.4 0 0 0-3.38-3.4L7.58 3.42q.207-.02.419-.019a4.6 4.6 0 1 1-2.344 8.559 1.2 1.2 0 0 1-1.583-1.562 4.624 4.624 0 0 1-.59-3.267l1.132.553Q4.6 7.839 4.6 8c0 .605.158 1.173.435 1.665q.072-.009.146-.009a1.2 1.2 0 0 1 1.193 1.33A3.4 3.4 0 0 0 11.4 8",
		opacity: .5
	})), _path3$77 || (_path3$77 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m-.043-7.117a.05.05 0 0 1-.07.062l-4.92-2.402a.195.195 0 0 1-.09-.266 5.82 5.82 0 0 1 2.92-2.644.195.195 0 0 1 .256.115zm.527-2.03A2.2 2.2 0 1 1 5.816 8.27L2.44 6.621l-.066-.035A5.8 5.8 0 1 0 7.15 2.262l.027.069z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/RadioProfile.svg
var _g$35;
var _path$216;
var _path2$152;
var _path3$76;
var _path4$30;
function _extends$230() {
	return _extends$230 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$230.apply(null, arguments);
}
var SvgRadioProfile = function SvgRadioProfile(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$230({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$35 || (_g$35 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M2.2 9.878c.5.371 1.118.59 1.788.59h8c.68 0 1.309-.226 1.812-.608V11a1.8 1.8 0 0 1-1.8 1.8H4A1.8 1.8 0 0 1 2.2 11zM4.012 7.5a.8.8 0 0 0 .776 0 .8.8 0 1 1-.776 0" }))), _path$216 || (_path$216 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M4.012 6.1a.8.8 0 1 0 .776 0 .8.8 0 0 1-.776 0",
		opacity: .5
	})), _path2$152 || (_path2$152 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M12 3.2H4A1.8 1.8 0 0 0 2.2 5v6A1.8 1.8 0 0 0 4 12.8h8a1.8 1.8 0 0 0 1.8-1.8V5A1.8 1.8 0 0 0 12 3.2M4 2a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3z",
		clipRule: "evenodd"
	})), _path3$76 || (_path3$76 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M7.582 6.647a.415.415 0 0 0-.04.573.39.39 0 0 0 .561.042l.003-.003.025-.021q.03-.026.09-.071c.082-.062.2-.144.344-.227.295-.168.666-.317 1.04-.317.375 0 .746.149 1.04.317a3 3 0 0 1 .435.298l.002.002.027.023a.39.39 0 0 0 .56-.043.415.415 0 0 0-.039-.572l-.05-.042-.12-.096a4 4 0 0 0-.428-.282 3.6 3.6 0 0 0-.503-.24 2.6 2.6 0 0 0-.923-.18c-.335 0-.649.076-.922.18-.19.072-.36.158-.505.24a4 4 0 0 0-.548.377l-.048.04zM6.546 5.474a.416.416 0 0 0-.04.573.39.39 0 0 0 .56.042l.003-.003.048-.04q.052-.043.152-.12c.136-.102.331-.24.57-.376.485-.277 1.116-.535 1.767-.535s1.28.258 1.765.535a5.4 5.4 0 0 1 .723.496l.003.002.048.041a.39.39 0 0 0 .56-.042.417.417 0 0 0-.04-.573l-.069-.06a6.244 6.244 0 0 0-.838-.576c-.542-.31-1.31-.638-2.152-.638s-1.611.329-2.153.638a6 6 0 0 0-.836.575l-.07.06z",
		clipRule: "evenodd"
	})), _path4$30 || (_path4$30 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M10.595 7.822c.11.1.152.25.125.388l-.002.01c-.034.232-.21.488-.416.683a1.6 1.6 0 0 1-.342.251.8.8 0 0 1-.355.104.8.8 0 0 1-.372-.113 1.7 1.7 0 0 1-.356-.272A1.7 1.7 0 0 1 8.6 8.52a.8.8 0 0 1-.117-.379v-.007a.41.41 0 0 1 .134-.312l.006-.005.083-.067a2 2 0 0 1 .198-.13 1.44 1.44 0 0 1 .701-.204c.29 0 .54.111.701.204.084.048.153.096.201.132l.002.002zM5.2 5.4a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0"
	})));
};

//#endregion
//#region src/Icon/icons/Radius.svg
var _g$34;
var _path$215;
var _path2$151;
var _path3$75;
function _extends$229() {
	return _extends$229 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$229.apply(null, arguments);
}
var SvgRadius = function SvgRadius(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$229({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$34 || (_g$34 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .2
	}, /*#__PURE__*/ React.createElement("path", { d: "M10.514 5.486q.114 0 .224.013A3.7 3.7 0 0 0 8 4.29c-1.084 0-2.06.466-2.738 1.208q.11-.013.224-.013zM5.486 10.514q-.113 0-.224-.013A3.7 3.7 0 0 0 7.74 11.7c.03-.43.16-.833.367-1.186z" }))), _path$215 || (_path$215 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M15.074 7.617c-.009-1.08-.056-2.202-.19-3.173a8.3 8.3 0 0 0-.32-1.461c-.14-.419-.318-.764-.549-.995-.232-.233-.606-.412-1.056-.552a10 10 0 0 0-1.561-.319C10.258.966 8.988.925 8.02.925s-2.238.04-3.377.192a10 10 0 0 0-1.561.32c-.45.14-.825.318-1.057.55-.23.232-.411.577-.555.995-.144.42-.253.918-.333 1.461C.976 5.53.925 6.805.925 8s.05 2.47.212 3.557a8.3 8.3 0 0 0 .333 1.461c.144.418.325.763.555.994.232.233.606.412 1.057.552.453.14.991.243 1.56.319 1.056.14 2.223.185 3.16.191a2.7 2.7 0 0 1-.069-.607v-.593c-.894-.008-1.973-.053-2.932-.18-.534-.071-1-.164-1.363-.276a3 3 0 0 1-.42-.164.7.7 0 0 1-.143-.09c-.046-.045-.153-.195-.27-.536a7 7 0 0 1-.281-1.247c-.148-1.002-.199-2.21-.199-3.381s.05-2.379.199-3.381c.074-.501.169-.922.28-1.247.118-.34.225-.49.271-.537a.7.7 0 0 1 .142-.089c.09-.045.225-.103.42-.164.364-.112.83-.205 1.364-.275 1.064-.142 2.275-.182 3.22-.182.943 0 2.155.04 3.22.182.533.07.998.163 1.362.275.196.061.331.119.42.164.09.046.132.079.143.09.042.042.147.188.26.527.11.324.2.744.269 1.246.088.633.136 1.349.16 2.087.474.212.89.529 1.218.921"
	})), _path2$151 || (_path2$151 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M12.14 6.415a1.89 1.89 0 0 0-1.626-.93H5.486A1.886 1.886 0 0 0 3.6 7.372V8.63c0 1.041.844 1.885 1.886 1.885h2.621c.17-.29.392-.545.653-.754H6.334c-.162 0-.183-.234-.024-.263l.095-.014a2.51 2.51 0 0 0 2.056-1.77l.24-.8c.119-.4.486-.673.903-.673h.91c.324 0 .615.136.821.353q.385-.135.805-.178"
	})), _path3$75 || (_path3$75 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M10.267 10.375V9.8a2.2 2.2 0 1 1 4.4 0v.575A1.534 1.534 0 0 1 16 11.895v2.572c0 .846-.687 1.533-1.533 1.533h-4a1.533 1.533 0 0 1-1.534-1.533v-2.572c0-.779.581-1.422 1.334-1.52m-.134 1.52c0-.184.15-.333.334-.333h4c.184 0 .333.15.333.333v2.572c0 .184-.15.333-.333.333h-4a.333.333 0 0 1-.334-.333zm3.064.72a.73.73 0 0 1-.265.563v.586a.465.465 0 1 1-.93 0v-.586a.728.728 0 0 1 .465-1.292.73.73 0 0 1 .73.73m.27-2.253V9.8a1 1 0 1 0-2 0v.562z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/RateLimit.svg
var _g$33;
var _path$214;
var _path2$150;
function _extends$228() {
	return _extends$228 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$228.apply(null, arguments);
}
var SvgRateLimit = function SvgRateLimit(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$228({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$33 || (_g$33 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M14.334 13.759c-.346.449-1.002.445-1.403.044-.286-.286-.282-.748-.032-1.066a6.24 6.24 0 0 0-1.15-8.853c.388.291.942.297 1.286-.046.343-.344.346-.904-.032-1.208a8 8 0 0 1 1.331 11.129M9.92 8.822a1.92 1.92 0 1 1-3.84 0 1.92 1.92 0 0 1 3.84 0" }))), _path$214 || (_path$214 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M8 .872a8 8 0 0 1 5.002 1.757c.379.303.376.865.033 1.209-.344.343-.898.337-1.287.046A6.24 6.24 0 0 0 3.1 12.737c.252.318.255.78-.03 1.066-.402.401-1.058.405-1.404-.044A8 8 0 0 1 8 .872",
		opacity: .75
	})), _path2$150 || (_path2$150 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M11.951 4.87a.43.43 0 0 1 .13.335l-.263 1.01c-.017.208.036.417.133.609q.206.406.33.862a4.447 4.447 0 1 1-2.284-2.815c.191.097.4.15.608.133l1.012-.264a.43.43 0 0 1 .334.13M4.937 9.655a3.155 3.155 0 1 0 6.095-1.633 3.155 3.155 0 0 0-6.095 1.633",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/ReadOnly.svg
var _path$213;
var _path2$149;
var _path3$74;
function _extends$227() {
	return _extends$227 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$227.apply(null, arguments);
}
var SvgReadOnly = function SvgReadOnly(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$227({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$213 || (_path$213 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M10.435 6.691a5.3 5.3 0 0 0-2.368 1.376A5.33 5.33 0 0 0 6.56 11.05a.6.6 0 0 0-.381-.135h-.75a.206.206 0 0 1-.205-.206v-.749a.617.617 0 0 0-.618-.617h-.61L8.54 4.797z",
		opacity: .25
	})), _path2$149 || (_path2$149 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8.915 8.915a4.15 4.15 0 1 1 5.87 5.87 4.15 4.15 0 0 1-5.87-5.87m4.995 4.995c-.97.969-2.45 1.11-3.572.427l4-3.999a2.91 2.91 0 0 1-.428 3.572M9.79 9.79a2.91 2.91 0 0 1 3.57-.428L9.363 13.36a2.91 2.91 0 0 1 .428-3.57",
		clipRule: "evenodd"
	})), _path3$74 || (_path3$74 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M9.628 1.921a3.146 3.146 0 0 1 4.45 4.45l-.438.436a5.37 5.37 0 0 0-3.206-.116L8.54 4.797 3.996 9.341h.61c.34 0 .618.277.618.618v.75c0 .113.092.205.206.205h.748c.145 0 .277.052.382.135a5.4 5.4 0 0 0 .246 2.588l-.01.01-.078.073a2.9 2.9 0 0 1-1.201.62l-2.525.614a1.61 1.61 0 0 1-1.944-1.944l.611-2.526c.124-.512.387-.98.76-1.353zm-6.74 8.86a2 2 0 0 1 .064-.204h.83c.114 0 .206.092.207.206v.749c0 .34.277.617.618.617h.748c.113 0 .206.092.206.206v.626q-.163.084-.342.13l-2.525.614a.346.346 0 0 1-.417-.417zm7.634-7.965a1.883 1.883 0 0 1 2.662 2.661l-.89.89-2.662-2.662z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Redo.svg
var _path$212;
function _extends$226() {
	return _extends$226 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$226.apply(null, arguments);
}
var SvgRedo = function SvgRedo(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$226({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$212 || (_path$212 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M3.35 6.497a5.4 5.4 0 0 0 7.688 6.573c.369-.204.442-.685.2-1.03-.256-.366-.764-.436-1.167-.243a3.825 3.825 0 1 1-.463-7.09l-.003.007-1.06.636a.94.94 0 0 0-.41 1.128c.158.41.599.57.983.357l2.548-1.531a.9.9 0 0 0 .447-.51.9.9 0 0 0-.015-.677l-.967-2.81a.675.675 0 0 0-.983-.358.94.94 0 0 0-.41 1.127l.408 1.152-.125-.043a5.4 5.4 0 0 0-6.67 3.312"
	})));
};

//#endregion
//#region src/Icon/icons/Reserve.svg
var _path$211;
var _path2$148;
var _path3$73;
function _extends$225() {
	return _extends$225 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$225.apply(null, arguments);
}
var SvgReserve = function SvgReserve(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$225({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$211 || (_path$211 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M14.632 10.998a1.102 1.102 0 0 1-1.058 1.41H10.74l.168-.424 1.927-6.612.069-.307z",
		clipRule: "evenodd",
		opacity: .25
	})), _path2$148 || (_path2$148 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M13.574 13.73c1.616 0 2.78-1.551 2.328-3.102l-1.927-6.612a2.424 2.424 0 0 0-2.327-1.746H4.352a2.424 2.424 0 0 0-2.327 1.746L.098 10.628a2.424 2.424 0 0 0 2.328 3.102zm1.058-2.732a1.102 1.102 0 0 1-1.058 1.41H10.74l.168-.424 1.927-6.612.069-.307zM4.352 3.592c-.49 0-.92.324-1.058.794l-1.926 6.612a1.102 1.102 0 0 0 1.058 1.41H8.58c.49 0 .92-.324 1.058-.794l1.926-6.611a1.102 1.102 0 0 0-1.058-1.41z",
		clipRule: "evenodd"
	})), _path3$73 || (_path3$73 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M6.254 9.874 9.15 6.978a.602.602 0 0 0-.851-.852L5.89 8.534a.1.1 0 0 1-.142 0l-.923-.923a.602.602 0 1 0-.851.852l1.411 1.41a.6.6 0 0 0 .434.177.6.6 0 0 0 .434-.176"
	})));
};

//#endregion
//#region src/Icon/icons/Reset.svg
var _path$210;
function _extends$224() {
	return _extends$224 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$224.apply(null, arguments);
}
var SvgReset = function SvgReset(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$224({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$210 || (_path$210 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M8 13.4a5.4 5.4 0 1 1 5.394-5.664l.002.132.942-.778a.94.94 0 0 1 1.2 0 .675.675 0 0 1 0 1.046l-2.31 1.87a.9.9 0 0 1-.631.246.9.9 0 0 1-.632-.246l-2.31-1.87a.675.675 0 0 1 0-1.046.94.94 0 0 1 1.2 0l.96.778h.008l-.008-.154a3.825 3.825 0 1 0-1.645 3.436c.347-.239.822-.267 1.14.01.34.296.367.82.012 1.097A5.38 5.38 0 0 1 8 13.4"
	})));
};

//#endregion
//#region src/Icon/icons/Ribbon.svg
var _path$209;
var _path2$147;
var _path3$72;
function _extends$223() {
	return _extends$223 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$223.apply(null, arguments);
}
var SvgRibbon = function SvgRibbon(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$223({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$209 || (_path$209 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M3.375 9.972 2.33 12.958c-.105.402.266.73.57.546l.032-.02q.043-.028.09-.051l1.656-.753a1 1 0 0 0 .052-.03l.021-.013c.104-.06.233-.027.303.08l.009.013q.015.027.035.05l1.294 1.525a1 1 0 0 1 .062.089l.011.017c.208.322.672.202.721-.218l.341-1.942a2.2 2.2 0 0 1-.655-.25l-3.33-1.922a2 2 0 0 1-.168-.107M8.47 12.24l.343 1.953c.049.42.513.54.721.218l.011-.017a1 1 0 0 1 .062-.089l1.294-1.525q.019-.023.035-.05l.009-.013c.07-.107.199-.14.303-.08l.021.014.052.029 1.657.753q.046.023.09.05.014.011.032.021c.303.183.675-.144.57-.546l-1.054-3.02q-.102.076-.213.14l-3.33 1.923a2.2 2.2 0 0 1-.603.238"
	})), _path2$147 || (_path2$147 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "m7.973 2.636-3.13 1.808v3.614l3.13 1.807 3.13-1.807V4.444zm.5-1.097a1 1 0 0 0-1 0l-3.33 1.923a1 1 0 0 0-.5.866v3.845a1 1 0 0 0 .5.866l3.33 1.923a1 1 0 0 0 1 0l3.33-1.923a1 1 0 0 0 .5-.866V4.328a1 1 0 0 0-.5-.866z",
		clipRule: "evenodd"
	})), _path3$72 || (_path3$72 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M7.658 4.279a.33.33 0 0 1 .629 0l.34 1.047h1.1c.32 0 .453.41.195.597l-.89.647.34 1.047a.33.33 0 0 1-.509.37l-.89-.648-.891.647a.33.33 0 0 1-.508-.369l.34-1.047-.89-.647a.33.33 0 0 1 .194-.597h1.1z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Rocket.svg
var _path$208;
var _path2$146;
function _extends$222() {
	return _extends$222 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$222.apply(null, arguments);
}
var SvgRocket = function SvgRocket(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$222({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$208 || (_path$208 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M7.958 4.163 5.032 7.09a1.21 1.21 0 0 0 0 1.709l2.234 2.233a1.21 1.21 0 0 0 1.709 0l3.944-3.944q.115-.115.195-.255l-.88.88a2.79 2.79 0 0 1-4.276-3.549",
		opacity: .25
	})), _path2$146 || (_path2$146 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "m13.375 8.32.388-.389c.385-.384.627-.888.688-1.428L14.847 3a1.725 1.725 0 0 0-1.97-1.9l-3.386.507a2.4 2.4 0 0 0-1.343.677l-.402.403-2.83-.257a1.5 1.5 0 0 0-1.196.433L1.583 5c-.9.899-.342 2.439.924 2.554l.995.09-.008.08a2.4 2.4 0 0 0 .694 1.918l2.234 2.234c.524.524 1.23.755 1.916.694l.08-.008.09.992c.115 1.266 1.654 1.824 2.553.925L13.2 12.34a1.5 1.5 0 0 0 .433-1.196zM3.928 6.484l-1.313-.12a.306.306 0 0 1-.188-.52l2.137-2.137a.3.3 0 0 1 .244-.089l1.82.166zm5.65 5.65 2.7-2.7.165 1.82a.3.3 0 0 1-.089.243l-2.137 2.137a.306.306 0 0 1-.52-.188zm-.586-9.005c.183-.183.42-.303.676-.34l3.387-.509a.53.53 0 0 1 .606.585l-.396 3.504c-.03.271-.153.525-.346.718l-3.944 3.944a1.21 1.21 0 0 1-1.71 0L5.033 8.798a1.21 1.21 0 0 1 0-1.709zm.647 3.296a1.161 1.161 0 1 0 1.642-1.642 1.161 1.161 0 0 0-1.642 1.642m-7.303 4.634.479-.478a.597.597 0 1 0-.845-.845l-.478.48a.597.597 0 1 0 .844.843m1.276 2.234.958-.957a.597.597 0 1 0-.845-.844l-.957.957a.597.597 0 0 0 .844.844m2.234 1.277.479-.48a.597.597 0 1 0-.844-.843l-.48.478a.597.597 0 1 0 .845.845",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/RoundTrip.svg
var _path$207;
function _extends$221() {
	return _extends$221 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$221.apply(null, arguments);
}
var SvgRoundTrip = function SvgRoundTrip(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$221({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$207 || (_path$207 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "m4.08 8.137.986.807c.34.3.892.3 1.233 0 .34-.3.34-.786 0-1.085l-2.373-1.94a.93.93 0 0 0-.649-.254.93.93 0 0 0-.648.254L.255 7.86c-.34.3-.34.785 0 1.085s.893.3 1.233 0l.968-.807a5.6 5.6 0 0 0 3.96 5.232 5.8 5.8 0 0 0 1.623.231l.423-.028c1.444-.103 2.602-.847 3.342-1.48.739-.635 1.025-1.266 1.025-1.266 1.547-2.679.65-6.091-2.003-7.623l-.031-.018a5.5 5.5 0 0 0-1.341-.555 1.6 1.6 0 1 0-.188 1.648q.366.123.712.322c1.522.878 2.228 2.63 1.86 4.273a3.9 3.9 0 0 1-.44 1.126c-.22.382-.543.828-1.168 1.268s-1.4.7-2.229.7c-2.085 0-3.791-1.641-3.92-3.714z"
	})));
};

//#endregion
//#region src/Icon/icons/Route.svg
var _path$206;
function _extends$220() {
	return _extends$220 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$220.apply(null, arguments);
}
var SvgRoute = function SvgRoute(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$220({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$206 || (_path$206 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M4.1 5.381c.459-.03.932-.107 1.103-.278.25-.251.297-1.02.297-1.703 0-.682-.047-1.452-.297-1.703-.25-.25-1.145-.297-1.697-.297-.553 0-1.448.047-1.698.297-.25.251-.308 1.02-.308 1.703 0 .682.058 1.452.308 1.703.17.17.637.246 1.092.277v6.37a2.85 2.85 0 0 0 5.7 0v-7.5a1.65 1.65 0 0 1 3.3 0v8.302l-.976-.976a.6.6 0 1 0-.848.848l2 2a.6.6 0 0 0 .848 0l2-2a.6.6 0 0 0-.848-.848l-.976.976V4.25a2.85 2.85 0 0 0-5.7 0v7.5a1.65 1.65 0 1 1-3.3 0z"
	})));
};

//#endregion
//#region src/Icon/icons/Routing.svg
var _path$205;
function _extends$219() {
	return _extends$219 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$219.apply(null, arguments);
}
var SvgRouting = function SvgRouting(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$219({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$205 || (_path$205 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "m6.007 4.845 1.165-.912V8.41C6.44 7.757 5.47 7.393 4.276 7.393h-.657l.331-.316.013-.015a.99.99 0 0 0-.002-1.27.73.73 0 0 0-.542-.258.72.72 0 0 0-.543.253l-.007.007-1.407 1.743-.003.003a.95.95 0 0 0-.261.668c0 .268.102.506.262.67l.002.001 1.507 1.787a.73.73 0 0 0 .544.255.73.73 0 0 0 .544-.257.99.99 0 0 0 .006-1.265l-.01-.01-.376-.38.214.007c2.126-.11 3.041.714 3.28 2.464v2.327c0 .397.37.72.826.72.457 0 .826-.323.826-.72v-2.289c.231-1.776 1.144-2.613 3.286-2.502l.214-.007-.377.38-.01.01a.99.99 0 0 0 .007 1.265c.146.165.34.257.544.257.203 0 .398-.09.544-.255l1.507-1.787.002-.002a.95.95 0 0 0 .262-.669.95.95 0 0 0-.261-.668l-.003-.003-1.407-1.743-.007-.007a.72.72 0 0 0-.543-.253.73.73 0 0 0-.542.258.99.99 0 0 0-.002 1.27l.012.014.332.317h-.657c-1.197 0-2.168.366-2.9 1.021V3.933l1.164.912a.914.914 0 0 0 1.168 0 .657.657 0 0 0 0-1.018L8.612 1.712a.88.88 0 0 0-.615-.239.88.88 0 0 0-.614.24L4.839 3.826a.657.657 0 0 0 0 1.018.914.914 0 0 0 1.168 0"
	})));
};

//#endregion
//#region src/Icon/icons/Rules.svg
var _g$32;
var _path$204;
var _path2$145;
function _extends$218() {
	return _extends$218 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$218.apply(null, arguments);
}
var SvgRules = function SvgRules(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$218({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$32 || (_g$32 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .5
	}, /*#__PURE__*/ React.createElement("path", { d: "M8.85 9.988a.6.6 0 0 1 .6-.6h3.856a.6.6 0 1 1 0 1.2H9.45a.6.6 0 0 1-.6-.6M9.45 11.788a.6.6 0 1 0 0 1.2h5.2a.6.6 0 1 0 0-1.2z" }))), _path$204 || (_path$204 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M9.45 2.638a.6.6 0 0 0 0 1.2h5.2a.6.6 0 1 0 0-1.2zM8.85 5.638a.6.6 0 0 1 .6-.6h3.294a.6.6 0 1 1 0 1.2H9.45a.6.6 0 0 1-.6-.6"
	})), _path2$145 || (_path2$145 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M2.2 11.863a2.158 2.158 0 0 1 2.726-2.725c.22.073.26.343.113.49l-2.35 2.348c-.146.147-.416.108-.488-.113m3.575.85a2.16 2.16 0 0 1-2.2.524c-.222-.073-.26-.343-.114-.49l2.35-2.348c.146-.147.416-.108.488.113a2.16 2.16 0 0 1-.524 2.2M2.03 8.967a3.14 3.14 0 1 0 4.44 4.44 3.14 3.14 0 0 0-4.44-4.44M7.784 3.071 3.915 6.94a.74.74 0 0 1-.532.215.74.74 0 0 1-.532-.215L.966 5.055a.737.737 0 1 1 1.043-1.043l1.374 1.375 3.359-3.359a.737.737 0 1 1 1.042 1.043",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Salesforce.svg
var _path$203;
function _extends$217() {
	return _extends$217 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$217.apply(null, arguments);
}
var SvgSalesforce$1 = function SvgSalesforce(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$217({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$203 || (_path$203 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M6.658 3.619a2.8 2.8 0 0 1 2.028-.87c1.058 0 1.976.588 2.47 1.464a3.4 3.4 0 0 1 1.393-.297c1.905 0 3.451 1.558 3.451 3.48 0 1.923-1.546 3.481-3.451 3.481q-.35 0-.682-.068a2.526 2.526 0 0 1-3.304 1.04 2.874 2.874 0 0 1-5.344-.13q-.272.058-.55.058C1.194 11.777 0 10.566 0 9.078c0-1 .537-1.87 1.335-2.34a3.106 3.106 0 0 1 2.854-4.339c1.005 0 1.905.48 2.47 1.223",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Save.svg
var _path$202;
var _path2$144;
var _path3$71;
function _extends$216() {
	return _extends$216 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$216.apply(null, arguments);
}
var SvgSave = function SvgSave(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$216({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$202 || (_path$202 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M4.484 8.107c0-.236.19-.427.426-.427h6.18c.236 0 .426.191.426.427v2.983c0 .236-.19.426-.426.426H4.91a.426.426 0 0 1-.426-.426z",
		opacity: .5
	})), _path2$144 || (_path2$144 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M3.631 2.779a.85.85 0 0 0-.852.852v8.738c0 .47.381.852.852.852h8.738c.47 0 .852-.381.852-.852V4.622a.85.85 0 0 0-.25-.603l-.99-.99a.85.85 0 0 0-.603-.25zM1.5 3.63c0-1.177.954-2.131 2.131-2.131h7.747c.565 0 1.107.225 1.507.624l.99.991c.4.4.625.942.625 1.507v7.747a2.13 2.13 0 0 1-2.131 2.131H3.63A2.13 2.13 0 0 1 1.5 12.369z",
		clipRule: "evenodd"
	})), _path3$71 || (_path3$71 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M4.27 1.5H9.45l1.24.623 1.04.474v1.46a2.344 2.344 0 0 1-2.344 2.345h-2.77A2.344 2.344 0 0 1 4.27 4.057zm1.28 1.279v1.278c0 .589.476 1.066 1.065 1.066h2.77c.589 0 1.066-.477 1.066-1.066V2.78z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Search.svg
var _path$201;
var _path2$143;
function _extends$215() {
	return _extends$215 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$215.apply(null, arguments);
}
var SvgSearch = function SvgSearch(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$215({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$201 || (_path$201 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "m11.047 9.125 2.292 2.293a1.359 1.359 0 0 1-1.921 1.921l-2.293-2.292.137-.084a5.4 5.4 0 0 0 1.706-1.71z",
		clipRule: "evenodd",
		opacity: .5
	})), _path2$143 || (_path2$143 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M14.197 14.197a2.57 2.57 0 0 1-3.637 0l-2.633-2.633-.083.024a5.365 5.365 0 1 1 3.743-3.743l-.023.082 2.633 2.633a2.57 2.57 0 0 1 0 3.637m-.858-2.78a1.359 1.359 0 0 1-1.921 1.922l-2.293-2.292.137-.084a5.4 5.4 0 0 0 1.706-1.71l.079-.128zm-2.772-5.002a4.152 4.152 0 1 1-8.304 0 4.152 4.152 0 0 1 8.304 0",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/SearchDomain.svg
var _g$31;
var _path$200;
function _extends$214() {
	return _extends$214 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$214.apply(null, arguments);
}
var SvgSearchDomain = function SvgSearchDomain(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$214({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$31 || (_g$31 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .5
	}, /*#__PURE__*/ React.createElement("path", { d: "m9.472 10.52.387 1.506a.02.02 0 0 0 .04 0l.214-.866z" }), /*#__PURE__*/ React.createElement("path", {
		fillRule: "evenodd",
		d: "m10.676 11.723-.28.99a.4.4 0 0 1-.385.29h-.179a.4.4 0 0 1-.385-.293l-.513-1.848a.029.029 0 0 0-.056 0l-.513 1.848a.4.4 0 0 1-.385.293H7.8a.4.4 0 0 1-.386-.29l-.69-2.444a.36.36 0 0 1 .005-.216 5.38 5.38 0 0 1-2.59-2.05H2a2 2 0 0 0-2 2v2.8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V10.95a3.3 3.3 0 0 1-.354.56l-.34 1.203a.4.4 0 0 1-.385.29h-.18a.4.4 0 0 1-.384-.293l-.052-.186a3.3 3.3 0 0 1-1.047.236.4.4 0 0 1-.368.244h-.18a.4.4 0 0 1-.386-.292l-.01-.035a3.25 3.25 0 0 1-1.554-.87zm-8.172.99a.4.4 0 0 0 .385.29h.181a.4.4 0 0 0 .386-.293l.512-1.848a.029.029 0 0 1 .056 0l.513 1.848a.4.4 0 0 0 .385.293h.179a.4.4 0 0 0 .385-.29l.692-2.444a.366.366 0 1 0-.708-.187l-.482 1.944a.02.02 0 0 1-.038 0l-.494-1.922a.4.4 0 0 0-.388-.3h-.14a.4.4 0 0 0-.387.3l-.494 1.935a.019.019 0 0 1-.037 0l-.49-1.959a.366.366 0 1 0-.706.188z",
		clipRule: "evenodd"
	}), /*#__PURE__*/ React.createElement("path", { d: "m7.478 10.27.442 1.77q.005.013.018.014a.02.02 0 0 0 .019-.015l.423-1.656a5.4 5.4 0 0 1-.902-.113" }), /*#__PURE__*/ React.createElement("path", {
		fillRule: "evenodd",
		d: "m10.855 8.524 1.595 1.594a.88.88 0 0 0 1.243-1.243L12.099 7.28a4.2 4.2 0 0 1-1.244 1.244",
		clipRule: "evenodd"
	}))), _path$200 || (_path$200 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "m9.692 9.042 1.917 1.917a2.069 2.069 0 1 0 2.925-2.925l-1.917-1.917A4.168 4.168 0 0 0 8.6.86a4.164 4.164 0 1 0 1.093 8.182m1.163-.518 1.595 1.594a.88.88 0 0 0 1.243-1.243L12.099 7.28a4.2 4.2 0 0 1-1.244 1.244M8.6 7.998a2.974 2.974 0 1 0 0-5.948 2.974 2.974 0 0 0 0 5.948",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/SearchScoped.svg
var _g$30;
var _path$199;
var _path2$142;
function _extends$213() {
	return _extends$213 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$213.apply(null, arguments);
}
var SvgSearchScoped = function SvgSearchScoped(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$213({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$30 || (_g$30 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .5
	}, /*#__PURE__*/ React.createElement("path", { d: "M8.599 10.387q.353 0 .696-.045l1.465 1.466c.303.302.65.533 1.02.692H5.584a1.1 1.1 0 0 1 0-2.2H7.63q.472.086.97.087M13.743 3.5a5.4 5.4 0 0 1 .18 2.177 1.1 1.1 0 0 0-.18-2.176" }), /*#__PURE__*/ React.createElement("path", {
		fillRule: "evenodd",
		d: "m10.855 8.524 1.595 1.594a.88.88 0 0 0 1.243-1.243L12.099 7.28a4.2 4.2 0 0 1-1.244 1.244",
		clipRule: "evenodd"
	}))), _path$199 || (_path$199 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M3.348 3.922a1 1 0 0 0-.027-.102.4.4 0 0 0-.086-.155.4.4 0 0 0-.164-.086 1.5 1.5 0 0 0-.243-.05 4 4 0 0 0-.525-.029c-.15 0-.348.006-.525.03a1.5 1.5 0 0 0-.243.05.4.4 0 0 0-.164.085.4.4 0 0 0-.086.155q-.034.099-.052.227A4 4 0 0 0 1.2 4.6c0 .186.008.384.033.553q.018.128.052.227.032.1.086.155a.4.4 0 0 0 .164.085c.07.022.155.038.243.05.177.024.375.03.525.03s.348-.006.525-.03a1.5 1.5 0 0 0 .243-.05.4.4 0 0 0 .164-.085l.022-.025a5.4 5.4 0 0 1 .091-1.588M3.32 8.78a.4.4 0 0 1-.085.155.4.4 0 0 1-.164.085 1.5 1.5 0 0 1-.243.05 4 4 0 0 1-.525.03 4 4 0 0 1-.525-.03 1.5 1.5 0 0 1-.243-.05.4.4 0 0 1-.164-.085.4.4 0 0 1-.086-.155 1.3 1.3 0 0 1-.052-.227A4 4 0 0 1 1.2 8c0-.186.008-.384.033-.553q.018-.128.052-.227a.4.4 0 0 1 .086-.155.4.4 0 0 1 .164-.086 1.5 1.5 0 0 1 .243-.05 4 4 0 0 1 .525-.029c.15 0 .348.006.525.03.089.012.173.028.243.05.07.021.128.05.164.085q.054.056.086.155.032.1.05.227c.023.17.029.367.029.553s-.006.384-.03.553a1.3 1.3 0 0 1-.05.227M3.32 12.18a.4.4 0 0 1-.085.155.4.4 0 0 1-.164.085 1.5 1.5 0 0 1-.243.05c-.177.024-.374.03-.525.03-.15 0-.348-.006-.525-.03a1.5 1.5 0 0 1-.243-.05.4.4 0 0 1-.164-.085.4.4 0 0 1-.086-.155 1.3 1.3 0 0 1-.052-.227A4 4 0 0 1 1.2 11.4c0-.186.008-.384.033-.553q.018-.129.052-.227a.4.4 0 0 1 .086-.155.4.4 0 0 1 .164-.085 1.5 1.5 0 0 1 .243-.05c.177-.024.375-.03.525-.03s.348.006.525.03c.089.012.173.028.243.05.07.021.128.05.164.085q.054.056.086.155.032.1.05.227c.023.17.029.367.029.553s-.006.384-.03.553a1.3 1.3 0 0 1-.05.227"
	})), _path2$142 || (_path2$142 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "m9.692 9.042 1.917 1.917a2.069 2.069 0 1 0 2.925-2.925l-1.917-1.917q.144-.525.145-1.093a4.164 4.164 0 1 0-3.07 4.018m1.163-.518 1.595 1.594a.88.88 0 0 0 1.243-1.243L12.099 7.28a4.2 4.2 0 0 1-1.244 1.244M8.6 7.998a2.974 2.974 0 1 0 0-5.948 2.974 2.974 0 0 0 0 5.948",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/SearchService.svg
var _g$29;
var _path$198;
var _path2$141;
function _extends$212() {
	return _extends$212 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$212.apply(null, arguments);
}
var SvgSearchService = function SvgSearchService(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$212({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$29 || (_g$29 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .5
	}, /*#__PURE__*/ React.createElement("path", { d: "M6.296 9.87a5.37 5.37 0 0 1-2.942-3.718 1.29 1.29 0 0 0-1.051 1.265V9.99c0 .71.576 1.287 1.286 1.287h.46v-.908a.5.5 0 0 1 .5-.5z" }), /*#__PURE__*/ React.createElement("path", {
		fillRule: "evenodd",
		d: "m10.855 8.524 1.595 1.594a.88.88 0 0 0 1.243-1.243L12.099 7.28a4.2 4.2 0 0 1-1.244 1.244",
		clipRule: "evenodd"
	}))), _path$198 || (_path$198 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M8.599 10.387q.353 0 .696-.045l.63.63H5.35a.2.2 0 0 0-.2.2v1.454c0 .508.412.92.92.92H9.93a.92.92 0 0 0 .919-.92v-.733c.328.305.704.53 1.102.675v.058a2.02 2.02 0 0 1-2.021 2.022H6.07a2.02 2.02 0 0 1-2.021-2.022v-.247h-.46A2.39 2.39 0 0 1 1.2 9.99V7.417c0-1.2.884-2.192 2.035-2.363q.004.565.119 1.098a1.29 1.29 0 0 0-1.051 1.265V9.99c0 .71.576 1.287 1.286 1.287h.46v-.908a.5.5 0 0 1 .5-.5h1.747a5.34 5.34 0 0 0 2.303.518M14.55 6.353c-.15-.3-.36-.565-.616-.777l-.016.144z"
	})), _path2$141 || (_path2$141 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "m9.692 9.042 1.917 1.917a2.069 2.069 0 1 0 2.925-2.925l-1.917-1.917q.144-.525.145-1.093a4.164 4.164 0 1 0-3.07 4.018m1.163-.518 1.595 1.594a.88.88 0 0 0 1.243-1.243L12.099 7.28a4.2 4.2 0 0 1-1.244 1.244M8.6 7.998a2.974 2.974 0 1 0 0-5.948 2.974 2.974 0 0 0 0 5.948",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Secure.svg
var _path$197;
var _path2$140;
function _extends$211() {
	return _extends$211 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$211.apply(null, arguments);
}
var SvgSecure = function SvgSecure(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$211({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$197 || (_path$197 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M12.52 8.618c-.37 2.095-1.857 3.823-4.27 5.003a.6.6 0 0 1-.25.058V2.314a1 1 0 0 1 .353.065l3.913 1.477c.21.08.36.27.38.495.094 1.041.156 2.674-.126 4.267",
		opacity: .25
	})), _path2$140 || (_path2$140 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M2.182 3.768c-.117 1.018-.264 3.05.092 5.064.48 2.719 2.47 4.789 5.342 6.08q.186.081.384.088.198-.006.384-.089c2.872-1.29 4.861-3.36 5.342-6.08.356-2.013.209-4.045.092-5.063a1.1 1.1 0 0 0-.704-.901L8.356 1.07A1.1 1.1 0 0 0 8 1q-.181.005-.356.07L2.886 2.867c-.379.143-.656.484-.704.901m6.171-1.39a1 1 0 0 0-.706 0L3.734 3.857a.59.59 0 0 0-.38.495c-.094 1.041-.156 2.674.126 4.267.37 2.095 1.858 3.823 4.27 5.003a.57.57 0 0 0 .5 0c2.412-1.18 3.9-2.908 4.27-5.003.282-1.593.22-3.226.126-4.267a.59.59 0 0 0-.38-.495z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Select.svg
var _g$28;
var _path$196;
function _extends$210() {
	return _extends$210 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$210.apply(null, arguments);
}
var SvgSelect = function SvgSelect(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$210({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$28 || (_g$28 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .5
	}, /*#__PURE__*/ React.createElement("path", { d: "M10.8 12.4v1q.001.05.005.1H9.2a.6.6 0 1 1 0-1.2h1.605q-.004.05-.005.1M6.8 12.3a.601.601 0 0 1 0 1.2H5.195q.004-.05.005-.1v-1q-.001-.05-.006-.1zM3.1 8.6c.331 0 .6.269.6.6v1.605q-.05-.004-.1-.005h-1q-.05 0-.1.004V9.2a.6.6 0 0 1 .6-.6M12.9 8.6a.6.6 0 0 1 .6.6v1.605q-.05-.004-.1-.005h-1q-.05 0-.1.004V9.2c0-.331.269-.6.6-.6M3.7 6.8a.601.601 0 0 1-1.2 0V5.194q.05.005.1.006h1q.05-.001.1-.006zM13.5 6.8a.6.6 0 1 1-1.2 0V5.194q.05.005.1.006h1q.05-.001.1-.006zM10.8 2.6v1q.001.05.005.1H9.2a.601.601 0 0 1 0-1.2h1.606q-.005.05-.006.1M6.8 2.5a.6.6 0 1 1 0 1.2H5.195q.004-.05.005-.1v-1q-.001-.05-.006-.1z" }))), _path$196 || (_path$196 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M13.4 10.8a1.6 1.6 0 0 1 1.6 1.6v1a1.6 1.6 0 0 1-1.6 1.6h-1a1.6 1.6 0 0 1-1.6-1.6v-1c0-.883.717-1.6 1.6-1.6zm-1.08 2.992a.4.4 0 0 1-.312-.312L12 13.4v-1a.4.4 0 0 1 .32-.392L12.4 12h1l.08.008a.4.4 0 0 1 .32.392v1l-.008.08a.4.4 0 0 1-.312.312l-.08.008h-1zM3.6 10.8a1.6 1.6 0 0 1 1.6 1.6v1A1.6 1.6 0 0 1 3.6 15h-1A1.6 1.6 0 0 1 1 13.4v-1c0-.883.717-1.6 1.6-1.6zm-1.08 2.992a.4.4 0 0 1-.312-.312L2.2 13.4v-1a.4.4 0 0 1 .32-.392L2.6 12h1l.08.008A.4.4 0 0 1 4 12.4v1l-.008.08a.4.4 0 0 1-.311.312l-.08.008h-1zM3.6 1a1.6 1.6 0 0 1 1.6 1.6v1a1.6 1.6 0 0 1-1.6 1.6h-1A1.6 1.6 0 0 1 1 3.6v-1C1 1.717 1.717 1 2.6 1zM2.52 3.992a.4.4 0 0 1-.312-.311L2.2 3.6v-1a.4.4 0 0 1 .32-.393L2.6 2.2h1l.08.008A.4.4 0 0 1 4 2.6v1l-.008.08a.4.4 0 0 1-.311.312L3.6 4h-1zM13.4 1A1.6 1.6 0 0 1 15 2.6v1a1.6 1.6 0 0 1-1.6 1.6h-1a1.6 1.6 0 0 1-1.6-1.6v-1c0-.883.717-1.6 1.6-1.6zm-1.08 2.992a.4.4 0 0 1-.312-.311L12 3.6v-1a.4.4 0 0 1 .32-.393l.08-.008h1l.08.008a.4.4 0 0 1 .32.392v1l-.008.08a.4.4 0 0 1-.312.312L13.4 4h-1z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Service.svg
var _path$195;
var _path2$139;
var _path3$70;
function _extends$209() {
	return _extends$209 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$209.apply(null, arguments);
}
var SvgService = function SvgService(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$209({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$195 || (_path$195 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M13.98 2.997H2.02v2.07h11.96zM3.076 4.55a.515.515 0 0 0 .513-.518.515.515 0 0 0-.513-.518.515.515 0 0 0-.512.518c0 .286.23.518.512.518m1.196 0a.515.515 0 0 0 .513-.518.515.515 0 0 0-.513-.518.515.515 0 0 0-.512.518c0 .286.23.518.512.518",
		clipRule: "evenodd",
		opacity: .5
	})), _path2$139 || (_path2$139 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M2.878 2h10.244C14.159 2 15 2.82 15 3.833v8.334C15 13.179 14.16 14 13.122 14H2.878C1.841 14 1 13.18 1 12.167V3.833C1 2.821 1.84 2 2.878 2m0 1a.844.844 0 0 0-.854.833v8.334c0 .46.383.833.854.833h10.244a.844.844 0 0 0 .854-.833V3.833A.844.844 0 0 0 13.122 3z",
		clipRule: "evenodd"
	})), _path3$70 || (_path3$70 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M5.967 10.644c-.51 0-.924-.48-.924-1.072s.414-1.071.924-1.071h.035c0-.9.629-1.63 1.404-1.63.502 0 .942.305 1.19.764a1 1 0 0 1 .38-.078c.51 0 .94.4 1.069.944.505.007.912.484.912 1.071 0 .592-.414 1.072-.924 1.072zm4.82-3c.75.336 1.183 1.153 1.183 1.928 0 1.006-.731 2.086-1.937 2.086H5.967c-1.206 0-1.938-1.08-1.938-2.086 0-.736.393-1.512 1.076-1.875.296-1.002 1.134-1.84 2.301-1.84.653 0 1.214.276 1.628.688.794.021 1.41.492 1.752 1.1",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/SFP.svg
var _path$194;
var _path2$138;
function _extends$208() {
	return _extends$208 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$208.apply(null, arguments);
}
var SvgSfp$1 = function SvgSfp(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$208({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$194 || (_path$194 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M2.2 11.91a.8.8 0 0 0 .8.8h10a.8.8 0 0 0 .796-.719l.004-.082-1.606-.73a2 2 0 0 0-.828-.179H4.633a2 2 0 0 0-.827.18z",
		opacity: .25
	})), _path2$138 || (_path2$138 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M15 4.09a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v7.82a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2zM3 12.71a.8.8 0 0 1-.8-.8V4.09a.8.8 0 0 1 .8-.8h1c.11 0 .2.09.2.2v.42a.6.6 0 0 0 .6.58h6.4a.6.6 0 0 0 .6-.58v-.418c0-.11.09-.2.2-.2l1-.001a.8.8 0 0 1 .8.8v7.818l-.004.082a.8.8 0 0 1-.796.718z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/SFPDown.svg
var _path$193;
var _path2$137;
function _extends$207() {
	return _extends$207 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$207.apply(null, arguments);
}
var SvgSfpDown = function SvgSfpDown(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$207({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$193 || (_path$193 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M13.8 4.09a.8.8 0 0 0-.8-.8H3a.8.8 0 0 0-.796.719L2.2 4.09l1.606.73A2 2 0 0 0 4.633 5h6.733a2 2 0 0 0 .828-.18z",
		opacity: .25
	})), _path2$137 || (_path2$137 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M1 11.91a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4.09a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2zm12-8.62a.8.8 0 0 1 .8.8v7.82a.8.8 0 0 1-.8.8h-1a.2.2 0 0 1-.2-.2v-.42a.6.6 0 0 0-.6-.58H4.8a.6.6 0 0 0-.6.58v.418a.2.2 0 0 1-.2.2l-1 .001a.8.8 0 0 1-.8-.8V4.091l.004-.082A.8.8 0 0 1 3 3.29z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/SFPUp.svg
var _path$192;
var _path2$136;
function _extends$206() {
	return _extends$206 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$206.apply(null, arguments);
}
var SvgSfpUp = function SvgSfpUp(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$206({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$192 || (_path$192 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M2.2 11.91a.8.8 0 0 0 .8.8h10a.8.8 0 0 0 .796-.719l.004-.082-1.606-.73a2 2 0 0 0-.828-.179H4.633a2 2 0 0 0-.827.18z",
		opacity: .25
	})), _path2$136 || (_path2$136 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M15 4.09a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v7.82a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2zM3 12.71a.8.8 0 0 1-.8-.8V4.09a.8.8 0 0 1 .8-.8h1c.11 0 .2.09.2.2v.42a.6.6 0 0 0 .6.58h6.4a.6.6 0 0 0 .6-.58v-.418c0-.11.09-.2.2-.2l1-.001a.8.8 0 0 1 .8.8v7.818l-.004.082a.8.8 0 0 1-.796.718z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Share.svg
var _path$191;
var _path2$135;
var _path3$69;
function _extends$205() {
	return _extends$205 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$205.apply(null, arguments);
}
var SvgShare = function SvgShare(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$205({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$191 || (_path$191 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M6.299 2.236A2.226 2.226 0 0 0 8.495 4.22h.15L6.032 6.835c-.875.876-.838 2.272.012 3.122s2.246.885 3.121.012l2.615-2.616.001.152a2.22 2.22 0 0 0 2.058 2.2c-.027.595-.07 1.168-.143 1.687a7 7 0 0 1-.268 1.245c-.114.339-.218.485-.261.528a.7.7 0 0 1-.143.089c-.089.045-.224.103-.42.164-.363.113-.83.205-1.363.275-1.064.142-2.276.182-3.22.182-.943 0-2.155-.04-3.22-.182-.533-.07-.999-.162-1.362-.275a3 3 0 0 1-.42-.164.7.7 0 0 1-.143-.089c-.046-.046-.153-.196-.27-.537a7 7 0 0 1-.28-1.247c-.15-1.002-.2-2.21-.2-3.381s.05-2.379.2-3.38c.073-.502.168-.923.28-1.248.117-.34.224-.49.27-.537a.7.7 0 0 1 .143-.089 3 3 0 0 1 .42-.164c.363-.113.83-.205 1.363-.275.48-.064.991-.106 1.494-.134z",
		opacity: .25
	})), _path2$135 || (_path2$135 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M6.546.958a2.2 2.2 0 0 0-.26 1.053l.009.162c-.503.028-1.013.07-1.494.134-.534.07-1 .162-1.364.275a3 3 0 0 0-.42.164.7.7 0 0 0-.142.089c-.046.046-.153.196-.27.537a7 7 0 0 0-.28 1.247c-.15 1.002-.2 2.21-.2 3.381s.05 2.379.2 3.38c.073.502.168.923.28 1.248.117.34.224.49.27.537.01.01.052.043.143.089.089.045.224.103.42.164.363.113.83.205 1.363.275 1.064.142 2.276.182 3.22.182.943 0 2.155-.04 3.22-.182.533-.07.999-.162 1.363-.275.195-.06.33-.119.42-.164a.7.7 0 0 0 .142-.089c.043-.043.147-.189.26-.528a7 7 0 0 0 .27-1.245c.071-.519.114-1.092.142-1.688q.075.008.15.009l.227-.01c.3-.029.58-.12.833-.257a21 21 0 0 1-.164 2.11 8.3 8.3 0 0 1-.32 1.462c-.14.417-.318.763-.548.994-.232.232-.607.412-1.057.551-.453.14-.992.244-1.561.32-1.14.15-2.41.192-3.377.192-.969 0-2.24-.041-3.378-.192a10 10 0 0 1-1.561-.32c-.45-.14-.825-.319-1.057-.551-.23-.231-.412-.577-.555-.994a8.4 8.4 0 0 1-.333-1.461C.976 10.47.925 9.195.925 8s.05-2.47.212-3.557c.08-.543.189-1.042.333-1.46.143-.419.325-.764.555-.995.232-.232.606-.412 1.057-.551.453-.14.991-.244 1.56-.32A22 22 0 0 1 6.547.958"
	})), _path3$69 || (_path3$69 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M8.49 1a.996.996 0 0 0-1.004 1.004A1.025 1.025 0 0 0 8.502 3.02l3.025.016L6.88 7.683a1.007 1.007 0 0 0 .011 1.426 1.007 1.007 0 0 0 1.425.01l4.648-4.648.016 3.027a1.023 1.023 0 0 0 1.015 1.015A.996.996 0 0 0 15 7.51l-.03-5.463a1.024 1.024 0 0 0-1.016-1.015z"
	})));
};

//#endregion
//#region src/Icon/icons/Ship.svg
var _path$190;
var _path2$134;
function _extends$204() {
	return _extends$204 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$204.apply(null, arguments);
}
var SvgShip = function SvgShip(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$204({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$190 || (_path$190 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M13.675 9.31a.4.4 0 0 0-.25-.505L8.6 7.14v5.342c.833.122 1.416.487 1.897.808l.068.045c.431.288.737.492 1.1.57l.135.028z",
		clipRule: "evenodd",
		opacity: .25
	})), _path2$134 || (_path2$134 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M2.183 7.67a1.6 1.6 0 0 0-.996 2.019l1.643 3.928a5 5 0 0 1-.56-.326 6.6 6.6 0 0 1-.836-.665l-.009-.01-.001-.001a.6.6 0 0 0-.848.85l.003.002.004.005.017.016a5 5 0 0 0 .267.242c.178.152.432.355.738.56.592.394 1.465.85 2.395.85.889 0 1.522-.425 2.029-.765l.126-.085c.392-.26.764-.484 1.245-.589q.271-.06.6-.061.33.001.6.062c.477.104.843.328 1.231.587l.12.08c.507.343 1.142.77 2.049.77.945 0 1.817-.454 2.409-.851a7.5 7.5 0 0 0 .996-.804l.016-.017.005-.005.002-.001v-.001a.6.6 0 0 0-.857-.84l-.01.01-.04.04a6.274 6.274 0 0 1-.78.622c-.182.12-.374.235-.573.333l1.645-3.936a1.6 1.6 0 0 0-.996-2.019l-.472-.163-.488-4.025a1.6 1.6 0 0 0-1.59-1.422H9.86v-.6a.6.6 0 0 0-.6-.6H6.741a.6.6 0 0 0-.6.6v.6H4.665a1.6 1.6 0 0 0-1.587 1.397l-.568 4.1zm5.1-1.758a2.2 2.2 0 0 1 1.434 0l3.334 1.15-.386-3.446a.4.4 0 0 0-.398-.356H4.665a.4.4 0 0 0-.397.35L3.82 7.105zM2.325 9.309 4.2 13.934l.127-.028c.353-.077.657-.279 1.089-.565l.077-.051c.484-.321 1.072-.685 1.907-.807V7.14L2.574 8.805a.4.4 0 0 0-.249.504m11.35 0a.4.4 0 0 0-.25-.504L8.6 7.14v5.342c.833.122 1.416.487 1.897.808l.068.045c.431.288.737.492 1.1.57l.135.028z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Signout.svg
var _path$189;
var _path2$133;
var _path3$68;
function _extends$203() {
	return _extends$203 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$203.apply(null, arguments);
}
var SvgSignout = function SvgSignout(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$203({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$189 || (_path$189 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M8.93 3.372c.117-.34.224-.49.27-.537a.7.7 0 0 1 .142-.089c.09-.045.225-.103.42-.164.364-.112.83-.205 1.364-.275.533.07.999.163 1.363.275.195.061.33.119.42.164s.132.079.142.09c.046.045.153.195.27.536.112.325.207.746.281 1.247.149 1.002.2 2.21.2 3.381s-.051 2.379-.2 3.381a7 7 0 0 1-.28 1.247c-.118.34-.225.49-.271.537a.7.7 0 0 1-.142.089c-.09.045-.225.103-.42.164-.364.112-.83.205-1.363.275-.534-.07-1-.163-1.363-.275a3 3 0 0 1-.42-.164.7.7 0 0 1-.143-.09c-.046-.045-.153-.195-.27-.536a7 7 0 0 1-.281-1.247 17 17 0 0 1-.134-1.276h1.828c1.258 0 1.994-1.11 1.994-2.105s-.736-2.105-1.994-2.105H8.515c.032-.448.075-.878.134-1.276.074-.501.169-.922.28-1.247",
		opacity: .25
	})), _path2$133 || (_path2$133 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M10.968 14.883a10 10 0 0 1-1.561-.32c-.45-.14-.825-.318-1.057-.55-.23-.232-.411-.577-.555-.995a8.3 8.3 0 0 1-.333-1.461 18 18 0 0 1-.15-1.452h1.203c.032.448.075.878.134 1.276.074.501.169.922.28 1.247.118.34.225.49.271.537.01.01.052.043.142.089.09.045.225.103.42.164.364.112.83.205 1.364.275.533-.07.999-.163 1.363-.275.195-.061.33-.119.42-.164a.7.7 0 0 0 .142-.09c.046-.045.153-.195.27-.536.112-.325.207-.746.281-1.247.149-1.002.2-2.21.2-3.381s-.051-2.379-.2-3.381a7 7 0 0 0-.28-1.247c-.118-.34-.225-.49-.271-.537a.7.7 0 0 0-.142-.089 3 3 0 0 0-.42-.164 8.6 8.6 0 0 0-1.363-.275c-.534.07-1 .163-1.363.275-.196.061-.331.119-.42.164a.7.7 0 0 0-.143.09c-.046.045-.153.195-.27.536a7 7 0 0 0-.281 1.247c-.059.398-.102.828-.134 1.276H7.313c.033-.504.081-.995.149-1.452.08-.543.189-1.042.333-1.461.144-.418.325-.763.555-.994.232-.233.606-.412 1.057-.552a9.7 9.7 0 0 1 1.719-.34l.157.021c.57.076 1.109.179 1.561.32.45.14.825.318 1.057.55.23.232.412.577.555.995.144.42.253.918.333 1.461.161 1.087.212 2.362.212 3.557s-.05 2.47-.212 3.557a8.3 8.3 0 0 1-.333 1.461c-.143.418-.325.763-.555.994-.232.233-.606.412-1.057.552-.452.14-.991.243-1.56.319l-.158.02z"
	})), _path3$68 || (_path3$68 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M11.137 8c0 .495-.35.905-.794.905H3.705l1.736 1.992a1 1 0 0 1 0 1.276.728.728 0 0 1-1.127 0L1.26 8.67A.96.96 0 0 1 1 8c0-.265.1-.505.261-.671l3.053-3.502a.728.728 0 0 1 1.127 0 1 1 0 0 1 0 1.276L3.705 7.095h6.638c.444 0 .794.41.794.905",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/SiteToSite.svg
var _g$27;
var _path$188;
var _path2$132;
function _extends$202() {
	return _extends$202 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$202.apply(null, arguments);
}
var SvgSiteToSite = function SvgSiteToSite(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$202({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$27 || (_g$27 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .2
	}, /*#__PURE__*/ React.createElement("path", { d: "M5.1 5.147c.13-.193.318-.343.54-.427l3.482-1.315q-.018-.312-.043-.572a.44.44 0 0 0-.286-.371L5.365 1.167A.8.8 0 0 0 5.1 1.12zM10.9 14.874a.4.4 0 0 0 .188-.043c2.083-1.012 3.367-2.498 3.686-4.301.245-1.386.187-2.807.105-3.697a.44.44 0 0 0-.286-.371l-3.428-1.295a.8.8 0 0 0-.265-.048z" }))), _path$188 || (_path$188 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M.192 6.713C-.113 4.987.013 3.245.113 2.373A.94.94 0 0 1 .717 1.6L4.795.06A1 1 0 0 1 5.1 0a1 1 0 0 1 .305.06L9.483 1.6a.94.94 0 0 1 .604.773c.02.18.042.398.061.645l-1.026.387q-.015-.257-.035-.48a.59.59 0 0 0-.38-.496L5.453 1.201a1 1 0 0 0-.706 0L1.493 2.429a.59.59 0 0 0-.38.496c-.078.894-.124 2.266.113 3.605.316 1.785 1.577 3.26 3.624 4.27a.6.6 0 0 0 .16.052v.003q.103.577.29 1.115a1 1 0 0 1-.2.03.9.9 0 0 1-.33-.076C2.31 10.818.605 9.044.193 6.713"
	})), _path2$132 || (_path2$132 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M5.913 6.373c-.1.872-.226 2.614.079 4.34.412 2.33 2.117 4.105 4.579 5.211A.9.9 0 0 0 10.9 16a.9.9 0 0 0 .33-.076c2.46-1.106 4.166-2.88 4.578-5.211.305-1.726.179-3.468.079-4.34a.94.94 0 0 0-.604-.773l-4.078-1.54A1 1 0 0 0 10.9 4a1 1 0 0 0-.305.06L6.517 5.6a.94.94 0 0 0-.604.773m5.34-1.172a1 1 0 0 0-.706 0L7.293 6.429a.59.59 0 0 0-.38.496c-.078.894-.124 2.266.113 3.605.316 1.785 1.577 3.26 3.624 4.27a.56.56 0 0 0 .5 0c2.047-1.01 3.308-2.485 3.624-4.27.237-1.34.19-2.71.113-3.605a.59.59 0 0 0-.38-.496z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Slack.svg
var _path$187;
var _path2$131;
function _extends$201() {
	return _extends$201 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$201.apply(null, arguments);
}
var SvgSlack$1 = function SvgSlack(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$201({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$187 || (_path$187 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M4.684 2.474a1.474 1.474 0 0 1 2.948 0v1.473H6.158c-.814 0-1.474-.66-1.474-1.473M1 9.842a1.474 1.474 0 1 0 2.947 0V8.368H2.474C1.66 8.368 1 9.028 1 9.842m10.316 3.684a1.474 1.474 0 0 1-2.948 0v-1.473h1.474c.814 0 1.474.66 1.474 1.473M15 6.158a1.474 1.474 0 0 0-2.947 0v1.474h1.473c.814 0 1.474-.66 1.474-1.474",
		clipRule: "evenodd",
		opacity: .5
	})), _path2$131 || (_path2$131 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8.368 6.158a1.474 1.474 0 1 0 2.948 0V2.474a1.474 1.474 0 0 0-2.948 0zM2.474 4.684a1.474 1.474 0 0 0 0 2.948h3.684a1.474 1.474 0 1 0 0-2.948zm7.368 3.684a1.474 1.474 0 1 0 0 2.948h3.684a1.474 1.474 0 0 0 0-2.948zM6.158 15c-.814 0-1.474-.66-1.474-1.474V9.842a1.474 1.474 0 1 1 2.948 0v3.684c0 .814-.66 1.474-1.474 1.474",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/SlideHorizontal.svg
var _path$186;
function _extends$200() {
	return _extends$200 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$200.apply(null, arguments);
}
var SvgSlideHorizontal = function SvgSlideHorizontal(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$200({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$186 || (_path$186 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M2.51 15A1.51 1.51 0 0 1 1 13.49V2.51a1.51 1.51 0 1 1 3.02 0v10.98A1.51 1.51 0 0 1 2.51 15M8 15a1.51 1.51 0 0 1-1.51-1.51V2.51a1.51 1.51 0 1 1 3.02 0v10.98A1.51 1.51 0 0 1 8 15M13.49 15a1.51 1.51 0 0 1-1.51-1.51V2.51a1.51 1.51 0 0 1 3.02 0v10.98A1.51 1.51 0 0 1 13.49 15"
	})));
};

//#endregion
//#region src/Icon/icons/SlideVertical.svg
var _path$185;
function _extends$199() {
	return _extends$199 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$199.apply(null, arguments);
}
var SvgSlideVertical = function SvgSlideVertical(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$199({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$185 || (_path$185 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M1 2.51C1 1.676 1.676 1 2.51 1h10.98a1.51 1.51 0 0 1 0 3.02H2.51A1.51 1.51 0 0 1 1 2.51M1 8c0-.834.676-1.51 1.51-1.51h10.98a1.51 1.51 0 0 1 0 3.02H2.51A1.51 1.51 0 0 1 1 8M1 13.49c0-.834.676-1.51 1.51-1.51h10.98a1.51 1.51 0 0 1 0 3.02H2.51A1.51 1.51 0 0 1 1 13.49"
	})));
};

//#endregion
//#region src/Icon/icons/Snowflake.svg
var _path$184;
var _path2$130;
function _extends$198() {
	return _extends$198 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$198.apply(null, arguments);
}
var SvgSnowflake = function SvgSnowflake(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$198({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$184 || (_path$184 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M12.085 3.991c.093.204.118.44.051.673L11.81 5.8l1.147.286A.977.977 0 0 1 12.864 8a.978.978 0 0 1 .093 1.914l-1.147.286.326 1.136a.977.977 0 0 1-1.704.877.977.977 0 0 1-1.61 1.037L8 12.4l-.821.85a.977.977 0 0 1-1.611-1.037.977.977 0 0 1-1.704-.877L4.19 10.2l-1.146-.286a1 1 0 0 1-.435-.237 10.85 10.85 0 0 0 9.476-5.686m-5.85 6.156-.493 1.728a1 1 0 0 1-.031.09 1 1 0 0 1 .064-.072l1.248-1.29V9.69zm2.742.455 1.249 1.29q.033.036.063.073a1 1 0 0 1-.03-.09l-.493-1.728-.789-.456zM9.953 8l.789.456 1.742-.437q.047-.012.094-.019a1 1 0 0 1-.094-.019l-1.741-.437z",
		clipRule: "evenodd",
		opacity: .25
	})), _path2$130 || (_path2$130 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M8 1.738a2.276 2.276 0 0 1 3.391.389q.13.01.263.035l.172.042.22.076a2.276 2.276 0 0 1 1.377 2.588A2.277 2.277 0 0 1 14.783 8q.055.119.099.245l.05.17.044.23a2.276 2.276 0 0 1-1.553 2.486 2.276 2.276 0 0 1-2.032 2.743A2.276 2.276 0 0 1 8 14.262a2.276 2.276 0 0 1-3.391-.388 2.278 2.278 0 0 1-2.033-2.744 2.276 2.276 0 0 1-1.508-2.715l.05-.17q.043-.127.1-.245a2.277 2.277 0 0 1 1.359-3.132 2.28 2.28 0 0 1 1.598-2.664l.172-.042a2 2 0 0 1 .26-.035q.125-.18.287-.337l.176-.154A2.28 2.28 0 0 1 8 1.738m2.202.989a.977.977 0 0 0-1.38.023L8 3.601l-.82-.851a.978.978 0 0 0-1.612 1.037.978.978 0 0 0-1.704.877L4.19 5.8l-1.147.286A.976.976 0 0 0 3.136 8a.977.977 0 0 0-.093 1.914l1.147.286-.326 1.136a.977.977 0 0 0 1.704.877.977.977 0 0 0 1.612 1.037L8 12.4l.821.85a.977.977 0 0 0 1.611-1.037.977.977 0 0 0 1.704-.877l-.325-1.136 1.145-.286A.977.977 0 0 0 12.864 8a.978.978 0 0 0 .092-1.914L11.811 5.8l.325-1.136a.976.976 0 0 0-1.704-.877.98.98 0 0 0-.23-1.06m-3.178 7.876-1.25 1.29a1 1 0 0 0-.063.072 1 1 0 0 0 .03-.09l.493-1.728.79-.456zm2.741-.456.493 1.727.031.09a1 1 0 0 0-.062-.072l-1.25-1.29v-.91zM6.047 8l-.79.456-1.74-.437A1 1 0 0 0 3.421 8a1 1 0 0 0 .094-.02l1.742-.436zm6.438-.018a1 1 0 0 0 .093.018 1 1 0 0 0-.093.02l-1.743.436L9.953 8l.79-.456zm-6.71-3.874 1.249 1.29v.91l-.79-.455-.492-1.727a1 1 0 0 0-.031-.09 1 1 0 0 0 .063.072m4.483.018-.493 1.727-.788.456v-.912l1.25-1.29a1 1 0 0 0 .062-.072 1 1 0 0 0-.03.09"
	})));
};

//#endregion
//#region src/Icon/icons/Spaces.svg
var _g$26;
var _g2$3;
var _path$183;
var _path2$129;
var _path3$67;
function _extends$197() {
	return _extends$197 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$197.apply(null, arguments);
}
var SvgSpaces = function SvgSpaces(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$197({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$26 || (_g$26 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "m14.136 10.502.05.03a.4.4 0 0 1-.05.677l-.52.274-5.242 2.774-.09.04a.8.8 0 0 1-.284.051v-3.31c.515 0 1.03-.123 1.497-.37l2.477-1.31zM10.866 7.227l-2.492 1.32-.09.04a.8.8 0 0 1-.659-.04L5.133 7.228 8 5.704zM7.625 1.743a.8.8 0 0 1 .75 0l2.265 1.198L8 4.346 5.36 2.94z" }))), _g2$3 || (_g2$3 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .5
	}, /*#__PURE__*/ React.createElement("path", { d: "m6.722 5.025-2.87 1.526-1.988-1.052a.4.4 0 0 1 0-.707l2.214-1.173zM14.136 4.792l.05.03a.4.4 0 0 1-.05.677l-1.99 1.05-2.868-1.524L11.92 3.62z" }))), _path$183 || (_path$183 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M7.175 6.338a2 2 0 0 1 1.65 0l.112.054.47.25-1.364.72a1 1 0 0 0-.089 0l-1.363-.72.472-.25z"
	})), _path2$129 || (_path2$129 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M7.175 6.338a2 2 0 0 1 1.65 0l.112.054.47.25-1.364.72a1 1 0 0 0-.089 0l-1.363-.72.472-.25z",
		clipRule: "evenodd"
	})), _path3$67 || (_path3$67 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8.825.628a2 2 0 0 0-1.65 0l-.112.055L1.302 3.73c-.568.3-.851.857-.852 1.413v5.727c.005.552.29 1.1.852 1.399l5.761 3.047c.586.31 1.288.31 1.874 0l5.761-3.047c1.136-.602 1.136-2.228 0-2.829l-1.442-.763-1.282.68 2.163 1.144.05.03a.4.4 0 0 1-.05.677l-.52.274-5.242 2.774-.09.04A.8.8 0 0 1 8 14.35V9.84c.322 0 .644-.078.937-.233l5.761-3.048c1.136-.6 1.136-2.227 0-2.828L8.937.683zm-.45 1.115a.8.8 0 0 0-.75 0L1.863 4.792a.4.4 0 0 0 0 .707l5.762 3.048a.8.8 0 0 0 .66.04l.09-.04 5.24-2.774.522-.274a.4.4 0 0 0 .05-.677l-.05-.03zM6.8 13.317a.4.4 0 0 1-.587.354l-.48-.232a.4.4 0 0 1-.225-.36v-2.77a.8.8 0 0 0-.414-.702l-1.775-.976a.4.4 0 0 0-.592.35v2.604a.16.16 0 0 1-.24.139l-.447-.256a.8.8 0 0 1-.427-.714l.032-3.525a.4.4 0 0 1 .587-.35l4.144 2.206a.8.8 0 0 1 .424.706z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/SPAN.svg
var _path$182;
var _path2$128;
var _path3$66;
var _path4$29;
function _extends$196() {
	return _extends$196 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$196.apply(null, arguments);
}
var SvgSpan = function SvgSpan(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$196({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$182 || (_path$182 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M12.266 9.826c0 .216.175.39.39.39h.008v.009c0 .215.175.39.39.39h.678c.07 0 .128.057.128.127v2.392c0 .07-.057.127-.128.127h-.28v-.189a.593.593 0 0 0-1.186 0v.189h-.867v-.189a.593.593 0 0 0-1.186 0v.189h-.466a.127.127 0 0 1-.127-.127v-1.7q.43-.398.86-.825a.39.39 0 0 0 .33-.335l.061-.061a.376.376 0 0 0 .34-.358q.114-.118.224-.236h.83z",
		opacity: .25
	})), _path2$128 || (_path2$128 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M12.338 8.599c.46 0 .84.327.928.76a1 1 0 0 1 .243.236h.223c.634 0 1.148.514 1.148 1.147v2.392c0 .633-.514 1.147-1.148 1.147H9.747A1.15 1.15 0 0 1 8.6 13.134v-.803q.504-.42 1.02-.897v1.7c0 .07.057.126.127.127h.466v-.189a.594.594 0 0 1 1.186 0v.189h.867v-.189a.594.594 0 0 1 1.186 0v.189h.28c.07 0 .128-.057.128-.127v-2.392a.13.13 0 0 0-.128-.127h-.677a.39.39 0 0 1-.39-.39v-.008h-.009a.39.39 0 0 1-.39-.39v-.208h-.83q.475-.516.897-1.02z"
	})), _path3$66 || (_path3$66 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M10.81 10.274a.39.39 0 0 1-.33.335l.066-.063q.134-.136.264-.272M11.21 9.855a.376.376 0 0 1-.339.358q.172-.179.34-.358M11.972 2.473c.3-.004.753.069 1.12.436l.124.14c.26.337.314.716.311.98a2.5 2.5 0 0 1-.158.797c-.161.45-.441.947-.77 1.44-.67 1.005-1.692 2.221-2.902 3.431S7.271 11.93 6.267 12.6c-.494.329-.99.609-1.44.77-.223.08-.501.155-.799.158-.3.004-.752-.068-1.119-.435a1.54 1.54 0 0 1-.436-1.12c.003-.298.08-.575.159-.797.16-.45.44-.947.77-1.44.237-.355.517-.736.834-1.134H5.8c-1.479 1.701-2.342 3.153-2.08 3.593l.039.05c.44.437 2.47-.871 4.652-2.967l.439-.428c2.342-2.343 3.861-4.622 3.394-5.091-.37-.37-1.872.502-3.643 2.04V4.237c.398-.317.78-.597 1.134-.834.494-.33.99-.61 1.44-.77.223-.08.5-.156.798-.16"
	})), _path4$29 || (_path4$29 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M5.786 2.48a.95.95 0 0 0-.928-.761H3.663a.95.95 0 0 0-.93.761 1 1 0 0 0-.242.235h-.224c-.633 0-1.147.514-1.147 1.147v2.392c0 .633.514 1.147 1.147 1.147h3.986c.633 0 1.147-.514 1.147-1.147V3.862c0-.633-.514-1.147-1.147-1.147h-.224a1 1 0 0 0-.243-.236m-2.432.857c.21 0 .38-.17.38-.38v-.218h1.052v.207c0 .216.175.39.39.39h.008v.009c0 .215.175.39.391.39h.678c.07 0 .127.057.128.127v2.392c0 .07-.058.127-.128.127h-.28v-.189a.593.593 0 0 0-1.187 0v.189H3.92v-.189a.593.593 0 0 0-1.187 0v.189h-.466a.127.127 0 0 1-.127-.127V3.862c0-.07.057-.127.127-.127h.678a.39.39 0 0 0 .39-.39v-.008z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Spare.svg
var _path$181;
var _path2$127;
var _path3$65;
function _extends$195() {
	return _extends$195 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$195.apply(null, arguments);
}
var SvgSpare = function SvgSpare(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$195({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$181 || (_path$181 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M7.48 3.459a.6.6 0 0 1-.22-.82l.242-.418A5.8 5.8 0 0 0 5.88 2.6v1.127a.6.6 0 1 1-1.2 0v-.483c-.457.32-.867.705-1.215 1.14l.563.976a.6.6 0 0 1-1.04.6l-.241-.42a5.8 5.8 0 0 0-.482 1.597l.975.563a.6.6 0 0 1-.6 1.04l-.418-.242c.048.568.179 1.113.379 1.623h1.127a.6.6 0 1 1 0 1.2h-.483c.32.457.705.867 1.14 1.215l.976-.563a.6.6 0 0 1 .6 1.04l-.42.241a5.8 5.8 0 0 0 1.597.482l.563-.975a.6.6 0 1 1 1.04.6l-.242.418a5.8 5.8 0 0 0 1.623-.379v-1.127a.6.6 0 0 1 1.2 0v.483c.457-.32.867-.705 1.215-1.14l-.563-.976a.6.6 0 1 1 1.04-.6l.241.42a5.8 5.8 0 0 0 .482-1.597l-.975-.563a.6.6 0 1 1 .6-1.04l.418.242A5.8 5.8 0 0 0 13.4 5.88h-1.127a.6.6 0 1 1 0-1.2h.483a5.8 5.8 0 0 0-1.14-1.215l-.976.563a.6.6 0 1 1-.6-1.04l.42-.241a5.8 5.8 0 0 0-1.597-.482l-.563.975a.6.6 0 0 1-.82.22M11.6 8a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0",
		clipRule: "evenodd",
		opacity: .25
	})), _path2$127 || (_path2$127 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M11.6 8a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0M8 10.4a2.4 2.4 0 1 0 0-4.8 2.4 2.4 0 0 0 0 4.8",
		clipRule: "evenodd"
	})), _path3$65 || (_path3$65 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0M7.48 3.459a.6.6 0 0 1-.22-.82l.242-.418A5.8 5.8 0 0 0 5.88 2.6v1.127a.6.6 0 1 1-1.2 0v-.483c-.457.32-.867.705-1.215 1.14l.563.976a.6.6 0 1 1-1.04.6l-.241-.42a5.8 5.8 0 0 0-.482 1.597l.975.563a.6.6 0 1 1-.6 1.04l-.418-.242c.048.568.179 1.113.379 1.623h1.127a.6.6 0 1 1 0 1.2h-.483c.32.457.705.867 1.14 1.215l.976-.563a.6.6 0 0 1 .6 1.04l-.42.241a5.8 5.8 0 0 0 1.597.482l.563-.975a.6.6 0 1 1 1.04.6l-.242.418a5.8 5.8 0 0 0 1.623-.379v-1.127a.6.6 0 0 1 1.2 0v.483c.457-.32.867-.705 1.215-1.14l-.563-.976a.6.6 0 1 1 1.04-.6l.241.42a5.8 5.8 0 0 0 .482-1.597l-.975-.563a.6.6 0 1 1 .6-1.04l.418.242A5.8 5.8 0 0 0 13.4 5.88h-1.127a.6.6 0 0 1 0-1.2h.483a5.8 5.8 0 0 0-1.14-1.215l-.976.563a.6.6 0 1 1-.6-1.04l.42-.241a5.8 5.8 0 0 0-1.597-.482l-.563.975a.6.6 0 0 1-.82.22M11.6 8a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0M8 10.4a2.4 2.4 0 1 0 0-4.8 2.4 2.4 0 0 0 0 4.8",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Speaker.svg
var _path$180;
var _path2$126;
function _extends$194() {
	return _extends$194 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$194.apply(null, arguments);
}
var SvgSpeaker = function SvgSpeaker(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$194({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$180 || (_path$180 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M5.712 1.1h4.576A2.82 2.82 0 0 1 13.1 3.925v8.15c0 1.56-1.26 2.825-2.812 2.825H5.712A2.82 2.82 0 0 1 2.9 12.075v-8.15C2.9 2.365 4.16 1.1 5.712 1.1m0 1.263c-.86 0-1.556.7-1.556 1.562v8.15a1.56 1.56 0 0 0 1.556 1.562h4.576c.86 0 1.556-.7 1.556-1.562v-8.15a1.56 1.56 0 0 0-1.556-1.562z",
		clipRule: "evenodd"
	})), _path2$126 || (_path2$126 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M10.2 9.7a2.2 2.2 0 1 1-4.4 0 2.2 2.2 0 0 1 4.4 0M8.9 5.1a.9.9 0 1 1-1.8 0 .9.9 0 0 1 1.8 0"
	})));
};

//#endregion
//#region src/Icon/icons/SpeedTest.svg
var _path$179;
var _path2$125;
function _extends$193() {
	return _extends$193 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$193.apply(null, arguments);
}
var SvgSpeedTest = function SvgSpeedTest(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$193({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$179 || (_path$179 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M8 4.145a5.466 5.466 0 0 0-5.446 4.997.605.605 0 0 0 .613.648c.354 0 .621-.285.655-.614a4.2 4.2 0 0 1 6.264-3.211l1.203-.72A5.44 5.44 0 0 0 8 4.145M12.242 9.406l.931-1.564q.213.623.273 1.3a.605.605 0 0 1-.613.648.66.66 0 0 1-.591-.384M12.13 5.973c.377-.225.806.202.581.58l-3.154 5.294v-.002a1.933 1.933 0 1 1-2.74-2.675l.001-.001q.078-.06.16-.112z"
	})), _path2$125 || (_path2$125 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M12.465 14.684H3.598l-.181-.018-.036-.005a1.92 1.92 0 0 1-1.225-.72 7.4 7.4 0 1 1 11.688 0 1.92 1.92 0 0 1-1.225.72h-.006zm-8.89-1.277a.65.65 0 0 1-.418-.246 6.131 6.131 0 1 1 9.685 0 .65.65 0 0 1-.417.246l-.054.008H3.659z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/SpeedTestHigh.svg
var _path$178;
var _path2$124;
var _path3$64;
function _extends$192() {
	return _extends$192 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$192.apply(null, arguments);
}
var SvgSpeedTestHigh = function SvgSpeedTestHigh(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$192({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$178 || (_path$178 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M8.001 4.469c1.048 0 2.019.328 2.817.885L6.354 8.027l-.008.006-.01.006q-.136.084-.26.18l-.004.004a3.13 3.13 0 0 0-.82 3.992H4.159a.38.38 0 0 1-.324-.174 4.933 4.933 0 0 1 4.166-7.572",
		opacity: .5
	})), _path2$124 || (_path2$124 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "m9.55 11.847 3.154-5.295c.225-.377-.204-.805-.58-.579L6.972 9.057a2 2 0 0 0-.16.112l-.003.002a1.933 1.933 0 1 0 2.74 2.675z"
	})), _path3$64 || (_path3$64 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "m3.38 14.66.037.006.18.018h8.868l.148-.022.006-.001a1.92 1.92 0 0 0 1.225-.72 7.4 7.4 0 1 0-11.688 0c.318.408.762.648 1.225.72m-.223-1.499a.65.65 0 0 0 .418.246l.084.008h8.712l.054-.008a.65.65 0 0 0 .417-.246 6.131 6.131 0 1 0-9.685 0",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/SpeedTestLow.svg
var _path$177;
var _path2$123;
var _path3$63;
function _extends$191() {
	return _extends$191 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$191.apply(null, arguments);
}
var SvgSpeedTestLow = function SvgSpeedTestLow(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$191({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$177 || (_path$177 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M5.27 12.215H4.16a.38.38 0 0 1-.325-.174 4.9 4.9 0 0 1-.705-3.417z",
		opacity: .5
	})), _path2$123 || (_path2$123 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M6.446 11.847 3.292 6.552c-.225-.377.204-.805.58-.579l5.153 3.084q.083.052.16.112l.003.002a1.933 1.933 0 1 1-2.74 2.675z"
	})), _path3$63 || (_path3$63 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "m3.38 14.66.037.006.18.018h8.868l.148-.022.006-.001a1.92 1.92 0 0 0 1.225-.72 7.4 7.4 0 1 0-11.688 0c.318.408.762.648 1.225.72m-.223-1.499a.65.65 0 0 0 .418.246l.084.008h8.712l.054-.008a.65.65 0 0 0 .417-.246 6.131 6.131 0 1 0-9.685 0",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/SpeedTestMedium.svg
var _path$176;
var _path2$122;
var _path3$62;
function _extends$190() {
	return _extends$190 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$190.apply(null, arguments);
}
var SvgSpeedTestMedium = function SvgSpeedTestMedium(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$190({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$176 || (_path$176 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "m4.954 9.936-.006.021-.031.155-.024.157v.004h-.001c-.083.66.046 1.345.386 1.942H4.16a.38.38 0 0 1-.324-.174 4.933 4.933 0 0 1 2.41-7.25z",
		opacity: .5
	})), _path2$122 || (_path2$122 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "m6.087 10.403 1.514-5.974c.108-.425.713-.425.82.001l1.462 5.824q.022.096.034.193v.003a1.933 1.933 0 1 1-3.83-.047"
	})), _path3$62 || (_path3$62 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "m3.38 14.66.037.006.18.018h8.868l.148-.022.006-.001a1.92 1.92 0 0 0 1.225-.72 7.4 7.4 0 1 0-11.688 0c.318.408.762.648 1.225.72m-.223-1.499a.65.65 0 0 0 .418.246l.084.008h8.712l.054-.008a.65.65 0 0 0 .417-.246 6.131 6.131 0 1 0-9.685 0",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Spotlight.svg
var _path$175;
var _path2$121;
function _extends$189() {
	return _extends$189 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$189.apply(null, arguments);
}
var SvgSpotlight = function SvgSpotlight(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$189({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$175 || (_path$175 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M2.744 3.08c-.07-.375.37-.63.653-.374C5.095 4.24 8.882 7.681 11.24 9.984c-.719-.113-1.53-.175-2.375-.175-1.29 0-2.502.14-3.428.393-.444.122-.89.287-1.254.517z",
		opacity: .25
	})), _path2$121 || (_path2$121 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M1.565 3.303C1.3 1.897 2.92.822 4.091 1.722l.11.094L6.83 4.203c1.048.96 2.205 2.028 3.283 3.041a111 111 0 0 1 2.825 2.732c.356.36.664.687.893.952.28.24.59.622.628 1.17a1.2 1.2 0 0 1 0 .231 2 2 0 0 1-.02.164c-.115.63-.594 1.014-.87 1.192-.369.238-.823.406-1.277.53-.926.252-2.137.394-3.427.394s-2.501-.142-3.427-.394q-.12-.035-.238-.072a6 6 0 0 1-.434-.15 3.6 3.6 0 0 1-.606-.308c-.296-.191-.826-.619-.89-1.333zm7.299 7.705c-.592 0-1.156.032-1.672.09q-.219.024-.426.056c-.785.116-1.424.297-1.829.515-.302.163-.473.345-.473.54a.34.34 0 0 0 .053.186l.016.026.022.03a1 1 0 0 0 .091.099q.11.1.277.191l.03.017q.07.036.147.07.023.012.05.023a4 4 0 0 0 .647.217q.376.1.83.173l.111.017q.466.07.99.109l.155.01q.26.016.53.026l.451.006c.916 0 1.766-.078 2.47-.209l.12-.023q.147-.03.283-.061l.124-.03a6 6 0 0 0 .548-.168l.076-.03q.07-.027.134-.056l.056-.025q.083-.04.155-.08.029-.017.054-.033.057-.035.105-.07l.031-.024a1 1 0 0 0 .107-.095 1 1 0 0 0 .056-.07l.011-.017a1 1 0 0 0 .037-.066l.003-.008a.4.4 0 0 0 .024-.073l.005-.062c0-.446-.893-.835-2.218-1.042l-.109-.016a13 13 0 0 0-.938-.102l-.2-.013-.324-.015q-.08-.004-.16-.007zM3.398 2.706c-.283-.256-.723-.001-.653.374l1.437 7.638c.365-.23.81-.395 1.254-.517.926-.252 2.138-.393 3.428-.393.841 0 1.648.061 2.365.173C8.88 7.653 5.19 4.322 3.4 2.706",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/SSID.svg
var _g$25;
var _path$174;
function _extends$188() {
	return _extends$188 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$188.apply(null, arguments);
}
var SvgSsid = function SvgSsid(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$188({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$25 || (_g$25 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M12.398 11.933H3.602A5.89 5.89 0 0 0 8 13.9c1.747 0 3.317-.76 4.398-1.967M12.398 4.067H3.602A5.89 5.89 0 0 1 8 2.1c1.747 0 3.317.76 4.398 1.967" }))), _path$174 || (_path$174 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M4 4a3 3 0 0 0-3 3v2a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3zm9.8 3A1.8 1.8 0 0 0 12 5.2h-1.448a1.5 1.5 0 0 0-1.437 1.07l-.381 1.275a4 4 0 0 1-3.271 2.815l-.151.021c-.253.046-.22.419.037.419H12A1.8 1.8 0 0 0 13.8 9z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/SSIDThreat.svg
var _g$24;
var _path$173;
function _extends$187() {
	return _extends$187 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$187.apply(null, arguments);
}
var SvgSsidThreat = function SvgSsidThreat(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$187({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$24 || (_g$24 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M8 2.1c-1.747 0-3.317.76-4.398 1.967h8.796A5.89 5.89 0 0 0 8 2.1M6.108 13.59a5.9 5.9 0 0 1-2.506-1.657h3.47z" }), /*#__PURE__*/ React.createElement("path", {
		fillRule: "evenodd",
		d: "M6.993 14.455 10.43 8.55c.227-.39.642-.551 1-.551.357 0 .772.16.999.55l3.436 5.905a.98.98 0 0 1-.055 1.078c-.209.29-.559.467-.944.467H7.993c-.386 0-.736-.176-.945-.467a.98.98 0 0 1-.055-1.078",
		clipRule: "evenodd"
	}))), _path$173 || (_path$173 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M1 7a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v2c0 .417-.085.814-.239 1.175L13.8 8.523V7A1.8 1.8 0 0 0 12 5.2h-1.448a1.5 1.5 0 0 0-1.437 1.07l-.381 1.275a4 4 0 0 1-3.271 2.815l-.151.021c-.253.046-.22.419.037.419h2.383L7.034 12H4a3 3 0 0 1-3-3z"
	})));
};

//#endregion
//#region src/Icon/icons/Stamp.svg
var _path$172;
var _path2$120;
var _path3$61;
function _extends$186() {
	return _extends$186 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$186.apply(null, arguments);
}
var SvgStamp = function SvgStamp(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$186({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$172 || (_path$172 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M13.342 6.24c.11.32.083.687-.12 1l-.09.136c-.246.38-.246.87 0 1.249l.09.135.065.116a1.146 1.146 0 0 1-.617 1.578l-.15.058c-.423.163-.71.558-.734 1.01l-.008.16-.014.135a1.147 1.147 0 0 1-1.428.913l-.155-.042a1.15 1.15 0 0 0-1.19.387l-.1.125-.091.1a1.145 1.145 0 0 1-1.69-.1l-.101-.125a1.15 1.15 0 0 0-1.19-.387l-.154.042-.132.028a1.147 1.147 0 0 1-1.31-1.075l-.008-.16a1.15 1.15 0 0 0-.735-1.01l-.15-.06a1.145 1.145 0 0 1-.584-1.637c.1.252.251.49.455.694l2.185 2.184c.4.4.925.598 1.447.6v.002l.017-.001h.018v-.001a2.05 2.05 0 0 0 1.447-.6l4.483-4.482c.277-.278.458-.616.544-.972",
		opacity: .25
	})), _path2$120 || (_path2$120 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M6.239 1.717a2.52 2.52 0 0 1 3.522 0l.2.22.006.007.012-.002.289-.06c1.35-.2 2.624.724 2.85 2.07l.033.294v.01l.01.006a2.52 2.52 0 0 1 1.211 3.729L14.366 8l.006.009a2.522 2.522 0 0 1-1.21 3.73l-.011.003v.013a2.52 2.52 0 0 1-3.172 2.303l-.012-.003-.007.01a2.52 2.52 0 0 1-3.92 0l-.008-.01-.01.003a2.52 2.52 0 0 1-3.173-2.303l-.001-.013-.01-.003a2.522 2.522 0 0 1-1.21-3.73l.006-.01-.007-.008a2.52 2.52 0 0 1 1.211-3.73l.01-.004v-.011a2.52 2.52 0 0 1 2.884-2.364l.29.06.01.002.007-.008zM8.89 2.8a1.145 1.145 0 0 0-1.781 0l-.102.125-.115.122a1.15 1.15 0 0 1-.908.295l-.166-.032-.155-.04a1.146 1.146 0 0 0-1.442 1.046l-.008.16-.02.167c-.077.381-.343.702-.713.844l-.15.058a1.146 1.146 0 0 0-.552 1.694l.088.136c.247.38.247.87 0 1.249l-.088.135a1.146 1.146 0 0 0 .551 1.694l.15.058c.423.163.71.558.734 1.01l.008.16a1.147 1.147 0 0 0 1.31 1.076l.132-.028.155-.042c.437-.117.904.035 1.19.387l.1.125c.43.531 1.217.565 1.691.1l.09-.1.102-.125a1.15 1.15 0 0 1 1.189-.387l.154.042a1.146 1.146 0 0 0 1.428-.913l.015-.135.008-.16c.023-.452.311-.847.734-1.01l.15-.058c.638-.245.914-.983.617-1.578l-.066-.116-.088-.135a1.15 1.15 0 0 1 0-1.25l.088-.135a1.14 1.14 0 0 0 .121-1 2.05 2.05 0 0 0-.402-1.777l-.142-.157-.155-.14a2.05 2.05 0 0 0-1.071-.448 1.15 1.15 0 0 0-1.237-.448l-.154.041-.166.032a1.15 1.15 0 0 1-.908-.295l-.115-.122z",
		clipRule: "evenodd"
	})), _path3$61 || (_path3$61 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "m11.95 6.363-4.482 4.482a.85.85 0 0 1-.617.25.85.85 0 0 1-.617-.25L4.05 8.661a.854.854 0 0 1 1.208-1.208l1.593 1.593 3.89-3.891a.854.854 0 1 1 1.209 1.208",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Star.svg
var _path$171;
function _extends$185() {
	return _extends$185 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$185.apply(null, arguments);
}
var SvgStar = function SvgStar(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$185({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$171 || (_path$171 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M6.489 2.154c.623-1.227 2.398-1.227 3.022 0l.059.127 1.08 2.6 2.81.226c1.507.122 2.118 2.002.97 2.986l-2.14 1.833.654 2.74c.35 1.47-1.249 2.633-2.54 1.846L8 13.043l-2.403 1.469c-1.29.788-2.89-.375-2.54-1.846l.653-2.74-2.14-1.833c-1.147-.984-.536-2.865.971-2.986l2.808-.225 1.082-2.6zm1.972.588a.5.5 0 0 0-.923 0L6.292 5.738l-.03.062a.5.5 0 0 1-.391.244l-3.235.26a.5.5 0 0 0-.285.878l2.464 2.111a.5.5 0 0 1 .161.495l-.753 3.156a.5.5 0 0 0 .747.543l2.77-1.691a.5.5 0 0 1 .52 0l2.77 1.691a.5.5 0 0 0 .747-.543l-.753-3.156a.5.5 0 0 1 .161-.495l2.464-2.111a.5.5 0 0 0-.205-.866l-.08-.012-3.235-.26a.5.5 0 0 1-.39-.244l-.032-.062z"
	})));
};

//#endregion
//#region src/Icon/icons/StarCrossed.svg
var _path$170;
function _extends$184() {
	return _extends$184 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$184.apply(null, arguments);
}
var SvgStarCrossed = function SvgStarCrossed(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$184({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$170 || (_path$170 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M13.8 5.168c1.253.353 1.687 2.018.63 2.924l-2.14 1.833.654 2.74c.351 1.471-1.248 2.634-2.539 1.846L8 13.043 5.597 14.51c-.51.311-1.067.318-1.534.122a2.1 2.1 0 0 0 .755-.481l1.469-1.47 1.453-.887a.5.5 0 0 1 .52 0l2.77 1.692a.5.5 0 0 0 .747-.543l-.753-3.156a.5.5 0 0 1 .162-.495l2.463-2.112a.5.5 0 0 0-.205-.865l-.08-.013-.645-.052zM6.49 2.154c.623-1.227 2.398-1.227 3.022 0l.058.127.346.833-.918.918-.536-1.29a.5.5 0 0 0-.923 0L6.293 5.738l-.031.061a.5.5 0 0 1-.391.244l-3.234.26a.5.5 0 0 0-.286.878l1.884 1.613-.851.852L1.57 8.092c-1.148-.984-.536-2.864.97-2.985l2.809-.226 1.082-2.6zM2.697 13.303a.9.9 0 0 1 0-1.273l9.334-9.333a.9.9 0 0 1 1.272 1.273L3.97 13.303a.9.9 0 0 1-1.273 0"
	})));
};

//#endregion
//#region src/Icon/icons/StarFilled.svg
var _path$169;
var _path2$119;
function _extends$183() {
	return _extends$183 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$183.apply(null, arguments);
}
var SvgStarFilled = function SvgStarFilled(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$183({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$169 || (_path$169 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M8.461 2.742a.5.5 0 0 0-.923 0L6.292 5.738l-.03.062a.5.5 0 0 1-.391.244l-3.235.26a.5.5 0 0 0-.285.878l2.464 2.111a.5.5 0 0 1 .161.495l-.753 3.156a.5.5 0 0 0 .747.543l2.77-1.691a.5.5 0 0 1 .52 0l2.77 1.691a.5.5 0 0 0 .747-.543l-.753-3.156a.5.5 0 0 1 .161-.495l2.464-2.111a.5.5 0 0 0-.205-.866l-.08-.012-3.235-.26a.5.5 0 0 1-.39-.244l-.032-.062z",
		opacity: .25
	})), _path2$119 || (_path2$119 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M6.489 2.154c.623-1.227 2.398-1.227 3.022 0l.059.127 1.08 2.6 2.81.226c1.507.122 2.118 2.002.97 2.986l-2.14 1.833.654 2.74c.35 1.47-1.249 2.633-2.54 1.846L8 13.043l-2.403 1.469c-1.29.788-2.89-.375-2.54-1.846l.653-2.74-2.14-1.833c-1.147-.984-.536-2.865.971-2.986l2.808-.225 1.082-2.6zm1.972.588a.5.5 0 0 0-.923 0L6.292 5.738l-.03.062a.5.5 0 0 1-.391.244l-3.235.26a.5.5 0 0 0-.285.878l2.464 2.111a.5.5 0 0 1 .161.495l-.753 3.156a.5.5 0 0 0 .747.543l2.77-1.691a.5.5 0 0 1 .52 0l2.77 1.691a.5.5 0 0 0 .747-.543l-.753-3.156a.5.5 0 0 1 .161-.495l2.464-2.111a.5.5 0 0 0-.205-.866l-.08-.012-3.235-.26a.5.5 0 0 1-.39-.244l-.032-.062z"
	})));
};

//#endregion
//#region src/Icon/icons/Stop.svg
var _path$168;
var _path2$118;
var _path3$60;
function _extends$182() {
	return _extends$182 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$182.apply(null, arguments);
}
var SvgStop = function SvgStop(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$182({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$168 || (_path$168 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M5.473 2.97a1.2 1.2 0 0 1 .851-.343l3.445.03a1.2 1.2 0 0 1 .846.359l2.414 2.457a1.2 1.2 0 0 1 .344.851l-.03 3.445a1.2 1.2 0 0 1-.359.846l-2.457 2.414a1.2 1.2 0 0 1-.851.344l-3.445-.03a1.2 1.2 0 0 1-.846-.358l-2.414-2.458a1.2 1.2 0 0 1-.344-.851l.03-3.445a1.2 1.2 0 0 1 .359-.846zm5.248 7.75c.104-.105.185-.261.248-.45.064-.19.11-.416.144-.662.069-.491.087-1.068.087-1.608s-.018-1.117-.087-1.608a4 4 0 0 0-.144-.661 1.15 1.15 0 0 0-.248-.45c-.105-.105-.274-.186-.478-.25a4.4 4.4 0 0 0-.706-.144A12 12 0 0 0 8.009 4.8c-.438 0-1.012.018-1.527.087-.258.034-.502.08-.706.144s-.373.145-.478.25a1.2 1.2 0 0 0-.252.45c-.065.189-.114.414-.15.66A11.5 11.5 0 0 0 4.8 8c0 .54.023 1.117.096 1.609.036.246.085.471.15.66.066.19.148.346.252.45s.274.187.478.25a4.4 4.4 0 0 0 .706.144c.515.069 1.09.087 1.527.087.438 0 1.013-.018 1.528-.087a4.4 4.4 0 0 0 .706-.144c.204-.063.373-.145.478-.25",
		clipRule: "evenodd",
		opacity: .25
	})), _path2$118 || (_path2$118 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "m6.335 1.427 3.445.03a2.4 2.4 0 0 1 1.69.718l2.415 2.457a2.4 2.4 0 0 1 .688 1.703l-.03 3.445a2.4 2.4 0 0 1-.717 1.69l-2.458 2.415a2.4 2.4 0 0 1-1.703.688l-3.445-.03a2.4 2.4 0 0 1-1.69-.717l-2.415-2.458a2.4 2.4 0 0 1-.688-1.703l.03-3.445a2.4 2.4 0 0 1 .718-1.69l2.457-2.415a2.4 2.4 0 0 1 1.703-.688m-.01 1.2a1.2 1.2 0 0 0-.852.344L3.016 5.385a1.2 1.2 0 0 0-.36.846l-.03 3.445a1.2 1.2 0 0 0 .345.851l2.414 2.458a1.2 1.2 0 0 0 .846.358l3.445.03a1.2 1.2 0 0 0 .851-.344l2.457-2.414a1.2 1.2 0 0 0 .36-.846l.03-3.445a1.2 1.2 0 0 0-.345-.851l-2.414-2.457a1.2 1.2 0 0 0-.846-.36z",
		clipRule: "evenodd"
	})), _path3$60 || (_path3$60 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M9.856 9.418A.7.7 0 0 1 9.7 9.7a.7.7 0 0 1-.298.155c-.128.04-.28.07-.441.09a8 8 0 0 1-.955.055c-.274 0-.633-.012-.955-.054a3 3 0 0 1-.441-.09.7.7 0 0 1-.299-.156.7.7 0 0 1-.157-.281 2.4 2.4 0 0 1-.094-.413A7 7 0 0 1 6 8c0-.338.014-.698.06-1.005.023-.154.053-.295.094-.413a.7.7 0 0 1 .157-.282.7.7 0 0 1 .299-.155c.128-.04.28-.07.441-.09.322-.043.681-.055.955-.055s.633.012.955.054c.16.022.313.05.44.09.128.04.234.09.3.156a.7.7 0 0 1 .155.282c.04.118.069.26.09.413.043.307.054.667.054 1.005s-.011.698-.054 1.005c-.021.154-.05.295-.09.413"
	})));
};

//#endregion
//#region src/Icon/icons/Sun.svg
var _path$167;
var _path2$117;
var _path3$59;
function _extends$181() {
	return _extends$181 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$181.apply(null, arguments);
}
var SvgSun = function SvgSun(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$181({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$167 || (_path$167 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M11.737 6.279a4.116 4.116 0 1 1-7.758 2.593 5.483 5.483 0 0 0 7.758-2.593",
		opacity: .25
	})), _path2$117 || (_path2$117 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M8.686 15.314a.686.686 0 1 1-1.372 0 .686.686 0 0 1 1.372 0M8.686.686a.686.686 0 1 1-1.372 0 .686.686 0 0 1 1.372 0M15.314 7.314a.686.686 0 1 1 0 1.372.686.686 0 0 1 0-1.372M.686 7.314a.686.686 0 1 1 0 1.372.686.686 0 0 1 0-1.372M13.657 12.687a.686.686 0 1 1-.97.97.686.686 0 0 1 .97-.97M3.313 2.343a.686.686 0 1 1-.97.97.686.686 0 0 1 .97-.97M12.687 2.343a.686.686 0 1 1 .97.97.686.686 0 0 1-.97-.97M2.343 12.687a.686.686 0 1 1 .97.97.686.686 0 0 1-.97-.97"
	})), _path3$59 || (_path3$59 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8 13.485a5.486 5.486 0 1 1 0-10.97 5.486 5.486 0 0 1 0 10.97m0-9.599a4.115 4.115 0 1 1 0 8.23 4.115 4.115 0 0 1 0-8.23",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Switch.svg
var _path$166;
var _path2$116;
var _path3$58;
function _extends$180() {
	return _extends$180 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$180.apply(null, arguments);
}
var SvgSwitch = function SvgSwitch(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$180({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$166 || (_path$166 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M13.166 2.835c.043.043.147.189.26.528.11.324.2.744.27 1.245.139 1.004.179 2.214.179 3.392s-.04 2.388-.18 3.392a7 7 0 0 1-.268 1.245c-.114.339-.218.485-.261.528a.7.7 0 0 1-.143.089c-.089.045-.224.103-.42.164-.363.113-.83.205-1.363.275-1.064.142-2.276.182-3.22.182-.943 0-2.155-.04-3.22-.182-.533-.07-.999-.162-1.362-.275a3 3 0 0 1-.42-.164.7.7 0 0 1-.143-.089l-.019-.022 1.47-1.47.89 1.022a1.686 1.686 0 0 0 2.56 0 1.85 1.85 0 0 0 .399-1.624c.365-.053.667-.215.9-.44a1.68 1.68 0 0 0 1.708-.53l1.893-2.17-.002-.001c.303-.337.468-.776.468-1.227s-.165-.89-.47-1.227l.003-.001-1.002-1.15 1.492-1.491z",
		opacity: .25
	})), _path2$116 || (_path2$116 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M7.915 8.7c.298 0 .527.276.527.597s-.229.596-.527.596H5.847l1.025 1.176a.65.65 0 0 1 0 .837.486.486 0 0 1-.751 0l-1.892-2.17a.63.63 0 0 1-.171-.44c0-.172.065-.329.17-.439l1.893-2.17a.486.486 0 0 1 .751 0 .65.65 0 0 1 0 .838L5.847 8.7zM8.086 7.3c-.3 0-.528-.276-.528-.597s.229-.596.528-.596h2.067L9.128 4.93a.65.65 0 0 1 0-.838.486.486 0 0 1 .751 0l1.892 2.17c.106.11.171.267.171.44s-.065.33-.17.44l-1.893 2.17a.486.486 0 0 1-.751 0 .65.65 0 0 1 0-.838L10.153 7.3z"
	})), _path3$58 || (_path3$58 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M14.015 14.012c.23-.231.41-.576.55-.995s.243-.917.319-1.46c.15-1.088.191-2.362.191-3.557s-.04-2.47-.191-3.556a8.3 8.3 0 0 0-.32-1.461c-.14-.419-.318-.764-.549-.995-.232-.233-.606-.412-1.056-.552a10 10 0 0 0-1.561-.319C10.258.966 8.988.925 8.02.925s-2.238.04-3.377.192a10 10 0 0 0-1.561.32c-.45.14-.825.318-1.057.55-.23.232-.411.577-.555.995a8.3 8.3 0 0 0-.333 1.461C.976 5.53.925 6.805.925 8s.05 2.47.212 3.557a8.3 8.3 0 0 0 .333 1.461c.144.418.325.763.555.994.232.233.606.412 1.057.552.453.14.991.243 1.56.319 1.14.151 2.41.192 3.378.192s2.239-.04 3.378-.192a10 10 0 0 0 1.56-.32c.451-.14.825-.318 1.057-.55M2.875 2.835c-.046.046-.153.196-.27.537a7 7 0 0 0-.281 1.247C2.175 5.62 2.125 6.829 2.125 8s.05 2.379.199 3.381c.074.501.169.922.28 1.247.118.34.225.49.271.537.01.01.052.043.142.089.09.045.225.103.42.164.364.112.83.205 1.364.275 1.064.142 2.275.182 3.22.182.943 0 2.155-.04 3.22-.182.533-.07.998-.163 1.362-.275a3 3 0 0 0 .42-.164.7.7 0 0 0 .143-.09c.042-.042.147-.188.26-.527.109-.324.2-.744.269-1.246.14-1.004.18-2.213.18-3.391s-.04-2.387-.18-3.391a7 7 0 0 0-.268-1.246c-.114-.34-.219-.485-.261-.528a.7.7 0 0 0-.143-.089 3 3 0 0 0-.42-.164 8.6 8.6 0 0 0-1.363-.275c-1.064-.142-2.276-.182-3.22-.182s-2.155.04-3.22.182c-.533.07-.999.163-1.362.275-.196.061-.331.119-.42.164a.7.7 0 0 0-.143.09",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Table.svg
var _path$165;
var _path2$115;
function _extends$179() {
	return _extends$179 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$179.apply(null, arguments);
}
var SvgTable = function SvgTable(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$179({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$165 || (_path$165 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M3.2 3.2a1 1 0 0 0-1 1v1.2h2.2V3.2zm10.6 1a1 1 0 0 0-1-1H5.6v2.2h8.2zM4.4 6.6v6.2H3.2a1 1 0 0 1-.996-.914L2.2 6.6z",
		clipRule: "evenodd",
		opacity: .25
	})), _path2$115 || (_path2$115 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M12.8 2H3.2A2.2 2.2 0 0 0 1 4.2v7.6A2.2 2.2 0 0 0 3.2 14h9.6a2.2 2.2 0 0 0 2.2-2.2V4.2A2.2 2.2 0 0 0 12.8 2M3.2 3.2a1 1 0 0 0-1 1v1.2h2.2V3.2zm9.6 9.6a1 1 0 0 0 1-1V6.6H5.6v6.2zm1-8.6a1 1 0 0 0-1-1H5.6v2.2h8.2zM4.4 6.6v6.2H3.2a1 1 0 0 1-.996-.913L2.2 6.6z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Tag.svg
var _path$164;
var _path2$114;
function _extends$178() {
	return _extends$178 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$178.apply(null, arguments);
}
var SvgTag = function SvgTag(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$178({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$164 || (_path$164 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "m14.172 10.07-4.102 4.102a1.8 1.8 0 0 1-2.545 0L2.428 9.075a3.2 3.2 0 0 1-.932-2.083l-.192-3.39a2.177 2.177 0 0 1 2.297-2.297l3.391.19a3.2 3.2 0 0 1 2.083.933l5.097 5.097a1.8 1.8 0 0 1 0 2.545m-4.95 3.253a.6.6 0 0 1-.849 0L3.276 8.226a2 2 0 0 1-.582-1.301l-.191-3.391a.977.977 0 0 1 1.03-1.031l3.392.19a2 2 0 0 1 1.301.583l5.097 5.097a.6.6 0 0 1 0 .849z",
		clipRule: "evenodd"
	})), _path2$114 || (_path2$114 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M4.06 5.757A1.2 1.2 0 1 1 5.757 4.06 1.2 1.2 0 0 1 4.06 5.757"
	})));
};

//#endregion
//#region src/Icon/icons/Tasks.svg
var _g$23;
var _path$163;
var _path2$113;
var _path3$57;
function _extends$177() {
	return _extends$177 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$177.apply(null, arguments);
}
var SvgTasks = function SvgTasks(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$177({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$23 || (_g$23 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M13.48 5.209a.4.4 0 0 1 .32.393v7.797l-.008.08a.4.4 0 0 1-.312.312l-.08.008H4.776l.608-.608.002.002c.4.4.926.599 1.447.6v.002l.018-.001h.017v-.001a2.05 2.05 0 0 0 1.447-.6l4.483-4.482c.752-.752.8-1.942.142-2.75l-.142-.155-.015-.014.591-.59h.026zM11.857 0C12.49 0 13 .513 13 1.145v.907A1.4 1.4 0 0 0 12.629 2h-.486v-.855a.29.29 0 0 0-.228-.282l-.058-.005H4.144l-.059.005a.29.29 0 0 0-.228.282V2h-.485A1.4 1.4 0 0 0 3 2.052v-.907C3 .513 3.512 0 4.144 0z" }))), _path$163 || (_path$163 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M12.629 2c.757 0 1.37.615 1.371 1.373v.744A1.6 1.6 0 0 0 13.4 4h-.428v-.627a.344.344 0 0 0-.275-.337l-.068-.007H3.372l-.07.007a.345.345 0 0 0-.274.337V4h-.427c-.213 0-.415.042-.601.117v-.744C2 2.615 2.615 2 3.372 2z",
		opacity: .5
	})), _path2$113 || (_path2$113 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "m11.95 7.863-4.482 4.482a.85.85 0 0 1-.617.25.85.85 0 0 1-.617-.25L4.05 10.161a.854.854 0 1 1 1.208-1.208l1.593 1.593 3.891-3.891a.854.854 0 1 1 1.208 1.208",
		clipRule: "evenodd"
	})), _path3$57 || (_path3$57 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M13.4 4c.884 0 1.6.718 1.6 1.602v7.797A1.6 1.6 0 0 1 13.4 15H2.6c-.883 0-1.6-.717-1.6-1.601V5.602C1 4.718 1.717 4 2.6 4zM2.52 13.79a.4.4 0 0 1-.312-.31l-.008-.081V5.602c0-.193.137-.356.32-.393l.08-.008h10.8l.08.008a.4.4 0 0 1 .32.393v7.797l-.008.08a.4.4 0 0 1-.312.312l-.08.008H2.6z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Template.svg
var _g$22;
var _g2$2;
var _path$162;
function _extends$176() {
	return _extends$176 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$176.apply(null, arguments);
}
var SvgTemplate = function SvgTemplate(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$176({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$22 || (_g$22 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M3.249 9.362c.127.116.281.207.457.26q.25.076.522.078h.221q.094-.001.184-.016-.035.14-.036.29v.236q0 .271.077.522c.063.21.18.388.329.528-.121.113-.22.252-.287.412l-.041.115a1.8 1.8 0 0 0-.078.522v.13q.001.111.02.215-.02.105-.02.216V13h-1.72a.844.844 0 0 1-.853-.833V9.7h.046q.04-.001.077-.005.039.004.078.005h.046a1.8 1.8 0 0 0 .521-.077c.176-.053.33-.145.457-.26M6.396 11.71a.6.6 0 0 1 .601.6V13h-1.2v-.69a.6.6 0 0 1 .6-.6M12.65 9.362c.127.116.28.208.456.261q.251.076.522.077h.066q.055 0 .108-.007.054.006.108.007h.066v2.467c0 .46-.383.833-.854.833H8.197v-.13q0-.111-.021-.216.02-.105.021-.214v-.131a1.8 1.8 0 0 0-.078-.523 1.2 1.2 0 0 0-.329-.526c.15-.14.266-.317.33-.527q.076-.252.077-.523v-.236a1.2 1.2 0 0 0-.036-.286q.077.011.155.012h.221a1.8 1.8 0 0 0 .522-.077c.176-.053.33-.145.458-.26.127.115.28.207.457.26q.25.076.522.077h.22q.194 0 .367-.057a1.2 1.2 0 0 0 .367.057h.222q.271 0 .521-.077c.176-.053.329-.145.456-.26M6.396 8.35c.332 0 .601.269.601.6v1.26a.6.6 0 0 1-1.2 0V8.95a.6.6 0 0 1 .6-.6M2.27 7.3a.601.601 0 0 1 0 1.2h-.246V7.3zM5.404 7.3a.6.6 0 0 1 0 1.2H4.23a.6.6 0 0 1 0-1.2zM8.537 7.3a.601.601 0 0 1 0 1.2H7.362a.6.6 0 0 1 0-1.2zM11.67 7.3a.6.6 0 0 1 0 1.2h-1.174a.6.6 0 0 1 0-1.2zM13.976 7.3v1.2h-.347a.6.6 0 0 1 0-1.2zM6.396 4.99a.6.6 0 0 1 .601.6v1.26a.601.601 0 0 1-1.2 0V5.59a.6.6 0 0 1 .6-.6M4.597 3.092q0 .078.01.153-.01.075-.01.153v.092q0 .271.077.523c.058.19.16.356.29.489a1.8 1.8 0 0 0-.358.903l-.01.185v.236q.001.15.037.29a1 1 0 0 0-.184-.016h-.221q-.204 0-.397.045l-.126.033a1.2 1.2 0 0 0-.456.259 1.2 1.2 0 0 0-.34-.218l-.116-.041-.126-.034a1.8 1.8 0 0 0-.396-.044h-.046q-.039 0-.078.004Q2.11 6.1 2.07 6.1h-.046V3.833c0-.46.383-.833.854-.833h1.719zM13.122 3c.471 0 .853.373.854.833V6.1h-.066q-.054 0-.108.005a1 1 0 0 0-.108-.005h-.066q-.203 0-.396.044l-.127.034a1.2 1.2 0 0 0-.456.259 1.2 1.2 0 0 0-.34-.218l-.115-.041-.127-.034a1.8 1.8 0 0 0-.395-.044h-.222a1.2 1.2 0 0 0-.367.056 1.2 1.2 0 0 0-.366-.056h-.22q-.205 0-.397.044l-.127.034a1.2 1.2 0 0 0-.456.259 1.2 1.2 0 0 0-.341-.218l-.116-.041-.126-.034a1.8 1.8 0 0 0-.397-.044h-.22a1 1 0 0 0-.156.01 1.2 1.2 0 0 0 .036-.284V5.59c0-.41-.139-.786-.369-1.088.13-.133.233-.298.291-.488q.077-.252.078-.524v-.092a1 1 0 0 0-.011-.153 1 1 0 0 0 .011-.153V3zM6.997 3v.49a.6.6 0 0 1-1.2 0V3z" }))), _g2$2 || (_g2$2 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .5
	}, /*#__PURE__*/ React.createElement("path", { d: "M6.396 11.71a.6.6 0 0 1 .601.6V13h-1.2v-.69a.6.6 0 0 1 .6-.6M6.396 8.35c.332 0 .601.269.601.6v1.26a.6.6 0 0 1-1.2 0V8.95a.6.6 0 0 1 .6-.6M5.404 7.3a.6.6 0 0 1 0 1.2H4.23a.6.6 0 0 1 0-1.2zM8.537 7.3a.601.601 0 0 1 0 1.2H7.362a.6.6 0 0 1 0-1.2zM11.67 7.3a.6.6 0 0 1 0 1.2h-1.174a.6.6 0 0 1 0-1.2zM13.976 8.5h-.347a.6.6 0 0 1 0-1.2h.347zM2.27 7.3a.601.601 0 0 1 0 1.2h-.246V7.3zM6.396 4.99a.6.6 0 0 1 .601.6v1.26a.601.601 0 0 1-1.2 0V5.59a.6.6 0 0 1 .6-.6M6.997 3.49a.6.6 0 0 1-1.2 0V3h1.2z" }))), _path$162 || (_path$162 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M2.878 2h10.244C14.159 2 15 2.82 15 3.833v8.334C15 13.179 14.16 14 13.122 14H2.878C1.841 14 1 13.18 1 12.167V3.833C1 2.821 1.84 2 2.878 2m0 1a.844.844 0 0 0-.854.833v8.334c0 .46.383.833.854.833h10.244a.844.844 0 0 0 .854-.833V3.833A.844.844 0 0 0 13.122 3z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Test.svg
var _path$161;
var _path2$112;
var _path3$56;
function _extends$175() {
	return _extends$175 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$175.apply(null, arguments);
}
var SvgTest = function SvgTest(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$175({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$161 || (_path$161 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M3 5.7v5.6a1.4 1.4 0 1 0 2.8 0V6.7s-.769-1-1.4-.544C3.769 6.613 3 5.7 3 5.7",
		clipRule: "evenodd",
		opacity: .25
	})), _path2$112 || (_path2$112 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M10.2 7.7v3.6a1.4 1.4 0 1 0 2.8 0V6.7s-.484 1-1.4.456c-.916-.543-1.4.544-1.4.544",
		clipRule: "evenodd",
		opacity: .5
	})), _path3$56 || (_path3$56 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M4.4 13.9A2.6 2.6 0 0 0 7 11.3V3.675A.8.8 0 0 0 6.8 2.1H2a.8.8 0 0 0-.2 1.575V11.3a2.6 2.6 0 0 0 2.6 2.6M3 11.3a1.4 1.4 0 1 0 2.8 0V3.7H3zM11.6 13.9a2.6 2.6 0 0 0 2.6-2.6V3.675A.8.8 0 0 0 14 2.1H9.2A.8.8 0 0 0 9 3.675V11.3a2.6 2.6 0 0 0 2.6 2.6m-1.4-2.6a1.4 1.4 0 1 0 2.8 0V3.7h-2.8z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/ThumbsDown.svg
var _path$160;
var _path2$111;
var _path3$55;
function _extends$174() {
	return _extends$174 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$174.apply(null, arguments);
}
var SvgThumbsDown = function SvgThumbsDown(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$174({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$160 || (_path$160 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M13.442 7.927c.293-.412.434-.935.345-1.481l-.622-3.776a1 1 0 0 0-.986-.838H8.49a5 5 0 0 0-1.424.207l-2.35.7V3a8 8 0 0 1 8.727 4.926",
		opacity: .25
	})), _path2$111 || (_path2$111 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M2.487 2.63a.3.3 0 0 0-.294.238l-.006.06V8.33a.3.3 0 0 0 .3.3h.728l.06-.006a.3.3 0 0 0 .24-.294v-5.4l-.006-.06a.3.3 0 0 0-.233-.234l-.06-.006z",
		clipRule: "evenodd",
		opacity: .5
	})), _path3$55 || (_path3$55 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M11.813 9.97a3.2 3.2 0 0 0 3.157-3.72l-.62-3.774A2.2 2.2 0 0 0 12.18.632H8.49c-.599 0-1.194.087-1.768.258l-2.67.794a1.5 1.5 0 0 0-.837-.255h-.728a1.5 1.5 0 0 0-1.5 1.5v5.4a1.5 1.5 0 0 0 1.5 1.5h.728c.23 0 .446-.051.64-.143l2.723 4.803.112.17a1.737 1.737 0 0 0 2.392.397l.16-.127.144-.137a2.99 2.99 0 0 0 .798-2.694L9.748 9.97zm-2.8-1.2h2.8l.227-.013a2 2 0 0 0 1.747-2.311l-.622-3.776a1 1 0 0 0-.986-.838H8.49a5 5 0 0 0-1.424.207l-2.35.7v6.03l2.907 5.128a.536.536 0 0 0 .823.135c.476-.423.691-1.07.563-1.694L8.425 9.49a.6.6 0 0 1 .518-.716zM2.487 2.63a.3.3 0 0 0-.294.238l-.006.06V8.33a.3.3 0 0 0 .3.3h.728l.06-.006a.3.3 0 0 0 .24-.294v-5.4l-.006-.06a.3.3 0 0 0-.233-.234l-.06-.006z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/ThumbsUp.svg
var _path$159;
var _path2$110;
var _path3$54;
function _extends$173() {
	return _extends$173 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$173.apply(null, arguments);
}
var SvgThumbsUp = function SvgThumbsUp(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$173({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$159 || (_path$159 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M13.442 8.073c.293.412.434.935.345 1.482l-.622 3.775a1 1 0 0 1-.986.838H8.49c-.482 0-.962-.07-1.424-.207l-2.35-.7V13q.635.105 1.298.106a8 8 0 0 0 7.429-5.032",
		opacity: .25
	})), _path2$110 || (_path2$110 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M2.487 13.37a.3.3 0 0 1-.294-.238l-.006-.06V7.67a.3.3 0 0 1 .3-.3h.728l.06.006a.3.3 0 0 1 .24.294v5.4l-.006.06a.3.3 0 0 1-.233.234l-.06.006z",
		clipRule: "evenodd",
		opacity: .5
	})), _path3$54 || (_path3$54 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M11.813 6.03a3.2 3.2 0 0 1 3.157 3.72l-.62 3.774a2.2 2.2 0 0 1-2.17 1.844H8.49a6.2 6.2 0 0 1-1.768-.258l-2.67-.793c-.24.16-.527.254-.837.254h-.728a1.5 1.5 0 0 1-1.5-1.5v-5.4a1.5 1.5 0 0 1 1.5-1.5h.728c.23 0 .446.051.64.143l2.723-4.802.112-.171A1.737 1.737 0 0 1 9.082.944l.16.127.144.137c.695.706.998 1.715.798 2.694L9.748 6.03zm-2.8 1.2h2.8l.227.013a2 2 0 0 1 1.747 2.312l-.622 3.775a1 1 0 0 1-.986.838H8.49c-.482 0-.962-.07-1.424-.207l-2.35-.7v-6.03l2.907-5.128a.536.536 0 0 1 .823-.135c.476.423.691 1.07.563 1.694L8.425 6.51a.6.6 0 0 0 .518.716zm-6.526 6.14a.3.3 0 0 1-.294-.238l-.006-.06V7.67a.3.3 0 0 1 .3-.3h.728l.06.006a.3.3 0 0 1 .24.294v5.4l-.006.06a.3.3 0 0 1-.233.234l-.06.006z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Toolbox.svg
var _path$158;
var _path2$109;
function _extends$172() {
	return _extends$172 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$172.apply(null, arguments);
}
var SvgToolbox = function SvgToolbox(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$172({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$158 || (_path$158 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M10.106 8.451v.394a2.106 2.106 0 1 1-4.212 0V8.45H2.75v3.85c0 .526.425.95.95.95h8.6a.95.95 0 0 0 .95-.95v-3.85z",
		clipRule: "evenodd",
		opacity: .25
	})), _path2$109 || (_path2$109 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "m1.524 8.419.026.014v3.869a2.15 2.15 0 0 0 2.15 2.15h8.6a2.15 2.15 0 0 0 2.15-2.15V8.433l.026-.014c.234-.128.427-.353.562-.613.134-.26.212-.56.212-.84a2.817 2.817 0 0 0-2.817-2.816H11.6v-.102a2.6 2.6 0 0 0-2.6-2.6H7a2.6 2.6 0 0 0-2.6 2.6v.102h-.833A2.817 2.817 0 0 0 .75 6.967c0 .28.078.579.212.84.135.26.328.484.562.612m4.458-1.17.023-.068a2.107 2.107 0 0 1 3.99 0l.023.068 3.749.001a.283.283 0 0 0 .283-.283c0-.893-.724-1.617-1.617-1.617H3.567c-.893 0-1.617.724-1.617 1.617 0 .156.127.283.283.283zm4.124 1.202v.394a2.106 2.106 0 1 1-4.212 0V8.45H2.75v3.851c0 .525.425.95.95.95h8.6a.95.95 0 0 0 .95-.95v-3.85zM8 6.951c-.5 0-.906.406-.906.906v.988a.906.906 0 1 0 1.812 0v-.988c0-.5-.406-.906-.906-.906m2.4-2.903c0-.28-.05-.513-.152-.71a1.23 1.23 0 0 0-.475-.488A1.5 1.5 0 0 0 9 2.636H7c-.283 0-.547.078-.773.214-.435.262-.674.652-.674 1.198v.102H10.4z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Toolshed.svg
var _path$157;
var _path2$108;
function _extends$171() {
	return _extends$171 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$171.apply(null, arguments);
}
var SvgToolshed = function SvgToolshed(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$171({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$157 || (_path$157 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M10.258 7.037h2.09L8 4.788l-4.348 2.25h2.09l.03-.027A1.6 1.6 0 0 1 6.8 6.637h2.4c.391 0 .75.14 1.028.374zm2.342 1.2h-1.8v2.2h1.8zm-1.8 3.4h1.8v1.8a.4.4 0 0 1-.4.4h-1.4zm-5.6 2.2H3.8a.4.4 0 0 1-.4-.4v-1.8h1.8zm-1.8-3.4h1.8v-2.2H3.4z",
		clipRule: "evenodd",
		opacity: .25
	})), _path2$108 || (_path2$108 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M2.2 13.437a1.6 1.6 0 0 0 1.6 1.6h8.4a1.6 1.6 0 0 0 1.6-1.6V7.496l.063-.011A1.4 1.4 0 0 0 15 6.108v-.827a1.6 1.6 0 0 0-.865-1.422L9.011 1.21a2.2 2.2 0 0 0-2.022 0l-5.124 2.65A1.6 1.6 0 0 0 1 5.281v.827a1.4 1.4 0 0 0 1.137 1.377l.063.01zm8.058-6.4h2.09L8 4.788l-4.348 2.25h2.09l.03-.027A1.6 1.6 0 0 1 6.8 6.637h2.4c.391 0 .75.14 1.028.374zm2.342 1.2h-1.8v2.2h1.8zm-1.8 3.4h1.8v1.8a.4.4 0 0 1-.4.4h-1.4zm-5.6 2.2H3.8a.4.4 0 0 1-.4-.4v-1.8h1.8zm-1.8-3.4h1.8v-2.2H3.4zm3.4-2.6a.4.4 0 0 0-.4.4v5.6h3.2v-5.6a.4.4 0 0 0-.4-.4zM2.416 4.925a.4.4 0 0 0-.216.356v.827a.2.2 0 0 0 .292.178L7.54 3.675a1 1 0 0 1 .918 0l5.05 2.611a.2.2 0 0 0 .291-.178v-.827a.4.4 0 0 0-.216-.356l-5.125-2.65a1 1 0 0 0-.918 0z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Topology.svg
var _path$156;
var _path2$107;
function _extends$170() {
	return _extends$170 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$170.apply(null, arguments);
}
var SvgTopology = function SvgTopology(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$170({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$156 || (_path$156 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M3.8 4.25a.45.45 0 1 1 .9 0v1.5a.45.45 0 1 1-.9 0zM11.75 6.2a.45.45 0 1 0 0-.9.45.45 0 0 0 0 .9M10.4 6.2a.45.45 0 1 0 0-.9.45.45 0 0 0 0 .9M9.05 6.2a.45.45 0 1 0 0-.9.45.45 0 0 0 0 .9"
	})), _path2$107 || (_path2$107 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M3.65 1.5A2.15 2.15 0 0 0 1.5 3.65v2.7a2.15 2.15 0 0 0 1.869 2.132L1.841 10.01c-.588.025-1.263.107-1.487.332C.067 10.63 0 11.515 0 12.3s.067 1.67.354 1.958c.288.288 1.318.342 1.953.342s1.665-.054 1.952-.342c.288-.288.341-1.173.341-1.958s-.053-1.67-.341-1.958c-.184-.184-.671-.273-1.165-.313L4.624 8.5H7.55v1.51c-.59.024-1.27.106-1.496.332-.287.288-.354 1.173-.354 1.958s.067 1.67.354 1.958c.288.288 1.318.342 1.953.342s1.665-.054 1.952-.342.341-1.173.341-1.958-.054-1.67-.341-1.958c-.227-.228-.916-.309-1.509-.333V8.5h3.028L13 10.023c-.52.037-1.053.124-1.247.319-.287.288-.354 1.173-.354 1.958s.067 1.67.354 1.958c.288.288 1.318.342 1.953.342s1.664-.054 1.952-.342c.287-.288.341-1.173.341-1.958s-.053-1.67-.341-1.958c-.212-.213-.83-.298-1.394-.328l-1.546-1.546A2.15 2.15 0 0 0 14.5 6.35v-2.7a2.15 2.15 0 0 0-2.15-2.15zM2.5 3.65c0-.635.515-1.15 1.15-1.15h8.7c.635 0 1.15.515 1.15 1.15v2.7a1.15 1.15 0 0 1-1.15 1.15h-8.7A1.15 1.15 0 0 1 2.5 6.35zm.907 9.757c.163-.163.193-.664.193-1.107s-.03-.944-.193-1.107C3.245 11.03 2.663 11 2.304 11c-.36 0-.941.03-1.104.193-.162.163-.2.664-.2 1.107s.038.944.2 1.107c.163.163.745.193 1.104.193s.94-.03 1.103-.193m5.7 0c.163-.163.193-.664.193-1.107s-.03-.944-.193-1.107C8.945 11.03 8.363 11 8.004 11c-.36 0-.941.03-1.104.193-.162.163-.2.664-.2 1.107s.038.944.2 1.107c.163.163.745.193 1.104.193s.94-.03 1.103-.193M15 12.3c0 .443-.03.944-.193 1.107-.162.163-.744.193-1.103.193-.36 0-.941-.03-1.104-.193-.162-.163-.2-.664-.2-1.107s.038-.944.2-1.107c.163-.163.745-.193 1.104-.193s.94.03 1.103.193.193.664.193 1.107",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/TrafficLight.svg
var _path$155;
var _path2$106;
var _path3$53;
var _path4$28;
var _path5$17;
function _extends$169() {
	return _extends$169 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$169.apply(null, arguments);
}
var SvgTrafficLight = function SvgTrafficLight(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$169({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$155 || (_path$155 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M9.4 11.275a1.4 1.4 0 1 1-2.8 0 1.4 1.4 0 0 1 2.8 0",
		opacity: .25
	})), _path2$106 || (_path2$106 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M9.4 8a1.4 1.4 0 1 1-2.8 0 1.4 1.4 0 0 1 2.8 0",
		opacity: .5
	})), _path3$53 || (_path3$53 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M9.4 4.725a1.4 1.4 0 1 1-2.8 0 1.4 1.4 0 0 1 2.8 0"
	})), _path4$28 || (_path4$28 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M9.4 4.725a1.4 1.4 0 1 1-2.8 0 1.4 1.4 0 0 1 2.8 0",
		clipRule: "evenodd"
	})), _path5$17 || (_path5$17 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M9.7 1H6.3a2.2 2.2 0 0 0-2.2 2.2l.005.125H1.788a.2.2 0 0 0-.142.341l2.459 2.459V6.6H1.788a.2.2 0 0 0-.142.341L4.105 9.4v.475H1.788a.2.2 0 0 0-.142.341l2.459 2.459-.005.125A2.2 2.2 0 0 0 6.3 15h3.4a2.2 2.2 0 0 0 2.2-2.2l-.005-.125 2.459-2.459a.2.2 0 0 0-.142-.341h-2.317V9.4l2.459-2.459a.2.2 0 0 0-.142-.341h-2.317v-.475l2.459-2.459a.2.2 0 0 0-.142-.341h-2.317L11.9 3.2A2.2 2.2 0 0 0 9.7 1M6.3 2.2a1 1 0 0 0-1 1v9.6a1 1 0 0 0 1 1h3.4a1 1 0 0 0 1-1V3.2a1 1 0 0 0-1-1z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/TrafficShaping.svg
var _path$154;
var _path2$105;
function _extends$168() {
	return _extends$168 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$168.apply(null, arguments);
}
var SvgTrafficShaping = function SvgTrafficShaping(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$168({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$154 || (_path$154 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M10.424 8.065a.896.896 0 0 1 1.552 0l3.103 5.374a.896.896 0 0 1-.776 1.344H8.097a.896.896 0 0 1-.776-1.344z",
		opacity: .5
	})), _path2$105 || (_path2$105 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M6.002 13.758A6.322 6.322 0 0 1 7.12 1.217a6.32 6.32 0 0 1 6.29 6.934l-.395-.686a2.07 2.07 0 0 0-.923-.852 5.06 5.06 0 0 0-3.22-3.82c-.138-.051-.252.105-.173.23.578.906 1.207 2.199 1.378 3.716a2.1 2.1 0 0 0-.692.726l-.61 1.057q.014-.088.027-.178a.155.155 0 0 0-.155-.175H5.582a.155.155 0 0 0-.155.172c.182 1.612.88 2.8 1.427 3.507l-.572.991c-.172.298-.261.61-.28.92M4.154 8.315a.16.16 0 0 0-.16-.146H2.283a.154.154 0 0 0-.154.177 5.06 5.06 0 0 0 3.114 3.887c.14.056.259-.104.178-.23a8.25 8.25 0 0 1-1.266-3.688m4.493-1.41a.155.155 0 0 0 .155-.175c-.233-1.682-1.135-3.062-1.707-3.786a.006.006 0 0 0-.01 0 7.03 7.03 0 0 0-1.658 3.79.155.155 0 0 0 .155.171zm-4.652 0a.16.16 0 0 0 .159-.146A8.25 8.25 0 0 1 5.42 3.072c.08-.127-.038-.287-.178-.23a5.06 5.06 0 0 0-3.114 3.886.154.154 0 0 0 .154.177z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/TrashCan.svg
var _g$21;
var _path$153;
var _path2$104;
function _extends$167() {
	return _extends$167 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$167.apply(null, arguments);
}
var SvgTrashCan = function SvgTrashCan(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$167({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$21 || (_g$21 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", {
		fillRule: "evenodd",
		d: "M3.7 3.2a.7.7 0 1 0 0 1.4h8.6a.7.7 0 1 0 0-1.4z",
		clipRule: "evenodd"
	}), /*#__PURE__*/ React.createElement("path", { d: "M12 7H4V5.8h8z" }))), _path$153 || (_path$153 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M6.2 7.8a.6.6 0 0 1 1.2 0v3.4a.6.6 0 1 1-1.2 0zM9.2 7.2a.6.6 0 0 0-.6.6v3.4a.6.6 0 1 0 1.2 0V7.8a.6.6 0 0 0-.6-.6"
	})), _path2$104 || (_path2$104 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M3.7 2h1.701C5.92 1.402 6.89 1 8 1s2.08.402 2.599 1H12.3a1.9 1.9 0 0 1 .9 3.574v7.051a2.2 2.2 0 0 1-2.2 2.2H5a2.2 2.2 0 0 1-2.2-2.2V5.574A1.9 1.9 0 0 1 3.7 2m0 1.2a.7.7 0 1 0 0 1.4h8.6a.7.7 0 1 0 0-1.4zm.3 9.425V5.8h8v6.825a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Tunnel.svg
var _path$152;
var _path2$103;
function _extends$166() {
	return _extends$166 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$166.apply(null, arguments);
}
var SvgTunnel = function SvgTunnel(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$166({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$152 || (_path$152 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M2.9 7.3a5.1 5.1 0 0 1 10.2 0v4.784l-1.2-.88v-3.31a3.9 3.9 0 0 0-7.8 0v3.31l-1.2.88z",
		opacity: .25
	})), _path2$103 || (_path2$103 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M14.3 7.3a6.3 6.3 0 1 0-12.6 0v5.678c-.824.781-.29 2.235.905 2.235h10.79c1.195 0 1.729-1.454.905-2.235zm-9 .594a2.7 2.7 0 0 1 5.4 0v2.7H5.3zm-2.695 6.118a.1.1 0 0 1-.059-.18l2.49-1.826a1 1 0 0 1 .591-.194h4.746a1 1 0 0 1 .591.194l2.49 1.826a.1.1 0 0 1-.06.18zm.295-1.928V7.3a5.1 5.1 0 0 1 10.2 0v4.784l-1.2-.88v-3.31a3.9 3.9 0 0 0-7.8 0v3.31z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Twinkle.svg
var _path$151;
var _g$20;
var _path2$102;
function _extends$165() {
	return _extends$165 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$165.apply(null, arguments);
}
var SvgTwinkle = function SvgTwinkle(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$165({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$151 || (_path$151 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "m10.903 7.204 2.407.89.271.1.05.025a.336.336 0 0 1-.05.605l-.27.1-2.408.89a.34.34 0 0 0-.198.199l-.99 2.678-.025.05a.336.336 0 0 1-.605-.05l-.99-2.678a.34.34 0 0 0-.131-.163q.561-.268 1.079-.647a6.8 6.8 0 0 0 1.821-2.018q.019.01.04.02",
		opacity: .25
	})), _g$20 || (_g$20 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .5
	}, /*#__PURE__*/ React.createElement("path", { d: "M3.436 1.64a.2.2 0 0 1 .375 0l.591 1.597a.2.2 0 0 0 .118.118l1.597.591a.2.2 0 0 1 0 .375l-1.597.591a.2.2 0 0 0-.118.118l-.59 1.597a.2.2 0 0 1-.376 0l-.59-1.597a.2.2 0 0 0-.119-.118l-1.596-.59a.2.2 0 0 1 0-.376l1.596-.59a.2.2 0 0 0 .118-.119zM3.51 11.37a.122.122 0 0 1 .228 0l.36.973q.021.053.072.072l.974.36c.106.04.106.19 0 .23l-.974.36a.12.12 0 0 0-.072.072l-.36.973a.122.122 0 0 1-.229 0l-.36-.973a.12.12 0 0 0-.072-.072l-.974-.36a.122.122 0 0 1 0-.23l.974-.36a.12.12 0 0 0 .072-.072z" }))), _path2$102 || (_path2$102 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M7.96 3.913c.495-1.337 2.385-1.337 2.88 0l.852 2.304 2.305.853c1.337.495 1.337 2.385 0 2.88l-2.305.852-.852 2.305c-.495 1.337-2.385 1.337-2.88 0l-.853-2.305-2.304-.852c-1.337-.495-1.337-2.385 0-2.88l2.304-.853zm1.755.416a.336.336 0 0 0-.63 0l-.99 2.678-.033.065a.34.34 0 0 1-.166.133l-2.408.89-.27.1a.336.336 0 0 0 0 .63l2.678.99a.34.34 0 0 1 .199.198l.99 2.678c.101.274.47.29.605.05l.025-.05.99-2.678a.34.34 0 0 1 .198-.198l2.407-.89.271-.1a.336.336 0 0 0 .05-.606l-.05-.024-.27-.1-2.408-.89a.34.34 0 0 1-.198-.199z"
	})));
};

//#endregion
//#region src/Icon/icons/Undo.svg
var _path$150;
function _extends$164() {
	return _extends$164 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$164.apply(null, arguments);
}
var SvgUndo = function SvgUndo(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$164({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$150 || (_path$150 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M12.247 7.197a5.4 5.4 0 0 1-7.688 6.573c-.369-.204-.442-.685-.2-1.03.256-.366.764-.436 1.167-.244a3.825 3.825 0 1 0 .463-7.09l.003.008 1.06.636a.94.94 0 0 1 .41 1.128.675.675 0 0 1-.983.357L3.93 6.004a.9.9 0 0 1-.447-.51.9.9 0 0 1 .015-.677l.967-2.81a.675.675 0 0 1 .983-.358.94.94 0 0 1 .41 1.127l-.408 1.152.125-.043a5.4 5.4 0 0 1 6.67 3.312"
	})));
};

//#endregion
//#region src/Icon/icons/Unhealthy.svg
var _path$149;
var _path2$101;
function _extends$163() {
	return _extends$163 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$163.apply(null, arguments);
}
var SvgUnhealthy = function SvgUnhealthy(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$163({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$149 || (_path$149 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M6.84 2.2a.773.773 0 0 0-.773.773v2.89c0 .113-.091.204-.203.204h-2.89a.773.773 0 0 0-.774.773v2.32c0 .427.346.773.773.773h2.89c.113 0 .204.091.204.203v2.89c0 .428.346.774.773.774h2.32a.773.773 0 0 0 .773-.773v-2.89c0-.113.091-.204.203-.204h2.89a.773.773 0 0 0 .774-.773V6.84a.773.773 0 0 0-.773-.773h-2.89a.203.203 0 0 1-.204-.203v-2.89A.773.773 0 0 0 9.16 2.2z",
		clipRule: "evenodd",
		opacity: .25
	})), _path2$101 || (_path2$101 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M4.867 2.973C4.867 1.883 5.75 1 6.84 1h2.32c1.09 0 1.973.884 1.973 1.973v1.894h1.894c1.09 0 1.973.883 1.973 1.973v2.32c0 1.09-.883 1.973-1.973 1.973h-1.894v1.894c0 1.09-.883 1.973-1.973 1.973H6.84a1.973 1.973 0 0 1-1.973-1.973v-1.894H2.973A1.973 1.973 0 0 1 1 9.16V6.84c0-1.09.884-1.973 1.973-1.973h1.894zM6.84 2.2a.773.773 0 0 0-.773.773v2.89c0 .113-.091.204-.203.204h-2.89a.773.773 0 0 0-.774.773v2.32c0 .427.346.773.773.773h2.89c.113 0 .204.091.204.203v2.89c0 .428.346.774.773.774h2.32a.773.773 0 0 0 .773-.773v-2.89c0-.113.091-.204.203-.204h2.89a.773.773 0 0 0 .774-.773V6.84a.773.773 0 0 0-.773-.773h-2.89a.203.203 0 0 1-.204-.203v-2.89A.773.773 0 0 0 9.16 2.2z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Upgrading.svg
var _path$148;
var _path2$100;
var _path3$52;
var _path4$27;
var _path5$16;
function _extends$162() {
	return _extends$162 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$162.apply(null, arguments);
}
var SvgUpgrading = function SvgUpgrading(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$162({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$148 || (_path$148 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M2.216 6.168v4.25c0 .431.238.829.618 1.034l3.06 1.648a1.81 1.81 0 0 1 1.498-1.076v-1.608a1.8 1.8 0 0 1 0-.618v-.641c0-.428-.232-.821-.606-1.028L2.715 5.874a.336.336 0 0 0-.499.294",
		opacity: .25
	})), _path2$100 || (_path2$100 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M2.216 6.168v4.25c0 .431.238.829.618 1.034l3.06 1.648c-.134.31-.182.667-.11 1.042q.03.149.068.316l-4.367-2.351A.92.92 0 0 1 1 11.294V4.752c0-.337.184-.648.48-.81L7.558.625a.92.92 0 0 1 .884 0l6.078 3.319c.296.161.48.472.48.81v4.005l-.059-.053-1.157-1.01V6.169a.336.336 0 0 0-.499-.294l-1.084.6a2 2 0 0 0-.725-.134c-.496 0-.982.181-1.351.521L8.01 8.705c-.343.299-.549.687-.618 1.093v-.641c0-.428-.232-.821-.606-1.028L2.715 5.874a.336.336 0 0 0-.499.294m10.378-1.891-4.03-2.202a1.18 1.18 0 0 0-1.127 0L3.406 4.277a.336.336 0 0 0-.002.588l4.027 2.23c.354.197.784.197 1.138 0l4.027-2.23a.336.336 0 0 0-.002-.588",
		clipRule: "evenodd"
	})), _path3$52 || (_path3$52 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M7.392 10.416v1.608c.461-.04.883.094 1.216.34v-.497a2 2 0 0 1-.598-.357 1.86 1.86 0 0 1-.618-1.094M9.519 13.416l-.098.052.098.016v-.068M14.983 11.473l-.042.037c-.424.37-.975.529-1.508.477v.702l1.082-.582a.92.92 0 0 0 .468-.634"
	})), _path4$27 || (_path4$27 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M8.26 14.16c.051.15.095.22.112.246l.038.022c.047.024.124.06.235.094a5 5 0 0 0 .827.167c.294.039.609.066.92.083.385.022.762.03 1.089.03.593 0 1.35-.026 2.01-.113.33-.044.612-.1.826-.167a1.5 1.5 0 0 0 .27-.11 1 1 0 0 0 .108-.244q.06-.182.111-.444a.61.61 0 0 1 .662-.5.59.59 0 0 1 .522.688c-.1.544-.264 1.055-.559 1.35-.185.186-.463.313-.759.404a6.4 6.4 0 0 1-1.024.21c-.735.098-1.55.124-2.167.124s-1.432-.026-2.167-.123a6.4 6.4 0 0 1-1.024-.21c-.296-.092-.574-.219-.76-.404-.293-.295-.462-.804-.568-1.349a.59.59 0 0 1 .516-.693.613.613 0 0 1 .666.493q.053.264.116.446"
	})), _path5$16 || (_path5$16 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M11.476 14.126c-.388 0-.757-.28-.757-.69v-3.59l-.872.76a.81.81 0 0 1-1.048 0 .65.65 0 0 1 0-.997l2.13-1.856a.8.8 0 0 1 .547-.213c.21 0 .407.079.547.213l2.13 1.856c.31.271.31.726 0 .997a.81.81 0 0 1-1.048 0l-.872-.76v3.59c0 .41-.37.69-.757.69"
	})));
};

//#endregion
//#region src/Icon/icons/Upload.svg
var _path$147;
var _path2$99;
function _extends$161() {
	return _extends$161 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$161.apply(null, arguments);
}
var SvgUpload = function SvgUpload(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$161({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$147 || (_path$147 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M2.678 12.585c-.05-.05-.162-.209-.283-.56a6 6 0 0 1-.202-.777.625.625 0 0 0-.677-.506.585.585 0 0 0-.515.687c.17.883.43 1.613.825 2.008.236.237.62.421 1.084.565a10 10 0 0 0 1.61.33c1.176.156 2.488.198 3.489.198s2.312-.042 3.488-.198a10 10 0 0 0 1.61-.33c.465-.144.848-.328 1.085-.565.394-.396.646-1.125.808-2.008a.585.585 0 0 0-.521-.682.624.624 0 0 0-.673.512 6 6 0 0 1-.194.774c-.118.352-.227.506-.274.553a.7.7 0 0 1-.151.095 3 3 0 0 1-.437.17c-.377.117-.86.213-1.412.286-1.101.146-2.354.188-3.33.188a32 32 0 0 1-1.798-.049 21 21 0 0 1-1.531-.139 9 9 0 0 1-1.412-.286 2.7 2.7 0 0 1-.447-.18 2 2 0 0 1-.134-.08l-.006-.005z",
		clipRule: "evenodd"
	})), _path2$99 || (_path2$99 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M7.14 10.72c0 .414.385.75.86.75s.86-.336.86-.75V4.032l2.046 1.784a.95.95 0 0 0 1.217 0 .684.684 0 0 0 0-1.06L8.64 1.718A.92.92 0 0 0 8 1.47a.92.92 0 0 0-.64.249L3.877 4.755a.684.684 0 0 0 0 1.06.95.95 0 0 0 1.217 0L7.14 4.033z"
	})));
};

//#endregion
//#region src/Icon/icons/User.svg
var _path$146;
var _path2$98;
function _extends$160() {
	return _extends$160 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$160.apply(null, arguments);
}
var SvgUser = function SvgUser(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$160({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$146 || (_path$146 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M5.884 8.516a5.73 5.73 0 0 0-3.507 4.398c-.062.385.252.71.64.71h9.967c.387 0 .701-.325.639-.71a5.73 5.73 0 0 0-3.507-4.398A3.4 3.4 0 0 1 8 9.254a3.4 3.4 0 0 1-2.116-.738",
		opacity: .2
	})), _path2$98 || (_path2$98 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M10.116 8.516a5.735 5.735 0 0 1 3.507 4.398c.062.385-.252.71-.64.71H3.017c-.387 0-.701-.325-.639-.71a5.74 5.74 0 0 1 3.507-4.398 3.45 3.45 0 0 1-1.302-2.701c0-1.9 1.53-3.44 3.418-3.44s3.418 1.54 3.418 3.44a3.44 3.44 0 0 1-1.302 2.7m2.084-.392a4.8 4.8 0 0 0 .585-2.31C12.785 3.157 10.643 1 8 1S3.215 3.156 3.215 5.815c0 .837.212 1.624.585 2.309a7.1 7.1 0 0 0-2.773 4.57C.812 14.031 1.907 15 3.017 15h9.967c1.108 0 2.204-.969 1.989-2.306a7.1 7.1 0 0 0-2.773-4.57",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Users.svg
var _g$19;
var _path$145;
var _path2$97;
function _extends$159() {
	return _extends$159 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$159.apply(null, arguments);
}
var SvgUsers = function SvgUsers(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$159({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$19 || (_g$19 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .2
	}, /*#__PURE__*/ React.createElement("path", { d: "M12.42 7.578a3.53 3.53 0 0 1 1.376 2.267c.02.12-.062.235-.191.263q-.03.006-.063.007h-.441a6 6 0 0 0-.805-1.082 4.4 4.4 0 0 0 .132-.835l.008-.263q0-.18-.016-.357M3.58 7.577q-.015.177-.015.358l.006.262q.027.43.131.836a6 6 0 0 0-.803 1.082h-.443q-.032-.001-.062-.007c-.128-.029-.21-.144-.19-.263a3.53 3.53 0 0 1 1.375-2.268M9.3 9.82q.42.17.777.435a3.53 3.53 0 0 1 1.38 2.27c.02.119-.063.234-.191.263q-.03.006-.063.007H4.796q-.032-.001-.062-.007c-.129-.029-.21-.144-.19-.264A3.53 3.53 0 0 1 6.698 9.82l.252-.102a2.18 2.18 0 0 0 2.096 0z" }))), _path$145 || (_path$145 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M8 4.68a3.246 3.246 0 0 1 3.236 3.255c0 .516-.121 1.005-.335 1.439a4.73 4.73 0 0 1 1.74 2.958c.156.973-.643 1.668-1.437 1.668H4.796c-.794 0-1.593-.695-1.437-1.668a4.73 4.73 0 0 1 1.739-2.958 3.26 3.26 0 0 1-.334-1.44A3.246 3.246 0 0 1 8 4.68m0 1.204a2.044 2.044 0 0 0-2.037 2.05 2.05 2.05 0 0 0 .776 1.612l.215.17-.255.104a3.528 3.528 0 0 0-2.156 2.704c-.022.138.09.272.253.272h6.408c.163 0 .275-.134.253-.272A3.53 3.53 0 0 0 9.301 9.82l-.256-.103.216-.171a2.06 2.06 0 0 0 .776-1.611c0-1.134-.913-2.051-2.037-2.051"
	})), _path2$97 || (_path2$97 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M5.66 2c1.144 0 2.148.597 2.723 1.497a4.43 4.43 0 0 0-1.497.123 2 2 0 0 0-1.225-.416 2.044 2.044 0 0 0-2.037 2.05c0 .346.084.671.233.956l.031.053a4.5 4.5 0 0 0-.31 1.315 3.53 3.53 0 0 0-1.374 2.267c-.022.137.09.271.253.271h.44a6 6 0 0 0-.528 1.2c-.764-.05-1.5-.727-1.349-1.664a4.73 4.73 0 0 1 1.738-2.958 3.26 3.26 0 0 1-.334-1.44A3.246 3.246 0 0 1 5.661 2M10.34 2a3.246 3.246 0 0 1 3.236 3.255c0 .517-.122 1.005-.335 1.44a4.73 4.73 0 0 1 1.739 2.957c.151.938-.586 1.616-1.35 1.663a6 6 0 0 0-.528-1.199h.441c.164 0 .275-.134.253-.271a3.53 3.53 0 0 0-1.376-2.267 4.5 4.5 0 0 0-.31-1.315q.016-.026.033-.053c.15-.285.233-.61.233-.955 0-1.133-.913-2.05-2.037-2.05-.24 0-.468.042-.681.118a4.5 4.5 0 0 0-.678-1.022C9.393 2.108 9.854 2 10.34 2"
	})));
};

//#endregion
//#region src/Icon/icons/Version.svg
var _path$144;
var _path2$96;
var _path3$51;
function _extends$158() {
	return _extends$158 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$158.apply(null, arguments);
}
var SvgVersion = function SvgVersion(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$158({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$144 || (_path$144 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M3.344 3H2.62c-.619 0-1.12.512-1.12 1.143v7.714c0 .631.501 1.143 1.12 1.143h.724v-1H2.62a.14.14 0 0 1-.14-.143V4.143c0-.079.063-.143.14-.143h.724z"
	})), _path2$96 || (_path2$96 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M14.5 6.563a.8.8 0 0 0-.234-.566L9.503 1.234A.8.8 0 0 0 8.937 1H6.1a1.6 1.6 0 0 0-1.6 1.6v10.8A1.6 1.6 0 0 0 6.1 15h6.8a1.6 1.6 0 0 0 1.6-1.6zM8.69 2.6a.2.2 0 0 0-.2-.2H6.1a.2.2 0 0 0-.2.2v10.8c0 .11.09.2.2.2h6.8a.2.2 0 0 0 .2-.2V7.213a.4.4 0 0 0-.4-.4H9.29a.6.6 0 0 1-.6-.6V2.6",
		clipRule: "evenodd"
	})), _path3$51 || (_path3$51 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M8.939 11.457c.06.057.16.057.22 0l2.995-2.851a.145.145 0 0 0 0-.212l-.368-.35a.16.16 0 0 0-.22 0l-2.517 2.395-1.214-1.156a.16.16 0 0 0-.22 0l-.369.35a.145.145 0 0 0 0 .212z"
	})));
};

//#endregion
//#region src/Icon/icons/View.svg
var _g$18;
var _path$143;
function _extends$157() {
	return _extends$157 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$157.apply(null, arguments);
}
var SvgView = function SvgView(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$157({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$18 || (_g$18 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		fillRule: "evenodd",
		clipRule: "evenodd",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M3 13.8a.8.8 0 0 1-.8-.8v-2.5a.8.8 0 0 1 .8-.8h2.5a.8.8 0 0 1 .8.8V13a.8.8 0 0 1-.8.8zM10.5 6.3a.8.8 0 0 1-.8-.8V3a.8.8 0 0 1 .8-.8H13a.8.8 0 0 1 .8.8v2.5a.8.8 0 0 1-.8.8z" }))), _path$143 || (_path$143 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M5.5 1a2 2 0 0 1 2 2v2.5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zM3 6.3a.8.8 0 0 1-.8-.8V3a.8.8 0 0 1 .8-.8h2.5a.8.8 0 0 1 .8.8v2.5a.8.8 0 0 1-.8.8zM5.5 8.5a2 2 0 0 1 2 2V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-2.5a2 2 0 0 1 2-2zM3 13.8a.8.8 0 0 1-.8-.8v-2.5a.8.8 0 0 1 .8-.8h2.5a.8.8 0 0 1 .8.8V13a.8.8 0 0 1-.8.8zM13 1a2 2 0 0 1 2 2v2.5a2 2 0 0 1-2 2h-2.5a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zm-2.5 5.3a.8.8 0 0 1-.8-.8V3a.8.8 0 0 1 .8-.8H13a.8.8 0 0 1 .8.8v2.5a.8.8 0 0 1-.8.8zM13 8.5a2 2 0 0 1 2 2V13a2 2 0 0 1-2 2h-2.5a2 2 0 0 1-2-2v-2.5a2 2 0 0 1 2-2zm-2.5 5.3a.8.8 0 0 1-.8-.8v-2.5a.8.8 0 0 1 .8-.8H13a.8.8 0 0 1 .8.8V13a.8.8 0 0 1-.8.8z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/VirtualDevice.svg
var _path$142;
var _path2$95;
function _extends$156() {
	return _extends$156 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$156.apply(null, arguments);
}
var SvgVirtualDevice = function SvgVirtualDevice(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$156({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$142 || (_path$142 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M2.216 10.417v-4.25c0-.255.275-.417.499-.293l4.071 2.255c.374.207.606.6.606 1.028v4.187a.336.336 0 0 1-.495.295l-4.063-2.187a1.18 1.18 0 0 1-.618-1.035",
		clipRule: "evenodd",
		opacity: .25
	})), _path2$95 || (_path2$95 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M2.216 10.417v-4.25c0-.255.275-.417.499-.293l4.071 2.255c.374.207.606.6.606 1.028v4.186a.336.336 0 0 1-.495.296l-4.063-2.187a1.18 1.18 0 0 1-.618-1.035m6.392 2.927V9.157c0-.428.232-.821.606-1.028l4.071-2.255a.336.336 0 0 1 .499.294v4.25c0 .431-.238.829-.618 1.034l-4.063 2.187a.336.336 0 0 1-.495-.295M8.563 2.075l4.031 2.202c.232.127.233.46.002.588l-4.027 2.23a1.18 1.18 0 0 1-1.138 0l-4.027-2.23a.336.336 0 0 1 .002-.588l4.03-2.202a1.18 1.18 0 0 1 1.127 0m5.957 1.868L8.442.623a.92.92 0 0 0-.884 0L1.48 3.944a.92.92 0 0 0-.48.81v6.541c0 .34.186.652.485.813l6.078 3.272a.92.92 0 0 0 .874 0l6.078-3.272a.92.92 0 0 0 .485-.813V4.752a.92.92 0 0 0-.48-.81",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/VLAN.svg
var _path$141;
var _g$17;
var _path2$94;
function _extends$155() {
	return _extends$155 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$155.apply(null, arguments);
}
var SvgVlan = function SvgVlan(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$155({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$141 || (_path$141 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M7.4 6.579a8 8 0 0 0 1.2 0V8h5.8a.6.6 0 1 1 0 1.2h-.7v1.478a6 6 0 0 0-.596-.028c-.161 0-.382.006-.604.03V9.2H8.6v1.478a6 6 0 0 0-.597-.028c-.16 0-.38.006-.603.03V9.2H3.5v1.478a6 6 0 0 0-.597-.028c-.16 0-.38.006-.603.03V9.2h-.7a.6.6 0 0 1 0-1.2h5.8z",
		opacity: .25
	})), _g$17 || (_g$17 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		fillRule: "evenodd",
		clipRule: "evenodd",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M9.363 5.162c.2-.2.237-.816.237-1.362s-.037-1.161-.237-1.362c-.2-.2-.916-.238-1.358-.238s-1.158.037-1.358.238S6.4 3.254 6.4 3.8s.047 1.162.247 1.362.916.238 1.358.238 1.158-.037 1.358-.238" }), /*#__PURE__*/ React.createElement("path", { d: "M9.363 5.162c.2-.2.237-.816.237-1.362s-.037-1.161-.237-1.362c-.2-.2-.916-.238-1.358-.238s-1.158.037-1.358.238S6.4 3.254 6.4 3.8s.047 1.162.247 1.362.916.238 1.358.238 1.158-.037 1.358-.238" }))), _path2$94 || (_path2$94 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M11.972 10.78c-.124.04-.37.127-.578.335a1.4 1.4 0 0 0-.323.537 2.4 2.4 0 0 0-.1.422 5 5 0 0 0-.046.751c0 .224.009.497.047.75.019.128.048.276.099.423.046.134.136.35.323.537.208.208.454.296.578.334.149.046.3.073.426.09.255.034.52.041.706.041.184 0 .448-.007.702-.04l.433-.092c.124-.039.368-.127.573-.333.19-.19.28-.41.326-.544.05-.149.078-.298.095-.424a6 6 0 0 0 .042-.742c0-.218-.007-.49-.042-.742a2.4 2.4 0 0 0-.095-.424 1.4 1.4 0 0 0-.325-.544 1.4 1.4 0 0 0-.578-.334 2.6 2.6 0 0 0-.426-.09 6 6 0 0 0-.705-.041c-.186 0-.451.008-.706.041a2.6 2.6 0 0 0-.426.09m2.253 2.045c0 .204-.007.417-.032.598q-.019.137-.051.234a.35.35 0 0 1-.073.137.4.4 0 0 1-.145.072 1.6 1.6 0 0 1-.253.052c-.19.025-.403.032-.567.032a5 5 0 0 1-.568-.032 1.6 1.6 0 0 1-.253-.052.4.4 0 0 1-.145-.072.4.4 0 0 1-.074-.137 1.4 1.4 0 0 1-.054-.235 4 4 0 0 1-.035-.597c0-.203.009-.417.035-.597q.02-.136.054-.235a.4.4 0 0 1 .074-.137.4.4 0 0 1 .145-.072q.109-.034.253-.052c.19-.025.403-.032.568-.032s.377.007.567.032c.095.013.182.03.253.052q.108.035.145.072.04.038.073.137.033.098.051.234c.025.18.032.394.032.598M6.872 10.78c-.124.04-.37.127-.578.335a1.4 1.4 0 0 0-.323.537 2.4 2.4 0 0 0-.1.422 5 5 0 0 0-.046.751c0 .224.01.497.047.75.019.128.048.276.099.423.046.134.136.35.323.537.208.208.454.296.578.334.149.046.3.073.426.09.255.034.52.041.705.041s.45-.007.703-.04l.433-.092c.124-.039.368-.127.574-.333.19-.19.28-.41.325-.544.05-.149.078-.298.095-.424a6 6 0 0 0 .042-.742c0-.218-.007-.49-.042-.742a2.4 2.4 0 0 0-.095-.424 1.4 1.4 0 0 0-.325-.544 1.4 1.4 0 0 0-.578-.334 2.6 2.6 0 0 0-.426-.09 6 6 0 0 0-.706-.041c-.185 0-.45.008-.705.041a2.6 2.6 0 0 0-.426.09m2.253 2.045c0 .204-.007.417-.032.598q-.019.137-.051.234a.35.35 0 0 1-.073.137.4.4 0 0 1-.145.072 1.6 1.6 0 0 1-.253.052 5 5 0 0 1-.568.032 5 5 0 0 1-.567-.032 1.6 1.6 0 0 1-.253-.052.4.4 0 0 1-.145-.072.4.4 0 0 1-.074-.137 1.4 1.4 0 0 1-.054-.235 4 4 0 0 1-.035-.597c0-.203.009-.417.035-.597q.02-.136.054-.235a.4.4 0 0 1 .074-.137.4.4 0 0 1 .145-.072c.071-.022.158-.04.253-.052a5 5 0 0 1 .567-.032c.165 0 .378.007.568.032.095.013.182.03.253.052q.108.035.145.072.04.038.073.137.033.098.051.234c.025.18.032.394.032.598M1.772 10.78c-.124.04-.37.127-.578.335a1.4 1.4 0 0 0-.323.537 2.4 2.4 0 0 0-.1.422 5 5 0 0 0-.046.751c0 .224.009.497.047.75.019.128.048.276.099.423.046.134.136.35.323.537.208.208.454.296.578.334.149.046.3.073.426.09.255.034.52.041.705.041s.449-.007.703-.04l.433-.092c.124-.039.368-.127.574-.333.19-.19.28-.41.325-.544.05-.149.077-.298.095-.424.035-.253.042-.524.042-.742s-.007-.49-.042-.742a2.4 2.4 0 0 0-.095-.424 1.4 1.4 0 0 0-.325-.544 1.4 1.4 0 0 0-.578-.334 2.6 2.6 0 0 0-.426-.09 6 6 0 0 0-.706-.041c-.185 0-.45.008-.705.041a2.6 2.6 0 0 0-.426.09m2.253 2.045c0 .204-.007.417-.032.598q-.02.137-.051.234a.35.35 0 0 1-.073.137.4.4 0 0 1-.145.072 1.6 1.6 0 0 1-.253.052 5 5 0 0 1-.568.032 5 5 0 0 1-.567-.032 1.6 1.6 0 0 1-.253-.052.4.4 0 0 1-.145-.072.4.4 0 0 1-.074-.137 1.4 1.4 0 0 1-.054-.235 4 4 0 0 1-.035-.597c0-.203.009-.417.035-.597q.02-.136.054-.235a.4.4 0 0 1 .074-.137.4.4 0 0 1 .145-.072q.108-.034.253-.052a5 5 0 0 1 .567-.032c.165 0 .378.007.568.032q.145.02.253.052.108.035.145.072.04.038.073.137.032.098.051.234c.025.18.032.394.032.598M5.389 5.332c.059.171.174.443.408.677.259.26.569.371.728.421.191.06.386.094.552.116.334.044.682.054.928.054.245 0 .593-.01.927-.054l.552-.116c.16-.05.47-.16.729-.42.237-.239.351-.515.41-.688.063-.19.1-.382.122-.547.046-.33.055-.686.055-.975 0-.29-.01-.645-.055-.975a3 3 0 0 0-.123-.547 1.75 1.75 0 0 0-.41-.687 1.76 1.76 0 0 0-.728-.421 3.4 3.4 0 0 0-.552-.116A7 7 0 0 0 8.005 1c-.246 0-.594.01-.928.054-.166.022-.36.057-.552.116-.16.05-.469.16-.728.42a1.8 1.8 0 0 0-.408.678c-.065.189-.103.38-.128.546-.049.332-.061.69-.061.986s.012.654.061.986c.025.166.063.357.128.546m3.974-.17c.2-.2.237-.816.237-1.362s-.037-1.162-.237-1.362S8.447 2.2 8.005 2.2s-1.159.037-1.359.238S6.4 3.254 6.4 3.8s.046 1.162.246 1.362.917.238 1.359.238 1.158-.037 1.358-.238",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/VPN.svg
var _g$16;
var _path$140;
var _path2$93;
function _extends$154() {
	return _extends$154 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$154.apply(null, arguments);
}
var SvgVpn = function SvgVpn(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$154({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$16 || (_g$16 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M14.436 10.759a7.002 7.002 0 0 0-3.837-9.26l.001.101c0 .322-.059.63-.165.915a6 6 0 0 1 3.151 7.679c.32.131.608.324.85.565M10.194 13.586C9.514 13.853 8.774 14 8 14a6 6 0 0 1-2.194-.414c-.13.32-.324.608-.565.85A7 7 0 0 0 8 15c.98 0 1.912-.201 2.758-.565a2.6 2.6 0 0 1-.564-.849M2.414 10.194a6.001 6.001 0 0 1 3.152-7.68 2.6 2.6 0 0 1-.164-1.016 7 7 0 0 0-3.837 9.26c.24-.24.529-.433.849-.564M8.057 11.255c1.438-.703 2.29-1.715 2.503-2.914.168-.95.132-1.932.075-2.563a.14.14 0 0 0-.092-.118l-2.404-.907A.4.4 0 0 0 8 4.727v6.542a.13.13 0 0 0 .057-.014" }))), _path$140 || (_path$140 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M14 12.6a1.4 1.4 0 1 1-2.8 0 1.4 1.4 0 0 1 2.8 0M4.8 12.6a1.4 1.4 0 1 1-2.8 0 1.4 1.4 0 0 1 2.8 0M9.4 1.6a1.4 1.4 0 1 1-2.8 0 1.4 1.4 0 0 1 2.8 0"
	})), _path2$93 || (_path2$93 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M11.22 4.64 8.295 3.538a.9.9 0 0 0-.29-.057h-.012a.9.9 0 0 0-.29.057L4.78 4.641a.89.89 0 0 0-.573.734c-.073.634-.166 1.907.058 3.174.312 1.764 1.6 3.085 3.408 3.897q.154.069.32.074h.013a.8.8 0 0 0 .32-.074c1.807-.812 3.095-2.133 3.407-3.897.224-1.267.131-2.54.058-3.174a.89.89 0 0 0-.573-.734m-3.08.113a.4.4 0 0 0-.28 0l-2.403.907a.14.14 0 0 0-.092.118c-.057.63-.093 1.612.075 2.563.212 1.2 1.065 2.21 2.503 2.914a.13.13 0 0 0 .114 0c1.438-.703 2.29-1.715 2.503-2.914.168-.951.132-1.932.075-2.563a.14.14 0 0 0-.092-.118z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Vulnerability.svg
var _path$139;
var _path2$92;
var _path3$50;
function _extends$153() {
	return _extends$153 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$153.apply(null, arguments);
}
var SvgVulnerability = function SvgVulnerability(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$153({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$139 || (_path$139 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M8.599 10.387q.353 0 .696-.045l1.465 1.466.038.037c-.674.68-1.528 1.277-2.548 1.776a.6.6 0 0 1-.25.058v-3.325q.295.033.599.033",
		opacity: .25
	})), _path2$92 || (_path2$92 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M3.279 5.712a5.34 5.34 0 0 1 .588-3.215l-.98.37c-.38.143-.657.484-.705.901-.117 1.018-.264 3.05.092 5.064.48 2.719 2.47 4.789 5.342 6.08q.186.081.384.088.198-.006.384-.089c1.38-.62 2.556-1.42 3.458-2.385a3.3 3.3 0 0 1-1.044-.68c-.674.68-1.528 1.276-2.548 1.775a.57.57 0 0 1-.5 0c-2.412-1.18-3.9-2.908-4.27-5.003-.178-1.006-.219-2.028-.201-2.906M13.947 5.75l-.005-.25a5 5 0 0 1-.024.22zM13.82 3.794l-.002-.026a1.1 1.1 0 0 0-.098-.345q.057.183.1.371M9.211 6.69a1.77 1.77 0 0 1-1.234-.004l.874-1.202-1.333-.256a.56.56 0 0 1-.336-.895l.746-.952a1.77 1.77 0 0 1 1.286-.022l-.8 1.023 1.306.25a.56.56 0 0 1 .348.879z"
	})), _path3$50 || (_path3$50 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "m9.692 9.042 1.917 1.917a2.069 2.069 0 1 0 2.925-2.925l-1.917-1.917A4.168 4.168 0 0 0 8.6.86a4.164 4.164 0 1 0 1.093 8.182m1.163-.518 1.595 1.594a.88.88 0 0 0 1.243-1.243L12.099 7.28a4.2 4.2 0 0 1-1.244 1.244M8.6 7.998a2.974 2.974 0 1 0 0-5.948 2.974 2.974 0 0 0 0 5.948",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Warning.svg
var _path$138;
var _path2$91;
var _path3$49;
function _extends$152() {
	return _extends$152 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$152.apply(null, arguments);
}
var SvgWarning = function SvgWarning(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$152({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$138 || (_path$138 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M14.725 12.9a.515.515 0 0 1-.033.581c-.127.178-.368.319-.68.319H1.988a.85.85 0 0 1-.623-.25l4.572-2.65q-.038.158-.053.318l-.01.205.01.206c.043.478.24.944.617 1.302.425.403.972.569 1.5.569s1.075-.166 1.5-.57c.431-.408.627-.958.627-1.507a2.06 2.06 0 0 0-.618-1.504c.21-.293.338-.65.347-1.037l.006-.257 1.776-1.03z",
		opacity: .25
	})), _path2$91 || (_path2$91 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M7.997 9.498a.66.66 0 0 1-.66-.645l-.095-3.98a.755.755 0 1 1 1.51 0l-.095 3.98a.66.66 0 0 1-.66.645M8 12.3c-.564 0-.927-.346-.927-.876 0-.536.363-.882.927-.882s.927.346.927.882c0 .53-.363.876-.927.876"
	})), _path3$49 || (_path3$49 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M8 1c.626 0 1.352.282 1.749.964l6.013 10.332c.375.645.28 1.365-.095 1.887-.366.508-.98.817-1.654.817H1.987c-.674 0-1.288-.309-1.654-.817a1.72 1.72 0 0 1-.095-1.887L6.251 1.964C6.648 1.282 7.374 1 8 1m0 1.2c-.307 0-.579.139-.712.367L1.275 12.9a.515.515 0 0 0 .033.582c.127.178.368.319.68.319h12.025c.311 0 .552-.141.68-.319a.515.515 0 0 0 .032-.582L8.712 2.567C8.579 2.34 8.307 2.2 8 2.2"
	})));
};

//#endregion
//#region src/Icon/icons/Waypoint.svg
var _g$15;
var _path$137;
var _path2$90;
function _extends$151() {
	return _extends$151 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$151.apply(null, arguments);
}
var SvgWaypoint = function SvgWaypoint(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$151({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$15 || (_g$15 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "M7.962 1.898a.175.175 0 0 1 .28-.046l.711.711a2.6 2.6 0 0 0-.61.791L6.682 6.677l-.776-.775A1 1 0 0 0 6 5.794l.006-.01.064-.106zM12.08 12.083a.6.6 0 0 1-.163.12L7.96 14.18a.18.18 0 0 1-.18-.014l-.03-.026-3.369-3.37a.175.175 0 0 1 .046-.28l3.77-1.886a.9.9 0 0 0 .233-.17z" }))), _path$137 || (_path$137 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M6.887 1.361a1.376 1.376 0 0 1 2.203-.358l.992.99c-.412.093-.801.286-1.128.571l-.712-.712a.175.175 0 0 0-.28.046L6.07 5.678l-.065.107L6 5.794a.9.9 0 0 1-.331.282l-3.77 1.886a.175.175 0 0 0-.047.28l.712.712a2.6 2.6 0 0 0-.57 1.129l-.991-.992a1.377 1.377 0 0 1 .209-2.118l.006-.004.136-.078.007-.004 3.684-1.842z",
		opacity: .5
	})), _path2$90 || (_path2$90 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M11.62 3.533a1.376 1.376 0 0 0-2.202.358L7.575 7.575 3.89 9.417l-.007.004-.135.078-.007.004a1.377 1.377 0 0 0-.21 2.117l3.378 3.378a1.38 1.38 0 0 0 1.588.257l3.956-1.978c.356-.178.645-.467.823-.823l1.978-3.957c.265-.529.161-1.169-.257-1.587zM8.537 8.315l.064-.107 1.892-3.78a.175.175 0 0 1 .28-.046l3.37 3.37.026.03c.036.051.042.12.013.178l-1.978 3.955-.056.091a.64.64 0 0 1-.23.197L7.96 14.18a.18.18 0 0 1-.178-.014l-.03-.026-3.37-3.37a.175.175 0 0 1 .046-.28l3.77-1.885a.9.9 0 0 0 .332-.282z"
	})));
};

//#endregion
//#region src/Icon/icons/Webhook.svg
var _path$136;
var _path2$89;
var _path3$48;
var _path4$26;
function _extends$150() {
	return _extends$150 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$150.apply(null, arguments);
}
var SvgWebhook = function SvgWebhook(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$150({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$136 || (_path$136 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M12.83 11.44a1.4 1.4 0 1 1-2.704-.724 1.4 1.4 0 0 1 2.705.725"
	})), _path2$89 || (_path2$89 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M9.711 6.753a1.2 1.2 0 0 0-.438 1.638l2.1 3.638a.6.6 0 0 0 1.04-.6l-1.919-3.323a.43.43 0 0 1 .083-.52A3.7 3.7 0 1 0 4.603 3.43c-.136.302.058.634.378.72s.643-.11.802-.401a2.501 2.501 0 1 1 3.928 3.003M3.42 12.009a1.4 1.4 0 1 1 1.98-1.98 1.4 1.4 0 0 1-1.98 1.98"
	})), _path3$48 || (_path3$48 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M9.04 11.651a1.2 1.2 0 0 0-1.2-1.199h-4.2a.6.6 0 1 0 0 1.2h3.836c.196 0 .36.143.41.332a3.7 3.7 0 1 0 6.585-3.096c-.194-.269-.578-.266-.813-.032s-.226.612-.054.895a2.501 2.501 0 1 1-4.564 1.9M7.726 3.483a1.4 1.4 0 1 1 .725 2.705 1.4 1.4 0 0 1-.725-2.705"
	})), _path4$26 || (_path4$26 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M5.226 8.529a1.2 1.2 0 0 0 1.638-.44l2.1-3.637a.6.6 0 0 0-1.04-.6L6.008 7.174a.43.43 0 0 1-.493.19 3.7 3.7 0 1 0-.611 7.25c.33-.033.52-.368.434-.688s-.416-.502-.748-.494a2.501 2.501 0 1 1 .637-4.903"
	})));
};

//#endregion
//#region src/Icon/icons/Width.svg
var _path$135;
var _path2$88;
var _path3$47;
function _extends$149() {
	return _extends$149 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$149.apply(null, arguments);
}
var SvgWidth = function SvgWidth(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$149({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$135 || (_path$135 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M9.52 9.3c.278 0 .505-.27.478-.6C9.746 5.669 7.605 3.3 5 3.3S.254 5.668.002 8.7c-.027.33.2.6.478.6z",
		opacity: .75
	})), _path2$88 || (_path2$88 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M15.52 9.3c.278 0 .505-.27.478-.6-.252-3.032-2.393-5.4-4.998-5.4S6.254 5.668 6.002 8.7c-.027.33.2.6.478.6z",
		opacity: .5
	})), _path3$47 || (_path3$47 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M0 12.3a1.2 1.2 0 1 1 2.4 0 1.2 1.2 0 0 1-2.4 0M3.4 12.3a1.2 1.2 0 1 1 2.4 0 1.2 1.2 0 0 1-2.4 0M8 11.1a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4M10.2 12.3a1.2 1.2 0 1 1 2.4 0 1.2 1.2 0 0 1-2.4 0M14.8 11.1a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4"
	})));
};

//#endregion
//#region src/Icon/icons/WiFi.svg
var _path$134;
var _path2$87;
function _extends$148() {
	return _extends$148 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$148.apply(null, arguments);
}
var SvgWiFi = function SvgWiFi(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$148({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$134 || (_path$134 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M9.93 10.27h.001l.18.147a.85.85 0 0 1 .258.804v.007c-.069.489-.444 1.04-.891 1.463a3.5 3.5 0 0 1-.731.538c-.25.135-.509.221-.746.221-.25 0-.522-.095-.785-.24a3.6 3.6 0 0 1-.763-.582 3.6 3.6 0 0 1-.593-.759c-.15-.263-.247-.539-.247-.795v-.034c0-.23.094-.459.277-.623l.183-.149c.103-.078.25-.18.43-.282.347-.199.882-.436 1.498-.436.615 0 1.15.237 1.498.436a4 4 0 0 1 .43.284M3.553 9.032a.847.847 0 0 1 .079-1.168l.105-.09a8.802 8.802 0 0 1 1.186-.815c.312-.179.68-.363 1.09-.52a5.6 5.6 0 0 1 1.988-.389c.72 0 1.398.166 1.99.391.409.156.776.34 1.087.518a9 9 0 0 1 1.186.814l.105.09c.334.302.37.824.08 1.17a.79.79 0 0 1-1.14.084l-.003-.002-.057-.048a7.186 7.186 0 0 0-.955-.655c-.646-.37-1.465-.7-2.293-.7-.83 0-1.648.33-2.293.699a7 7 0 0 0-.955.655l-.056.048-.002.001a.793.793 0 0 1-1.142-.083"
	})), _path2$87 || (_path2$87 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M1.296 6.478a.85.85 0 0 1 .08-1.169l.152-.13a13.51 13.51 0 0 1 1.815-1.248C4.518 3.262 6.18 2.552 8 2.552c1.819 0 3.482.71 4.657 1.38a13.5 13.5 0 0 1 1.816 1.249l.149.127a.85.85 0 0 1 .082 1.171.793.793 0 0 1-1.141.084l-.002-.001-.103-.089h-.001a11.906 11.906 0 0 0-1.584-1.087C10.813 4.778 9.43 4.211 8 4.211s-2.814.567-3.873 1.172a12 12 0 0 0-1.584 1.087l-.105.09-.002.001a.793.793 0 0 1-1.14-.084"
	})));
};

//#endregion
//#region src/Icon/icons/Wired.svg
var _path$133;
function _extends$147() {
	return _extends$147 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$147.apply(null, arguments);
}
var SvgWired = function SvgWired(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$147({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$133 || (_path$133 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M9.2 8a1.2 1.2 0 1 1-2.4 0 1.2 1.2 0 0 1 2.4 0M11.508 3.264a.916.916 0 0 0-1.288.001.905.905 0 0 0 0 1.282L12.49 6.8h-.89a1.2 1.2 0 0 0 0 2.4h.889l-2.269 2.252a.904.904 0 0 0 0 1.283.916.916 0 0 0 1.288 0l4.124-4.094a.904.904 0 0 0 0-1.283zM5.779 3.265a.916.916 0 0 0-1.288 0H4.49L.367 7.357a.9.9 0 0 0 0 1.283l4.124 4.094a.916.916 0 0 0 1.288 0 .904.904 0 0 0 0-1.283L3.509 9.2h.89a1.2 1.2 0 0 0 0-2.4h-.89l2.27-2.252a.903.903 0 0 0 0-1.283"
	})));
};

//#endregion
//#region src/Icon/icons/WireGuard.svg
var _path$132;
var _path2$86;
function _extends$146() {
	return _extends$146 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$146.apply(null, arguments);
}
var SvgWireGuard = function SvgWireGuard(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$146({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$132 || (_path$132 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M4.051 8.558c-.57.093-1.526.796-1.837 1.32-.034.059-.005.137.05.15.273.057.553.076.834.095.656.045 1.32.09 1.925.628-.154.153-.414.326-.664.491a8 8 0 0 0-.433.3c-.06.046-.044.15.025.161.354.054.913.013 1.154-.009.239-.02.35-.028.447.077l.777.8c.115.119.258.184.406.186l3.824.043c.159.002.229-.259.102-.384q-.372-.363-.748-.719c-.411-.39-.822-.782-1.22-1.194a1.3 1.3 0 0 1-.188-.268s-1.068.122-2.38-.356C4.812 9.4 4.051 8.558 4.051 8.558",
		opacity: .25
	})), _path2$86 || (_path2$86 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M5.738 2.012c1.248-.06 2.58.083 3.875.913.11.07.224.137.36.217.234.139.538.318.832.543.336.257.546.632.602.725.046.075.067.11.085.135.065.092.12.187.15.236.095.045.213.073.39.085.35-.2.808-.256 1.236-.04l.103.057.148.097c.341.24.637.554.866.873.259.363.497.823.59 1.319.109.573-.195 1.4-.97 1.594a7 7 0 0 1-.44.725l-.024.035-.027.033a3 3 0 0 1-.258.284c-.108.102-.3.265-.574.368a1.45 1.45 0 0 1-1.35-.174l-.192-.004c-.442-.01-.835-.02-1.22 0 .266.263.537.525.82.795.249.237.506.481.762.732.444.437.478 1.015.376 1.402-.094.356-.476 1.047-1.331 1.038l-3.826-.043a1.78 1.78 0 0 1-1.252-.55l-.487-.501c-.312.022-.814.043-1.21-.017-.699-.105-1.007-.68-1.067-1.069a1.3 1.3 0 0 1 .027-.523 6 6 0 0 1-.715-.095 1.28 1.28 0 0 1-.947-.845 1.31 1.31 0 0 1 .112-1.09l.113-.174c.281-.398.687-.755 1.047-1.015.126-.091.27-.188.427-.28l-.023-.159c-.16-.117-.333-.233-.552-.375l-.198-.129a1.31 1.31 0 0 1-.587-1.055c-.01-.31.095-.781.531-1.1l.185-.126a3 3 0 0 1 1.182-.436 1.36 1.36 0 0 1-.05-.846c.059-.217.195-.487.466-.691.27-.204.61-.29.945-.24.19-.315.522-.602 1.07-.629m.059 1.199c-.19.01-.209.342-.025.398l1.501.46-.027.192c-.736.13-1.444-.071-2.155-.273-.196-.055-.392-.111-.588-.16-.09-.022-.129.122-.05.18q.399.286.811.535c.282.166.57.314.86.464q.192.097.384.199c-.532.597-1.066.728-1.735.527a3.2 3.2 0 0 0-1.125-.143 1.8 1.8 0 0 0-1 .359c-.056.04-.052.145.005.183l.193.126c.254.164.495.319.725.497.134.103.288.28.325.46q.113.665.168 1.34c-.568.085-1.536.795-1.85 1.324-.034.058-.005.136.05.148.274.058.554.077.834.096.657.045 1.32.09 1.925.628-.154.153-.414.325-.664.49a8 8 0 0 0-.432.3c-.06.047-.045.151.024.162.355.054.914.013 1.154-.009s.35-.029.448.077l.776.8c.116.118.259.184.406.186l3.824.043c.16.001.229-.26.102-.384q-.372-.363-.748-.719c-.41-.39-.821-.782-1.219-1.194-.208-.216-.348-.587-.444-.924-.04-.143.092-.53.18-.55a8 8 0 0 1 1.431-.193c.435-.022.87-.012 1.306-.002l.419.007c.108-.002.23-.003.288.07.286.37.51.133.71-.11q.233-.331.42-.71a2.3 2.3 0 0 0-.413-.075q-.36-.01-.718-.011a24 24 0 0 1-.952-.022c-.068-.003-.134-.067-.2-.13q-.047-.046-.092-.084.048-.026.097-.06c.07-.045.14-.091.21-.092q.56-.007 1.117-.008h1.598c.092 0 .167-.098.145-.215-.105-.552-.579-1.197-1.054-1.489-.092-.056-.19.032-.197.164-.59.019-1.168.004-1.694-.363-.094-.066-.168-.188-.24-.31q-.049-.085-.101-.163a4 4 0 0 1-.128-.2c-.093-.15-.185-.303-.304-.394a7 7 0 0 0-.717-.463q-.199-.117-.395-.24c-1.009-.646-2.06-.78-3.17-.725M9.68 6.114c.106-.106.215-.195.345-.054q.074.08.153.171l.083.094-.102.072q-.1.072-.192.133a.2.2 0 0 1-.082.037.2.2 0 0 1-.087-.008.2.2 0 0 1-.078-.05.3.3 0 0 1-.058-.086.2.2 0 0 1-.04-.073.237.237 0 0 1 .01-.173.2.2 0 0 1 .048-.063"
	})));
};

//#endregion
//#region src/Icon/icons/Wireless.svg
var _path$131;
var _path2$85;
var _path3$46;
function _extends$145() {
	return _extends$145 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$145.apply(null, arguments);
}
var SvgWireless = function SvgWireless(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$145({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$131 || (_path$131 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "m14.255 4.3-2.796 8.278a2 2 0 0 1-1.894 1.36H6.432c-.503 0-.973-.189-1.332-.508l8.847-10.692c.354.408.501.99.308 1.562",
		opacity: .25
	})), _path2$85 || (_path2$85 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M3.235.987h9.505a2.8 2.8 0 0 1 2.652 3.697l-2.796 8.278a3.2 3.2 0 0 1-3.031 2.175H6.432a3.2 3.2 0 0 1-3.03-2.168L.585 4.689A2.8 2.8 0 0 1 3.234.988m0 1.2h9.505A1.6 1.6 0 0 1 14.255 4.3l-2.796 8.278a2 2 0 0 1-1.894 1.36H6.432a2 2 0 0 1-1.893-1.356L1.72 4.303a1.6 1.6 0 0 1 1.515-2.116",
		clipRule: "evenodd"
	})), _path3$46 || (_path3$46 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M6.368 9.707a.61.61 0 0 1 .201-.466l.004-.003.119-.096a3 3 0 0 1 .287-.19c.23-.13.59-.29 1.006-.29s.775.16 1.006.29c.12.07.218.138.287.19m-2.91.565v.009c0 .182.069.373.169.55.101.178.24.353.396.507s.333.29.51.388c.176.098.364.165.542.165.169 0 .348-.061.515-.151.17-.091.338-.217.49-.36.294-.28.55-.65.598-.99a.62.62 0 0 0-.189-.585l-.12-.096-.001-.002m1.588-1.56c.245.218.27.598.06.85a.58.58 0 0 1-.835.061l-.037-.031-.128-.102a5 5 0 0 0-.483-.318c-.415-.237-.936-.446-1.458-.446-.523 0-1.043.209-1.458.446a4.6 4.6 0 0 0-.611.42l-.036.03a.58.58 0 0 1-.836-.06.616.616 0 0 1 .059-.85l.069-.06q.062-.052.172-.136c.146-.11.354-.255.608-.4.205-.118.448-.24.718-.342.39-.148.838-.258 1.315-.258.478 0 .927.11 1.317.259.269.102.51.224.715.34a6 6 0 0 1 .78.536zm1.367-1.746.098.084c.244.219.272.6.06.851a.58.58 0 0 1-.834.062l-.067-.058a7.66 7.66 0 0 0-1.02-.7c-.684-.391-1.572-.754-2.485-.754-.914 0-1.801.363-2.485.754a7.7 7.7 0 0 0-1.02.7l-.068.058a.58.58 0 0 1-.834-.062.616.616 0 0 1 .058-.85l.1-.085a8.844 8.844 0 0 1 1.19-.818c.767-.439 1.86-.906 3.059-.906 1.198 0 2.29.467 3.06.906a9 9 0 0 1 1.188.818",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/WirelessIDS.svg
var _g$14;
var _path$130;
var _path2$84;
var _path3$45;
var _path4$25;
function _extends$144() {
	return _extends$144 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$144.apply(null, arguments);
}
var SvgWirelessIds = function SvgWirelessIds(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$144({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _g$14 || (_g$14 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .25
	}, /*#__PURE__*/ React.createElement("path", { d: "m13.634 6.14.621-1.84a1.59 1.59 0 0 0-.308-1.562l-2.524 3.05q.284-.079.578-.088h.098c.263.008.524.059.772.153zM7.643 13.938a5.7 5.7 0 0 1-.588-1.708c-.061-.343-.1-.684-.124-1.012L5.1 13.43c.358.32.828.508 1.33.508zM12.05 14.669q.13 0 .25-.06c1.315-.673 2.127-1.64 2.333-2.806.147-.834.13-1.687.085-2.281a.584.584 0 0 0-.378-.496l-1.937-.732a1 1 0 0 0-.353-.064z" }))), _path$130 || (_path$130 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M12.74.987H3.234A2.8 2.8 0 0 0 .585 4.69l2.818 8.279a3.2 3.2 0 0 0 3.029 2.169H8.49a6 6 0 0 1-.847-1.2H6.432a2 2 0 0 1-1.893-1.356L1.72 4.303a1.6 1.6 0 0 1 1.515-2.116h9.505A1.6 1.6 0 0 1 14.255 4.3l-.621 1.84 1.123.425.635-1.881A2.8 2.8 0 0 0 12.74.987"
	})), _path2$84 || (_path2$84 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "m12.064 5.7-.091-.07a9 9 0 0 0-.929-.612c-.768-.439-1.86-.906-3.06-.906-1.198 0-2.29.467-3.059.906a9 9 0 0 0-1.19.818l-.099.085c-.244.219-.27.599-.058.85a.58.58 0 0 0 .834.062l.068-.058a7.668 7.668 0 0 1 1.02-.7c.684-.391 1.571-.754 2.485-.754s1.8.363 2.484.754l.068.039.691-.261c.249-.094.51-.145.773-.153h.063"
	})), _path3$45 || (_path3$45 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M9.215 6.613a3.7 3.7 0 0 0-1.23-.227c-.477 0-.926.11-1.315.258-.27.103-.513.224-.718.341a6 6 0 0 0-.78.537l-.07.06a.616.616 0 0 0-.058.85.58.58 0 0 0 .836.06l.036-.03.128-.102a5 5 0 0 1 .483-.318c.274-.157.595-.301.932-.381a2.4 2.4 0 0 1 1.05-.782zM6.973 8.956a3 3 0 0 0-.281.186l-.119.096-.004.003a.61.61 0 0 0-.2.466l-.001.009c0 .182.069.373.169.55.095.168.224.332.37.48-.024-.732.022-1.37.066-1.79"
	})), _path4$25 || (_path4$25 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8.18 8.969c-.07.603-.16 1.825.056 3.052.316 1.787 1.62 3.093 3.37 3.88q.204.092.427.098l.017.001h.017c.146-.005.292-.038.428-.1 1.75-.786 3.053-2.092 3.369-3.88.217-1.226.126-2.448.057-3.051a1.18 1.18 0 0 0-.755-.967l-2.719-1.027a1.2 1.2 0 0 0-.382-.075h-.03q-.197.006-.383.075L8.934 8.002a1.18 1.18 0 0 0-.755.967m6.538.553c.045.595.062 1.447-.085 2.281-.206 1.166-1.018 2.133-2.334 2.806a.55.55 0 0 1-.498 0c-1.316-.673-2.128-1.64-2.334-2.806a7 7 0 0 1-.04-.255 9.8 9.8 0 0 1-.045-2.026.58.58 0 0 1 .378-.496l1.937-.731a1 1 0 0 1 .706 0l1.937.731a.58.58 0 0 1 .378.496",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/icons/Workbench.svg
var _path$129;
var _g$13;
var _path2$83;
var _path3$44;
function _extends$143() {
	return _extends$143 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$143.apply(null, arguments);
}
var SvgWorkbench = function SvgWorkbench(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$143({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$129 || (_path$129 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M5.132 1.872c-.609 0-1.103.494-1.103 1.103V4.96c0 .61.494 1.103 1.103 1.103h5.295c.609 0 1.102-.494 1.102-1.103V2.975c0-.61-.493-1.103-1.102-1.103z",
		clipRule: "evenodd",
		opacity: .25
	})), _g$13 || (_g$13 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .5
	}, /*#__PURE__*/ React.createElement("path", { d: "M6.139 7.386h3.515v1.007H6.14zM3.588 12.987v-3.05h8.824v3.05z" }))), _path2$83 || (_path2$83 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M5.132.548h5.295a2.427 2.427 0 0 1 2.426 2.427V4.96a2.426 2.426 0 0 1-2.426 2.426H5.132A2.426 2.426 0 0 1 2.706 4.96V2.975A2.426 2.426 0 0 1 5.132.548m0 1.324c-.609 0-1.103.494-1.103 1.103V4.96c0 .61.494 1.103 1.103 1.103h5.295c.609 0 1.102-.494 1.102-1.103V2.975c0-.61-.493-1.103-1.102-1.103z",
		clipRule: "evenodd"
	})), _path3$44 || (_path3$44 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M1.272 8.393h13.456a.772.772 0 1 1 0 1.544h-.993v4.853a.662.662 0 0 1-1.323 0V9.937H3.588v4.853a.662.662 0 0 1-1.323 0V9.937h-.993a.772.772 0 1 1 0-1.544"
	})));
};

//#endregion
//#region src/Icon/icons/Wrench.svg
var _path$128;
var _path2$82;
function _extends$142() {
	return _extends$142 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$142.apply(null, arguments);
}
var SvgWrench = function SvgWrench(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$142({
		xmlns: "http://www.w3.org/2000/svg",
		width: 16,
		height: 16,
		fill: "none",
		viewBox: "0 0 16 16"
	}, props), _path$128 || (_path$128 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M13.518 13.054c.47-.47.47-1.232 0-1.703L8.773 7.23s-.153.595-.523 1.084c-.37.488-1.04.758-1.04.758l4.606 3.983c.47.47 1.232.47 1.702 0",
		opacity: .25
	})), _path2$82 || (_path2$82 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M4.91 2.853a.05.05 0 0 1 .018-.083l.088-.029c.354-.111.711-.16 1.062-.145q.177.007.353.036c.622.103 1.214.41 1.725.921.58.582.859 1.393.87 2.225a4 4 0 0 1-.253 1.45l4.745 4.123a1.204 1.204 0 1 1-1.702 1.703L7.21 9.071a4 4 0 0 1-1.265.439c-1.082.185-2.233-.058-2.983-.808a2.78 2.78 0 0 1-.768-1.418 3 3 0 0 1-.051-.345 3.8 3.8 0 0 1 .077-1.158.05.05 0 0 1 .082-.026l1.91 1.736a.6.6 0 0 0 .607.12l1.5-.538a.6.6 0 0 0 .369-.38l.418-1.297a.6.6 0 0 0-.159-.62zm.646 3.345a.2.2 0 0 0 .158-.158l.064-.326a.6.6 0 0 0-.176-.553L4.084 3.728c-.671-.634-.456-1.783.452-2.096 1.586-.547 3.24-.161 4.471 1.07.933.932 1.277 2.212 1.216 3.39q-.02.391-.1.784L14.37 10.5a2.408 2.408 0 0 1-3.406 3.406L6.935 10.5c-.46.153-.937.241-1.408.266-1.183.062-2.48-.276-3.417-1.213C.931 8.374.762 6.843 1.043 5.53c.206-.964 1.367-1.303 2.069-.665L4.53 6.153a.6.6 0 0 0 .52.144z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/Icon/index.ts
const IconSVG = {
	AccessControl: SvgAccessControl,
	AccessPoint: SvgAccessPoint,
	AccessPointBackup: SvgAccessPointBackup,
	AccessPointCycle: SvgAccessPointCycle,
	AccessPointRogue: SvgAccessPointRogue,
	AccessPointScan: SvgAccessPointScan,
	AccessPoints: SvgAccessPoints,
	AirPlay: SvgAirPlay,
	Airtable: SvgAirtable$1,
	Allowlist: SvgAllowlist,
	Alpha: SvgAlpha,
	Anchor: SvgAnchor,
	Antenna: SvgAntenna,
	API: SvgApi,
	Application: SvgApplication,
	Archive: SvgArchive,
	Area: SvgArea,
	ArrowBottom: SvgArrowBottom,
	ArrowDown: SvgArrowDown,
	ArrowDownLeft: SvgArrowDownLeft,
	ArrowDownRight: SvgArrowDownRight,
	ArrowEnd: SvgArrowEnd,
	ArrowLeft: SvgArrowLeft,
	ArrowsLeftRight: SvgArrowsLeftRight,
	ArrowRight: SvgArrowRight,
	ArrowStart: SvgArrowStart,
	ArrowTop: SvgArrowTop,
	ArrowUp: SvgArrowUp,
	ArrowUpLeft: SvgArrowUpLeft,
	ArrowUpRight: SvgArrowUpRight,
	ArrowsCorners: SvgArrowsCorners,
	ArrowsDiagonal: SvgArrowsDiagonal,
	ArrowsDiagonalReverse: SvgArrowsDiagonalReverse,
	ArrowsMove: SvgArrowsMove,
	ArrowsRotate: SvgArrowsRotate,
	ArrowsUpDown: SvgArrowsUpDown,
	Attach: SvgAttach,
	Attention: SvgAttention,
	Attributes: SvgAttributes,
	Automated: SvgAutomated,
	AutoVPN: SvgAutoVpn$1,
	Backspace: SvgBackspace,
	Bell: SvgBell,
	BellCrossed: SvgBellCrossed,
	BellFilled: SvgBellFilled,
	Beta: SvgBeta,
	BestPath: SvgBestPath,
	BGP: SvgBgp,
	BillOfMaterials: SvgBillOfMaterials,
	Block: SvgBlock,
	Blocklist: SvgBlocklist,
	Bookmark: SvgBookmark,
	BookmarkFilled: SvgBookmarkFilled,
	BookmarkOne: SvgBookmarkOne,
	BookmarkThree: SvgBookmarkThree,
	BookmarkTwo: SvgBookmarkTwo,
	Bug: SvgBug,
	Calculator: SvgCalculator,
	Calendar: SvgCalendar,
	CaptivePortal: SvgCaptivePortal,
	Cards: SvgCards,
	Cellular: SvgCellular$1,
	Changelog: SvgChangelog,
	Channel: SvgChannel,
	ChannelCycle: SvgChannelCycle,
	ChartBar: SvgChartBar,
	ChartLine: SvgChartLine,
	Chat: SvgChat,
	Checkmark: SvgCheckmark,
	CheckmarkCircle: SvgCheckmarkCircle,
	ChevronDown: SvgChevronDown,
	ChevronLeft: SvgChevronLeft,
	ChevronRight: SvgChevronRight,
	ChevronsHorizontal: SvgChevronsHorizontal,
	ChevronsVertical: SvgChevronsVertical,
	ChevronUp: SvgChevronUp,
	Client: SvgClient,
	ClientVPN: SvgClientVpn,
	Clock: SvgClock,
	Cloud: SvgCloud,
	CloudCheckmark: SvgCloudCheckmark,
	CloudCross: SvgCloudCross,
	CloudDown: SvgCloudDown,
	Cloudflare: SvgCloudflare$1,
	CloudPending: SvgCloudPending,
	CloudUp: SvgCloudUp,
	Code: SvgCode,
	Cog: SvgCog,
	Columns: SvgColumns,
	Command: SvgCommand$1,
	Company: SvgCompany,
	CompanyCam: SvgCompanyCam,
	Compass: SvgCompass,
	Connect: SvgConnect$1,
	Connection: SvgConnection,
	ConnectionConnected: SvgConnectionConnected,
	ConnectionDisassociated: SvgConnectionDisassociated,
	ConnectionFailed: SvgConnectionFailed,
	Console: SvgConsole,
	Context: SvgContext,
	Copy: SvgCopy,
	Cross: SvgCross,
	CrossCircle: SvgCrossCircle,
	Crown: SvgCrown,
	Cut: SvgCut,
	Data: SvgData,
	DataCycle: SvgDataCycle,
	Deliverable: SvgDeliverable,
	Description: SvgDescription,
	Design: SvgDesign,
	Detection: SvgDetection,
	DetectionNetwork: SvgDetectionNetwork,
	DetectionWireless: SvgDetectionWireless,
	DHCP: SvgDhcp,
	Diagnostics: SvgDiagnostics,
	Digest: SvgDigest,
	Disable: SvgDisable,
	DNS: SvgDns,
	DNSGenerateMaps: SvgDnsGenerateMaps,
	DNSSecurity: SvgDnsSecurity,
	Dock: SvgDock,
	Document: SvgDocument,
	DocumentCSV: SvgDocumentCsv,
	DocumentPNG: SvgDocumentPng,
	Documentation: SvgDocumentation,
	Documents: SvgDocuments,
	Download: SvgDownload,
	DragHorizontal: SvgDragHorizontal,
	DragVertical: SvgDragVertical,
	DynamicVLAN: SvgDynamicVlan,
	Email: SvgEmail,
	EthernetConfig: SvgEthernetConfig,
	EthernetDown: SvgEthernetDown,
	EthernetDownCycle: SvgEthernetDownCycle,
	EthernetFlipped: SvgEthernetFlipped,
	EthernetUp: SvgEthernetUp,
	EthernetUpCycle: SvgEthernetUpCycle,
	EthernetUsage: SvgEthernetUsage,
	Export: SvgExport,
	EyeClosed: SvgEyeClosed,
	EyeOpen: SvgEyeOpen,
	Filter: SvgFilter,
	Fingerprint: SvgFingerprint,
	Firewall: SvgFirewall,
	Flag: SvgFlag,
	FloorPlan: SvgFloorPlan,
	Folder: SvgFolder,
	Gateway: SvgGateway,
	Gavel: SvgGavel,
	Globe: SvgGlobe,
	GlobeOne: SvgGlobeOne,
	GlobeThree: SvgGlobeThree,
	GlobeTwo: SvgGlobeTwo,
	Group: SvgGroup,
	Hamina: SvgHamina,
	Hardware: SvgHardware,
	Heart: SvgHeart,
	HeartFilled: SvgHeartFilled,
	HeartHalf: SvgHeartHalf,
	HighAvailability: SvgHighAvailability,
	Home: SvgHome,
	Honeypot: SvgHoneypot,
	HostMonitoring: SvgHostMonitoring,
	Hotspot20: SvgHotspot20,
	Hose: SvgHose,
	Hourglass: SvgHourglass,
	Hub: SvgHub$1,
	Inbox: SvgInbox,
	InboxUnread: SvgInboxUnread,
	Information: SvgInformation,
	Insights: SvgInsights,
	Inspector: SvgInspector,
	Integrations: SvgIntegrations,
	Intercom: SvgIntercom,
	Interface: SvgInterface,
	InterVLAN: SvgInterVlan,
	IPAddress: SvgIpAddress,
	IPForward: SvgIpForward,
	IPSecTunnel: SvgIpSecTunnel,
	Issue: SvgIssue,
	Jitter: SvgJitter,
	Key: SvgKey,
	Keyboard: SvgKeyboard,
	KeyboardSpacebar: SvgKeyboardSpacebar,
	Layer3: SvgLayer3,
	LED: SvgLed,
	LEDFlash: SvgLedFlash,
	LifeRing: SvgLifeRing,
	Lightbulb: SvgLightbulb,
	Lightning: SvgLightning,
	LightningCycle: SvgLightningCycle,
	LightningDisabled: SvgLightningDisabled,
	LightningFilled: SvgLightningFilled,
	List: SvgList,
	Location: SvgLocation,
	Locations: SvgLocations,
	Log: SvgLog,
	MACAddress: SvgMacAddress,
	Magnet: SvgMagnet,
	Map: SvgMap,
	Megaphone: SvgMegaphone,
	Menu: SvgMenu,
	Meter: SvgMeter$1,
	Microchip: SvgMicrochip,
	MicrochipCheckmark: SvgMicrochipCheckmark,
	MicrochipClock: SvgMicrochipClock,
	MicrochipCross: SvgMicrochipCross,
	MicrochipUpgrade: SvgMicrochipUpgrade,
	Minus: SvgMinus,
	MinusCircle: SvgMinusCircle,
	MoneyBag: SvgMoneyBag,
	Moon: SvgMoon,
	Mouse: SvgMouse,
	MouseLeftClick: SvgMouseLeftClick,
	MouseRightClick: SvgMouseRightClick,
	MouseWheel: SvgMouseWheel,
	Move: SvgMove,
	MulticastDNS: SvgMulticastDns,
	NAT: SvgNat,
	NetworkIDS: SvgNetworkIds,
	NetworkWide: SvgNetworkWide,
	Noise: SvgNoise,
	Note: SvgNote,
	Observer: SvgObserver,
	Onboarding: SvgOnboarding,
	Operator: SvgOperator$1,
	Outlet: SvgOutlet$1,
	OverflowHorizontal: SvgOverflowHorizontal,
	OverflowHorizontalCircle: SvgOverflowHorizontalCircle,
	OverflowVertical: SvgOverflowVertical,
	OverflowVerticalCircle: SvgOverflowVerticalCircle,
	PacketCapture: SvgPacketCapture,
	Padlock: SvgPadlock,
	PadlockContent: SvgPadlockContent,
	PaneBottom: SvgPaneBottom,
	PaneEnd: SvgPaneEnd,
	PaneEndCollapse: SvgPaneEndCollapse,
	PaneEndExpand: SvgPaneEndExpand,
	PaneStart: SvgPaneStart,
	PaneStartCollapse: SvgPaneStartCollapse,
	PaneStartExpand: SvgPaneStartExpand,
	PaneTop: SvgPaneTop,
	Parts: SvgParts,
	Paste: SvgPaste,
	Patching: SvgPatching,
	Pattern: SvgPattern,
	Pause: SvgPause,
	PDU: SvgPdu,
	Pencil: SvgPencil,
	Phone: SvgPhone,
	Picker: SvgPicker,
	Pin: SvgPin,
	Ping: SvgPing,
	PingPong: SvgPingPong,
	Placeholder: SvgPlaceholder,
	Play: SvgPlay,
	Plus: SvgPlus,
	PlusCircle: SvgPlusCircle,
	Policy: SvgPolicy,
	PortForward: SvgPortForward,
	Power: SvgPower,
	PowerCycle: SvgPowerCycle,
	PowerHistory: SvgPowerHistory,
	Preferences: SvgPreferences,
	Printer: SvgPrinter,
	PriorityHigh: SvgPriorityHigh,
	PriorityHighest: SvgPriorityHighest,
	PriorityLow: SvgPriorityLow,
	PriorityLowest: SvgPriorityLowest,
	PriorityMedium: SvgPriorityMedium,
	Probe: SvgProbe,
	Project: SvgProject,
	Protect: SvgProtect,
	Pulse: SvgPulse,
	QRCode: SvgQrCode,
	Question: SvgQuestion,
	Rack: SvgRack,
	Radar: SvgRadar,
	RadioProfile: SvgRadioProfile,
	Radius: SvgRadius,
	RateLimit: SvgRateLimit,
	ReadOnly: SvgReadOnly,
	Redo: SvgRedo,
	Reserve: SvgReserve,
	Reset: SvgReset,
	Ribbon: SvgRibbon,
	Rocket: SvgRocket,
	Route: SvgRoute,
	RoundTrip: SvgRoundTrip,
	Routing: SvgRouting,
	Rules: SvgRules,
	Salesforce: SvgSalesforce$1,
	Save: SvgSave,
	Search: SvgSearch,
	SearchDomain: SvgSearchDomain,
	SearchScoped: SvgSearchScoped,
	SearchService: SvgSearchService,
	Secure: SvgSecure,
	Select: SvgSelect,
	Service: SvgService,
	Share: SvgShare,
	Ship: SvgShip,
	Signout: SvgSignout,
	SFP: SvgSfp$1,
	SFPDown: SvgSfpDown,
	SFPUp: SvgSfpUp,
	SiteToSite: SvgSiteToSite,
	Slack: SvgSlack$1,
	SlideHorizontal: SvgSlideHorizontal,
	SlideVertical: SvgSlideVertical,
	Snowflake: SvgSnowflake,
	SPAN: SvgSpan,
	Spaces: SvgSpaces,
	Spare: SvgSpare,
	Speaker: SvgSpeaker,
	SpeedTest: SvgSpeedTest,
	SpeedTestMedium: SvgSpeedTestMedium,
	SpeedTestHigh: SvgSpeedTestHigh,
	SpeedTestLow: SvgSpeedTestLow,
	Spotlight: SvgSpotlight,
	SSID: SvgSsid,
	SSIDThreat: SvgSsidThreat,
	Stamp: SvgStamp,
	Star: SvgStar,
	StarCrossed: SvgStarCrossed,
	StarFilled: SvgStarFilled,
	Stop: SvgStop,
	Sun: SvgSun,
	Switch: SvgSwitch,
	Table: SvgTable,
	Tag: SvgTag,
	Tasks: SvgTasks,
	Template: SvgTemplate,
	Test: SvgTest,
	ThumbsDown: SvgThumbsDown,
	ThumbsUp: SvgThumbsUp,
	Toolbox: SvgToolbox,
	Toolshed: SvgToolshed,
	Topology: SvgTopology,
	TrafficLight: SvgTrafficLight,
	TrafficShaping: SvgTrafficShaping,
	TrashCan: SvgTrashCan,
	Tunnel: SvgTunnel,
	Twinkle: SvgTwinkle,
	Undo: SvgUndo,
	Unhealthy: SvgUnhealthy,
	Upgrading: SvgUpgrading,
	Upload: SvgUpload,
	User: SvgUser,
	Users: SvgUsers,
	Version: SvgVersion,
	View: SvgView,
	VirtualDevice: SvgVirtualDevice,
	VLAN: SvgVlan,
	VPN: SvgVpn,
	Vulnerability: SvgVulnerability,
	Warning: SvgWarning,
	Waypoint: SvgWaypoint,
	Webhook: SvgWebhook,
	Width: SvgWidth,
	WiFi: SvgWiFi,
	Wired: SvgWired,
	Wireless: SvgWireless,
	WirelessIDS: SvgWirelessIds,
	WireGuard: SvgWireGuard,
	Workbench: SvgWorkbench,
	Wrench: SvgWrench
};

//#endregion
//#region src/Logo/icons/Initial.svg
var _path$127;
function _extends$141() {
	return _extends$141 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$141.apply(null, arguments);
}
var SvgInitial = function SvgInitial(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$141({
		xmlns: "http://www.w3.org/2000/svg",
		width: 10,
		height: 8,
		fill: "none",
		viewBox: "0 0 10 8"
	}, props), _path$127 || (_path$127 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M7.88.243c1.346 0 2.117.809 2.117 2.218v4.941H8.725V3.097c0-1.335-.529-1.692-1.237-1.692-.974 0-1.604 1.056-1.604 2.864v3.133H4.612V3.097c0-1.25-.465-1.692-1.244-1.692-.983 0-1.596 1.141-1.596 2.864v3.133H.5V.352h1.273v1.11C2.205.654 2.907.242 3.823.242S5.49.731 5.75 1.59C6.13.765 6.911.242 7.88.242"
	})));
};

//#endregion
//#region src/Logo/icons/Word.svg
var _path$126;
function _extends$140() {
	return _extends$140 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$140.apply(null, arguments);
}
var SvgWord = function SvgWord(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$140({
		xmlns: "http://www.w3.org/2000/svg",
		width: 33,
		height: 10,
		fill: "none",
		viewBox: "0 0 33 10"
	}, props), _path$126 || (_path$126 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M7.88 2.618c1.346 0 2.117.809 2.117 2.218v4.941H8.725V5.472c0-1.335-.529-1.692-1.237-1.692-.974 0-1.604 1.056-1.604 2.864v3.133H4.612V5.472c0-1.25-.465-1.692-1.244-1.692-.983 0-1.596 1.141-1.596 2.864v3.133H.5v-7.05h1.273v1.11c.432-.808 1.134-1.22 2.05-1.22s1.667.489 1.926 1.348c.381-.825 1.162-1.348 2.13-1.348M19.7.25l-1.273.803V2.73h-1.197v1.163h1.197v3.655c0 1.49.753 2.342 2.067 2.342.372 0 .796-.117.998-.221v-1.21c-.367.2-.672.268-.93.268-.556 0-.863-.384-.863-1.083V3.89h1.793V2.728h-1.793zm12.28 2.368c-.744 0-1.57.382-1.978 1.22v-1.11h-1.273v7.05h1.273V6.64c0-1.64.627-2.86 1.88-2.86.314 0 .619.092.619.092v-1.21a3 3 0 0 0-.522-.045m-15.088 5.4c-.684 1.3-1.536 1.87-2.952 1.87-1.014 0-1.812-.354-2.371-1.053-.555-.726-.824-1.57-.824-2.581q.002-1.517.824-2.567c.564-.719 1.34-1.068 2.37-1.068 1.032 0 1.787.332 2.342.984.574.644.853 1.417.853 2.363v.595h-5.085c.018 1.291.792 2.165 1.89 2.165.896 0 1.433-.352 1.836-1.208zm-4.764-2.622h3.665c-.107-1.036-.899-1.616-1.852-1.616s-1.63.572-1.811 1.616zm15.631 2.621c-.683 1.302-1.535 1.871-2.952 1.871-1.014 0-1.811-.354-2.37-1.053-.555-.726-.825-1.57-.825-2.581q.001-1.517.825-2.567c.563-.719 1.339-1.068 2.37-1.068s1.787.332 2.342.984c.573.644.853 1.417.853 2.363v.595h-5.086c.019 1.291.792 2.165 1.891 2.165.895 0 1.432-.352 1.835-1.208l1.117.5m-4.763-2.62h3.664c-.106-1.037-.898-1.617-1.852-1.617s-1.63.572-1.811 1.616z"
	})));
};

//#endregion
//#region src/Logo/index.ts
const LogoSVG = {
	Word: SvgWord,
	Initial: SvgInitial
};

//#endregion
//#region src/ManufacturerIcon/icons/Amazon.svg
var _path$125;
var _path2$81;
function _extends$139() {
	return _extends$139 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$139.apply(null, arguments);
}
var SvgAmazon = function SvgAmazon(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$139({
		xmlns: "http://www.w3.org/2000/svg",
		width: 28,
		height: 28,
		fill: "none",
		viewBox: "0 0 28 28"
	}, props), _path$125 || (_path$125 = /*#__PURE__*/ React.createElement("path", {
		fill: "#F90",
		fillRule: "evenodd",
		d: "M3.616 20.915c3.725 2.27 9.491 5.786 18.681 1.412.396-.165.673.111.28.611-.394.505-3.548 3.398-8.85 3.398-5.297 0-9.356-3.62-10.594-5.121-.34-.39.052-.566.282-.423zm18.978-.328c.803-.1 2.08-.038 2.331.289.191.25-.006 1.369-.33 2.172-.326.798-.811 1.362-1.08 1.58-.271.218-.471.134-.327-.193.15-.328.97-2.357.646-2.783-.302-.393-1.668-.25-2.303-.184l-.128.013q-.2.019-.33.034c-.273.03-.346.038-.387-.046-.105-.295 1.103-.787 1.908-.883",
		clipRule: "evenodd"
	})), _path2$81 || (_path2$81 = /*#__PURE__*/ React.createElement("path", {
		fill: "#000",
		fillRule: "evenodd",
		d: "M16.005 13.4v-.81c-2.168 0-4.459.465-4.459 3.021 0 1.295.67 2.172 1.822 2.172.844 0 1.6-.518 2.076-1.362.564-.99.562-1.923.561-3.021m2.316 7.223c.224.118.51.105.709-.072l.008.008a127 127 0 0 1 2.3-1.99c.244-.203.202-.528.008-.798l-.177-.24c-.49-.66-.954-1.286-.954-2.54v-4.674l.002-.476c.01-1.793.02-3.43-1.322-4.683-1.152-1.106-3.059-1.494-4.518-1.494-2.852 0-6.037 1.063-6.708 4.59-.067.375.203.574.447.629l2.911.312c.27-.013.468-.279.52-.549.248-1.215 1.269-1.801 2.412-1.801.616 0 1.316.228 1.683.78.375.553.37 1.29.364 1.95v.611q-.424.047-.88.093c-1.576.162-3.396.348-4.761.949-1.877.81-3.198 2.468-3.198 4.902 0 3.117 1.966 4.674 4.489 4.674 2.134 0 3.299-.502 4.944-2.181q.129.187.237.347c.388.574.646.957 1.484 1.653",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/ManufacturerIcon/icons/Amcrest.svg
var _path$124;
var _path2$80;
function _extends$138() {
	return _extends$138 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$138.apply(null, arguments);
}
var SvgAmcrest = function SvgAmcrest(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$138({
		xmlns: "http://www.w3.org/2000/svg",
		width: 28,
		height: 28,
		fill: "none",
		viewBox: "0 0 28 28"
	}, props), _path$124 || (_path$124 = /*#__PURE__*/ React.createElement("path", {
		fill: "#1C234F",
		d: "M3.593 7.999 14.03 1.966 24.407 8v8.358l-3.19-1.79V9.81L14.03 5.59 6.743 9.81v4.756l-3.15 1.791z"
	})), _path2$80 || (_path2$80 = /*#__PURE__*/ React.createElement("path", {
		fill: "#1C234F",
		d: "m15.699 13.022-1.627-.988-1.791.988v1.997l1.791.927 1.627-.927zM21.278 21.854l-7.247 4.18-7.288-4.18V18.19l7.288 4.2 7.247-4.2z"
	})));
};

//#endregion
//#region src/ManufacturerIcon/icons/Apple.svg
function _extends$137() {
	return _extends$137 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$137.apply(null, arguments);
}
var SvgApple$1 = function SvgApple(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$137({
		xmlns: "http://www.w3.org/2000/svg",
		width: 28,
		height: 28,
		fill: "none",
		viewBox: "0 0 28 28"
	}, props), /*#__PURE__*/ React.createElement("path", {
		fill: "#D3D6E0",
		d: "M20.175 23.114c-1.193 1.158-2.51.978-3.765.432-1.334-.557-2.554-.593-3.963 0-1.755.757-2.686.537-3.743-.432-5.966-6.143-5.086-15.5 1.696-15.852 1.644.088 2.796.91 3.765.978 1.44-.293 2.818-1.132 4.359-1.022q2.775.224 4.16 2.195c-3.808 2.29-2.905 7.31.593 8.719-.7 1.838-1.598 3.654-3.104 4.997zM14.032 7.196c-.178-2.73 2.035-4.976 4.58-5.196.35 3.148-2.862 5.504-4.58 5.196",
		style: { mixBlendMode: "multiply" }
	}));
};

//#endregion
//#region src/ManufacturerIcon/icons/Arista.svg
var _path$123;
function _extends$136() {
	return _extends$136 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$136.apply(null, arguments);
}
var SvgArista = function SvgArista(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$136({
		xmlns: "http://www.w3.org/2000/svg",
		width: 28,
		height: 28,
		fill: "none",
		viewBox: "0 0 28 28"
	}, props), _path$123 || (_path$123 = /*#__PURE__*/ React.createElement("path", {
		fill: "#16325B",
		d: "M12.111 5.792C11.334 7.014 1 23.348 1 23.348h3.667l3.444-5.556h7.333l1.89-3H10l4-6.444 9.333 14.888H27S16.778 7.126 15.889 5.681c-1-1.444-2.778-1.333-3.778.111"
	})));
};

//#endregion
//#region src/ManufacturerIcon/icons/ASIX.svg
var _path$122;
var _path2$79;
var _path3$43;
function _extends$135() {
	return _extends$135 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$135.apply(null, arguments);
}
var SvgAsix = function SvgAsix(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$135({
		xmlns: "http://www.w3.org/2000/svg",
		width: 28,
		height: 28,
		fill: "none",
		viewBox: "0 0 28 28"
	}, props), _path$122 || (_path$122 = /*#__PURE__*/ React.createElement("path", {
		fill: "#0D3A7D",
		fillRule: "evenodd",
		d: "M6.56 24.706h14.88A11.98 11.98 0 0 0 26 15.29c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 3.818 1.783 7.219 4.56 9.416M2.293 15.29C2.292 8.824 7.534 3.582 14 3.582S25.708 8.824 25.708 15.29c0 3.688-1.705 6.978-4.37 9.124H6.662a11.69 11.69 0 0 1-4.37-9.124",
		clipRule: "evenodd"
	})), _path2$79 || (_path2$79 = /*#__PURE__*/ React.createElement("path", {
		fill: "#0D3A7D",
		fillRule: "evenodd",
		d: "M6.63 5.82q-.185.142-.36.292h.5v2.093H4.58v-.35q-.248.313-.474.642h.182v2.094H2.955a12 12 0 0 0-.12.292h1.453v2.093H2.223q-.029.145-.053.292h2.118v2.045H2q0 .146.004.292h2.284v2.142H2.252q.03.147.064.292h1.972v2.093H3.017q.065.147.134.292h1.137v1.916q.142.195.292.385v-.013h2.19v1.994h.293v-1.994h1.996v1.994h.292v-1.994h2.093v1.994h.292v-1.994h2.142v1.994h.292v-1.994h2.045v1.994h.292v-1.994H18.6v1.994h.292v-1.994h2.094v1.994h.292v-1.994h2.093v.074q.15-.187.292-.38v-1.982h1.186q.069-.144.134-.292h-1.32V18.04h2.02q.035-.146.065-.292h-2.085v-2.142h2.333q.004-.146.004-.292h-2.337v-2.045h2.167l-.053-.292h-2.114v-2.093h1.502a12 12 0 0 0-.12-.292h-1.382V8.497h.23a12 12 0 0 0-.207-.292h-.023v-.031a12 12 0 0 0-.292-.38v.411h-2.093V6.112h.453q-.177-.15-.36-.292h-.093v-.072a12 12 0 0 0-.292-.216v.288h-2.094V4.33a12 12 0 0 0-.292-.126V5.82h-2.093V3.552q-.145-.03-.292-.058V5.82H14.17V3.29h-.292V5.82h-2.142V3.503l-.292.06V5.82H9.351V4.224q-.147.062-.292.127V5.82H7.063v-.323q-.148.105-.292.214v.109zm.433.292v2.093h1.996V6.112zm2.288 0v2.093h2.093V6.112zm2.385 0v2.093h2.142V6.112zm2.434 0v2.093h2.045V6.112zm2.337 0v2.093H18.6V6.112zm2.385 0v2.093h2.094V6.112zM4.58 10.59V8.497h2.19v2.094zm2.483 0V8.497h1.996v2.094zm2.288 0V8.497h2.093v2.094zm2.385 0V8.497h2.142v2.094zm2.434 0V8.497h2.045v2.094zm2.337 0V8.497H18.6v2.094zm2.385 0V8.497h2.094v2.094zm2.386 0V8.497h2.093v2.094zm-16.698.292v2.093h2.19v-2.093zm2.483 0v2.093h1.996v-2.093zm2.288 0v2.093h2.093v-2.093zm2.385 0v2.093h2.142v-2.093zm2.434 0v2.093h2.045v-2.093zm2.337 0v2.093H18.6v-2.093zm2.385 0v2.093h2.094v-2.093zm2.386 0v2.093h2.093v-2.093zM4.58 15.313v-2.045h2.19v2.045zm2.483 0v-2.045h1.996v2.045zm2.288 0v-2.045h2.093v2.045zm2.385 0v-2.045h2.142v2.045zm2.434 0v-2.045h2.045v2.045zm2.337 0v-2.045H18.6v2.045zm2.385 0v-2.045h2.094v2.045zm2.386 0v-2.045h2.093v2.045zM4.58 22.42h2.19v-1.996H4.58zm2.483 0h1.996v-1.996H7.063zm2.288 0h2.093v-1.996H9.351zm2.385 0h2.142v-1.996h-2.142zm2.434 0h2.045v-1.996H14.17zm2.337 0H18.6v-1.996h-2.093zm2.385 0h2.094v-1.996h-2.094zm2.386 0h2.093v-1.996h-2.093zm2.093-4.381v2.093h-2.093V18.04zm-2.385 0v2.093h-2.094V18.04zm-2.386 0v2.093h-2.093V18.04zm-2.385 0v2.093H14.17V18.04zm-2.337 0v2.093h-2.142V18.04zm-2.434 0v2.093H9.351V18.04zm-2.385 0v2.093H7.063V18.04zm-2.288 0v2.093H4.58V18.04zm-2.19-2.434v2.142h2.19v-2.142zm2.482 0v2.142h1.996v-2.142zm2.288 0v2.142h2.093v-2.142zm2.385 0v2.142h2.142v-2.142zm2.434 0v2.142h2.045v-2.142zm2.337 0v2.142H18.6v-2.142zm2.385 0v2.142h2.094v-2.142zm2.386 0v2.142h2.093v-2.142z",
		clipRule: "evenodd"
	})), _path3$43 || (_path3$43 = /*#__PURE__*/ React.createElement("path", {
		fill: "#004696",
		d: "m6.917 24.71 7.132-21.396 7.083 21.396-7.083-7.132z"
	})));
};

//#endregion
//#region src/ManufacturerIcon/icons/Asus.svg
var _path$121;
function _extends$134() {
	return _extends$134 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$134.apply(null, arguments);
}
var SvgAsus = function SvgAsus(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$134({
		xmlns: "http://www.w3.org/2000/svg",
		width: 28,
		height: 28,
		fill: "none",
		viewBox: "0 0 28 28"
	}, props), _path$121 || (_path$121 = /*#__PURE__*/ React.createElement("path", {
		fill: "#2D2926",
		d: "M23.764 11.155V23h-5.04V10.833zM2.164 23h6.12l7.668-12.385-5.472-.54zM15.304 5h8.532v4.61H10.624l2.34-3.42c.575-.829 1.15-1.19 2.34-1.19"
	})));
};

//#endregion
//#region src/ManufacturerIcon/icons/Cisco.svg
var _g$12;
var _defs$20;
function _extends$133() {
	return _extends$133 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$133.apply(null, arguments);
}
var SvgCisco = function SvgCisco(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$133({
		xmlns: "http://www.w3.org/2000/svg",
		width: 28,
		height: 28,
		fill: "none",
		viewBox: "0 0 28 28"
	}, props), _g$12 || (_g$12 = /*#__PURE__*/ React.createElement("g", {
		fill: "#C4122E",
		clipPath: "url(#a)"
	}, /*#__PURE__*/ React.createElement("path", { d: "M8.338 11H6.906v5.676h1.432zM19.888 12.627c-.058-.03-.519-.304-1.204-.304-.927 0-1.57.645-1.57 1.515 0 .843.616 1.515 1.57 1.515.674 0 1.142-.267 1.204-.301v1.523c-.178.05-.667.202-1.307.202-1.61 0-3.022-1.11-3.022-2.94 0-1.695 1.28-2.938 3.022-2.938.675 0 1.172.164 1.307.204zM4.937 12.627c-.058-.03-.518-.304-1.204-.304-.927 0-1.57.645-1.57 1.515 0 .843.616 1.515 1.57 1.515.674 0 1.142-.267 1.204-.301v1.523c-.178.05-.667.202-1.307.202-1.61 0-3.022-1.11-3.022-2.94 0-1.695 1.28-2.938 3.022-2.938.675 0 1.172.164 1.307.204zM24.394 12.345c-.85 0-1.481.668-1.481 1.492 0 .826.63 1.495 1.48 1.495s1.482-.669 1.482-1.495c0-.823-.633-1.492-1.481-1.492m3 1.492c0 1.624-1.254 2.94-3 2.94s-2.998-1.316-2.998-2.94c0-1.62 1.252-2.938 2.998-2.938s3 1.317 3 2.938M13.77 12.29c-.021-.007-.624-.173-1.12-.173-.574 0-.886.192-.886.465 0 .346.421.466.657.54l.395.127c.93.295 1.353.932 1.353 1.623 0 1.426-1.254 1.905-2.35 1.905-.762 0-1.475-.14-1.546-.155v-1.306c.127.032.727.211 1.353.211.713 0 1.04-.208 1.04-.53 0-.288-.283-.454-.639-.565-.086-.03-.216-.07-.305-.1-.798-.251-1.463-.72-1.463-1.66 0-1.061.795-1.774 2.115-1.774.697 0 1.353.17 1.396.18z" }))), _defs$20 || (_defs$20 = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", { id: "a" }, /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M0 10.5h28v7H0z"
	})))));
};

//#endregion
//#region src/ManufacturerIcon/icons/Dell.svg
var _path$120;
var _path2$78;
function _extends$132() {
	return _extends$132 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$132.apply(null, arguments);
}
var SvgDell = function SvgDell(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$132({
		xmlns: "http://www.w3.org/2000/svg",
		width: 28,
		height: 28,
		fill: "none",
		viewBox: "0 0 28 28"
	}, props), _path$120 || (_path$120 = /*#__PURE__*/ React.createElement("path", {
		fill: "#007DB8",
		d: "M14 3.297c-2.954 0-5.63 1.198-7.567 3.137a10.66 10.66 0 0 0-3.135 7.568c0 2.953 1.197 5.629 3.135 7.564a10.68 10.68 0 0 0 7.568 3.136c2.955 0 5.632-1.2 7.567-3.136a10.66 10.66 0 0 0 3.132-7.564c0-2.956-1.195-5.634-3.133-7.568a10.66 10.66 0 0 0-7.566-3.137M14 2c6.627 0 12 5.374 12 12.002C26 20.627 20.627 26 14 26 7.376 26 2 20.627 2 14.002 2 7.373 7.375 2 14 2"
	})), _path2$78 || (_path2$78 = /*#__PURE__*/ React.createElement("path", {
		fill: "#007DB8",
		d: "M8.325 13.904c0-.7-.464-1.097-1.12-1.097h-.403v2.194h.39c.612 0 1.133-.332 1.133-1.097m7.152.789-2.962 2.332-2.707-2.13a2.62 2.62 0 0 1-2.421 1.59H5.07v-5.162h2.317c1.214 0 2.09.773 2.42 1.595l2.708-2.129 1.003.79-2.482 1.95.477.374 2.481-1.95L15 12.74l-2.482 1.953.476.374 2.484-1.953v-1.79h1.8v3.654h1.796v1.513h-3.596zm5.877.286h1.795v1.512h-3.597v-5.168h1.802z"
	})));
};

//#endregion
//#region src/ManufacturerIcon/icons/Ecobee.svg
var _path$119;
function _extends$131() {
	return _extends$131 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$131.apply(null, arguments);
}
var SvgEcobee = function SvgEcobee(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$131({
		xmlns: "http://www.w3.org/2000/svg",
		width: 28,
		height: 28,
		fill: "none",
		viewBox: "0 0 28 28"
	}, props), _path$119 || (_path$119 = /*#__PURE__*/ React.createElement("path", {
		fill: "#686058",
		fillRule: "evenodd",
		d: "M14.722 5q4.122 0 6.213 2.085t2.091 6.224v1.56H6.809q.06 3.27 1.655 4.817 1.594 1.544 4.875 1.544h1.323q2.437 0 3.911-.75t2.046-2.22h1.926q-.603 2.31-2.588 3.525T14.723 23h-1.445q-4.122 0-6.213-2.085-2.09-2.085-2.09-6.225v-1.38q0-4.14 2.09-6.225Q9.156 5 13.278 5zm-.06 1.77h-1.324q-3.28 0-4.874 1.545Q6.869 9.86 6.809 13.1h14.382q-.06-3.24-1.655-4.786T14.662 6.77",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/ManufacturerIcon/icons/Foxconn.svg
var _path$118;
var _path2$77;
function _extends$130() {
	return _extends$130 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$130.apply(null, arguments);
}
var SvgFoxconn = function SvgFoxconn(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$130({
		xmlns: "http://www.w3.org/2000/svg",
		width: 28,
		height: 28,
		fill: "none",
		viewBox: "0 0 28 28"
	}, props), _path$118 || (_path$118 = /*#__PURE__*/ React.createElement("path", {
		fill: "#E83434",
		fillRule: "evenodd",
		d: "M16.167 3.5v6.285h-4.239V3.5H3.454l-.048 21h8.476v-6.333h4.19l.047 6.285h8.477V3.5z",
		clipRule: "evenodd"
	})), _path2$77 || (_path2$77 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		fillRule: "evenodd",
		d: "M22.453 22.357h-4.19v-4.239a2.12 2.12 0 0 0-2.05-1.999h-4.285a2.176 2.176 0 0 0-2.142 2v4.285H5.548V5.596h4.238v6.285h9.476a3.6 3.6 0 0 1 3.19 3.238z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/ManufacturerIcon/icons/Google.svg
var _path$117;
var _path2$76;
var _path3$42;
var _path4$24;
var _path5$15;
function _extends$129() {
	return _extends$129 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$129.apply(null, arguments);
}
var SvgGoogle$2 = function SvgGoogle(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$129({
		xmlns: "http://www.w3.org/2000/svg",
		width: 28,
		height: 28,
		fill: "none",
		viewBox: "0 0 28 28"
	}, props), _path$117 || (_path$117 = /*#__PURE__*/ React.createElement("path", {
		fill: "#DB4437",
		d: "M4.74 8.06v8.444h4.93L14 9.006h9.808A11 11 0 0 0 14 3c-3.89 0-7.302 2.01-9.26 5.06"
	})), _path2$76 || (_path2$76 = /*#__PURE__*/ React.createElement("path", {
		fill: "#0F9D58",
		d: "m13.48 24.987 4.85-4.847v-3.636H9.67L4.738 8.061a10.9 10.9 0 0 0-1.746 5.94c0 5.9 4.65 10.72 10.487 10.986"
	})), _path3$42 || (_path3$42 = /*#__PURE__*/ React.createElement("path", {
		fill: "#FFCD40",
		d: "m14 9.006 4.33 7.498-4.85 8.483c.173.013.346.013.52.013 6.076 0 11.006-4.927 11.006-11 0-1.798-.44-3.502-1.2-4.994z"
	})), _path4$24 || (_path4$24 = /*#__PURE__*/ React.createElement("path", {
		fill: "#F1F1F1",
		d: "M14 18.994A4.995 4.995 0 0 0 18.998 14a4.995 4.995 0 0 0-4.996-4.994A4.995 4.995 0 0 0 9.004 14 4.995 4.995 0 0 0 14 18.994"
	})), _path5$15 || (_path5$15 = /*#__PURE__*/ React.createElement("path", {
		fill: "#4285F4",
		d: "M14 17.996a3.996 3.996 0 1 0 0-7.99 3.996 3.996 0 1 0 0 7.99"
	})));
};

//#endregion
//#region src/ManufacturerIcon/icons/HP.svg
var _path$116;
function _extends$128() {
	return _extends$128 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$128.apply(null, arguments);
}
var SvgHp = function SvgHp(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$128({
		xmlns: "http://www.w3.org/2000/svg",
		width: 28,
		height: 28,
		fill: "none",
		viewBox: "0 0 28 28"
	}, props), _path$116 || (_path$116 = /*#__PURE__*/ React.createElement("path", {
		fill: "#0096D6",
		d: "M20.6 10.7h-1.833L16.2 17.3h1.833zM14 25q-.164 0-.327-.006l2.248-6.177h3.094c.543 0 1.139-.418 1.325-.928l2.439-6.699c.399-1.097-.23-1.994-1.397-1.994h-4.291l-3.603 9.896-2.042 5.61C6.603 23.55 3 19.195 3 14c0-5.046 3.398-9.298 8.03-10.594l-5.609 15.41h2.331l2.978-8.174h1.752l-2.978 8.175h2.33l2.776-7.627c.4-1.097-.229-1.994-1.395-1.994h-1.96l2.25-6.184Q13.752 3 14 3c6.075 0 11 4.925 11 11s-4.925 11-11 11"
	})));
};

//#endregion
//#region src/ManufacturerIcon/icons/IBM.svg
var _path$115;
function _extends$127() {
	return _extends$127 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$127.apply(null, arguments);
}
var SvgIbm = function SvgIbm(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$127({
		xmlns: "http://www.w3.org/2000/svg",
		width: 28,
		height: 28,
		fill: "none",
		viewBox: "0 0 28 28"
	}, props), _path$115 || (_path$115 = /*#__PURE__*/ React.createElement("path", {
		fill: "#161616",
		fillRule: "evenodd",
		d: "M28 18.812v.74h-3.684v-.74zm-8.842 0v.74h-3.684v-.74zm2.874 0-.296.74-.293-.74zm-8.253 0c-.529.46-1.226.74-2.004.74h-5.88v-.74zm-8.621 0v.74H0v-.74zm14-1.481v.74h-3.684v-.74zm3.45 0-.286.74h-1.167l-.289-.74zm-8.092 0a2.8 2.8 0 0 1-.31.74H5.895v-.74zm-9.358 0v.74H0v-.74zm22.842 0v.74h-3.684v-.74zm-1.474-1.48v.74h-2.21v-.74zm-7.368 0v.74h-2.21v-.74zm4.028 0-.289.74h-2.32l-.292-.74zm-8.773 0q.101.354.103.74H11.79v-.74zm-4.834 0v.74h-2.21v-.74zm-5.895 0v.74h-2.21v-.74zm22.842-1.48v.74h-2.21v-.74zm-7.368 0v.74h-2.21v-.74zm4.606 0-.288.74H19.99l-.286-.74zm-10.258 0c.254.208.473.458.641.74H7.368v-.74zm-9.822 0v.74h-2.21v-.74zM21.53 12.89l.207.598.206-.598h4.583v.74h-2.21v-.68l-.25.68H19.4l-.243-.68v.68h-2.21v-.74zm-17.846 0v.74h-2.21v-.74zm10.463 0c-.168.28-.387.53-.64.74H7.367v-.74zm12.38-1.48v.74h-4.328l.26-.74zm-5.51 0 .26.74h-4.33v-.74zm-6.501 0c0 .255-.037.503-.103.74H11.79v-.74zm-4.937 0v.74h-2.21v-.74zm-5.895 0v.74h-2.21v-.74zm16.822-1.481.256.74h-5.288v-.74zm7.494 0v.74h-5.291l.266-.74zm-13.794 0q.208.344.31.74H5.895v-.74zm-9.048 0v.74H0v-.74zm14.83-1.48.262.74h-4.776v-.74zm8.012 0v.74h-4.77l.255-.74zm-16.225 0c.772 0 1.475.28 2.004.74H5.895v-.74zm-6.617 0v.74H0v-.74z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/ManufacturerIcon/icons/ICANN.svg
var _path$114;
var _path2$75;
function _extends$126() {
	return _extends$126 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$126.apply(null, arguments);
}
var SvgIcann = function SvgIcann(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$126({
		xmlns: "http://www.w3.org/2000/svg",
		width: 28,
		height: 28,
		fill: "none",
		viewBox: "0 0 28 28"
	}, props), _path$114 || (_path$114 = /*#__PURE__*/ React.createElement("path", {
		fill: "#274A5B",
		d: "M14.22 4.948a8 8 0 0 0-1.59.16c-.89.198-1.676.625-2.463 1.059-2.596 1.271-4.25 3.94-4.02 6.828l1.263-.367c-.154-2.036.397-3.845 1.669-5.322.772 4.101 2.44 7.828 4.925 11.225.226.015.446.03.664.03a3.3 3.3 0 0 0 .66-.06c-.876-.882-1.574-1.83-2.28-2.779 1.08-.492 2.176-1 3.153-1.69-.131-.33-.227-.691-.396-.986-1.029.78-2.095 1.456-3.234 1.963-.53-.793-.985-1.61-1.426-2.433v-.08c1.212-.494 2.38-1.104 3.469-1.904-.191-.353-.396-.721-.61-1.037-1.022.794-2.073 1.53-3.176 2.117h-.11A24.5 24.5 0 0 1 9.13 7.225c.36-.404.773-.794 1.19-1.11l1.222-.345c3.072 3.447 5.071 7.358 6.167 11.591.287-.286.544-.595.61-.976-.213-.597-.367-1.207-.64-1.773-.139-.419-.412-.808-.5-1.22a25 25 0 0 0 2.33-1.933 3.1 3.1 0 0 0-.396-1.455h-.058a23 23 0 0 1-2.434 2.36c-.456-.743-.875-1.5-1.374-2.228.852-.647 1.676-1.427 2.432-2.25-.271-.353-.624-.728-1.029-.867-.646.721-1.374 1.478-2.117 2.088-.896-1.14-1.867-2.272-2.94-3.308a6.6 6.6 0 0 1 1.432-.149c.497 0 .993.05 1.427.149 2.53.456 4.991 2.94 5.396 5.476.537 2.837-.478 5.447-2.8 7.174-.824.299-1.701.45-2.575.45-1.883 0-3.75-.702-5.02-2.148.882-.146 1.72-.412 2.567-.683-.126-.213-.28-.412-.375-.64a20.2 20.2 0 0 1-8.543 1.456c.915.117 1.848.168 2.787.168q.893 0 1.786-.057a7.6 7.6 0 0 0 2.228 1.852c.922.513 2.07.77 3.224.77 1.373 0 2.758-.363 3.788-1.086a7.4 7.4 0 0 0 3.065-2.463c1.485-1.897 1.712-5.028.61-7.174l-.477-.817c-1.39-2.056-3.542-3.129-5.893-3.129"
	})), _path2$75 || (_path2$75 = /*#__PURE__*/ React.createElement("path", {
		fill: "#274A5B",
		d: "M10.005 12.07a19 19 0 0 1-6.615 1.72 31 31 0 0 0 2.807-.081c.155.933.471 1.808.978 2.594.53-.103 1.059-.19 1.558-.345-.448-.595-.764-1.258-.999-1.956-.037-.168-.163-.368-.059-.529.911-.169 1.8-.375 2.646-.69zM14.023 21.626c-4.816 0-9.638.473-14.023 1.404 4.398-.479 8.993-.704 13.593-.704 4.873 0 9.752.253 14.407.726-4.366-.956-9.17-1.426-13.977-1.426"
	})));
};

//#endregion
//#region src/ManufacturerIcon/icons/Intel.svg
var _path$113;
var _path2$74;
function _extends$125() {
	return _extends$125 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$125.apply(null, arguments);
}
var SvgIntel = function SvgIntel(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$125({
		xmlns: "http://www.w3.org/2000/svg",
		width: 28,
		height: 28,
		fill: "none",
		viewBox: "0 0 28 28"
	}, props), _path$113 || (_path$113 = /*#__PURE__*/ React.createElement("path", {
		fill: "#04C7FD",
		d: "M2.204 8.259H0v2.204h2.204z"
	})), _path2$74 || (_path2$74 = /*#__PURE__*/ React.createElement("path", {
		fill: "#0068B5",
		d: "M2.149 19.741v-7.937H.063v7.937zm13.867.079v-1.945c-.306 0-.565-.016-.753-.048-.22-.03-.385-.11-.494-.22-.11-.109-.18-.266-.22-.47a5 5 0 0 1-.047-.768v-2.777h1.514v-1.788h-1.514V8.706h-2.094v7.678q0 .978.165 1.64c.11.43.298.784.556 1.05.26.267.604.455 1.02.573q.638.175 1.592.173zM28 19.74V8.094h-2.094v11.647zm-17.608-7.16c-.58-.628-1.396-.942-2.431-.942-.502 0-.957.102-1.373.306-.408.204-.76.486-1.035.847l-.118.15v-1.138H3.373v7.937H5.45v-4.227.29-.141c.024-.745.204-1.294.549-1.647a1.8 1.8 0 0 1 1.325-.565c.604 0 1.067.188 1.373.549.298.36.455.87.455 1.522v4.211h2.11v-4.502c.008-1.129-.29-2.023-.87-2.65m14.432 3.176c0-.573-.102-1.106-.299-1.608a4.3 4.3 0 0 0-.839-1.31 3.8 3.8 0 0 0-1.294-.878 4.2 4.2 0 0 0-1.663-.314c-.572 0-1.113.11-1.615.322-.502.22-.942.51-1.31.878a4.1 4.1 0 0 0-.878 1.31 4 4 0 0 0-.322 1.616c0 .572.102 1.113.306 1.615s.494.941.855 1.31c.36.369.808.667 1.325.878.518.22 1.09.33 1.702.33 1.773 0 2.87-.808 3.53-1.56L22.816 17.2c-.314.377-1.067.886-2.008.886-.588 0-1.075-.133-1.443-.408a2 2 0 0 1-.753-1.105l-.024-.071h6.235zm-6.22-.73c0-.58.667-1.592 2.102-1.6 1.435 0 2.11 1.012 2.11 1.593z"
	})));
};

//#endregion
//#region src/ManufacturerIcon/icons/Lenovo.svg
var _path$112;
var _path2$73;
function _extends$124() {
	return _extends$124 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$124.apply(null, arguments);
}
var SvgLenovo = function SvgLenovo(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$124({
		xmlns: "http://www.w3.org/2000/svg",
		width: 28,
		height: 28,
		fill: "none",
		viewBox: "0 0 28 28"
	}, props), _path$112 || (_path$112 = /*#__PURE__*/ React.createElement("path", {
		fill: "#E1251B",
		d: "M3.726 25V3h20.548v22z"
	})), _path2$73 || (_path2$73 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M17.95 17.48h-5.463V8.317h-2.436v11.366h7.898z"
	})));
};

//#endregion
//#region src/ManufacturerIcon/icons/LG.svg
var _path$111;
var _path2$72;
var _path3$41;
var _path4$23;
var _path5$14;
var _path6$11;
var _path7$8;
var _path8$7;
var _path9$6;
var _path0$6;
var _path1$5;
var _path10$5;
var _path11$4;
var _path12$3;
var _path13$3;
var _path14$3;
var _path15$3;
var _path16$3;
var _path17$3;
var _path18$3;
var _path19$3;
var _defs$19;
function _extends$123() {
	return _extends$123 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$123.apply(null, arguments);
}
var SvgLg = function SvgLg(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$123({
		xmlns: "http://www.w3.org/2000/svg",
		width: 28,
		height: 28,
		fill: "none",
		viewBox: "0 0 28 28"
	}, props), _path$111 || (_path$111 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#a)",
		d: "M13.993 3C7.925 3 3 7.925 3 14.001 3 20.078 7.925 25 13.993 25 20.046 25 24.954 20.123 25 14.087v-.171C24.952 7.876 20.046 3 13.993 3"
	})), _path2$72 || (_path2$72 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#b)",
		d: "M6.55 6.555c-3.675 3.678-4.048 9.278-.821 12.506s8.825 2.857 12.503-.82c3.683-3.684 4.053-9.285.829-12.512-1.473-1.473-3.441-2.2-5.498-2.2-2.444 0-5.014 1.024-7.014 3.026"
	})), _path3$41 || (_path3$41 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#c)",
		d: "m13.429 18.93.27-.154V9.484l-.068-.109.069-.02v-.014h.048l.823-.282.148.254s.023.022.02.07l-.008 8.464h2l.159.25c.014.02.026.04.026.103v.852c0 .049-.029.068-.063.074h-3.06a.3.3 0 0 1-.153-.046zm9.925-5.436-6.806.003v1.088l.168.225s.02.023.057.023h5.695c-.294 4.304-3.926 7.677-8.264 7.677a8.26 8.26 0 0 1-5.857-2.413 8.16 8.16 0 0 1-2.421-5.82c0-2.198.814-4.31 2.375-5.862 1.573-1.55 3.547-2.367 5.914-2.418l.447-.006h.049c.031-.003.057-.003.057-.074v-.892c0-.065-.023-.096-.023-.096l-.202-.251-.453.065-.228.074c-5.168 0-9.042 4.319-9.042 9.464 0 2.486.977 4.83 2.75 6.591 1.768 1.76 4.113 2.652 6.614 2.652 2.512 0 4.874-.948 6.64-2.709a9.24 9.24 0 0 0 2.746-6.591v-.536zM10.623 9.187c-.818 0-1.478.658-1.478 1.47 0 .81.66 1.467 1.478 1.467s1.478-.655 1.478-1.467-.66-1.47-1.478-1.47"
	})), _path4$23 || (_path4$23 = /*#__PURE__*/ React.createElement("path", {
		fill: "#626D77",
		d: "m13.651 18.716-.222.214h3.299l-.214-.22z"
	})), _path5$14 || (_path5$14 = /*#__PURE__*/ React.createElement("path", {
		fill: "#8699A3",
		d: "m16.514 18.052.213-.208h-2.159l-.256.208z"
	})), _path6$11 || (_path6$11 = /*#__PURE__*/ React.createElement("path", {
		fill: "#8D9AA1",
		d: "M14.568 9.056h-1.14l.214.205h.681z"
	})), _path7$8 || (_path7$8 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#d)",
		d: "m14.332 18.038.236-.194V9.056l-.245.205z"
	})), _path8$7 || (_path8$7 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#e)",
		d: "M16.514 18.052v.658l.214.22v-1.086z"
	})), _path9$6 || (_path9$6 = /*#__PURE__*/ React.createElement("path", {
		fill: "#B4BDC3",
		d: "M13.429 9.056v9.874l.222-.214-.008-9.455z"
	})), _path0$6 || (_path0$6 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#f)",
		d: "M9.048 10.49c0 .791.643 1.43 1.435 1.43a1.432 1.432 0 1 0 0-2.867c-.792 0-1.435.644-1.435 1.436m2.658 0a1.22 1.22 0 0 1-1.223 1.215 1.22 1.22 0 0 1-1.225-1.216c0-.675.55-1.22 1.225-1.22.673 0 1.223.545 1.223 1.22"
	})), _path1$5 || (_path1$5 = /*#__PURE__*/ React.createElement("path", {
		fill: "#505C61",
		d: "m22.422 14.338-5.7-.009-.214.222h5.695l.114-.117z"
	})), _path10$5 || (_path10$5 = /*#__PURE__*/ React.createElement("path", {
		fill: "#8F9CA4",
		d: "m16.722 13.688 6.375-.011.217-.217h-6.806z"
	})), _path11$4 || (_path11$4 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#g)",
		d: "M23.314 13.996v-.539l-.217.217v.322c0 2.432-.946 4.72-2.663 6.44a9.05 9.05 0 0 1-6.447 2.67 9.03 9.03 0 0 1-6.432-2.67 9.06 9.06 0 0 1-2.666-6.44c0-5.025 4.082-9.11 9.098-9.11l.348-.006.213-.205-.56-.006c-5.134 0-9.316 4.182-9.316 9.327 0 2.49.972 4.831 2.73 6.591a9.25 9.25 0 0 0 6.585 2.732c2.496 0 4.84-.971 6.598-2.732a9.26 9.26 0 0 0 2.729-6.591"
	})), _path12$3 || (_path12$3 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#h)",
		d: "m14.335 5.56-.24-.005h-.225a8.43 8.43 0 0 0-8.315 8.44c0 2.257.878 4.376 2.467 5.972a8.4 8.4 0 0 0 5.863 2.475h.216c4.379-.054 8.022-3.495 8.315-7.874l.009-.233-.108.097-.114.116c-.294 4.305-3.9 7.677-8.21 7.677a8.19 8.19 0 0 1-5.82-2.412 8.18 8.18 0 0 1-2.404-5.82c0-2.2.854-4.27 2.404-5.82a8.21 8.21 0 0 1 5.82-2.407l.555.006z"
	})), _path13$3 || (_path13$3 = /*#__PURE__*/ React.createElement("path", {
		fill: "#B4BDC3",
		d: "m16.722 13.688-.214-.228v1.091l.214-.222z"
	})), _path14$3 || (_path14$3 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#i)",
		d: "m14.335 5.56.213.215V4.678l-.213.205z"
	})), _path15$3 || (_path15$3 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#j)",
		d: "M13.549 9.173v9.64h3.065v-.86h-2.188v-8.78zm.321-4.384c-5.013.06-9.084 4.168-9.084 9.21 0 2.46.957 4.771 2.695 6.509a9.13 9.13 0 0 0 6.5 2.697c2.467 0 4.78-.957 6.515-2.697a9.15 9.15 0 0 0 2.695-6.51v-.418H16.62v.854h5.698c0 .02 0 .109-.003.126-.297 4.338-3.911 7.785-8.327 7.785a8.3 8.3 0 0 1-5.902-2.447 8.3 8.3 0 0 1-2.439-5.9c0-2.233.87-4.33 2.439-5.902a8.32 8.32 0 0 1 5.902-2.441c.097 0 .333 0 .439.003v-.863c-.086 0-.23-.003-.345-.006z"
	})), _path16$3 || (_path16$3 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#k)",
		d: "M9.156 10.49a1.322 1.322 0 0 0 2.64 0 1.32 1.32 0 0 0-2.64 0"
	})), _path17$3 || (_path17$3 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M10.717 9.407c.302 0 .578.108.8.279a1.31 1.31 0 0 0-1.04-.519 1.32 1.32 0 0 0-1.321 1.32c0 .42.205.791.513 1.03a1.3 1.3 0 0 1-.277-.794c0-.727.596-1.316 1.325-1.316"
	})), _path18$3 || (_path18$3 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M14.426 4.795a23 23 0 0 0-.444-.006c-5.068 0-9.199 4.133-9.199 9.21 0 2.464.957 4.768 2.695 6.512l.171.162a9.15 9.15 0 0 1-2.541-6.35c-.003-5.07 3.586-9.275 9.318-9.528M14.426 17.955s.632.183 2.185.183v-.183zM14.426 9.446v-.27h-.877v9.64s.273-1.467.273-9.37zM23.191 13.577l-6.572.003v.854h.24v-.615c5.725-.003 6.332-.242 6.332-.242"
	})), _path19$3 || (_path19$3 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M22.317 14.434c-.003.018-.003.112-.006.129-.294 4.335-3.911 7.782-8.327 7.782a8.3 8.3 0 0 1-5.902-2.447 8.3 8.3 0 0 1-2.134-3.649 8.46 8.46 0 0 0 8.182 6.199c4.193 0 8.056-3.285 8.295-8.01h-.108z"
	})), _defs$19 || (_defs$19 = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
		id: "b",
		x1: 9.493,
		x2: 15.296,
		y1: 4.422,
		y2: 20.367,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#F38895" }), /*#__PURE__*/ React.createElement("stop", {
		offset: .086,
		stopColor: "#EB7588"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .314,
		stopColor: "#D84869"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .517,
		stopColor: "#CA2752"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .687,
		stopColor: "#C21344"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .801,
		stopColor: "#BF0C3F"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#BF0C3F"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "c",
		x1: 6.657,
		x2: 19.969,
		y1: 8.363,
		y2: 21.674,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#CD425C" }), /*#__PURE__*/ React.createElement("stop", {
		offset: .089,
		stopColor: "#BE3351"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .249,
		stopColor: "#AA1F43"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .43,
		stopColor: "#9B1039"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .648,
		stopColor: "#930833"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#900531"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "d",
		x1: 14.324,
		x2: 14.568,
		y1: 13.547,
		y2: 13.547,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#B4BDC3" }), /*#__PURE__*/ React.createElement("stop", {
		offset: .04,
		stopColor: "#AEB7BD"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .498,
		stopColor: "#6C737A"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .83,
		stopColor: "#434950"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#333940"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "e",
		x1: 16.513,
		x2: 16.727,
		y1: 18.387,
		y2: 18.387,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#B3BBC1" }), /*#__PURE__*/ React.createElement("stop", {
		offset: .081,
		stopColor: "#A6AEB4"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .52,
		stopColor: "#636B70"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .838,
		stopColor: "#3A4246"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#2A3236"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "f",
		x1: 9.466,
		x2: 11.494,
		y1: 9.469,
		y2: 11.498,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#ABBAC2" }), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#262A30"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "g",
		x1: 6.56,
		x2: 19.848,
		y1: 8.216,
		y2: 21.504,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#B4BDC3" }), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#3E454D"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "h",
		x1: 22.424,
		x2: 5.552,
		y1: 13.998,
		y2: 13.998,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#B4BDC3" }), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#485159"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "i",
		x1: 14.335,
		x2: 14.547,
		y1: 5.226,
		y2: 5.226,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#B3BBC1" }), /*#__PURE__*/ React.createElement("stop", {
		offset: .081,
		stopColor: "#A6AEB4"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .52,
		stopColor: "#636B70"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .838,
		stopColor: "#3A4246"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#2A3236"
	})), /*#__PURE__*/ React.createElement("radialGradient", {
		id: "a",
		cx: 0,
		cy: 0,
		r: 1,
		gradientTransform: "matrix(11.4682 0 0 11.4681 13.59 13.665)",
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#BF0C3F" }), /*#__PURE__*/ React.createElement("stop", {
		offset: .5,
		stopColor: "#BF0C3F"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .753,
		stopColor: "#BD0B3E"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .86,
		stopColor: "#B6093A"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .938,
		stopColor: "#A90534"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#99002C"
	})), /*#__PURE__*/ React.createElement("radialGradient", {
		id: "j",
		cx: 0,
		cy: 0,
		r: 1,
		gradientTransform: "translate(10.277 10.098)scale(14.0783)",
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#fff" }), /*#__PURE__*/ React.createElement("stop", {
		offset: .35,
		stopColor: "#fff"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .511,
		stopColor: "#FBFCFC"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .677,
		stopColor: "#EEF2F3"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .845,
		stopColor: "#DAE1E5"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#C0CCD2"
	})), /*#__PURE__*/ React.createElement("radialGradient", {
		id: "k",
		cx: 0,
		cy: 0,
		r: 1,
		gradientTransform: "matrix(2.05569 0 0 2.05568 9.931 10.002)",
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#fff" }), /*#__PURE__*/ React.createElement("stop", {
		offset: .35,
		stopColor: "#fff"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .537,
		stopColor: "#FBFCFC"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .731,
		stopColor: "#EEF2F4"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .926,
		stopColor: "#DAE2E6"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#D0DADF"
	})))));
};

//#endregion
//#region src/ManufacturerIcon/icons/Logitech.svg
var _path$110;
function _extends$122() {
	return _extends$122 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$122.apply(null, arguments);
}
var SvgLogitech = function SvgLogitech(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$122({
		xmlns: "http://www.w3.org/2000/svg",
		width: 28,
		height: 28,
		fill: "none",
		viewBox: "0 0 28 28"
	}, props), _path$110 || (_path$110 = /*#__PURE__*/ React.createElement("path", {
		fill: "#131522",
		d: "M14.457 3.5c-5.79 0-10.5 4.71-10.5 10.5s4.71 10.5 10.5 10.5a.456.456 0 0 0 .456-.456V20.39a.456.456 0 0 0-.457-.456A5.94 5.94 0 0 1 8.523 14a5.94 5.94 0 0 1 5.935-5.935.456.456 0 0 0 .456-.456V3.957a.456.456 0 0 0-.457-.457m0 8.217a.456.456 0 0 0-.457.457v4.109c0 .252.204.456.457.456h4.565v4.565c0 .252.204.457.456.457h4.109a.456.456 0 0 0 .457-.457v-9.13a.456.456 0 0 0-.457-.457z"
	})));
};

//#endregion
//#region src/ManufacturerIcon/icons/Meter.svg
var _path$109;
function _extends$121() {
	return _extends$121 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$121.apply(null, arguments);
}
var SvgMeter = function SvgMeter(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$121({
		xmlns: "http://www.w3.org/2000/svg",
		width: 28,
		height: 28,
		fill: "none",
		viewBox: "0 0 28 28"
	}, props), _path$109 || (_path$109 = /*#__PURE__*/ React.createElement("path", {
		fill: "#5461C8",
		d: "M3.66 21.795h2.53v-.274q0-.85-.002-1.699c-.003-1.408-.007-2.817.01-4.225.01-.797.071-1.598.176-2.389.142-1.063.488-2.066 1.092-2.964.595-.883 1.343-1.554 2.452-1.678 1.273-.142 2.338.358 2.65 1.756.113.51.147 1.045.15 1.57.009 2.326.008 4.653.007 6.98v2.622q.001.101.008.202l.006.092h2.54v-.251q0-.87-.002-1.738c-.004-1.454-.007-2.909.01-4.362.01-.775.07-1.555.184-2.321.188-1.266.637-2.435 1.486-3.42.693-.806 1.563-1.22 2.633-1.146.881.061 1.538.47 1.899 1.304.252.585.302 1.205.303 1.83q.002 3.663.001 7.325v2.783h2.534l.004-.07q.005-.069.006-.132l.001-2.473c.002-2.707.004-5.414-.009-8.12a7.8 7.8 0 0 0-.182-1.635c-.257-1.16-.859-2.107-1.945-2.657-1.218-.617-2.499-.622-3.78-.236-1.439.434-2.455 1.406-3.218 2.673l-.098.162-.057.094-.031-.108-.043-.148c-.373-1.207-1.085-2.121-2.276-2.601-.923-.372-1.883-.41-2.847-.205-1.59.337-2.72 1.296-3.516 2.687l-.074.131-.036.063-.043-.017V6.497H3.66z"
	})));
};

//#endregion
//#region src/ManufacturerIcon/icons/Microsoft.svg
var _path$108;
var _path2$71;
var _path3$40;
var _path4$22;
function _extends$120() {
	return _extends$120 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$120.apply(null, arguments);
}
var SvgMicrosoft$1 = function SvgMicrosoft(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$120({
		xmlns: "http://www.w3.org/2000/svg",
		width: 28,
		height: 28,
		fill: "none",
		viewBox: "0 0 28 28"
	}, props), _path$108 || (_path$108 = /*#__PURE__*/ React.createElement("path", {
		fill: "#F1511B",
		d: "M13.499 13.504H4V4.006h9.499z"
	})), _path2$71 || (_path2$71 = /*#__PURE__*/ React.createElement("path", {
		fill: "#80CC28",
		d: "M23.986 13.504h-9.498V4.005h9.498z"
	})), _path3$40 || (_path3$40 = /*#__PURE__*/ React.createElement("path", {
		fill: "#00ADEF",
		d: "M13.498 23.995H4v-9.499h9.498z"
	})), _path4$22 || (_path4$22 = /*#__PURE__*/ React.createElement("path", {
		fill: "#FBBC09",
		d: "M23.986 23.995h-9.498v-9.499h9.498z"
	})));
};

//#endregion
//#region src/ManufacturerIcon/icons/Neat.svg
var _path$107;
function _extends$119() {
	return _extends$119 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$119.apply(null, arguments);
}
var SvgNeat = function SvgNeat(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$119({
		xmlns: "http://www.w3.org/2000/svg",
		width: 28,
		height: 28,
		fill: "none",
		viewBox: "0 0 28 28"
	}, props), _path$107 || (_path$107 = /*#__PURE__*/ React.createElement("path", {
		fill: "#5F259F",
		d: "M27.235 15.982a.765.765 0 1 0 0 1.53.765.765 0 0 0 0-1.53M3.084 11.447C1.154 11.447 0 12.624 0 14.594v3.415c.602 0 1.002-.4 1.002-1.002v-2.413c0-1.402.76-2.204 2.082-2.204s2.081.802 2.081 2.204v3.415c.603 0 1.003-.4 1.003-1.002v-2.413c.003-1.97-1.151-3.147-3.084-3.147M10.536 11.447c-1.944 0-3.355 1.38-3.355 3.281s1.41 3.281 3.355 3.281c1.4 0 2.573-.731 3.067-1.907l.037-.092c-.371-.188-.9-.177-1.293.303-.406.491-1.034.757-1.81.757-1.251 0-2.17-.791-2.32-1.982h5.649v-.36c0-1.902-1.402-3.28-3.33-3.28M8.25 14.171c.214-1.088 1.102-1.781 2.287-1.781 1.171 0 2.053.696 2.273 1.784H8.25zM24.79 17.107c-.947 0-1.467-.549-1.467-1.542v-2.676h1.336c.603 0 1.002-.4 1.002-1.002h-2.338V9.991l-1.002.4v5.174c0 1.333.68 2.207 1.853 2.427.234.04 1.673.103 1.539-1.14q-.36.254-.922.255M17.972 11.447c-1.976 0-3.355 1.365-3.355 3.318 0 1.88 1.359 3.244 3.232 3.244 1.114 0 2.03-.5 2.524-1.354v.415c0 .565.377.939.94.939v-3.244c.003-1.953-1.374-3.318-3.341-3.318m0 5.623c-1.38 0-2.342-.963-2.342-2.342s.963-2.341 2.342-2.341 2.341.962 2.341 2.341-.962 2.342-2.341 2.342"
	})));
};

//#endregion
//#region src/ManufacturerIcon/icons/Nest.svg
var _path$106;
var _path2$70;
function _extends$118() {
	return _extends$118 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$118.apply(null, arguments);
}
var SvgNest = function SvgNest(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$118({
		xmlns: "http://www.w3.org/2000/svg",
		width: 28,
		height: 28,
		fill: "none",
		viewBox: "0 0 28 28"
	}, props), _path$106 || (_path$106 = /*#__PURE__*/ React.createElement("path", {
		fill: "#00C3E8",
		d: "M21.745 5.851v3.547l4.175 3.412-1.998 2.402-2.155-1.773V25h-2.963v-6.712c0-2.627-2.155-4.76-4.782-4.76-2.649 0-4.781 2.133-4.781 4.76V25H6.233V13.439l-2.155 1.773L2.08 12.81 13.977 3l5.299 4.355V5.851z"
	})), _path2$70 || (_path2$70 = /*#__PURE__*/ React.createElement("path", {
		fill: "#00C3E8",
		d: "M14.022 15.706a2.597 2.597 0 0 1 2.582 2.582V25h-5.163v-6.712a2.57 2.57 0 0 1 2.581-2.582"
	})));
};

//#endregion
//#region src/ManufacturerIcon/icons/Philips.svg
var _path$105;
function _extends$117() {
	return _extends$117 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$117.apply(null, arguments);
}
var SvgPhilips = function SvgPhilips(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$117({
		xmlns: "http://www.w3.org/2000/svg",
		width: 28,
		height: 28,
		fill: "none",
		viewBox: "0 0 28 28"
	}, props), _path$105 || (_path$105 = /*#__PURE__*/ React.createElement("path", {
		fill: "#0B5ED7",
		fillRule: "evenodd",
		d: "M26.353 12.41c.502 0 1.026.108 1.397.251v-.973a5 5 0 0 0-1.571-.244c-1.287 0-2.158.478-2.158 1.478 0 1.724 2.485 1.376 2.485 2.176 0 .308-.292.484-.881.484-.523 0-1.145-.018-1.625-.243v.973c.48.165 1.176.244 1.7.244 1.329 0 2.3-.4 2.3-1.632 0-1.642-2.5-1.167-2.5-2.14 0-.366.395-.375.853-.375m-5.242 2.812h-.444v1.334H19.11v-5.112c.036 0 1.236.025 1.778 0 1.601.025 2.667.536 2.667 1.778 0 1.457-1.044 2-2.445 2m-.222-2.889c-.077.002-.135-.002-.222 0v2h.222c.783 0 1.111-.237 1.111-1.11 0-.542-.37-.888-1.111-.89m-4.222-.889h1.555v5.112h-1.555zm-3.778 5.112v-5.112h1.555v4H16l-.222 1.112zm-2.445-5.112H12v5.112h-1.556zM8 14.557H6.444v2H4.89v-5.112h1.555v2H8v-2h1.556v5.112H8zm-6 .666h-.444v1.334H0v-5.112c.036 0 1.236.025 1.778 0 1.601.025 2.666.536 2.666 1.778 0 1.457-1.043 2-2.444 2m-.222-2.889c-.078.002-.135-.002-.222 0v2h.222c.783 0 1.11-.237 1.11-1.11 0-.542-.368-.888-1.11-.89",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/ManufacturerIcon/icons/Samsung.svg
var _path$104;
function _extends$116() {
	return _extends$116 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$116.apply(null, arguments);
}
var SvgSamsung = function SvgSamsung(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$116({
		xmlns: "http://www.w3.org/2000/svg",
		width: 28,
		height: 28,
		fill: "none",
		viewBox: "0 0 28 28"
	}, props), _path$104 || (_path$104 = /*#__PURE__*/ React.createElement("path", {
		fill: "#2D4F9E",
		fillRule: "evenodd",
		d: "M9.806 10.018q-.013.09-.021.176c-.07.528-.053.967.05 1.475.29 1.423 1.769 2.265 3.085 3.014.974.553 1.859 1.057 2.108 1.708.104.27.079.625.022.865-.123.522-.48.778-1.09.778-.644 0-1.116-.373-1.116-1.05l-.002-1.203H9.67l-.002.966c0 1.432.6 2.588 1.997 3.151C5.321 20.876.347 19.813.017 17.18c-.195-1.562 1.285-3.372 3.814-5.016l1.027-.625c1.47-.84 3.207-1.62 5.125-2.278q-.12.342-.177.757m6.323-2.294c.443.182.788.428 1.046.734.42.492.632 1.145.632 1.946v.881H14.85v-.778c0-.648-.373-1.05-1.035-1.05-.556 0-.9.262-1.01.776a1.6 1.6 0 0 0 .012.614c.133.567.988 1.042 1.969 1.589 1.35.752 2.941 1.637 3.218 3.076.063.32.148 1.003.014 1.982a3.3 3.3 0 0 1-.261.923c2.162-.723 4.105-1.6 5.703-2.548l.82-.513c2.462-1.626 3.897-3.406 3.704-4.946-.334-2.661-5.411-3.72-11.854-2.686",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/ManufacturerIcon/icons/Shure.svg
var _path$103;
function _extends$115() {
	return _extends$115 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$115.apply(null, arguments);
}
var SvgShure = function SvgShure(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$115({
		xmlns: "http://www.w3.org/2000/svg",
		width: 28,
		height: 28,
		fill: "none",
		viewBox: "0 0 28 28"
	}, props), _path$103 || (_path$103 = /*#__PURE__*/ React.createElement("path", {
		fill: "#000",
		fillRule: "evenodd",
		d: "m4.456 13.527-2.069-.846H5.17l.157-1.156H1.65c-.672 0-1.287.598-1.265 1.273.017.495.24.846.704 1.039l2.01.837H.16L0 15.84l3.602.008c.753.002 1.397-.407 1.524-1.181.099-.598-.131-.919-.67-1.14m.838 2.32H7.37l.185-1.491h.653l-.185 1.49H10.1l.537-4.321H8.561l-.187 1.5h-.652l.186-1.5H5.831zm10.465-2.027c-.053.463-.276.84-.573 1.214-.227.285-.54.515-.863.679-.378.192-.753.267-1.173.301-.61.05-1.123-.059-1.625-.444a1.77 1.77 0 0 1-.594-.82c-.089-.266-.06-.52-.026-.788l.302-2.437h2.128l-.378 2.99h.549l.378-2.99h2.14zm2.124 2.027h-1.824l.334-2.664h2.972l.076-.51h-2.984l.144-1.148h3.692c1.436 0 1.465 2.057-.178 2.41l1.523.823.396-3.233h4.593l-.109.988H24.05l-.072.595h2.476l-.125 1.164h-2.494l-.071.586h2.489l-.109.989h-4.629l-.074.628-3.379-2.052zm9.671-3.93h-.077v.166h.08a.2.2 0 0 0 .096-.019q.03-.019.03-.06 0-.046-.031-.066-.03-.02-.098-.02m.017-.06q.104 0 .156.034a.12.12 0 0 1 .052.103.13.13 0 0 1-.03.088.14.14 0 0 1-.083.046l.11.227h-.105l-.101-.212h-.093v.212h-.094v-.498zm.371.262a.382.382 0 0 0-.735-.15.37.37 0 0 0 .083.413.38.38 0 0 0 .414.085.4.4 0 0 0 .127-.083.36.36 0 0 0 .111-.265m-.383-.444a.43.43 0 0 1 .314.13.438.438 0 0 1-.314.75.43.43 0 0 1-.31-.133.44.44 0 0 1-.128-.307q0-.088.034-.169a.46.46 0 0 1 .236-.24.4.4 0 0 1 .168-.03",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/ManufacturerIcon/icons/Sonos.svg
var _path$102;
function _extends$114() {
	return _extends$114 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$114.apply(null, arguments);
}
var SvgSonos = function SvgSonos(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$114({
		xmlns: "http://www.w3.org/2000/svg",
		width: 28,
		height: 28,
		fill: "none",
		viewBox: "0 0 28 28"
	}, props), _path$102 || (_path$102 = /*#__PURE__*/ React.createElement("path", {
		fill: "#1E202E",
		d: "M15.167 11.433h.982v5.254L12.833 13.6v2.928h-.982v-5.241l3.316 3.091zM10.3 13.989a2.754 2.754 0 0 1-2.75 2.751 2.754 2.754 0 0 1-2.751-2.751 2.754 2.754 0 0 1 2.75-2.751 2.754 2.754 0 0 1 2.75 2.751m-1.008 0c0-.973-.783-1.765-1.747-1.765s-1.742.792-1.742 1.765.782 1.765 1.742 1.765c.964 0 1.746-.792 1.746-1.765m-6.169.044c-.261-.2-.606-.358-1.114-.522-.995-.318-.995-.566-.995-.69 0-.283.314-.575.844-.575.447 0 .792.221.92.319l.07.053.792-.536-.088-.101a2.32 2.32 0 0 0-1.698-.743c-.509 0-.977.164-1.318.46A1.5 1.5 0 0 0 0 12.826c0 .451.2.831.588 1.128.261.198.606.358 1.114.521.995.314.995.566.995.69 0 .284-.313.575-.844.575a1.58 1.58 0 0 1-.92-.318l-.07-.053-.792.535.088.102c.027.03.637.738 1.694.738.508 0 .977-.163 1.318-.46.34-.296.534-.707.534-1.127q0-.671-.583-1.124m14.588-.022a2.754 2.754 0 0 1 2.75-2.751 2.754 2.754 0 0 1 2.75 2.751 2.754 2.754 0 0 1-2.75 2.751 2.754 2.754 0 0 1-2.75-2.751m1.004 0c0 .973.782 1.765 1.742 1.765.964 0 1.742-.792 1.742-1.765s-.782-1.765-1.742-1.765-1.742.792-1.742 1.765m6.169-.049c.26.2.605.358 1.114.522.995.319.995.566.995.69 0 .283-.314.575-.845.575-.446 0-.791-.221-.92-.318l-.07-.053-.792.535.088.101c.027.032.637.739 1.695.739.508 0 .976-.163 1.317-.46A1.5 1.5 0 0 0 28 15.165c0-.45-.2-.831-.588-1.127-.261-.2-.606-.359-1.114-.522-.995-.319-.995-.566-.995-.69 0-.283.313-.575.844-.575.447 0 .792.221.92.318l.07.053.792-.535-.088-.101a2.32 2.32 0 0 0-1.694-.739c-.508 0-.977.164-1.318.46-.34.296-.534.707-.534 1.128.004.45.198.83.588 1.127"
	})));
};

//#endregion
//#region src/ManufacturerIcon/icons/Ubiquiti.svg
var _path$101;
function _extends$113() {
	return _extends$113 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$113.apply(null, arguments);
}
var SvgUbiquiti = function SvgUbiquiti(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$113({
		xmlns: "http://www.w3.org/2000/svg",
		width: 28,
		height: 28,
		fill: "none",
		viewBox: "0 0 28 28"
	}, props), _path$101 || (_path$101 = /*#__PURE__*/ React.createElement("path", {
		fill: "#000",
		d: "M24.233 3h-1.365v1.364h1.365zm-4.774 9.554V9.821h2.729v2.729h2.727v.865c0 1-.085 2.184-.28 3.114a10 10 0 0 1-.47 1.532 10.699 10.699 0 0 1-1.82 3.058l-.024.027-.039.045c-.105.123-.209.245-.323.365q-.2.21-.412.412a10.85 10.85 0 0 1-6.4 2.972c-.286.03-.86.06-1.147.06s-.861-.03-1.148-.06a10.85 10.85 0 0 1-6.398-2.972 11 11 0 0 1-.412-.412 8 8 0 0 1-.338-.381l-.048-.056a10.7 10.7 0 0 1-1.82-3.058 10 10 0 0 1-.47-1.532c-.196-.931-.28-2.115-.28-3.114V3.17H8.54v9.383s0 .72.009.955l.002.055c.012.304.023.603.054.9.09.842.277 1.641.66 2.318.112.195.225.384.36.564a5.5 5.5 0 0 0 3.627 2.145c.185.027.56.05.747.05s.562-.023.747-.05a5.5 5.5 0 0 0 3.628-2.145c.135-.18.247-.37.358-.564.384-.677.57-1.476.66-2.318.032-.298.044-.597.055-.902l.002-.053c.01-.236.01-.955.01-.955m.681-7.507h2.047v2.045h2.728v2.729h-2.728V7.093H20.14z"
	})));
};

//#endregion
//#region src/ManufacturerIcon/icons/Unknown.svg
var _path$100;
var _path2$69;
function _extends$112() {
	return _extends$112 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$112.apply(null, arguments);
}
var SvgUnknown$1 = function SvgUnknown(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$112({
		xmlns: "http://www.w3.org/2000/svg",
		width: 28,
		height: 28,
		fill: "none",
		viewBox: "0 0 28 28"
	}, props), _path$100 || (_path$100 = /*#__PURE__*/ React.createElement("path", {
		fill: "#131522",
		d: "M9.8 23.581a.919.919 0 1 0 1.837 0v-1.444H9.8zM13.081 23.581a.919.919 0 0 0 1.838 0v-1.444H13.08zM16.363 23.581a.919.919 0 1 0 1.837 0v-1.444h-1.837zM23.581 11.637a.919.919 0 1 0 0-1.837h-1.444v1.837zM23.581 14.919a.919.919 0 1 0 0-1.838h-1.444v1.838zM23.581 18.2a.919.919 0 1 0 0-1.838h-1.444V18.2zM4.419 11.637a.919.919 0 1 1 0-1.837h1.444v1.837zM4.419 14.919a.919.919 0 1 1 0-1.838h1.444v1.838zM4.419 18.2a.919.919 0 1 1 0-1.838h1.444V18.2zM9.8 4.419a.919.919 0 1 1 1.837 0v1.444H9.8zM13.081 4.419a.919.919 0 1 1 1.838 0v1.444H13.08zM16.363 4.419a.919.919 0 1 1 1.837 0v1.444h-1.837z"
	})), _path2$69 || (_path2$69 = /*#__PURE__*/ React.createElement("path", {
		fill: "#131522",
		fillRule: "evenodd",
		d: "M17.6 8.3h-7.2a2.1 2.1 0 0 0-2.1 2.1v7.2c0 1.16.94 2.1 2.1 2.1h7.2a2.1 2.1 0 0 0 2.1-2.1v-7.2a2.1 2.1 0 0 0-2.1-2.1m-7.2-1.8a3.9 3.9 0 0 0-3.9 3.9v7.2a3.9 3.9 0 0 0 3.9 3.9h7.2a3.9 3.9 0 0 0 3.9-3.9v-7.2a3.9 3.9 0 0 0-3.9-3.9z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/ManufacturerIcon/icons/Verkada.svg
var _path$99;
function _extends$111() {
	return _extends$111 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$111.apply(null, arguments);
}
var SvgVerkada = function SvgVerkada(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$111({
		xmlns: "http://www.w3.org/2000/svg",
		width: 28,
		height: 28,
		fill: "none",
		viewBox: "0 0 28 28"
	}, props), _path$99 || (_path$99 = /*#__PURE__*/ React.createElement("path", {
		fill: "#151616",
		fillRule: "evenodd",
		d: "M8.433 18.373 22.211 4.598a.76.76 0 0 1 1.074 0l4.493 4.492a.76.76 0 0 1 0 1.073L14.537 23.402a.76.76 0 0 1-1.074 0zM.223 10.164a.76.76 0 0 1 0-1.074l4.492-4.492a.76.76 0 0 1 1.074 0l6.966 6.965-5.567 5.565z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/ManufacturerIcon/icons/Yealink.svg
var _path$98;
function _extends$110() {
	return _extends$110 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$110.apply(null, arguments);
}
var SvgYealink = function SvgYealink(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$110({
		xmlns: "http://www.w3.org/2000/svg",
		width: 28,
		height: 28,
		fill: "none",
		viewBox: "0 0 28 28"
	}, props), _path$98 || (_path$98 = /*#__PURE__*/ React.createElement("path", {
		fill: "#4C6363",
		fillRule: "evenodd",
		d: "M1.384 11.348H.027l2.064 3.13-.115 2.245h1.256l.128-2.26-.003-.004 2.297-3.133H4.3L2.77 13.502l-.006-.01zm19.29 1.295h-1.28l-.221 4.038h1.286l.16-2.854c1.502-.733 1.45.336 1.45.336l-.121 2.518h1.27l.176-2.65s.142-1.37-1.025-1.485-1.715.557-1.715.557zm-3.531-1.582h1.304l-.056.999H17.09zm1.216 1.578-.226 4.053h-1.295l.22-4.053zm5.791-1.472h1.119l-.14 2.86 1.642-1.596h1.202l-1.727 1.706 1.303 2.52H26.39l-.895-1.908-.425.461L25 16.656h-1.111zm-9.335-.106h1.304l-.313 5.63H14.51zm-1.728 1.538-.034.498c-.26-.355-.756-.724-1.671-.586-1.645.247-2.21 2.024-1.866 3.049.345 1.025 1.309 1.405 2.025 1.353.693-.052 1.038-.228 1.293-.617l-.03.422h.955l.31-4.115zm-1.4.875c.664 0 1.17.552 1.129 1.233s-.612 1.233-1.275 1.233c-.664 0-1.17-.552-1.13-1.233.041-.68.612-1.233 1.276-1.233m-4.961-1.193a2.33 2.33 0 0 1 2.28 2.802h-.938l.003-.009H5.4a1.403 1.403 0 0 0 2.27.614h1.12a2.33 2.33 0 1 1-2.065-3.407m-1.364 2.077H8.11a1.404 1.404 0 0 0-2.747 0",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/ManufacturerIcon/index.ts
const ManufacturerIconSVG = {
	Amazon: SvgAmazon,
	Amcrest: SvgAmcrest,
	Apple: SvgApple$1,
	Arista: SvgArista,
	ASIX: SvgAsix,
	Asus: SvgAsus,
	Cisco: SvgCisco,
	Dell: SvgDell,
	Ecobee: SvgEcobee,
	Foxconn: SvgFoxconn,
	Google: SvgGoogle$2,
	HP: SvgHp,
	IBM: SvgIbm,
	ICANN: SvgIcann,
	Intel: SvgIntel,
	Lenovo: SvgLenovo,
	LG: SvgLg,
	Logitech: SvgLogitech,
	Meter: SvgMeter,
	Microsoft: SvgMicrosoft$1,
	Neat: SvgNeat,
	Nest: SvgNest,
	Philips: SvgPhilips,
	Samsung: SvgSamsung,
	Shure: SvgShure,
	Sonos: SvgSonos,
	Ubiquiti: SvgUbiquiti,
	Unknown: SvgUnknown$1,
	Verkada: SvgVerkada,
	Yealink: SvgYealink
};

//#endregion
//#region src/PortIcon/icons/Ethernet.svg
var _path$97;
var _g$11;
var _path2$68;
function _extends$109() {
	return _extends$109 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$109.apply(null, arguments);
}
var SvgEthernet = function SvgEthernet(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$109({
		xmlns: "http://www.w3.org/2000/svg",
		width: 24,
		height: 20,
		fill: "none",
		viewBox: "0 0 24 20"
	}, props), _path$97 || (_path$97 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M1 7.3c0-1.491 1.231-2.7 2.75-2.7H6.5c0-.994.82-1.8 1.833-1.8 0-.932.722-1.698 1.646-1.79l.188-.01h3.666c1.012 0 1.834.806 1.834 1.8 1.012 0 1.833.806 1.833 1.8h2.75C21.769 4.6 23 5.809 23 7.3v9c0 1.491-1.231 2.7-2.75 2.7h-.75v-5.5a.5.5 0 1 0-1 0V19h-1v-5.5a.5.5 0 1 0-1 0V19h-1v-5.5a.5.5 0 1 0-1 0V19h-1v-5.5a.5.5 0 1 0-1 0V19h-1v-5.5a.5.5 0 1 0-1 0V19h-1v-5.5a.5.5 0 0 0-1 0V19h-1v-5.5a.5.5 0 0 0-1 0V19h-1v-5.5a.5.5 0 0 0-1 0V19h-.75C2.231 19 1 17.791 1 16.3z",
		clipRule: "evenodd",
		opacity: .25
	})), _g$11 || (_g$11 = /*#__PURE__*/ React.createElement("g", {
		fill: "currentColor",
		opacity: .5
	}, /*#__PURE__*/ React.createElement("path", { d: "M5.5 19v-5.5a.5.5 0 0 0-1 0V19zM7.5 19v-5.5a.5.5 0 0 0-1 0V19zM9.5 19v-5.5a.5.5 0 0 0-1 0V19zM11.5 19v-5.5a.5.5 0 0 0-1 0V19zM13.5 19v-5.5a.5.5 0 0 0-1 0V19zM15.5 19v-5.5a.5.5 0 0 0-1 0V19zM17.5 19v-5.5a.5.5 0 0 0-1 0V19zM19.5 19v-5.5a.5.5 0 0 0-1 0V19z" }))), _path2$68 || (_path2$68 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M0 16.3v-9c0-2.06 1.696-3.7 3.75-3.7h1.94a2.82 2.82 0 0 1 1.782-1.666A2.83 2.83 0 0 1 10.167 0h3.666c1.247 0 2.323.803 2.694 1.934A2.82 2.82 0 0 1 18.311 3.6h1.939C22.304 3.6 24 5.24 24 7.3v9c0 2.06-1.696 3.7-3.75 3.7H3.75C1.696 20 0 18.36 0 16.3m1-9c0-1.491 1.231-2.7 2.75-2.7H6.5c0-.994.82-1.8 1.833-1.8 0-.932.722-1.698 1.646-1.79l.188-.01h3.666c1.012 0 1.834.806 1.834 1.8 1.012 0 1.833.806 1.833 1.8h2.75C21.769 4.6 23 5.809 23 7.3v9c0 1.491-1.231 2.7-2.75 2.7H3.75C2.231 19 1 17.791 1 16.3z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/PortIcon/icons/Outlet.svg
var _path$96;
var _path2$67;
var _path3$39;
function _extends$108() {
	return _extends$108 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$108.apply(null, arguments);
}
var SvgOutlet = function SvgOutlet(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$108({
		xmlns: "http://www.w3.org/2000/svg",
		width: 24,
		height: 20,
		fill: "none",
		viewBox: "0 0 24 20"
	}, props), _path$96 || (_path$96 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M15.994 1c.413 0 .825.091 1.184.302 3.026 1.775 4.88 5.051 4.88 8.698s-1.853 6.923-4.88 8.698c-.359.21-.77.302-1.183.302H8.006c-.413 0-.824-.091-1.184-.302-3.026-1.775-4.88-5.051-4.88-8.698s1.854-6.923 4.88-8.698c.36-.21.77-.302 1.184-.302zm-7.541 9.265a.953.953 0 0 0-.953.952v3.389a.953.953 0 0 0 1.906 0v-3.389a.953.953 0 0 0-.953-.952m7.094.53a.953.953 0 0 0-.953.952v2.33a.953.953 0 0 0 1.906 0v-2.33a.953.953 0 0 0-.953-.953M10.765 4.44a.62.62 0 0 0-.618.618v1.235a1.853 1.853 0 1 0 3.706 0V5.06a.62.62 0 0 0-.618-.618z",
		clipRule: "evenodd",
		opacity: .25
	})), _path2$67 || (_path2$67 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8.453 10.265a.953.953 0 0 0-.953.952v3.389a.953.953 0 0 0 1.906 0v-3.389a.953.953 0 0 0-.953-.952m7.094.53a.953.953 0 0 0-.953.952v2.33a.953.953 0 1 0 1.906 0v-2.33a.953.953 0 0 0-.953-.953M10.765 4.44a.62.62 0 0 0-.618.618v1.235a1.853 1.853 0 1 0 3.706 0V5.06a.62.62 0 0 0-.618-.618z",
		clipRule: "evenodd",
		opacity: .5
	})), _path3$39 || (_path3$39 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		d: "M15.994 0c.558 0 1.15.123 1.69.44 3.343 1.96 5.374 5.57 5.374 9.56s-2.032 7.6-5.374 9.56c-.54.317-1.132.44-1.69.44H8.008c-.558 0-1.151-.123-1.69-.44C2.973 17.6.94 13.99.94 10S2.974 2.4 6.316.44A3.3 3.3 0 0 1 8.006 0zM8.006 1c-.413 0-.824.092-1.184.303-3.026 1.775-4.88 5.05-4.88 8.697s1.854 6.922 4.88 8.697c.36.211.772.303 1.185.303h7.988c.413 0 .824-.092 1.184-.303 3.025-1.774 4.88-5.05 4.88-8.697s-1.855-6.922-4.88-8.697A2.33 2.33 0 0 0 15.994 1z"
	})));
};

//#endregion
//#region src/PortIcon/icons/SFP.svg
var _path$95;
var _path2$66;
function _extends$107() {
	return _extends$107 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$107.apply(null, arguments);
}
var SvgSfp = function SvgSfp(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$107({
		xmlns: "http://www.w3.org/2000/svg",
		width: 24,
		height: 20,
		fill: "none",
		viewBox: "0 0 24 20"
	}, props), _path$95 || (_path$95 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M1 4a3 3 0 0 1 3-3h3.5l.224.447A1 1 0 0 0 8.618 2h6.764a1 1 0 0 0 .894-.553L16.5 1H20a3 3 0 0 1 3 3v12l-.004.154a3 3 0 0 1-2.842 2.842L20 19H4l-.154-.004a3 3 0 0 1-2.842-2.842L1 16z",
		clipRule: "evenodd",
		opacity: .25
	})), _path2$66 || (_path2$66 = /*#__PURE__*/ React.createElement("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M0 4v12a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4H4a4 4 0 0 0-4 4m1 0a3 3 0 0 1 3-3h3.5l.224.447A1 1 0 0 0 8.618 2h6.764a1 1 0 0 0 .894-.553L16.5 1H20a3 3 0 0 1 3 3v12l-.004.154a3 3 0 0 1-2.842 2.842L20 19H4l-.154-.004a3 3 0 0 1-2.842-2.842L1 16z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/PortIcon/index.ts
const PortIconSVG = {
	Ethernet: SvgEthernet,
	Outlet: SvgOutlet,
	SFP: SvgSfp
};

//#endregion
//#region src/ProductIcon/icons/Access.svg
var _g$10;
var _defs$18;
function _extends$106() {
	return _extends$106 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$106.apply(null, arguments);
}
var SvgAccess = function SvgAccess(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$106({
		xmlns: "http://www.w3.org/2000/svg",
		width: 34,
		height: 34,
		fill: "none",
		viewBox: "0 0 34 34"
	}, props), _g$10 || (_g$10 = /*#__PURE__*/ React.createElement("g", { clipPath: "url(#a)" }, /*#__PURE__*/ React.createElement("g", { filter: "url(#b)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "url(#c)",
		fillRule: "evenodd",
		d: "M33 17c0 5.458-.372 11.615-2.372 13.621S21.465 33 17.047 33c-4.42 0-11.582-.373-13.582-2.379S1 22.458 1 17 1.465 5.385 3.465 3.379 12.628 1 17.047 1c4.418 0 11.58.373 13.58 2.379S33 11.542 33 17",
		clipRule: "evenodd"
	}), /*#__PURE__*/ React.createElement("path", {
		stroke: "url(#d)",
		strokeWidth: .421,
		d: "M32.79 17c0 2.726-.094 5.618-.435 8.076-.17 1.229-.402 2.343-.712 3.271-.312.931-.697 1.657-1.164 2.125-.463.465-1.246.852-2.258 1.166-1.006.312-2.214.545-3.504.716-2.58.342-5.465.435-7.67.435s-5.09-.093-7.67-.435c-1.29-.171-2.499-.404-3.505-.716-1.012-.314-1.795-.701-2.258-1.166-.467-.469-.859-1.195-1.179-2.126-.319-.929-.562-2.043-.744-3.272-.364-2.457-.48-5.35-.48-8.074s.116-5.617.48-8.074c.182-1.229.425-2.343.744-3.272.32-.93.712-1.657 1.18-2.126.462-.465 1.245-.852 2.257-1.166 1.006-.312 2.214-.545 3.505-.716 2.58-.342 5.464-.435 7.67-.435s5.09.093 7.67.435c1.29.171 2.498.404 3.504.716 1.012.314 1.795.701 2.258 1.166.467.468.852 1.194 1.164 2.125.31.928.542 2.042.712 3.271.341 2.458.434 5.35.434 8.076Z"
	})), /*#__PURE__*/ React.createElement("g", { filter: "url(#e)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		fillRule: "evenodd",
		d: "M26.404 12.504v8.61c0 .789-.496 1.493-1.24 1.758l-6.838 2.442c-.812.29-1.7.29-2.511 0l-6.84-2.442a1.87 1.87 0 0 1-1.238-1.758v-8.61c0-.833.552-1.566 1.354-1.795l6.954-1.986a3.73 3.73 0 0 1 2.05 0l6.955 1.986a1.87 1.87 0 0 1 1.354 1.795m-6.183 2.924 4.183-1.494v5.865c0 .732-.461 1.386-1.15 1.632l-4.184 1.494V17.06c0-.733.46-1.386 1.15-1.632m1.447-4.12-4.313-1.255a1.1 1.1 0 0 0-.57 0l-4.313 1.256a.458.458 0 0 0-.023.875l4.276 1.242c.22.075.47.075.69 0l4.277-1.242a.458.458 0 0 0-.024-.876",
		clipRule: "evenodd"
	})), /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		fillRule: "evenodd",
		d: "m20.22 15.428 4.184-1.494v5.865c0 .732-.461 1.385-1.15 1.632l-4.184 1.494V17.06c0-.733.46-1.386 1.15-1.632",
		clipRule: "evenodd",
		opacity: .56
	}))), _defs$18 || (_defs$18 = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("filter", {
		id: "b",
		width: 33.4,
		height: 33.4,
		x: .3,
		y: .7,
		colorInterpolationFilters: "sRGB",
		filterUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("feFlood", {
		floodOpacity: 0,
		result: "BackgroundImageFix"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", {
		"in": "SourceAlpha",
		result: "hardAlpha",
		values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
	}), /*#__PURE__*/ React.createElement("feOffset", { dy: .4 }), /*#__PURE__*/ React.createElement("feGaussianBlur", { stdDeviation: .35 }), /*#__PURE__*/ React.createElement("feComposite", {
		in2: "hardAlpha",
		operator: "out"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", { values: "0 0 0 0 0.113618 0 0 0 0 0.115698 0 0 0 0 0.133377 0 0 0 0.56 0" }), /*#__PURE__*/ React.createElement("feBlend", {
		in2: "BackgroundImageFix",
		result: "effect1_dropShadow_6008_1354"
	}), /*#__PURE__*/ React.createElement("feBlend", {
		"in": "SourceGraphic",
		in2: "effect1_dropShadow_6008_1354",
		result: "shape"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", {
		"in": "SourceAlpha",
		result: "hardAlpha",
		values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
	}), /*#__PURE__*/ React.createElement("feOffset", { dy: -.168 }), /*#__PURE__*/ React.createElement("feGaussianBlur", { stdDeviation: .421 }), /*#__PURE__*/ React.createElement("feComposite", {
		in2: "hardAlpha",
		k2: -1,
		k3: 1,
		operator: "arithmetic"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" }), /*#__PURE__*/ React.createElement("feBlend", {
		in2: "shape",
		result: "effect2_innerShadow_6008_1354"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", {
		"in": "SourceAlpha",
		result: "hardAlpha",
		values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
	}), /*#__PURE__*/ React.createElement("feOffset", { dy: .842 }), /*#__PURE__*/ React.createElement("feGaussianBlur", { stdDeviation: .421 }), /*#__PURE__*/ React.createElement("feComposite", {
		in2: "hardAlpha",
		k2: -1,
		k3: 1,
		operator: "arithmetic"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", { values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" }), /*#__PURE__*/ React.createElement("feBlend", {
		in2: "effect2_innerShadow_6008_1354",
		result: "effect3_innerShadow_6008_1354"
	})), /*#__PURE__*/ React.createElement("filter", {
		id: "e",
		width: 20.351,
		height: 18.637,
		x: 6.895,
		y: 8.579,
		colorInterpolationFilters: "sRGB",
		filterUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("feFlood", {
		floodOpacity: 0,
		result: "BackgroundImageFix"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", {
		"in": "SourceAlpha",
		result: "hardAlpha",
		values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
	}), /*#__PURE__*/ React.createElement("feOffset", { dy: .842 }), /*#__PURE__*/ React.createElement("feGaussianBlur", { stdDeviation: .421 }), /*#__PURE__*/ React.createElement("feComposite", {
		in2: "hardAlpha",
		operator: "out"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.56 0" }), /*#__PURE__*/ React.createElement("feBlend", {
		in2: "BackgroundImageFix",
		result: "effect1_dropShadow_6008_1354"
	}), /*#__PURE__*/ React.createElement("feBlend", {
		"in": "SourceGraphic",
		in2: "effect1_dropShadow_6008_1354",
		result: "shape"
	})), /*#__PURE__*/ React.createElement("radialGradient", {
		id: "c",
		cx: 0,
		cy: 0,
		r: 1,
		gradientTransform: "matrix(0 -32 64.2653 0 17 33)",
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#58DB6D" }), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#1CA733"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "d",
		x1: 17,
		x2: 17,
		y1: 1,
		y2: 33,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#58DB6D" }), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#1CA733"
	})), /*#__PURE__*/ React.createElement("clipPath", { id: "a" }, /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M0 0h34v34H0z"
	})))));
};

//#endregion
//#region src/ProductIcon/icons/AutoVPN.svg
var _g$9;
var _defs$17;
function _extends$105() {
	return _extends$105 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$105.apply(null, arguments);
}
var SvgAutoVpn = function SvgAutoVpn(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$105({
		xmlns: "http://www.w3.org/2000/svg",
		width: 34,
		height: 34,
		fill: "none",
		viewBox: "0 0 34 34"
	}, props), _g$9 || (_g$9 = /*#__PURE__*/ React.createElement("g", { clipPath: "url(#a)" }, /*#__PURE__*/ React.createElement("g", { filter: "url(#b)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "url(#c)",
		fillRule: "evenodd",
		d: "M33 17c0 5.458-.372 11.615-2.372 13.621S21.465 33 17.047 33c-4.42 0-11.582-.373-13.582-2.379S1 22.458 1 17 1.465 5.385 3.465 3.379 12.628 1 17.047 1c4.418 0 11.58.373 13.58 2.379S33 11.542 33 17",
		clipRule: "evenodd"
	}), /*#__PURE__*/ React.createElement("path", {
		stroke: "url(#d)",
		strokeWidth: .421,
		d: "M32.79 17c0 2.726-.094 5.618-.435 8.076-.17 1.229-.402 2.343-.712 3.271-.312.931-.697 1.657-1.164 2.125-.463.465-1.246.852-2.258 1.166-1.006.312-2.214.545-3.504.716-2.58.342-5.465.435-7.67.435s-5.09-.093-7.67-.435c-1.29-.171-2.499-.404-3.505-.716-1.012-.314-1.795-.701-2.258-1.166-.467-.469-.859-1.195-1.179-2.126-.319-.929-.562-2.043-.744-3.272-.364-2.457-.48-5.35-.48-8.074s.116-5.617.48-8.074c.182-1.229.425-2.343.744-3.272.32-.93.712-1.657 1.18-2.126.462-.465 1.245-.852 2.257-1.166 1.006-.312 2.214-.545 3.505-.716 2.58-.342 5.464-.435 7.67-.435s5.09.093 7.67.435c1.29.171 2.498.404 3.504.716 1.012.314 1.795.701 2.258 1.166.467.468.852 1.194 1.164 2.125.31.928.542 2.042.712 3.271.341 2.458.434 5.35.434 8.076Z"
	})), /*#__PURE__*/ React.createElement("g", {
		fill: "#fff",
		filter: "url(#e)"
	}, /*#__PURE__*/ React.createElement("path", {
		fillOpacity: .56,
		d: "M18.04 12.547a6.344 6.344 0 0 0 1.635 11.649l-.004.002-8.82-2.364v-.002a6.344 6.344 0 1 1 3.49-12.2l8.236 2.208-.006.003a6.32 6.32 0 0 0-3.657.284"
	}), /*#__PURE__*/ React.createElement("path", {
		fillRule: "evenodd",
		d: "M19.845 15.671a2.736 2.736 0 1 0 2.736 4.74 2.736 2.736 0 0 0-2.736-4.74m-1.804-3.125a6.344 6.344 0 1 0 6.344 10.99 6.344 6.344 0 0 0-6.344-10.99",
		clipRule: "evenodd"
	})))), _defs$17 || (_defs$17 = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("filter", {
		id: "b",
		width: 33.4,
		height: 33.4,
		x: .3,
		y: .7,
		colorInterpolationFilters: "sRGB",
		filterUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("feFlood", {
		floodOpacity: 0,
		result: "BackgroundImageFix"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", {
		"in": "SourceAlpha",
		result: "hardAlpha",
		values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
	}), /*#__PURE__*/ React.createElement("feOffset", { dy: .4 }), /*#__PURE__*/ React.createElement("feGaussianBlur", { stdDeviation: .35 }), /*#__PURE__*/ React.createElement("feComposite", {
		in2: "hardAlpha",
		operator: "out"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", { values: "0 0 0 0 0.113618 0 0 0 0 0.115698 0 0 0 0 0.133377 0 0 0 0.56 0" }), /*#__PURE__*/ React.createElement("feBlend", {
		in2: "BackgroundImageFix",
		result: "effect1_dropShadow_6008_1365"
	}), /*#__PURE__*/ React.createElement("feBlend", {
		"in": "SourceGraphic",
		in2: "effect1_dropShadow_6008_1365",
		result: "shape"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", {
		"in": "SourceAlpha",
		result: "hardAlpha",
		values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
	}), /*#__PURE__*/ React.createElement("feOffset", { dy: -.168 }), /*#__PURE__*/ React.createElement("feGaussianBlur", { stdDeviation: .421 }), /*#__PURE__*/ React.createElement("feComposite", {
		in2: "hardAlpha",
		k2: -1,
		k3: 1,
		operator: "arithmetic"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" }), /*#__PURE__*/ React.createElement("feBlend", {
		in2: "shape",
		result: "effect2_innerShadow_6008_1365"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", {
		"in": "SourceAlpha",
		result: "hardAlpha",
		values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
	}), /*#__PURE__*/ React.createElement("feOffset", { dy: .842 }), /*#__PURE__*/ React.createElement("feGaussianBlur", { stdDeviation: .421 }), /*#__PURE__*/ React.createElement("feComposite", {
		in2: "hardAlpha",
		k2: -1,
		k3: 1,
		operator: "arithmetic"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", { values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" }), /*#__PURE__*/ React.createElement("feBlend", {
		in2: "effect2_innerShadow_6008_1365",
		result: "effect3_innerShadow_6008_1365"
	})), /*#__PURE__*/ React.createElement("filter", {
		id: "e",
		width: 23.042,
		height: 16.697,
		x: 5.359,
		y: 9.373,
		colorInterpolationFilters: "sRGB",
		filterUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("feFlood", {
		floodOpacity: 0,
		result: "BackgroundImageFix"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", {
		"in": "SourceAlpha",
		result: "hardAlpha",
		values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
	}), /*#__PURE__*/ React.createElement("feOffset", { dy: .842 }), /*#__PURE__*/ React.createElement("feGaussianBlur", { stdDeviation: .421 }), /*#__PURE__*/ React.createElement("feComposite", {
		in2: "hardAlpha",
		operator: "out"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.56 0" }), /*#__PURE__*/ React.createElement("feBlend", {
		in2: "BackgroundImageFix",
		result: "effect1_dropShadow_6008_1365"
	}), /*#__PURE__*/ React.createElement("feBlend", {
		"in": "SourceGraphic",
		in2: "effect1_dropShadow_6008_1365",
		result: "shape"
	})), /*#__PURE__*/ React.createElement("radialGradient", {
		id: "c",
		cx: 0,
		cy: 0,
		r: 1,
		gradientTransform: "matrix(0 -32 64.2653 0 17 33)",
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#D0A0DA" }), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#901CA7"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "d",
		x1: 17,
		x2: 17,
		y1: 1,
		y2: 33,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#D0A0DA" }), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#901CA7"
	})), /*#__PURE__*/ React.createElement("clipPath", { id: "a" }, /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M0 0h34v34H0z"
	})))));
};

//#endregion
//#region src/ProductIcon/icons/Cellular.svg
var _g$8;
var _g2$1;
var _defs$16;
function _extends$104() {
	return _extends$104 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$104.apply(null, arguments);
}
var SvgCellular = function SvgCellular(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$104({
		xmlns: "http://www.w3.org/2000/svg",
		width: 34,
		height: 35,
		fill: "none",
		viewBox: "0 0 34 35"
	}, props), _g$8 || (_g$8 = /*#__PURE__*/ React.createElement("g", { filter: "url(#a)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "url(#b)",
		fillRule: "evenodd",
		d: "M33 17c0 5.458-.372 11.615-2.372 13.621S21.465 33 17.047 33c-4.42 0-11.582-.373-13.582-2.379S1 22.458 1 17 1.465 5.385 3.465 3.379 12.628 1 17.047 1c4.418 0 11.58.373 13.58 2.379S33 11.542 33 17",
		clipRule: "evenodd"
	}), /*#__PURE__*/ React.createElement("path", {
		stroke: "url(#c)",
		strokeWidth: .421,
		d: "M32.79 17c0 2.726-.094 5.618-.435 8.076-.17 1.229-.402 2.343-.712 3.271-.312.931-.697 1.657-1.164 2.125-.463.465-1.246.852-2.258 1.166-1.006.312-2.214.545-3.504.716-2.58.342-5.465.435-7.67.435s-5.09-.093-7.67-.435c-1.29-.171-2.499-.404-3.505-.716-1.012-.314-1.795-.701-2.258-1.166-.467-.469-.859-1.195-1.179-2.126-.319-.929-.562-2.043-.744-3.272-.364-2.457-.48-5.35-.48-8.074s.116-5.617.48-8.074c.182-1.229.425-2.343.744-3.272.32-.93.712-1.657 1.18-2.126.462-.465 1.245-.852 2.257-1.166 1.006-.312 2.214-.545 3.505-.716 2.58-.342 5.464-.435 7.67-.435s5.09.093 7.67.435c1.29.171 2.498.404 3.504.716 1.012.314 1.795.701 2.258 1.166.467.468.852 1.194 1.164 2.125.31.928.542 2.042.712 3.271.341 2.458.434 5.35.434 8.076Z"
	}))), _g2$1 || (_g2$1 = /*#__PURE__*/ React.createElement("g", {
		fill: "#fff",
		filter: "url(#d)"
	}, /*#__PURE__*/ React.createElement("path", { d: "M12.064 12.063c.292-.293.347-1.192.347-1.99 0-.796-.055-1.696-.347-1.989s-1.338-.347-1.983-.347c-.646 0-1.692.054-1.984.347s-.36 1.193-.36 1.99.068 1.696.36 1.99c.292.292 1.338.347 1.984.347s1.69-.055 1.983-.348" }), /*#__PURE__*/ React.createElement("path", {
		d: "M12.404 22.175a2.333 2.333 0 0 0-4.667 0v1.51a2.333 2.333 0 1 0 4.666 0z",
		opacity: .5
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M17.07 19.368a2.333 2.333 0 1 0-4.666 0v4.316a2.333 2.333 0 1 0 4.667 0z",
		opacity: .667
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M21.737 16.56a2.333 2.333 0 1 0-4.666 0v7.123a2.333 2.333 0 1 0 4.666 0z",
		opacity: .833
	}), /*#__PURE__*/ React.createElement("path", { d: "M26.404 13.754a2.333 2.333 0 0 0-4.667 0v9.93a2.333 2.333 0 1 0 4.667 0z" }))), _defs$16 || (_defs$16 = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("filter", {
		id: "a",
		width: 33.4,
		height: 33.4,
		x: .3,
		y: .7,
		colorInterpolationFilters: "sRGB",
		filterUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("feFlood", {
		floodOpacity: 0,
		result: "BackgroundImageFix"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", {
		"in": "SourceAlpha",
		result: "hardAlpha",
		values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
	}), /*#__PURE__*/ React.createElement("feOffset", { dy: .4 }), /*#__PURE__*/ React.createElement("feGaussianBlur", { stdDeviation: .35 }), /*#__PURE__*/ React.createElement("feComposite", {
		in2: "hardAlpha",
		operator: "out"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", { values: "0 0 0 0 0.113618 0 0 0 0 0.115698 0 0 0 0 0.133377 0 0 0 0.56 0" }), /*#__PURE__*/ React.createElement("feBlend", {
		in2: "BackgroundImageFix",
		result: "effect1_dropShadow_6008_1376"
	}), /*#__PURE__*/ React.createElement("feBlend", {
		"in": "SourceGraphic",
		in2: "effect1_dropShadow_6008_1376",
		result: "shape"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", {
		"in": "SourceAlpha",
		result: "hardAlpha",
		values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
	}), /*#__PURE__*/ React.createElement("feOffset", { dy: -.168 }), /*#__PURE__*/ React.createElement("feGaussianBlur", { stdDeviation: .421 }), /*#__PURE__*/ React.createElement("feComposite", {
		in2: "hardAlpha",
		k2: -1,
		k3: 1,
		operator: "arithmetic"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" }), /*#__PURE__*/ React.createElement("feBlend", {
		in2: "shape",
		result: "effect2_innerShadow_6008_1376"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", {
		"in": "SourceAlpha",
		result: "hardAlpha",
		values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
	}), /*#__PURE__*/ React.createElement("feOffset", { dy: .842 }), /*#__PURE__*/ React.createElement("feGaussianBlur", { stdDeviation: .421 }), /*#__PURE__*/ React.createElement("feComposite", {
		in2: "hardAlpha",
		k2: -1,
		k3: 1,
		operator: "arithmetic"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", { values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" }), /*#__PURE__*/ React.createElement("feBlend", {
		in2: "effect2_innerShadow_6008_1376",
		result: "effect3_innerShadow_6008_1376"
	})), /*#__PURE__*/ React.createElement("filter", {
		id: "d",
		width: 20.351,
		height: 20.21,
		x: 6.895,
		y: 7.737,
		colorInterpolationFilters: "sRGB",
		filterUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("feFlood", {
		floodOpacity: 0,
		result: "BackgroundImageFix"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", {
		"in": "SourceAlpha",
		result: "hardAlpha",
		values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
	}), /*#__PURE__*/ React.createElement("feOffset", { dy: .842 }), /*#__PURE__*/ React.createElement("feGaussianBlur", { stdDeviation: .421 }), /*#__PURE__*/ React.createElement("feComposite", {
		in2: "hardAlpha",
		operator: "out"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.56 0" }), /*#__PURE__*/ React.createElement("feBlend", {
		in2: "BackgroundImageFix",
		result: "effect1_dropShadow_6008_1376"
	}), /*#__PURE__*/ React.createElement("feBlend", {
		"in": "SourceGraphic",
		in2: "effect1_dropShadow_6008_1376",
		result: "shape"
	})), /*#__PURE__*/ React.createElement("radialGradient", {
		id: "b",
		cx: 0,
		cy: 0,
		r: 1,
		gradientTransform: "matrix(0 -32 64.2653 0 17 33)",
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#92BBFC" }), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#1754B1"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "c",
		x1: 17,
		x2: 17,
		y1: 1,
		y2: 33,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#92BBFC" }), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#1754B1"
	})))));
};

//#endregion
//#region src/ProductIcon/icons/Command.svg
var _g$7;
var _defs$15;
function _extends$103() {
	return _extends$103 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$103.apply(null, arguments);
}
var SvgCommand = function SvgCommand(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$103({
		xmlns: "http://www.w3.org/2000/svg",
		width: 34,
		height: 34,
		fill: "none",
		viewBox: "0 0 34 34"
	}, props), _g$7 || (_g$7 = /*#__PURE__*/ React.createElement("g", { clipPath: "url(#a)" }, /*#__PURE__*/ React.createElement("g", { filter: "url(#b)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "url(#c)",
		fillRule: "evenodd",
		d: "M33 17c0 5.458-.372 11.615-2.372 13.621S21.465 33 17.047 33c-4.42 0-11.582-.373-13.582-2.379S1 22.458 1 17 1.465 5.385 3.465 3.379 12.628 1 17.047 1c4.418 0 11.58.373 13.58 2.379S33 11.542 33 17",
		clipRule: "evenodd"
	}), /*#__PURE__*/ React.createElement("path", {
		stroke: "url(#d)",
		strokeWidth: .421,
		d: "M32.79 17c0 2.726-.094 5.618-.435 8.076-.17 1.229-.402 2.343-.712 3.271-.312.931-.697 1.657-1.164 2.125-.463.465-1.246.852-2.258 1.166-1.006.312-2.214.545-3.504.716-2.58.342-5.465.435-7.67.435s-5.09-.093-7.67-.435c-1.29-.171-2.499-.404-3.505-.716-1.012-.314-1.795-.701-2.258-1.166-.467-.469-.859-1.195-1.179-2.126-.319-.929-.562-2.043-.744-3.272-.364-2.457-.48-5.35-.48-8.074s.116-5.617.48-8.074c.182-1.229.425-2.343.744-3.272.32-.93.712-1.657 1.18-2.126.462-.465 1.245-.852 2.257-1.166 1.006-.312 2.214-.545 3.505-.716 2.58-.342 5.464-.435 7.67-.435s5.09.093 7.67.435c1.29.171 2.498.404 3.504.716 1.012.314 1.795.701 2.258 1.166.467.468.852 1.194 1.164 2.125.31.928.542 2.042.712 3.271.341 2.458.434 5.35.434 8.076Z"
	})), /*#__PURE__*/ React.createElement("g", { filter: "url(#e)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M14.053 8.294a.55.55 0 0 0-.61-.552q-.21.024-.419.051c-.707.094-1.416.227-2.038.42-.59.183-1.258.466-1.741.95-.456.458-.745 1.06-.94 1.63-.203.589-.345 1.255-.446 1.938-.202 1.366-.263 2.936-.263 4.37 0 1.433.06 3.003.263 4.37.101.682.243 1.348.445 1.937.196.57.485 1.172.94 1.63.484.484 1.153.767 1.742.95.622.193 1.33.326 2.038.42q.208.027.42.051a.55.55 0 0 0 .609-.552v-1.471c0-.29-.22-.53-.507-.565l-.182-.023a10 10 0 0 1-1.613-.327 3 3 0 0 1-.5-.195 1 1 0 0 1-.167-.102l-.008-.007-.002-.002c-.06-.06-.189-.243-.328-.647a8.5 8.5 0 0 1-.332-1.476c-.175-1.184-.235-2.61-.235-3.991s.06-2.808.235-3.992c.088-.592.2-1.09.332-1.476.14-.404.268-.586.327-.646l.003-.003.008-.007.033-.024q.044-.03.133-.078.18-.095.501-.195a10 10 0 0 1 1.613-.326l.182-.024a.573.573 0 0 0 .507-.565zm6.175 16.147c0-.289.22-.53.508-.564l.229-.03c.63-.083 1.181-.192 1.613-.326q.32-.1.5-.195a1 1 0 0 0 .167-.102l.007-.007.003-.003c.056-.056.182-.233.316-.636.129-.385.236-.881.318-1.474.165-1.186.213-2.614.213-4.003s-.049-2.817-.213-4.003c-.082-.593-.189-1.09-.318-1.475-.134-.402-.26-.58-.317-.637l-.001-.002-.008-.007-.033-.024a1 1 0 0 0-.134-.078 3 3 0 0 0-.5-.195c-.432-.134-.983-.243-1.613-.326l-.23-.03a.57.57 0 0 1-.507-.564V8.289c0-.329.282-.588.608-.552q.237.026.469.057c.707.093 1.415.226 2.038.42.589.182 1.258.465 1.74.95.46.46.746 1.068.937 1.64.198.59.332 1.257.427 1.939.19 1.364.237 2.932.237 4.358s-.048 2.993-.237 4.358c-.095.682-.23 1.349-.427 1.939-.191.571-.476 1.179-.936 1.64-.483.484-1.152.767-1.741.95-.623.193-1.331.326-2.038.42q-.233.03-.468.056a.55.55 0 0 1-.609-.552z"
	})))), _defs$15 || (_defs$15 = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("filter", {
		id: "b",
		width: 33.4,
		height: 33.4,
		x: .3,
		y: .7,
		colorInterpolationFilters: "sRGB",
		filterUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("feFlood", {
		floodOpacity: 0,
		result: "BackgroundImageFix"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", {
		"in": "SourceAlpha",
		result: "hardAlpha",
		values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
	}), /*#__PURE__*/ React.createElement("feOffset", { dy: .4 }), /*#__PURE__*/ React.createElement("feGaussianBlur", { stdDeviation: .35 }), /*#__PURE__*/ React.createElement("feComposite", {
		in2: "hardAlpha",
		operator: "out"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", { values: "0 0 0 0 0.113618 0 0 0 0 0.115698 0 0 0 0 0.133377 0 0 0 0.56 0" }), /*#__PURE__*/ React.createElement("feBlend", {
		in2: "BackgroundImageFix",
		result: "effect1_dropShadow_6008_1393"
	}), /*#__PURE__*/ React.createElement("feBlend", {
		"in": "SourceGraphic",
		in2: "effect1_dropShadow_6008_1393",
		result: "shape"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", {
		"in": "SourceAlpha",
		result: "hardAlpha",
		values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
	}), /*#__PURE__*/ React.createElement("feOffset", { dy: -.168 }), /*#__PURE__*/ React.createElement("feGaussianBlur", { stdDeviation: .421 }), /*#__PURE__*/ React.createElement("feComposite", {
		in2: "hardAlpha",
		k2: -1,
		k3: 1,
		operator: "arithmetic"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" }), /*#__PURE__*/ React.createElement("feBlend", {
		in2: "shape",
		result: "effect2_innerShadow_6008_1393"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", {
		"in": "SourceAlpha",
		result: "hardAlpha",
		values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
	}), /*#__PURE__*/ React.createElement("feOffset", { dy: .842 }), /*#__PURE__*/ React.createElement("feGaussianBlur", { stdDeviation: .421 }), /*#__PURE__*/ React.createElement("feComposite", {
		in2: "hardAlpha",
		k2: -1,
		k3: 1,
		operator: "arithmetic"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", { values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" }), /*#__PURE__*/ React.createElement("feBlend", {
		in2: "effect2_innerShadow_6008_1393",
		result: "effect3_innerShadow_6008_1393"
	})), /*#__PURE__*/ React.createElement("filter", {
		id: "e",
		width: 20.772,
		height: 20.419,
		x: 6.754,
		y: 7.733,
		colorInterpolationFilters: "sRGB",
		filterUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("feFlood", {
		floodOpacity: 0,
		result: "BackgroundImageFix"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", {
		"in": "SourceAlpha",
		result: "hardAlpha",
		values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
	}), /*#__PURE__*/ React.createElement("feOffset", { dy: .842 }), /*#__PURE__*/ React.createElement("feGaussianBlur", { stdDeviation: .421 }), /*#__PURE__*/ React.createElement("feComposite", {
		in2: "hardAlpha",
		operator: "out"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0" }), /*#__PURE__*/ React.createElement("feBlend", {
		in2: "BackgroundImageFix",
		result: "effect1_dropShadow_6008_1393"
	}), /*#__PURE__*/ React.createElement("feBlend", {
		"in": "SourceGraphic",
		in2: "effect1_dropShadow_6008_1393",
		result: "shape"
	})), /*#__PURE__*/ React.createElement("radialGradient", {
		id: "c",
		cx: 0,
		cy: 0,
		r: 1,
		gradientTransform: "matrix(0 -32 64.2653 0 17 33)",
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#818394" }), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#1E202E"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "d",
		x1: 17,
		x2: 17,
		y1: 1,
		y2: 33,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#818394" }), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#1E202E"
	})), /*#__PURE__*/ React.createElement("clipPath", { id: "a" }, /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M0 0h34v34H0z"
	})))));
};

//#endregion
//#region src/ProductIcon/icons/Connect.svg
var _g$6;
var _defs$14;
function _extends$102() {
	return _extends$102 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$102.apply(null, arguments);
}
var SvgConnect = function SvgConnect(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$102({
		xmlns: "http://www.w3.org/2000/svg",
		width: 34,
		height: 34,
		fill: "none",
		viewBox: "0 0 34 34"
	}, props), _g$6 || (_g$6 = /*#__PURE__*/ React.createElement("g", { clipPath: "url(#a)" }, /*#__PURE__*/ React.createElement("g", { filter: "url(#b)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "url(#c)",
		fillRule: "evenodd",
		d: "M33 17c0 5.458-.372 11.615-2.372 13.621S21.465 33 17.047 33c-4.42 0-11.582-.373-13.582-2.379S1 22.458 1 17 1.465 5.385 3.465 3.379 12.628 1 17.047 1c4.418 0 11.58.373 13.58 2.379S33 11.542 33 17",
		clipRule: "evenodd"
	}), /*#__PURE__*/ React.createElement("path", {
		stroke: "url(#d)",
		strokeWidth: .421,
		d: "M32.79 17c0 2.726-.094 5.618-.435 8.076-.17 1.229-.402 2.343-.712 3.271-.312.931-.697 1.657-1.164 2.125-.463.465-1.246.852-2.258 1.166-1.006.312-2.214.545-3.504.716-2.58.342-5.465.435-7.67.435s-5.09-.093-7.67-.435c-1.29-.171-2.499-.404-3.505-.716-1.012-.314-1.795-.701-2.258-1.166-.467-.469-.859-1.195-1.179-2.126-.319-.929-.562-2.043-.744-3.272-.364-2.457-.48-5.35-.48-8.074s.116-5.617.48-8.074c.182-1.229.425-2.343.744-3.272.32-.93.712-1.657 1.18-2.126.462-.465 1.245-.852 2.257-1.166 1.006-.312 2.214-.545 3.505-.716 2.58-.342 5.464-.435 7.67-.435s5.09.093 7.67.435c1.29.171 2.498.404 3.504.716 1.012.314 1.795.701 2.258 1.166.467.468.852 1.194 1.164 2.125.31.928.542 2.042.712 3.271.341 2.458.434 5.35.434 8.076Z"
	})), /*#__PURE__*/ React.createElement("g", { filter: "url(#e)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "#D2EDE8",
		d: "M22.897 22.57h1.294c.447 0 .809-.37.809-.825V20a.817.817 0 0 0-.809-.825h-1.294a.41.41 0 0 1-.404-.413v-2.397c0-.636-.676-1.033-1.215-.714l-7.609 4.507a.834.834 0 0 0 0 1.428l7.609 4.506c.54.32 1.215-.077 1.215-.713v-2.397c0-.228.18-.413.404-.413"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M11.103 11.26H9.809a.817.817 0 0 0-.809.826v1.743c0 .456.362.826.809.826h1.294c.223 0 .404.184.404.412v2.397c0 .636.676 1.034 1.215.714l7.609-4.507a.834.834 0 0 0 0-1.428l-7.609-4.506c-.54-.32-1.215.078-1.215.714v2.396a.41.41 0 0 1-.404.413"
	})))), _defs$14 || (_defs$14 = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("filter", {
		id: "b",
		width: 33.4,
		height: 33.4,
		x: .3,
		y: .7,
		colorInterpolationFilters: "sRGB",
		filterUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("feFlood", {
		floodOpacity: 0,
		result: "BackgroundImageFix"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", {
		"in": "SourceAlpha",
		result: "hardAlpha",
		values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
	}), /*#__PURE__*/ React.createElement("feOffset", { dy: .4 }), /*#__PURE__*/ React.createElement("feGaussianBlur", { stdDeviation: .35 }), /*#__PURE__*/ React.createElement("feComposite", {
		in2: "hardAlpha",
		operator: "out"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", { values: "0 0 0 0 0.113618 0 0 0 0 0.115698 0 0 0 0 0.133377 0 0 0 0.56 0" }), /*#__PURE__*/ React.createElement("feBlend", {
		in2: "BackgroundImageFix",
		result: "effect1_dropShadow_6008_1400"
	}), /*#__PURE__*/ React.createElement("feBlend", {
		"in": "SourceGraphic",
		in2: "effect1_dropShadow_6008_1400",
		result: "shape"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", {
		"in": "SourceAlpha",
		result: "hardAlpha",
		values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
	}), /*#__PURE__*/ React.createElement("feOffset", { dy: -.168 }), /*#__PURE__*/ React.createElement("feGaussianBlur", { stdDeviation: .421 }), /*#__PURE__*/ React.createElement("feComposite", {
		in2: "hardAlpha",
		k2: -1,
		k3: 1,
		operator: "arithmetic"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" }), /*#__PURE__*/ React.createElement("feBlend", {
		in2: "shape",
		result: "effect2_innerShadow_6008_1400"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", {
		"in": "SourceAlpha",
		result: "hardAlpha",
		values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
	}), /*#__PURE__*/ React.createElement("feOffset", { dy: .842 }), /*#__PURE__*/ React.createElement("feGaussianBlur", { stdDeviation: .421 }), /*#__PURE__*/ React.createElement("feComposite", {
		in2: "hardAlpha",
		k2: -1,
		k3: 1,
		operator: "arithmetic"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", { values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" }), /*#__PURE__*/ React.createElement("feBlend", {
		in2: "effect2_innerShadow_6008_1400",
		result: "effect3_innerShadow_6008_1400"
	})), /*#__PURE__*/ React.createElement("filter", {
		id: "e",
		width: 17.684,
		height: 20.266,
		x: 8.158,
		y: 7.624,
		colorInterpolationFilters: "sRGB",
		filterUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("feFlood", {
		floodOpacity: 0,
		result: "BackgroundImageFix"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", {
		"in": "SourceAlpha",
		result: "hardAlpha",
		values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
	}), /*#__PURE__*/ React.createElement("feOffset", { dy: .842 }), /*#__PURE__*/ React.createElement("feGaussianBlur", { stdDeviation: .421 }), /*#__PURE__*/ React.createElement("feComposite", {
		in2: "hardAlpha",
		operator: "out"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.56 0" }), /*#__PURE__*/ React.createElement("feBlend", {
		in2: "BackgroundImageFix",
		result: "effect1_dropShadow_6008_1400"
	}), /*#__PURE__*/ React.createElement("feBlend", {
		"in": "SourceGraphic",
		in2: "effect1_dropShadow_6008_1400",
		result: "shape"
	})), /*#__PURE__*/ React.createElement("radialGradient", {
		id: "c",
		cx: 0,
		cy: 0,
		r: 1,
		gradientTransform: "matrix(0 -32 64.2653 0 17 33)",
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#75E1BD" }), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#04747A"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "d",
		x1: 17,
		x2: 17,
		y1: 1,
		y2: 33,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#75E1BD" }), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#04747A"
	})), /*#__PURE__*/ React.createElement("clipPath", { id: "a" }, /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M0 0h34v34H0z"
	})))));
};

//#endregion
//#region src/ProductIcon/icons/Hub.svg
var _g$5;
var _defs$13;
function _extends$101() {
	return _extends$101 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$101.apply(null, arguments);
}
var SvgHub = function SvgHub(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$101({
		xmlns: "http://www.w3.org/2000/svg",
		width: 34,
		height: 34,
		fill: "none",
		viewBox: "0 0 34 34"
	}, props), _g$5 || (_g$5 = /*#__PURE__*/ React.createElement("g", { clipPath: "url(#a)" }, /*#__PURE__*/ React.createElement("g", { filter: "url(#b)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "url(#c)",
		fillRule: "evenodd",
		d: "M33 17c0 5.458-.372 11.615-2.372 13.621S21.465 33 17.047 33c-4.42 0-11.582-.373-13.582-2.379S1 22.458 1 17 1.465 5.385 3.465 3.379 12.628 1 17.047 1c4.418 0 11.58.373 13.58 2.379S33 11.542 33 17",
		clipRule: "evenodd"
	}), /*#__PURE__*/ React.createElement("path", {
		stroke: "url(#d)",
		strokeWidth: .421,
		d: "M32.79 17c0 2.726-.094 5.618-.435 8.076-.17 1.229-.402 2.343-.712 3.271-.312.931-.697 1.657-1.164 2.125-.463.465-1.246.852-2.258 1.166-1.006.312-2.214.545-3.504.716-2.58.342-5.465.435-7.67.435s-5.09-.093-7.67-.435c-1.29-.171-2.499-.404-3.505-.716-1.012-.314-1.795-.701-2.258-1.166-.467-.469-.859-1.195-1.179-2.126-.319-.929-.562-2.043-.744-3.272-.364-2.457-.48-5.35-.48-8.074s.116-5.617.48-8.074c.182-1.229.425-2.343.744-3.272.32-.93.712-1.657 1.18-2.126.462-.465 1.245-.852 2.257-1.166 1.006-.312 2.214-.545 3.505-.716 2.58-.342 5.464-.435 7.67-.435s5.09.093 7.67.435c1.29.171 2.498.404 3.504.716 1.012.314 1.795.701 2.258 1.166.467.468.852 1.194 1.164 2.125.31.928.542 2.042.712 3.271.341 2.458.434 5.35.434 8.076Z"
	})), /*#__PURE__*/ React.createElement("g", { filter: "url(#e)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "#E2DFFA",
		fillOpacity: .64,
		d: "M11.223 8.158a3.065 3.065 0 0 0-3.065 3.065v1.995a3.066 3.066 0 0 0 2.67 3.04v-.453c0-.585.1-1.147.286-1.668a.925.925 0 0 1-.816-.919v-1.995c0-.51.414-.925.925-.925h1.995c.474 0 .864.356.919.816a5 5 0 0 1 1.668-.287h.453a3.066 3.066 0 0 0-3.04-2.67zM23.173 16.258a3.066 3.066 0 0 0 2.67-3.04v-1.995a3.065 3.065 0 0 0-3.066-3.065h-1.995a3.066 3.066 0 0 0-3.04 2.67h.453c.586 0 1.147.1 1.668.286a.925.925 0 0 1 .92-.816h1.994c.51 0 .925.414.925.925v1.995a.925.925 0 0 1-.816.918 5 5 0 0 1 .287 1.669zM17.742 23.173a3.066 3.066 0 0 0 3.04 2.67h1.995a3.065 3.065 0 0 0 3.065-3.066v-1.995a3.066 3.066 0 0 0-2.67-3.04v.453a5 5 0 0 1-.285 1.668c.459.055.815.445.815.919v1.995c0 .51-.414.925-.925.925h-1.995a.925.925 0 0 1-.919-.816 5 5 0 0 1-1.668.287zM10.827 17.742a3.066 3.066 0 0 0-2.669 3.04v1.995a3.065 3.065 0 0 0 3.065 3.065h1.995a3.066 3.066 0 0 0 3.04-2.67h-.453a5 5 0 0 1-1.668-.286.925.925 0 0 1-.919.816h-1.995a.925.925 0 0 1-.925-.925v-1.995c0-.474.356-.864.816-.919a5 5 0 0 1-.287-1.668z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		fillRule: "evenodd",
		d: "M12.329 15.855a3.524 3.524 0 0 1 3.524-3.525h2.294a3.524 3.524 0 0 1 3.524 3.524v2.294a3.524 3.524 0 0 1-3.524 3.525h-2.294a3.524 3.524 0 0 1-3.524-3.525zm3.524-1.064c-.587 0-1.063.476-1.063 1.063v2.294c0 .588.476 1.064 1.063 1.064h2.294c.587 0 1.064-.476 1.064-1.064v-2.293c0-.588-.477-1.064-1.064-1.064z",
		clipRule: "evenodd"
	})))), _defs$13 || (_defs$13 = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("filter", {
		id: "b",
		width: 33.4,
		height: 33.4,
		x: .3,
		y: .7,
		colorInterpolationFilters: "sRGB",
		filterUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("feFlood", {
		floodOpacity: 0,
		result: "BackgroundImageFix"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", {
		"in": "SourceAlpha",
		result: "hardAlpha",
		values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
	}), /*#__PURE__*/ React.createElement("feOffset", { dy: .4 }), /*#__PURE__*/ React.createElement("feGaussianBlur", { stdDeviation: .35 }), /*#__PURE__*/ React.createElement("feComposite", {
		in2: "hardAlpha",
		operator: "out"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", { values: "0 0 0 0 0.113618 0 0 0 0 0.115698 0 0 0 0 0.133377 0 0 0 0.56 0" }), /*#__PURE__*/ React.createElement("feBlend", {
		in2: "BackgroundImageFix",
		result: "effect1_dropShadow_6008_1407"
	}), /*#__PURE__*/ React.createElement("feBlend", {
		"in": "SourceGraphic",
		in2: "effect1_dropShadow_6008_1407",
		result: "shape"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", {
		"in": "SourceAlpha",
		result: "hardAlpha",
		values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
	}), /*#__PURE__*/ React.createElement("feOffset", { dy: -.168 }), /*#__PURE__*/ React.createElement("feGaussianBlur", { stdDeviation: .421 }), /*#__PURE__*/ React.createElement("feComposite", {
		in2: "hardAlpha",
		k2: -1,
		k3: 1,
		operator: "arithmetic"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" }), /*#__PURE__*/ React.createElement("feBlend", {
		in2: "shape",
		result: "effect2_innerShadow_6008_1407"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", {
		"in": "SourceAlpha",
		result: "hardAlpha",
		values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
	}), /*#__PURE__*/ React.createElement("feOffset", { dy: .842 }), /*#__PURE__*/ React.createElement("feGaussianBlur", { stdDeviation: .421 }), /*#__PURE__*/ React.createElement("feComposite", {
		in2: "hardAlpha",
		k2: -1,
		k3: 1,
		operator: "arithmetic"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", { values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" }), /*#__PURE__*/ React.createElement("feBlend", {
		in2: "effect2_innerShadow_6008_1407",
		result: "effect3_innerShadow_6008_1407"
	})), /*#__PURE__*/ React.createElement("filter", {
		id: "e",
		width: 19.368,
		height: 19.368,
		x: 7.316,
		y: 8.158,
		colorInterpolationFilters: "sRGB",
		filterUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("feFlood", {
		floodOpacity: 0,
		result: "BackgroundImageFix"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", {
		"in": "SourceAlpha",
		result: "hardAlpha",
		values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
	}), /*#__PURE__*/ React.createElement("feOffset", { dy: .842 }), /*#__PURE__*/ React.createElement("feGaussianBlur", { stdDeviation: .421 }), /*#__PURE__*/ React.createElement("feComposite", {
		in2: "hardAlpha",
		operator: "out"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0" }), /*#__PURE__*/ React.createElement("feBlend", {
		in2: "BackgroundImageFix",
		result: "effect1_dropShadow_6008_1407"
	}), /*#__PURE__*/ React.createElement("feBlend", {
		"in": "SourceGraphic",
		in2: "effect1_dropShadow_6008_1407",
		result: "shape"
	})), /*#__PURE__*/ React.createElement("radialGradient", {
		id: "c",
		cx: 0,
		cy: 0,
		r: 1,
		gradientTransform: "matrix(0 -32 64.2653 0 17 33)",
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#6C79AC" }), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#181E49"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "d",
		x1: 17,
		x2: 17,
		y1: 1,
		y2: 33,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#6C79AC" }), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#181E49"
	})), /*#__PURE__*/ React.createElement("clipPath", { id: "a" }, /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M0 0h34v34H0z"
	})))));
};

//#endregion
//#region src/ProductIcon/icons/Network.svg
var _g$4;
var _defs$12;
function _extends$100() {
	return _extends$100 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$100.apply(null, arguments);
}
var SvgNetwork = function SvgNetwork(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$100({
		xmlns: "http://www.w3.org/2000/svg",
		width: 34,
		height: 34,
		fill: "none",
		viewBox: "0 0 34 34"
	}, props), _g$4 || (_g$4 = /*#__PURE__*/ React.createElement("g", { clipPath: "url(#a)" }, /*#__PURE__*/ React.createElement("g", { filter: "url(#b)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "url(#c)",
		fillRule: "evenodd",
		d: "M33 17c0 5.458-.372 11.615-2.372 13.621S21.465 33 17.047 33c-4.42 0-11.582-.373-13.582-2.379S1 22.458 1 17 1.465 5.385 3.465 3.379 12.628 1 17.047 1c4.418 0 11.58.373 13.58 2.379S33 11.542 33 17",
		clipRule: "evenodd"
	}), /*#__PURE__*/ React.createElement("path", {
		stroke: "url(#d)",
		strokeWidth: .421,
		d: "M32.79 17c0 2.726-.094 5.618-.435 8.076-.17 1.229-.402 2.343-.712 3.271-.312.931-.697 1.657-1.164 2.125-.463.465-1.246.852-2.258 1.166-1.006.312-2.214.545-3.504.716-2.58.342-5.465.435-7.67.435s-5.09-.093-7.67-.435c-1.29-.171-2.499-.404-3.505-.716-1.012-.314-1.795-.701-2.258-1.166-.467-.469-.859-1.195-1.179-2.126-.319-.929-.562-2.043-.744-3.272-.364-2.457-.48-5.35-.48-8.074s.116-5.617.48-8.074c.182-1.229.425-2.343.744-3.272.32-.93.712-1.657 1.18-2.126.462-.465 1.245-.852 2.257-1.166 1.006-.312 2.214-.545 3.505-.716 2.58-.342 5.464-.435 7.67-.435s5.09.093 7.67.435c1.29.171 2.498.404 3.504.716 1.012.314 1.795.701 2.258 1.166.467.468.852 1.194 1.164 2.125.31.928.542 2.042.712 3.271.341 2.458.434 5.35.434 8.076Z"
	})), /*#__PURE__*/ React.createElement("g", {
		fill: "#fff",
		filter: "url(#e)"
	}, /*#__PURE__*/ React.createElement("path", {
		fillOpacity: .56,
		d: "M19.24 20.964c.363.189.397.671.108.96l-1.904 1.904a.67.67 0 0 1-.949 0l-1.859-1.859c-.285-.286-.256-.761.098-.955a4.8 4.8 0 0 1 2.3-.585 4.8 4.8 0 0 1 2.205.535"
	}), /*#__PURE__*/ React.createElement("path", {
		fillOpacity: .72,
		d: "M23.231 18.04a.636.636 0 0 0-.05-.96 10.16 10.16 0 0 0-6.149-2.06c-2.343 0-4.502.79-6.226 2.118a.636.636 0 0 0-.045.957l1.058 1.058c.247.247.64.26.924.058a7.36 7.36 0 0 1 4.29-1.372c1.569 0 3.024.49 4.22 1.324a.72.72 0 0 0 .918-.063z"
	}), /*#__PURE__*/ React.createElement("path", { d: "M27.21 14.062a.65.65 0 0 0-.032-.957A15.75 15.75 0 0 0 17.033 9.42a15.75 15.75 0 0 0-10.217 3.745.65.65 0 0 0-.029.955l1.05 1.05c.253.253.66.26.936.033a12.94 12.94 0 0 1 8.26-2.964c3.106 0 5.958 1.09 8.194 2.91.276.224.68.215.932-.037z" })))), _defs$12 || (_defs$12 = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("filter", {
		id: "b",
		width: 33.4,
		height: 33.4,
		x: .3,
		y: .7,
		colorInterpolationFilters: "sRGB",
		filterUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("feFlood", {
		floodOpacity: 0,
		result: "BackgroundImageFix"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", {
		"in": "SourceAlpha",
		result: "hardAlpha",
		values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
	}), /*#__PURE__*/ React.createElement("feOffset", { dy: .4 }), /*#__PURE__*/ React.createElement("feGaussianBlur", { stdDeviation: .35 }), /*#__PURE__*/ React.createElement("feComposite", {
		in2: "hardAlpha",
		operator: "out"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", { values: "0 0 0 0 0.113618 0 0 0 0 0.115698 0 0 0 0 0.133377 0 0 0 0.56 0" }), /*#__PURE__*/ React.createElement("feBlend", {
		in2: "BackgroundImageFix",
		result: "effect1_dropShadow_6008_1416"
	}), /*#__PURE__*/ React.createElement("feBlend", {
		"in": "SourceGraphic",
		in2: "effect1_dropShadow_6008_1416",
		result: "shape"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", {
		"in": "SourceAlpha",
		result: "hardAlpha",
		values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
	}), /*#__PURE__*/ React.createElement("feOffset", { dy: -.168 }), /*#__PURE__*/ React.createElement("feGaussianBlur", { stdDeviation: .421 }), /*#__PURE__*/ React.createElement("feComposite", {
		in2: "hardAlpha",
		k2: -1,
		k3: 1,
		operator: "arithmetic"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" }), /*#__PURE__*/ React.createElement("feBlend", {
		in2: "shape",
		result: "effect2_innerShadow_6008_1416"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", {
		"in": "SourceAlpha",
		result: "hardAlpha",
		values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
	}), /*#__PURE__*/ React.createElement("feOffset", { dy: .842 }), /*#__PURE__*/ React.createElement("feGaussianBlur", { stdDeviation: .421 }), /*#__PURE__*/ React.createElement("feComposite", {
		in2: "hardAlpha",
		k2: -1,
		k3: 1,
		operator: "arithmetic"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", { values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" }), /*#__PURE__*/ React.createElement("feBlend", {
		in2: "effect2_innerShadow_6008_1416",
		result: "effect3_innerShadow_6008_1416"
	})), /*#__PURE__*/ React.createElement("filter", {
		id: "e",
		width: 22.498,
		height: 16.288,
		x: 5.75,
		y: 9.421,
		colorInterpolationFilters: "sRGB",
		filterUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("feFlood", {
		floodOpacity: 0,
		result: "BackgroundImageFix"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", {
		"in": "SourceAlpha",
		result: "hardAlpha",
		values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
	}), /*#__PURE__*/ React.createElement("feOffset", { dy: .842 }), /*#__PURE__*/ React.createElement("feGaussianBlur", { stdDeviation: .421 }), /*#__PURE__*/ React.createElement("feComposite", {
		in2: "hardAlpha",
		operator: "out"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.64 0" }), /*#__PURE__*/ React.createElement("feBlend", {
		in2: "BackgroundImageFix",
		result: "effect1_dropShadow_6008_1416"
	}), /*#__PURE__*/ React.createElement("feBlend", {
		"in": "SourceGraphic",
		in2: "effect1_dropShadow_6008_1416",
		result: "shape"
	})), /*#__PURE__*/ React.createElement("radialGradient", {
		id: "c",
		cx: 0,
		cy: 0,
		r: 1,
		gradientTransform: "matrix(0 -32 64.2653 0 17 33)",
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#92A2FC" }), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#172CB1"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "d",
		x1: 17,
		x2: 17,
		y1: 1,
		y2: 33,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#92A2FC" }), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#172CB1"
	})), /*#__PURE__*/ React.createElement("clipPath", { id: "a" }, /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M0 0h34v34H0z"
	})))));
};

//#endregion
//#region src/ProductIcon/icons/Operator.svg
var _g$3;
var _defs$11;
function _extends$99() {
	return _extends$99 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$99.apply(null, arguments);
}
var SvgOperator = function SvgOperator(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$99({
		xmlns: "http://www.w3.org/2000/svg",
		width: 40,
		height: 40,
		fill: "none",
		viewBox: "0 0 40 40"
	}, props), _g$3 || (_g$3 = /*#__PURE__*/ React.createElement("g", { clipPath: "url(#a)" }, /*#__PURE__*/ React.createElement("g", { filter: "url(#b)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "url(#c)",
		fillRule: "evenodd",
		d: "M38.824 20c0 6.42-.438 13.665-2.791 16.025s-10.78 2.799-15.978 2.799-13.625-.44-15.978-2.8-2.9-9.603-2.9-16.024c0-6.42.547-13.665 2.9-16.025s10.78-2.799 15.978-2.799 13.625.44 15.978 2.8 2.79 9.603 2.79 16.024",
		clipRule: "evenodd"
	}), /*#__PURE__*/ React.createElement("path", {
		stroke: "url(#d)",
		strokeWidth: .495,
		d: "M38.576 20c0 3.207-.11 6.61-.51 9.501-.201 1.446-.474 2.757-.84 3.849-.366 1.095-.82 1.949-1.369 2.5-.545.547-1.466 1.002-2.656 1.371-1.184.367-2.605.641-4.123.843-3.035.402-6.43.512-9.023.512s-5.989-.11-9.024-.513c-1.518-.2-2.939-.475-4.123-.842-1.19-.37-2.111-.824-2.656-1.371-.55-.552-1.01-1.407-1.387-2.502-.376-1.092-.662-2.403-.876-3.849-.428-2.891-.565-6.293-.565-9.499 0-3.205.137-6.608.565-9.499.214-1.446.5-2.757.876-3.849.377-1.095.837-1.95 1.387-2.502.545-.546 1.466-1.002 2.656-1.371 1.184-.367 2.605-.641 4.123-.843 3.035-.402 6.43-.512 9.024-.512s5.988.11 9.023.512c1.518.202 2.94.476 4.123.843 1.19.37 2.111.825 2.657 1.371.549.551 1.002 1.405 1.369 2.5.365 1.092.638 2.403.838 3.849.401 2.891.51 6.294.51 9.501Z"
	})), /*#__PURE__*/ React.createElement("g", {
		fill: "#fff",
		fillRule: "evenodd",
		clipRule: "evenodd",
		filter: "url(#e)"
	}, /*#__PURE__*/ React.createElement("path", { d: "M24.074 23.49c.37-.68.58-1.459.58-2.288 0-2.634-2.123-4.77-4.741-4.77s-4.741 2.136-4.741 4.77c0 .83.21 1.609.58 2.288-1.434 1.068-1.516 1.648-1.814 3.5 1.056.922 2.113 1.295 2.747 2.658h6.425c.634-1.363 1.41-1.548 2.747-2.657-.298-1.853-.35-2.433-1.783-3.501" }), /*#__PURE__*/ React.createElement("path", { d: "M19.923 9.102c.23.007.46.052.679.134l7.576 2.86a2.09 2.09 0 0 1 1.343 1.72c.187 1.635.426 4.909-.15 8.163-.791 4.476-4.063 7.85-8.704 9.936-.237.106-.49.163-.743.171h-.008l.003-.099h-.014l-.003.099a2 2 0 0 1-.742-.171c-4.642-2.086-7.914-5.46-8.705-9.936-.572-3.232-.34-6.483-.153-8.128l.094-.45a2.1 2.1 0 0 1 1.252-1.304l7.576-2.86q.332-.125.68-.135h.019m7.032 5.643-.024-.246-6.812-2.572a.58.58 0 0 0-.412 0l-6.812 2.572-.024.246c-.154 1.635-.265 4.265.187 6.82.569 3.216 2.866 5.903 6.682 7.75l.173.084.173-.084c3.816-1.847 6.113-4.534 6.682-7.75.452-2.555.34-5.185.186-6.82" })))), _defs$11 || (_defs$11 = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("filter", {
		id: "b",
		width: 39.294,
		height: 39.294,
		x: .353,
		y: .824,
		colorInterpolationFilters: "sRGB",
		filterUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("feFlood", {
		floodOpacity: 0,
		result: "BackgroundImageFix"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", {
		"in": "SourceAlpha",
		result: "hardAlpha",
		values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
	}), /*#__PURE__*/ React.createElement("feOffset", { dy: .471 }), /*#__PURE__*/ React.createElement("feGaussianBlur", { stdDeviation: .412 }), /*#__PURE__*/ React.createElement("feComposite", {
		in2: "hardAlpha",
		operator: "out"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", { values: "0 0 0 0 0.113618 0 0 0 0 0.115698 0 0 0 0 0.133377 0 0 0 0.56 0" }), /*#__PURE__*/ React.createElement("feBlend", {
		in2: "BackgroundImageFix",
		result: "effect1_dropShadow_4799_668"
	}), /*#__PURE__*/ React.createElement("feBlend", {
		"in": "SourceGraphic",
		in2: "effect1_dropShadow_4799_668",
		result: "shape"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", {
		"in": "SourceAlpha",
		result: "hardAlpha",
		values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
	}), /*#__PURE__*/ React.createElement("feOffset", { dy: -.198 }), /*#__PURE__*/ React.createElement("feGaussianBlur", { stdDeviation: .495 }), /*#__PURE__*/ React.createElement("feComposite", {
		in2: "hardAlpha",
		k2: -1,
		k3: 1,
		operator: "arithmetic"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" }), /*#__PURE__*/ React.createElement("feBlend", {
		in2: "shape",
		result: "effect2_innerShadow_4799_668"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", {
		"in": "SourceAlpha",
		result: "hardAlpha",
		values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
	}), /*#__PURE__*/ React.createElement("feOffset", { dy: .991 }), /*#__PURE__*/ React.createElement("feGaussianBlur", { stdDeviation: .495 }), /*#__PURE__*/ React.createElement("feComposite", {
		in2: "hardAlpha",
		k2: -1,
		k3: 1,
		operator: "arithmetic"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", { values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" }), /*#__PURE__*/ React.createElement("feBlend", {
		in2: "effect2_innerShadow_4799_668",
		result: "effect3_innerShadow_4799_668"
	})), /*#__PURE__*/ React.createElement("filter", {
		id: "e",
		width: 21.622,
		height: 24.965,
		x: 9.102,
		y: 9.102,
		colorInterpolationFilters: "sRGB",
		filterUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("feFlood", {
		floodOpacity: 0,
		result: "BackgroundImageFix"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", {
		"in": "SourceAlpha",
		result: "hardAlpha",
		values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
	}), /*#__PURE__*/ React.createElement("feOffset", { dy: .991 }), /*#__PURE__*/ React.createElement("feGaussianBlur", { stdDeviation: .495 }), /*#__PURE__*/ React.createElement("feComposite", {
		in2: "hardAlpha",
		operator: "out"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.64 0" }), /*#__PURE__*/ React.createElement("feBlend", {
		in2: "BackgroundImageFix",
		result: "effect1_dropShadow_4799_668"
	}), /*#__PURE__*/ React.createElement("feBlend", {
		"in": "SourceGraphic",
		in2: "effect1_dropShadow_4799_668",
		result: "shape"
	})), /*#__PURE__*/ React.createElement("radialGradient", {
		id: "c",
		cx: 0,
		cy: 0,
		r: 1,
		gradientTransform: "matrix(0 -37.6471 75.6062 0 20 38.824)",
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#FFC368" }), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#C66029"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "d",
		x1: 20,
		x2: 20,
		y1: 1.176,
		y2: 38.824,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#FFC368" }), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#C66029"
	})), /*#__PURE__*/ React.createElement("clipPath", { id: "a" }, /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M0 0h40v40H0z"
	})))));
};

//#endregion
//#region src/ProductIcon/icons/Spend.svg
var _g$2;
var _defs$10;
function _extends$98() {
	return _extends$98 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$98.apply(null, arguments);
}
var SvgSpend = function SvgSpend(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$98({
		xmlns: "http://www.w3.org/2000/svg",
		width: 40,
		height: 40,
		fill: "none",
		viewBox: "0 0 40 40"
	}, props), _g$2 || (_g$2 = /*#__PURE__*/ React.createElement("g", { clipPath: "url(#a)" }, /*#__PURE__*/ React.createElement("g", { filter: "url(#b)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "url(#c)",
		fillRule: "evenodd",
		d: "M38.824 20c0 6.42-.438 13.665-2.791 16.025s-10.78 2.799-15.978 2.799-13.625-.44-15.978-2.8-2.9-9.603-2.9-16.024c0-6.42.547-13.665 2.9-16.025s10.78-2.799 15.978-2.799 13.625.44 15.978 2.8 2.79 9.603 2.79 16.024",
		clipRule: "evenodd"
	}), /*#__PURE__*/ React.createElement("path", {
		stroke: "url(#d)",
		strokeWidth: .495,
		d: "M38.576 20c0 3.207-.11 6.61-.51 9.501-.201 1.446-.474 2.757-.84 3.849-.366 1.095-.82 1.949-1.369 2.5-.545.547-1.466 1.002-2.656 1.371-1.184.367-2.605.641-4.123.843-3.035.402-6.43.512-9.023.512s-5.989-.11-9.024-.513c-1.518-.2-2.939-.475-4.123-.842-1.19-.37-2.111-.824-2.656-1.371-.55-.552-1.01-1.407-1.387-2.502-.376-1.092-.662-2.403-.876-3.849-.428-2.891-.565-6.293-.565-9.499 0-3.205.137-6.608.565-9.499.214-1.446.5-2.757.876-3.849.377-1.095.837-1.95 1.387-2.502.545-.546 1.466-1.002 2.656-1.371 1.184-.367 2.605-.641 4.123-.843 3.035-.402 6.43-.512 9.024-.512s5.988.11 9.023.512c1.518.202 2.94.476 4.123.843 1.19.37 2.111.825 2.657 1.371.549.551 1.002 1.405 1.369 2.5.365 1.092.638 2.403.838 3.849.401 2.891.51 6.294.51 9.501Z"
	})), /*#__PURE__*/ React.createElement("g", { filter: "url(#e)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		fillRule: "evenodd",
		d: "M24.339 13.13a2.82 2.82 0 0 0-2.82 2.82v8.678a5.857 5.857 0 0 1-11.715 0v-4.34a1.519 1.519 0 0 1 3.037 0v4.34a2.82 2.82 0 0 0 5.64 0V15.95a5.857 5.857 0 0 1 11.715 0v4.339a1.519 1.519 0 1 1-3.037 0V15.95a2.82 2.82 0 0 0-2.82-2.82",
		clipRule: "evenodd"
	})))), _defs$10 || (_defs$10 = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("filter", {
		id: "b",
		width: 39.294,
		height: 39.294,
		x: .353,
		y: .824,
		colorInterpolationFilters: "sRGB",
		filterUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("feFlood", {
		floodOpacity: 0,
		result: "BackgroundImageFix"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", {
		"in": "SourceAlpha",
		result: "hardAlpha",
		values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
	}), /*#__PURE__*/ React.createElement("feOffset", { dy: .471 }), /*#__PURE__*/ React.createElement("feGaussianBlur", { stdDeviation: .412 }), /*#__PURE__*/ React.createElement("feComposite", {
		in2: "hardAlpha",
		operator: "out"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", { values: "0 0 0 0 0.113618 0 0 0 0 0.115698 0 0 0 0 0.133377 0 0 0 0.56 0" }), /*#__PURE__*/ React.createElement("feBlend", {
		in2: "BackgroundImageFix",
		result: "effect1_dropShadow_3711_46135"
	}), /*#__PURE__*/ React.createElement("feBlend", {
		"in": "SourceGraphic",
		in2: "effect1_dropShadow_3711_46135",
		result: "shape"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", {
		"in": "SourceAlpha",
		result: "hardAlpha",
		values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
	}), /*#__PURE__*/ React.createElement("feOffset", { dy: -.198 }), /*#__PURE__*/ React.createElement("feGaussianBlur", { stdDeviation: .495 }), /*#__PURE__*/ React.createElement("feComposite", {
		in2: "hardAlpha",
		k2: -1,
		k3: 1,
		operator: "arithmetic"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" }), /*#__PURE__*/ React.createElement("feBlend", {
		in2: "shape",
		result: "effect2_innerShadow_3711_46135"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", {
		"in": "SourceAlpha",
		result: "hardAlpha",
		values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
	}), /*#__PURE__*/ React.createElement("feOffset", { dy: .991 }), /*#__PURE__*/ React.createElement("feGaussianBlur", { stdDeviation: .495 }), /*#__PURE__*/ React.createElement("feComposite", {
		in2: "hardAlpha",
		k2: -1,
		k3: 1,
		operator: "arithmetic"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", { values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" }), /*#__PURE__*/ React.createElement("feBlend", {
		in2: "effect2_innerShadow_3711_46135",
		result: "effect3_innerShadow_3711_46135"
	})), /*#__PURE__*/ React.createElement("filter", {
		id: "e",
		width: 22.374,
		height: 22.374,
		x: 8.813,
		y: 10.093,
		colorInterpolationFilters: "sRGB",
		filterUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("feFlood", {
		floodOpacity: 0,
		result: "BackgroundImageFix"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", {
		"in": "SourceAlpha",
		result: "hardAlpha",
		values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
	}), /*#__PURE__*/ React.createElement("feOffset", { dy: .991 }), /*#__PURE__*/ React.createElement("feGaussianBlur", { stdDeviation: .495 }), /*#__PURE__*/ React.createElement("feComposite", {
		in2: "hardAlpha",
		operator: "out"
	}), /*#__PURE__*/ React.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.56 0" }), /*#__PURE__*/ React.createElement("feBlend", {
		in2: "BackgroundImageFix",
		result: "effect1_dropShadow_3711_46135"
	}), /*#__PURE__*/ React.createElement("feBlend", {
		"in": "SourceGraphic",
		in2: "effect1_dropShadow_3711_46135",
		result: "shape"
	})), /*#__PURE__*/ React.createElement("radialGradient", {
		id: "c",
		cx: 0,
		cy: 0,
		r: 1,
		gradientTransform: "matrix(0 -37.6471 75.6062 0 20 38.824)",
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#E1F66F" }), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#8F9E07"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "d",
		x1: 20,
		x2: 20,
		y1: 39,
		y2: 1.176,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#8F9E07" }), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#E1F66F"
	})), /*#__PURE__*/ React.createElement("clipPath", { id: "a" }, /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M0 0h40v40H0z"
	})))));
};

//#endregion
//#region src/ProductIcon/index.ts
const ProductIconSVG = {
	Access: SvgAccess,
	AutoVPN: SvgAutoVpn,
	Cellular: SvgCellular,
	Command: SvgCommand,
	Connect: SvgConnect,
	Hub: SvgHub,
	Network: SvgNetwork,
	Operator: SvgOperator,
	Spend: SvgSpend
};

//#endregion
//#region src/ProviderIcon/icons/Allstream.svg
var _path$94;
var _path2$65;
var _path3$38;
function _extends$97() {
	return _extends$97 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$97.apply(null, arguments);
}
var SvgAllstream = function SvgAllstream(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$97({
		xmlns: "http://www.w3.org/2000/svg",
		width: 40,
		height: 40,
		fill: "none",
		viewBox: "0 0 40 40"
	}, props), _path$94 || (_path$94 = /*#__PURE__*/ React.createElement("path", {
		fill: "#5FAFE1",
		fillOpacity: .984,
		d: "M8.462 26.992h.023c.596-.518 1.268-1.9 1.862-3.375h-.883c-.44 1.636-.804 3.063-1.002 3.377M10.715 12.923c.379-.24.401 1.052.127 3.074h.923c.137-2.42-.22-3.745-.59-3.623q-.246.08-.502.565h.02q.01-.011.022-.018"
	})), _path2$65 || (_path2$65 = /*#__PURE__*/ React.createElement("path", {
		fill: "#F59130",
		d: "M8.39 27.079c-.38.24-.337-1.402-.054-3.465h-.923c-.145 2.456.146 4.136.516 4.014q.246-.081.501-.565h-.019q-.01.01-.021.018M10.642 13.006h-.024c-.594.517-1.205 1.563-1.79 2.985h.882c.431-1.586.735-2.674.932-2.987"
	})), _path3$38 || (_path3$38 = /*#__PURE__*/ React.createElement("path", {
		fill: "#000",
		d: "M24.016 18.992c-1.508-.006-2.238.98-2.433 2.07-.238 1.337.494 2.081 1.694 2.084.592 0 1.047-.086 1.493-.317l.34-.79c-.337.133-.875.43-1.58.428-1.316 0-1.163-.916-1.077-1.369l2.925.006.045-.238c.19-1.074-.44-1.872-1.407-1.874m-.149.71c.687 0 .75.478.705.727v.002l-1.914-.006c.223-.489.631-.725 1.21-.724M5.52 18.938c-.472 0-1.028.071-1.637.224l-.276.823c.676-.29 1.186-.4 1.725-.4.341 0 .81.067.748.415-.149.835-2.88.362-3.154 1.901-.15.839.361 1.22 1.26 1.222.376 0 .657-.041.922-.084l.296-.73c-.264.087-.646.195-.95.195-.343 0-.772-.098-.702-.492.118-.66 1.41-.732 2.156-1.047l-.368 2.064h.95l.535-3.004c.128-.712-.362-1.086-1.505-1.089M35.746 18.998c-.739 0-1.3.276-1.614.626-.16-.332-.535-.63-1.074-.632-.462 0-.89.107-1.24.433l.067-.375h-.95l-.72 4.029h.95l.423-2.356c.118-.67.532-.98 1.12-.978.5 0 .744.465.65 1.06l-.407 2.277h.954l.409-2.355c.12-.677.539-.98 1.127-.979.5 0 .752.466.65 1.061l-.407 2.277h.953l.438-2.471c.12-.668-.165-1.62-1.329-1.621M28.305 18.977c-.471 0-1.028.07-1.637.223l-.275.824c.675-.29 1.186-.401 1.724-.4.341 0 .81.067.748.415-.148.835-2.88.361-3.154 1.9-.15.84.362 1.22 1.26 1.223.376 0 .657-.041.922-.084l.296-.73c-.264.086-.645.195-.95.194-.343 0-.772-.097-.702-.49.118-.661 1.41-.733 2.156-1.049l-.368 2.065h.95l.535-3.004c.128-.712-.362-1.087-1.505-1.09M12.006 19.966c-.183 1.02 1.606 1.469 1.497 2.08-.054.304-.433.4-.75.4a2.5 2.5 0 0 1-1.115-.288l-.001.81c.313.092.712.163 1.07.163.437 0 1.528-.073 1.71-1.08.188-1.038-1.565-1.503-1.465-2.054.055-.312.481-.363.653-.363.445 0 .721.12.966.23l.001-.805a4.2 4.2 0 0 0-.904-.113c-1.368-.006-1.615.755-1.662 1.02M10.752 16.564l-1.154 6.464h.95l1.153-6.464zM9.574 16.564h-.949l-1.153 6.464h.95zM19.856 19.396l.067-.375h-.95l-.719 4.029h.95l.401-2.25c.106-.596.555-1.091 1.247-1.09.204 0 .425.06.62.126l.07-.805a1.6 1.6 0 0 0-.445-.068c-.463 0-.891.106-1.242.433M17.061 18.022l-.99.226-.134.765h-.46l-.12.673h.46l-.386 2.19c-.128.718-.011 1.263 1.085 1.265.273 0 .578-.046.857-.122l.224-.728c-.345.1-.62.172-.832.172-.32 0-.462-.162-.413-.43l.415-2.345h1.193l.12-.673h-1.194"
	})));
};

//#endregion
//#region src/ProviderIcon/icons/APXNet.svg
var _path$93;
var _path2$64;
var _path3$37;
function _extends$96() {
	return _extends$96 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$96.apply(null, arguments);
}
var SvgApxNet = function SvgApxNet(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$96({
		xmlns: "http://www.w3.org/2000/svg",
		width: 40,
		height: 40,
		fill: "none",
		viewBox: "0 0 40 40"
	}, props), _path$93 || (_path$93 = /*#__PURE__*/ React.createElement("path", {
		fill: "#B52939",
		d: "m11.933 31.444.08-.043a31 31 0 0 0 3.614-2.27 26 26 0 0 0 1.995-1.607 2.136 2.136 0 0 1 2.658-2.851c.929-1.233 1.69-2.602 2.143-4.097 1.752-5.778.932-9.666-.256-12.083a10.3 10.3 0 0 0-1.7-2.485 13.972 13.972 0 0 0-5.299.848l.096.107c.36.411.785.945 1.22 1.594q.144-.02.292-.02a2.136 2.136 0 0 1 1.506 3.65c.741 2.187 1.09 4.897.387 8.034-.86 3.833-3.224 6.615-5.331 8.421a21 21 0 0 1-2.571 1.882q.558.49 1.166.92"
	})), _path2$64 || (_path2$64 = /*#__PURE__*/ React.createElement("path", {
		fill: "#B52939",
		d: "M13.343 32.32q.934.505 1.948.868a30.6 30.6 0 0 0 3.756-2.03c2.872-1.823 6.202-4.619 8.268-8.576a2.136 2.136 0 0 1 1.435-3.648c.729-2.641.79-5.123.607-7.132a21 21 0 0 0-.389-2.553A13.95 13.95 0 0 0 22.5 6.222c.329.468.66 1.01.965 1.633 1.362 2.771 2.192 7.04.342 13.14-.514 1.695-1.37 3.224-2.397 4.581a2.136 2.136 0 0 1-2.808 3.012 28 28 0 0 1-2.122 1.71 33 33 0 0 1-3.137 2.021"
	})), _path3$37 || (_path3$37 = /*#__PURE__*/ React.createElement("path", {
		fill: "#B52939",
		d: "M30.727 11.003q.04.325.07.668c.196 2.156.131 4.841-.67 7.708a2.136 2.136 0 0 1-1.501 3.816c-2.225 4.297-5.8 7.278-8.804 9.184a32 32 0 0 1-2.404 1.383q1.257.236 2.582.238c7.732 0 14-6.268 14-14 0-3.426-1.23-6.564-3.273-8.997M9.698 29.48A13.95 13.95 0 0 1 6 20c0-5.49 3.16-10.242 7.76-12.536q.181.185.416.452c.3.344.656.786 1.02 1.32a2.136 2.136 0 0 0 1.765 3.565c.636 1.946.917 4.336.296 7.103-.767 3.42-2.889 5.95-4.86 7.64a19.4 19.4 0 0 1-2.699 1.936"
	})));
};

//#endregion
//#region src/ProviderIcon/icons/ATT.svg
var _path$92;
var _path2$63;
function _extends$95() {
	return _extends$95 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$95.apply(null, arguments);
}
var SvgAtt = function SvgAtt(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$95({
		xmlns: "http://www.w3.org/2000/svg",
		width: 40,
		height: 40,
		fill: "none",
		viewBox: "0 0 40 40"
	}, props), _path$92 || (_path$92 = /*#__PURE__*/ React.createElement("path", {
		fill: "#00A8E0",
		d: "M15.546 21.969a8 8 0 0 0 4.905 1.681 7.97 7.97 0 0 0 5.27-1.983c.017-.015.01-.025-.008-.015-.63.421-2.43 1.342-5.262 1.342-2.461 0-4.017-.55-4.895-1.04-.017-.008-.023.004-.01.015m5.448.409c1.969 0 4.132-.537 5.426-1.6a4.3 4.3 0 0 0 .993-1.193c.174-.298.345-.652.483-1 .006-.017-.004-.025-.017-.006-1.203 1.771-4.687 2.876-8.285 2.876-2.543 0-5.28-.813-6.35-2.367-.01-.014-.021-.008-.015.008.998 2.122 4.025 3.282 7.765 3.282m-2.15-3.52c-4.095 0-6.026-1.908-6.376-3.21-.004-.02-.017-.015-.017.002 0 .438.044 1.004.12 1.38.036.182.184.469.402.697.992 1.034 3.463 2.483 7.744 2.483 5.833 0 7.166-1.944 7.439-2.583.194-.457.295-1.283.295-1.977 0-.168-.004-.302-.01-.434 0-.021-.013-.023-.017-.002-.291 1.564-5.274 3.643-9.58 3.643m-5.621-6.64a8 8 0 0 0-.572 1.658.53.53 0 0 0 .041.388c.491 1.042 2.973 2.709 8.764 2.709 3.532 0 6.276-.869 6.72-2.453.083-.292.087-.6-.018-1.014a7.8 7.8 0 0 0-.524-1.384c-.006-.013-.017-.011-.015.004.07 2.078-5.723 3.417-8.646 3.417-3.166 0-5.807-1.262-5.807-2.855 0-.153.032-.306.071-.466.004-.014-.008-.017-.014-.004m12.511-2.551c.034.052.05.109.05.184 0 .89-2.718 2.462-7.047 2.462-3.181 0-3.776-1.18-3.776-1.931 0-.269.102-.543.329-.822.012-.017.002-.023-.012-.01-.414.35-.793.744-1.126 1.17-.16.2-.258.379-.258.485 0 1.556 3.899 2.684 7.545 2.684 3.884 0 5.618-1.269 5.618-2.384 0-.398-.155-.63-.551-1.082a9 9 0 0 0-.76-.767c-.012-.01-.02-.002-.012.01m-1.19-.89A7.9 7.9 0 0 0 20.45 7.65a7.94 7.94 0 0 0-4.149 1.161c-.36.222-.564.4-.564.63 0 .674 1.577 1.4 4.374 1.4 2.767 0 4.914-.795 4.914-1.56 0-.182-.16-.31-.482-.503"
	})), _path2$63 || (_path2$63 = /*#__PURE__*/ React.createElement("path", {
		fill: "#1E202E",
		d: "M26.874 33.52a.15.15 0 0 1-.158-.157v-4.63H25.15a.15.15 0 0 1-.157-.157v-.639a.15.15 0 0 1 .157-.158h4.172a.15.15 0 0 1 .157.158v.639a.15.15 0 0 1-.157.158h-1.567v4.629a.15.15 0 0 1-.158.158zm-12.005-2.31-.823-2.369-.83 2.369zm1.825 2.124c.036.093-.022.187-.122.187h-.744c-.107 0-.172-.05-.208-.151l-.422-1.22h-2.31l-.423 1.22c-.036.1-.1.15-.207.15h-.701c-.094 0-.158-.093-.122-.186l1.939-5.411c.036-.1.1-.144.207-.144h.959c.107 0 .179.043.215.144zm5.558-.588c.457 0 .765-.223 1.015-.603l-1.158-1.249c-.444.251-.73.502-.73 1.005 0 .495.4.847.872.847m.321-4.206c-.372 0-.586.237-.586.553 0 .244.128.459.422.775.508-.295.723-.474.723-.79 0-.294-.186-.538-.559-.538m3.17 4.78c.093.1.036.2-.079.2h-.908c-.122 0-.186-.028-.265-.121l-.544-.603c-.365.488-.873.854-1.717.854-1.045 0-1.868-.631-1.868-1.715 0-.833.444-1.278 1.117-1.651-.33-.38-.48-.782-.48-1.134 0-.89.623-1.5 1.56-1.5.959 0 1.546.567 1.546 1.407 0 .717-.515 1.119-1.06 1.42l.802.87.45-.79c.058-.094.122-.13.237-.13h.694c.114 0 .179.08.107.201l-.801 1.378zm-7.14.2a.15.15 0 0 0 .157-.157v-4.63h1.567a.15.15 0 0 0 .158-.157v-.639a.15.15 0 0 0-.158-.158h-4.171a.15.15 0 0 0-.158.158v.639a.15.15 0 0 0 .158.158h1.566v4.629a.15.15 0 0 0 .158.158z"
	})));
};

//#endregion
//#region src/ProviderIcon/icons/Blu.svg
var _path$91;
function _extends$94() {
	return _extends$94 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$94.apply(null, arguments);
}
var SvgBlu = function SvgBlu(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$94({
		xmlns: "http://www.w3.org/2000/svg",
		width: 40,
		height: 40,
		fill: "none",
		viewBox: "0 0 40 40"
	}, props), _path$91 || (_path$91 = /*#__PURE__*/ React.createElement("path", {
		fill: "#515151",
		d: "M34.007 26.12h-6.806v-.861a2.87 2.87 0 0 1-2.277 1.087c-2.155 0-3.087-1.363-3.087-3.466v-5.863h3.343v5.362c0 .697.413 1.017.966 1.017a.906.906 0 0 0 .967-.964v-5.415h3.345v8.472h3.533zM11.656 16.792a3.65 3.65 0 0 0-2.323.794v-3.932H6V26.12h3.103v-.586c.344.344 1.139.811 2.323.811 2.655 0 4.518-1.984 4.518-4.776s-1.651-4.778-4.288-4.778m-.743 6.67c-1.103 0-1.67-.863-1.67-1.896 0-1.208.671-1.917 1.67-1.917 1.07 0 1.69.795 1.69 1.917s-.638 1.895-1.69 1.895M20.388 13.654h-3.345V26.12h3.345z"
	})));
};

//#endregion
//#region src/ProviderIcon/icons/Cogent.svg
var _path$90;
var _path2$62;
var _path3$36;
var _path4$21;
function _extends$93() {
	return _extends$93 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$93.apply(null, arguments);
}
var SvgCogent = function SvgCogent(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$93({
		xmlns: "http://www.w3.org/2000/svg",
		width: 40,
		height: 40,
		fill: "none",
		viewBox: "0 0 40 40"
	}, props), _path$90 || (_path$90 = /*#__PURE__*/ React.createElement("path", {
		fill: "#0071BC",
		d: "M15.223 20.47a3.42 3.42 0 0 1-3.411 3.425A3.42 3.42 0 0 1 8.4 20.469a3.42 3.42 0 0 1 3.412-3.425 3.42 3.42 0 0 1 3.41 3.425"
	})), _path2$62 || (_path2$62 = /*#__PURE__*/ React.createElement("path", {
		fill: "#808285",
		d: "M33.625 18.054h.85v3.322c0 2.17 1.505 2.416 2.252 2.416.232 0 .373-.025.373-.025v-.789s-.116.026-.296.026c-.49 0-1.454-.194-1.454-1.719v-3.231h1.621v-.737h-1.62v-1.874h-.864v1.874h-.862zM6.298 17.087c1.583 0 2.368.93 2.368.93l-.45.66s-.72-.789-1.892-.789c-1.416 0-2.523 1.06-2.523 2.61 0 1.526 1.12 2.611 2.549 2.611 1.312 0 2.072-.917 2.072-.917l.399.685s-.875 1.02-2.523 1.02C4.38 23.898 2.9 22.516 2.9 20.5c0-2.004 1.493-3.412 3.398-3.412"
	})), _path3$36 || (_path3$36 = /*#__PURE__*/ React.createElement("path", {
		fill: "#808285",
		fillRule: "evenodd",
		d: "M18.089 25.669c1.261 0 2.265-.595 2.265-2.042v-.595c0-.246.026-.466.026-.466h-.026c-.386.725-1.042 1.138-2.046 1.138-1.738 0-2.883-1.383-2.883-3.335s1.068-3.282 2.806-3.282c1.712 0 2.136 1.085 2.136 1.085h.026s-.013-.078-.013-.22v-.71h.85v6.346c0 2.068-1.52 2.869-3.102 2.869a4.7 4.7 0 0 1-2.124-.517l.334-.724s.798.453 1.751.453m2.278-5.3c0-1.9-.901-2.481-2.046-2.481-1.262 0-1.995.917-1.995 2.468s.836 2.56 2.123 2.56c1.017 0 1.918-.634 1.918-2.547M27.498 20.085c0-1.616-.914-2.998-2.703-2.998-1.75 0-3.192 1.279-3.192 3.412 0 2.003 1.455 3.399 3.385 3.399a3.7 3.7 0 0 0 2.394-.904l-.399-.673s-.785.788-1.969.788c-1.338 0-2.471-.904-2.51-2.572h4.968s.026-.297.026-.452m-2.729-2.262c.966 0 1.79.634 1.841 1.99h-4.067c.206-1.305 1.146-1.99 2.226-1.99",
		clipRule: "evenodd"
	})), _path4$21 || (_path4$21 = /*#__PURE__*/ React.createElement("path", {
		fill: "#808285",
		d: "M27.882 17.241h.862v.97c0 .284-.025.517-.025.517h.025c.232-.594 1.056-1.642 2.587-1.642 1.597 0 2.163.918 2.163 2.52v4.137h-.875v-3.904c0-1.02-.155-1.926-1.404-1.926-1.107 0-2.059.763-2.355 1.836a3.2 3.2 0 0 0-.103.88v3.114h-.875z"
	})));
};

//#endregion
//#region src/ProviderIcon/icons/ComcastBusiness.svg
var _path$89;
var _path2$61;
function _extends$92() {
	return _extends$92 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$92.apply(null, arguments);
}
var SvgComcastBusiness = function SvgComcastBusiness(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$92({
		xmlns: "http://www.w3.org/2000/svg",
		width: 40,
		height: 40,
		fill: "none",
		viewBox: "0 0 40 40"
	}, props), _path$89 || (_path$89 = /*#__PURE__*/ React.createElement("path", {
		fill: "#1C1F33",
		d: "M11.014 13.783c-1.467 0-2.66 1.243-2.66 2.772 0 1.527 1.193 2.771 2.66 2.771s2.66-1.244 2.66-2.771c0-1.529-1.193-2.772-2.66-2.772m0 4.997c-1.178 0-2.137-.999-2.137-2.226s.959-2.225 2.137-2.225 2.137.999 2.137 2.226-.96 2.225-2.137 2.225m22.936-2.19-1.135-.612c-.456-.242-.617-.456-.617-.82 0-.503.397-.83 1.014-.83.362 0 .712.166.916.287a.26.26 0 0 0 .312-.047.28.28 0 0 0-.054-.429c-.258-.15-.7-.356-1.174-.356-.906 0-1.538.566-1.538 1.376 0 .727.459 1.07.908 1.309.125.066 1.004.538 1.135.61.347.19.539.473.539.8 0 .438-.356.903-1.015.903-.64 0-1.138-.448-1.276-.586l-.04-.04-.388.367.046.047c.172.178.8.758 1.658.758.963 0 1.537-.737 1.537-1.45 0-.53-.301-1-.828-1.287M5.56 14.33c.571 0 1.108.23 1.511.65.096.1.276.1.37 0 .05-.05.077-.12.077-.192a.27.27 0 0 0-.077-.193l-.032-.034a2.6 2.6 0 0 0-1.85-.778c-1.466 0-2.659 1.243-2.659 2.772 0 1.527 1.193 2.771 2.66 2.771.774 0 1.471-.346 1.958-.898l-.37-.386a2.1 2.1 0 0 1-1.588.739c-1.178 0-2.137-1-2.137-2.226 0-1.227.959-2.226 2.137-2.226m18.033 0c.57 0 1.108.23 1.51.65.096.1.276.1.371 0a.27.27 0 0 0 .077-.192.28.28 0 0 0-.077-.193l-.032-.034a2.6 2.6 0 0 0-1.85-.778c-1.466 0-2.66 1.243-2.66 2.772 0 1.527 1.194 2.771 2.66 2.771.775 0 1.472-.346 1.958-.898l-.37-.386a2.1 2.1 0 0 1-1.587.739c-1.179 0-2.137-1-2.137-2.226 0-1.227.958-2.226 2.137-2.226m-4.506-.547c-.098 0-.176.066-.218.152-.044.085-1.566 4.008-1.566 4.008s-1.522-3.923-1.565-4.008c-.043-.086-.12-.152-.218-.152-.115 0-.201.088-.231.199s-.89 5.049-.89 5.049a.3.3 0 0 0-.004.05c0 .135.106.245.236.245a.23.23 0 0 0 .15-.056.25.25 0 0 0 .081-.143l.744-4.224s1.435 3.694 1.478 3.782.12.156.22.156c.099 0 .177-.068.219-.156A760 760 0 0 0 19 14.903l.773 4.392h.48s-.904-5.202-.934-5.313-.118-.199-.232-.199m9.458 0c-.1 0-.177.068-.22.156-.043.087-1.97 5.046-1.97 5.046a.26.26 0 0 0 0 .19.25.25 0 0 0 .127.133q.044.018.09.018c.1 0 .185-.064.22-.155l.748-1.918h2.01l.797 2.043h.51s-2.05-5.27-2.093-5.357c-.042-.088-.12-.156-.22-.156m-.791 2.925.79-2.027.792 2.027zM38.9 14.084a.267.267 0 0 0-.262-.272h-2.962a.26.26 0 0 0-.183.08.28.28 0 0 0 0 .384c.048.05.114.08.183.08h1.242v4.939h.479v-4.938h1.24a.27.27 0 0 0 .263-.273"
	})), _path2$61 || (_path2$61 = /*#__PURE__*/ React.createElement("path", {
		fill: "#006FBA",
		d: "M18.632 21.327c-.262 0-.424.192-.424.428v5.083h.848v-5.083c0-.236-.162-.428-.424-.428M9.011 24.66v-2.904a.41.41 0 0 0-.424-.428.41.41 0 0 0-.424.428v2.878c0 1.232.833 2.233 2.16 2.233 1.324 0 2.159-1 2.159-2.233v-3.277h-.85v3.303c0 .727-.463 1.378-1.31 1.378-.846 0-1.311-.65-1.311-1.378m20.543-2.44c.278 0 .449-.186.449-.432s-.17-.432-.449-.432h-2.597c-.242 0-.411.178-.411.428v4.629c0 .242.173.426.411.426h3.018v-.862h-2.582v-1.592h1.947c.295 0 .458-.183.458-.43 0-.249-.161-.432-.458-.432h-1.947v-1.302zM6.311 23.87c.14-.093.53-.413.53-1.123 0-.841-.576-1.39-1.46-1.39H3.561c-.245 0-.41.173-.41.426v5.056h2.334c.946 0 1.6-.718 1.6-1.636 0-.977-.625-1.26-.775-1.332M4 22.214h1.272c.478 0 .71.297.71.667 0 .366-.255.667-.71.667H4zm1.326 3.78H4.001v-1.64h1.326c.61 0 .9.37.9.82s-.308.82-.9.82m15.829-4.666a.41.41 0 0 0-.423.423v4.691c0 .236.2.426.426.426a.43.43 0 0 0 .421-.426v-3.384s2.064 2.75 2.613 3.476c.136.18.233.334.478.334.246 0 .41-.186.41-.426v-5.086h-.846v3.796s-2.3-3.075-2.622-3.501c-.146-.195-.262-.323-.457-.323m-7.687 4.727c.108.147.604.818 1.699.818 1.072 0 1.803-.644 1.803-1.541 0-.59-.223-1.065-1.06-1.485l-.856-.429c-.336-.169-.483-.37-.483-.64 0-.29.227-.6.781-.6.315 0 .559.107.69.168.064.03.215.106.358.106.186 0 .388-.137.388-.418 0-.234-.162-.362-.302-.431a2.46 2.46 0 0 0-1.173-.272c-.938 0-1.632.618-1.632 1.473 0 .786.505 1.176 1.119 1.483l.692.349c.386.194.59.38.59.718 0 .367-.327.672-.825.672-.711 0-1.09-.487-1.16-.569zm17.37 0c.109.147.607.818 1.702.818 1.07 0 1.8-.644 1.8-1.541 0-.59-.219-1.065-1.06-1.485l-.855-.429c-.337-.169-.484-.37-.484-.64 0-.29.228-.6.784-.6.314 0 .556.107.688.168.064.03.216.106.36.106.186 0 .389-.137.389-.418 0-.234-.162-.362-.303-.431a2.5 2.5 0 0 0-1.173-.272c-.935 0-1.634.618-1.634 1.473 0 .786.508 1.176 1.118 1.483l.697.349c.382.194.586.38.586.718 0 .367-.328.672-.822.672-.715 0-1.091-.487-1.16-.569zm4.307 0c.108.147.601.818 1.695.818 1.071 0 1.807-.644 1.807-1.541 0-.59-.225-1.065-1.06-1.485l-.86-.429c-.332-.169-.48-.37-.48-.64 0-.29.228-.6.779-.6.316 0 .562.107.693.168.062.03.21.106.355.106.185 0 .389-.137.389-.418 0-.234-.162-.362-.304-.431a2.45 2.45 0 0 0-1.173-.272c-.934 0-1.628.618-1.628 1.473 0 .786.502 1.176 1.119 1.483l.69.349c.388.194.59.38.59.718 0 .367-.326.672-.825.672-.71 0-1.092-.487-1.16-.569z"
	})));
};

//#endregion
//#region src/ProviderIcon/icons/Cox.svg
var _path$88;
function _extends$91() {
	return _extends$91 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$91.apply(null, arguments);
}
var SvgCox = function SvgCox(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$91({
		xmlns: "http://www.w3.org/2000/svg",
		width: 40,
		height: 40,
		fill: "none",
		viewBox: "0 0 40 40"
	}, props), _path$88 || (_path$88 = /*#__PURE__*/ React.createElement("path", {
		fill: "#00D258",
		d: "m32.22 20 2.713-3.068a1.062 1.062 0 1 0-1.592-1.408l-2.54 2.872-2.54-2.872a1.063 1.063 0 0 0-1.592 1.408l2.714 3.067-2.714 3.068a1.062 1.062 0 1 0 1.593 1.407l2.539-2.87 2.54 2.87a1.063 1.063 0 0 0 1.592-1.407zM19.615 25.031A5.04 5.04 0 0 1 14.582 20a5.04 5.04 0 0 1 5.033-5.031A5.04 5.04 0 0 1 24.647 20a5.04 5.04 0 0 1-5.032 5.031m0-7.937A2.91 2.91 0 0 0 16.707 20a2.91 2.91 0 0 0 2.908 2.906A2.91 2.91 0 0 0 22.522 20a2.91 2.91 0 0 0-2.907-2.906M9.833 25.031A5.04 5.04 0 0 1 4.8 20a5.038 5.038 0 0 1 7.592-4.333 1.062 1.062 0 1 1-1.082 1.829A2.91 2.91 0 0 0 6.926 20a2.91 2.91 0 0 0 4.384 2.504 1.063 1.063 0 0 1 1.082 1.829 5.03 5.03 0 0 1-2.56.698"
	})));
};

//#endregion
//#region src/ProviderIcon/icons/CradlePoint.svg
var _path$87;
var _path2$60;
var _path3$35;
function _extends$90() {
	return _extends$90 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$90.apply(null, arguments);
}
var SvgCradlePoint = function SvgCradlePoint(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$90({
		xmlns: "http://www.w3.org/2000/svg",
		width: 40,
		height: 40,
		fill: "none",
		viewBox: "0 0 40 40"
	}, props), _path$87 || (_path$87 = /*#__PURE__*/ React.createElement("path", {
		fill: "#323E48",
		d: "M4.421 24.323a3 3 0 0 1-.812-.09.83.83 0 0 1-.46-.314 1.3 1.3 0 0 1-.203-.601 8 8 0 0 1-.046-.939 8 8 0 0 1 .046-.935c.018-.214.089-.42.206-.6a.83.83 0 0 1 .46-.314c.264-.068.538-.1.812-.09q.183 0 .353.013.172.013.306.028l.28.035-.014.758a5 5 0 0 1-.238-.021l-.263-.013a7 7 0 0 0-.314-.007 1 1 0 0 0-.333.042.3.3 0 0 0-.183.169 1 1 0 0 0-.073.35q-.014.224-.014.589t.014.589a1 1 0 0 0 .072.346.3.3 0 0 0 .183.165q.163.048.333.042.16 0 .314-.003.153-.004.263-.017c.074-.009.164-.012.239-.02l.014.757-.28.042q-.133.014-.306.028c-.117.01-.232.009-.354.009M6.139 20.506h.778l.099.287.105-.08q.092-.071.193-.126.13-.069.27-.109a1.2 1.2 0 0 1 .343-.046q.07 0 .133.003.063.005.113.011.053.007.105.007l-.013.812q-.056 0-.112-.006h-.12c-.042 0-.088-.004-.14-.004a1.2 1.2 0 0 0-.503.083 3 3 0 0 0-.242.12v2.79h-1.01zM8.543 23.066a1.8 1.8 0 0 1 .057-.476.74.74 0 0 1 .196-.34.87.87 0 0 1 .377-.203 2.1 2.1 0 0 1 .585-.067q.225-.002.45.02l.322.036v-.226a1.4 1.4 0 0 0-.024-.287.33.33 0 0 0-.094-.176.4.4 0 0 0-.204-.087 2 2 0 0 0-.35-.024q-.352 0-.613.014l-.395.02v-.763q.202-.014.412-.035.184-.014.386-.024.204-.01.377-.01.395-.01.778.087a.97.97 0 0 1 .455.267.9.9 0 0 1 .213.448q.057.315.053.635v2.377h-.776l-.09-.232c-.024.009-.063.03-.126.063q-.113.059-.232.102-.157.058-.32.094a1.7 1.7 0 0 1-.389.042q-.199.001-.392-.052a.83.83 0 0 1-.564-.523 1.5 1.5 0 0 1-.087-.546v-.134zm.961.007c0 .189.036.324.107.396q.104.109.399.11.166.002.326-.043.11-.03.213-.077v-.863a3.427 3.427 0 0 0-.54-.041q-.28 0-.392.099-.113.1-.113.365zM13.293 24.323c-.18.006-.36-.025-.53-.09a.73.73 0 0 1-.33-.287 1.4 1.4 0 0 1-.17-.503 5 5 0 0 1-.048-.722v-.66a4.3 4.3 0 0 1 .052-.726q.04-.269.18-.503a.77.77 0 0 1 .333-.297c.164-.071.343-.105.522-.099q.178 0 .353.033a2.2 2.2 0 0 1 .504.153 1 1 0 0 0 .116.046v-1.32h.995v4.902h-.78l-.084-.232q-.035.014-.136.06-.1.044-.252.101-.163.063-.333.098a1.8 1.8 0 0 1-.395.041zm.417-.805a1.6 1.6 0 0 0 .568-.098v-2.074a2 2 0 0 0-.22-.07 1.4 1.4 0 0 0-.348-.042.8.8 0 0 0-.251.036.28.28 0 0 0-.157.133.8.8 0 0 0-.08.287 4 4 0 0 0-.025.491v.407q-.003.246.024.491a.8.8 0 0 0 .08.28.27.27 0 0 0 .158.13.8.8 0 0 0 .251.032M17.139 19.349h-.989v4.9h.989zM22.72 25.407h-.989v-4.902h.779l.083.224q.036-.013.134-.06.097-.046.242-.099.164-.057.333-.094a2 2 0 0 1 .4-.042c.184-.006.368.027.539.099a.76.76 0 0 1 .333.297c.089.155.146.326.168.503a5 5 0 0 1 .046.715v.659q.005.36-.046.715a1.3 1.3 0 0 1-.168.503.76.76 0 0 1-.333.298c-.17.072-.355.105-.54.098q-.177.001-.353-.031a3 3 0 0 1-.29-.07 2 2 0 0 1-.214-.077q-.087-.038-.126-.053v1.32zm-.007-1.998a1.5 1.5 0 0 0 .567.106.8.8 0 0 0 .256-.032.28.28 0 0 0 .16-.13.7.7 0 0 0 .084-.284q.028-.247.025-.495v-.406a4 4 0 0 0-.025-.495.75.75 0 0 0-.083-.283.3.3 0 0 0-.161-.13 1.305 1.305 0 0 0-.603.012 3 3 0 0 0-.22.063zM27.06 24.323a2.5 2.5 0 0 1-.796-.105.96.96 0 0 1-.476-.34 1.4 1.4 0 0 1-.235-.602 5.3 5.3 0 0 1-.063-.895q-.006-.45.063-.898c.03-.216.11-.423.235-.602a.97.97 0 0 1 .476-.336c.258-.078.527-.114.796-.106.27-.008.54.028.8.106.19.059.358.176.479.336.124.18.204.386.232.602q.064.447.06.898.005.45-.06.895a1.4 1.4 0 0 1-.232.602.95.95 0 0 1-.48.34 2.5 2.5 0 0 1-.799.105m0-.8q.16.005.314-.039a.3.3 0 0 0 .182-.157.9.9 0 0 0 .08-.347q.018-.225.018-.599a8 8 0 0 0-.017-.596.9.9 0 0 0-.08-.346.31.31 0 0 0-.183-.162 1 1 0 0 0-.314-.04 1 1 0 0 0-.319.04.3.3 0 0 0-.176.162 1 1 0 0 0-.076.346q-.018.225-.018.596 0 .372.018.6a1 1 0 0 0 .076.346.3.3 0 0 0 .176.157q.156.045.319.04M29.315 21.265l.996-.76v3.745h-.996zM31.089 20.506h.78l.084.238q.036-.013.137-.062.102-.05.252-.106.165-.06.336-.1.196-.04.396-.041c.182-.007.364.027.533.097.136.062.25.163.329.29.086.148.142.311.165.48q.05.33.046.666v2.28h-.99v-2.196a3 3 0 0 0-.024-.42.6.6 0 0 0-.084-.252.3.3 0 0 0-.157-.119.9.9 0 0 0-.252-.032 1.537 1.537 0 0 0-.567.113v2.903h-.982v-3.74zM37.086 23.472l-.197.027q-.202.023-.406.021a.7.7 0 0 1-.164-.017.2.2 0 0 1-.106-.073.4.4 0 0 1-.056-.163 2 2 0 0 1-.017-.272V19.77h-.715l-.175.736h-.54v.75h.435v1.71q-.004.31.039.618c.017.15.069.293.15.42.078.11.188.193.315.238q.256.085.526.078a4 4 0 0 0 .638-.05 4 4 0 0 0 .287-.05z"
	})), _path2$60 || (_path2$60 = /*#__PURE__*/ React.createElement("path", {
		fill: "#323E48",
		d: "M37.052 20.506h-.903l.463.75h.44zM20.887 21.376a1.2 1.2 0 0 0-.236-.519 1 1 0 0 0-.452-.314 2.1 2.1 0 0 0-.709-.107 2.1 2.1 0 0 0-.754.117c-.19.07-.358.19-.483.35-.131.179-.22.385-.26.603a4.3 4.3 0 0 0-.074.87q-.008.452.084.893c.044.22.137.426.273.603.127.157.296.275.488.34.232.075.475.11.719.106a7 7 0 0 0 .995-.07q.202-.025.4-.07l-.015-.735-.358.043a12 12 0 0 1-.861.034q-.18.004-.354-.039a.46.46 0 0 1-.232-.133.6.6 0 0 1-.13-.251 1.5 1.5 0 0 1-.042-.386l-.03-.575a3 3 0 0 1 .035-.503.7.7 0 0 1 .113-.29.35.35 0 0 1 .2-.134q.143-.033.29-.03.13-.003.256.027.107.026.179.11a.53.53 0 0 1 .106.223q.04.189.035.382v.113a1 1 0 0 1-.007.106h-1.201l.484.575h1.571l.014-.183.014-.196q.007-.112.007-.246a3.6 3.6 0 0 0-.07-.714"
	})), _path3$35 || (_path3$35 = /*#__PURE__*/ React.createElement("path", {
		fill: "#F8AB14",
		d: "m26.332 18.455-3.339-2.545a.48.48 0 0 0-.582.764l3.34 2.545a.474.474 0 0 0 .57.008.48.48 0 0 0 .011-.772M23.09 18.455l-1.715-1.31a.481.481 0 0 0-.581.763l1.713 1.31a.48.48 0 1 0 .582-.763M20.059 18.455l-.201-.153a.48.48 0 1 0-.582.763l.201.154a.474.474 0 0 0 .572.008.48.48 0 0 0 .01-.772M32.818 18.455l-4.031-3.079a.535.535 0 0 0-.651 0l-1.3.99-2.227-1.684a.48.48 0 0 0-.582.764l4.965 3.77a.48.48 0 1 0 .583-.763l-1.948-1.485.834-.633 3.774 2.883a.48.48 0 1 0 .58-.765z"
	})));
};

//#endregion
//#region src/ProviderIcon/icons/CrownCastle.svg
var _path$86;
var _path2$59;
function _extends$89() {
	return _extends$89 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$89.apply(null, arguments);
}
var SvgCrownCastle = function SvgCrownCastle(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$89({
		xmlns: "http://www.w3.org/2000/svg",
		width: 40,
		height: 40,
		fill: "none",
		viewBox: "0 0 40 40"
	}, props), _path$86 || (_path$86 = /*#__PURE__*/ React.createElement("path", {
		fill: "#5A6771",
		d: "M31.437 17.816a.82.82 0 0 1-.032 1.148 6.64 6.64 0 0 1-4.573 1.82 6.62 6.62 0 0 1-4.54-1.788.8.8 0 0 1-.04-1.14.8.8 0 0 1 1.139-.04 5.03 5.03 0 0 0 3.441 1.356c1.292 0 2.527-.49 3.466-1.38a.79.79 0 0 1 1.139.024m-4.693-8.76c1.332 0 2.583.514 3.538 1.444a1 1 0 0 0 .2.145.83.83 0 0 0 .97-.145c.314-.32.29-.842-.031-1.155a6.64 6.64 0 0 0-4.67-1.91c-1.732 0-3.368.659-4.62 1.862a6.6 6.6 0 0 0-2.038 4.5l-.088.875a5.035 5.035 0 0 1-5.021 4.484 5.05 5.05 0 0 1-5.046-5.046 5.05 5.05 0 0 1 8.583-3.602.82.82 0 0 0 1.147-.008.82.82 0 0 0-.008-1.147 6.64 6.64 0 0 0-4.668-1.91c-.899 0-1.773.177-2.6.522a6.7 6.7 0 0 0-2.117 1.428 6.7 6.7 0 0 0-1.428 2.118 6.7 6.7 0 0 0-.522 2.6c0 .898.177 1.772.522 2.598a6.7 6.7 0 0 0 1.428 2.118 6.7 6.7 0 0 0 2.117 1.428 6.7 6.7 0 0 0 2.6.521c1.652 0 3.24-.61 4.46-1.716a6.67 6.67 0 0 0 2.166-4.22l.088-.906v-.048a5.03 5.03 0 0 1 5.038-4.83"
	})), _path2$59 || (_path2$59 = /*#__PURE__*/ React.createElement("path", {
		fill: "#520B90",
		d: "M11.172 31.273c-.377.345-.722.561-1.26.561-.818 0-1.444-.666-1.444-1.548v-.016c0-.866.634-1.54 1.444-1.54.441 0 .818.168 1.22.545l.497-.57v-.007c-.353-.337-.834-.682-1.717-.682-.634 0-1.211.24-1.628.666-.41.417-.634.986-.634 1.604v.016c0 .61.225 1.18.634 1.604.417.426.978.658 1.596.658.393 0 .73-.072 1.027-.208.265-.12.497-.305.754-.57v-.008zm-3.049.433s.008 0 0 0c0 0 .008 0 0 0m.032.04c0 .008.008.008.008.016 0-.008 0-.008-.008-.016m.049.056-.017-.016c.009.008.017.008.017.016m.024.024.016.016c-.008-.008-.016-.008-.016-.016m.032.04.008.008s0-.008-.008-.008m20.007-.088v.698s0 .008-.008.008h-3.073s-.008 0-.008-.008v-4.38s0-.008.008-.008h.77s.008 0 .008.008v3.674zs-.008-.008 0 0m4.075.016v.69s0 .008-.008.008h-3.273s-.008 0-.008-.008v-4.38s0-.008.008-.008h3.249s.008 0 .008.008v.69s0 .008-.008.008h-2.47v1.131h2.19s.007 0 .007.008v.69s0 .008-.008.008h-2.19v1.163zq0-.012 0 0m-7.966-3.698v.714s0 .008-.008.008h-1.38v3.658s0 .008-.008.008h-.778s-.008 0-.008-.008v-3.658h-1.38s-.008 0-.008-.008v-.714s0-.008.008-.008zm-4.051 3.129v.016c0 .794-.618 1.315-1.572 1.315-.682 0-1.316-.24-1.83-.706v-.008l.466-.553c.457.393.882.57 1.38.57.457 0 .77-.217.77-.546v-.016c0-.297-.145-.474-.987-.666-.537-.128-.858-.257-1.083-.433-.257-.209-.385-.49-.385-.875v-.016c0-.36.152-.69.425-.922s.65-.353 1.075-.353c.61 0 1.131.176 1.596.553v.008l-.409.586c-.409-.305-.794-.45-1.187-.45-.216 0-.393.049-.521.153a.45.45 0 0 0-.185.361v.016c0 .345.225.49 1.043.682.497.12.826.265 1.05.457q.352.288.354.827m-5.704-3.161h-.73l-1.925 4.412v.008h.802l.45-1.05h2.061l.441 1.05h.827s.008 0 .008-.008zm.377 2.671h-1.492l.746-1.733zM27.866 22.2s0 .008 0 0l-1.508 4.372h-.682l-1.06-3.105-1.058 3.105h-.674l-1.492-4.364V22.2h.842l1.027 3.2 1.059-3.208h.658l1.059 3.209 1.027-3.201h.802M11.14 25.344c-.008 0 0 0 0 0-.377.345-.714.554-1.252.554-.81 0-1.428-.658-1.428-1.532v-.016c0-.859.626-1.525 1.428-1.525.433 0 .81.169 1.212.538l.489-.562v-.008c-.353-.337-.826-.674-1.7-.674-.627 0-1.204.233-1.613.658a2.27 2.27 0 0 0-.626 1.589v.016c0 .61.225 1.17.634 1.588.409.417.97.65 1.58.65.385 0 .722-.064 1.019-.209a2.4 2.4 0 0 0 .746-.561v-.008zm7.765-3.216c-.634 0-1.22.232-1.637.665-.409.418-.641.979-.641 1.58v.017c0 .601.224 1.163.634 1.572.417.425.994.658 1.636.658.634 0 1.22-.233 1.637-.666.409-.417.641-.979.641-1.58v-.016c0-.602-.224-1.164-.634-1.573-.417-.425-1.002-.657-1.636-.657m-1.468 2.23c0-.867.626-1.525 1.46-1.525.826 0 1.468.674 1.468 1.54v.017c0 .866-.626 1.516-1.46 1.516s-1.468-.658-1.468-1.532zm14.913-2.15v4.332s0 .008-.008.008h-.65l-2.382-3.073v3.065s0 .008-.008.008h-.746s-.009 0-.009-.008v-4.332s0-.008.009-.008h.714l2.31 2.984v-2.976s0-.008.008-.008zq0-.012 0 0m-17.368 2.695c.658-.192 1.027-.658 1.027-1.315v-.017c0-.369-.128-.697-.361-.938-.289-.28-.722-.433-1.251-.433h-1.934s-.008 0-.008.008v4.332s0 .008.008.008h.762s.008 0 .008-.008v-1.508h.947l1.067 1.508h.898s.008 0 .008-.008v-.008zm-1.757-1.997h1.107c.57 0 .89.256.89.714v.016c0 .433-.344.722-.89.722h-1.107z"
	})));
};

//#endregion
//#region src/ProviderIcon/icons/Cruzio.svg
var _path$85;
var _path2$58;
var _path3$34;
var _path4$20;
var _path5$13;
var _path6$10;
var _path7$7;
function _extends$88() {
	return _extends$88 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$88.apply(null, arguments);
}
var SvgCruzio = function SvgCruzio(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$88({
		xmlns: "http://www.w3.org/2000/svg",
		width: 40,
		height: 40,
		fill: "none",
		viewBox: "0 0 40 40"
	}, props), _path$85 || (_path$85 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M19.99 19.654A6.708 6.708 0 1 0 17.514 6.71l-.287-.97-.309.085-.974 1.392-1.045 1.137-.85 1.214-.09.439a6.708 6.708 0 0 0 6.031 9.647"
	})), _path2$58 || (_path2$58 = /*#__PURE__*/ React.createElement("path", {
		fill: "#162230",
		fillRule: "evenodd",
		d: "M16.976 5.248c-.17.078-.263.222-.586.906-.346.733-.71 1.139-1.742 1.942-.76.59-.992 1.05-1.002 1.982l-.004.361-.092.271c-1.296 3.823.989 7.93 4.912 8.83 4.884 1.122 9.256-3.199 8.19-8.094-.85-3.911-4.925-6.258-8.726-5.027-.108.035-.199.06-.202.055a3 3 0 0 1-.06-.19c-.234-.778-.266-.858-.379-.967-.114-.11-.185-.125-.309-.069m.222.833c.337 1.13.161 2.496-.405 3.155-.366.426-.465.612-.323.611.063 0 .116-.041.352-.276.238-.238.21-.228.368-.126.276.18.42.107.26-.132-.189-.28-.177-.59.019-.51.09.038.291.245.42.433.06.088.13.184.157.213l.05.054-.103.03c-1.248.371-1.502 2.583-.379 3.294.19.12.194.118-.097.09-.131-.014-.325-.02-.43-.014l-.19.01-.094-.152c-.416-.684-.743-1.563-.82-2.203-.074-.618-.166-.595-.569.143-.68 1.244-.88 2.252-.612 3.08.21.651.806 1.307 1.338 1.474.26.081.293.07.472-.146.396-.477.911-.866 1.115-.842.097.012.064.06-.258.383-.25.25-.36.378-.475.551-.258.387-.357.437-.746.38-1.5-.216-2.43-2.192-1.709-3.63.243-.484.19-.459-.523.245l-.431.427-.007-.098a2 2 0 0 1 .016-.3l.022-.2.095-.085c.138-.125.471-.349.662-.444.357-.18.04-.27-.4-.114-.288.103-.279.104-.311-.037s-.033-.138.15-.268c.164-.118.422-.228.74-.318.574-.162.555-.25-.062-.287-.25-.014-.267-.03-.17-.167.083-.116.136-.125.672-.12.307.003.503-.003.54-.016l.056-.022-.045-.048c-.203-.216-.638-.288-.985-.162-.22.08-.234.082-.25.032-.056-.175.182-.399.513-.483.32-.081.137-.293-.258-.3-.123-.001-.136-.036-.063-.155.093-.15.284-.183.614-.104.257.062.33-.01.18-.179-.29-.327-.168-.603.198-.446.189.08.286.043.213-.083-.166-.283-.081-.434.23-.408.217.018.234 0 .173-.19-.092-.284-.052-.352.21-.355.254-.002.268-.004.268-.04 0-.018-.024-.06-.054-.096-.16-.19-.113-.393.091-.394.122 0 .133-.018.133-.207 0-.165.001-.169.083-.276.046-.06.107-.156.136-.213.092-.186.16-.173.223.04m-.231.168c-.014.717-.146 1.052-.627 1.598-.605.686-.875 1.653-.42 1.5a.9.9 0 0 1 .254-.042c.1 0 .13-.006.13-.029 0-.052-.084-.091-.195-.091-.274 0 .055-.646.432-.85q.298-.162.2.267l-.015.07.07-.068c.382-.37.52-1.638.249-2.27-.037-.087-.077-.13-.078-.085m3.91.274c2.337.355 4.213 1.817 5.096 3.972l.09.22-.04.093-.284.634c-1.313 2.907-1.464 3.42-1.157 3.93l.065.108-.162.036c-.089.02-.263.067-.387.104-.291.088-.27.094-.313-.087-.308-1.283-1.59-1.695-2.687-.863-.14.105-.188.13-.297.152-.703.142-1.39.953-1.394 1.644 0 .124-.004.226-.007.226a15.646 15.646 0 0 0-.702-.179 4 4 0 0 1-.493-.142c-.317-.132-.923-.47-.913-.51.063-.234.572-1.086.757-1.265.122-.118.119-.08-.014.193-.205.42-.274.675-.192.707.073.028.103-.008.165-.199.063-.196.17-.44.256-.587l.05-.085.066.027c.314.132.822.142 1.06.022l.103-.051.181.03c.616.106 1.072-.16 1.3-.755.041-.11.047-.116.146-.145.252-.074.377-.227.445-.549l.036-.165h.173c.645 0 1.225.276 1.497.713.15.242.298.2.17-.047-.244-.47-.798-.767-1.549-.83l-.28-.023.006-.071c.007-.083.063-.111.462-.232.767-.232 1.372-.171 1.855.186.142.105.223-.022.09-.14-.449-.398-1.285-.46-2.15-.156-.41.143-.44.12-.173-.136.585-.56 1.348-.815 2.005-.67.217.048.28.028.245-.08-.033-.104-.7-.16-1.048-.088-.46.095-.893.326-1.321.706-.174.153-.184.16-.231.134a.2.2 0 0 0-.081-.028c-.028 0-.03-.016-.014-.116.134-.818-.357-1.74-1.115-2.1l-.148-.07-.012-.14a.5.5 0 0 0-.174-.385c-.12-.12-.123-.144-.033-.354.31-.73-.066-2.376-.545-2.376-.182 0-.26.086-.526.582-.36.673-.976 1.18-.9.742.033-.195.026-.736-.013-.99-.018-.12-.03-.22-.027-.223.085-.077 1.077-.304 1.532-.35.276-.029 1.285-.011 1.53.026m-1.568.91c.018.042.037.158.042.259.01.2.004.215-.1.217-.053.001-.064.016-.124.153-.216.496-.321.574-.563.416l-.068-.045.198-.187c.246-.232.332-.36.44-.655.093-.254.123-.28.175-.157m.083 1.166c-.007.26-.038.347-.132.361-.118.018-.11-.22.016-.474.107-.216.125-.198.116.113m-1.155.203c.028.033.124.204.215.382.17.333.199.364.241.261.042-.101.205-.26.267-.26s.09.045.153.252c.088.289.166.341.252.17.075-.147.207-.147.412.002.161.116.224.368.085.338a1.5 1.5 0 0 0-.485-.022l-.149.02-.122-.11c-.238-.217-.474-.322-.762-.343l-.163-.011-.002-.073a7 7 0 0 0-.028-.316c-.035-.336-.014-.409.086-.29m.513 1.005c.593.28.967.995 1.05 2.004l.022.287-.047.033a2 2 0 0 0-.132.11l-.084.078.043-.107c.089-.222.043-.911-.067-1.022-.081-.08-.198-.013-.238.138q-.038.14-.134.075c-.115-.075-.11-.168.015-.377.15-.248.128-.372-.09-.497-.397-.227-.667.234-.546.93.116.66.545 1.16.859 1l.074-.037-.023.042c-.332.622-1.493.39-1.87-.374-.522-1.058.311-2.688 1.168-2.283m1.007.456c.614.2.956.753 1.053 1.7.01.107.009.116-.024.102a1 1 0 0 0-.29-.08c-.106-.013-.113-.017-.098-.057.078-.207.012-.717-.095-.732-.055-.008-.104.028-.104.075 0 .067-.05.11-.097.084-.074-.04-.076-.112-.006-.248.142-.276-.097-.56-.308-.365-.03.028-.058.048-.06.045l-.05-.132a2 2 0 0 0-.136-.27 3 3 0 0 1-.1-.172c-.015-.035.12-.014.315.05m-3.98.816c.048.2.167.563.253.77l.051.127-.037.085c-.092.208-.169.562-.212.98l-.011.112-.152.066c-.178.079-.173.082-.205-.147-.12-.858-.066-1.671.13-1.99.144-.23.13-.23.184-.003m10.535.546.037.191-.124.366c-.385 1.14-.497 2.165-.323 2.966.054.25.06.223-.106.563l-.145.299-.102-.015a1.4 1.4 0 0 0-.202-.013l-.265.005c-.326.005-.815.094-1.052.19-.16.066-.158.067-.158-.043v-.099l.246-.072c.376-.11.562-.15.86-.183.452-.05.509-.1.297-.262-.409-.312-.325-.708.745-3.513l.204-.537c.031-.084.049-.053.088.157m-11.06.636c.001.467.025.771.081 1.053.011.056.005.068-.06.11-.08.052-.099.084-.082.138.017.053.08.066.137.029.06-.039.058-.04.112.153.06.217.16.463.28.69.128.244.123.25-.062.066-.492-.486-.71-1.257-.59-2.078.035-.233.151-.668.179-.668.002 0 .004.228.005.507m5.414.075c.286.09.178.209-.276.305-.754.16-1.078.599-.67.91.113.086.12.126.056.3-.112.299-.501.434-1.022.355l-.089-.013.09-.077c.15-.128.33-.218.557-.275.081-.02.086-.025.08-.086-.017-.17-.447-.024-.8.272l-.139.115-.146-.052c-.288-.104-.65-.318-.592-.351.141-.08.76-.137 1.077-.1.207.023.242.013.242-.07 0-.165-1.047-.136-1.486.04-.067.028-.548-.503-.488-.537.136-.076 1.064.079 1.54.258.317.118.457-.006.146-.13l-.137-.054.186-.023c.313-.038.518-.154.906-.51.38-.348.568-.402.965-.277m-4.184.425c.059.1.104.184.1.186-.01.008-.24.052-.27.052-.022 0-.027-.061-.027-.286l.001-.286.045.076zm-.36.287a.3.3 0 0 1-.066.022l-.059.015.013-.136c.007-.075.028-.219.048-.32l.035-.182.018.297c.01.163.014.3.01.304m10.299.352c-.023.298-.108.852-.142.93-.026.06-.004-.611.033-1.01.032-.335.082-.694.105-.743.025-.053.027.522.004.823m-9.723-.206a6 6 0 0 0-.037.796c.028.348-.22-.174-.317-.668-.03-.151-.03-.152.161-.19.222-.043.209-.047.193.062m-.515.185c.044.231.122.468.226.687l.101.214-.065.08c-.05.063-.062.093-.052.133.018.073.114.071.17-.004l.043-.055.05.057.052.058-.107.113a5 5 0 0 0-.176.197l-.07.084-.11-.046-.109-.047-.045-.278a6.4 6.4 0 0 1-.095-1.019l-.003-.28.07-.024c.088-.03.09-.028.12.13m-.36.157c.001.173.012.341.05.727l.01.11-.09-.18a4.3 4.3 0 0 1-.242-.673c-.01-.045.171-.172.257-.179.008 0 .015.087.016.195m1.232.035.15.18-.064.038-.184.115-.12.077-.007-.215c-.003-.118 0-.264.007-.323.015-.126 0-.136.218.128m3.108.183c.157.04.163.055.087.207a.6.6 0 0 1-.377.293l-.055.013.04-.115c.021-.063.05-.191.064-.284.022-.156.028-.169.065-.16zm-6.198.66c1.183 1.847 3.132 3.162 5.27 3.556.622.114 1.656-.075 1.384-.253-.848-.556-.525-2.087.515-2.443.334-.114.773-.05.99.146.133.12.134.118-.09.148-.651.086-1.091.497-1.092 1.02-.001.29.157.358.23.098.305-1.092 1.647-1.065 2.12.042.068.16.072.247.017.394-.055.146-.062.148-.142.032-.31-.454-1.125-.552-1.654-.199-.29.195-.25.414.047.254.485-.261.94-.226 1.264.098.496.496.174 1.473-.53 1.605-.143.027-.238-.166-.254-.516-.014-.318-.095-.419-.338-.426-.152-.004-.189.03-.133.125.114.193-.558.845-.872.845-.152 0-.195-.1-.228-.542-.026-.347-.06-.323-.27.184-.13.32-.41.506-.623.418-.103-.043-.12-.104-.12-.427 0-.446-.059-.47-.317-.128-.435.576-.791.541-.726-.07.03-.28-.04-.435-.133-.302a.6.6 0 0 1-.126.102 1.6 1.6 0 0 0-.243.224c-.369.408-.55.263-.373-.299.132-.422.083-.45-.24-.143-.585.56-.88.341-.452-.335.124-.194.058-.29-.121-.177a.9.9 0 0 1-.22.083 1.1 1.1 0 0 0-.325.142c-.427.254-.487.139-.278-.526.163-.514.129-.573-.17-.291-.139.132-.375.326-.436.358-.053.029-.094-.003-.238-.186l-.04-.051.131-.333c.207-.523.145-.573-.274-.22-.189.158-.184.161-.425-.257l-.055-.096.04-.064c.248-.396.24-.457-.04-.294a.7.7 0 0 1-.149.074 5 5 0 0 1-.222-.491l-.036-.105.054-.057c.074-.077.069-.092-.023-.08-.067.01-.081.004-.099-.034-.067-.147-.286-1.043-.284-1.165 0-.022.057.068.126.2.07.133.16.296.203.362m3.414-.492c.022.024.03.048.018.057-.01.01-.095.075-.19.145-.093.07-.208.163-.255.207-.098.09-.107.087-.12-.032-.01-.098.03-.137.335-.325.173-.107.164-.104.212-.052m7.517 2.135c0 .004-.07.032-.156.063-.204.072-.495.22-.707.358-.19.124-.191.123-.172-.057l.014-.127.134-.05c.309-.114.887-.236.887-.187m.553.033c.074 0 .06.023-.069.105l-.117.076-.149-.033c-.22-.05-.223-.058-.025-.104.246-.059.255-.06.285-.052a.4.4 0 0 0 .075.008m-.453.243a.3.3 0 0 1-.091.067c-.05.03-.123.081-.16.115l-.07.06-.176-.044c-.253-.063-.24-.057-.186-.094.025-.017.12-.065.212-.106l.167-.074.152.031a.5.5 0 0 1 .152.045m.326.07c.077.017.05.08-.137.326a2 2 0 0 1-.355-.116c-.037-.034.344-.251.407-.233zm-1.074.179c.088.017.084.029-.05.123a3 3 0 0 0-.22.176l-.104.094-.031-.06c-.055-.106-.042-.132.122-.252.085-.062.168-.108.186-.104zm.458.122c.248.072.248.072.13.137-.057.03-.188.121-.291.202l-.188.147-.192-.06c-.232-.072-.23-.066-.04-.221.342-.281.33-.277.58-.205m.358.174c-.023.04-.28.341-.333.39-.048.045-.05.045-.138.012-.115-.044-.112-.039-.057-.086.21-.18.576-.399.528-.316m-1.074.314c.022.014.016.025-.026.052-.062.041-.075.035-.059-.026q.018-.07.085-.026m.402.135c.243.087.24.07.042.248l-.161.145-.25-.087a1.5 1.5 0 0 1-.252-.101c0-.031.358-.27.415-.278zm-.451.395.237.087-.053.042-.053.042-.165-.05q-.426-.13-.271-.194c.046-.02.067-.014.305.073m-.166.255c.119.032.125.038.085.082-.068.075-.229.028-.229-.067 0-.044.008-.057.029-.049.016.006.068.022.115.034",
		clipRule: "evenodd"
	})), _path3$34 || (_path3$34 = /*#__PURE__*/ React.createElement("path", {
		fill: "#162230",
		d: "m13.54 24.28-1.654.034a.93.93 0 0 0-.315-.573.9.9 0 0 0-.607-.216q-.48 0-.78.415-.3.406-.3 1.071 0 .657.316 1.097.316.43.79.431.755 0 .896-.905h1.695q-.084.788-.457 1.304-.34.465-.897.731a2.85 2.85 0 0 1-1.213.258q-1.221 0-2.01-.823-.78-.83-.78-2.118 0-1.237.78-2.043.788-.806 1.994-.806.996 0 1.677.574.681.573.864 1.57M13.693 23.79h1.47v.557q.524-.665 1.188-.665.216 0 .482.083v1.387q-.375-.14-.623-.14-.44 0-.706.265-.258.258-.258.698v1.827h-1.553zM21.05 23.79v4.012h-1.47v-.515q-.49.623-1.229.623-.705 0-1.121-.515-.35-.432-.35-1.246V23.79h1.554v2.11q0 .698.523.698a.49.49 0 0 0 .39-.166q.15-.166.15-.457V23.79zM25.207 26.614v1.188h-3.879v-1.204l1.786-1.62h-1.661V23.79h3.68v1.188l-1.811 1.636zM27.089 23.79v4.012h-1.554V23.79zm0-1.528v1.105h-1.554v-1.105zM29.526 23.682q.98 0 1.61.607.64.606.64 1.536a1.94 1.94 0 0 1-.647 1.487q-.648.598-1.603.598-.964 0-1.603-.606a2 2 0 0 1-.64-1.512q0-.906.64-1.503.639-.607 1.603-.607m0 1.105q-.69 0-.69 1.005 0 1.013.698 1.013.332 0 .507-.257.182-.258.182-.74 0-1.02-.697-1.021"
	})), _path4$20 || (_path4$20 = /*#__PURE__*/ React.createElement("path", {
		fill: "#F15C2F",
		d: "M7.47 29.136v5.54H5.75v-5.54zM7.954 30.664h1.47v.473q.472-.58 1.188-.581.664 0 1.07.398.433.407.433 1.23v2.491h-1.553v-2.184q0-.623-.524-.623-.531 0-.531.623v2.184H7.954z"
	})), _path5$13 || (_path5$13 = /*#__PURE__*/ React.createElement("path", {
		fill: "#F15C2F",
		d: "M14.938 30.664v.971h-.723v1.487q0 .258.1.374.099.108.315.108a.9.9 0 0 0 .308-.05v1.055a3.6 3.6 0 0 1-.856.124q-.69 0-1.08-.406-.34-.35-.34-1.147v-1.544h-.59v-.972h.59v-1.196h1.553v1.196z"
	})), _path6$10 || (_path6$10 = /*#__PURE__*/ React.createElement("path", {
		fill: "#F15C2F",
		d: "M19.378 33.04h-2.949a.75.75 0 0 0 .257.49.84.84 0 0 0 .549.174q.398 0 .564-.266h1.512q-.133.581-.74.963-.597.382-1.386.382-1.014 0-1.653-.59-.64-.597-.64-1.536 0-.914.632-1.503.639-.598 1.62-.598.689 0 1.22.315t.797.89q.216.48.216 1.278m-2.94-.831h1.386a.68.68 0 0 0-.697-.632.66.66 0 0 0-.474.175.7.7 0 0 0-.216.457M19.569 30.664h1.47v.556q.523-.664 1.187-.664.216 0 .482.083v1.387q-.374-.141-.623-.141-.44 0-.706.265-.257.258-.257.698v1.827h-1.553zM22.756 30.664h1.47v.473q.474-.58 1.188-.581.665 0 1.071.398.432.407.432 1.23v2.491h-1.553v-2.184q0-.623-.523-.623-.531 0-.532.623v2.184h-1.553zM31.6 33.04h-2.948a.75.75 0 0 0 .258.49.84.84 0 0 0 .548.174q.399 0 .565-.266h1.511q-.133.581-.739.963-.598.382-1.387.382-1.013 0-1.653-.59-.64-.597-.64-1.536 0-.914.632-1.503.639-.598 1.62-.598.69 0 1.22.315.532.315.798.89.216.48.216 1.278m-2.94-.831h1.388a.68.68 0 0 0-.698-.632.66.66 0 0 0-.474.175.7.7 0 0 0-.216.457"
	})), _path7$7 || (_path7$7 = /*#__PURE__*/ React.createElement("path", {
		fill: "#F15C2F",
		d: "M34.25 30.664v.971h-.723v1.487q0 .258.1.374.1.108.316.108a.9.9 0 0 0 .307-.05v1.055a3.6 3.6 0 0 1-.855.124q-.69 0-1.08-.406-.34-.35-.34-1.147v-1.544h-.59v-.972h.59v-1.196h1.552v1.196z"
	})));
};

//#endregion
//#region src/ProviderIcon/icons/EarthLink.svg
var _path$84;
var _path2$57;
var _path3$33;
function _extends$87() {
	return _extends$87 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$87.apply(null, arguments);
}
var SvgEarthLink = function SvgEarthLink(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$87({
		xmlns: "http://www.w3.org/2000/svg",
		width: 40,
		height: 40,
		fill: "none",
		viewBox: "0 0 40 40"
	}, props), _path$84 || (_path$84 = /*#__PURE__*/ React.createElement("path", {
		fill: "#4D5156",
		d: "M6.58 22.07v1.012H4.037v1.058h2.288v.965H4.036v1.066H6.66v1.004H2.9V22.07zM14.098 24.21c-.327 0-.568.117-.732.35-.163.234-.241.537-.241.919v1.704h-1.097v-3.93h1.097v.521a1.9 1.9 0 0 1 .53-.412q.317-.165.645-.179l.008 1.027zM16.51 25.79c0 .148.039.272.117.358a.36.36 0 0 0 .28.124q.301 0 .521-.28l.413.77q-.514.467-1.074.467-.572 0-.957-.373c-.257-.25-.39-.584-.39-1.02v-1.813h-.459v-.785h.46v-1.175h1.105v1.175h.949v.785h-.965zM19.514 25.058v2.117h-1.098v-5.424h1.098v1.93c.334-.335.7-.506 1.112-.506s.755.148 1.043.436q.42.444.42 1.167v2.39h-1.097V25.02c0-.607-.226-.903-.661-.903a.79.79 0 0 0-.576.241c-.156.163-.241.39-.241.7M22.852 27.175V22.07h1.136v4.093h2.179v1.012zM27.988 27.175H26.89v-3.93h1.097zm-1.004-4.428a.63.63 0 0 1-.187-.459c0-.179.062-.335.187-.459a.63.63 0 0 1 .46-.187c.178 0 .334.063.458.187.125.124.187.28.187.46a.63.63 0 0 1-.187.458.63.63 0 0 1-.459.187.62.62 0 0 1-.459-.187M29.941 24.988v2.195h-1.097v-3.93h1.097v.436c.335-.335.7-.506 1.12-.506s.763.148 1.043.436q.42.444.42 1.167v2.389h-1.097v-2.218c0-.607-.225-.902-.661-.902a.79.79 0 0 0-.576.24c-.163.149-.249.382-.249.693M34.439 27.175h-1.097v-5.416h1.097v2.778l1.221-1.3h1.378l-1.494 1.596 1.556 2.342h-1.3l-1.003-1.502-.358.374zM9.872 25.969a.84.84 0 0 1-.646.303.87.87 0 0 1-.661-.303 1.1 1.1 0 0 1-.288-.778q0-.48.28-.794a.835.835 0 0 1 1.315 0c.18.21.265.475.265.794 0 .31-.086.576-.265.778m.25-2.32a1.5 1.5 0 0 0-1.168-.505q-.714 0-1.253.56-.537.56-.537 1.432-.001.876.545 1.47c.366.398.778.592 1.245.592s.848-.194 1.16-.576v.522h1.097v-3.922h-1.098v.428z"
	})), _path2$57 || (_path2$57 = /*#__PURE__*/ React.createElement("path", {
		fill: "#F78D1E",
		d: "M15.4 14.361a4.597 4.597 0 0 1 6.72-4.07c.267-.167.533-.315.79-.453a5.37 5.37 0 0 0-2.918-.867 5.39 5.39 0 0 0-5.38 5.38c0 .76.157 1.479.443 2.139.177-.227.374-.463.571-.7a4.8 4.8 0 0 1-.226-1.429M25.048 12.528c-.06-.148-.118-.295-.187-.433a3 3 0 0 0-.168-.316 5.4 5.4 0 0 0-1.163-1.429c-.227.119-.473.266-.73.414a4.57 4.57 0 0 1 1.647 2.503c.088.355.138.73.138 1.104a4.597 4.597 0 0 1-6.318 4.258c-.157-.06-.295-.138-.443-.217a4.618 4.618 0 0 1-1.853-1.853c-.187.227-.374.444-.532.65a5.3 5.3 0 0 0 1.33 1.45c.1.068.188.137.296.206.128.089.266.168.404.237.76.404 1.616.64 2.533.64a5.39 5.39 0 0 0 5.38-5.38 5.7 5.7 0 0 0-.334-1.834"
	})), _path3$33 || (_path3$33 = /*#__PURE__*/ React.createElement("path", {
		fill: "#4D5156",
		d: "M25.757 9.621c-.118-.138-.295-.207-.542-.207-.837 0-2.523.887-4.415 2.277a1 1 0 0 1 .187.266 25 25 0 0 1 1.804-1.213c.256-.157.503-.295.73-.413.719-.375 1.31-.592 1.684-.592q.207 0 .296.089c.158.177.02.788-.818 1.932.06.108.108.207.168.315.946-1.232 1.251-2.06.906-2.454M20.012 12.006a.484.484 0 0 0-.483.483c0 .059.02.118.04.177-.158.128-.316.256-.464.385-.079.069-.168.138-.246.207-1.518 1.3-2.829 2.66-3.706 3.814-.946 1.251-1.251 2.079-.916 2.473.118.138.295.197.542.197.502 0 1.32-.315 2.296-.867l-.296-.207c-.857.483-1.567.759-2 .759q-.207 0-.296-.089c-.158-.187-.01-.838.926-2.07.01-.02.03-.039.04-.049.158-.207.345-.433.532-.65.818-.966 1.892-2.02 3.085-3.055.088-.07.167-.138.256-.217.158-.128.305-.256.463-.384.01.01.02.01.03.02.059.029.138.049.207.049a.488.488 0 0 0-.01-.976"
	})));
};

//#endregion
//#region src/ProviderIcon/icons/Fastmetrics.svg
var _path$83;
var _path2$56;
var _path3$32;
function _extends$86() {
	return _extends$86 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$86.apply(null, arguments);
}
var SvgFastmetrics = function SvgFastmetrics(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$86({
		xmlns: "http://www.w3.org/2000/svg",
		width: 40,
		height: 40,
		fill: "none",
		viewBox: "0 0 40 40"
	}, props), _path$83 || (_path$83 = /*#__PURE__*/ React.createElement("path", {
		fill: "#E38F33",
		d: "M17.668 13.95h6.074v-2.584h-8.658v8.59h2.584z"
	})), _path2$56 || (_path2$56 = /*#__PURE__*/ React.createElement("path", {
		fill: "#E38F33",
		d: "M23.339 17.977a1.575 1.575 0 0 1-1.577-1.578c0-.872-.705-1.577-1.577-1.577-.873 0-1.578.705-1.578 1.577 0 .873.705 1.578 1.578 1.578.872 0 1.577.704 1.577 1.543 0 .873.704 1.577 1.577 1.577s1.577-.704 1.577-1.577c0-.839-.704-1.543-1.577-1.543m-.034 2.281a.745.745 0 0 1-.738-.738c0-.402.336-.738.738-.738.403 0 .739.335.739.738a.745.745 0 0 1-.739.738"
	})), _path3$32 || (_path3$32 = /*#__PURE__*/ React.createElement("path", {
		fill: "#4C667C",
		d: "M4.808 23.817a.8.8 0 0 0-.312-.07c-.14 0-.243.087-.243.226v.416h.676l-.139.694h-.537v2.463H3.177v-2.463H2.9v-.694h.277c-.017-.104-.017-.26-.017-.381 0-.92.711-1.023 1.11-1.023.33 0 .555.034.798.173zM7.322 27.372c-.156.139-.433.26-.797.26-.798 0-1.093-.468-1.093-1.04 0-.607.52-1.04 1.422-1.04h.174v-.174c0-.19-.018-.295-.26-.295-.365 0-.642.121-.92.33l-.399-.66c.4-.242.92-.45 1.44-.45.607 0 1.04.208 1.162.572.052.139.052.26.052.485l-.018 1.11c0 .26.018.486.243.625l-.624.59c-.139-.053-.33-.209-.382-.313m-.85-.78c0 .19.105.312.295.312.087 0 .226-.052.26-.104v-.555c-.468-.017-.554.173-.554.347M10.305 27.632c-.45 0-.901-.138-1.387-.399l.381-.78c.209.122.729.399 1.041.399.19 0 .33-.121.33-.243 0-.173-.104-.225-.417-.295l-.416-.086c-.52-.104-.746-.417-.746-.868 0-.659.52-1.075 1.318-1.075.642 0 .954.191 1.266.33l-.33.659c-.311-.174-.571-.226-.78-.226-.173 0-.277.07-.277.174s.07.19.33.26l.398.087c.573.121.798.433.798.936-.034.694-.624 1.127-1.509 1.127M13.705 24.39h.59l-.14.693h-.45v1.283c0 .451.069.538.33.538a.47.47 0 0 0 .277-.07l.138.608c-.277.121-.537.19-.815.19-.607 0-1.006-.156-1.006-.763v-1.786h-.26v-.694h.26c0-.312 0-.572.035-.78l1.075-.156c-.052.33-.034.642-.034.936M18.422 27.563v-1.96c0-.416-.052-.45-.226-.45a.8.8 0 0 0-.347.12v2.29h-1.005v-1.977c0-.416-.018-.468-.226-.468a.65.65 0 0 0-.347.121v2.307h-1.04V25.55c0-.381-.018-.728-.104-1.058l.988-.173c.035.104.052.19.07.312.225-.19.503-.312.78-.312.347 0 .555.139.728.347.26-.226.538-.347.92-.347.45 0 .867.156.867.936v2.307zM21.925 26.887c.277 0 .572-.104.85-.312l.416.607c-.433.329-.832.45-1.3.45-1.024 0-1.596-.624-1.596-1.647 0-1.04.555-1.682 1.457-1.682 1.023 0 1.456.659 1.44 1.734v.26h-1.787c0 .208.07.59.52.59m-.139-1.839c-.225 0-.381.14-.381.573h.728c0-.347-.086-.573-.347-.573M25.134 24.39h.59l-.14.693h-.45v1.283c0 .451.069.538.329.538a.47.47 0 0 0 .277-.07l.14.608c-.278.121-.538.19-.816.19-.607 0-1.006-.156-1.006-.763v-1.786h-.26v-.694h.26c0-.312 0-.572.035-.78l1.075-.156c-.034.33-.034.642-.034.936M28.429 25.256a.5.5 0 0 0-.313-.086.42.42 0 0 0-.381.225v2.168H26.66v-1.925c0-.399-.018-.798-.104-1.145l.988-.173c.035.104.07.243.07.381.138-.173.312-.398.659-.398.156 0 .26.034.398.086zM29.85 24.147a.614.614 0 0 1-.606-.607c0-.33.277-.607.641-.607.347 0 .607.277.607.607s-.294.607-.641.607m-.537 3.416v-3.122l1.075-.104v3.226zM32.678 27.632c-.902 0-1.457-.555-1.457-1.63 0-1.058.572-1.7 1.526-1.7.399 0 .676.122.989.382l-.503.642c-.122-.122-.313-.226-.451-.226-.26 0-.4.14-.4.85 0 .642.07.902.382.902.243 0 .434-.121.59-.277l.45.624c-.311.33-.727.433-1.126.433M35.591 27.632c-.468 0-.902-.138-1.387-.399l.381-.78c.208.122.729.399 1.04.399.192 0 .33-.121.33-.243 0-.173-.104-.225-.416-.295l-.416-.086c-.52-.104-.746-.417-.746-.868 0-.659.52-1.075 1.318-1.075.642 0 .954.191 1.266.33l-.33.659c-.311-.174-.572-.226-.78-.226-.173 0-.277.07-.277.174s.07.19.33.26l.398.087c.572.121.798.433.798.936-.035.694-.624 1.127-1.509 1.127"
	})));
};

//#endregion
//#region src/ProviderIcon/icons/For2Fi.svg
var _path$82;
var _path2$55;
var _path3$31;
var _path4$19;
var _path5$12;
var _path6$9;
function _extends$85() {
	return _extends$85 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$85.apply(null, arguments);
}
var SvgFor2Fi = function SvgFor2Fi(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$85({
		xmlns: "http://www.w3.org/2000/svg",
		width: 40,
		height: 40,
		fill: "none",
		viewBox: "0 0 40 40"
	}, props), _path$82 || (_path$82 = /*#__PURE__*/ React.createElement("path", {
		fill: "#1E5A8F",
		d: "M10.279 23.275h1.041V21.16h2.618v-.94H11.32v-1.386h2.978v-.941h-4.02zM17.08 23.384c1.234 0 2.11-.858 2.11-2.082s-.876-2.092-2.11-2.092c-1.242 0-2.118.868-2.118 2.092s.876 2.082 2.119 2.082m0-.82c-.675 0-1.252-.54-1.252-1.262-.056-.884.55-1.336 1.253-1.336.676 0 1.243.524 1.243 1.336 0 .759-.567 1.261-1.243 1.261M20.165 23.275h.987v-2.066c.192-.54.46-.93.997-1.072.129-.023.27-.023.407-.023v-.952h-.326c-.42 0-.912.522-1.1.925v-.875h-.965zM27.136 23.332v-.863H24.53c1.401-1.22 2.497-1.754 2.497-3.085 0-1.115-.87-1.587-1.952-1.587-.78 0-1.363.47-1.784 1.126l.635.555c.285-.358.655-.812 1.166-.812s.971.322.971.718c0 1.054-.846 1.345-2.905 3.177v.771z"
	})), _path2$55 || (_path2$55 = /*#__PURE__*/ React.createElement("path", {
		fill: "#009FDB",
		d: "M33.715 18.68a.59.59 0 0 0 .612-.602.59.59 0 0 0-.612-.613c-.366 0-.621.256-.621.613 0 .347.255.602.62.602m-.493 4.595h.986v-4.063h-.986zM28.188 23.275h1.042V21.16h2.617v-.94H29.23v-1.386h2.977v-.941h-4.019z"
	})), _path3$31 || (_path3$31 = /*#__PURE__*/ React.createElement("path", {
		fill: "#009FDB",
		d: "M34.601 17.457a.78.78 0 0 1-.01.545c0-.476-.232-.73-.413-.833a.87.87 0 0 0-.927.072.778.778 0 0 1 1.35.216"
	})), _path4$19 || (_path4$19 = /*#__PURE__*/ React.createElement("path", {
		fill: "#009FDB",
		d: "M35.07 17.107c.09.255.084.533-.015.785 0-.686-.334-1.052-.596-1.2a1.26 1.26 0 0 0-1.335.103 1.122 1.122 0 0 1 1.945.312"
	})), _path5$12 || (_path5$12 = /*#__PURE__*/ React.createElement("path", {
		fill: "#009FDB",
		d: "M35.666 16.774c.129.363.121.76-.02 1.117 0-.976-.476-1.497-.848-1.708a1.79 1.79 0 0 0-1.902.147 1.598 1.598 0 0 1 2.77.444"
	})), _path6$9 || (_path6$9 = /*#__PURE__*/ React.createElement("path", {
		fill: "#9C6",
		d: "M20.53 15.17C15.8 13.68 4.166 18.5 4.298 22.798c.033 1.066 2.089 2.194 6.516 1.44-4.538 1.322-8.038.329-7.912-1.516s2.444-3.469 2.444-3.469c4.73-3.736 11.866-5.483 15.182-4.083"
	})));
};

//#endregion
//#region src/ProviderIcon/icons/Frontier.svg
var _path$81;
var _path2$54;
function _extends$84() {
	return _extends$84 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$84.apply(null, arguments);
}
var SvgFrontier = function SvgFrontier(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$84({
		xmlns: "http://www.w3.org/2000/svg",
		width: 40,
		height: 40,
		fill: "none",
		viewBox: "0 0 40 40"
	}, props), _path$81 || (_path$81 = /*#__PURE__*/ React.createElement("path", {
		fill: "#DB202C",
		d: "M7.794 16.454v1.208H4.277v1.822h3.326v1.165H4.277v3.04H2.9v-7.235zM11.5 19.96a1.5 1.5 0 0 0-.519-.106c-.773 0-1.398.773-1.398 1.886v1.949H8.27v-4.926h1.303v.805h.02c.297-.582.721-.921 1.357-.921.233 0 .392.053.55.116zM37.1 19.96a1.5 1.5 0 0 0-.519-.106c-.773 0-1.398.773-1.398 1.886v1.949H33.87v-4.926h1.302v.805h.021c.297-.582.72-.921 1.356-.921.233 0 .392.053.551.116zM12.994 21.22c0 .88.656 1.42 1.324 1.42.762 0 1.27-.72 1.27-1.398 0-.72-.529-1.43-1.26-1.43-.762 0-1.334.604-1.334 1.409m4.003.012c0 1.292-1.027 2.573-2.722 2.573-1.652 0-2.69-1.207-2.69-2.563 0-1.546 1.292-2.595 2.637-2.595 1.822 0 2.775 1.324 2.775 2.585M22.029 23.689h-1.314v-2.86c0-.509-.148-.911-.72-.911-.795 0-1.26.826-1.26 1.769v2.002H17.42v-4.926h1.312l.001.774c.212-.318.604-.89 1.557-.89 1.187 0 1.738.815 1.738 1.832zM27.748 23.689h-1.314v-4.926h1.313zM31.804 20.5a1.02 1.02 0 0 0-.995-.868c-.106 0-.837.032-1.113.868zm1.42.9H29.58c.074.244.138.424.307.637a1.58 1.58 0 0 0 1.197.56c.72 0 1.377-.37 1.949-.815v1.345c-.434.233-1.25.678-2.161.678-1.567 0-2.658-1.197-2.658-2.563 0-1.377 1.101-2.595 2.563-2.595 1.483 0 2.447 1.06 2.447 2.553zM24.354 17.291v1.483h1.377v.985h-1.335v2.15c0 .551.297.689.636.689.265 0 .498-.085.699-.17v1.165c-.392.106-.795.17-1.197.17-.89 0-1.451-.456-1.451-1.409v-2.595h-.816v-.985h.816v-1.489h1.27M25.557 15.785a.626.626 0 1 1-1.253 0 .626.626 0 0 1 1.253 0M23.265 14.582a.527.527 0 1 1-1.055 0 .527.527 0 0 1 1.055 0M21.073 13.823a.494.494 0 1 1-.989 0 .494.494 0 0 1 .989 0M18.732 13.444a.428.428 0 1 1-.856 0 .428.428 0 0 1 .856 0M16.359 13.444a.363.363 0 1 1-.725 0 .363.363 0 0 1 .725 0M14.059 13.74a.321.321 0 1 1-.642 0 .321.321 0 0 1 .642 0M11.8 14.565a.222.222 0 1 1-.443 0 .222.222 0 0 1 .444 0M9.937 15.81a.139.139 0 1 1-.277.001.139.139 0 0 1 .277 0M8.82 17.195a.104.104 0 1 1-.207 0 .104.104 0 0 1 .208 0M27.772 17.462c0 .383-.316.69-.7.69a.697.697 0 0 1-.699-.7c0-.412.345-.7.671-.7.24 0 .728.202.728.71"
	})), _path2$54 || (_path2$54 = /*#__PURE__*/ React.createElement("path", {
		fill: "#4F4C4D",
		d: "M4.858 26.661c-.222.222-.505.32-.81.32-.779 0-1.136-.538-1.136-1.105s.363-1.13 1.136-1.13c.293 0 .567.105.788.327l-.23.221a.8.8 0 0 0-.558-.221c-.55 0-.794.403-.794.8 0 .394.24.785.794.785.2 0 .422-.083.573-.234zM6.335 26.667c.536 0 .76-.382.76-.791 0-.397-.224-.81-.754-.819-.502 0-.767.348-.767.819.01.382.225.791.76.791m1.102-.797c0 .582-.354 1.114-1.102 1.114s-1.102-.545-1.102-1.111c0-.656.458-1.13 1.108-1.13.736 0 1.096.545 1.096 1.127M9.956 25.288l-.733 1.02H9.15l-.723-1.02v1.653H8.08v-2.155h.4l.711 1.01.709-1.01h.4v2.155h-.345zM12.94 25.288l-.732 1.02h-.074l-.724-1.02v1.653h-.344v-2.155h.4l.71 1.01.709-1.01h.4v2.155h-.344zM15.858 24.786v1.262c0 .635-.419.949-.94.934-.48-.01-.889-.324-.889-.933v-1.263h.342v1.262c0 .389.228.607.548.616.345.015.597-.203.597-.616v-1.262zM18.087 26.316v-1.533h.345v2.155h-.262l-1.222-1.52v1.52H16.6v-2.155h.265zM19.195 24.783h.342v2.155h-.342zM22.119 26.661c-.222.222-.505.32-.81.32-.779 0-1.136-.538-1.136-1.105s.363-1.13 1.136-1.13c.292 0 .566.105.788.327l-.23.221a.8.8 0 0 0-.558-.221c-.551 0-.794.403-.794.8 0 .394.24.785.794.785.2 0 .422-.083.573-.234zM23.654 25.146l-.455 1.026h.911zm.582 1.34H23.07l-.204.452H22.5l.967-2.155h.375l.967 2.155h-.367zM25.557 25.094h-.708v-.31h1.761v.31h-.705v1.844h-.348zM27.143 24.783h.341v2.155h-.341zM29.222 26.667c.536 0 .761-.382.761-.791 0-.397-.225-.81-.754-.819-.502 0-.767.348-.767.819.01.382.225.791.76.791m1.103-.797c0 .582-.354 1.114-1.103 1.114-.748 0-1.102-.545-1.102-1.111 0-.656.459-1.13 1.109-1.13.735 0 1.096.545 1.096 1.127M32.456 26.316v-1.533h.344v2.155h-.261l-1.223-1.52v1.52h-.348v-2.155h.265zM34.85 25.279c-.102-.148-.309-.237-.533-.24-.29 0-.5.12-.5.308 0 .209.241.267.524.307.444.065.865.185.865.663 0 .483-.443.664-.892.664-.416 0-.73-.126-.927-.49l.258-.171c.157.261.422.353.672.353.258 0 .545-.083.545-.356 0-.222-.247-.308-.551-.349-.428-.058-.835-.166-.835-.628.01-.415.437-.6.832-.6.31 0 .621.074.803.363z"
	})));
};

//#endregion
//#region src/ProviderIcon/icons/Google.svg
var _path$80;
var _path2$53;
var _path3$30;
var _path4$18;
var _path5$11;
var _path6$8;
var _path7$6;
var _path8$6;
function _extends$83() {
	return _extends$83 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$83.apply(null, arguments);
}
var SvgGoogle$1 = function SvgGoogle(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$83({
		xmlns: "http://www.w3.org/2000/svg",
		width: 40,
		height: 40,
		fill: "none",
		viewBox: "0 0 40 40"
	}, props), _path$80 || (_path$80 = /*#__PURE__*/ React.createElement("path", {
		fill: "#5F6368",
		d: "M2.9 20.013h.825l1.147 4.626.102.434h.034l.128-.434 1.411-4.626h.774l1.343 4.626.127.434h.034l1.25-5.06h.825l-1.7 6.293h-.774l-1.48-5.043h-.033l-.153.494-1.378 4.549H4.61zM11.741 26.144a2.15 2.15 0 0 1-.782-.825c-.195-.348-.28-.748-.28-1.199 0-.425.085-.807.263-1.165.179-.357.425-.637.748-.841a2 2 0 0 1 1.122-.315c.425 0 .79.094 1.114.29.323.186.561.458.731.807q.255.523.255 1.199a.8.8 0 0 1-.017.178h-3.46c.009.332.094.604.238.834.145.23.332.39.553.502.22.11.45.17.68.17.552 0 .977-.273 1.275-.808l.663.314a2.3 2.3 0 0 1-.782.85c-.332.213-.731.324-1.19.324-.425-.009-.8-.11-1.13-.315m2.38-2.5a1.24 1.24 0 0 0-.152-.527c-.085-.178-.23-.323-.426-.45a1.43 1.43 0 0 0-.748-.188c-.331 0-.612.102-.85.315a1.47 1.47 0 0 0-.459.842zM16.944 26.22a1.6 1.6 0 0 1-.604-.569h-.034v.655h-.714v-6.293h.748v1.982l-.034.595h.034c.145-.221.34-.408.604-.561s.57-.221.918-.221c.374 0 .723.102 1.037.306.315.204.57.476.757.833q.28.525.28 1.19c0 .443-.093.834-.28 1.19-.187.358-.442.63-.757.834a1.87 1.87 0 0 1-1.037.306c-.349-.017-.655-.093-.918-.246m1.522-.654c.22-.136.4-.323.527-.578a1.9 1.9 0 0 0 .195-.868 1.9 1.9 0 0 0-.195-.867 1.45 1.45 0 0 0-.527-.578 1.34 1.34 0 0 0-.715-.204 1.4 1.4 0 0 0-.714.195c-.22.136-.4.323-.527.57a1.9 1.9 0 0 0-.195.876c0 .332.068.62.195.867.128.255.306.442.527.579s.46.195.715.195a1.2 1.2 0 0 0 .714-.187M20.531 21.944h.714v.637h.034c.145-.22.34-.408.604-.56.264-.154.57-.222.918-.222.374 0 .723.102 1.037.306.315.204.57.476.757.834.187.357.28.748.28 1.19s-.093.833-.28 1.19c-.187.358-.442.63-.757.834a1.87 1.87 0 0 1-1.037.306 1.9 1.9 0 0 1-.918-.221 1.6 1.6 0 0 1-.604-.57h-.034l.034.604v1.947h-.748zm2.874 3.622c.22-.136.4-.323.527-.578a1.9 1.9 0 0 0 .195-.868 1.9 1.9 0 0 0-.195-.867 1.39 1.39 0 0 0-1.241-.782 1.4 1.4 0 0 0-.714.195c-.221.136-.4.323-.528.57a1.9 1.9 0 0 0-.195.876c0 .332.068.62.195.867.128.255.306.442.527.579s.46.195.715.195c.255.017.493-.051.714-.187M26.108 26.255a1.5 1.5 0 0 1-.595-.527 1.38 1.38 0 0 1-.213-.757c0-.46.17-.825.527-1.08.35-.255.8-.391 1.344-.391.272 0 .51.025.73.085.213.06.392.119.52.195v-.23q.002-.316-.162-.569a1.13 1.13 0 0 0-.434-.391 1.26 1.26 0 0 0-.586-.136c-.502 0-.876.204-1.14.604l-.62-.417c.178-.272.425-.476.723-.63a2.2 2.2 0 0 1 1.011-.22c.595 0 1.071.161 1.411.484.349.323.519.757.519 1.301v2.721h-.714v-.646h-.034a1.9 1.9 0 0 1-.57.561 1.5 1.5 0 0 1-.833.221c-.34.017-.629-.05-.884-.178m1.59-.655q.318-.182.51-.502a1.3 1.3 0 0 0 .195-.688 2.04 2.04 0 0 0-1.13-.315q-.55.002-.884.247-.332.255-.332.637c0 .238.094.425.29.579.195.152.416.22.68.22q.354.014.67-.178M30.29 26.093a1.9 1.9 0 0 1-.68-.867l.664-.29c.119.273.28.485.493.63s.45.221.697.221c.28 0 .518-.06.697-.187q.28-.181.28-.45a.53.53 0 0 0-.204-.426c-.136-.11-.374-.204-.705-.289l-.595-.153a1.9 1.9 0 0 1-.842-.417q-.347-.293-.348-.79c0-.273.076-.502.23-.698q.226-.29.62-.442.382-.153.841-.153c.374 0 .714.085 1.029.255s.527.417.654.731l-.663.281a.95.95 0 0 0-.425-.468 1.3 1.3 0 0 0-.637-.153c-.23 0-.434.06-.62.17q-.281.166-.281.434 0 .23.178.357c.12.085.315.17.578.238l.655.162c.433.11.756.28.969.493a1.1 1.1 0 0 1 .323.782c0 .255-.077.485-.221.689a1.47 1.47 0 0 1-.612.485c-.264.119-.561.178-.901.178-.46.034-.85-.085-1.173-.323M34.193 26.093a1.97 1.97 0 0 1-.68-.867l.663-.29c.119.273.28.485.493.63s.45.221.697.221c.28 0 .518-.06.697-.187q.28-.181.28-.45a.53.53 0 0 0-.204-.426c-.136-.11-.374-.204-.705-.289l-.595-.153a1.9 1.9 0 0 1-.842-.417q-.346-.293-.348-.79c0-.273.076-.502.23-.698q.226-.29.62-.442.382-.153.841-.153c.374 0 .714.085 1.029.255s.527.417.654.731l-.663.281a.95.95 0 0 0-.425-.468 1.3 1.3 0 0 0-.637-.153c-.23 0-.434.06-.62.17q-.281.166-.281.434 0 .23.178.357c.12.085.315.17.578.238l.655.162c.433.11.756.28.969.493a1.1 1.1 0 0 1 .323.782c0 .255-.077.485-.221.689a1.47 1.47 0 0 1-.612.485c-.264.119-.561.178-.901.178-.46.034-.85-.085-1.173-.323"
	})), _path2$53 || (_path2$53 = /*#__PURE__*/ React.createElement("path", {
		fill: "#EA4335",
		d: "M9.527 13.519c-.869 0-1.574.659-1.574 1.568 0 .904.705 1.569 1.574 1.569s1.574-.665 1.574-1.569c0-.91-.711-1.568-1.574-1.568m0 2.519c-.478 0-.886-.39-.886-.95 0-.566.408-.951.886-.951s.886.385.886.95c-.006.554-.414.95-.886.95"
	})), _path3$30 || (_path3$30 = /*#__PURE__*/ React.createElement("path", {
		fill: "#FBBC04",
		d: "M12.955 13.519c-.869 0-1.574.659-1.574 1.568 0 .904.705 1.569 1.574 1.569.868 0 1.574-.665 1.574-1.569 0-.91-.706-1.568-1.574-1.568m0 2.519c-.472 0-.886-.39-.886-.95 0-.566.408-.951.886-.951s.886.385.886.95c0 .554-.408.95-.886.95"
	})), _path4$18 || (_path4$18 = /*#__PURE__*/ React.createElement("path", {
		fill: "#4285F4",
		d: "M17.17 13.869h-.024c-.151-.187-.454-.35-.827-.35-.782 0-1.504.688-1.504 1.574 0 .88.717 1.563 1.504 1.563.373 0 .67-.163.827-.356h.024v.228c0 .6-.32.92-.84.92-.42 0-.682-.302-.793-.559l-.6.25c.169.415.63.928 1.387.928.805 0 1.493-.472 1.493-1.633v-2.822h-.653zm-.793 2.169c-.472 0-.875-.397-.875-.945 0-.554.397-.956.875-.956.472 0 .84.402.84.956 0 .542-.368.945-.84.945"
	})), _path5$11 || (_path5$11 = /*#__PURE__*/ React.createElement("path", {
		fill: "#EA4335",
		d: "M20.872 16.038c-.35 0-.6-.164-.758-.478l2.098-.87-.07-.18c-.128-.35-.53-.997-1.34-.997s-1.481.636-1.481 1.569c0 .88.664 1.568 1.556 1.568.718 0 1.137-.437 1.306-.694l-.536-.356c-.18.263-.426.438-.775.438m-.053-1.913c.274 0 .507.134.583.332l-1.399.584a.86.86 0 0 1 .816-.916"
	})), _path6$8 || (_path6$8 = /*#__PURE__*/ React.createElement("path", {
		fill: "#34A853",
		d: "M18.983 11.95h-.688v4.613h.688z"
	})), _path7$6 || (_path7$6 = /*#__PURE__*/ React.createElement("path", {
		fill: "#4285F4",
		d: "M5.44 13.997v.665h1.592c-.047.373-.175.647-.362.84-.233.232-.594.483-1.23.483-.979 0-1.749-.793-1.749-1.772 0-.98.764-1.773 1.75-1.773.53 0 .915.21 1.2.478l.472-.466a2.35 2.35 0 0 0-1.673-.67c-1.34 0-2.471 1.09-2.471 2.437s1.13 2.437 2.471 2.437c.723 0 1.271-.24 1.697-.682.437-.438.577-1.056.577-1.557q0-.239-.035-.414c0-.006-2.239-.006-2.239-.006"
	})), _path8$6 || (_path8$6 = /*#__PURE__*/ React.createElement("path", {
		fill: "#5F6368",
		d: "M25.197 14.708v1.849h-.554v-4.31h2.513v.531h-1.959v1.411h1.767v.52zM28.264 12.592c0 .11-.041.198-.117.28a.393.393 0 0 1-.56 0 .38.38 0 0 1-.116-.28.37.37 0 0 1 .116-.28.37.37 0 0 1 .28-.117c.11 0 .198.04.28.117a.38.38 0 0 1 .117.28m-.117 1.02v2.95h-.554v-2.95zM30.28 16.656q-.322 0-.594-.14a1.06 1.06 0 0 1-.414-.367h-.017v.408h-.53v-4.31h.553v1.36l-.023.407h.023q.141-.227.414-.367.27-.14.595-.14.583 0 .985.455a1.6 1.6 0 0 1 .414 1.114q-.002.657-.414 1.113a1.25 1.25 0 0 1-.991.467m-.087-.508c.263 0 .49-.099.67-.303.181-.198.269-.449.269-.764q.001-.465-.268-.763a.87.87 0 0 0-.67-.304q-.404-.001-.677.304-.262.298-.262.764 0 .47.262.77a.88.88 0 0 0 .676.296M33.423 16.656a1.42 1.42 0 0 1-1.073-.443c-.28-.298-.42-.67-.42-1.126q-.001-.673.409-1.12a1.37 1.37 0 0 1 1.049-.448q.657-.001 1.043.425c.257.28.391.677.391 1.19l-.006.058h-2.314a.96.96 0 0 0 .291.7.94.94 0 0 0 .659.262c.35 0 .63-.175.828-.53l.495.239c-.134.25-.314.443-.548.583-.244.14-.507.21-.804.21m-.886-1.924h1.69a.73.73 0 0 0-.25-.508c-.152-.134-.35-.204-.607-.204q-.316 0-.536.193a.92.92 0 0 0-.297.519M35.766 16.557h-.553v-2.945h.53v.478h.023a.8.8 0 0 1 .344-.402.95.95 0 0 1 .513-.163q.244 0 .409.07l-.17.536a.9.9 0 0 0-.326-.04c-.21 0-.39.08-.542.25a.87.87 0 0 0-.233.589v1.627z"
	})));
};

//#endregion
//#region src/ProviderIcon/icons/GTT.svg
var _path$79;
var _path2$52;
var _path3$29;
function _extends$82() {
	return _extends$82 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$82.apply(null, arguments);
}
var SvgGtt = function SvgGtt(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$82({
		xmlns: "http://www.w3.org/2000/svg",
		width: 40,
		height: 40,
		fill: "none",
		viewBox: "0 0 40 40"
	}, props), _path$79 || (_path$79 = /*#__PURE__*/ React.createElement("path", {
		fill: "#FDB913",
		d: "M30.183 15.034c0 .826.667 1.497 1.491 1.497s1.492-.67 1.492-1.497-.667-1.497-1.491-1.497-1.492.67-1.492 1.497M33.167 16.738c0 .826.667 1.497 1.491 1.497s1.492-.67 1.492-1.497-.668-1.497-1.492-1.497-1.491.67-1.491 1.497M30.132 18.494c0 .827.667 1.497 1.491 1.497s1.492-.67 1.492-1.497-.668-1.498-1.492-1.498-1.492.67-1.492 1.498"
	})), _path2$52 || (_path2$52 = /*#__PURE__*/ React.createElement("path", {
		fill: "#003863",
		d: "M12.128 21.775a2.01 2.01 0 0 1-2.008-2.015c0-1.113.899-2.016 2.008-2.016s2.007.903 2.007 2.016a2.01 2.01 0 0 1-2.008 2.015m4.068-3.746h.228l.846-2.53h-5.967c-.862 0-3.653.734-3.653 3.77 0 3.304 2.675 4.44 3.653 4.49.977.052 3.172 1.23 2.314 3.047-.887 1.88-3.19 1.447-4.321-.413L7.7 28.097s2.315 3.15 5.66 2.117c3.343-1.033 3.755-5.472 1.491-7.332 0 0 2.887-1.187 1.344-4.853"
	})), _path3$29 || (_path3$29 = /*#__PURE__*/ React.createElement("path", {
		fill: "#003863",
		d: "M26.543 15.508v-4.03l-2.53 1.47v2.56h-2.75v-4.03l-2.53 1.47v2.54h-.823l-.843 2.519h1.666v4.272s-.462 3.405 4.337 3.405v-2.358s-1.767.12-1.767-1.41v-3.89h2.71v4.253s-.461 3.405 4.338 3.405v-2.358s-1.768.12-1.768-1.41v-3.89h1.827v-2.518z"
	})));
};

//#endregion
//#region src/ProviderIcon/icons/HughesNet.svg
var _path$78;
function _extends$81() {
	return _extends$81 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$81.apply(null, arguments);
}
var SvgHughesNet = function SvgHughesNet(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$81({
		xmlns: "http://www.w3.org/2000/svg",
		width: 40,
		height: 40,
		fill: "none",
		viewBox: "0 0 40 40"
	}, props), _path$78 || (_path$78 = /*#__PURE__*/ React.createElement("path", {
		fill: "#0091C4",
		d: "M5.84 19.882H4.245v1.697H2.9v-4.447h1.346v1.574H5.84v-1.574h1.347v4.447H5.839zM10.059 21.218c-.19.209-.54.437-1.11.437-.749 0-1.071-.446-1.071-1.006v-2.294h1.204v1.792c0 .322.17.455.465.455.265 0 .407-.142.502-.256v-1.991h1.204v3.224H10.06zM12.315 21.55c.247.247.617.351.958.351.284 0 .749-.104.749-.673v-.17c-.275.312-.569.435-.91.435-.778 0-1.413-.502-1.413-1.611 0-1.072.616-1.612 1.413-1.612.332 0 .644.113.91.417v-.341h1.204v2.872c0 1.394-1.147 1.65-1.944 1.65-.55 0-1.043-.142-1.47-.483zm1.707-2c-.114-.133-.341-.209-.493-.209-.322 0-.598.152-.598.55 0 .389.276.55.598.55.152 0 .38-.076.493-.209zM18.08 19.787c0-.332-.18-.446-.465-.446a.62.62 0 0 0-.512.256v1.991H15.9v-4.456h1.204v1.593c.19-.218.54-.446 1.11-.446.749 0 1.071.436 1.071 1.005v2.304H18.08zM21.474 18.28c.949 0 1.679.682 1.679 1.81v.247h-2.19c.066.208.303.407.71.407.276 0 .57-.104.73-.227l.494.74c-.323.274-.892.397-1.375.397-1.005 0-1.792-.635-1.792-1.697-.01-.929.71-1.678 1.744-1.678m-.521 1.298h1.062c-.038-.142-.142-.389-.531-.389a.51.51 0 0 0-.531.39M23.769 20.356c.256.199.796.407 1.157.407.246 0 .322-.066.322-.151 0-.105-.142-.143-.455-.19-.54-.076-1.375-.17-1.375-1.043 0-.578.503-1.1 1.441-1.1.54 0 1.024.17 1.394.417l-.436.778c-.2-.17-.569-.332-.948-.332-.17 0-.304.047-.304.142s.095.133.418.18c.54.076 1.412.19 1.412 1.09 0 .645-.569 1.11-1.526 1.11-.598 0-1.233-.209-1.584-.493zM27.751 18.336v3.243h-.777v-4.447h.796l2.276 3.157v-3.157h.777v4.447h-.749zM33.184 18.28c.967 0 1.584.739 1.584 1.753v.17h-2.485c.057.484.418.892 1.024.892.313 0 .683-.123.91-.35l.323.464c-.322.303-.797.465-1.309.465-.967 0-1.687-.674-1.687-1.698.01-.948.692-1.697 1.64-1.697m-.9 1.421h1.81c-.01-.379-.275-.853-.91-.853-.597 0-.872.465-.9.853M35.611 20.83V18.97h-.53v-.616h.53v-.872h.702v.881h.654v.617h-.654v1.688c0 .218.104.379.303.379a.47.47 0 0 0 .313-.114l.171.53c-.123.124-.332.21-.664.21-.54-.01-.825-.304-.825-.844"
	})));
};

//#endregion
//#region src/ProviderIcon/icons/Lumen.svg
var _path$77;
var _path2$51;
function _extends$80() {
	return _extends$80 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$80.apply(null, arguments);
}
var SvgLumen = function SvgLumen(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$80({
		xmlns: "http://www.w3.org/2000/svg",
		width: 40,
		height: 40,
		fill: "none",
		viewBox: "0 0 40 40"
	}, props), _path$77 || (_path$77 = /*#__PURE__*/ React.createElement("path", {
		fill: "#50ACDC",
		d: "M29.364 17.517c.17 0 .306.137.306.306v.175a.305.305 0 0 1-.306.306h-4.43a.05.05 0 0 1-.052-.051v-.43c0-.17.137-.306.306-.306z"
	})), _path2$51 || (_path2$51 = /*#__PURE__*/ React.createElement("path", {
		fill: "#17140A",
		d: "M28.344 19.577c.169 0 .306.136.306.305v.176a.305.305 0 0 1-.306.305h-2.64a.036.036 0 0 0-.036.036v1.041c0 .084.069.153.153.153h3.543c.17 0 .306.137.306.305v.176a.305.305 0 0 1-.306.306h-4.15a.33.33 0 0 1-.332-.331v-2.472zM21.84 17.672l-2.221 2.093-2.213-2.093a.567.567 0 0 0-.957.413v3.989c0 .169.138.306.308.306h.177c.17 0 .308-.137.308-.306v-3.387c0-.031.037-.047.06-.026l2.092 1.98c.063.059.144.087.225.084a.3.3 0 0 0 .224-.085l2.101-1.988a.036.036 0 0 1 .06.026v3.396c0 .169.138.306.309.306h.177c.17 0 .308-.137.308-.306v-3.989a.568.568 0 0 0-.958-.413M3.205 17.517a.306.306 0 0 0-.305.306v4.226a.33.33 0 0 0 .33.331h4.068a.305.305 0 0 0 .305-.305v-.176a.305.305 0 0 0-.305-.305h-3.46a.153.153 0 0 1-.152-.153v-3.618a.306.306 0 0 0-.305-.306zM8.742 17.823c0-.17.136-.306.305-.306h.175c.169 0 .306.137.306.306v2.91c0 .534.432.968.966.968h2.127a.967.967 0 0 0 .967-.968v-2.91c0-.17.137-.306.306-.306h.175c.169 0 .305.137.305.306v3.136c0 .844-.683 1.528-1.526 1.528h-2.58a1.527 1.527 0 0 1-1.526-1.528zM31.334 18.015v4.06c0 .169.136.305.305.305h.17a.305.305 0 0 0 .305-.305V18.81a.05.05 0 0 1 .084-.038l4.059 3.485a.51.51 0 0 0 .843-.388v-4.05a.305.305 0 0 0-.305-.306h-.178a.305.305 0 0 0-.305.305v3.197a.05.05 0 0 1-.084.039l-4.07-3.423a.502.502 0 0 0-.825.384"
	})));
};

//#endregion
//#region src/ProviderIcon/icons/Metronet.svg
var _path$76;
var _path2$50;
function _extends$79() {
	return _extends$79 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$79.apply(null, arguments);
}
var SvgMetronet = function SvgMetronet(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$79({
		xmlns: "http://www.w3.org/2000/svg",
		width: 40,
		height: 40,
		fill: "none",
		viewBox: "0 0 40 40"
	}, props), _path$76 || (_path$76 = /*#__PURE__*/ React.createElement("path", {
		fill: "#9645FD",
		d: "M21.878 19.913c0-4.16 2.472-6.296 6.157-6.296s6.164 2.115 6.164 6.296v4.972a1.501 1.501 0 0 1-3.002 0v-4.972c0-2.368-1.262-3.5-3.154-3.5s-3.156 1.132-3.156 3.5v4.972a1.497 1.497 0 0 1-1.5 1.497 1.503 1.503 0 0 1-1.501-1.497z"
	})), _path2$50 || (_path2$50 = /*#__PURE__*/ React.createElement("path", {
		fill: "#00C900",
		d: "M5.8 19.156c0-3.902 2.271-5.663 5.225-5.663 1.867 0 3.406.779 4.315 2.24.884-1.461 2.421-2.24 4.315-2.24 2.952 0 5.223 1.76 5.223 5.663v5.854a1.495 1.495 0 0 1-1.501 1.497 1.503 1.503 0 0 1-1.501-1.497v-5.854c0-2.038-1.06-2.87-2.524-2.87-1.443 0-2.498.856-2.498 2.87v5.854a1.496 1.496 0 0 1-1.501 1.497 1.51 1.51 0 0 1-1.388-.924 1.5 1.5 0 0 1-.115-.573v-5.854c0-2.014-1.085-2.87-2.524-2.87-1.438 0-2.522.832-2.522 2.87v5.854a1.495 1.495 0 0 1-.928 1.384 1.505 1.505 0 0 1-1.636-.325 1.5 1.5 0 0 1-.44-1.06z"
	})));
};

//#endregion
//#region src/ProviderIcon/icons/Monkeybrains.svg
var _path$75;
var _path2$49;
var _path3$28;
function _extends$78() {
	return _extends$78 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$78.apply(null, arguments);
}
var SvgMonkeybrains = function SvgMonkeybrains(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$78({
		xmlns: "http://www.w3.org/2000/svg",
		width: 40,
		height: 40,
		fill: "none",
		viewBox: "0 0 40 40"
	}, props), _path$75 || (_path$75 = /*#__PURE__*/ React.createElement("path", {
		fill: "#EB262A",
		fillRule: "evenodd",
		d: "M19.49 5.759c-.238.008-.543.024-.678.036s-.39.04-.569.061c-.178.022-.456.062-.618.09s-.4.071-.53.098c-.129.027-.394.09-.588.138-.194.05-.508.137-.696.195a16 16 0 0 0-.689.231c-.19.07-.508.195-.706.279a16 16 0 0 0-1.598.802 17.108 17.108 0 0 0-1.354.9c-.15.113-.397.309-.549.435-.15.126-.39.335-.532.464a16 16 0 0 0-1.087 1.107c-.113.13-.295.345-.403.48a17 17 0 0 0-.659.884c-.07.102-.203.305-.295.45a17 17 0 0 0-.334.56 17 17 0 0 0-.633 1.256c-.062.14-.17.401-.24.58-.07.177-.188.504-.262.725-.073.222-.178.57-.233.775s-.13.515-.167.687-.095.477-.127.675c-.033.198-.077.516-.098.706s-.048.47-.059.621-.025.47-.032.707c-.008.25-.004.63.01.902.012.26.04.644.061.854.022.21.062.528.089.707s.08.478.119.667c.037.189.107.493.154.677.047.183.131.484.187.667a16 16 0 0 0 .51 1.405 18 18 0 0 0 .74 1.49c.097.167.258.435.36.594.102.16.282.427.4.593.12.167.327.442.463.613s.36.438.5.594a17 17 0 0 0 1.109 1.12c.113.102.308.27.433.375.124.104.375.302.558.44.182.138.508.368.724.51s.543.345.726.45a18 18 0 0 0 1.373.696c.13.056.324.138.432.181a15.92 15.92 0 0 0 1.095.387c.175.054.472.138.661.186.189.049.471.115.628.147a16.1 16.1 0 0 0 1.687.249c.178.017.615.036.971.042.403.007.796.002 1.04-.012.216-.013.52-.037.677-.053a16.084 16.084 0 0 0 1.462-.226 16.722 16.722 0 0 0 1.219-.313c.18-.055.452-.144.604-.198s.43-.161.62-.237c.188-.076.5-.212.69-.3.192-.09.484-.236.648-.325s.438-.244.607-.345c.17-.1.445-.275.613-.388s.409-.282.536-.376.32-.243.427-.33c.108-.086.324-.267.48-.403a17.41 17.41 0 0 0 1.333-1.326c.123-.14.33-.387.459-.55.13-.161.339-.44.465-.618.127-.178.303-.438.393-.579s.245-.399.347-.575a17 17 0 0 0 .672-1.327c.063-.142.165-.385.227-.542a17 17 0 0 0 .497-1.5c.044-.162.11-.435.149-.606a16 16 0 0 0 .215-1.2c.016-.118.043-.348.059-.51s.04-.489.052-.726c.015-.265.019-.64.011-.971a17 17 0 0 0-.042-.884 20 20 0 0 0-.07-.656 17 17 0 0 0-.088-.599 16.19 16.19 0 0 0-.324-1.427 18 18 0 0 0-.208-.673 17 17 0 0 0-.448-1.168 14.514 14.514 0 0 0-.838-1.626 16 16 0 0 0-.69-1.043 18 18 0 0 0-.81-1.016 18 18 0 0 0-1.164-1.18 19 19 0 0 0-.51-.444 16 16 0 0 0-1.022-.77 16 16 0 0 0-.483-.316c-.131-.082-.37-.223-.53-.314a17 17 0 0 0-1.24-.625c-.146-.065-.41-.175-.584-.243a17 17 0 0 0-.696-.252c-.209-.07-.543-.17-.742-.225-.2-.054-.508-.13-.685-.17-.177-.039-.5-.1-.716-.136a17 17 0 0 0-.758-.106c-.2-.022-.513-.05-.696-.06-.184-.01-.48-.023-.657-.026-.178-.004-.518-.001-.756.007m.185.96c.022.011.094.165.189.402.084.21.16.38.17.377s.087-.176.17-.384.164-.387.18-.397.166-.017.335-.018.321.005.338.012.031.031.031.055-.154.39-.343.811l-.343.767v.452c0 .384-.005.456-.031.482s-.085.031-.334.031c-.276 0-.306-.003-.342-.04-.037-.036-.039-.064-.039-.49v-.452l-.343-.764c-.19-.42-.344-.776-.344-.79s.01-.037.024-.05c.016-.017.119-.024.335-.024.17 0 .327.009.347.02m-1.17.063q.032.026.072.231c.022.113.041.235.043.27s-.007.075-.018.086c-.012.012-.232.06-.49.108a17 17 0 0 0-.5.097.08.08 0 0 0-.046.048.4.4 0 0 0 .002.128.3.3 0 0 0 .041.118.12.12 0 0 0 .074.028c.024 0 .163-.022.307-.049a4 4 0 0 1 .315-.049c.028 0 .061.012.073.027a2.617 2.617 0 0 1 .1.506c0 .032-.014.062-.034.073s-.17.044-.336.073c-.175.032-.318.068-.34.086-.034.028-.038.046-.025.136.008.062.03.12.053.143s.055.035.077.03c.02-.006.245-.048.499-.094.426-.078.464-.082.493-.052.02.019.05.127.077.273.025.133.04.257.035.275-.006.02-.043.043-.082.055-.04.01-.412.082-.827.157-.415.076-.77.132-.79.126s-.035-.022-.036-.034-.01-.009-.02.01c-.01.018-.157.087-.326.153-.193.076-.323.116-.35.11a4 4 0 0 1-.398-.267 5 5 0 0 0-.374-.255c-.01 0-.028.029-.04.064-.01.035-.029.1-.04.145-.02.075-.014.1.066.314.076.201.084.238.062.272-.015.023-.124.077-.266.133-.21.082-.246.09-.28.068-.025-.017-.18-.395-.478-1.163-.242-.627-.437-1.16-.434-1.187.004-.043.032-.06.23-.141.124-.05.25-.093.28-.093q.052-.002.08.042c.016.025.088.201.161.393s.142.346.152.343c.011-.004.08-.236.155-.516s.147-.52.161-.535a2 2 0 0 1 .302-.132c.152-.059.3-.107.327-.107s.056.014.063.03c.006.017-.065.316-.158.665-.093.348-.169.646-.168.661 0 .015.285.232.632.482s.634.453.635.451c.001-.001-.093-.524-.21-1.16a43 43 0 0 1-.214-1.213q-.001-.054.044-.074c.024-.011.393-.085.819-.164.426-.08.784-.146.796-.147.011-.001.035.009.054.022m3.597.073c.226.042.454.088.508.1.053.014.16.053.236.088.077.034.176.096.22.136s.106.123.135.184c.046.094.056.141.062.307.004.133-.003.24-.024.33-.018.073-.05.17-.073.216a1 1 0 0 1-.117.174c-.067.08-.073.094-.046.116a.5.5 0 0 1 .077.117c.026.05.052.135.06.188a.7.7 0 0 1-.02.229 1.2 1.2 0 0 1-.079.228.6.6 0 0 1-.122.158.6.6 0 0 1-.181.092 1 1 0 0 1-.324.021 6 6 0 0 1-.708-.101c-.27-.05-.51-.1-.534-.11-.034-.014-.044-.034-.044-.084 0-.036.092-.564.206-1.173l.218-1.172a.2.2 0 0 1 .04-.093.1.1 0 0 1 .064-.028c.02 0 .22.034.446.077m2.366.601c.24.093.494.199.565.236s.171.11.223.16c.053.051.117.14.144.198.028.06.053.158.059.227a.8.8 0 0 1-.032.287c-.023.09-.081.246-.13.344a.8.8 0 0 1-.392.412c-.065.024-.089.045-.089.073 0 .022.023.22.05.44.029.221.046.424.04.45a.11.11 0 0 1-.066.068c-.044.017-.09.007-.275-.062a1.6 1.6 0 0 1-.258-.114c-.03-.027-.044-.1-.08-.444a10 10 0 0 0-.05-.444c-.005-.017-.05-.047-.098-.066a.3.3 0 0 0-.134-.022c-.027.007-.059.039-.076.076a9 9 0 0 0-.125.316c-.062.164-.11.263-.138.28-.038.026-.063.021-.265-.053a1.6 1.6 0 0 1-.256-.112.1.1 0 0 1-.035-.074c0-.024.195-.55.434-1.17s.448-1.136.465-1.15a.1.1 0 0 1 .057-.024c.014 0 .222.076.462.168m-2.363.102a.7.7 0 0 0-.063.205c-.024.124-.028.182-.013.21.012.023.056.045.114.058.051.01.139.026.195.033a.5.5 0 0 0 .153 0c.036-.008.063-.038.09-.095a.5.5 0 0 0 .037-.192c0-.086-.008-.118-.039-.146a.7.7 0 0 0-.2-.071 2 2 0 0 0-.204-.036.1.1 0 0 0-.07.034m2.228.582a.6.6 0 0 0-.105.196c-.06.154-.062.171-.035.212.018.027.09.068.18.102a1 1 0 0 0 .21.057.17.17 0 0 0 .098-.037.42.42 0 0 0 .115-.277c0-.065-.01-.09-.05-.122a1 1 0 0 0-.206-.1 4 4 0 0 0-.16-.059.3.3 0 0 0-.047.028m-10.509.124c.022.02.328.495.68 1.057.351.562.64 1.04.64 1.062a.1.1 0 0 1-.035.069 5 5 0 0 1-.274.18c-.133.082-.262.15-.287.15-.03 0-.254-.15-.61-.405-.308-.222-.57-.4-.581-.397s.13.246.314.54c.204.324.335.552.335.582 0 .042-.035.07-.223.188a1.5 1.5 0 0 1-.254.139c-.017 0-.053-.029-.08-.064a61 61 0 0 1-.646-1.017c-.328-.524-.607-.972-.62-.995a.2.2 0 0 1-.022-.082c0-.03.044-.07.162-.145l.286-.18c.108-.066.131-.073.177-.056.03.011.291.19.582.399.291.208.54.387.552.397s.028.01.033.001c.006-.008-.14-.254-.322-.544s-.332-.549-.332-.573c0-.026.025-.063.064-.092a4 4 0 0 1 .408-.248c.008 0 .032.015.053.034m12.857.194c.059.017.164.06.234.096.07.035.183.105.25.156.068.05.153.13.19.174.036.045.086.121.11.17a.65.65 0 0 1 .03.442c-.019.063-.06.168-.093.233s-.262.447-.51.85c-.348.565-.462.735-.498.744q-.047.012-.14-.043a9 9 0 0 1-.227-.14c-.094-.06-.132-.096-.132-.125a1 1 0 0 1 .108-.222c.06-.1.108-.19.108-.2 0-.012-.02-.039-.044-.06a2 2 0 0 0-.178-.121.6.6 0 0 0-.182-.082c-.04 0-.07.033-.167.184a1 1 0 0 1-.148.197c-.016.006-.049.001-.072-.01a7 7 0 0 1-.234-.14c-.167-.102-.191-.124-.191-.17q0-.055.45-.785c.248-.402.481-.773.52-.825.037-.052.107-.13.155-.174a1 1 0 0 1 .152-.114 1 1 0 0 1 .115-.049.84.84 0 0 1 .394.014m-4.777.13a.6.6 0 0 0-.048.152c-.015.085-.013.117.008.15s.066.049.2.074c.094.017.204.031.244.031.055 0 .082-.012.113-.052a.22.22 0 0 0 .04-.138.3.3 0 0 0-.018-.123.12.12 0 0 0-.054-.049 3 3 0 0 0-.219-.051 3 3 0 0 0-.21-.038c-.015 0-.04.02-.056.044m4.53.565a.3.3 0 0 0-.08.06c-.023.026-.101.143-.174.26-.09.148-.128.228-.12.256.006.025.075.081.18.146q.17.104.22.098c.044-.005.079-.049.205-.252q.152-.245.152-.304a.2.2 0 0 0-.03-.103.5.5 0 0 0-.116-.094 1 1 0 0 0-.142-.066.2.2 0 0 0-.095-.001m1.932.49c.151.12.197.168.197.204 0 .032-.24.345-.775 1.01-.681.846-.783.964-.83.964-.036 0-.11-.047-.239-.153-.159-.131-.186-.162-.186-.211 0-.046.151-.245.773-1.014.619-.768.78-.957.817-.957.028 0 .124.062.243.157m-16.545.264c.054.017.15.064.214.105.076.049.237.206.46.447.189.204.385.418.436.476s.12.159.152.226c.033.066.069.175.08.24a.7.7 0 0 1-.001.226c-.011.058-.048.162-.081.231a1.1 1.1 0 0 1-.223.288c-.129.128-.198.18-.335.247-.165.082-.18.086-.351.086-.167 0-.19-.005-.326-.073-.115-.057-.185-.112-.335-.264-.104-.106-.314-.33-.467-.497-.215-.236-.295-.338-.35-.45-.07-.14-.073-.156-.073-.344 0-.186.004-.205.068-.333.044-.087.117-.186.206-.277.076-.077.182-.17.236-.207s.151-.086.216-.11a.7.7 0 0 1 .247-.045c.07 0 .173.012.227.028m17.423.492c.116.124.22.243.23.263.012.028-.053.191-.272.677a8 8 0 0 0-.28.663c.003.013.205-.165.447-.395s.46-.432.485-.448q.044-.03.083-.013c.02.01.113.1.205.2s.168.195.168.212a.4.4 0 0 1-.104.135c-.056.058-.462.445-.901.862-.604.572-.811.758-.847.758s-.105-.061-.277-.247c-.194-.209-.228-.254-.218-.294.007-.026.136-.321.287-.656s.274-.619.274-.63q-.002-.019-.017-.015c-.01.004-.218.197-.463.429s-.457.428-.472.437c-.014.008-.047.004-.072-.008a1.6 1.6 0 0 1-.207-.195c-.092-.098-.162-.189-.162-.211 0-.027.297-.322.898-.894.717-.683.908-.855.95-.856.042 0 .095.045.265.226m-8.833-.03c.216.01.52.032.677.05.157.017.413.053.57.08.156.026.46.091.677.144.216.054.539.146.716.205.178.059.462.165.63.235a12 12 0 0 1 1.126.552 12 12 0 0 1 .959.633c.109.082.3.233.423.336a11 11 0 0 1 1.058 1.034c.114.13.28.33.367.442s.234.311.325.442c.092.131.24.36.33.51s.24.423.334.606c.093.184.21.43.26.55.05.118.089.215.087.215l-.45-.006c-.403-.005-.447-.01-.447-.039 0-.018-.039-.148-.086-.288a7 7 0 0 0-.173-.453 4 4 0 0 0-.203-.393 6 6 0 0 0-.57-.775 7 7 0 0 0-.367-.384 8 8 0 0 0-.424-.376 10 10 0 0 0-.41-.316 9 9 0 0 0-.455-.296 10 10 0 0 0-1.245-.618c-.13-.052-.377-.14-.55-.197a12 12 0 0 0-.628-.182 12 12 0 0 0-1.147-.228 14 14 0 0 0-.49-.06c-.157-.016-.512-.04-.789-.053a10 10 0 0 0-1.02 0c-.284.013-.645.037-.801.053a12.865 12.865 0 0 0-1.246.197 13 13 0 0 0-.56.137 12 12 0 0 0-.946.311c-.073.028-.254.105-.402.17a9 9 0 0 0-.476.23 8.335 8.335 0 0 0-1.462.998 7.015 7.015 0 0 0-.709.724c-.08.097-.202.256-.271.353-.07.097-.18.27-.246.385a4.5 4.5 0 0 0-.374.887c-.032.109-.06.2-.063.202-.002.002-.204.007-.447.011l-.443.007.059-.148c.032-.08.161-.35.286-.598s.306-.577.402-.73.252-.387.347-.52c.095-.132.275-.367.4-.52a11 11 0 0 1 1.036-1.082c.12-.107.32-.275.444-.374.123-.099.344-.262.49-.363.147-.102.393-.26.548-.353s.42-.24.589-.325.432-.208.584-.274a10.759 10.759 0 0 1 1.331-.45c.173-.043.407-.097.52-.12.114-.021.286-.053.383-.069s.304-.043.46-.061.43-.039.608-.047l.404-.017c.043-.002.255.005.47.016m-8.95.227a.44.44 0 0 0-.136.138c-.046.08-.05.097-.03.162.012.04.042.1.067.134s.176.204.335.377.32.332.355.354c.037.023.098.04.142.04.05 0 .1-.015.14-.045a.7.7 0 0 0 .104-.1.3.3 0 0 0 .05-.125c.008-.057-.003-.092-.047-.161a8.762 8.762 0 0 0-.65-.712.6.6 0 0 0-.132-.094.3.3 0 0 0-.083-.018.4.4 0 0 0-.116.05M10.917 12c.538.38.998.708 1.023.73s.044.057.044.077-.057.119-.126.218c-.07.1-.144.196-.165.216-.025.023-.055.031-.08.024a14 14 0 0 1-.65-.444 28 28 0 0 0-.618-.43q-.009.001-.01.016c0 .01.235.285.52.613.367.421.52.61.52.643a.5.5 0 0 1-.09.173.6.6 0 0 1-.133.147c-.036.016-.17-.03-.766-.267a14 14 0 0 0-.755-.285c-.024 0-.02.01.016.04.025.021.31.225.632.452.48.338.586.421.586.459a.4.4 0 0 1-.072.15l-.147.208c-.058.079-.088.104-.127.104-.035 0-.354-.215-1.036-.696-.542-.383-.996-.71-1.01-.726a.1.1 0 0 1-.017-.075c.005-.024.117-.196.249-.382.131-.185.255-.342.275-.348.021-.007.26.076.59.207.303.12.558.213.564.206.007-.006-.002-.027-.018-.046l-.362-.417c-.184-.21-.348-.406-.367-.434-.02-.031-.028-.066-.02-.088.008-.02.119-.185.246-.365.128-.18.248-.337.266-.348a.2.2 0 0 1 .048-.02c.007 0 .452.31.99.688m19.897.351c.067.031.171.103.23.16a1.4 1.4 0 0 1 .298.43c.022.048.051.135.065.193.014.06.021.168.016.258a.6.6 0 0 1-.07.278 1 1 0 0 1-.159.22c-.069.067-.113.095-.151.095-.043 0-.096-.042-.247-.196-.152-.154-.191-.204-.18-.233a.5.5 0 0 1 .068-.1.34.34 0 0 0 .067-.134.3.3 0 0 0-.02-.156.4.4 0 0 0-.1-.147c-.038-.033-.09-.06-.117-.06a.14.14 0 0 0-.088.04c-.029.028-.039.065-.039.137 0 .054.023.224.051.377.04.22.05.32.043.476a1 1 0 0 1-.053.309.8.8 0 0 1-.131.21.8.8 0 0 1-.2.153c-.102.05-.131.055-.329.055-.211 0-.22-.002-.366-.074a.9.9 0 0 1-.296-.23 1.2 1.2 0 0 1-.236-.338c-.049-.1-.1-.235-.112-.3a1 1 0 0 1-.012-.235.8.8 0 0 1 .081-.259.8.8 0 0 1 .179-.24q.108-.1.159-.1c.037 0 .1.048.234.18.138.135.184.193.183.23 0 .032-.025.076-.068.117a.3.3 0 0 0-.08.134.5.5 0 0 0-.002.138.4.4 0 0 0 .068.14c.03.038.077.085.103.104.027.019.07.04.098.046.035.008.066 0 .103-.03.048-.037.053-.054.053-.163 0-.067-.023-.232-.05-.367a1.6 1.6 0 0 1-.044-.45c.006-.157.018-.23.05-.3a1 1 0 0 1 .142-.199.7.7 0 0 1 .216-.158c.065-.028.155-.06.201-.07a1 1 0 0 1 .201-.007.8.8 0 0 1 .24.066m-13.382 1.56c.127.017.32.052.428.078s.281.078.385.115.263.104.353.148c.09.043.237.123.327.177.089.055.235.155.323.222.09.068.232.19.317.27.085.082.222.229.304.327.082.099.156.18.164.182a.5.5 0 0 0 .106-.11c.05-.063.175-.2.279-.306.104-.107.26-.25.346-.317.086-.068.227-.17.313-.226a4 4 0 0 1 .373-.207 5 5 0 0 1 .415-.173c.109-.038.299-.09.421-.118a5 5 0 0 1 .414-.07 5 5 0 0 1 .415-.021c.124 0 .334.014.467.031s.344.057.468.09c.124.031.327.098.451.147s.292.125.373.169a5 5 0 0 1 .559.365 4.3 4.3 0 0 1 .57.554c.069.082.184.237.255.343s.182.3.245.43.146.33.184.447.094.323.123.46c.05.235.054.283.054.742 0 .46-.003.506-.053.738-.029.137-.084.344-.123.461a4 4 0 0 1-.184.449c-.063.13-.168.315-.232.412a5 5 0 0 1-.263.354 5 5 0 0 1-.317.336 5 5 0 0 1-.332.282c-.09.067-.248.171-.353.232l-.191.111v.913c-.001.502-.01.992-.02 1.089a5.513 5.513 0 0 1-.156.798 6 6 0 0 1-.139.406 6 6 0 0 1-.197.435 6 6 0 0 1-.273.464 6 6 0 0 1-.31.42 6 6 0 0 1-.368.388c-.115.11-.308.274-.428.364s-.312.22-.425.288a6 6 0 0 1-.422.226c-.119.056-.33.141-.47.19-.141.048-.353.11-.472.139a7 7 0 0 1-.422.082 6 6 0 0 1-1.15.03 6 6 0 0 1-.458-.062 5.427 5.427 0 0 1-.884-.253c-.107-.043-.3-.13-.426-.194a6 6 0 0 1-.466-.271 6 6 0 0 1-.422-.31 6 6 0 0 1-.356-.328 6 6 0 0 1-.317-.354c-.08-.1-.206-.27-.278-.378a5.5 5.5 0 0 1-.508-1.024 6 6 0 0 1-.207-.82 7 7 0 0 1-.04-.354c-.011-.119-.02-.602-.02-1.074s-.007-.859-.016-.859-.111-.062-.228-.138a5 5 0 0 1-.322-.227 6 6 0 0 1-.314-.289 4 4 0 0 1-.348-.39 5 5 0 0 1-.257-.384 4 4 0 0 1-.208-.417 5 5 0 0 1-.163-.468 5 5 0 0 1-.1-.46 4 4 0 0 1-.033-.553c0-.184.01-.409.024-.5a4.418 4.418 0 0 1 .22-.853c.042-.11.117-.277.167-.375s.137-.247.193-.333a5 5 0 0 1 .222-.304 4.529 4.529 0 0 1 .687-.662c.088-.066.236-.165.328-.22.092-.056.241-.136.333-.178.091-.043.253-.108.36-.145s.295-.09.418-.118.294-.057.38-.067.274-.02.417-.02c.142-.002.363.01.49.027m-.661 1.807-.167.03a2 2 0 0 0-.245.06 2 2 0 0 0-.245.1 3 3 0 0 0-.253.148c-.074.049-.195.15-.27.223-.073.074-.18.203-.236.287a2.3 2.3 0 0 0-.175.319c-.04.091-.088.228-.108.304-.03.108-.037.208-.037.47 0 .287.006.358.044.501.025.092.089.255.142.363.054.11.155.27.229.361.072.09.203.221.29.29s.233.164.325.211c.091.047.237.108.324.135s.227.06.31.071c.085.012.203.021.265.021.06 0 .158-.006.215-.012l.104-.013-.01-.512c-.007-.282-.016-.774-.022-1.093l-.01-.581.815-.011c.45-.006.822-.016.829-.023a.7.7 0 0 0-.032-.183 2.3 2.3 0 0 0-.279-.626 2.3 2.3 0 0 0-.5-.497 2.4 2.4 0 0 0-.296-.17 1.928 1.928 0 0 0-.742-.173 2 2 0 0 0-.265 0m6.078.01a3 3 0 0 0-.23.047c-.065.017-.187.06-.271.096a2 2 0 0 0-.294.155c-.077.05-.206.153-.286.23a2 2 0 0 0-.248.286 3 3 0 0 0-.178.309 2.5 2.5 0 0 0-.12.328c-.04.145-.046.21-.045.5.002.305.006.35.055.51.03.098.088.249.13.336s.129.23.192.314c.063.085.166.202.23.26.062.057.166.14.231.183.065.044.19.114.277.155s.226.093.307.115c.082.023.232.049.334.058a2.3 2.3 0 0 0 .523-.016c.003 0 .005-.505.005-1.12v-1.12l.796.014.796.014-.013-.077a3 3 0 0 0-.071-.254 2 2 0 0 0-.128-.304 2.09 2.09 0 0 0-.354-.473 3 3 0 0 0-.195-.169 2.2 2.2 0 0 0-.608-.307 2 2 0 0 0-.324-.07 2 2 0 0 0-.28-.019c-.066.002-.17.01-.23.02m-11.04 1.946c0 .176.012.412.026.525s.022.21.02.213a.5.5 0 0 1-.118-.015 2 2 0 0 0-.248-.021 1.7 1.7 0 0 0-.586.12 1.8 1.8 0 0 0-.525.338 2 2 0 0 0-.356.536 3 3 0 0 0-.075.232 1.5 1.5 0 0 0-.032.393c0 .258.004.286.064.461.035.103.1.246.143.32.043.072.121.183.174.247.052.063.15.157.22.208a1.976 1.976 0 0 0 .605.291c.07.018.182.037.25.045l.123.013-.005-.488-.006-.487-.087-.015a1 1 0 0 1-.19-.066.6.6 0 0 1-.163-.118 1 1 0 0 1-.1-.147.8.8 0 0 1-.059-.18.6.6 0 0 1 0-.207 1 1 0 0 1 .05-.17 1 1 0 0 1 .1-.146.7.7 0 0 1 .195-.142c.119-.058.136-.061.298-.053.124.006.194.02.25.05a1 1 0 0 1 .141.1c.035.031.213.284.398.56l.335.505v1.68l-.143.06a4 4 0 0 1-.274.1c-.073.022-.21.056-.304.074a2.5 2.5 0 0 1-.456.034q-.284 0-.457-.034a4 4 0 0 1-.352-.092 3 3 0 0 1-.37-.159 3 3 0 0 1-.356-.224 3 3 0 0 1-.321-.288c-.086-.09-.201-.23-.257-.311a2.903 2.903 0 0 1-.328-.649 4 4 0 0 1-.083-.312 2.3 2.3 0 0 1-.036-.509c0-.26.009-.384.036-.51.02-.09.058-.232.086-.314.027-.08.091-.231.143-.334.051-.102.14-.252.196-.332s.17-.215.251-.3c.082-.086.218-.208.302-.271s.21-.148.28-.187c.072-.04.202-.103.29-.14.089-.038.245-.09.348-.116s.261-.055.353-.064.266-.018.387-.02l.221-.003zm17.168-.269c.09.017.235.053.321.08s.231.085.322.127c.09.043.239.127.33.187.09.06.244.186.341.278s.234.244.303.337a3 3 0 0 1 .38.727c.022.07.054.194.072.275s.037.28.042.444c.008.227.003.345-.023.5a3 3 0 0 1-.1.404 3 3 0 0 1-.128.324c-.034.068-.11.197-.168.287s-.188.247-.287.35c-.1.103-.25.24-.334.303a3 3 0 0 1-.809.402 4 4 0 0 1-.392.08q-.215.03-.434.018a3 3 0 0 1-.375-.04 2.7 2.7 0 0 1-.57-.18l-.122-.052v-1.668l.316-.483c.198-.303.355-.52.42-.584a.6.6 0 0 1 .198-.132 1 1 0 0 1 .234-.032c.117 0 .16.01.26.06a.8.8 0 0 1 .191.14.8.8 0 0 1 .114.17c.03.069.04.131.04.248 0 .118-.01.18-.04.248a.8.8 0 0 1-.116.173.7.7 0 0 1-.172.133.7.7 0 0 1-.188.062l-.09.013-.005.488-.005.488.137-.013c.076-.008.202-.032.28-.053.079-.022.213-.074.3-.117a2 2 0 0 0 .28-.176c.066-.054.171-.158.231-.23a2 2 0 0 0 .196-.31c.047-.096.105-.255.128-.352a1.2 1.2 0 0 0 .031-.413 2 2 0 0 0-.042-.353 1.906 1.906 0 0 0-.314-.604 2 2 0 0 0-.23-.229 2 2 0 0 0-.28-.176 2 2 0 0 0-.314-.121 1.3 1.3 0 0 0-.353-.045 3 3 0 0 0-.302.013l-.106.016.012-.075c.007-.04.022-.202.034-.359s.019-.363.015-.459l-.007-.174.307.012c.169.007.38.027.471.043m-9.063 2.616a4.4 4.4 0 0 1-.687.667 4.185 4.185 0 0 1-.662.399c-.12.054-.126.06-.104.1.012.025.094.116.182.203.087.087.215.197.284.243s.197.118.285.16c.088.04.201.085.252.099l.093.025v4.442l.23.015c.14.009.34.006.506-.008a5 5 0 0 0 .51-.07c.13-.027.342-.085.471-.13.13-.044.337-.131.462-.194.125-.062.293-.155.373-.207s.22-.152.312-.223.251-.214.354-.317.249-.27.326-.373c.076-.102.177-.248.224-.324a5 5 0 0 0 .187-.353c.056-.119.133-.308.171-.422s.087-.294.109-.402l.05-.26c.009-.054.004-.065-.033-.074l-.482-.099a8 8 0 0 0-.443-.083 3 3 0 0 0-.028.182c-.014.097-.059.28-.1.405a4 4 0 0 1-.15.373 4 4 0 0 1-.16.282 4 4 0 0 1-.217.291 3 3 0 0 1-.284.291 3.7 3.7 0 0 1-.606.42c-.051.026-.161.075-.245.108a3.6 3.6 0 0 1-.532.156c-.019 0-.024-.356-.024-1.714v-1.713l.113-.036a2.3 2.3 0 0 0 .544-.276c.065-.046.19-.16.28-.252.089-.093.162-.176.162-.185s-.1-.066-.221-.127a4 4 0 0 1-.388-.222 5 5 0 0 1-.298-.219 4.229 4.229 0 0 1-.69-.727 2 2 0 0 0-.126.15m-7.106 3.487c.03.119.09.313.133.432.042.12.116.3.163.403.047.102.129.265.181.362.053.097.16.274.237.393.078.118.216.308.306.422a8 8 0 0 0 .934.95c.132.11.335.266.452.349s.31.208.429.28a10 10 0 0 0 1.02.517c.13.055.38.148.557.208s.464.145.638.188.435.1.58.126c.146.026.386.062.532.079s.438.04.647.05c.241.012.521.012.772 0 .217-.01.54-.037.718-.06.178-.022.474-.07.657-.107a10 10 0 0 0 .639-.155c.167-.048.419-.13.559-.18s.364-.14.5-.198c.134-.059.351-.163.482-.232s.334-.183.451-.255.302-.194.409-.27c.108-.077.28-.208.383-.291s.287-.246.41-.363c.122-.116.306-.31.409-.429.103-.12.251-.306.33-.414.078-.107.192-.277.252-.377s.167-.293.236-.431.16-.348.205-.467a8 8 0 0 0 .15-.458c.038-.133.069-.255.069-.27s.006-.028.013-.028.094.026.193.058c.1.032.27.076.38.099.108.022.31.049.448.06.162.013.33.013.477.001.124-.01.228-.015.232-.012.003.004-.04.116-.095.249a11 11 0 0 1-.54 1.086 11.392 11.392 0 0 1-.608.923c-.088.12-.252.326-.364.46a10.608 10.608 0 0 1-1.017 1.04c-.14.121-.35.295-.467.386a11 11 0 0 1-.997.678c-.118.07-.326.186-.46.257a11 11 0 0 1-.534.256c-.158.07-.418.176-.579.235s-.396.139-.526.177c-.13.04-.363.102-.52.14a12 12 0 0 1-.55.117 13 13 0 0 1-.629.093c-.314.038-.457.044-1.097.044-.58 0-.798-.006-1.03-.034a11.785 11.785 0 0 1-1.148-.193 11 11 0 0 1-.97-.275 11 11 0 0 1-.907-.366 11 11 0 0 1-.52-.26c-.143-.079-.372-.21-.506-.294-.136-.084-.36-.233-.5-.332-.139-.1-.36-.268-.493-.376a9.77 9.77 0 0 1-1.616-1.666 12 12 0 0 1-.349-.49 11 11 0 0 1-.327-.527 13 13 0 0 1-.277-.515c-.07-.139-.18-.378-.245-.53a3 3 0 0 1-.113-.284c.003-.003.11.001.237.01a4 4 0 0 0 .477-.001c.136-.01.335-.035.443-.057.108-.023.272-.066.366-.097s.182-.055.196-.053c.016.002.048.086.082.219m.966 5.051c.113.074.21.15.217.167a.1.1 0 0 1 0 .066c-.008.019-.238.372-.513.784-.4.602-.496.758-.486.795.008.031.127.121.394.298.214.141.387.27.394.291.009.027-.03.102-.137.262-.124.187-.157.224-.198.224-.031 0-.284-.156-.698-.433-.646-.431-.65-.434-.641-.496.005-.04.24-.409.69-1.077.576-.86.688-1.016.727-1.016.025 0 .138.06.251.135m13.112 0a1 1 0 0 1 .224.16 1.784 1.784 0 0 1 .337.505.7.7 0 0 1 .045.28c0 .145-.006.18-.055.272-.03.059-.1.153-.153.21a2 2 0 0 1-.272.224.8.8 0 0 0-.187.16c-.009.028.043.12.186.332.109.161.197.304.197.317a.1.1 0 0 1-.015.048 2 2 0 0 1-.219.162 1.3 1.3 0 0 1-.237.139c-.017 0-.05-.02-.072-.044a48 48 0 0 1-.693-1.006c-.36-.53-.662-.985-.673-1.014-.015-.04-.014-.06.006-.085.015-.017.19-.142.39-.278s.41-.272.466-.304.15-.075.207-.095a.8.8 0 0 1 .252-.039c.122 0 .167.01.267.056m-.53.712a.8.8 0 0 0-.17.14c-.018.032-.002.067.094.207.063.094.13.173.15.177.02.003.11-.042.198-.101.114-.076.17-.127.189-.172.024-.059.022-.072-.03-.17a.6.6 0 0 0-.104-.144.2.2 0 0 0-.113-.038c-.045 0-.11.03-.214.101m-10.95.223c.074.015.218.068.319.117.13.064.216.123.3.205a.8.8 0 0 1 .169.226c.032.07.054.16.061.252.007.098 0 .18-.022.27-.018.07-.126.334-.24.588s-.236.514-.27.578a1.3 1.3 0 0 1-.165.23.8.8 0 0 1-.213.166.6.6 0 0 1-.266.062 1.2 1.2 0 0 1-.267-.014 2 2 0 0 1-.311-.12 1.1 1.1 0 0 1-.31-.204.9.9 0 0 1-.162-.221c-.047-.1-.054-.138-.054-.31 0-.136.01-.228.035-.299.019-.056.131-.316.25-.578.12-.262.24-.516.268-.564s.087-.126.13-.174a1 1 0 0 1 .168-.137 1 1 0 0 1 .178-.076 1 1 0 0 1 .178-.025c.048 0 .15.012.224.028m9.547.01c.058.01.15.04.207.066a1 1 0 0 1 .194.132c.05.046.114.121.14.168q.05.083.037.124c-.007.023-.106.111-.22.197a1.3 1.3 0 0 1-.24.156c-.018 0-.067-.035-.11-.079a.4.4 0 0 0-.15-.098.3.3 0 0 0-.128-.007.396.396 0 0 0-.201.11.16.16 0 0 0-.04.093c0 .027.007.06.015.072a.2.2 0 0 0 .064.049c.038.02.128.026.402.022a3 3 0 0 1 .514.022c.1.018.206.053.28.092.065.035.15.097.187.139.037.04.09.12.118.175a.6.6 0 0 1 .062.232c.008.089 0 .17-.021.258-.018.07-.061.175-.096.233a1.2 1.2 0 0 1-.18.212c-.073.066-.187.14-.295.194a2 2 0 0 1-.314.118 1 1 0 0 1-.288.022.7.7 0 0 1-.26-.06.92.92 0 0 1-.38-.355c-.026-.05-.04-.105-.035-.124a1.2 1.2 0 0 1 .214-.186c.111-.084.219-.153.238-.153.02 0 .078.044.129.097.065.068.114.101.164.11.039.008.1.008.137.001a.46.46 0 0 0 .259-.19.2.2 0 0 0 .02-.108.17.17 0 0 0-.065-.081c-.047-.03-.097-.034-.442-.028a3 3 0 0 1-.5-.017 1.3 1.3 0 0 1-.194-.06.76.76 0 0 1-.31-.283 1 1 0 0 1-.082-.21.75.75 0 0 1 .223-.743c.068-.062.183-.137.29-.188a1.6 1.6 0 0 1 .313-.113c.076-.015.16-.028.189-.03a1 1 0 0 1 .155.018m-1.534.566c.015.01.19.545.388 1.19s.36 1.188.36 1.208-.02.05-.044.065a2 2 0 0 1-.248.09 1 1 0 0 1-.247.052c-.024-.006-.054-.036-.066-.066a90 90 0 0 1-.365-1.175 34 34 0 0 1-.344-1.16.1.1 0 0 1 .027-.062c.014-.012.122-.052.24-.089s.227-.068.243-.068.042.006.056.015m-8.26.091a.4.4 0 0 0-.109.122 7 7 0 0 0-.215.447 9 9 0 0 0-.18.42.5.5 0 0 0-.023.13c0 .034.019.086.042.115a.4.4 0 0 0 .112.088c.04.02.096.042.126.05a.2.2 0 0 0 .121-.016.3.3 0 0 0 .118-.104c.027-.042.121-.23.208-.419a7 7 0 0 0 .198-.46.4.4 0 0 0 .028-.177.25.25 0 0 0-.065-.113.5.5 0 0 0-.127-.082.4.4 0 0 0-.127-.03.3.3 0 0 0-.107.03m2.196.02c.085.018.23.07.331.118a.73.73 0 0 1 .449.584c.008.051.008.15 0 .222q-.014.127-.05.165c-.031.032-.061.034-.277.025-.159-.007-.258-.02-.287-.038-.037-.024-.044-.044-.044-.147a.4.4 0 0 0-.033-.176.26.26 0 0 0-.095-.085.6.6 0 0 0-.143-.042.3.3 0 0 0-.141.012.3.3 0 0 0-.109.107 3 3 0 0 0-.145.458c-.053.206-.107.427-.12.491-.017.09-.017.133 0 .187a.25.25 0 0 0 .078.109c.03.021.094.048.144.061a.25.25 0 0 0 .16 0c.052-.017.084-.047.123-.115.029-.05.066-.107.082-.126a.1.1 0 0 1 .065-.035c.02 0 .11.037.197.081s.194.102.235.128c.046.03.075.062.075.087a.7.7 0 0 1-.059.17c-.033.07-.09.167-.127.212a.8.8 0 0 1-.162.144.798.798 0 0 1-.505.114 2 2 0 0 1-.275-.044 2 2 0 0 1-.259-.1.85.85 0 0 1-.382-.374.8.8 0 0 1-.051-.29c-.009-.194-.006-.206.14-.782.106-.41.17-.624.217-.716.037-.072.105-.17.152-.216a.8.8 0 0 1 .163-.126c.043-.022.114-.052.157-.066a1 1 0 0 1 .212-.026c.073 0 .201.013.284.03m2.038.334c.082.017.195.052.252.077a.8.8 0 0 1 .186.12.7.7 0 0 1 .127.164c.025.05.055.136.067.193.012.058.022.158.022.224 0 .065-.035.5-.078.965-.043.466-.083.866-.089.89a.1.1 0 0 1-.047.064c-.025.013-.115.011-.287-.006-.205-.021-.254-.032-.277-.064-.017-.023-.024-.064-.018-.106.006-.038.016-.131.022-.208.01-.112.007-.145-.018-.17-.02-.019-.084-.036-.164-.043l-.201-.023c-.042-.005-.083.001-.106.018-.03.023-.043.07-.062.249-.015.143-.033.227-.05.239a.6.6 0 0 1-.194.007 6 6 0 0 1-.261-.023c-.067-.009-.103-.025-.123-.055-.024-.037-.017-.155.06-.964.052-.546.1-.965.12-1.029a1.4 1.4 0 0 1 .077-.197.75.75 0 0 1 .279-.277c.03-.012.094-.034.142-.047.049-.014.175-.026.28-.027.106 0 .26.012.341.03m1.361.068c.02.01.042.048.048.083s.041.44.08.898c.037.459.073.854.078.878a.08.08 0 0 0 .06.056c.028.007.22-.001.427-.019s.414-.032.46-.032c.07 0 .087.008.102.048.01.026.024.156.031.29.012.202.01.246-.015.266-.02.016-.304.048-.793.09-.44.038-.781.059-.806.05q-.043-.016-.054-.08a80 80 0 0 1-.11-1.25c-.097-1.148-.099-1.187-.064-1.22.027-.027.088-.04.242-.054l.241-.021a.2.2 0 0 1 .073.017m-1.81.63a.2.2 0 0 0-.055.057 2 2 0 0 0-.048.317c-.017.175-.021.29-.01.311.01.019.033.04.051.047a2 2 0 0 0 .234.024c.186.012.203.01.221-.025.012-.021.032-.163.046-.316.019-.215.02-.289.001-.329a.2.2 0 0 0-.091-.08.6.6 0 0 0-.192-.027.5.5 0 0 0-.157.02",
		clipRule: "evenodd"
	})), _path2$49 || (_path2$49 = /*#__PURE__*/ React.createElement("path", {
		fill: "#000",
		fillRule: "evenodd",
		d: "M20.638 11.748a14.305 14.305 0 0 1 1.167.11c.114.016.326.051.471.078a10.937 10.937 0 0 1 1.306.333c.183.06.443.155.578.209s.369.158.52.23c.15.072.372.187.49.255.119.067.34.205.49.306.152.1.395.278.54.395s.385.332.53.478c.147.146.344.362.44.48a4.883 4.883 0 0 1 .539.81 5.325 5.325 0 0 1 .318.803l.044.164h.375c.223 0 .456.012.579.03.113.016.287.05.386.077s.268.08.373.12c.107.039.276.114.377.168s.251.143.334.198c.082.055.211.15.287.212a4.2 4.2 0 0 1 .561.578c.05.065.133.184.185.265s.14.244.198.363.134.309.172.422.086.295.108.402.05.314.061.457c.016.19.016.329 0 .52-.012.143-.04.348-.061.456-.022.108-.07.287-.106.397-.037.11-.112.295-.167.411a4 4 0 0 1-.515.793c-.07.081-.201.216-.291.3a4 4 0 0 1-.342.277c-.097.07-.258.172-.358.228-.1.055-.277.14-.394.186a4 4 0 0 1-.401.134 3.167 3.167 0 0 1-1.004.105 3.2 3.2 0 0 1-.58-.051 5 5 0 0 1-.392-.1 1.3 1.3 0 0 0-.191-.052 3 3 0 0 0-.064.22 7 7 0 0 1-.127.417 5.5 5.5 0 0 1-.588 1.17 7 7 0 0 1-.305.422 7.6 7.6 0 0 1-.924.942 8 8 0 0 1-.431.335c-.112.08-.319.214-.46.3a9 9 0 0 1-1.187.588 10 10 0 0 1-.903.296c-.102.028-.31.077-.46.109a10 10 0 0 1-.56.097c-.156.022-.415.05-.575.063-.183.014-.5.019-.854.012-.32-.006-.677-.024-.827-.042a13 13 0 0 1-.55-.08 10 10 0 0 1-.589-.126 10 10 0 0 1-.53-.149 10 10 0 0 1-.5-.18 10 10 0 0 1-.51-.221 9 9 0 0 1-.442-.226 8.397 8.397 0 0 1-1.028-.69 9 9 0 0 1-.479-.43 7 7 0 0 1-.41-.43 6.271 6.271 0 0 1-.547-.751 7 7 0 0 1-.216-.385 7 7 0 0 1-.173-.383 5.596 5.596 0 0 1-.238-.72 1 1 0 0 0-.047-.153c-.008-.009-.099.01-.201.043s-.278.08-.39.104c-.18.04-.259.045-.674.045s-.495-.006-.677-.045a4.233 4.233 0 0 1-.873-.296 4 4 0 0 1-.353-.198 6 6 0 0 1-.314-.225 4 4 0 0 1-.622-.64 5 5 0 0 1-.193-.283 3.933 3.933 0 0 1-.35-.757 5 5 0 0 1-.1-.387 5 5 0 0 1-.062-.454 3 3 0 0 1 0-.512c.012-.141.04-.346.062-.456.023-.11.072-.296.11-.415a4 4 0 0 1 .473-.934c.074-.105.248-.302.397-.451a4.4 4.4 0 0 1 .451-.397 4.285 4.285 0 0 1 .944-.475 5 5 0 0 1 .422-.111c.174-.035.301-.045.68-.052l.465-.01.041-.14a7 7 0 0 1 .102-.315 5 5 0 0 1 .44-.885c.065-.097.18-.256.256-.353s.216-.262.312-.366c.096-.105.258-.268.36-.362a8 8 0 0 1 .726-.59 8 8 0 0 1 .422-.276c.14-.085.348-.205.461-.265a9 9 0 0 1 .946-.425 11 11 0 0 1 1.14-.355 12 12 0 0 1 1.053-.205 14.817 14.817 0 0 1 1.099-.107c.167-.009.454-.018.638-.02.183 0 .501.007.706.018m-4.17 2.17c-.112.016-.295.05-.406.077a4 4 0 0 0-.392.12c-.106.039-.285.118-.398.174a5 5 0 0 0-.382.22 4.27 4.27 0 0 0-.63.518 6 6 0 0 0-.214.242c-.062.075-.17.222-.238.326-.07.105-.178.3-.242.434a5 5 0 0 0-.184.45 4 4 0 0 0-.108.403c-.022.107-.05.28-.06.384-.012.105-.022.279-.022.386s.01.286.021.398.039.287.06.39c.023.102.072.283.11.402s.115.313.171.432c.056.118.149.29.205.382.057.091.162.241.234.333s.215.252.317.355.275.253.383.334c.108.08.264.186.347.235l.15.087.009 1.021c.006.83.014 1.057.04 1.217a5.656 5.656 0 0 0 .232.903c.044.119.135.33.204.47.069.141.188.353.265.472s.208.3.29.402c.08.103.252.29.379.416.127.125.335.307.462.402.128.096.309.221.403.278s.298.164.451.238.37.165.478.203a6 6 0 0 0 .91.223c.17.026.343.035.688.035s.518-.009.686-.035c.124-.02.334-.061.467-.094.133-.032.331-.09.441-.128s.304-.117.431-.174.33-.163.451-.236a6 6 0 0 0 .44-.296c.12-.09.313-.254.429-.364s.28-.285.367-.389a6 6 0 0 0 .307-.413 6 6 0 0 0 .274-.465c.067-.131.16-.339.208-.46a5 5 0 0 0 .249-.9c.039-.208.043-.305.05-1.251l.01-1.026.042-.03c.023-.016.113-.071.2-.122.086-.051.226-.145.311-.21a5 5 0 0 0 .322-.274c.093-.087.234-.237.315-.335.081-.097.2-.256.264-.353a4 4 0 0 0 .21-.363c.051-.102.124-.27.163-.373.038-.102.092-.274.119-.383a3.347 3.347 0 0 0 .106-1.05 3.3 3.3 0 0 0-.053-.616 5 5 0 0 0-.121-.452 5 5 0 0 0-.185-.459 4 4 0 0 0-.231-.412 5 5 0 0 0-.244-.337 4.413 4.413 0 0 0-.668-.643 5 5 0 0 0-.327-.22 4 4 0 0 0-.333-.178 5 5 0 0 0-.36-.144 5 5 0 0 0-.419-.117 5 5 0 0 0-.414-.07 5 5 0 0 0-.412-.021c-.122 0-.3.01-.398.02a5 5 0 0 0-.373.06c-.107.022-.288.07-.402.108-.113.038-.314.12-.447.185a5 5 0 0 0-.412.227c-.094.062-.222.151-.285.2a4.1 4.1 0 0 0-.591.582 1 1 0 0 1-.157.167.6.6 0 0 1-.119-.128 4.574 4.574 0 0 0-.691-.67 5 5 0 0 0-.328-.221 4 4 0 0 0-.34-.18 4.34 4.34 0 0 0-.81-.27 5 5 0 0 0-.376-.06 5 5 0 0 0-.441-.018 4 4 0 0 0-.457.03m.99 1.861c.106.027.266.085.355.128s.23.13.316.193.21.176.28.25c.068.076.167.208.22.294.054.086.124.227.158.314.033.086.072.21.085.275.014.064.018.125.01.134-.009.01-.38.022-.825.028l-.81.01.014.64c.007.352.013.842.014 1.088 0 .247-.003.453-.008.457a1.4 1.4 0 0 1-.203.02c-.141.01-.251.003-.396-.02a3 3 0 0 1-.332-.08 2 2 0 0 1-.24-.099 3 3 0 0 1-.24-.142 2.3 2.3 0 0 1-.56-.592 2 2 0 0 1-.159-.325 3 3 0 0 1-.09-.311 2 2 0 0 1-.03-.377c0-.13.013-.29.03-.376a3 3 0 0 1 .091-.313 2.1 2.1 0 0 1 .353-.596c.047-.056.153-.156.237-.223a2.4 2.4 0 0 1 .324-.213 2.4 2.4 0 0 1 .338-.142c.092-.028.225-.06.295-.07.07-.009.229-.013.353-.01.155.006.286.024.42.058m5.956-.038c.103.015.25.05.328.076a3 3 0 0 1 .294.129c.085.043.226.137.315.207.09.072.218.2.29.29.07.089.167.237.214.329.047.091.109.24.137.33.028.089.05.19.05.223v.061l-1.569-.027v1.108c0 .825-.006 1.112-.023 1.123a1 1 0 0 1-.181.028 2.1 2.1 0 0 1-.669-.06 2 2 0 0 1-.353-.137 2.4 2.4 0 0 1-.357-.225 2 2 0 0 1-.258-.246 3 3 0 0 1-.187-.26 2 2 0 0 1-.148-.292 3 3 0 0 1-.094-.285c-.026-.101-.034-.214-.033-.458 0-.295.006-.34.054-.5.03-.098.084-.242.12-.32.038-.08.113-.21.169-.29.055-.08.166-.208.247-.285s.208-.179.284-.228.194-.114.262-.145a2.2 2.2 0 0 1 .531-.153 2 2 0 0 1 .254-.02c.075 0 .22.01.323.027M11.27 17.374a3.254 3.254 0 0 0-.576.117 3 3 0 0 0-.32.126c-.088.042-.24.13-.337.194a3 3 0 0 0-.342.28c-.091.09-.219.234-.283.322a3 3 0 0 0-.217.353 3 3 0 0 0-.158.37 3 3 0 0 0-.093.373 3 3 0 0 0 0 .874c.017.102.063.279.1.392.039.113.11.28.158.372s.138.235.198.32a3.1 3.1 0 0 0 .634.617 3 3 0 0 0 .304.178c.086.043.22.101.3.13.078.028.232.07.343.093.15.031.271.042.485.043q.284 0 .456-.033c.094-.018.231-.052.304-.074.073-.023.197-.068.275-.1l.142-.06v-1.69l-.337-.507a7 7 0 0 0-.397-.559 1 1 0 0 0-.159-.097.5.5 0 0 0-.255-.046.5.5 0 0 0-.257.047.7.7 0 0 0-.174.12.8.8 0 0 0-.126.185.5.5 0 0 0-.05.266c0 .117.01.18.04.247.023.049.071.122.107.163a.645.645 0 0 0 .357.201l.094.012v.98l-.123-.013a1.83 1.83 0 0 1-.538-.146 2 2 0 0 1-.237-.135 2 2 0 0 1-.261-.234 1.5 1.5 0 0 1-.238-.33 2 2 0 0 1-.133-.323 1.704 1.704 0 0 1-.042-.648 2 2 0 0 1 .079-.307c.03-.089.096-.228.147-.31a2 2 0 0 1 .218-.276c.07-.07.192-.17.273-.223.08-.053.22-.122.31-.155.089-.032.23-.07.315-.083a1.844 1.844 0 0 1 .56.013c.043.012.046.008.035-.044a4 4 0 0 1-.032-.273 6 6 0 0 1-.02-.476v-.26l-.22.004a7 7 0 0 0-.31.01m16.925.4c-.007.231-.018.472-.025.534l-.013.114.057-.016c.03-.008.167-.014.302-.013.18.002.284.013.395.043a1.9 1.9 0 0 1 .525.245c.047.032.138.111.202.175s.154.175.2.247.108.184.135.25c.027.064.065.174.084.245.025.09.035.2.036.382 0 .207-.009.285-.044.412a2 2 0 0 1-.137.332c-.059.112-.14.227-.227.32-.075.08-.19.184-.255.23a2 2 0 0 1-.222.136 2 2 0 0 1-.27.1 1.6 1.6 0 0 1-.3.055l-.132.005v-.961l.09-.013a.7.7 0 0 0 .187-.062.7.7 0 0 0 .172-.133.8.8 0 0 0 .117-.173.53.53 0 0 0 .041-.248.55.55 0 0 0-.197-.46.7.7 0 0 0-.197-.126.9.9 0 0 0-.232-.031.5.5 0 0 0-.226.04 1 1 0 0 0-.153.09c-.036.027-.196.245-.355.484a21 21 0 0 0-.343.525l-.052.09v1.67l.142.06c.078.032.199.077.268.1.07.022.202.056.294.074.115.023.263.033.463.032.225 0 .342-.01.495-.043.11-.023.265-.065.344-.093s.23-.096.336-.15c.107-.055.265-.152.353-.217a3 3 0 0 0 .297-.26c.075-.077.177-.194.226-.26a2.787 2.787 0 0 0 .336-.602c.033-.087.082-.241.11-.344.04-.152.05-.248.058-.52a2.4 2.4 0 0 0-.022-.52 3 3 0 0 0-.1-.386 3 3 0 0 0-.129-.324 4 4 0 0 0-.168-.287 3 3 0 0 0-.287-.35 4 4 0 0 0-.33-.3 2.8 2.8 0 0 0-.68-.362 3 3 0 0 0-.336-.09 4 4 0 0 0-.507-.053l-.314-.013zm-7.982 2.311c.098.118.251.28.34.36s.217.186.281.235c.065.05.171.124.236.165s.222.13.35.196l.232.12-.102.123a2 2 0 0 1-.237.233 3 3 0 0 1-.297.205 2 2 0 0 1-.324.147l-.162.052v1.714c0 1.357.005 1.713.025 1.713a3.37 3.37 0 0 0 .858-.31 3.42 3.42 0 0 0 .53-.378 3 3 0 0 0 .484-.558c.044-.065.12-.198.168-.295s.117-.26.151-.363c.035-.102.078-.279.097-.391a.8.8 0 0 1 .053-.21c.01-.003.226.037.48.088.424.086.46.096.466.136a1.5 1.5 0 0 1-.036.254 5 5 0 0 1-.11.417c-.037.114-.12.316-.184.449a5 5 0 0 1-.241.432 5 5 0 0 1-.244.336 4.4 4.4 0 0 1-.648.625c-.09.068-.231.166-.315.218a5 5 0 0 1-.298.168 4.4 4.4 0 0 1-.657.258 5 5 0 0 1-.352.086c-.108.022-.32.05-.471.062a3 3 0 0 1-.501.004l-.226-.018-.01-4.437-.113-.034a2 2 0 0 1-.273-.112 2.3 2.3 0 0 1-.319-.197 1.98 1.98 0 0 1-.4-.403c-.012-.02.016-.042.116-.086a4 4 0 0 0 .659-.396 4.388 4.388 0 0 0 .687-.666c.067-.085.123-.155.125-.155s.084.096.182.213",
		clipRule: "evenodd"
	})), _path3$28 || (_path3$28 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		fillRule: "evenodd",
		d: "M16.472 13.913c-.113.016-.296.05-.407.076a4 4 0 0 0-.392.12c-.106.04-.285.118-.398.175a5 5 0 0 0-.383.22 4.273 4.273 0 0 0-.63.518 6 6 0 0 0-.213.242 4 4 0 0 0-.238.326c-.07.105-.178.3-.242.434a5 5 0 0 0-.184.45 4 4 0 0 0-.108.403 5 5 0 0 0-.06.384 4 4 0 0 0-.022.386c0 .107.01.286.021.398s.039.287.06.39c.023.102.072.283.11.402s.115.313.171.432c.056.118.149.29.205.382.057.09.162.241.234.333s.215.252.317.355.275.253.383.334c.108.08.264.186.347.235l.15.087.009 1.021c.006.83.014 1.057.04 1.217a5.629 5.629 0 0 0 .232.903c.044.118.135.33.204.47.069.141.188.353.265.472.078.118.208.3.29.402.08.102.252.29.379.415.127.126.335.308.463.403.127.096.308.221.402.278s.298.164.451.238.37.165.478.203a6 6 0 0 0 .91.223c.17.026.343.035.688.035s.518-.009.686-.035c.124-.02.334-.061.467-.094.133-.032.331-.09.441-.128a6 6 0 0 0 .431-.174c.127-.057.33-.164.451-.236a6 6 0 0 0 .44-.296c.12-.09.313-.254.429-.365s.28-.285.367-.388.224-.289.307-.413c.084-.124.207-.333.274-.465s.16-.34.208-.461a5 5 0 0 0 .249-.899c.039-.208.043-.305.05-1.251l.01-1.026.042-.03c.023-.016.113-.071.2-.122.086-.051.226-.145.311-.21.085-.063.23-.187.322-.274s.234-.238.315-.335.2-.256.264-.353.158-.26.21-.363a5 5 0 0 0 .163-.373c.038-.102.092-.275.119-.383s.064-.297.082-.421c.026-.177.03-.314.023-.628a3.3 3.3 0 0 0-.052-.618 5 5 0 0 0-.121-.451 5 5 0 0 0-.185-.46 4 4 0 0 0-.231-.411 5 5 0 0 0-.244-.337 4.41 4.41 0 0 0-.668-.643 5 5 0 0 0-.327-.22 4 4 0 0 0-.333-.178 5 5 0 0 0-.36-.144 5 5 0 0 0-.419-.117 5 5 0 0 0-.414-.07 5 5 0 0 0-.412-.021c-.122 0-.3.009-.398.02a5 5 0 0 0-.373.06c-.107.022-.288.07-.402.108-.113.037-.314.12-.447.184a5 5 0 0 0-.412.228c-.094.061-.222.15-.285.199a4.133 4.133 0 0 0-.591.582 1 1 0 0 1-.157.168.6.6 0 0 1-.119-.128 4.555 4.555 0 0 0-.691-.67 5 5 0 0 0-.328-.221 4 4 0 0 0-.34-.18 4.34 4.34 0 0 0-.81-.27 5 5 0 0 0-.376-.06 5 5 0 0 0-.441-.018 4 4 0 0 0-.457.03m.988 1.86c.107.028.267.086.356.129s.23.13.316.193.21.176.28.25c.068.076.167.207.22.294.054.086.124.227.158.314.033.086.072.21.085.275.014.064.018.125.01.134-.009.01-.38.022-.825.028l-.81.01.014.64c.007.352.013.842.014 1.088 0 .247-.003.453-.008.457a1.4 1.4 0 0 1-.203.02c-.141.01-.251.003-.396-.02a3 3 0 0 1-.332-.08 2 2 0 0 1-.24-.099 3 3 0 0 1-.24-.142 2.3 2.3 0 0 1-.56-.592 2 2 0 0 1-.159-.326 3 3 0 0 1-.09-.31 2 2 0 0 1-.03-.377c0-.13.013-.29.03-.376a3 3 0 0 1 .091-.313 2.1 2.1 0 0 1 .353-.596c.047-.056.153-.156.237-.223.083-.068.229-.163.324-.213.094-.05.247-.114.338-.142s.225-.06.295-.07.229-.014.353-.01c.155.006.286.024.42.058m5.957-.038c.103.016.25.05.328.077s.21.085.294.128c.085.044.226.138.315.208.09.072.218.2.29.29.07.089.167.237.214.329.047.091.109.24.137.33.028.089.05.19.05.223v.061l-1.569-.027v1.108c0 .825-.006 1.112-.023 1.123a1 1 0 0 1-.181.028 2.1 2.1 0 0 1-.669-.06 2 2 0 0 1-.353-.137 2.4 2.4 0 0 1-.357-.225 2 2 0 0 1-.258-.246 3 3 0 0 1-.187-.26 2 2 0 0 1-.148-.292 3 3 0 0 1-.094-.285c-.026-.102-.034-.214-.033-.458 0-.295.006-.34.054-.5.03-.098.084-.242.12-.32.038-.08.113-.21.169-.29a2 2 0 0 1 .247-.285c.08-.076.208-.179.284-.228s.194-.114.262-.145a2.2 2.2 0 0 1 .531-.154c.064-.009.178-.018.254-.019.075-.001.22.01.323.026M11.273 17.37a3.247 3.247 0 0 0-.576.117 3 3 0 0 0-.32.126c-.088.042-.24.13-.337.194-.096.065-.25.19-.342.28-.091.09-.219.234-.283.322a3 3 0 0 0-.217.353 3 3 0 0 0-.158.37 3 3 0 0 0-.093.373 3 3 0 0 0 0 .874c.017.102.063.279.1.392.039.113.11.28.158.372s.138.235.198.32a3.2 3.2 0 0 0 .634.616c.08.055.218.135.304.178.086.044.22.102.3.13.078.028.232.07.343.094.15.031.271.042.485.043q.284 0 .456-.033c.094-.018.231-.052.304-.074.073-.023.197-.068.275-.1l.142-.06v-1.69l-.337-.507a7 7 0 0 0-.397-.56 1 1 0 0 0-.159-.096.5.5 0 0 0-.255-.046.5.5 0 0 0-.257.047.7.7 0 0 0-.174.12.8.8 0 0 0-.126.184.5.5 0 0 0-.05.267c0 .117.01.18.04.246.023.05.071.123.107.164a.645.645 0 0 0 .357.201l.094.012v.98l-.123-.014a1.842 1.842 0 0 1-.538-.145 2 2 0 0 1-.237-.135 2 2 0 0 1-.261-.234 1.5 1.5 0 0 1-.238-.33 2 2 0 0 1-.133-.323 1.705 1.705 0 0 1-.042-.648 2 2 0 0 1 .079-.307c.03-.089.096-.228.147-.31s.15-.206.218-.276c.07-.07.192-.17.273-.223.08-.053.22-.122.31-.155.089-.032.23-.07.315-.083a1.844 1.844 0 0 1 .56.013c.043.012.046.008.035-.044a4 4 0 0 1-.032-.273 6 6 0 0 1-.02-.476v-.26l-.22.004c-.122.001-.26.006-.31.01m16.925.4c-.007.231-.018.472-.025.534l-.013.114.057-.016c.03-.008.167-.014.302-.013.18.002.284.013.395.043a1.9 1.9 0 0 1 .525.245c.047.032.138.111.202.175s.154.175.2.247.108.184.135.25c.027.064.065.174.084.245.025.09.035.2.036.382 0 .207-.009.285-.044.412a2 2 0 0 1-.137.332c-.059.112-.14.227-.227.32-.075.08-.19.184-.255.23a2 2 0 0 1-.222.136 2 2 0 0 1-.27.1 1.6 1.6 0 0 1-.3.055l-.132.005v-.961l.09-.013a.7.7 0 0 0 .187-.063.7.7 0 0 0 .172-.132.8.8 0 0 0 .117-.173.5.5 0 0 0 .041-.248c0-.122-.01-.18-.046-.26a.682.682 0 0 0-.348-.326.9.9 0 0 0-.232-.032.5.5 0 0 0-.226.04 1 1 0 0 0-.153.09c-.036.028-.196.246-.355.485-.16.24-.314.475-.343.525l-.052.09v1.67l.142.06c.078.032.199.077.268.1.07.022.202.056.294.074.115.022.263.033.463.032.225 0 .342-.01.495-.043a3 3 0 0 0 .344-.093 3.034 3.034 0 0 0 .69-.367 3 3 0 0 0 .296-.26c.075-.077.177-.194.225-.26a2.78 2.78 0 0 0 .336-.602c.034-.087.084-.241.11-.344.04-.152.051-.248.06-.52a2.4 2.4 0 0 0-.023-.52 3 3 0 0 0-.1-.386 3 3 0 0 0-.129-.324 4 4 0 0 0-.168-.287 3 3 0 0 0-.287-.35 4 4 0 0 0-.33-.3 2.8 2.8 0 0 0-.68-.362 3 3 0 0 0-.336-.09 4 4 0 0 0-.507-.053l-.314-.013zm-7.982 2.311c.098.118.251.28.34.36s.217.186.281.235c.065.05.171.123.236.165s.222.13.35.196l.232.12-.102.123a2 2 0 0 1-.237.233 3 3 0 0 1-.297.205 2 2 0 0 1-.324.146l-.162.053v1.713c0 1.358.005 1.714.025 1.714a3.37 3.37 0 0 0 .858-.31 3.42 3.42 0 0 0 .53-.377 3 3 0 0 0 .484-.56c.044-.064.12-.197.168-.294s.117-.26.151-.363a3 3 0 0 0 .097-.391.7.7 0 0 1 .053-.21c.01-.003.226.037.48.088.424.086.46.096.466.136a1.5 1.5 0 0 1-.036.254 5 5 0 0 1-.11.417 4 4 0 0 1-.184.449 5 5 0 0 1-.241.432 5 5 0 0 1-.244.336 4.4 4.4 0 0 1-.648.625c-.09.068-.231.166-.315.218a5 5 0 0 1-.298.168 4.4 4.4 0 0 1-.657.258 5 5 0 0 1-.352.086c-.108.022-.32.05-.471.062a3 3 0 0 1-.501.004l-.226-.018-.01-4.437-.113-.034a2 2 0 0 1-.273-.112 2.3 2.3 0 0 1-.319-.197 1.954 1.954 0 0 1-.4-.403c-.012-.021.016-.042.116-.087a4 4 0 0 0 .659-.396 4.391 4.391 0 0 0 .687-.666c.067-.085.123-.154.125-.154s.084.096.182.213",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/ProviderIcon/icons/Pilot.svg
var _path$74;
function _extends$77() {
	return _extends$77 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$77.apply(null, arguments);
}
var SvgPilot = function SvgPilot(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$77({
		xmlns: "http://www.w3.org/2000/svg",
		width: 40,
		height: 40,
		fill: "none",
		viewBox: "0 0 40 40"
	}, props), _path$74 || (_path$74 = /*#__PURE__*/ React.createElement("path", {
		fill: "#000",
		d: "M15.238 17.171a.725.725 0 0 0 .727-.723c0-.4-.325-.723-.727-.723a.725.725 0 0 0-.728.723c0 .4.326.723.728.723M15.825 18.778h-1.849v.777h.96v4.667h.89zM10.106 15.81h-2.93v8.412h.93V20.98h2c1.548 0 2.509-1.204 2.509-2.587 0-1.382-.96-2.583-2.509-2.583m0 4.275h-2v-3.391h2c.968 0 1.527.805 1.527 1.7s-.56 1.702-1.527 1.702zM25.074 18.725c-1.663 0-2.677 1.29-2.677 2.775s1.015 2.775 2.677 2.775 2.677-1.29 2.677-2.775c0-1.486-1.007-2.775-2.677-2.775m0 4.752c-1.121 0-1.767-.937-1.767-1.977s.646-1.977 1.767-1.977c1.122 0 1.792.95 1.792 1.977 0 1.026-.663 1.977-1.792 1.977M20.885 23.424c-.738 0-1.344-.282-1.344-1.425V15.81h-1.856v.797h.964v5.38c0 1.75 1.028 2.234 2.236 2.234h.785v-.798zM30.693 19.576h2.132v-.798h-2.132v-1.867h-.627l-.262 1.856h-1.146v.798h1.146v2.412c0 1.75 1.029 2.234 2.236 2.234h.782v-.787h-.782c-.738 0-1.347-.282-1.347-1.425z"
	})));
};

//#endregion
//#region src/ProviderIcon/icons/RCN.svg
var _path$73;
var _path2$48;
var _path3$27;
function _extends$76() {
	return _extends$76 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$76.apply(null, arguments);
}
var SvgRcn = function SvgRcn(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$76({
		xmlns: "http://www.w3.org/2000/svg",
		width: 40,
		height: 40,
		fill: "none",
		viewBox: "0 0 40 40"
	}, props), _path$73 || (_path$73 = /*#__PURE__*/ React.createElement("path", {
		fill: "#472F91",
		d: "M20.805 20.269c.897-2.868 2.728-4.274 5.547-4.201 1.099.036 1.63.164 1.923.219l-.696 2.356c-.256-.055-.732-.146-1.63-.183-.951-.018-1.519.348-1.995 1.882s-.165 1.918.824 1.954a14 14 0 0 0 1.74-.073l-.715 2.393c-.311.055-1.208.091-2.179.055-2.838-.073-3.698-1.534-2.82-4.402m-3.516-2.302h-.769l-.44 1.516h.788c.733 0 1.007-.09 1.209-.748.183-.676-.129-.768-.788-.768m1.154-1.79c2.398.073 2.691 1.188 2.453 2.466-.238 1.37-1.226 1.973-2.16 2.32.293.183.476.493.53 1.096l.257 2.539H16.43l-.11-2.758c0-.384-.146-.567-.531-.585h-.256l-1.007 3.343H11.54l2.326-7.781s.146-.658.933-.658zm16.68 0c-.788 0-.934.658-.934.658l-1.099 3.653-.586-4.31h-2.728c-.787 0-.933.657-.933.657l-2.326 7.781h2.966l1.355-4.512.586 4.512h3.15l2.526-8.439z"
	})), _path2$48 || (_path2$48 = /*#__PURE__*/ React.createElement("path", {
		fill: "#37B34A",
		d: "M12.694 17.438c-.75-.384-1.63-.603-2.655-.621-1.703-.019-3.406.09-5.566 1.223-.476.256-.934.567-1.245 1.005-.623.84-.293 1.827.44 2.21 1.537-.237 7.872-2.922 9.026-3.817"
	})), _path3$27 || (_path3$27 = /*#__PURE__*/ React.createElement("path", {
		fill: "#472F91",
		d: "M10.039 16.524c.842 0 1.593.146 2.289.42-.092-.11-.202-.219-.33-.347-1.044-1.077-2.746-2.83-4.962-3.141-2.215-.292-4.101.968-2.783 3.817l.22.439c2.142-1.096 3.863-1.188 5.328-1.188z"
	})));
};

//#endregion
//#region src/ProviderIcon/icons/Sonic.svg
var _path$72;
var _path2$47;
function _extends$75() {
	return _extends$75 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$75.apply(null, arguments);
}
var SvgSonic = function SvgSonic(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$75({
		xmlns: "http://www.w3.org/2000/svg",
		width: 40,
		height: 40,
		fill: "none",
		viewBox: "0 0 40 40"
	}, props), _path$72 || (_path$72 = /*#__PURE__*/ React.createElement("path", {
		fill: "#505256",
		d: "M34.5 21.74a2.77 2.77 0 1 1-.064-3.555l.654-.612a3.664 3.664 0 1 0 .102 4.733zM18.085 16.5v7.004l.887-.002v-6.116h2.144c1.315 0 2.424 1.09 2.424 2.382v3.737l.884-.002V19.79c0-1.813-1.485-3.29-3.31-3.29zM2.9 22.607a4.37 4.37 0 0 0 2.802 1.002c1.484 0 2.442-.788 2.442-2.007v-.02c0-1.043-.603-1.576-2.226-1.971-1.328-.317-1.92-.59-1.92-1.371v-.022c0-.642.582-1.09 1.418-1.09.657 0 1.302.223 1.967.68l.46-.65c-.71-.522-1.48-.766-2.405-.766-1.37 0-2.326.799-2.326 1.943v.022c0 1.229.778 1.642 2.311 2.012 1.39.32 1.837.646 1.837 1.34v.02c0 .685-.613 1.144-1.525 1.144-.844 0-1.566-.273-2.319-.88zm23.294.896h.885V16.5h-.885z"
	})), _path2$47 || (_path2$47 = /*#__PURE__*/ React.createElement("path", {
		fill: "#52AEE5",
		d: "M12.86 22.769a2.77 2.77 0 1 1 0-5.539 2.77 2.77 0 0 1 0 5.539m0-6.433a3.664 3.664 0 1 0 0 7.329 3.664 3.664 0 0 0 0-7.33M37.1 23.05a.55.55 0 1 1-1.102 0 .55.55 0 0 1 1.102 0"
	})));
};

//#endregion
//#region src/ProviderIcon/icons/Spectrum.svg
var _path$71;
var _path2$46;
function _extends$74() {
	return _extends$74 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$74.apply(null, arguments);
}
var SvgSpectrum = function SvgSpectrum(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$74({
		xmlns: "http://www.w3.org/2000/svg",
		width: 40,
		height: 40,
		fill: "none",
		viewBox: "0 0 40 40"
	}, props), _path$71 || (_path$71 = /*#__PURE__*/ React.createElement("path", {
		fill: "#0076BC",
		d: "M34.81 18.523v3.475l2.29-1.737z"
	})), _path2$46 || (_path2$46 = /*#__PURE__*/ React.createElement("path", {
		fill: "#77787B",
		d: "M8.584 23.037c0 .28-.218.536-.536.536h-.535V19.65c.062-1.043.441-1.875 2.027-1.932.685.009 1.183.281 1.477.625.315.41.45.919.45 1.56q0 .99-.473 1.606-.473.6-1.213.599c-.74 0-1.1-.309-1.198-.366zm1.796-3.088c0-.41-.075-1.276-.914-1.276-.796 0-.882.846-.882 1.276 0 1.09.62 1.23.914 1.23.76 0 .882-.808.882-1.23M3.527 21.647q.533.454 1.598.454 1.035 0 1.6-.438.563-.471.564-1.317a1.46 1.46 0 0 0-.173-.721c-.11-.2-.3-.39-.527-.504a2.3 2.3 0 0 0-.411-.159 82 82 0 0 0-1.245-.345c-.533-.13-.871-.307-.873-.622.027-.61.595-.658.909-.658q.485 0 .768.203c.337.263.3.597.3.597H7.1q-.03-.785-.564-1.27-.518-.44-1.473-.44-1.02 0-1.552.424-.533.439-.533 1.207c.002.657.314 1.045.596 1.222.171.103.561.26 1.066.36l.423.093c.735.18 1.157.406 1.144.77-.008.22-.083.387-.25.502-.154.104-.414.172-.737.172q-.549 0-.862-.22-.3-.187-.36-.658H2.9q.046.894.627 1.348M13.629 18.643c.673-.01.778.564.799.846h-1.599s-.013-.831.8-.846m.047 2.523c-.272-.013-.789-.067-.836-.971h2.716v-.326c-.018-.682-.182-1.19-.501-1.571q-.517-.564-1.458-.564-.893 0-1.395.58-.486.564-.486 1.567 0 1.05.502 1.614.502.58 1.395.58.736 0 1.222-.36.487-.345.66-1.005h-.944c-.139.395-.493.476-.875.456M31.866 22.003h-1.087v-2.678c0-.309-.127-.725-.74-.725-.602 0-.725.473-.725.725v2.678h-1.103v-2.458c0-.714.212-1.15.56-1.433.344-.28.784-.373 1.236-.394q.363 0 .709.079t.63.315q.236-.205.56-.291a2.6 2.6 0 0 1 .669-.103c1.345-.007 1.885.609 1.93.806v3.479h-.623c-.157 0-.535-.107-.535-.536v-2.142c.003-.304-.104-.725-.74-.725-.631 0-.741.473-.741.725zM18.551 20.712h1.03s-.28 1.363-1.836 1.363-1.94-1.248-1.94-2.07c0-.82.147-2.222 1.88-2.27a1.774 1.774 0 0 1 1.865 1.363h-1.097s-.106-.47-.76-.455c-.652.015-.823.628-.823 1.211s.145 1.312.87 1.312c.69.021.75-.351.811-.454M24.268 17.827h1.097v2.664s-.04.721.721.721c.718 0 .736-.644.736-.69v-2.178s.037-.517.513-.517h.57V20.3c-.008.135.143 1.775-1.819 1.768-1.944 0-1.806-1.658-1.818-1.756zM20.911 18.942h.644v-1.099h-.642v-.705c0-.194-.108-.533-.518-.533h-.564v4.608c0 .481.186.768.59.768h.49zM22.704 21.99v-2.148q-.001-.47.22-.69.218-.22.673-.22h.36V17.82s-.567-.014-.98.11c-.264.08-.498.188-.696.345q-.314.25-.494.666t-.18 1.026v2.022z"
	})));
};

//#endregion
//#region src/ProviderIcon/icons/TMobile.svg
var _path$70;
var _path2$45;
function _extends$73() {
	return _extends$73 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$73.apply(null, arguments);
}
var SvgTMobile = function SvgTMobile(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$73({
		xmlns: "http://www.w3.org/2000/svg",
		width: 40,
		height: 40,
		fill: "none",
		viewBox: "0 0 40 40"
	}, props), _path$70 || (_path$70 = /*#__PURE__*/ React.createElement("path", {
		fill: "#ED008C",
		d: "M21.507 10.526h.488c3.148 0 4.616 1.685 5.229 6.176l.975-.043-.13-7.126H12.048l-.158 7.126.938.043c.163-1.684.357-2.591.78-3.498.748-1.685 2.308-2.678 4.226-2.678h.683v15.505c0 1.641-.098 2.16-.488 2.548-.325.302-.975.432-1.723.432h-.748v1.036h8.907v-1.036h-.752c-.743 0-1.398-.13-1.718-.432-.39-.389-.488-.907-.488-2.548z"
	})), _path2$45 || (_path2$45 = /*#__PURE__*/ React.createElement("path", {
		fill: "#999B9E",
		d: "M28.317 18.895H24.21v4.193h4.108zM15.749 18.895H11.64v4.193h4.109z"
	})));
};

//#endregion
//#region src/ProviderIcon/icons/Unknown.svg
var _path$69;
function _extends$72() {
	return _extends$72 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$72.apply(null, arguments);
}
var SvgUnknown = function SvgUnknown(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$72({
		xmlns: "http://www.w3.org/2000/svg",
		width: 40,
		height: 40,
		fill: "none",
		viewBox: "0 0 40 40"
	}, props), _path$69 || (_path$69 = /*#__PURE__*/ React.createElement("path", {
		fill: "#66687A",
		fillRule: "evenodd",
		d: "M28.75 20a8.75 8.75 0 1 1-17.5 0 8.75 8.75 0 0 1 17.5 0m-6.424.656c.126 0 .226.106.216.231A11.32 11.32 0 0 1 20.168 27a.21.21 0 0 1-.334 0 11.32 11.32 0 0 1-2.375-6.113.215.215 0 0 1 .216-.23zm1.754 0a.22.22 0 0 0-.22.207 12.64 12.64 0 0 1-1.945 5.935c-.107.168.04.383.232.325a7.45 7.45 0 0 0 5.237-6.23.214.214 0 0 0-.214-.237zm3.304-1.55a.214.214 0 0 1-.214.238h-3.09a.22.22 0 0 1-.22-.208 12.64 12.64 0 0 0-1.944-5.934c-.108-.168.04-.383.23-.325a7.45 7.45 0 0 1 5.238 6.229m-4.841.006a.215.215 0 0 1-.216.232h-4.653a.215.215 0 0 1-.216-.232c.169-2.172.96-4.305 2.375-6.112a.21.21 0 0 1 .334 0 11.32 11.32 0 0 1 2.375 6.113m-6.623.232a.22.22 0 0 0 .22-.208 12.64 12.64 0 0 1 1.944-5.934c.108-.168-.04-.383-.23-.325a7.45 7.45 0 0 0-5.238 6.229.214.214 0 0 0 .214.238zm-3.09 1.312c-.129 0-.23.11-.214.238a7.45 7.45 0 0 0 5.238 6.23c.19.056.338-.158.23-.326a12.64 12.64 0 0 1-1.944-5.934.22.22 0 0 0-.22-.208z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/ProviderIcon/icons/Verizon.svg
var _path$68;
var _path2$44;
function _extends$71() {
	return _extends$71 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$71.apply(null, arguments);
}
var SvgVerizon = function SvgVerizon(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$71({
		xmlns: "http://www.w3.org/2000/svg",
		width: 40,
		height: 40,
		fill: "none",
		viewBox: "0 0 40 40"
	}, props), _path$68 || (_path$68 = /*#__PURE__*/ React.createElement("path", {
		fill: "#D52B1E",
		d: "m36.345 16.223-1.868 3.982-.702-1.509h-.76l1.155 2.468h.614l2.316-4.94z"
	})), _path2$44 || (_path2$44 = /*#__PURE__*/ React.createElement("path", {
		fill: "#000",
		d: "M28.331 23.616h1.504v-2.742c0-.628.365-1.068.906-1.068.52 0 .79.363.79.886v2.924h1.505v-3.209c0-1.089-.656-1.856-1.718-1.856-.676 0-1.15.29-1.504.82h-.03v-.675h-1.458zm-2.955-5.055c-1.572 0-2.623 1.125-2.623 2.608 0 1.472 1.051 2.608 2.623 2.608 1.571 0 2.622-1.136 2.622-2.608.006-1.483-1.05-2.608-2.622-2.608m-.01 4.106c-.714 0-1.094-.596-1.094-1.498 0-.912.375-1.498 1.093-1.498.713 0 1.109.586 1.109 1.498.005.902-.39 1.498-1.109 1.498m-6.901.949h4.225v-1.182h-2.393v-.031l2.29-2.556v-1.156h-4.122v1.187h2.316v.031l-2.316 2.577zm-1.93 0h1.514v-4.92h-1.515zm-3.513 0h1.509v-2.26c0-1.027.619-1.483 1.56-1.353h.032v-1.296a.8.8 0 0 0-.307-.037c-.588 0-.984.27-1.322.845h-.03v-.819h-1.442zm-2.769-.944c-.666 0-1.072-.43-1.15-1.093h3.56c.01-1.058-.271-1.903-.86-2.432-.415-.383-.962-.596-1.66-.596-1.487 0-2.518 1.125-2.518 2.597 0 1.483.984 2.613 2.618 2.613.619 0 1.108-.166 1.514-.44.432-.296.744-.732.827-1.162h-1.446c-.14.322-.443.513-.885.513m-.078-3.048c.53 0 .895.394.958.97h-2.02c.12-.581.438-.97 1.062-.97m-5.558 3.992H6.2l1.718-4.92H6.402l-.963 3.162h-.02l-.963-3.162H2.9zm11.917-6.672h1.515v1.338h-1.515z"
	})));
};

//#endregion
//#region src/ProviderIcon/icons/Viasat.svg
var _path$67;
var _path2$43;
function _extends$70() {
	return _extends$70 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$70.apply(null, arguments);
}
var SvgViasat = function SvgViasat(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$70({
		xmlns: "http://www.w3.org/2000/svg",
		width: 40,
		height: 40,
		fill: "none",
		viewBox: "0 0 40 40"
	}, props), _path$67 || (_path$67 = /*#__PURE__*/ React.createElement("path", {
		fill: "#BED733",
		fillRule: "evenodd",
		d: "M34.862 12.683c.089.03.23.105.314.167s.206.184.271.27c.088.115.32.849.887 2.804.644 2.224.767 2.696.766 2.955 0 .218-.03.362-.1.497-.054.104-.17.256-.257.338-.086.081-.23.184-.317.228a1.4 1.4 0 0 1-.402.106c-.134.013-.33.001-.437-.028a1.4 1.4 0 0 1-.351-.159 1.7 1.7 0 0 1-.296-.28c-.115-.143-.241-.527-.726-2.221a126 126 0 0 0-.601-2.062c-.008-.007-.286.94-.62 2.103-.37 1.293-.649 2.183-.717 2.288a.9.9 0 0 1-.318.273c-.114.055-.291.1-.394.1-.102-.002-.274-.042-.381-.09a1 1 0 0 1-.316-.248c-.083-.108-.215-.487-.417-1.193l-.296-1.034-.315 1.081c-.173.595-.34 1.13-.373 1.19a.7.7 0 0 1-.21.202.7.7 0 0 1-.306.092 1 1 0 0 1-.316-.067.6.6 0 0 1-.236-.183c-.042-.064-.171-.448-.288-.854s-.212-.798-.212-.87c0-.074.039-.207.087-.295.047-.09.159-.2.248-.248a.8.8 0 0 1 .293-.087.789.789 0 0 1 .522.224c.047.053.123.23.17.395.046.164.095.279.11.254.013-.024.157-.513.32-1.086s.347-1.13.409-1.238a.7.7 0 0 1 .317-.296c.113-.054.298-.1.412-.1s.299.045.41.1a.9.9 0 0 1 .297.228c.05.07.191.479.313.907s.236.794.253.813.275-.812.571-1.847c.297-1.034.589-2.04.648-2.236.062-.201.171-.43.252-.528a1.4 1.4 0 0 1 .39-.296c.177-.088.32-.123.514-.123.147 0 .34.025.428.054",
		clipRule: "evenodd"
	})), _path2$43 || (_path2$43 = /*#__PURE__*/ React.createElement("path", {
		fill: "#1F3844",
		d: "M27.204 19.34v.028c0 .33-.074.6-.61.6-.538 0-.612-.27-.612-.6v-.029c0-.331.074-.6.611-.6s.611.269.611.6m-1.599 4.157c-.314 0-.657-.063-.925-.297-.377-.326-.423-.817-.423-1.257v-2.027c0-.006-.005-.006-.005-.006h-.6c-.308 0-.383-.057-.383-.56 0-.502.075-.56.383-.56h.6c.005 0 .005-.005.005-.005v-.81c0-.372.069-.463.674-.463.611 0 .674.091.674.462v3.815c0 .394.04.474.171.565.177.12.543.035.863-.011.245-.034.257.063.325.434.063.371.057.502-.182.56-.212.051-.674.16-1.177.16m-5.928-3.547c-.245.052-.256-.051-.336-.417-.08-.365-.075-.502.165-.565.08-.023.691-.223 1.61-.223.903 0 1.36.486 1.525.914.172.451.16.72.16 1.45v1.708c0 .268-.12.377-.32.468-.188.091-.76.286-1.479.286-1.136 0-2.033-.337-2.033-1.462 0-1.12.777-1.474 1.874-1.474.24 0 .496.006.73.035q.017 0 .017-.017V20.4c0-.417-.205-.662-.747-.656-.417-.006-1.16.205-1.166.205m1.348 2.678c.2 0 .394-.04.537-.09a.04.04 0 0 0 .023-.035v-.885q-.002-.026-.029-.035a4 4 0 0 0-.57-.045c-.452.005-.76.114-.76.548-.006.383.28.542.8.542m-3.06.554c-.24.183-.657.389-1.229.389-.748 0-1.467-.257-1.467-.257-.246-.08-.246-.143-.189-.526.057-.377.098-.53.32-.48.309.07.897.223 1.245.223.263 0 .497-.108.514-.388.017-.297-.228-.457-.73-.594-.578-.16-1.337-.44-1.36-1.41-.023-.783.588-1.4 1.582-1.4.776 0 1.16.166 1.365.223.24.069.245.2.165.566s-.097.474-.337.416c-.245-.05-.685-.205-1.079-.177-.2.012-.422.109-.422.349 0 .285.302.348.622.468.491.183.822.308 1.05.508.326.28.412.566.418.925.017.514-.16.931-.469 1.165M11.18 19.95c-.245.052-.263-.051-.337-.417-.08-.365-.074-.502.166-.565.085-.023.69-.223 1.61-.223.902 0 1.36.486 1.52.914.17.451.16.72.16 1.45v1.708c0 .268-.12.377-.315.468-.188.091-.76.286-1.48.286-1.136 0-2.032-.337-2.032-1.462 0-1.12.777-1.474 1.873-1.474.24 0 .497.006.737.035q.017 0 .017-.017V20.4c0-.417-.206-.662-.748-.656-.417-.006-1.165.205-1.17.205m1.348 2.678c.2 0 .394-.04.537-.09a.04.04 0 0 0 .022-.035v-.885q-.001-.026-.028-.035a4 4 0 0 0-.571-.045c-.451.005-.76.114-.76.548 0 .383.28.542.8.542m-3.53.869c-.61 0-.673-.092-.673-.463v-3.775c0-.371.068-.462.674-.462.61 0 .673.091.673.462v3.775c0 .371-.062.463-.673.463m-1.804-5.985c-.571 0-.651.091-.742.462L5.355 22.08 4.26 17.974c-.092-.37-.177-.462-.743-.462-.565 0-.68.091-.588.457l1.45 5.065c.126.371.372.463.977.463.611 0 .851-.092.977-.463l1.45-5.065c.092-.366-.023-.457-.588-.457"
	})));
};

//#endregion
//#region src/ProviderIcon/icons/Videotron.svg
var _path$66;
var _path2$42;
function _extends$69() {
	return _extends$69 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$69.apply(null, arguments);
}
var SvgVideotron = function SvgVideotron(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$69({
		xmlns: "http://www.w3.org/2000/svg",
		width: 40,
		height: 40,
		fill: "none",
		viewBox: "0 0 40 40"
	}, props), _path$66 || (_path$66 = /*#__PURE__*/ React.createElement("path", {
		fill: "#FFD200",
		d: "M34 6H6v28h28z"
	})), _path2$42 || (_path2$42 = /*#__PURE__*/ React.createElement("path", {
		fill: "#000",
		d: "m13.564 13.186 13.545 6.735-13.562 6.892 8.723-6.87z"
	})));
};

//#endregion
//#region src/ProviderIcon/icons/Wave.svg
var _path$65;
function _extends$68() {
	return _extends$68 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$68.apply(null, arguments);
}
var SvgWave = function SvgWave(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$68({
		xmlns: "http://www.w3.org/2000/svg",
		width: 40,
		height: 40,
		fill: "none",
		viewBox: "0 0 40 40"
	}, props), _path$65 || (_path$65 = /*#__PURE__*/ React.createElement("path", {
		fill: "#00BFDF",
		d: "M18.364 22.089c-1.177 0-2.134-.944-2.134-2.105s.957-2.106 2.134-2.106 2.134.945 2.134 2.106c0 1.16-.957 2.105-2.134 2.105m2.134-5.157a3.77 3.77 0 0 0-2.134-.657 3.76 3.76 0 0 0-3.635 2.763s-.125.434-.125.977c0 .544.125.914.125.914a3.76 3.76 0 0 0 3.635 2.764c.792 0 1.527-.244 2.134-.658v.462h1.625v-7.004h-1.625zM27.541 18.093c0 1.834-1.315 3.37-3.063 3.74v-5.34h-1.626v7.028h.813c2.377 0 4.338-1.425 5.174-3.582.258-.666.279-1.128.31-1.432.013-.122.018-.275.018-.414v-1.6h-1.626zM33.34 17.879c.82 0 1.533.458 1.89 1.13h-3.78a2.14 2.14 0 0 1 1.89-1.13m3.705 2.733q.054-.306.055-.628c0-2.045-1.687-3.71-3.76-3.71-1.072 0-2 .425-2.67 1.085a3.66 3.66 0 0 0-1.09 2.625c0 2.045 1.687 3.708 3.76 3.708a3.79 3.79 0 0 0 3.326-1.98c.083-.157.132-.277.17-.363h-1.874a2.14 2.14 0 0 1-1.622.74 2.135 2.135 0 0 1-2.037-1.477zM12.291 20.533c0 .8-.664 1.45-1.481 1.45-.76 0-1.386-.562-1.471-1.284q.006-.082.008-.166v-4.04h-1.76v4.04q.002.084.008.166a1.47 1.47 0 0 1-1.471 1.284c-.817 0-1.482-.65-1.482-1.45v-4.04H2.9v4.04c0 1.76 1.446 3.192 3.224 3.192.923 0 1.754-.388 2.343-1.006a3.23 3.23 0 0 0 2.343 1.006c1.778 0 3.223-1.432 3.223-3.192v-4.04h-1.742z"
	})));
};

//#endregion
//#region src/ProviderIcon/icons/Webpass.svg
var _path$64;
var _path2$41;
var _path3$26;
function _extends$67() {
	return _extends$67 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$67.apply(null, arguments);
}
var SvgWebpass = function SvgWebpass(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$67({
		xmlns: "http://www.w3.org/2000/svg",
		width: 40,
		height: 40,
		fill: "none",
		viewBox: "0 0 40 40"
	}, props), _path$64 || (_path$64 = /*#__PURE__*/ React.createElement("path", {
		fill: "#000",
		fillRule: "evenodd",
		d: "M24.442 20.19c.093.02.214.05.269.068s.154.06.22.091c.067.032.176.095.243.14a2.3 2.3 0 0 1 .516.532c.044.069.08.136.08.149s.01.023.021.023c.013 0 .023.013.023.029s.02.072.047.126c.026.054.056.128.068.164s.03.106.043.155a3 3 0 0 1 .076.55 2.6 2.6 0 0 1-.012.42c-.015.121-.037.26-.049.309a2.689 2.689 0 0 1-.2.556c-.05.1-.109.201-.131.225s-.041.052-.041.062-.063.082-.138.162a2.3 2.3 0 0 1-.34.3 4.335 4.335 0 0 1-.458.23 3 3 0 0 1-.145.04l-.176.051c-.043.013-.24.024-.441.025-.208 0-.397-.01-.441-.025l-.177-.05a1.9 1.9 0 0 1-.537-.272 1.6 1.6 0 0 1-.177-.161c-.035-.04-.072-.073-.082-.073s-.022.852-.025 1.913l-.006 1.913h-.86l-.014-3.694a244 244 0 0 0-.03-3.788l-.016-.095.405.006.405.006.014.21c.007.115.02.261.03.325l.015.115.095-.115c.052-.064.129-.147.172-.185s.125-.104.184-.145a1.75 1.75 0 0 1 .692-.28l.166-.032a3 3 0 0 1 .293-.011c.15-.002.317.011.419.032m4.327.018c.066.017.17.048.231.069.06.02.14.05.177.067a1.5 1.5 0 0 1 .504.424 1.392 1.392 0 0 1 .237.513c.012.042.032.142.045.22.012.08.03.744.039 1.478.011.904.025 1.359.042 1.41.014.043.018.085.008.094-.01.01-.188.018-.398.02a5 5 0 0 1-.39-.007 3 3 0 0 1-.047-.254l-.038-.245-.09.092c-.049.05-.123.12-.166.152a1.8 1.8 0 0 1-.518.26l-.22.066a2.663 2.663 0 0 1-.904-.011 1 1 0 0 1-.111-.032 5 5 0 0 1-.198-.091 1.1 1.1 0 0 1-.31-.23 1.1 1.1 0 0 1-.22-.287 4 4 0 0 1-.08-.176 1 1 0 0 1-.03-.121 3 3 0 0 1-.026-.197c-.007-.066 0-.18.015-.254a3 3 0 0 1 .059-.233 1.3 1.3 0 0 1 .161-.317 1.601 1.601 0 0 1 .293-.296 2 2 0 0 1 .292-.178 3 3 0 0 1 .32-.137 3 3 0 0 1 .418-.111 5 5 0 0 1 .232-.043c.073-.012.326-.033.563-.049l.43-.027.006-.121a.8.8 0 0 0-.029-.243 2 2 0 0 0-.082-.215.8.8 0 0 0-.144-.185 1 1 0 0 0-.233-.15 1.2 1.2 0 0 0-.257-.079 3 3 0 0 0-.243-.021 2 2 0 0 0-.287.015 2.486 2.486 0 0 0-.813.22c-.076.036-.153.06-.17.054-.017-.007-.031-.025-.031-.04a.3.3 0 0 0-.029-.084 1 1 0 0 1-.058-.154.5.5 0 0 0-.05-.12c-.01-.012-.017-.049-.017-.082 0-.051.017-.068.126-.119l.171-.077.088-.033c.025-.009.08-.025.122-.036l.154-.042a4 4 0 0 1 .441-.088c.067-.01.295-.014.508-.01.239.006.431.021.507.04m4.027-.018a2.13 2.13 0 0 1 .596.178l.113.055-.03.098c-.016.054-.047.14-.07.192a3 3 0 0 0-.07.188c-.017.051-.041.093-.054.093-.014 0-.089-.026-.168-.057l-.187-.076a1 1 0 0 0-.155-.04 9 9 0 0 0-.27-.05.8.8 0 0 0-.32.003c-.087.016-.21.05-.27.077a.6.6 0 0 0-.199.148.5.5 0 0 0-.113.208.4.4 0 0 0 .002.214.572.572 0 0 0 .244.331l.122.066c.03.018.09.047.132.066a8 8 0 0 0 .419.162 3 3 0 0 1 .43.187l.151.08c.035.018.14.108.233.2s.19.208.216.256.063.133.081.188q.035.099.035.342c0 .205-.008.267-.055.396-.03.084-.093.207-.138.272a1.4 1.4 0 0 1-.41.375c-.05.029-.15.075-.223.103s-.172.06-.221.074a4 4 0 0 1-.22.048 3.4 3.4 0 0 1-.54.015 5 5 0 0 1-.53-.036l-.193-.038c-.04-.006-.078-.021-.084-.032s-.03-.02-.053-.02a.8.8 0 0 1-.18-.06 3 3 0 0 1-.181-.085c-.038-.022-.036-.037.046-.28.047-.14.1-.276.118-.302l.031-.048.1.05c.054.026.118.056.142.066a3 3 0 0 0 .441.132c.122.029.256.042.43.042a1.5 1.5 0 0 0 .364-.033c.06-.018.152-.054.204-.08a.6.6 0 0 0 .246-.24.6.6 0 0 0 .042-.203.53.53 0 0 0-.03-.254.6.6 0 0 0-.134-.194 1.1 1.1 0 0 0-.233-.158 7 7 0 0 0-.216-.102 4 4 0 0 0-.251-.091 2.954 2.954 0 0 1-.675-.32 2 2 0 0 1-.247-.208 1.2 1.2 0 0 1-.198-.273c-.072-.144-.073-.155-.073-.424v-.275l.087-.177a1.1 1.1 0 0 1 .243-.33c.113-.114.205-.18.342-.249.103-.051.267-.113.364-.136s.201-.047.232-.052a4 4 0 0 1 .785.018m3.592.031c.097.025.206.057.243.07.036.014.113.046.17.072.08.036.105.059.105.097a.2.2 0 0 1-.019.088.945.945 0 0 0-.077.193 2 2 0 0 1-.042.127.4.4 0 0 1-.055.108c-.018.018-.062.009-.164-.033a3 3 0 0 0-.227-.083l-.132-.043a2 2 0 0 0-.235-.041 1.1 1.1 0 0 0-.353 0c-.09.014-.213.049-.275.076a.7.7 0 0 0-.171.109.476.476 0 0 0-.146.36c0 .072.012.155.028.183.016.03.043.076.06.104a.6.6 0 0 0 .132.121c.055.039.15.094.21.123s.13.06.154.07.144.054.265.098.25.093.287.109l.154.069a1.82 1.82 0 0 1 .515.374 1.1 1.1 0 0 1 .227.368c.01.021.019.064.019.095s.011.102.025.157a.56.56 0 0 1-.002.258 2 2 0 0 1-.05.224c-.012.036-.048.12-.08.187-.037.076-.12.18-.222.281-.09.088-.172.16-.183.16a.4.4 0 0 0-.1.051 1.4 1.4 0 0 1-.358.152 4 4 0 0 1-.188.044 5 5 0 0 1-.518.033 3.4 3.4 0 0 1-.54-.015 5 5 0 0 1-.221-.047 5 5 0 0 1-.232-.067 3 3 0 0 1-.259-.1c-.105-.05-.114-.06-.102-.113.007-.032.036-.124.064-.202.029-.08.067-.188.084-.243.026-.076.043-.098.074-.092a1 1 0 0 1 .117.041l.122.052c.024.01.093.035.154.055.06.02.19.055.287.078.12.029.256.042.425.042.209 0 .277-.009.422-.057a1 1 0 0 0 .253-.123.6.6 0 0 0 .127-.156.7.7 0 0 0 .057-.213.8.8 0 0 0-.015-.219.5.5 0 0 0-.117-.194 1 1 0 0 0-.214-.17 2 2 0 0 0-.255-.122l-.176-.07a5 5 0 0 0-.188-.066 3 3 0 0 1-.297-.126 3 3 0 0 1-.282-.164c-.07-.048-.18-.14-.243-.204a1.2 1.2 0 0 1-.178-.247l-.085-.174a1.1 1.1 0 0 1-.011-.276 2 2 0 0 1 .031-.31c.013-.044.047-.128.076-.188.029-.059.127-.182.218-.274.122-.123.208-.187.33-.247.091-.044.214-.096.274-.116s.173-.05.254-.067c.102-.022.253-.028.509-.022.273.007.408.02.54.055m-12.769.607a2 2 0 0 0-.287.066c-.06.022-.174.082-.253.135a2 2 0 0 0-.2.146c-.03.028-.1.116-.156.194a1.4 1.4 0 0 0-.147.266 2 2 0 0 0-.072.306c-.017.12-.023.333-.015.616.008.321.02.462.048.543.02.061.049.135.063.166.014.03.055.099.09.153.037.054.116.146.178.205.063.06.189.144.288.193.102.05.255.101.362.123.131.026.233.033.342.023.086-.008.196-.025.244-.037.049-.013.143-.044.21-.07s.166-.077.22-.113c.055-.037.138-.107.185-.156a1.6 1.6 0 0 0 .252-.37l.046-.111c.01-.027.03-.085.042-.127s.04-.154.058-.247a2 2 0 0 0 .035-.365c0-.12-.018-.271-.046-.393l-.058-.258c-.006-.033-.02-.066-.03-.073-.012-.006-.02-.027-.02-.045 0-.019-.044-.1-.097-.18a2 2 0 0 0-.182-.238c-.047-.049-.131-.12-.187-.159a1 1 0 0 0-.198-.105l-.141-.055a1 1 0 0 0-.188-.033 3 3 0 0 1-.176-.02 1.3 1.3 0 0 0-.21.02m4.896 1.556a3 3 0 0 0-.525.085 1.618 1.618 0 0 0-.446.194 1 1 0 0 0-.191.178 1 1 0 0 0-.118.222.7.7 0 0 0-.027.275c.007.101.03.2.062.27.028.06.083.141.121.18a.8.8 0 0 0 .163.117c.052.026.167.061.255.078.14.027.186.027.35-.002.103-.018.228-.047.276-.064s.136-.057.195-.09.161-.115.229-.184c.068-.07.152-.186.186-.258.063-.13.064-.132.065-.571v-.441l-.198-.003a6 6 0 0 0-.397.014",
		clipRule: "evenodd"
	})), _path2$41 || (_path2$41 = /*#__PURE__*/ React.createElement("path", {
		fill: "#797979",
		fillRule: "evenodd",
		d: "m17.72 18.755.011 1.852.088-.078c.049-.043.133-.108.188-.144a2 2 0 0 1 .341-.174c.025-.008.094-.028.155-.044.06-.016.192-.04.293-.054s.239-.023.308-.021a3 3 0 0 1 .49.066 1.5 1.5 0 0 1 .31.11 1.985 1.985 0 0 1 .58.424c.062.072.147.182.187.244s.098.168.129.235a2.8 2.8 0 0 1 .184.604c.016.084.028.297.028.474s-.011.392-.026.476a4 4 0 0 1-.051.243l-.055.188a2.312 2.312 0 0 1-.32.61 3 3 0 0 1-.214.245 3 3 0 0 1-.237.194c-.074.054-.22.138-.322.186a2.6 2.6 0 0 1-.421.143c-.19.044-.29.055-.527.055a1.8 1.8 0 0 1-.758-.142 2 2 0 0 1-.248-.143 1.3 1.3 0 0 1-.216-.19c-.046-.054-.095-.098-.11-.098s-.032.04-.039.093l-.024.22c-.008.068-.026.135-.042.148-.02.017-.253.023-.739.018l-.709-.005.001-3.78c0-2.078.007-3.788.014-3.799.006-.01.388-.017.876-.014l.864.006zm-12.97-.124c.01.02.031.111.045.202.015.091.036.201.047.245s.02.107.02.14c0 .035.01.098.021.142s.037.179.057.3a44 44 0 0 0 .144.838 24 24 0 0 1 .133.794l.04.276.058.363a37 37 0 0 1 .095.629c.01.086.025.121.048.121.024 0 .038-.034.048-.121.008-.067.031-.206.05-.309l.058-.309c.011-.066.03-.173.043-.236l.042-.221c.01-.058.037-.19.057-.292.02-.103.042-.218.047-.254.006-.036.019-.106.03-.154.01-.049.03-.143.042-.21a128 128 0 0 0 .233-1.213l.077-.408c.012-.06.028-.148.035-.194a.3.3 0 0 1 .055-.127c.041-.04.081-.043.912-.043.796 0 .872.004.913.039.031.027.052.089.07.204a19 19 0 0 0 .088.518 26 26 0 0 0 .1.552 22 22 0 0 1 .098.573l.078.43c.033.176.064.36.07.408.005.049.019.138.03.198.012.061.042.26.068.442.026.181.055.395.065.474s.025.165.033.192c.009.028.024.044.035.038.01-.007.02-.05.02-.098 0-.046.01-.133.022-.191.012-.059.043-.24.069-.404l.104-.662a218.037 218.037 0 0 1 .278-1.588l.1-.562.056-.309c.022-.12.05-.21.071-.226.027-.02.232-.028.849-.028.478 0 .83.01.853.022.037.02.037.029.007.138-.018.064-.04.15-.05.193a5 5 0 0 1-.053.199l-.1.364-.124.452a10 10 0 0 0-.076.286c-.01.043-.044.172-.076.287l-.08.287-.042.154c-.01.043-.05.197-.088.342a5 5 0 0 1-.088.309.6.6 0 0 0-.03.099c-.005.03-.036.15-.069.265-.032.115-.067.244-.077.286-.01.043-.035.137-.055.21l-.145.53-.054.198-.158.584-.14.518c-.01.037-.028.094-.041.127l-.024.06H7.817l-.024-.06a1 1 0 0 1-.043-.182l-.041-.231-.254-1.357-.1-.529c-.01-.067-.03-.18-.043-.254a29 29 0 0 1-.155-1.003 2 2 0 0 0-.048-.254l-.027-.088-.016.11a31 31 0 0 1-.108.673l-.043.254c-.012.072-.047.251-.078.397a38 38 0 0 0-.122.584c-.012.055-.031.15-.042.212s-.03.152-.043.199-.04.165-.06.262l-.054.264c-.009.049-.043.208-.075.353a20 20 0 0 0-.118.563l-.018.077-.957.006c-.526.003-.964-.002-.973-.012a2 2 0 0 1-.088-.281 16 16 0 0 1-.129-.513l-.042-.17-.157-.618a39 39 0 0 1-.21-.838l-.153-.596-.033-.143c-.01-.042-.08-.315-.156-.606a66 66 0 0 1-.241-.96l-.142-.558a7 7 0 0 1-.124-.533c0-.029.012-.057.028-.063.015-.007.427-.012.915-.011.805 0 .89.004.907.037m8.813 1.484c.085.01.209.03.275.044a1.4 1.4 0 0 1 .287.086c.043.015.121.046.174.07.053.023.163.086.243.139s.206.159.28.235a2.4 2.4 0 0 1 .34.468c0 .007.024.066.055.132.03.066.07.178.089.25.019.07.049.212.066.315a3.3 3.3 0 0 1 .007.845c-.014.091-.04.17-.059.186-.027.022-.351.028-1.453.028H12.45v.048c0 .028.041.087.099.142a.9.9 0 0 0 .39.215c.052.017.16.044.239.06q.143.031.551.028c.247-.002.495-.018.629-.039.121-.019.27-.046.33-.06.061-.014.14-.026.175-.028.05-.002.067.01.08.053.009.03.028.115.043.187a17 17 0 0 0 .098.464c.02.084.037.198.04.252.005.084-.001.1-.038.106a.5.5 0 0 0-.089.027c-.024.01-.108.035-.187.054s-.216.049-.305.067a6.3 6.3 0 0 1-1.108.1 5 5 0 0 1-.562-.033 5 5 0 0 1-.374-.065 4 4 0 0 1-.397-.12 2.976 2.976 0 0 1-.408-.212 2.4 2.4 0 0 1-.283-.221 2 2 0 0 1-.405-.553 2 2 0 0 1-.081-.208l-.049-.154a2.73 2.73 0 0 1-.075-.673 2.299 2.299 0 0 1 .165-.816l.087-.19c.037-.081.126-.226.2-.323.072-.096.194-.233.27-.304s.21-.174.297-.231.244-.14.35-.184c.104-.044.208-.08.23-.08s.047-.008.053-.019c.007-.01.054-.026.106-.035l.282-.045a3 3 0 0 1 .76-.008m-.618 1.053a1 1 0 0 0-.155.064.7.7 0 0 0-.17.134 1 1 0 0 0-.116.159c-.02.038-.05.115-.067.172l-.032.108c0 .003.313.005.695.005.54 0 .694-.006.694-.027 0-.016-.013-.078-.03-.138a1 1 0 0 0-.064-.18.8.8 0 0 0-.113-.147.6.6 0 0 0-.16-.115 1 1 0 0 0-.25-.044c-.091-.005-.195 0-.232.009m5.348.166a1 1 0 0 0-.21.073.7.7 0 0 0-.15.108 1 1 0 0 0-.113.151.9.9 0 0 0-.076.234 3 3 0 0 0-.024.43c0 .157.01.35.023.429a1 1 0 0 0 .049.198c.014.03.05.086.077.124.028.038.09.097.138.13s.144.08.212.102a.9.9 0 0 0 .217.041.96.96 0 0 0 .448-.147c.04-.03.097-.081.127-.114a1 1 0 0 0 .113-.174c.03-.064.07-.188.087-.276a2 2 0 0 0 .03-.326c0-.09-.014-.227-.03-.304a1.5 1.5 0 0 0-.1-.28.8.8 0 0 0-.163-.222 1 1 0 0 0-.18-.119 1 1 0 0 0-.177-.054l-.132-.024a.6.6 0 0 0-.166.02",
		clipRule: "evenodd"
	})), _path3$26 || (_path3$26 = /*#__PURE__*/ React.createElement("path", {
		fill: "#7EA632",
		fillRule: "evenodd",
		d: "M20.277 12.22c.1.037.173.083.247.157a.9.9 0 0 1 .15.208c.026.057.042.117.035.132a.05.05 0 0 1-.04.03c-.015 0-.063-.037-.105-.082a.8.8 0 0 0-.197-.137c-.108-.05-.15-.057-.365-.057-.235 0-.247.002-.41.082a1.1 1.1 0 0 0-.246.16.7.7 0 0 0-.113.152.4.4 0 0 0-.035.16c0 .047.023.135.052.197s.09.143.137.182a1 1 0 0 0 .174.111 1 1 0 0 0 .184.058c.053.009.15.009.217 0a.28.28 0 0 0 .208-.1c.081-.082.086-.095.086-.22a.5.5 0 0 0-.033-.197.4.4 0 0 0-.09-.11.24.24 0 0 0-.153-.045.24.24 0 0 0-.151.045c-.032.025-.058.062-.058.081s.016.054.036.076.063.04.095.04.07-.011.083-.025a.06.06 0 0 1 .06-.012q.032.015.02.053a.6.6 0 0 1-.067.111c-.047.064-.065.072-.162.072-.102 0-.113-.006-.175-.092a.3.3 0 0 1-.067-.168c0-.042.02-.11.045-.149a.4.4 0 0 1 .143-.118.54.54 0 0 1 .243-.047c.111 0 .175.015.283.063a.8.8 0 0 1 .189.116.5.5 0 0 1 .08.127c.018.041.032.097.032.124a.4.4 0 0 1-.125.263 1 1 0 0 1-.14.114 1.2 1.2 0 0 1-.228.099.7.7 0 0 1-.32.037 1.1 1.1 0 0 1-.291-.06c-.07-.027-.18-.099-.254-.165a.5.5 0 0 1-.184-.264.6.6 0 0 1-.04-.3.7.7 0 0 1 .072-.28 1.1 1.1 0 0 1 .392-.406c.05-.027.117-.056.148-.066s.154-.015.275-.01c.162.006.258.022.363.06m-3.458.329c.126.012.293.038.372.057s.183.047.231.063.133.046.188.066.149.06.21.088a.5.5 0 0 1 .14.085c.024.03.02.037-.034.048-.035.007-.092.02-.129.03l-.165.048a.5.5 0 0 0-.12.047.1.1 0 0 1-.061.018.2.2 0 0 0-.079.02 5.96 5.96 0 0 0-.284.124q-.135.06-.198.049a3 3 0 0 1-.229-.06c-.133-.04-.221-.05-.452-.05-.266 0-.3.005-.47.068a3 3 0 0 0-.327.148c-.079.044-.2.125-.268.18a3 3 0 0 0-.232.213 1.4 1.4 0 0 0-.204.313c-.054.11-.099.228-.1.264a.6.6 0 0 1-.016.114q-.014.052-.045.03c-.017-.01-.044-.056-.06-.102a2 2 0 0 1-.055-.234.7.7 0 0 1 .003-.31c.016-.088.064-.229.106-.312.049-.097.13-.205.224-.299.08-.08.215-.192.3-.247.083-.054.236-.14.34-.19.102-.05.262-.115.354-.146s.25-.07.353-.089.22-.037.263-.042l.146-.012c.038-.002.172.007.298.02m1.503.564a2.552 2.552 0 0 1 .436.35c.042.044.185.177.318.294.134.117.313.27.4.339a7 7 0 0 0 .824.54c.091.047.235.114.32.148l.198.08c.025.01.124.037.221.061s.231.054.298.067.2.034.297.047.41.024.695.024c.284 0 .607-.01.716-.023a38.18 38.18 0 0 0 .998-.153c.073-.013.094-.01.094.013 0 .016-.01.03-.02.03a1 1 0 0 0-.139.053c-.064.029-.176.076-.248.105a4 4 0 0 1-.353.115c-.122.033-.256.07-.298.08-.043.01-.142.03-.22.042-.08.013-.221.033-.316.045a6 6 0 0 1-.572.023c-.22 0-.485-.011-.59-.024a7 7 0 0 1-.552-.091 6 6 0 0 1-.308-.075 13 13 0 0 1-.783-.25l-.232-.091a11.573 11.573 0 0 1-.998-.478l-.105-.06-.192.098a3 3 0 0 0-.204.11 1 1 0 0 1-.11.065c-.055.03-.194.116-.31.192l-.264.178-.21.153c-.084.062-.179.135-.21.162-.03.027-.099.085-.153.128a4 4 0 0 0-.55.578c-.069.091-.172.24-.23.33a6 6 0 0 0-.581 1.266l-.075.235a4 4 0 0 0-.11.408l-.042.198-.066.33a2 2 0 0 0-.044.294c0 .045-.013.077-.035.085a.35.35 0 0 1-.149-.025l-.18-.056c-.037-.01-.186-.05-.331-.087a10 10 0 0 0-1.513-.264 9 9 0 0 0-.629-.023c-.205 0-.416.01-.469.023a.3.3 0 0 1-.105.014c-.005-.005-.003-.023.003-.04a.4.4 0 0 1 .095-.088 2.6 2.6 0 0 1 .423-.242c.091-.044.25-.108.353-.14s.217-.068.254-.078c.036-.01.146-.026.242-.033a6.544 6.544 0 0 1 1.04-.002c.18.015.335.023.344.018.01-.004.017-.202.017-.438 0-.237.01-.502.023-.589l.046-.313a5.68 5.68 0 0 1 .156-.662c.012-.036.03-.086.04-.11s.036-.094.057-.154a4.374 4.374 0 0 1 .447-.838c.086-.121.218-.29.294-.375s.217-.226.315-.312c.097-.087.228-.199.291-.248a6.031 6.031 0 0 1 1.33-.751 9 9 0 0 1 .32-.117 3 3 0 0 1 .386-.104c.042-.01.09-.019.106-.02a.3.3 0 0 1 .099.033m-.086 1.926.322.046c.103.014.316.05.474.078a43 43 0 0 1 .96.187c.054.01.173.038.264.062s.23.063.309.087a8 8 0 0 1 .58.207c.063.027.263.124.445.216s.435.236.563.32.326.23.44.322c.116.093.27.23.341.303.072.074.126.14.12.146a.7.7 0 0 1-.182-.084 5 5 0 0 0-.361-.18l-.281-.121a4 4 0 0 0-.265-.093c-.097-.03-.246-.076-.33-.1a6 6 0 0 0-.453-.114 7.213 7.213 0 0 0-.739-.135c-.109-.014-.287-.034-.396-.046a16 16 0 0 0-.563-.041 16.391 16.391 0 0 0-1.577 0c-.182.011-.42.03-.529.042s-.268.032-.352.045a9 9 0 0 0-.375.07l-.27.057c-.028.006-.05 0-.05-.012s.057-.096.128-.185a4.936 4.936 0 0 1 1.07-.996l.15-.102h.21c.117 0 .272.01.347.02",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/ProviderIcon/icons/WiLine.svg
var _path$63;
var _path2$40;
var _path3$25;
function _extends$66() {
	return _extends$66 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$66.apply(null, arguments);
}
var SvgWiLine = function SvgWiLine(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$66({
		xmlns: "http://www.w3.org/2000/svg",
		width: 40,
		height: 40,
		fill: "none",
		viewBox: "0 0 40 40"
	}, props), _path$63 || (_path$63 = /*#__PURE__*/ React.createElement("path", {
		fill: "#004486",
		d: "M17.942 18.273h1.407v4.178h2.453v1.185h-3.86zM23.39 19.136h-1.387v4.48h1.388zM23.974 20.583c0-.563-.02-1.025-.04-1.427h1.206l.06.623h.02c.181-.301.644-.723 1.388-.723.925 0 1.608.623 1.608 1.928v2.652H26.83v-2.491c0-.583-.201-.964-.704-.964-.382 0-.623.26-.724.522-.04.1-.04.221-.04.341v2.592h-1.408v-3.053M29.744 21.828c.04.582.624.864 1.267.864.483 0 .865-.06 1.247-.201l.18.944c-.462.2-1.025.281-1.628.281-1.528 0-2.393-.884-2.393-2.29 0-1.145.724-2.39 2.272-2.39 1.448 0 2.011 1.125 2.011 2.25 0 .24-.02.441-.04.562zm1.63-.964c0-.322-.142-.904-.785-.904-.603 0-.845.542-.865.904z"
	})), _path2$40 || (_path2$40 = /*#__PURE__*/ React.createElement("path", {
		fill: "#004486",
		d: "M4.61 19.759c.463-3.234 7.802-4.881 16.408-3.676a38.6 38.6 0 0 1 7.158 1.687c-2.413-.964-5.348-1.747-8.586-2.189-8.746-1.225-16.206.422-16.668 3.676-.362 2.611 3.88 5.463 10.093 7.13C7.747 24.7 4.29 22.13 4.611 19.76"
	})), _path3$25 || (_path3$25 = /*#__PURE__*/ React.createElement("path", {
		fill: "#004486",
		d: "M27.875 26.448c4.443-.281 7.58-1.587 7.962-3.616.583-3.234-5.992-7.13-14.678-8.697a41 41 0 0 0-4.987-.583c2.01.02 4.203.221 6.475.623 8.545 1.526 15 5.383 14.416 8.597-.382 2.23-4.102 3.575-9.189 3.676M9.456 23.636 7.99 18.273h1.487s.744 3.254.845 3.876h.02c.1-.683.925-3.876.925-3.876h1.488s.744 3.153.824 3.856h.02c.1-.683.865-3.856.865-3.856h1.428l-1.609 5.363h-1.508s-.663-3.214-.824-3.917h-.02c-.161.703-.945 3.917-.945 3.917zM17.338 19.136h-1.387v4.48h1.387z"
	})));
};

//#endregion
//#region src/ProviderIcon/icons/Windstream.svg
var _path$62;
var _path2$39;
function _extends$65() {
	return _extends$65 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$65.apply(null, arguments);
}
var SvgWindstream = function SvgWindstream(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$65({
		xmlns: "http://www.w3.org/2000/svg",
		width: 40,
		height: 40,
		fill: "none",
		viewBox: "0 0 40 40"
	}, props), _path$62 || (_path$62 = /*#__PURE__*/ React.createElement("path", {
		fill: "#7FCC28",
		d: "M21.268 16.713c-.383 2.99-.703 5.446-.87 5.446-.235 0-1.087-3.77-1.93-7.315-1.082-4.547-1.666-5.891-2.977-5.891-2.21 0-3.091 7.07-3.091 8.446 0 .842.43 1.195.95 1.195.845 0 1.205-.698 1.3-1.485.418-3.407.937-4.972 1.074-4.972.134 0 .608 1.27 1.783 5.818 1.127 4.36 1.674 6.384 2.59 6.384 1.226 0 1.71-3.038 2.26-7.556.305-2.51.566-5.02.78-5.02.14 0 .432 2.322.697 4.54.366 3.062.548 4.531 1.152 4.531.824 0 1.037-2.206 1.38-5.378.29-2.697.454-3.831.536-3.831.096 0 .166.718.208 2.211.009.329.11.407.229.407.253 0 .261-.424.261-.764 0-1.7-.294-3.425-.672-3.425-.507 0-.864 1.774-1.24 5.286-.305 2.851-.409 3.942-.532 3.942-.103 0-.251-1.298-.533-3.618C24.17 11.932 24 9.69 23.081 9.69c-.907 0-1.172 2.03-1.813 7.022"
	})), _path2$39 || (_path2$39 = /*#__PURE__*/ React.createElement("path", {
		fill: "#231F20",
		d: "M6.49 30.984h-.574l-.733-2.27a2 2 0 0 1-.09-.409h-.025c-.019.153-.057.294-.095.415l-.708 2.264h-.58A28 28 0 0 1 2.9 27.68c.16-.025.396-.038.555-.038l.49 2.264c.026.128.052.3.065.44h.031c.02-.14.052-.312.096-.453l.702-2.238h.548l.708 2.245c.038.12.076.287.102.446h.025c.02-.16.045-.306.077-.453l.478-2.25c.16 0 .363.012.51.037a27 27 0 0 1-.797 3.304M8.894 30.984h-.568v-3.329h.568zm-.287-3.896c-.223 0-.332-.166-.332-.351 0-.191.109-.364.338-.364.224 0 .332.173.332.364s-.108.35-.338.35M12.178 30.984V28.63c0-.326-.14-.523-.555-.523-.319 0-.574.09-.829.261v2.615h-.567V27.68c.153-.025.395-.038.567-.038v.326h.032c.332-.288.638-.377.982-.377.504 0 .944.242.944 1.014v2.379zM15.81 28.235a1.45 1.45 0 0 0-.62-.14c-.56 0-.873.287-.873 1.256 0 .931.249 1.18.733 1.18.268 0 .517-.057.76-.223zm.7 2.812c-.248 0-.503-.063-.63-.401h-.026c-.338.318-.644.401-.982.401-.727 0-1.167-.516-1.167-1.626 0-1.313.58-1.83 1.46-1.83.198 0 .447.045.644.115v-1.422c.153-.026.402-.045.574-.045v4.024c0 .16.045.217.192.217h.37v.172c0 .287-.192.395-.434.395M18.45 31.047c-.326 0-.708-.07-.97-.21.045-.185.083-.35.147-.517.261.134.625.204.937.204.37 0 .517-.16.517-.433 0-.663-1.544-.447-1.544-1.48 0-.675.568-1.02 1.25-1.02.21 0 .53.025.778.096a3 3 0 0 1-.082.529 3 3 0 0 0-.849-.121c-.331 0-.51.14-.51.446 0 .58 1.556.39 1.556 1.518 0 .688-.574.988-1.23.988M21.765 31.047c-.689 0-.97-.344-.97-1.078v-1.817H20.4v-.497h.396v-.714c.153-.045.408-.09.573-.102v.816h.842c0 .16-.012.332-.038.497h-.803v1.862c0 .396.12.498.446.498.153 0 .357-.045.485-.102.038.146.07.337.083.503-.173.083-.44.134-.619.134M26.05 29.026h1.39c.006-.051.006-.16.006-.204 0-.549-.243-.784-.67-.784-.44 0-.708.286-.727.988m1.944.395h-1.951v.051c0 .695.21 1.033.918 1.033.306 0 .657-.089.855-.21.057.153.115.363.14.536-.255.14-.689.216-1.008.216-.994 0-1.524-.555-1.524-1.683 0-1.23.587-1.773 1.365-1.773.81 0 1.224.498 1.224 1.352 0 .14-.006.325-.019.478M30.927 28.216a1.4 1.4 0 0 0-.567-.115c-.568 0-.874.287-.874 1.25 0 .937.249 1.18.734 1.18.274 0 .497-.077.707-.217zm.574 2.047c0 .16.039.217.191.217h.37v.172c0 .287-.191.395-.44.395-.255 0-.49-.07-.63-.395h-.02c-.293.274-.574.395-.905.395-.74 0-1.193-.49-1.193-1.626 0-1.25.574-1.83 1.46-1.83.198 0 .383.032.593.096.09-.051.23-.077.364-.077q.115 0 .21.02zM36.526 30.984V28.63c0-.313-.14-.523-.53-.523-.3 0-.503.095-.727.274v2.602h-.573V28.63c0-.32-.147-.523-.523-.523-.262 0-.497.095-.727.261v2.615h-.568V27.68c.153-.025.396-.038.568-.038v.326h.032c.306-.275.542-.377.88-.377s.625.121.771.447c.351-.332.65-.447 1.02-.447.523 0 .951.255.951 1.008v2.385zM24.864 28.222a1.2 1.2 0 0 0-.287-.038c-.23 0-.453.045-.74.325v2.474h-.567V27.68c.153-.025.395-.038.568-.038v.42h.031c.364-.433.593-.47.797-.47.07 0 .179.006.256.031 0 .191-.026.408-.058.6"
	})));
};

//#endregion
//#region src/ProviderIcon/icons/WOW.svg
var _path$61;
var _path2$38;
var _path3$24;
var _path4$17;
var _path5$10;
var _path6$7;
var _path7$5;
var _path8$5;
var _path9$5;
var _path0$5;
function _extends$64() {
	return _extends$64 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$64.apply(null, arguments);
}
var SvgWow = function SvgWow(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$64({
		xmlns: "http://www.w3.org/2000/svg",
		width: 40,
		height: 40,
		fill: "none",
		viewBox: "0 0 40 40"
	}, props), _path$61 || (_path$61 = /*#__PURE__*/ React.createElement("path", {
		fill: "#C52024",
		d: "M6.918 24.278H5.541L2.9 15.689h1.377z"
	})), _path2$38 || (_path2$38 = /*#__PURE__*/ React.createElement("path", {
		fill: "#E23F23",
		d: "M12.209 24.278h-1.377l-2.641-8.589h1.377z"
	})), _path3$24 || (_path3$24 = /*#__PURE__*/ React.createElement("path", {
		fill: "#F15121",
		d: "M10.84 24.278h1.377l2.641-8.589h-1.376z"
	})), _path4$17 || (_path4$17 = /*#__PURE__*/ React.createElement("path", {
		fill: "#D42F23",
		d: "M5.55 24.278h1.376l2.641-8.589H8.191z"
	})), _path5$10 || (_path5$10 = /*#__PURE__*/ React.createElement("path", {
		fill: "#00ADEF",
		d: "M26.375 24.278h-1.377l-2.641-8.589h1.377z"
	})), _path6$7 || (_path6$7 = /*#__PURE__*/ React.createElement("path", {
		fill: "#2184C4",
		d: "M31.666 24.278h-1.377l-2.641-8.589h1.376z"
	})), _path7$5 || (_path7$5 = /*#__PURE__*/ React.createElement("path", {
		fill: "#306FB2",
		d: "M30.297 24.278h1.377l2.641-8.589H32.94zM35.259 21.677l1.841-5.988h-1.377l-1.841 5.988zM33.477 22.992l-.395 1.286h1.376l.398-1.292z"
	})), _path8$5 || (_path8$5 = /*#__PURE__*/ React.createElement("path", {
		fill: "#0F9ADA",
		d: "M25.006 24.278h1.377l2.641-8.589h-1.376z"
	})), _path9$5 || (_path9$5 = /*#__PURE__*/ React.createElement("path", {
		fill: "#00ADEF",
		d: "M22.996 19.33a4.4 4.4 0 0 0-.457-1.388l-.026-.046a4.46 4.46 0 0 0-2.602-2.136l-.378 1.226v.001q.109.033.215.074.038.016.078.034.076.031.151.067.045.021.089.046.066.034.13.071.046.027.09.056.06.037.12.078.044.031.087.065.056.04.11.084l.083.072a3 3 0 0 1 .273.27 3.3 3.3 0 0 1 .426.61q.026.048.051.098.031.063.059.128.022.05.043.101.026.067.049.136l.035.102.04.147q.012.049.024.099.017.082.03.168.008.042.015.085.018.128.024.26.004.08.005.162-.001.081-.005.162-.007.122-.022.24l-.01.069q-.014.09-.032.178l-.013.062a3 3 0 0 1-.056.213l-.001.003-.003.009-.018.051q-.03.088-.062.174l-.033.078a3 3 0 0 1-.182.358l-.04.068a3 3 0 0 1-.12.177l-.011.018a3 3 0 0 1-.145.182l-.05.055q-.054.06-.11.118l-.061.06q-.057.054-.115.104-.03.028-.063.054a3 3 0 0 1-.139.108l-.047.035q-.096.068-.197.129l-.047.026q-.08.046-.16.087l-.075.035a3 3 0 0 1-.382.15l-.072.023a3.16 3.16 0 0 1-1.751.009l-.026-.008-.033-.011-.377 1.228a4.42 4.42 0 0 0 3.364-.315l.038-.021a4.44 4.44 0 0 0 2.292-3.237 3.15 3.15 0 0 0 0-1.342"
	})), _path0$5 || (_path0$5 = /*#__PURE__*/ React.createElement("path", {
		fill: "#F15121",
		d: "M19.255 15.61a4.5 4.5 0 0 0-1.298-.002 4.4 4.4 0 0 0-1.423.462l-.03.015a4.44 4.44 0 0 0-2.346 3.753q-.003.081-.004.162 0 .082.004.162c.025.685.206 1.33.507 1.902l.02.038a4.45 4.45 0 0 0 2.617 2.142l.377-1.228a3.16 3.16 0 0 1-2.165-2.345 4.5 4.5 0 0 1 0-1.342q.016-.07.035-.137l.075-.243a3.16 3.16 0 0 1 3.885-1.97l.024.007.378-1.226a4.4 4.4 0 0 0-.656-.15"
	})));
};

//#endregion
//#region src/ProviderIcon/icons/Xfinity.svg
var _path$60;
function _extends$63() {
	return _extends$63 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$63.apply(null, arguments);
}
var SvgXfinity = function SvgXfinity(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$63({
		xmlns: "http://www.w3.org/2000/svg",
		width: 40,
		height: 40,
		fill: "none",
		viewBox: "0 0 40 40"
	}, props), _path$60 || (_path$60 = /*#__PURE__*/ React.createElement("path", {
		fill: "#000",
		d: "m8.197 20.053 1.89-2.538h-.78a.88.88 0 0 0-.775.379l-1.005 1.33-.965-1.352a.88.88 0 0 0-.788-.357h-.798l1.886 2.56L4.8 22.84h.753a.88.88 0 0 0 .776-.379l1.194-1.581 2.797 3.868a.88.88 0 0 0 .776.379h.82zm15.28 2.788h1.079v-5.326h-1.08zm-8.57 0h1.084v-5.326h-1.084zm16.38 1.886 3.913-7.212h-.586a.8.8 0 0 0-.775.379l-1.542 2.864-1.322-2.864a.77.77 0 0 0-.789-.38h-.564l2.053 4.34-1.793 3.274h.586a.88.88 0 0 0 .82-.4m-14.01-7.212v5.326h1.08v-3.67a1.7 1.7 0 0 1 1.423-.775c.797 0 1.321.502 1.321 1.511v2.41a.49.49 0 0 0 .503.516h.577v-3.115c0-1.384-.881-2.349-2.159-2.349a2.4 2.4 0 0 0-1.679.64v-.494zm9.279 3.45a1.855 1.855 0 0 0 1.991 1.991q.402.005.789-.106l-.22-.943a2.2 2.2 0 0 1-.494.053.917.917 0 0 1-.987-1.018v-2.484h1.511l-.436-.943h-1.07v-2.172l-1.08.471v1.7h-1.145v.944h1.14zm-14.98-2.485v4.383h1.08v-4.405h1.396v-.943h-1.388v-.44c0-.913.547-1.217 1.08-1.217q.187 0 .366.053l.22-.956a1.9 1.9 0 0 0-.67-.084c-1.322 0-2.075.996-2.075 2.203v.44h-.568l-.679.944z"
	})));
};

//#endregion
//#region src/ProviderIcon/icons/Zayo.svg
var _path$59;
var _path2$37;
function _extends$62() {
	return _extends$62 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$62.apply(null, arguments);
}
var SvgZayo = function SvgZayo(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$62({
		xmlns: "http://www.w3.org/2000/svg",
		width: 40,
		height: 40,
		fill: "none",
		viewBox: "0 0 40 40"
	}, props), _path$59 || (_path$59 = /*#__PURE__*/ React.createElement("path", {
		fill: "#FF7C00",
		d: "M11.532 18.141c.124-.668.3-1.501 1.457-2.093.91-.455 2.062-.532 2.91-.532 3.847 0 3.847 1.93 3.847 2.872v4.28c0 .515.05.652.282.97h-3.174v-.608c-.407.274-1.159.79-2.678.79-2.034 0-2.927-1.201-2.927-2.533 0-.471.108-1.123.69-1.688.734-.729 1.61-.85 3.033-1.03.893-.12 1.237-.197 1.723-.334-.017-.532-.17-.894-1.096-.894-.734 0-.937.181-1.05.73zm4.192 2.138c-.266.06-.548.12-.83.213-.628.242-.656.609-.656.697 0 .213.186.608.796.608.452 0 1.204-.29 1.486-.893.158-.335.158-.653.158-.927-.316.104-.627.214-.954.302"
	})), _path2$37 || (_path2$37 = /*#__PURE__*/ React.createElement("path", {
		fill: "#FF7C00",
		d: "M19.458 15.774h3.36l.797 3.381c.17.926.22 1.14.379 2.307.141-1.227.203-1.485.39-2.4l.813-3.294h3.35l-2.954 8.314c-.22.592-.435 1.228-.955 1.715-.69.653-1.248.67-2.254.67-.718 0-1.062-.034-1.706-.105v-2.23c.265.016.61.043.91.043.44 0 .689-.093.689-.378 0-.137-.187-.625-.249-.805zM35.835 16.574c.768.712 1.265 1.896 1.265 3.14 0 2.472-1.768 4.22-4.836 4.22-3.27 0-4.615-2.066-4.615-4.176 0-2.581 1.796-4.34 4.785-4.324 1.65.022 2.774.565 3.4 1.14m-4.977 3.096c0 .762.186 2.083 1.502 2.083 1.124 0 1.486-.926 1.486-2.11 0-.471-.034-2.05-1.503-2.006-1.22.033-1.485 1.157-1.485 2.033M11.052 17.56l-3.124 3.08-2.442 2.37h.857l1.781-1.728h2.894v2.35h-7.6l7.634-7.406zM10.661 15.774H3.386v2.335h2.486l1.809-1.755h.856L6.73 18.109h.018L2.9 21.9v1.402z"
	})));
};

//#endregion
//#region src/ProviderIcon/index.ts
const ProviderIconSVG = {
	Unknown: SvgUnknown,
	Allstream: SvgAllstream,
	APXNet: SvgApxNet,
	ATT: SvgAtt,
	Blu: SvgBlu,
	Cogent: SvgCogent,
	ComcastBusiness: SvgComcastBusiness,
	Cox: SvgCox,
	CradlePoint: SvgCradlePoint,
	CrownCastle: SvgCrownCastle,
	Cruzio: SvgCruzio,
	EarthLink: SvgEarthLink,
	Fastmetrics: SvgFastmetrics,
	For2Fi: SvgFor2Fi,
	Frontier: SvgFrontier,
	Google: SvgGoogle$1,
	GTT: SvgGtt,
	HughesNet: SvgHughesNet,
	Lumen: SvgLumen,
	Metronet: SvgMetronet,
	Monkeybrains: SvgMonkeybrains,
	Pilot: SvgPilot,
	RCN: SvgRcn,
	Sonic: SvgSonic,
	Spectrum: SvgSpectrum,
	TMobile: SvgTMobile,
	Verizon: SvgVerizon,
	Viasat: SvgViasat,
	Videotron: SvgVideotron,
	Wave: SvgWave,
	Webpass: SvgWebpass,
	WiLine: SvgWiLine,
	Windstream: SvgWindstream,
	WOW: SvgWow,
	Xfinity: SvgXfinity,
	Zayo: SvgZayo
};

//#endregion
//#region src/ServiceIcon/icons/AccessPeopleHR.svg
var _path$58;
function _extends$61() {
	return _extends$61 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$61.apply(null, arguments);
}
var SvgAccessPeopleHr = function SvgAccessPeopleHr(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$61({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$58 || (_path$58 = /*#__PURE__*/ React.createElement("path", {
		fill: "#E5173F",
		d: "M18.311 10.142 12.64 5.166a6.6 6.6 0 0 0-4.415-1.66c-3.667 0-6.656 2.98-6.656 6.636s2.989 6.635 6.656 6.635c1.698 0 3.227-.643 4.415-1.659zm-14.738 0a4.65 4.65 0 0 1 4.652-4.638c2.547 0 4.653 2.065 4.653 4.638a4.653 4.653 0 0 1-4.653 4.638 4.65 4.65 0 0 1-3.294-1.354 4.62 4.62 0 0 1-1.358-3.284"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/ADP.svg
var _path$57;
function _extends$60() {
	return _extends$60 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$60.apply(null, arguments);
}
var SvgAdp = function SvgAdp(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$60({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$57 || (_path$57 = /*#__PURE__*/ React.createElement("path", {
		fill: "#D0271D",
		d: "M12.571 10.085a2.61 2.61 0 0 1-2.6 2.6h-1v-1.143h1a1.457 1.457 0 1 0 0-2.914h-1V7.485h1a2.61 2.61 0 0 1 2.6 2.6m-5.542-2.6v2.114h-1.8l-.658 1.143h3.6V7.485zM20 9.113a3.57 3.57 0 0 1-3.571 3.572v1.943h-3.086v-1.515a4.47 4.47 0 0 1-3.4 1.515H7.029v-1.943H4.743L3.6 14.628H0l5.286-9.086H9.97a4.66 4.66 0 0 1 3.4 1.514V5.542h3.086A3.565 3.565 0 0 1 20 9.113M9.971 13.485a3.41 3.41 0 0 0 3.086-1.943h1.457v1.943h.8v-1.943h1.143a2.43 2.43 0 0 0 2.429-2.429 2.45 2.45 0 0 0-2.457-2.428h-1.943v2.914h-1.143A3.43 3.43 0 0 0 9.97 6.685h-4L2 13.485h.943l1.143-1.943H8.17v1.943zm6.458-6h-1.143v1.143h1.143a.483.483 0 0 1 .485.485.5.5 0 0 1-.485.486h-1.143v1.143h1.143a1.63 1.63 0 0 0 1.628-1.629 1.645 1.645 0 0 0-1.628-1.628"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/Airtable.svg
function _extends$59() {
	return _extends$59 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$59.apply(null, arguments);
}
var SvgAirtable = function SvgAirtable(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$59({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 20,
		fill: "none",
		viewBox: "0 0 20 20"
	}, props), /*#__PURE__*/ React.createElement("path", {
		fill: "#FCB400",
		d: "M8.931 1.846 1.475 4.93a.5.5 0 0 0 .006.926l7.488 2.97c.658.26 1.39.26 2.049 0l7.488-2.97a.5.5 0 0 0 .006-.926l-7.456-3.086a2.78 2.78 0 0 0-2.125 0",
		style: {
			fill: "#fcb400",
			fillOpacity: 1
		}
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#18BFFF",
		d: "M10.658 10.448v7.418a.5.5 0 0 0 .684.464l8.344-3.239a.5.5 0 0 0 .315-.464V7.209a.5.5 0 0 0-.684-.464l-8.343 3.238a.5.5 0 0 0-.316.464",
		style: {
			fill: "#18bfff",
			fillOpacity: 1
		}
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#F82B60",
		d: "m8.709 10.83-2.476 1.196-.252.122-5.227 2.504c-.331.16-.754-.081-.754-.45V7.24c0-.133.068-.248.16-.334a.6.6 0 0 1 .126-.095.53.53 0 0 1 .455-.035l7.926 3.14c.403.16.435.725.042.915",
		style: {
			fill: "#f82b60",
			fillOpacity: 1
		}
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#000",
		fillOpacity: .25,
		d: "m8.71 10.83-2.477 1.196L.16 6.906a.6.6 0 0 1 .127-.095.53.53 0 0 1 .454-.035l7.927 3.14c.403.16.434.725.041.915",
		style: {
			fill: "#000",
			fillOpacity: .25
		}
	}));
};

//#endregion
//#region src/ServiceIcon/icons/Apple.svg
var _path$56;
function _extends$58() {
	return _extends$58 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$58.apply(null, arguments);
}
var SvgApple = function SvgApple(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$58({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$56 || (_path$56 = /*#__PURE__*/ React.createElement("path", {
		fill: "#2C333B",
		d: "M15.863 7.67c-.09.07-1.665.967-1.665 2.96 0 2.307 2.005 3.123 2.065 3.143-.01.05-.319 1.117-1.057 2.206-.659.957-1.346 1.913-2.393 1.913s-1.315-.614-2.523-.614c-1.177 0-1.595.634-2.552.634s-1.625-.886-2.393-1.974c-.89-1.277-1.608-3.262-1.608-5.146 0-3.021 1.945-4.623 3.859-4.623 1.017 0 1.865.674 2.503.674.608 0 1.556-.715 2.713-.715.438 0 2.014.04 3.05 1.542m-3.6-2.82c.478-.574.816-1.37.816-2.166a1.5 1.5 0 0 0-.029-.312c-.778.03-1.705.524-2.263 1.178-.439.503-.848 1.3-.848 2.106 0 .121.02.242.03.281.049.01.129.02.209.02.698 0 1.577-.472 2.084-1.108"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/Asana.svg
var _path$55;
function _extends$57() {
	return _extends$57 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$57.apply(null, arguments);
}
var SvgAsana = function SvgAsana(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$57({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 20,
		fill: "none",
		viewBox: "0 0 20 20"
	}, props), _path$55 || (_path$55 = /*#__PURE__*/ React.createElement("path", {
		fill: "#F06A6A",
		fillRule: "evenodd",
		d: "M15.65 10.544a4.35 4.35 0 1 0 0 8.699 4.35 4.35 0 0 0 0-8.7m-11.3 0a4.35 4.35 0 1 0 0 8.699 4.35 4.35 0 0 0 0-8.7m10-5.438a4.35 4.35 0 1 1-8.7 0 4.35 4.35 0 0 1 8.7 0",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/Auth0.svg
var _path$54;
function _extends$56() {
	return _extends$56 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$56.apply(null, arguments);
}
var SvgAuth0 = function SvgAuth0(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$56({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$54 || (_path$54 = /*#__PURE__*/ React.createElement("path", {
		fill: "#000",
		d: "M16.03 9.035c-2.755-.454-4.912-2.73-5.366-5.484l-.002-.002-.152-1.324c-.032-.207.107-.502.373-.482 2.082.162 4.045.848 5.138 1.295.542.223.896.75.896 1.335V8.69c0 .256-.23.452-.482.41zM9.336 3.553c-.454 2.753-2.611 5.03-5.366 5.484v.001l-.405.066a.416.416 0 0 1-.482-.41V4.376c0-.585.354-1.113.896-1.334 1.094-.447 3.056-1.134 5.138-1.296.266-.02.408.272.37.482zM16.028 10.245c-3.763.742-5.511 3.243-5.511 7.98 0 .238.236.402.434.27 1.73-1.167 5.54-4.214 5.932-8.026.013-.393-.387-.314-.68-.255q-.1.021-.175.03M9.482 18.225c0-4.737-1.747-7.238-5.51-7.98q-.076-.01-.175-.03c-.293-.06-.693-.14-.68.254.392 3.812 4.201 6.859 5.932 8.026.197.132.433-.032.433-.27"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/Azure.svg
var _path$53;
var _path2$36;
var _path3$23;
var _path4$16;
var _defs$9;
function _extends$55() {
	return _extends$55 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$55.apply(null, arguments);
}
var SvgAzure = function SvgAzure(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$55({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$53 || (_path$53 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#a)",
		d: "M7.48 3.017h4.475L7.31 16.782a.71.71 0 0 1-.676.485H3.151a.713.713 0 0 1-.676-.94L6.804 3.502a.71.71 0 0 1 .676-.485"
	})), _path2$36 || (_path2$36 = /*#__PURE__*/ React.createElement("path", {
		fill: "#0078D4",
		d: "M13.983 12.25H6.886a.328.328 0 0 0-.224.568l4.56 4.256a.72.72 0 0 0 .49.193h4.018z"
	})), _path3$23 || (_path3$23 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#b)",
		d: "M7.48 3.017a.71.71 0 0 0-.678.494L2.481 16.315a.712.712 0 0 0 .671.952h3.573a.76.76 0 0 0 .586-.498l.862-2.54 3.078 2.87c.13.108.291.167.459.168h4.003l-1.756-5.018-5.118.001 3.132-9.233z"
	})), _path4$16 || (_path4$16 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#c)",
		d: "M13.196 3.501a.71.71 0 0 0-.675-.484H7.533a.71.71 0 0 1 .675.484l4.329 12.826a.713.713 0 0 1-.675.94h4.987a.71.71 0 0 0 .675-.94z"
	})), _defs$9 || (_defs$9 = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
		id: "a",
		x1: 9.111,
		x2: 4.463,
		y1: 4.073,
		y2: 17.803,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#114A8B" }), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#0669BC"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "b",
		x1: 10.563,
		x2: 9.488,
		y1: 10.471,
		y2: 10.835,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopOpacity: .3 }), /*#__PURE__*/ React.createElement("stop", {
		offset: .071,
		stopOpacity: .2
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .321,
		stopOpacity: .1
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .623,
		stopOpacity: .05
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopOpacity: 0
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "c",
		x1: 9.972,
		x2: 15.073,
		y1: 3.672,
		y2: 17.264,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#3CCBF4" }), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#2892DF"
	})))));
};

//#endregion
//#region src/ServiceIcon/icons/BambooHR.svg
var _path$52;
function _extends$54() {
	return _extends$54 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$54.apply(null, arguments);
}
var SvgBambooHr = function SvgBambooHr(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$54({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$52 || (_path$52 = /*#__PURE__*/ React.createElement("path", {
		fill: "#73C41D",
		fillRule: "evenodd",
		d: "M11.356 13.422a1.897 1.897 0 0 1-1.908-1.904c0-1.092.736-1.988 1.924-1.988s1.888.96 1.888 1.968c.004 1.096-.74 1.924-1.904 1.924M8.308 9.81l-.364-1.196c-.216-.628-.284-.992-.896-1.64-.212-.224-1.008-.712-.908-.604 1.008 1.088 1.524 2.408 1.724 2.776-.184-.22-.396-.42-.64-.668a3.5 3.5 0 0 0-.632-.528c-.136-.084-.212-.132-.352-.2a7.3 7.3 0 0 0-1.456-.576c-.284-.072-.56-.088-.56-.088s.9.76 1.288 1.244c.384.484.78.916 1.216 1.096.436.176.588.228.928.28.292.036.652.104.652.104m3.128-1.06c-.952 0-1.464.328-1.82.684l-.096.104V6.346h-.824v5.224c0 1.608 1.236 2.608 2.66 2.608 1.564 0 2.748-1.204 2.748-2.752 0-1.44-1.236-2.676-2.668-2.676M18 10.142c0 4.42-3.58 8-8 8s-8-3.58-8-8 3.58-8 8-8 8 3.58 8 8",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/BreatheHR.svg
var _path$51;
var _path2$35;
function _extends$53() {
	return _extends$53 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$53.apply(null, arguments);
}
var SvgBreatheHr = function SvgBreatheHr(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$53({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$51 || (_path$51 = /*#__PURE__*/ React.createElement("path", {
		fill: "#003E51",
		d: "M10.624 11.73a2.88 2.88 0 0 1 2.769-2.07c1.295 0 2.43.866 2.779 2.1.362.057.696.182 1 .358a3.822 3.822 0 0 0-3.35-5.257 3.824 3.824 0 0 0-7.54 0c-.05 0-.1-.007-.155-.007a3.828 3.828 0 0 0 0 7.654h1.836a2.9 2.9 0 0 1 2.66-2.779"
	})), _path2$35 || (_path2$35 = /*#__PURE__*/ React.createElement("path", {
		fill: "#007DC5",
		d: "m15.813 12.629-.395-.02-.068-.39a1.98 1.98 0 0 0-1.96-1.656c-.974 0-1.796.696-1.962 1.656l-.07.426-.437-.02-.077-.003a1.993 1.993 0 0 0 0 3.983h4.865a1.993 1.993 0 0 0 1.991-1.992c0-1.099-.832-1.93-1.89-1.984"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/CAS.svg
var _circle;
var _path$50;
var _path2$34;
var _path3$22;
var _path4$15;
function _extends$52() {
	return _extends$52 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$52.apply(null, arguments);
}
var SvgCas = function SvgCas(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$52({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _circle || (_circle = /*#__PURE__*/ React.createElement("circle", {
		cx: 9.95,
		cy: 10.18,
		r: 7.938,
		fill: "#077EBD"
	})), _path$50 || (_path$50 = /*#__PURE__*/ React.createElement("path", {
		fill: "#FCFDFD",
		d: "M15.14 6.922q.669-.01 1.29.24c.135.053.196.09.114.257-.12.245-.203.51-.291.77-.056.162-.129.194-.294.122-.464-.201-.946-.284-1.445-.125-.237.075-.41.216-.46.471-.047.248.075.418.258.566.26.212.561.35.845.519.848.508 1.196 1.172 1.022 1.96-.198.902-.92 1.531-1.829 1.67-.5.076-.985.056-1.48-.002-.187-.022-.239-.105-.254-.273q-.04-.428-.109-.852c-.033-.206.022-.27.226-.185.394.163.807.216 1.231.175.387-.038.68-.252.757-.543q.117-.436-.412-.788c-.138-.091-.283-.17-.427-.252a4.5 4.5 0 0 1-.715-.473c-.916-.773-.616-1.984-.058-2.53.566-.554 1.268-.722 2.029-.726zM7.359 12.124c-.182.374-.358.736-.536 1.097a.18.18 0 0 1-.16.1c-.802.018-1.596 0-2.272-.52a2.34 2.34 0 0 1-.94-1.712c-.19-2.129.866-3.43 2.312-3.995a4.07 4.07 0 0 1 2.753-.1c.165.05.219.126.169.284-.007.02-.02.04-.028.06-.086.26-.107.58-.276.766-.192.212-.48-.046-.728-.074-1.986-.22-2.895 1.266-2.72 2.783.117 1.015.91 1.428 1.93 1.323.152-.015.3-.059.496-.013M9.07 11.92q-.287.61-.569 1.225c-.053.117-.138.15-.262.149q-.496-.01-.993.001c-.209.006-.279-.02-.161-.25.644-1.262 1.274-2.534 1.908-3.802.334-.67.673-1.336.998-2.01.082-.17.175-.253.374-.245.374.014.75.008 1.125.002.154-.002.24.03.26.21.13 1.125.27 2.248.403 3.373.015.13-.004.263-.006.395-.425-.06-.835-.214-1.269-.227l-.203-1.964-.068.004-1.026 2.13c-.103.063-.204.129-.31.186a3.4 3.4 0 0 0-.603.402c-.083.07-.131.147-.1.257.036.125.143.077.221.08.103.005.197.02.28.084"
	})), _path2$34 || (_path2$34 = /*#__PURE__*/ React.createElement("path", {
		fill: "#FCFDFD",
		d: "M12.242 11.207c.07.63.131 1.264.216 1.893.02.152 0 .197-.15.194a29 29 0 0 0-1.024 0c-.13.002-.193-.028-.205-.179-.05-.646-.116-1.29-.175-1.936.45-.188.895-.14 1.339.027"
	})), _path3$22 || (_path3$22 = /*#__PURE__*/ React.createElement("path", {
		fill: "#69C064",
		d: "M12.242 11.207c-.443-.168-.888-.217-1.339-.028-.344.072-.614.252-.87.495-.57.543-.45.464-.845.161-.083-.063-.295.004-.397 0-.079-.003-.186.045-.222-.08-.03-.11.018-.188.1-.258.186-.157.39-.288.604-.402.106-.056.206-.123.31-.184a7 7 0 0 1 1.296-.17c.434.012.843.165 1.27.226.17.188.456.198.685.464z"
	})), _path4$15 || (_path4$15 = /*#__PURE__*/ React.createElement("path", {
		fill: "#077EBD",
		d: "M10.88 10.741q-.657.025-1.297.17l1.025-2.13.069-.005z"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/CezanneHR.svg
var _path$49;
var _path2$33;
function _extends$51() {
	return _extends$51 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$51.apply(null, arguments);
}
var SvgCezanneHr = function SvgCezanneHr(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$51({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$49 || (_path$49 = /*#__PURE__*/ React.createElement("path", {
		fill: "#C90144",
		d: "m14.587 13.146-.903-.903-.965-.965a.827.827 0 0 0-1.152 0L9.7 13.146a3.44 3.44 0 0 0 0 4.857 3.44 3.44 0 0 0 4.857 0 3.41 3.41 0 0 0 .031-4.857"
	})), _path2$33 || (_path2$33 = /*#__PURE__*/ React.createElement("path", {
		fill: "#AEB0B1",
		d: "m9.045 12.68 5.542-5.543a3.44 3.44 0 0 0 0-4.857 3.44 3.44 0 0 0-4.857 0L6.617 5.394c-2.678 2.677-2.678 7.036 0 9.745l1.37 1.37c-.343-1.65.311-3.082 1.058-3.83"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/Chrome.svg
var _path$48;
var _path2$32;
var _path3$21;
var _path4$14;
var _path5$9;
var _path6$6;
var _path7$4;
var _path8$4;
var _path9$4;
var _path0$4;
var _path1$4;
var _path10$4;
var _path11$3;
var _path12$2;
var _path13$2;
var _path14$2;
var _path15$2;
var _path16$2;
var _path17$2;
var _path18$2;
var _path19$2;
var _path20$2;
var _path21$2;
var _path22$2;
var _path23$2;
var _path24$2;
var _path25$2;
var _defs$8;
function _extends$50() {
	return _extends$50 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$50.apply(null, arguments);
}
var SvgChrome = function SvgChrome(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$50({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$48 || (_path$48 = /*#__PURE__*/ React.createElement("path", {
		fill: "#DB4437",
		d: "M2.933 5.604v6.443h3.762L10 6.326h7.485A8.4 8.4 0 0 0 10 1.742a8.38 8.38 0 0 0-7.067 3.862"
	})), _path2$32 || (_path2$32 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#a)",
		d: "M2.933 5.604v6.443h3.762L10 6.326h7.485A8.4 8.4 0 0 0 10 1.742a8.38 8.38 0 0 0-7.067 3.862"
	})), _path3$21 || (_path3$21 = /*#__PURE__*/ React.createElement("path", {
		fill: "#3E2723",
		fillOpacity: .15,
		d: "m2.933 5.604 3.772 6.453.082-.05-3.793-6.505c-.02.04-.041.071-.062.102"
	})), _path4$14 || (_path4$14 = /*#__PURE__*/ React.createElement("path", {
		fill: "#0F9D58",
		d: "m9.603 18.522 3.702-3.7v-2.774h-6.61L2.932 5.605A8.3 8.3 0 0 0 1.6 10.137a8.396 8.396 0 0 0 8.003 8.385"
	})), _path5$9 || (_path5$9 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#b)",
		d: "m9.603 18.522 3.702-3.7v-2.774h-6.61L2.932 5.605A8.3 8.3 0 0 0 1.6 10.137a8.396 8.396 0 0 0 8.003 8.385"
	})), _path6$6 || (_path6$6 = /*#__PURE__*/ React.createElement("path", {
		fill: "#263238",
		fillOpacity: .15,
		d: "M9.502 18.522c.03 0 .07 0 .101.01l3.63-6.352-.08-.051z"
	})), _path7$4 || (_path7$4 = /*#__PURE__*/ React.createElement("path", {
		fill: "#FFCD40",
		d: "m9.603 18.522 3.702-3.7v-2.774z"
	})), _path8$4 || (_path8$4 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#c)",
		d: "m9.603 18.522 3.702-3.7v-2.774z"
	})), _path9$4 || (_path9$4 = /*#__PURE__*/ React.createElement("path", {
		fill: "#FFCD40",
		d: "m10 6.326 3.305 5.722-3.702 6.474c.132.01.265.01.397.01 4.637 0 8.4-3.76 8.4-8.395a8.4 8.4 0 0 0-.915-3.811z"
	})), _path0$4 || (_path0$4 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#d)",
		d: "m10 6.326 3.305 5.722-3.702 6.474c.132.01.265.01.397.01 4.637 0 8.4-3.76 8.4-8.395a8.4 8.4 0 0 0-.915-3.811z"
	})), _path1$4 || (_path1$4 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#e)",
		d: "M17.485 6.326H10v1.992z"
	})), _path10$4 || (_path10$4 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#f)",
		d: "m2.933 5.605 3.762 6.443 1.709-.986z"
	})), _path11$3 || (_path11$3 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#g)",
		d: "m13.305 12.048-1.698-.986-2.004 7.46z"
	})), _path12$2 || (_path12$2 = /*#__PURE__*/ React.createElement("path", {
		fill: "#F1F1F1",
		d: "M10 13.948a3.812 3.812 0 1 0 0-7.622 3.812 3.812 0 1 0 0 7.622"
	})), _path13$2 || (_path13$2 = /*#__PURE__*/ React.createElement("path", {
		fill: "#4285F4",
		d: "M10 13.187a3.05 3.05 0 1 0-3.05-3.05 3.05 3.05 0 0 0 3.05 3.05"
	})), _path14$2 || (_path14$2 = /*#__PURE__*/ React.createElement("path", {
		fill: "#3E2723",
		fillOpacity: .2,
		d: "M17.434 6.224H10a3.814 3.814 0 0 0-3.813 3.811v.092A3.814 3.814 0 0 1 10 6.315h7.475c-.01-.03-.02-.06-.04-.091"
	})), _path15$2 || (_path15$2 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		fillOpacity: .1,
		d: "M10.061 13.949H10a3.82 3.82 0 0 1-3.305-1.911L2.932 5.605c-.01.01-.02.03-.03.04l3.793 6.495A3.82 3.82 0 0 0 10 14.05a3.81 3.81 0 0 0 2.715-1.138 3.82 3.82 0 0 1-2.613 1.037c-.02.01-.03 0-.041 0M11.332 13.715"
	})), _path16$2 || (_path16$2 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		fillOpacity: .1,
		d: "M11.525 13.633c.061-.02.112-.051.173-.082-.06.03-.112.061-.173.082M11.15 13.776c.011 0 .022-.011.034-.011-.012 0-.023.011-.034.011M11.77 13.522c.05-.02.091-.051.142-.082-.05.031-.102.051-.142.082"
	})), _path17$2 || (_path17$2 = /*#__PURE__*/ React.createElement("path", {
		fill: "#3E2723",
		d: "M13.803 10.442v-.061q.015.015 0 .06M12.715 12.912l.244-.245.041-.07a4 4 0 0 1-.285.315",
		opacity: .1
	})), _path18$2 || (_path18$2 = /*#__PURE__*/ React.createElement("path", {
		fill: "#3E2723",
		d: "M13.712 9.223c.091.335.142.68.142 1.047 0 .58-.132 1.118-.366 1.616a3.86 3.86 0 0 0 .427-1.748 3.814 3.814 0 0 0-3.813-3.812h-.051a3.82 3.82 0 0 1 3.661 2.897",
		opacity: .1
	})), _path19$2 || (_path19$2 = /*#__PURE__*/ React.createElement("path", {
		fill: "#3E2723",
		d: "M13.783 10.666c0-.02 0-.03.01-.051-.01.02-.01.04-.01.05M11.18 13.765c.051-.02.102-.03.143-.05-.041.02-.092.03-.143.05M11.393 13.695c.041-.02.092-.031.133-.051a.7.7 0 0 0-.133.05M11.902 13.44c.02-.01.03-.02.051-.03-.01.01-.03.02-.05.03M10.05 13.948h.011c.376-.01.742-.072 1.088-.173a3.6 3.6 0 0 1-1.098.173",
		opacity: .1
	})), _path20$2 || (_path20$2 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		fillOpacity: .1,
		d: "M13.305 12.048a3.9 3.9 0 0 1-1.352 1.372c-.02.01-.031.02-.051.03-.051.031-.092.051-.143.082-.02.01-.04.02-.071.04-.05.03-.112.051-.173.082a.7.7 0 0 1-.132.05c-.02.01-.04.02-.061.02-.05.021-.092.031-.142.052-.01 0-.02.01-.03.01a3.5 3.5 0 0 1-1.09.173h.031a3.8 3.8 0 0 0 2.614-1.037c.102-.102.193-.213.285-.325z"
	})), _path21$2 || (_path21$2 = /*#__PURE__*/ React.createElement("path", {
		fill: "#3E2723",
		d: "M13.305 12.048a3.9 3.9 0 0 1-1.352 1.372c-.02.01-.031.02-.051.03-.051.031-.092.051-.143.082-.02.01-.04.02-.071.04-.05.03-.112.051-.173.082a.7.7 0 0 1-.132.05c-.02.01-.04.02-.061.02-.05.021-.092.031-.142.052-.01 0-.02.01-.03.01a3.5 3.5 0 0 1-1.09.173h.031a3.8 3.8 0 0 0 2.614-1.037c.102-.102.193-.213.285-.325z",
		opacity: .1
	})), _path22$2 || (_path22$2 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		fillOpacity: .2,
		d: "M13.712 9.222c-.01-.04-.02-.071-.031-.112.071.244.112.488.132.752v.02c.01.082.01.174.01.255s0 .152-.01.234v.06c0 .062-.01.123-.02.184 0 .02 0 .03-.01.05a3.7 3.7 0 0 1-.478 1.372l-.316.55-.04.07-3.346 5.855h.112l3.63-6.353c.051-.091.102-.193.153-.294a3.7 3.7 0 0 0 .366-1.616 4.4 4.4 0 0 0-.153-1.027"
	})), _path23$2 || (_path23$2 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		fillOpacity: .2,
		d: "M10 1.833c4.627 0 8.37 3.73 8.4 8.345v-.051c0-4.625-3.763-8.385-8.4-8.385s-8.4 3.76-8.4 8.395v.05c.03-4.614 3.773-8.354 8.4-8.354"
	})), _path24$2 || (_path24$2 = /*#__PURE__*/ React.createElement("path", {
		fill: "#3E2723",
		fillOpacity: .15,
		d: "M10 18.44c4.627 0 8.37-3.73 8.4-8.344v.05c0 4.635-3.763 8.396-8.4 8.396s-8.4-3.77-8.4-8.405v-.051C1.63 14.7 5.373 18.44 10 18.44"
	})), _path25$2 || (_path25$2 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#h)",
		d: "M10 18.532c4.64 0 8.4-3.759 8.4-8.395 0-4.637-3.76-8.395-8.4-8.395S1.6 5.5 1.6 10.137s3.76 8.395 8.4 8.395"
	})), _defs$8 || (_defs$8 = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("radialGradient", {
		id: "e",
		cx: 0,
		cy: 0,
		r: 1,
		gradientTransform: "matrix(8.02664 0 0 8.0218 9.636 6.317)",
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", {
		stopColor: "#3E2723",
		stopOpacity: .2
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#3E2723",
		stopOpacity: 0
	})), /*#__PURE__*/ React.createElement("radialGradient", {
		id: "f",
		cx: 0,
		cy: 0,
		r: 1,
		gradientTransform: "matrix(7.45064 0 0 7.44613 2.925 5.608)",
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", {
		stopColor: "#3E2723",
		stopOpacity: .2
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#3E2723",
		stopOpacity: 0
	})), /*#__PURE__*/ React.createElement("radialGradient", {
		id: "g",
		cx: 0,
		cy: 0,
		r: 1,
		gradientTransform: "matrix(8.38868 0 0 8.38361 9.986 10.151)",
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", {
		stopColor: "#263238",
		stopOpacity: .2
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#263238",
		stopOpacity: 0
	})), /*#__PURE__*/ React.createElement("radialGradient", {
		id: "h",
		cx: 0,
		cy: 0,
		r: 1,
		gradientTransform: "matrix(16.8738 0 0 16.8636 4.11 4.033)",
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", {
		stopColor: "#fff",
		stopOpacity: .1
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#fff",
		stopOpacity: 0
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "a",
		x1: 4.13,
		x2: 9.14,
		y1: 8.979,
		y2: 6.051,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", {
		stopColor: "#A52714",
		stopOpacity: .6
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .66,
		stopColor: "#A52714",
		stopOpacity: 0
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "b",
		x1: 11.874,
		x2: 6.307,
		y1: 15.901,
		y2: 12.637,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", {
		stopColor: "#055524",
		stopOpacity: .4
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .33,
		stopColor: "#055524",
		stopOpacity: 0
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "c",
		x1: 9.431,
		x2: 10.832,
		y1: 6.424,
		y2: 12.562,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", {
		stopColor: "#EA6100",
		stopOpacity: .3
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .66,
		stopColor: "#EA6100",
		stopOpacity: 0
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "d",
		x1: 12.162,
		x2: 13.562,
		y1: 5.801,
		y2: 11.938,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", {
		stopColor: "#EA6100",
		stopOpacity: .3
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .66,
		stopColor: "#EA6100",
		stopOpacity: 0
	})))));
};

//#endregion
//#region src/ServiceIcon/icons/ClassLink.svg
var _path$47;
var _path2$31;
var _path3$20;
function _extends$49() {
	return _extends$49 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$49.apply(null, arguments);
}
var SvgClassLink = function SvgClassLink(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$49({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$47 || (_path$47 = /*#__PURE__*/ React.createElement("path", {
		fill: "#0A4D7F",
		d: "M15.89 8.943s1.046-2.592-1.343-4.369c0 0-3.825-2.516-5.958 1.683 0 0-1.53-1.53-3.417-.34-1.615 1.012-1.343 2.38-1.199 3.069 0 0-3.043.892-2.89 4.14.12 2.413 2.448 3.144 3.358 3.331.195.043.4.06.603.06h9.997c.195 0 .39-.017.586-.06.918-.187 3.272-.91 3.23-3.476-.06-3.17-2.966-4.038-2.966-4.038m-6.562 5.823c-2.023-.026-2.745-1.539-2.745-1.539a6 6 0 0 1-.11-.238c-.553-.204-.885-.595-.808-1.181s.74-1.165.74-1.165c.382-1.19 1.249-2.006 1.249-2.006s.722-.773 1.521-1.173l1.377.213c-3.119 1.275-3.28 3.901-3.28 3.901-.018.4.025.731.118 1.02.23-.017.4-.042.4-.042a8 8 0 0 0 1.997-.57c-.017-.518-.255-.646-.255-.646s-.28-.323-1.445-.51l.111-.153s.578.128 1.224 0c.705-.136 1.36-.62 2.082-1.615l.349-.017c-.705.935-.756 1.65-.637 2.117.705-.527 1.037-.986 1.037-.986 1.274-1.777-.494-1.505-.494-1.505l.527-.629c2.704.587.222 3.026.222 3.026a5.5 5.5 0 0 1-.927.765c.043.051.51.527 1.411.96.238-.254.357-.433.357-.433l.357.068c-2.091 2.525-4.378 2.338-4.378 2.338M10.29 9.7a.567.567 0 1 1-1.13-.051.567.567 0 1 1 1.13.05"
	})), _path2$31 || (_path2$31 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M9.328 14.766c-2.023-.026-2.745-1.539-2.745-1.539-.043-.085-.077-.161-.11-.238-.553-.204-.885-.595-.808-1.181s.74-1.165.74-1.165c.382-1.19 1.249-2.006 1.249-2.006s.722-.773 1.521-1.173l1.377.213c-3.119 1.275-3.28 3.901-3.28 3.901-.018.4.025.731.118 1.02.23-.017.4-.042.4-.042a8 8 0 0 0 1.997-.57c-.017-.518-.255-.646-.255-.646s-.28-.323-1.445-.51l.111-.153s.578.128 1.224 0c.705-.136 1.36-.62 2.082-1.615l.349-.017c-.705.935-.756 1.65-.637 2.117.705-.527 1.037-.986 1.037-.986 1.274-1.777-.494-1.505-.494-1.505l.527-.629c2.704.587.222 3.026.222 3.026a5.5 5.5 0 0 1-.927.765c.043.051.51.527 1.411.96.238-.254.357-.433.357-.433l.357.068c-2.091 2.525-4.378 2.338-4.378 2.338"
	})), _path3$20 || (_path3$20 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M10.289 9.7a.567.567 0 1 1-1.13-.051.567.567 0 1 1 1.13.05"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/Cloudflare.svg
var _g$1;
var _defs$7;
function _extends$48() {
	return _extends$48 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$48.apply(null, arguments);
}
var SvgCloudflare = function SvgCloudflare(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$48({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _g$1 || (_g$1 = /*#__PURE__*/ React.createElement("g", { clipPath: "url(#a)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "#F4801F",
		d: "m13.07 13.817.086-.297c.102-.351.065-.676-.107-.916-.16-.22-.422-.35-.742-.364l-6.056-.077a.12.12 0 0 1-.116-.104.1.1 0 0 1 .008-.055.16.16 0 0 1 .14-.107l6.115-.08c.722-.033 1.51-.619 1.786-1.334l.348-.906a.2.2 0 0 0 .01-.123 3.96 3.96 0 0 0-1.315-2.16 3.993 3.993 0 0 0-6.343 1.75 1.798 1.798 0 0 0-2.742.792c-.133.344-.155.72-.064 1.077a2.55 2.55 0 0 0-1.884.903 2.53 2.53 0 0 0-.567 2.003.12.12 0 0 0 .116.101H12.93a.15.15 0 0 0 .142-.104"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#F9AB41",
		d: "M15.089 9.645q-.08 0-.168.005a.1.1 0 0 0-.026.006.1.1 0 0 0-.061.064l-.24.818c-.103.352-.066.677.107.916a.93.93 0 0 0 .74.365l1.293.08a.117.117 0 0 1 .105.159.16.16 0 0 1-.14.107l-1.342.08c-.73.033-1.514.618-1.79 1.332l-.096.252a.072.072 0 0 0 .063.098h4.621a.125.125 0 0 0 .124-.094 3.28 3.28 0 0 0-.55-2.88 3.31 3.31 0 0 0-2.638-1.308z"
	}))), _defs$7 || (_defs$7 = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", { id: "a" }, /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M1.6 6.362h16.8v7.56H1.6z"
	})))));
};

//#endregion
//#region src/ServiceIcon/icons/CyberArk.svg
var _path$46;
var _path2$30;
var _path3$19;
var _path4$13;
var _path5$8;
var _path6$5;
function _extends$47() {
	return _extends$47 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$47.apply(null, arguments);
}
var SvgCyberArk = function SvgCyberArk(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$47({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$46 || (_path$46 = /*#__PURE__*/ React.createElement("path", {
		fill: "#4C8ECC",
		fillRule: "evenodd",
		d: "m6.797 8.293 3.247-1.88V2.442L3.35 6.31z",
		clipRule: "evenodd"
	})), _path2$30 || (_path2$30 = /*#__PURE__*/ React.createElement("path", {
		fill: "#2F74B0",
		fillRule: "evenodd",
		d: "m10.05 13.917 3.252-1.877 3.439-1.988v3.973l-6.685 3.862zm-.006-7.504 3.251 1.877 3.437-1.987-6.689-3.86z",
		clipRule: "evenodd"
	})), _path3$19 || (_path3$19 = /*#__PURE__*/ React.createElement("path", {
		fill: "#4C8ECC",
		fillRule: "evenodd",
		d: "m10.051 13.917-3.254-1.873-3.436 1.99 6.695 3.853z",
		clipRule: "evenodd"
	})), _path4$13 || (_path4$13 = /*#__PURE__*/ React.createElement("path", {
		fill: "#2F74B0",
		fillRule: "evenodd",
		d: "M6.797 12.044v-3.75L3.35 6.31l.01 7.723z",
		clipRule: "evenodd"
	})), _path5$8 || (_path5$8 = /*#__PURE__*/ React.createElement("path", {
		fill: "#808183",
		fillRule: "evenodd",
		d: "m10.044 6.412 3.251 1.878v3.754l-3.251-1.877z",
		clipRule: "evenodd"
	})), _path6$5 || (_path6$5 = /*#__PURE__*/ React.createElement("path", {
		fill: "#5A5A5D",
		fillRule: "evenodd",
		d: "M10.044 6.412 6.797 8.293v3.75l3.247-1.876z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/Datadog.svg
var _path$45;
function _extends$46() {
	return _extends$46 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$46.apply(null, arguments);
}
var SvgDatadog = function SvgDatadog(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$46({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$45 || (_path$45 = /*#__PURE__*/ React.createElement("path", {
		fill: "#632CA6",
		fillRule: "evenodd",
		d: "m15.275 13.67-1.391-.921-1.16 1.947-1.35-.396-1.19 1.822.062.574 6.462-1.197-.375-4.056zM9.25 11.922l1.037-.144c.167.076.284.105.485.156.313.082.676.16 1.213-.111.125-.062.385-.301.49-.438l4.249-.774.433 5.27-7.278 1.317zm7.89-1.9-.419.081-.805-8.361L2.188 3.34 3.88 17.127l1.606-.234c-.128-.184-.328-.407-.67-.692-.472-.395-.305-1.066-.026-1.49.37-.715 2.272-1.625 2.164-2.769-.038-.416-.104-.957-.488-1.328a1.3 1.3 0 0 0 .011.302s-.158-.202-.236-.478c-.079-.106-.14-.14-.223-.28-.059.163-.051.352-.051.352s-.13-.306-.15-.565c-.077.116-.096.336-.096.336s-.168-.483-.13-.743c-.076-.227-.303-.676-.239-1.697.42.295 1.341.225 1.7-.307.12-.177.202-.658-.059-1.605-.167-.608-.582-1.513-.743-1.857l-.02.014c.086.277.261.857.329 1.138.203.853.258 1.15.162 1.543-.081.342-.276.565-.771.815-.495.251-1.152-.36-1.194-.393-.481-.385-.853-1.013-.895-1.318-.043-.334.192-.534.31-.807-.17.048-.358.135-.358.135s.225-.235.503-.437c.115-.077.183-.126.304-.227-.175-.003-.318.002-.318.002s.293-.159.596-.274c-.222-.01-.434-.002-.434-.002s.653-.293 1.169-.509c.355-.146.702-.103.896.18.256.37.524.572 1.093.697.35-.156.456-.236.895-.356.387-.427.69-.482.69-.482s-.15.139-.19.357c.218-.174.459-.319.459-.319s-.093.116-.18.299l.02.03c.256-.154.556-.276.556-.276s-.086.11-.186.25c.192 0 .583.01.735.026.896.02 1.082-.96 1.425-1.084.43-.154.623-.248 1.357.476.63.621 1.12 1.734.877 1.983-.205.207-.609-.08-1.056-.641a2.43 2.43 0 0 1-.5-1.094c-.07-.376-.345-.595-.345-.595s.16.357.16.672c0 .172.02.816.295 1.177-.027.052-.04.26-.07.3-.319-.387-1.005-.665-1.117-.747.379.312 1.25 1.028 1.584 1.714.316.65.13 1.244.29 1.398.045.044.68.839.801 1.238.213.695.013 1.426-.266 1.88l-.778.121c-.114-.031-.19-.047-.293-.107.057-.1.168-.35.17-.4l-.044-.078c-.242.344-.648.679-.985.871-.441.251-.95.213-1.281.11-.94-.291-1.828-.93-2.042-1.097 0 0-.007.134.034.164.236.268.78.754 1.304 1.092l-1.118.124.528 4.135c-.234.034-.27.05-.527.087-.226-.802-.659-1.326-1.132-1.632-.417-.269-.992-.33-1.542-.22l-.036.041a1.98 1.98 0 0 1 1.3.311c.455.29.822 1.037.957 1.487.173.575.293 1.19-.173 1.843-.331.463-1.299.72-2.08.165.208.338.49.613.87.665.564.077 1.1-.02 1.468-.4.315-.326.482-1.005.438-1.72l.497-.073.18 1.284 8.241-.997zm-5.013-3.487c-.023.053-.06.088-.005.26l.003.009.009.022.023.052c.097.2.205.39.384.487a1 1 0 0 1 .145-.016.66.66 0 0 1 .342.056.7.7 0 0 0 .004-.156c-.013-.254.05-.687-.437-.915-.184-.086-.441-.06-.527.048a.2.2 0 0 1 .04.009c.13.045.042.09.019.144M13.49 8.91c-.063-.036-.362-.022-.572.003-.4.048-.83.187-.925.261-.172.133-.094.366.033.462.356.267.668.446.998.402.202-.026.38-.348.507-.64.086-.201.086-.418-.04-.488M9.953 6.85c.113-.107-.561-.248-1.084.11-.386.264-.398.83-.03 1.152a1 1 0 0 0 .097.073q.16-.078.372-.15a3.3 3.3 0 0 1 .6-.139c.079-.087.17-.242.147-.521-.031-.38-.317-.32-.102-.525",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/Docusign.svg
var _path$44;
var _path2$29;
function _extends$45() {
	return _extends$45 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$45.apply(null, arguments);
}
var SvgDocusign = function SvgDocusign(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$45({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 20,
		fill: "none",
		viewBox: "0 0 20 20"
	}, props), _path$44 || (_path$44 = /*#__PURE__*/ React.createElement("path", {
		fill: "#D5FF00",
		d: "M20 0H0v20h20z"
	})), _path2$29 || (_path2$29 = /*#__PURE__*/ React.createElement("path", {
		fill: "#000",
		d: "M17.221 15.28H2.777v1.943h14.444zM10.001 14.167l1.376-1.373 4.18-4.183-1.39-1.39-3.194 3.197V2.499H9.027l.003 7.919-3.196-3.196L4.445 8.61l4.18 4.183z"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/Duo.svg
var _path$43;
var _path2$28;
var _path3$18;
function _extends$44() {
	return _extends$44 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$44.apply(null, arguments);
}
var SvgDuo = function SvgDuo(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$44({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$43 || (_path$43 = /*#__PURE__*/ React.createElement("path", {
		fill: "#63C43F",
		d: "M10 18.142a8 8 0 1 0 0-16 8 8 0 0 0 0 16"
	})), _path2$28 || (_path2$28 = /*#__PURE__*/ React.createElement("path", {
		fill: "#E8F4E2",
		d: "M10.503 14.648H6V10.37h9a4.503 4.503 0 0 1-4.497 4.278"
	})), _path3$18 || (_path3$18 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M10.503 5.642H6v4.277h9a4.503 4.503 0 0 0-4.497-4.277"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/Figma.svg
var _path$42;
var _path2$27;
var _path3$17;
var _path4$12;
var _path5$7;
function _extends$43() {
	return _extends$43 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$43.apply(null, arguments);
}
var SvgFigma = function SvgFigma(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$43({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$42 || (_path$42 = /*#__PURE__*/ React.createElement("path", {
		fill: "#1ABCFE",
		d: "M10 10.142a2.8 2.8 0 1 1 5.6 0 2.8 2.8 0 0 1-5.6 0"
	})), _path2$27 || (_path2$27 = /*#__PURE__*/ React.createElement("path", {
		fill: "#0ACF83",
		d: "M4.4 15.742a2.8 2.8 0 0 1 2.8-2.8H10v2.8a2.8 2.8 0 0 1-5.6 0"
	})), _path3$17 || (_path3$17 = /*#__PURE__*/ React.createElement("path", {
		fill: "#FF7262",
		d: "M10 1.742v5.6h2.8a2.8 2.8 0 0 0 0-5.6z"
	})), _path4$12 || (_path4$12 = /*#__PURE__*/ React.createElement("path", {
		fill: "#F24E1E",
		d: "M4.4 4.542a2.8 2.8 0 0 0 2.8 2.8H10v-5.6H7.2a2.8 2.8 0 0 0-2.8 2.8"
	})), _path5$7 || (_path5$7 = /*#__PURE__*/ React.createElement("path", {
		fill: "#A259FF",
		d: "M4.4 10.142a2.8 2.8 0 0 0 2.8 2.8H10v-5.6H7.2a2.8 2.8 0 0 0-2.8 2.8"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/Firebase.svg
var _path$41;
var _path2$26;
var _path3$16;
var _path4$11;
var _path5$6;
var _path6$4;
var _defs$6;
function _extends$42() {
	return _extends$42 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$42.apply(null, arguments);
}
var SvgFirebase = function SvgFirebase(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$42({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$41 || (_path$41 = /*#__PURE__*/ React.createElement("path", {
		fill: "#FFA000",
		d: "M3.853 15.32 5.951 1.9a.387.387 0 0 1 .724-.122l2.169 4.045.864-1.646a.387.387 0 0 1 .686 0l5.853 11.143z"
	})), _path2$26 || (_path2$26 = /*#__PURE__*/ React.createElement("path", {
		fill: "#F57C00",
		d: "M11.099 10.093 8.843 5.82l-4.99 9.5z"
	})), _path3$16 || (_path3$16 = /*#__PURE__*/ React.createElement("path", {
		fill: "#FFCA28",
		d: "M16.247 15.32 14.64 5.38a.388.388 0 0 0-.655-.209L3.853 15.321l5.606 3.143c.352.197.781.197 1.133 0z"
	})), _path4$11 || (_path4$11 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		fillOpacity: .2,
		d: "M14.64 5.38a.388.388 0 0 0-.655-.209l-2.011 2.016-1.581-3.01a.387.387 0 0 0-.686 0l-.864 1.646-2.17-4.045a.387.387 0 0 0-.723.124L3.853 15.32h-.006l.006.008.055.027L13.983 5.27a.387.387 0 0 1 .656.21l1.593 9.85.016-.01zM3.872 15.302 5.95 1.996a.387.387 0 0 1 .724-.123l2.169 4.045.864-1.646a.387.387 0 0 1 .686 0l1.549 2.946z"
	})), _path5$6 || (_path5$6 = /*#__PURE__*/ React.createElement("path", {
		fill: "#A52714",
		d: "M10.592 18.37c-.352.196-.78.196-1.133 0l-5.592-3.136-.014.086 5.606 3.143c.352.197.781.197 1.133 0l5.655-3.143-.015-.089z",
		opacity: .2
	})), _path6$4 || (_path6$4 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#a)",
		d: "M14.624 5.382a.387.387 0 0 0-.653-.209l-2.004 2.015-1.575-3.008a.386.386 0 0 0-.684 0l-.861 1.645L6.686 1.78a.386.386 0 0 0-.722.124L3.875 15.318l5.586 3.141c.351.197.778.197 1.13 0l5.634-3.141z"
	})), _defs$6 || (_defs$6 = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
		id: "a",
		x1: 3.444,
		x2: 18.856,
		y1: 4.475,
		y2: 12.605,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", {
		stopColor: "#fff",
		stopOpacity: .1
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .14,
		stopColor: "#fff",
		stopOpacity: .08
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .61,
		stopColor: "#fff",
		stopOpacity: .02
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#fff",
		stopOpacity: 0
	})))));
};

//#endregion
//#region src/ServiceIcon/icons/Firefox.svg
var _path$40;
var _path2$25;
var _path3$15;
var _path4$10;
var _path5$5;
var _path6$3;
var _path7$3;
var _path8$3;
var _path9$3;
var _path0$3;
var _path1$3;
var _path10$3;
var _defs$5;
function _extends$41() {
	return _extends$41 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$41.apply(null, arguments);
}
var SvgFirefox = function SvgFirefox(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$41({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$40 || (_path$40 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#a)",
		d: "M17.407 7.433c-.347-.836-1.052-1.738-1.604-2.024a8.3 8.3 0 0 1 .81 2.426l.001.014c-.904-2.253-2.436-3.163-3.688-5.141q-.096-.149-.188-.306a3 3 0 0 1-.089-.165 1.5 1.5 0 0 1-.124-.33.02.02 0 0 0-.013-.008h-.015l-.004.003-.006.003.003-.006C10.482 3.075 9.8 5.252 9.738 6.341a4 4 0 0 0-2.2.848 2 2 0 0 0-.207-.156 3.7 3.7 0 0 1-.023-1.955 5.9 5.9 0 0 0-1.924 1.488H5.38c-.317-.402-.294-1.726-.276-2.003a1.4 1.4 0 0 0-.267.142q-.42.3-.782.67a7 7 0 0 0-.747.896v.001-.001a6.8 6.8 0 0 0-1.073 2.422l-.01.052c-.016.07-.07.423-.08.5l-.001.017q-.105.547-.13 1.102v.042a7.996 7.996 0 0 0 15.875 1.352q.019-.154.036-.31a8.2 8.2 0 0 0-.519-4.016zm-9.215 6.259q.054.028.11.054l.006.004zm8.423-5.841v-.008l.001.009z"
	})), _path2$25 || (_path2$25 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#b)",
		d: "M17.407 7.433c-.347-.836-1.052-1.738-1.604-2.024.394.762.667 1.58.81 2.426v.008l.001.008a7.24 7.24 0 0 1-.248 5.397c-.917 1.966-3.134 3.982-6.606 3.883-3.75-.107-7.055-2.89-7.672-6.536-.113-.575 0-.866.056-1.334q-.116.546-.128 1.104v.04a7.996 7.996 0 0 0 15.874 1.353q.02-.153.037-.31a8.2 8.2 0 0 0-.52-4.016z"
	})), _path3$15 || (_path3$15 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#c)",
		d: "M17.407 7.433c-.347-.836-1.052-1.738-1.604-2.024.394.762.667 1.58.81 2.426v.008l.001.008a7.24 7.24 0 0 1-.248 5.397c-.917 1.966-3.134 3.982-6.606 3.883-3.75-.107-7.055-2.89-7.672-6.536-.113-.575 0-.866.056-1.334q-.116.546-.128 1.104v.04a7.996 7.996 0 0 0 15.874 1.353q.02-.153.037-.31a8.2 8.2 0 0 0-.52-4.016z"
	})), _path4$10 || (_path4$10 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#d)",
		d: "m13.52 8.372.05.036c-.2-.356-.45-.682-.742-.968-2.486-2.486-.652-5.389-.342-5.537l.003-.005C10.48 3.074 9.799 5.25 9.737 6.34c.093-.007.185-.015.28-.015a4.04 4.04 0 0 1 3.504 2.046"
	})), _path5$5 || (_path5$5 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#e)",
		d: "M10.022 8.869c-.013.199-.716.885-.962.885-2.273 0-2.642 1.375-2.642 1.375.1 1.158.907 2.112 1.883 2.616q.067.034.135.064.117.053.235.096c.334.119.685.186 1.04.201 3.986.187 4.757-4.765 1.881-6.203a2.76 2.76 0 0 1 1.928.468 4.04 4.04 0 0 0-3.503-2.046c-.095 0-.188.008-.28.014a4 4 0 0 0-2.202.848c.122.103.26.241.55.527.542.534 1.933 1.088 1.936 1.153z"
	})), _path6$3 || (_path6$3 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#f)",
		d: "M10.022 8.869c-.013.199-.716.885-.962.885-2.273 0-2.642 1.375-2.642 1.375.1 1.158.907 2.112 1.883 2.616q.067.034.135.064.117.053.235.096c.334.119.685.186 1.04.201 3.986.187 4.757-4.765 1.881-6.203a2.76 2.76 0 0 1 1.928.468 4.04 4.04 0 0 0-3.503-2.046c-.095 0-.188.008-.28.014a4 4 0 0 0-2.202.848c.122.103.26.241.55.527.542.534 1.933 1.088 1.936 1.153z"
	})), _path7$3 || (_path7$3 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#g)",
		d: "m7.163 6.923.165.11a3.7 3.7 0 0 1-.023-1.954 5.9 5.9 0 0 0-1.924 1.487c.039 0 1.198-.022 1.782.357"
	})), _path8$3 || (_path8$3 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#h)",
		d: "M2.087 10.596c.617 3.645 3.921 6.43 7.672 6.535 3.471.098 5.69-1.917 6.605-3.883.776-1.699.865-3.633.249-5.396v-.015l.001.013c.284 1.852-.658 3.645-2.13 4.86l-.005.01c-2.87 2.338-5.616 1.41-6.17 1.032l-.117-.058c-1.673-.8-2.364-2.323-2.215-3.63a2.05 2.05 0 0 1-1.894-1.192 3.02 3.02 0 0 1 2.94-.118c.946.43 2.023.472 3 .118-.002-.065-1.394-.619-1.936-1.153-.29-.286-.428-.424-.55-.527a2 2 0 0 0-.206-.156q-.069-.048-.165-.11c-.583-.379-1.743-.358-1.781-.357H5.38c-.317-.402-.295-1.726-.276-2.003a1.4 1.4 0 0 0-.267.142q-.421.3-.782.67a7 7 0 0 0-.75.894 6.8 6.8 0 0 0-1.073 2.422c-.004.016-.288 1.258-.148 1.902z"
	})), _path9$3 || (_path9$3 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#i)",
		d: "M12.827 7.44c.292.286.542.612.743.969q.067.05.12.098c1.813 1.671.863 4.033.792 4.2 1.473-1.213 2.414-3.008 2.131-4.86-.904-2.255-2.438-3.165-3.688-5.143a10 10 0 0 1-.189-.306 3 3 0 0 1-.088-.165 1.5 1.5 0 0 1-.124-.33.02.02 0 0 0-.013-.008h-.015l-.004.003-.006.003c-.31.147-2.144 3.05.342 5.535z"
	})), _path0$3 || (_path0$3 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#j)",
		d: "M13.69 8.508a2 2 0 0 0-.12-.098l-.05-.037a2.76 2.76 0 0 0-1.928-.468c2.876 1.438 2.105 6.389-1.88 6.203a3.6 3.6 0 0 1-1.041-.2 4 4 0 0 1-.235-.097q-.068-.029-.135-.064l.006.004c.555.379 3.3 1.306 6.17-1.032l.005-.01c.071-.167 1.02-2.53-.793-4.2z"
	})), _path1$3 || (_path1$3 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#k)",
		d: "M6.418 11.128s.369-1.376 2.643-1.376c.245 0 .948-.686.961-.884a3.98 3.98 0 0 1-3.001-.118 3.02 3.02 0 0 0-2.94.118 2.05 2.05 0 0 0 1.894 1.19c-.148 1.308.543 2.831 2.215 3.632q.056.028.111.054c-.976-.504-1.782-1.458-1.883-2.616"
	})), _path10$3 || (_path10$3 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#l)",
		d: "M17.407 7.433c-.347-.836-1.052-1.738-1.604-2.024.394.762.667 1.58.81 2.426l.001.014c-.904-2.253-2.436-3.163-3.688-5.141q-.096-.149-.189-.306a3 3 0 0 1-.088-.165 1.5 1.5 0 0 1-.124-.33.02.02 0 0 0-.013-.008.03.03 0 0 0-.015 0l-.004.003-.006.003.003-.006C10.482 3.075 9.8 5.252 9.738 6.341c.094-.006.186-.014.281-.014a4.04 4.04 0 0 1 3.503 2.045 2.76 2.76 0 0 0-1.928-.468c2.876 1.438 2.105 6.39-1.88 6.204a3.6 3.6 0 0 1-1.041-.201 4 4 0 0 1-.37-.16l.006.003-.117-.058q.056.028.111.054c-.976-.504-1.782-1.458-1.883-2.615 0 0 .369-1.376 2.642-1.376.246 0 .95-.686.962-.885-.003-.064-1.395-.618-1.937-1.153-.29-.285-.428-.423-.55-.526a2 2 0 0 0-.206-.157A3.7 3.7 0 0 1 7.31 5.08a5.9 5.9 0 0 0-1.925 1.487h-.003c-.317-.401-.295-1.726-.277-2.002a1.4 1.4 0 0 0-.267.141q-.42.3-.781.67a7 7 0 0 0-.748.897 6.8 6.8 0 0 0-1.072 2.421l-.011.053c-.015.07-.083.428-.092.505a9 9 0 0 0-.118 1.114v.041a7.996 7.996 0 0 0 15.874 1.352l.036-.309a8.2 8.2 0 0 0-.518-4.017"
	})), _defs$5 || (_defs$5 = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("radialGradient", {
		id: "b",
		cx: 0,
		cy: 0,
		r: 1,
		gradientTransform: "translate(15.835 3.755)scale(16.6686)",
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", {
		offset: .129,
		stopColor: "#FFBD4F"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .186,
		stopColor: "#FFAC31"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .247,
		stopColor: "#FF9D17"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .283,
		stopColor: "#FF980E"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .403,
		stopColor: "#FF563B"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .467,
		stopColor: "#FF3750"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .71,
		stopColor: "#F5156C"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .782,
		stopColor: "#EB0878"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .86,
		stopColor: "#E50080"
	})), /*#__PURE__*/ React.createElement("radialGradient", {
		id: "c",
		cx: 0,
		cy: 0,
		r: 1,
		gradientTransform: "translate(9.646 10.563)scale(16.6686)",
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", {
		offset: .3,
		stopColor: "#960E18"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .351,
		stopColor: "#B11927",
		stopOpacity: .74
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .435,
		stopColor: "#DB293D",
		stopOpacity: .343
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .497,
		stopColor: "#F5334B",
		stopOpacity: .094
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .53,
		stopColor: "#FF3750",
		stopOpacity: 0
	})), /*#__PURE__*/ React.createElement("radialGradient", {
		id: "d",
		cx: 0,
		cy: 0,
		r: 1,
		gradientTransform: "translate(11.71 .041)scale(12.0744)",
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", {
		offset: .132,
		stopColor: "#FFF44F"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .252,
		stopColor: "#FFDC3E"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .506,
		stopColor: "#FF9D12"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .526,
		stopColor: "#FF980E"
	})), /*#__PURE__*/ React.createElement("radialGradient", {
		id: "e",
		cx: 0,
		cy: 0,
		r: 1,
		gradientTransform: "matrix(7.93614 0 0 7.93613 7.79 14.895)",
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", {
		offset: .353,
		stopColor: "#3A8EE6"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .472,
		stopColor: "#5C79F0"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .669,
		stopColor: "#9059FF"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#C139E6"
	})), /*#__PURE__*/ React.createElement("radialGradient", {
		id: "f",
		cx: 0,
		cy: 0,
		r: 1,
		gradientTransform: "rotate(-13.592 43.54 -39.29)scale(4.20842 4.92701)",
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", {
		offset: .206,
		stopColor: "#9059FF",
		stopOpacity: 0
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .278,
		stopColor: "#8C4FF3",
		stopOpacity: .064
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .747,
		stopColor: "#7716A8",
		stopOpacity: .45
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .975,
		stopColor: "#6E008B",
		stopOpacity: .6
	})), /*#__PURE__*/ React.createElement("radialGradient", {
		id: "g",
		cx: 0,
		cy: 0,
		r: 1,
		gradientTransform: "translate(9.44 3.136)scale(5.71022)",
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#FFE226" }), /*#__PURE__*/ React.createElement("stop", {
		offset: .121,
		stopColor: "#FFDB27"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .295,
		stopColor: "#FFC82A"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .502,
		stopColor: "#FFA930"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .732,
		stopColor: "#FF7E37"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .792,
		stopColor: "#FF7139"
	})), /*#__PURE__*/ React.createElement("radialGradient", {
		id: "h",
		cx: 0,
		cy: 0,
		r: 1,
		gradientTransform: "translate(13.979 -.577)scale(24.3633)",
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", {
		offset: .113,
		stopColor: "#FFF44F"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .456,
		stopColor: "#FF980E"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .622,
		stopColor: "#FF5634"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .716,
		stopColor: "#FF3647"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .904,
		stopColor: "#E31587"
	})), /*#__PURE__*/ React.createElement("radialGradient", {
		id: "i",
		cx: 0,
		cy: 0,
		r: 1,
		gradientTransform: "matrix(1.87367 17.75521 -11.6526 1.22967 11.954 .773)",
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#FFF44F" }), /*#__PURE__*/ React.createElement("stop", {
		offset: .06,
		stopColor: "#FFE847"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .168,
		stopColor: "#FFC830"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .304,
		stopColor: "#FF980E"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .356,
		stopColor: "#FF8B16"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .455,
		stopColor: "#FF672A"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .57,
		stopColor: "#FF3647"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .737,
		stopColor: "#E31587"
	})), /*#__PURE__*/ React.createElement("radialGradient", {
		id: "j",
		cx: 0,
		cy: 0,
		r: 1,
		gradientTransform: "translate(9.44 5.199)scale(15.208)",
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", {
		offset: .137,
		stopColor: "#FFF44F"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .48,
		stopColor: "#FF980E"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .592,
		stopColor: "#FF5634"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .655,
		stopColor: "#FF3647"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .904,
		stopColor: "#E31587"
	})), /*#__PURE__*/ React.createElement("radialGradient", {
		id: "k",
		cx: 0,
		cy: 0,
		r: 1,
		gradientTransform: "translate(13.36 6.024)scale(16.6459)",
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", {
		offset: .094,
		stopColor: "#FFF44F"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .231,
		stopColor: "#FFE141"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .509,
		stopColor: "#FFAF1E"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .626,
		stopColor: "#FF980E"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "a",
		x1: 16.349,
		x2: 3.075,
		y1: 4.453,
		y2: 17.26,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", {
		offset: .048,
		stopColor: "#FFF44F"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .111,
		stopColor: "#FFE847"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .225,
		stopColor: "#FFC830"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .368,
		stopColor: "#FF980E"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .401,
		stopColor: "#FF8B16"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .462,
		stopColor: "#FF672A"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .534,
		stopColor: "#FF3647"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .705,
		stopColor: "#E31587"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "l",
		x1: 16.188,
		x2: 4.895,
		y1: 4.385,
		y2: 15.68,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", {
		offset: .167,
		stopColor: "#FFF44F",
		stopOpacity: .8
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .266,
		stopColor: "#FFF44F",
		stopOpacity: .634
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .489,
		stopColor: "#FFF44F",
		stopOpacity: .217
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .6,
		stopColor: "#FFF44F",
		stopOpacity: 0
	})))));
};

//#endregion
//#region src/ServiceIcon/icons/Fourth.svg
var _path$39;
var _path2$24;
var _path3$14;
var _path4$9;
var _path5$4;
function _extends$40() {
	return _extends$40 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$40.apply(null, arguments);
}
var SvgFourth = function SvgFourth(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$40({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$39 || (_path$39 = /*#__PURE__*/ React.createElement("path", {
		fill: "#002072",
		d: "M4.072 10.917c.495-.173 1.028-.141 1.542-.122-.114.103-.268.136-.399.21-.529.284-.876.87-.875 1.476 0 1.137-.007 2.274.004 3.411.465.047.931-.004 1.397.004h2.076a1.68 1.68 0 0 0 1.403-.789c.088-.143.146-.3.235-.443.018.524.069 1.076-.14 1.572a2.27 2.27 0 0 1-2.04 1.438H4.436c-.583.02-1.167.018-1.75.009-.104.012-.135-.107-.123-.187V12.7c-.001-.41.199-.79.463-1.09a2.5 2.5 0 0 1 1.045-.693m10.51-.216c.573-.063 1.191-.063 1.718.208a2.3 2.3 0 0 1 1.26 2.01c-.002 1.541.004 3.084-.003 4.626.018.08-.067.113-.13.113-1.64.013-3.278-.007-4.916-.014-.4-.027-.755-.258-1.038-.53a2.54 2.54 0 0 1-.734-1.715c0-.274-.012-.55.013-.823.117.155.156.351.267.51.296.468.83.774 1.382.77 1.132-.003 2.264.003 3.396-.004.006-1.162 0-2.323.004-3.485A1.72 1.72 0 0 0 15.119 11c-.163-.127-.36-.196-.537-.3M2.564 2.888c-.012-.082.018-.205.124-.192a33 33 0 0 1 1.694.01H7.27a2.27 2.27 0 0 1 1.94 1.206c.17.328.267.696.259 1.067-.008.243.024.491-.035.73-.22-.65-.804-1.18-1.498-1.222-.858-.01-1.715.001-2.573-.004-.34-.012-.681-.03-1.02.004-.01 1.138-.004 2.277-.004 3.416.001.563.3 1.108.77 1.41.157.113.356.147.507.27-.62.034-1.276.052-1.843-.243-.61-.308-1.165-.887-1.207-1.606-.004-1.615 0-3.231-.003-4.846m8.258 1.22a2.29 2.29 0 0 1 2.122-1.417c1.536.01 3.073-.016 4.608.013.019 1.64.001 3.282.009 4.922.017.432-.192.84-.474 1.151a2.46 2.46 0 0 1-1.738.805c-.281 0-.563.016-.843-.018.182-.106.388-.168.559-.293.458-.313.733-.87.721-1.426-.003-1.123.007-2.246-.005-3.37-1.145-.013-2.289-.001-3.433-.006a1.7 1.7 0 0 0-1.409.742c-.11.148-.146.34-.273.475-.014-.528-.06-1.082.156-1.578"
	})), _path2$24 || (_path2$24 = /*#__PURE__*/ React.createElement("path", {
		fill: "#D3302F",
		d: "M6.402 5.41c.324-.06.659-.027.987-.02 1.067.068 2.007.993 2.073 2.076.014.703.006 1.406.004 2.11-.589.015-1.178.009-1.767.002-.01-.835 0-1.671-.005-2.506a1.7 1.7 0 0 0-.702-1.367c-.178-.134-.392-.2-.59-.294"
	})), _path3$14 || (_path3$14 = /*#__PURE__*/ React.createElement("path", {
		fill: "#F8A925",
		d: "M14.68 6.727q.049-.127.123-.242c.026.583.061 1.197-.185 1.742-.339.787-1.144 1.353-2 1.357-.652-.006-1.306.01-1.958-.009-.005-.592-.01-1.184.003-1.776.653-.017 1.306-.003 1.96-.007.289-.006.581.022.867-.04a1.67 1.67 0 0 0 1.19-1.025"
	})), _path4$9 || (_path4$9 = /*#__PURE__*/ React.createElement("path", {
		fill: "#66BB6A",
		d: "M5.567 12.02a2.25 2.25 0 0 1 1.975-1.236c.633.003 1.267-.014 1.9.008.043.075.02.169.028.252-.006.51.005 1.02-.006 1.528-.896.01-1.792-.016-2.687.024-.484.056-.933.351-1.191.766-.106.165-.162.355-.256.527-.05-.626-.064-1.298.237-1.868"
	})), _path5$4 || (_path5$4 = /*#__PURE__*/ React.createElement("path", {
		fill: "#37A3FF",
		d: "M10.628 10.99c.01-.067-.021-.209.085-.203.56-.01 1.122-.005 1.683-.001.05.889 0 1.782.024 2.672.037.47.294.91.668 1.19.185.146.411.216.62.32a6.6 6.6 0 0 1-1.14-.004 2.28 2.28 0 0 1-1.788-1.443c-.123-.313-.153-.652-.152-.986z"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/Github.svg
var _path$38;
function _extends$39() {
	return _extends$39 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$39.apply(null, arguments);
}
var SvgGithub = function SvgGithub(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$39({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$38 || (_path$38 = /*#__PURE__*/ React.createElement("path", {
		fill: "#24292F",
		fillRule: "evenodd",
		d: "M10.007 1.882c-4.649 0-8.407 3.786-8.407 8.47a8.46 8.46 0 0 0 5.749 8.034c.417.084.57-.182.57-.407 0-.196-.013-.869-.013-1.57-2.34.505-2.826-1.01-2.826-1.01-.376-.981-.933-1.234-.933-1.234-.765-.518.056-.518.056-.518.849.056 1.295.869 1.295.869.751 1.29 1.962.925 2.45.7.069-.546.292-.925.528-1.135-1.865-.196-3.828-.925-3.828-4.179 0-.925.334-1.682.863-2.271-.083-.21-.375-1.08.084-2.244 0 0 .71-.224 2.31.87a8 8 0 0 1 2.102-.28c.71 0 1.434.097 2.102.28 1.6-1.094 2.31-.87 2.31-.87.46 1.164.167 2.034.084 2.244.543.589.863 1.346.863 2.271 0 3.254-1.963 3.969-3.842 4.18.307.265.57.77.57 1.57 0 1.135-.013 2.047-.013 2.327 0 .225.153.491.57.407a8.46 8.46 0 0 0 5.75-8.035c.013-4.683-3.759-8.47-8.394-8.47",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/GoDaddy.svg
var _path$37;
function _extends$38() {
	return _extends$38 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$38.apply(null, arguments);
}
var SvgGoDaddy = function SvgGoDaddy(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$38({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$37 || (_path$37 = /*#__PURE__*/ React.createElement("path", {
		fill: "#1BDBDB",
		fillRule: "evenodd",
		d: "M16.376 9.998a8.6 8.6 0 0 1-1.037 2.378q-.454.727-1.015 1.332c.426-1.738.137-3.868-.908-5.865a.263.263 0 0 0-.377-.103L9.784 9.776a.267.267 0 0 0-.085.367l.478.765a.266.266 0 0 0 .366.084l2.11-1.32q.106.306.188.613c.203.773.278 1.527.224 2.242-.1 1.33-.64 2.366-1.523 2.918-.44.275-.952.421-1.508.437h-.067a2.97 2.97 0 0 1-1.51-.437c-.881-.552-1.422-1.588-1.522-2.918a6.8 6.8 0 0 1 .224-2.242c.216-.82.564-1.62 1.037-2.377a8.6 8.6 0 0 1 1.68-1.975 6.8 6.8 0 0 1 1.914-1.185c1.238-.493 2.406-.46 3.288.091.882.552 1.422 1.588 1.523 2.918a6.8 6.8 0 0 1-.225 2.241M4.661 12.376a8.6 8.6 0 0 1-1.037-2.378 6.8 6.8 0 0 1-.225-2.24c.1-1.33.641-2.367 1.523-2.919.882-.551 2.05-.584 3.288-.09q.279.111.553.255a10.2 10.2 0 0 0-1.782 2.144c-1.365 2.188-1.78 4.618-1.305 6.56a9 9 0 0 1-1.015-1.332m11.176-8.753c-1.673-1.047-3.876-.798-5.838.439-1.96-1.236-4.163-1.485-5.836-.439C1.52 5.277 1.2 9.536 3.446 13.136c1.657 2.654 4.248 4.21 6.554 4.18 2.306.03 4.897-1.526 6.554-4.18 2.247-3.6 1.926-7.86-.717-9.513",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/Google.svg
var _path$36;
var _path2$23;
var _path3$13;
var _path4$8;
function _extends$37() {
	return _extends$37 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$37.apply(null, arguments);
}
var SvgGoogle = function SvgGoogle(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$37({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$36 || (_path$36 = /*#__PURE__*/ React.createElement("path", {
		fill: "#4285F4",
		d: "M18.4 10.33c0-.552-.05-1.077-.136-1.588h-8.081v3.157h4.627c-.208 1.036-.816 1.91-1.717 2.506v2.1h2.761c1.616-1.463 2.546-3.62 2.546-6.174"
	})), _path2$23 || (_path2$23 = /*#__PURE__*/ React.createElement("path", {
		fill: "#34A853",
		d: "M10.183 18.542c2.317 0 4.255-.756 5.671-2.037l-2.76-2.1c-.773.504-1.753.812-2.911.812-2.239 0-4.134-1.477-4.814-3.472H2.523v2.163c1.409 2.744 4.305 4.634 7.66 4.634"
	})), _path3$13 || (_path3$13 = /*#__PURE__*/ React.createElement("path", {
		fill: "#FBBC05",
		d: "M5.37 11.745a4.8 4.8 0 0 1-.272-1.603c0-.56.1-1.1.271-1.603V6.376H2.523a8.16 8.16 0 0 0-.923 3.766 8.16 8.16 0 0 0 .923 3.766z"
	})), _path4$8 || (_path4$8 = /*#__PURE__*/ React.createElement("path", {
		fill: "#EA4335",
		d: "M10.183 5.067c1.265 0 2.396.427 3.29 1.26l2.445-2.394c-1.48-1.358-3.418-2.191-5.735-2.191-3.355 0-6.251 1.89-7.66 4.634l2.846 2.163c.68-1.995 2.575-3.472 4.814-3.472"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/GoogleCloud.svg
var _path$35;
var _path2$22;
var _path3$12;
var _path4$7;
function _extends$36() {
	return _extends$36 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$36.apply(null, arguments);
}
var SvgGoogleCloud = function SvgGoogleCloud(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$36({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$35 || (_path$35 = /*#__PURE__*/ React.createElement("path", {
		fill: "#EA4335",
		d: "M12.422 6.888h.549l1.565-1.565.076-.664A7.032 7.032 0 0 0 3.172 8.09a.85.85 0 0 1 .548-.033l3.13-.516s.159-.263.241-.247a3.903 3.903 0 0 1 5.342-.406z"
	})), _path2$22 || (_path2$22 = /*#__PURE__*/ React.createElement("path", {
		fill: "#4285F4",
		d: "M16.764 8.09a7.05 7.05 0 0 0-2.124-3.426L12.444 6.86a3.9 3.9 0 0 1 1.433 3.097v.39a1.955 1.955 0 0 1 0 3.908h-3.91l-.389.396v2.344l.39.39h3.909a5.084 5.084 0 0 0 2.887-9.295"
	})), _path3$12 || (_path3$12 = /*#__PURE__*/ React.createElement("path", {
		fill: "#34A853",
		d: "M6.053 17.363h3.91v-3.13h-3.91c-.278 0-.553-.06-.807-.175l-.549.17-1.575 1.565-.137.549a5.06 5.06 0 0 0 3.068 1.02"
	})), _path4$7 || (_path4$7 = /*#__PURE__*/ React.createElement("path", {
		fill: "#FBBC05",
		d: "M6.053 7.212a5.084 5.084 0 0 0-3.069 9.113l2.268-2.267a1.955 1.955 0 1 1 2.586-2.586l2.267-2.267a5.08 5.08 0 0 0-4.052-1.993"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/Greenhouse.svg
var _path$34;
function _extends$35() {
	return _extends$35 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$35.apply(null, arguments);
}
var SvgGreenhouse = function SvgGreenhouse(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$35({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 20,
		fill: "none",
		viewBox: "0 0 20 20"
	}, props), _path$34 || (_path$34 = /*#__PURE__*/ React.createElement("path", {
		fill: "#008561",
		d: "M13.565 5.942c0 .966-.408 1.82-1.077 2.488-.743.743-1.82.93-1.82 1.56 0 .854 1.374.594 2.693 1.913.873.873 1.41 2.024 1.41 3.361C14.772 17.901 12.656 20 10 20c-2.656 0-4.773-2.097-4.773-4.735 0-1.337.538-2.488 1.411-3.361 1.318-1.318 2.693-1.058 2.693-1.912 0-.632-1.078-.818-1.82-1.56-.67-.67-1.078-1.524-1.078-2.526 0-1.931 1.579-3.492 3.51-3.492.372 0 .706.057.985.057.502 0 .761-.224.761-.576 0-.205-.093-.465-.093-.743C11.596.52 12.135 0 12.785 0s1.17.539 1.17 1.188c0 .688-.539 1.004-.947 1.152-.334.112-.595.26-.595.595 0 .629 1.152 1.242 1.152 3.007m-.372 9.324c0-1.838-1.355-3.324-3.193-3.324-1.84 0-3.195 1.485-3.195 3.324 0 1.82 1.355 3.324 3.195 3.324 1.837 0 3.193-1.506 3.193-3.324m-1.095-9.362c0-1.17-.947-2.135-2.098-2.135-1.152 0-2.098.966-2.098 2.135 0 1.17.946 2.137 2.098 2.137s2.098-.966 2.098-2.137"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/HiBob.svg
var _path$33;
var _path2$21;
function _extends$34() {
	return _extends$34 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$34.apply(null, arguments);
}
var SvgHiBob = function SvgHiBob(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$34({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$33 || (_path$33 = /*#__PURE__*/ React.createElement("path", {
		fill: "#E42C53",
		d: "M14.632 2.892H5.368A2.62 2.62 0 0 0 2.75 5.51v9.264a2.62 2.62 0 0 0 2.618 2.618h9.264a2.62 2.62 0 0 0 2.618-2.618V5.51a2.62 2.62 0 0 0-2.618-2.618"
	})), _path2$21 || (_path2$21 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M6.699 12.044a1.131 1.131 0 1 1 1.148-1.131 1.14 1.14 0 0 1-1.149 1.13m-1.441-4.36a.287.287 0 0 0-.293.288v2.937a1.723 1.723 0 0 0 1.734 1.71 1.723 1.723 0 0 0 1.73-1.71A1.723 1.723 0 0 0 6.7 9.203a1.74 1.74 0 0 0-1.15.431V7.973a.287.287 0 0 0-.291-.287M10.201 12.169a1.252 1.252 0 1 1-.003-2.504 1.252 1.252 0 0 1 .003 2.504m0-2.831a1.58 1.58 0 1 0 0 3.159 1.58 1.58 0 0 0 0-3.16M13.535 12.25a1.333 1.333 0 1 1-.004-2.666 1.333 1.333 0 0 1 .004 2.667m-1.413-4.523a.083.083 0 0 0-.082.08v3.108a1.495 1.495 0 1 0 .164-.678v-2.43a.08.08 0 0 0-.08-.079"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/JIRA.svg
var _path$32;
var _path2$20;
var _path3$11;
var _defs$4;
function _extends$33() {
	return _extends$33 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$33.apply(null, arguments);
}
var SvgJira = function SvgJira(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$33({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$32 || (_path$32 = /*#__PURE__*/ React.createElement("path", {
		fill: "#2684FF",
		d: "m17.68 9.676-7.003-7.225-.688-.71-5.263 5.43L2.32 9.677c-.258.266-.258.687 0 .931l4.812 4.965 2.857 2.948 5.264-5.43.086-.09 2.341-2.393c.258-.266.258-.687 0-.93m-7.69 2.948-2.407-2.482L9.99 7.66l2.406 2.482z"
	})), _path2$20 || (_path2$20 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#a)",
		d: "M9.99 7.66C8.42 6.041 8.4 3.403 9.967 1.763l-5.242 5.43 2.857 2.948z"
	})), _path3$11 || (_path3$11 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#b)",
		d: "m12.417 10.12-2.428 2.504a4.267 4.267 0 0 1 0 5.918l5.285-5.452z"
	})), _defs$4 || (_defs$4 = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
		id: "a",
		x1: 9.568,
		x2: 6.103,
		y1: 5.143,
		y2: 8.502,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", {
		offset: .176,
		stopColor: "#0052CC"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#2684FF"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "b",
		x1: 10.457,
		x2: 13.916,
		y1: 15.102,
		y2: 11.75,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", {
		offset: .176,
		stopColor: "#0052CC"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#2684FF"
	})))));
};

//#endregion
//#region src/ServiceIcon/icons/JumpCloud.svg
var _path$31;
function _extends$32() {
	return _extends$32 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$32.apply(null, arguments);
}
var SvgJumpCloud = function SvgJumpCloud(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$32({
		xmlns: "http://www.w3.org/2000/svg",
		width: 21,
		height: 21,
		fill: "none",
		viewBox: "0 0 21 21"
	}, props), _path$31 || (_path$31 = /*#__PURE__*/ React.createElement("path", {
		fill: "#002B49",
		d: "M20.072 11.835a2.723 2.723 0 0 1-2.72 2.717h-.75c-.077-.906-1.013-1.676-2.336-2.034a2.358 2.358 0 0 0-1.66-4.039 2.365 2.365 0 0 0-2.185 1.464 2.36 2.36 0 0 0 .526 2.575c-.63.15-1.214.447-1.707.865a4.1 4.1 0 0 0-.99-.406 2.019 2.019 0 0 0-1.416-3.461 2.02 2.02 0 0 0-1.872 1.255 2.02 2.02 0 0 0 .457 2.206c-1.043.288-1.802.865-1.964 1.563h-.748a2.725 2.725 0 0 1-2.635-2.718 2.72 2.72 0 0 1 2.635-2.719c.346.001.689.068 1.01.196A2.71 2.71 0 0 1 6.2 7.721h.196A3.54 3.54 0 0 1 9.26 4.906a3.55 3.55 0 0 1 3.658 1.662A2.89 2.89 0 0 1 16.3 7.96c.21.388.327.82.343 1.261a2.72 2.72 0 0 1 3.15 1.42c.185.375.28.787.279 1.205z"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/Keycloak.svg
var _path$30;
var _path2$19;
var _path3$10;
var _path4$6;
var _path5$3;
var _path6$2;
var _path7$2;
var _path8$2;
var _path9$2;
var _path0$2;
var _path1$2;
var _path10$2;
var _path11$2;
var _path12$1;
var _path13$1;
var _path14$1;
var _path15$1;
var _path16$1;
var _path17$1;
var _path18$1;
var _path19$1;
var _path20$1;
var _path21$1;
var _path22$1;
var _path23$1;
var _path24$1;
var _path25$1;
var _path26$1;
var _path27$1;
var _path28$1;
var _path29$1;
var _path30$1;
var _path31$1;
var _path32$1;
var _path33$1;
var _path34$1;
function _extends$31() {
	return _extends$31 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$31.apply(null, arguments);
}
var SvgKeycloak = function SvgKeycloak(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$31({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$30 || (_path$30 = /*#__PURE__*/ React.createElement("path", {
		fill: "#4D4D4D",
		d: "M16.387 6.502a.13.13 0 0 1-.116-.066L14.249 2.93a.14.14 0 0 0-.119-.066H5.882a.13.13 0 0 0-.117.066l-2.1 3.638-1.954 3.507a.14.14 0 0 0 0 .134l1.954 3.503 2.1 3.64a.13.13 0 0 0 .116.066h8.249a.14.14 0 0 0 .118-.066l2.024-3.504a.13.13 0 0 1 .116-.066h2.518a.15.15 0 0 0 .151-.151V6.653a.15.15 0 0 0-.151-.151h-2.52"
	})), _path2$19 || (_path2$19 = /*#__PURE__*/ React.createElement("path", {
		fill: "#E2E2E2",
		d: "m3.59 6.7-1.932 3.442.206.453 1.92 3.135 1.253.052h12.138l1.34-.34.542-1.498V8.616l-.15-2.114H6.217z"
	})), _path3$10 || (_path3$10 = /*#__PURE__*/ React.createElement("path", {
		fill: "#E1E1E1",
		d: "m4.123 9.774-2.26.82-.222-.384a.13.13 0 0 1 0-.134l1.023-1.772z"
	})), _path4$6 || (_path4$6 = /*#__PURE__*/ React.createElement("path", {
		fill: "#C8C8C8",
		d: "m17.567 10.43 1.49-.214v1.728z"
	})), _path5$3 || (_path5$3 = /*#__PURE__*/ React.createElement("path", {
		fill: "#C2C2C2",
		d: "m17.567 10.43 1.49 1.514v1.687a.15.15 0 0 1-.149.15h-1.733z"
	})), _path6$2 || (_path6$2 = /*#__PURE__*/ React.createElement("path", {
		fill: "#C7C7C7",
		d: "m17.567 10.43-.392 3.351h-2.084l-.631-1.52z"
	})), _path7$2 || (_path7$2 = /*#__PURE__*/ React.createElement("path", {
		fill: "#CECECE",
		d: "m17.567 10.43 1.49-1.814v1.6z"
	})), _path8$2 || (_path8$2 = /*#__PURE__*/ React.createElement("path", {
		fill: "#D3D3D3",
		d: "M19.057 6.653v1.963l-1.49 1.813-1.123-3.927h2.462a.15.15 0 0 1 .151.151"
	})), _path9$2 || (_path9$2 = /*#__PURE__*/ React.createElement("path", {
		fill: "#C6C6C6",
		d: "M15.091 13.781h-1.099l-.285-.408.753-1.113z"
	})), _path0$2 || (_path0$2 = /*#__PURE__*/ React.createElement("path", {
		fill: "#D5D5D5",
		d: "m17.567 10.43-4.122-1.743 2.168-2.185h.831z"
	})), _path1$2 || (_path1$2 = /*#__PURE__*/ React.createElement("path", {
		fill: "#D0D0D0",
		d: "m13.445 8.687 1.015 3.573 3.108-1.83z"
	})), _path10$2 || (_path10$2 = /*#__PURE__*/ React.createElement("path", {
		fill: "#BFBFBF",
		d: "M13.992 13.781h-.298l.013-.408z"
	})), _path11$2 || (_path11$2 = /*#__PURE__*/ React.createElement("path", {
		fill: "#D9D9D9",
		d: "m15.613 6.502-2.168 2.185-.392-1.954.837-.23z"
	})), _path12$1 || (_path12$1 = /*#__PURE__*/ React.createElement("path", {
		fill: "#D4D4D4",
		d: "M13.445 8.687 8.44 9.842l5.267 3.53z"
	})), _path13$1 || (_path13$1 = /*#__PURE__*/ React.createElement("path", {
		fill: "#D0D0D0",
		d: "m13.445 8.687.262 4.686.752-1.112z"
	})), _path14$1 || (_path14$1 = /*#__PURE__*/ React.createElement("path", {
		fill: "#D9D9D9",
		d: "M13.053 6.733 8.441 9.84l5.005-1.155z"
	})), _path15$1 || (_path15$1 = /*#__PURE__*/ React.createElement("path", {
		fill: "#D8D8D8",
		d: "m8.441 9.84-2.168 3.941H5.037l-.913-4.007z"
	})), _path16$1 || (_path16$1 = /*#__PURE__*/ React.createElement("path", {
		fill: "#E2E2E2",
		d: "M6.218 6.502 4.123 9.774 3.59 6.7l.075-.13v-.002a.14.14 0 0 1 .117-.065z"
	})), _path17$1 || (_path17$1 = /*#__PURE__*/ React.createElement("path", {
		fill: "#D8D8D8",
		d: "M5.037 13.782H3.782a.14.14 0 0 1-.117-.07l-1.801-3.117 2.26-.82z"
	})), _path18$1 || (_path18$1 = /*#__PURE__*/ React.createElement("path", {
		fill: "#E4E4E4",
		d: "M2.664 8.303 3.59 6.7l.533 3.075z"
	})), _path19$1 || (_path19$1 = /*#__PURE__*/ React.createElement("path", {
		fill: "#DEDEDE",
		d: "M10.727 6.502H7.074L8.44 9.841l4.612-3.108-1.39-.23z"
	})), _path20$1 || (_path20$1 = /*#__PURE__*/ React.createElement("path", {
		fill: "#DEDEDE",
		d: "M6.503 6.502h-.285L4.124 9.774l4.317.067-1.367-3.339z"
	})), _path21$1 || (_path21$1 = /*#__PURE__*/ React.createElement("path", {
		fill: "#C5C5C5",
		d: "M12.703 13.781h.991l.013-.408z"
	})), _path22$1 || (_path22$1 = /*#__PURE__*/ React.createElement("path", {
		fill: "#D0D0D0",
		d: "M13.707 13.373 8.441 9.84l.949 3.94h3.313z"
	})), _path23$1 || (_path23$1 = /*#__PURE__*/ React.createElement("path", {
		fill: "#D1D1D1",
		d: "M6.272 13.781H9.39l-.949-3.94z"
	})), _path24$1 || (_path24$1 = /*#__PURE__*/ React.createElement("path", {
		fill: "#DDD",
		d: "m13.068 6.502-.015.23.837-.23h-.822"
	})), _path25$1 || (_path25$1 = /*#__PURE__*/ React.createElement("path", {
		fill: "#E3E3E3",
		d: "m11.663 6.502 1.39.23-.128-.23z"
	})), _path26$1 || (_path26$1 = /*#__PURE__*/ React.createElement("path", {
		fill: "#E2E2E2",
		d: "m12.925 6.502.128.23.015-.23z"
	})), _path27$1 || (_path27$1 = /*#__PURE__*/ React.createElement("path", {
		fill: "#00B8E3",
		d: "m9.27 6.565-2.035 3.523a.1.1 0 0 0-.015.057H5.802L8.593 5.31a.1.1 0 0 1 .042.04l.004.004.633 1.1a.12.12 0 0 1-.002.112"
	})), _path28$1 || (_path28$1 = /*#__PURE__*/ React.createElement("path", {
		fill: "#33C6E9",
		d: "m9.268 13.848-.63 1.094a.1.1 0 0 1-.043.04L5.8 10.148h1.421q0 .029.013.055l.003.006 2.03 3.52a.12.12 0 0 1 0 .12"
	})), _path29$1 || (_path29$1 = /*#__PURE__*/ React.createElement("path", {
		fill: "#008AAA",
		d: "m8.593 5.309-2.79 4.836-.7 1.213-.669-1.159a.118.118 0 0 1 .001-.112l.676-1.17 2.056-3.561a.12.12 0 0 1 .105-.061h1.262q.03 0 .06.014"
	})), _path30$1 || (_path30$1 = /*#__PURE__*/ React.createElement("path", {
		fill: "#00B8E3",
		d: "M8.593 14.983a.13.13 0 0 1-.06.015H7.27a.12.12 0 0 1-.105-.06l-1.88-3.256-.185-.322.7-1.214z"
	})), _path31$1 || (_path31$1 = /*#__PURE__*/ React.createElement("path", {
		fill: "#008AAA",
		d: "m14.207 10.145-2.793 4.838a.13.13 0 0 1-.042-.04l-.002-.004-.635-1.097a.12.12 0 0 1 0-.113l2.032-3.522a.1.1 0 0 0 .017-.062h1.423"
	})), _path32$1 || (_path32$1 = /*#__PURE__*/ React.createElement("path", {
		fill: "#00B8E3",
		d: "M15.589 10.145a.1.1 0 0 1-.017.062l-2.735 4.736a.12.12 0 0 1-.101.056h-1.26a.13.13 0 0 1-.062-.016l2.793-4.838.7-1.211.665 1.152a.1.1 0 0 1 .017.06"
	})), _path33$1 || (_path33$1 = /*#__PURE__*/ React.createElement("path", {
		fill: "#00B8E3",
		d: "M14.207 10.145h-1.42a.1.1 0 0 0-.017-.06l-2.03-3.519a.12.12 0 0 1 0-.12l.633-1.096a.1.1 0 0 1 .041-.04z"
	})), _path34$1 || (_path34$1 = /*#__PURE__*/ React.createElement("path", {
		fill: "#33C6E9",
		d: "m14.907 8.932-.7 1.212-2.793-4.835a.13.13 0 0 1 .06-.016h1.26a.12.12 0 0 1 .102.057z"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/Kisi.svg
var _path$29;
var _path2$18;
function _extends$30() {
	return _extends$30 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$30.apply(null, arguments);
}
var SvgKisi = function SvgKisi(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$30({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 12,
		fill: "none",
		viewBox: "0 0 20 12"
	}, props), _path$29 || (_path$29 = /*#__PURE__*/ React.createElement("path", {
		fill: "#4C51F6",
		d: "M20 1.043v9.913h-9.913v-.002c.35-1.595.535-3.253.535-4.954s-.184-3.36-.535-4.955v-.002z"
	})), _path2$18 || (_path2$18 = /*#__PURE__*/ React.createElement("path", {
		fill: "#4C51F6",
		d: "M5.31 11.31a5.31 5.31 0 1 0 0-10.62 5.31 5.31 0 0 0 0 10.62"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/LastPass.svg
var _path$28;
var _path2$17;
function _extends$29() {
	return _extends$29 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$29.apply(null, arguments);
}
var SvgLastPass = function SvgLastPass(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$29({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$28 || (_path$28 = /*#__PURE__*/ React.createElement("path", {
		fill: "#D32D27",
		d: "M15.18 2.742H4.82a2.22 2.22 0 0 0-2.22 2.22v10.36a2.22 2.22 0 0 0 2.22 2.22h10.36a2.22 2.22 0 0 0 2.22-2.22V4.962a2.22 2.22 0 0 0-2.22-2.22"
	})), _path2$17 || (_path2$17 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M5.722 11.414a1.272 1.272 0 1 0 0-2.544 1.272 1.272 0 0 0 0 2.544M9.162 11.414a1.272 1.272 0 1 0 0-2.544 1.272 1.272 0 0 0 0 2.544M12.63 11.414a1.272 1.272 0 1 0 0-2.544 1.272 1.272 0 0 0 0 2.544M15.55 7.663a.293.293 0 0 0-.29-.296c-.159 0-.288.132-.288.296v4.958c0 .163.13.296.289.296.16 0 .289-.133.289-.296z"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/Linear.svg
var _path$27;
var _path2$16;
var _path3$9;
var _path4$5;
var _path5$2;
var _defs$3;
function _extends$28() {
	return _extends$28 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$28.apply(null, arguments);
}
var SvgLinear = function SvgLinear(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$28({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$27 || (_path$27 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#a)",
		d: "M1.6 5.102a3.36 3.36 0 0 1 3.36-3.36h10.08a3.36 3.36 0 0 1 3.36 3.36v10.08a3.36 3.36 0 0 1-3.36 3.36H4.96a3.36 3.36 0 0 1-3.36-3.36z"
	})), _path2$16 || (_path2$16 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#b)",
		d: "M4.147 11.525c-.027-.114.109-.186.192-.103l4.381 4.381c.083.083.011.218-.103.192a6.02 6.02 0 0 1-4.47-4.47"
	})), _path3$9 || (_path3$9 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#c)",
		d: "M4 9.769a.12.12 0 0 0 .035.09l6.247 6.248a.12.12 0 0 0 .091.035q.428-.028.836-.111a.117.117 0 0 0 .057-.198L4.31 8.876a.117.117 0 0 0-.198.057 6 6 0 0 0-.11.836"
	})), _path4$5 || (_path4$5 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#d)",
		d: "M4.505 7.707a.12.12 0 0 0 .025.131l7.773 7.774a.12.12 0 0 0 .132.024q.322-.143.623-.321a.118.118 0 0 0 .021-.185L5.012 7.062a.118.118 0 0 0-.185.022q-.178.3-.322.623"
	})), _path5$2 || (_path5$2 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#e)",
		d: "M5.52 6.31a.12.12 0 0 1-.006-.162 6.006 6.006 0 1 1 8.48 8.48.12.12 0 0 1-.163-.005z"
	})), _defs$3 || (_defs$3 = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
		id: "a",
		x1: 10,
		x2: 10,
		y1: 1.742,
		y2: 18.542,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#5C6BF1" }), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#283188"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "b",
		x1: 4.429,
		x2: 10.686,
		y1: 5.256,
		y2: 14.428,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#fff" }), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#fff",
		stopOpacity: .65
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "c",
		x1: 4.429,
		x2: 10.686,
		y1: 5.256,
		y2: 14.428,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#fff" }), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#fff",
		stopOpacity: .65
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "d",
		x1: 4.429,
		x2: 10.686,
		y1: 5.256,
		y2: 14.428,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#fff" }), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#fff",
		stopOpacity: .65
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "e",
		x1: 4.429,
		x2: 10.686,
		y1: 5.256,
		y2: 14.428,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#fff" }), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#fff",
		stopOpacity: .65
	})))));
};

//#endregion
//#region src/ServiceIcon/icons/LoginGOV.svg
var _path$26;
var _path2$15;
var _path3$8;
function _extends$27() {
	return _extends$27 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$27.apply(null, arguments);
}
var SvgLoginGov = function SvgLoginGov(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$27({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$26 || (_path$26 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M13.687 4.988H6.71v8.946h6.976z"
	})), _path2$15 || (_path2$15 = /*#__PURE__*/ React.createElement("path", {
		fill: "#E21D3E",
		fillRule: "evenodd",
		d: "m8.309 12.483.588-3.358a1.78 1.78 0 0 1 1.099-3.188V2.21H5.454a1.76 1.76 0 0 0-1.76 1.76v8.63c-.001.163.035.324.105.47.382.771 1.886 3.245 6.193 5.147V12.62a10 10 0 0 1-1.683-.137",
		clipRule: "evenodd"
	})), _path3$8 || (_path3$8 = /*#__PURE__*/ React.createElement("path", {
		fill: "#B51E23",
		fillRule: "evenodd",
		d: "M14.526 2.198H9.992v3.727A1.78 1.78 0 0 1 11.107 9.1l.588 3.374a10 10 0 0 1-1.703.146v5.589c4.303-1.894 5.811-4.376 6.193-5.147.07-.146.106-.307.105-.47V3.966a1.76 1.76 0 0 0-1.764-1.768",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/Loom.svg
var _path$25;
function _extends$26() {
	return _extends$26 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$26.apply(null, arguments);
}
var SvgLoom = function SvgLoom(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$26({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 20,
		fill: "none",
		viewBox: "0 0 20 20"
	}, props), _path$25 || (_path$25 = /*#__PURE__*/ React.createElement("path", {
		fill: "#625DF5",
		d: "M20 8.954h-6.093l5.277-3.046-1.047-1.813-5.277 3.046 3.046-5.275L14.093.82l-3.046 5.273V.003H8.953v6.091L5.907.82 4.093 1.866 7.14 7.14 1.863 4.095.816 5.908l5.277 3.046H0v2.093h6.092L.816 14.093l1.047 1.812L7.14 12.86l-3.047 5.275 1.813 1.046 3.047-5.274v6.09h2.094v-6.22l3.102 5.37 1.7-.98-3.103-5.373 5.39 3.11 1.047-1.812-5.276-3.046H20zm-10 3.892a2.845 2.845 0 1 1-.001-5.691 2.845 2.845 0 0 1 .001 5.69"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/Microsoft.svg
var _path$24;
var _path2$14;
var _path3$7;
var _path4$4;
function _extends$25() {
	return _extends$25 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$25.apply(null, arguments);
}
var SvgMicrosoft = function SvgMicrosoft(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$25({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$24 || (_path$24 = /*#__PURE__*/ React.createElement("path", {
		fill: "#FFBA08",
		d: "M10.42 10.56h7.98v7.98h-7.98z"
	})), _path2$14 || (_path2$14 = /*#__PURE__*/ React.createElement("path", {
		fill: "#05A6F0",
		d: "M1.6 10.56h7.98v7.98H1.6z"
	})), _path3$7 || (_path3$7 = /*#__PURE__*/ React.createElement("path", {
		fill: "#81BC06",
		d: "M10.42 1.746h7.98v7.98h-7.98z"
	})), _path4$4 || (_path4$4 = /*#__PURE__*/ React.createElement("path", {
		fill: "#F35325",
		d: "M1.6 1.743h7.98v7.98H1.6z"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/MiniOrange.svg
var _path$23;
var _path2$13;
var _path3$6;
var _path4$3;
function _extends$24() {
	return _extends$24 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$24.apply(null, arguments);
}
var SvgMiniOrange = function SvgMiniOrange(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$24({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$23 || (_path$23 = /*#__PURE__*/ React.createElement("path", {
		fill: "#F7934D",
		d: "M8.033 17.784a7.866 7.866 0 0 1-5.877-7.627c.008-2.035.665-3.767 1.987-5.205 1.504-1.64 3.133-2.438 5.336-2.64.707-.059 1.987.076 2.328.252a.94.94 0 0 1 .499.85c0 .235-.067.37-.291.596-.121.096-.261.163-.41.198-.246.057-.571.03-.571.03-1.846-.194-3.259.142-4.58 1.093C4.982 6.39 4.109 8.02 4.018 9.88c-.158 2.993 1.97 5.667 4.921 6.188.333.06.931.085 1.446.05 2.669-.134 4.872-2.042 5.453-4.716.117-.538.142-.883.1-1.716 0 0-.078-.438-.022-.77.036-.204.12-.395.246-.558.391-.396.848-.404 1.256-.009.266.253.29.32.382 1.043.241 2.094-.523 4.406-1.987 6.004-.764.832-1.38 1.311-2.227 1.749-1.28.647-2.145.849-3.69.84-.907 0-1.265-.033-1.863-.201"
	})), _path2$13 || (_path2$13 = /*#__PURE__*/ React.createElement("path", {
		fill: "#F7934D",
		d: "M9.11 12.546c-.052-.098-.026-.509.079-1.149l.166-1.01-.341-.287c-.796-.681-.612-1.88.367-2.347.525-.255 1.26-.19 1.697.148.761.566.822 1.444.167 2.133l-.416.353.205 1.06c.123.763.14 1.042.062 1.124-.07.082-.341.115-1.006.115-.77 0-.918-.025-.98-.14"
	})), _path3$6 || (_path3$6 = /*#__PURE__*/ React.createElement("path", {
		fill: "#4D9965",
		d: "M13.194 6.742c-.905-1.077-.303-2.147.85-2.784.504-.329.957-.824 1.187-1.359l.1-.301.156.35c.173.56.322 1.697.181 1.738-1.178.345-2.408 2.512-2.474 2.356"
	})), _path4$3 || (_path4$3 = /*#__PURE__*/ React.createElement("path", {
		fill: "#9BCE7A",
		d: "M14.036 7.352c-.442-.088-.856-.365-.856-.6 0-.27.408-1.226.737-1.587.354-.403.932-.723 1.435-.874.28-.084.81-.095 1.381-.079.57.017.9.06.9.144 0 .034-.523.324-.663.4-.48.318-.67.68-.99 1.3-.33.655-.516.932-.879 1.126-.312.167-.624.258-1.065.17"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/NetIQ.svg
var _path$22;
function _extends$23() {
	return _extends$23 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$23.apply(null, arguments);
}
var SvgNetIq = function SvgNetIq(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$23({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$22 || (_path$22 = /*#__PURE__*/ React.createElement("path", {
		fill: "#F42147",
		d: "M16.463 9.525v7.101a5.92 5.92 0 0 1-5.919-5.918V3.607a5.967 5.967 0 0 1 5.918 5.967zM9.362 3.607H3.443v13.02a5.92 5.92 0 0 0 5.919-5.92z"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/Notion.svg
var _path$21;
var _path2$12;
function _extends$22() {
	return _extends$22 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$22.apply(null, arguments);
}
var SvgNotion = function SvgNotion(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$22({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 20,
		fill: "none",
		viewBox: "0 0 20 20"
	}, props), _path$21 || (_path$21 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M1.633.863 12.7.045c1.359-.116 1.708-.038 2.563.584l3.532 2.488c.583.428.777.545.777 1.011v13.649c0 .855-.31 1.36-1.398 1.438l-12.851.778c-.816.039-1.205-.078-1.632-.622L1.09 15.988c-.467-.623-.66-1.089-.66-1.633V2.223c0-.7.31-1.283 1.203-1.36"
	})), _path2$12 || (_path2$12 = /*#__PURE__*/ React.createElement("path", {
		fill: "#000",
		fillRule: "evenodd",
		d: "M12.7.045 1.633.863C.74.94.43 1.523.43 2.223v12.132c0 .544.193 1.01.66 1.633L3.69 19.37c.427.544.816.66 1.632.622l12.851-.778c1.087-.077 1.398-.583 1.398-1.438V4.128c0-.442-.175-.57-.689-.947q-.045-.03-.088-.064L15.263.63c-.855-.622-1.204-.7-2.563-.584m-7.086 3.86c-1.05.07-1.288.086-1.884-.398L2.215 2.3c-.154-.156-.077-.35.311-.389l10.639-.777c.893-.078 1.359.233 1.708.505l1.824 1.322c.078.04.272.272.04.272L5.75 3.895zM4.39 17.66V6.073c0-.506.156-.739.621-.778l12.618-.739c.428-.039.622.233.622.739v11.509c0 .506-.078.934-.777.973l-12.075.7c-.699.038-1.009-.194-1.009-.817M16.31 6.695c.077.35 0 .7-.35.74l-.582.115v8.555c-.505.272-.97.427-1.36.427-.62 0-.776-.195-1.241-.777L8.97 9.767v5.793l1.204.273s0 .7-.971.7l-2.678.155c-.078-.156 0-.545.27-.622l.7-.194v-7.66l-.97-.079c-.078-.35.116-.855.66-.894l2.873-.194 3.96 6.066V7.745l-1.01-.116c-.078-.429.233-.74.621-.778z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/Okta.svg
var _path$20;
function _extends$21() {
	return _extends$21 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$21.apply(null, arguments);
}
var SvgOkta = function SvgOkta(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$21({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$20 || (_path$20 = /*#__PURE__*/ React.createElement("path", {
		fill: "#000",
		fillRule: "evenodd",
		d: "m10.843 1.858-.346 4.256a4.3 4.3 0 0 0-1.111.02L9.19 4.07a.113.113 0 0 1 .112-.12h.35l-.168-2.087c-.005-.065.047-.121.107-.121h1.145c.065 0 .116.056.107.121zm-2.886.21c-.019-.06-.084-.098-.145-.074l-1.074.392a.11.11 0 0 0-.06.15l.873 1.903-.332.121c-.06.024-.089.094-.06.15L8.05 6.58a4 4 0 0 1 1.042-.397l-1.13-4.116zM5.323 3.254l2.47 3.481a4 4 0 0 0-.84.728l-1.48-1.456a.113.113 0 0 1 .004-.163l.271-.224-1.47-1.489a.11.11 0 0 1 .008-.163l.874-.733a.11.11 0 0 1 .158.019zM3.25 5.27c-.052-.038-.126-.019-.16.037l-.569.99a.11.11 0 0 0 .047.153l1.896.896-.178.304a.107.107 0 0 0 .052.154l1.886.863c.136-.35.318-.677.542-.97zM1.853 7.958c.01-.066.075-.103.136-.089l4.133 1.078q-.162.526-.178 1.102L3.875 9.88a.108.108 0 0 1-.098-.13l.061-.346-2.087-.196c-.066-.004-.108-.065-.098-.13l.196-1.125zm-.154 2.79c-.065.005-.107.066-.098.131l.201 1.125c.01.065.075.103.135.088l2.027-.527.06.346c.01.065.076.102.136.088l1.999-.55a4 4 0 0 1-.21-1.092l-4.254.392zm.663 2.96a.11.11 0 0 1 .047-.155l3.857-1.83c.145.346.341.668.575.957l-1.69 1.204a.11.11 0 0 1-.16-.032l-.177-.308-1.723 1.19c-.051.037-.126.018-.159-.037l-.574-.99zm4.675-.803-3.003 3.038a.11.11 0 0 0 .01.163l.878.732a.11.11 0 0 0 .158-.018l1.214-1.708.271.229a.11.11 0 0 0 .164-.024l1.177-1.708a4.2 4.2 0 0 1-.864-.704zm-.593 4.876c-.06-.023-.089-.093-.06-.15l1.778-3.882c.327.168.682.294 1.051.364L8.69 16.12a.11.11 0 0 1-.145.075l-.331-.122-.556 2.02c-.019.061-.084.099-.145.076l-1.074-.393zm3.063-3.616-.345 4.256c-.005.065.046.12.107.12h1.144a.107.107 0 0 0 .108-.12l-.169-2.087h.35a.113.113 0 0 0 .113-.12l-.196-2.063a3.8 3.8 0 0 1-1.112.014m4.12-11.523a.11.11 0 0 0-.062-.149l-1.074-.392c-.06-.023-.126.014-.144.075l-.556 2.02-.332-.12c-.06-.024-.126.013-.144.074l-.524 2.006c.374.075.724.201 1.051.364zm2.343 1.694-3.002 3.038a4 4 0 0 0-.864-.704l1.177-1.708a.114.114 0 0 1 .163-.024l.27.23 1.215-1.709a.11.11 0 0 1 .159-.019l.878.733a.113.113 0 0 1 .01.163zm1.626 2.39a.107.107 0 0 0 .046-.154l-.574-.99a.115.115 0 0 0-.159-.037l-1.723 1.19-.178-.303c-.032-.056-.107-.075-.158-.033l-1.69 1.204q.35.436.573.957l3.858-1.83zm.607 1.55.196 1.124a.113.113 0 0 1-.098.13l-4.255.397a4 4 0 0 0-.21-1.092l1.999-.55a.107.107 0 0 1 .135.088l.061.345 2.027-.527c.06-.014.126.023.135.089zm-.192 4.13c.06.013.126-.024.136-.09l.196-1.124a.113.113 0 0 0-.098-.13l-2.088-.197.06-.345a.113.113 0 0 0-.097-.13l-2.069-.169q-.016.576-.177 1.101l4.132 1.079zm-1.102 2.566a.115.115 0 0 1-.159.037l-3.516-2.427c.224-.293.406-.62.541-.97l1.887.863c.06.028.084.098.051.154l-.177.303 1.896.896a.11.11 0 0 1 .047.155zm-4.702-1.433 2.47 3.481c.037.052.112.061.159.02l.873-.733a.113.113 0 0 0 .01-.164l-1.472-1.489.271-.223c.051-.042.051-.117.005-.164l-1.48-1.456a4 4 0 0 1-.841.728zm-.024 4.742c-.06.023-.126-.014-.145-.075l-1.13-4.116c.37-.084.72-.22 1.042-.397l.892 1.872c.028.06 0 .13-.061.149l-.332.121.874 1.904c.028.06 0 .126-.061.15l-1.074.392z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/OneLogin.svg
var _path$19;
var _path2$11;
function _extends$20() {
	return _extends$20 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$20.apply(null, arguments);
}
var SvgOneLogin = function SvgOneLogin(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$20({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$19 || (_path$19 = /*#__PURE__*/ React.createElement("path", {
		fill: "#1C1F2A",
		d: "M10 1.742c-4.634 0-8.4 3.76-8.4 8.396a8.4 8.4 0 0 0 8.4 8.404c4.642 0 8.4-3.76 8.4-8.404A8.397 8.397 0 0 0 10 1.742"
	})), _path2$11 || (_path2$11 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M11.253 13.113q-.002.24-.242.242h-1.51c-.158 0-.24-.084-.24-.242v-3.64H8.105q-.24-.001-.242-.241v-1.51q.002-.24.242-.242h2.943c.159 0 .196.083.196.197v5.436z"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/OnePassword.svg
var _path$18;
var _path2$10;
var _path3$5;
var _path4$2;
var _path5$1;
var _path6$1;
var _path7$1;
var _path8$1;
var _path9$1;
var _path0$1;
var _path1$1;
var _path10$1;
var _path11$1;
function _extends$19() {
	return _extends$19 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$19.apply(null, arguments);
}
var SvgOnePassword = function SvgOnePassword(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$19({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 20,
		fill: "none",
		viewBox: "0 0 20 20"
	}, props), _path$18 || (_path$18 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		fillRule: "evenodd",
		d: "M.346 10A9.655 9.655 0 0 0 10 19.655 9.655 9.655 0 0 0 19.656 10c0-5.333-4.323-9.655-9.655-9.655A9.655 9.655 0 0 0 .346 10",
		clipRule: "evenodd"
	})), _path2$10 || (_path2$10 = /*#__PURE__*/ React.createElement("path", {
		fill: "#1A8CFF",
		fillRule: "evenodd",
		d: "M10 2.414a7.586 7.586 0 1 1 0 15.172 7.586 7.586 0 0 1 0-15.172",
		clipRule: "evenodd"
	})), _path3$5 || (_path3$5 = /*#__PURE__*/ React.createElement("path", {
		fill: "#000",
		d: "M0 10c0 5.523 4.477 10 10 10s10-4.477 10-10S15.523 0 10 0 0 4.477 0 10m.345 0C.345 4.668 4.667.345 10 .345S19.655 4.668 19.655 10 15.333 19.655 10 19.655.345 15.332.345 10",
		opacity: .5
	})), _path4$2 || (_path4$2 = /*#__PURE__*/ React.createElement("path", {
		fill: "#000",
		fillOpacity: .052,
		fillRule: "evenodd",
		d: "M19.642 9.483q.015.257.014.517c0 5.333-4.323 9.655-9.655 9.655A9.655 9.655 0 0 1 .359 9.483c.27 5.092 4.483 9.138 9.642 9.138 5.119 0 9.308-3.984 9.634-9.02zm-9.641-8.104a8.448 8.448 0 0 1 5.408 14.94 7.931 7.931 0 1 0-10.817 0A8.448 8.448 0 0 1 10 1.38",
		clipRule: "evenodd"
	})), _path5$1 || (_path5$1 = /*#__PURE__*/ React.createElement("path", {
		fill: "#000",
		d: "M10 2.414a7.586 7.586 0 1 1-7.585 7.711V10A7.586 7.586 0 0 1 10 2.414m0 .344a7.241 7.241 0 1 0 0 14.483 7.241 7.241 0 0 0 0-14.483",
		opacity: .256
	})), _path6$1 || (_path6$1 = /*#__PURE__*/ React.createElement("path", {
		fill: "#000",
		fillOpacity: .25,
		d: "M10.038 3.965a6.05 6.05 0 0 0-6.073 6.073c0 3.307 2.714 5.996 6.073 5.996 3.294 0 5.996-2.701 5.996-5.996 0-3.358-2.69-6.073-5.996-6.073m0 .345c3.104 0 5.651 2.548 5.651 5.728 0 3.104-2.547 5.652-5.651 5.652-3.18 0-5.728-2.548-5.728-5.652a5.706 5.706 0 0 1 5.728-5.728"
	})), _path7$1 || (_path7$1 = /*#__PURE__*/ React.createElement("path", {
		fill: "#F7F7F7",
		fillRule: "evenodd",
		d: "M10.038 4.31c3.105 0 5.652 2.548 5.652 5.728 0 3.105-2.547 5.652-5.652 5.652-3.18 0-5.727-2.547-5.727-5.652a5.706 5.706 0 0 1 5.727-5.727",
		clipRule: "evenodd"
	})), _path8$1 || (_path8$1 = /*#__PURE__*/ React.createElement("path", {
		fill: "#000",
		fillOpacity: .05,
		fillRule: "evenodd",
		d: "M12.587 10a2.586 2.586 0 1 1-5.173 0 2.586 2.586 0 0 1 5.172 0",
		clipRule: "evenodd"
	})), _path9$1 || (_path9$1 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M10 7.069a2.931 2.931 0 1 0 0 5.862 2.931 2.931 0 0 0 0-5.862m0 .345a2.586 2.586 0 1 1 0 5.172 2.586 2.586 0 0 1 0-5.172"
	})), _path0$1 || (_path0$1 = /*#__PURE__*/ React.createElement("path", {
		fill: "#000",
		fillOpacity: .15,
		d: "M10 7.414a2.586 2.586 0 1 1 0 5.172 2.586 2.586 0 0 1 0-5.172m0 .344a2.241 2.241 0 1 0 0 4.483 2.241 2.241 0 0 0 0-4.483"
	})), _path1$1 || (_path1$1 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M10.961 5.517H9.038c-.426 0-.763.373-.763.823V8.2c0 .17.061.333.172.456l.283.314c.006.007.006.027 0 .035l-.283.313a.68.68 0 0 0-.172.456v3.886c0 .45.337.823.763.823h1.923c.426 0 .763-.374.763-.823V11.8c0-.169-.06-.33-.172-.456l-.283-.314c-.006-.007-.006-.028 0-.035l.283-.314a.68.68 0 0 0 .172-.455V6.34c0-.45-.337-.823-.763-.823m-.022.351c.243 0 .44.224.44.499v3.857a.36.36 0 0 1-.086.235l-.275.312a.364.364 0 0 0 0 .47l.275.31a.36.36 0 0 1 .086.235v1.847c0 .275-.197.498-.44.498H9.06c-.242 0-.439-.223-.439-.498V9.775c0-.088.031-.172.086-.235l.275-.311a.364.364 0 0 0 0-.47l-.275-.31a.36.36 0 0 1-.086-.236V6.367c0-.275.197-.499.44-.499z"
	})), _path10$1 || (_path10$1 = /*#__PURE__*/ React.createElement("path", {
		fill: "#0A2D4D",
		fillRule: "evenodd",
		d: "M8.621 8.21V6.36c0-.275.197-.498.44-.498h1.88c.242 0 .439.223.439.499v3.864c0 .086-.03.17-.086.235l-.275.312a.365.365 0 0 0 0 .47l.275.312a.36.36 0 0 1 .086.235v1.85c0 .275-.197.499-.44.499H9.06c-.242 0-.439-.224-.439-.5V9.776c0-.088.031-.173.086-.235l.275-.312a.365.365 0 0 0 0-.47l-.275-.313a.36.36 0 0 1-.086-.235",
		clipRule: "evenodd"
	})), _path11$1 || (_path11$1 = /*#__PURE__*/ React.createElement("path", {
		fill: "#000",
		fillOpacity: .4,
		d: "M10.94 5.862c.243 0 .44.223.44.499v3.864c0 .086-.03.17-.086.235l-.275.312a.365.365 0 0 0 0 .47l.275.312a.36.36 0 0 1 .086.235v1.85c0 .275-.197.499-.44.499H9.06c-.242 0-.439-.224-.439-.5V9.776c0-.088.031-.173.086-.235l.275-.312a.365.365 0 0 0 0-.47l-.275-.313a.36.36 0 0 1-.086-.235V6.36c0-.275.197-.498.44-.498zm-.05.354-1.78-.002c-.07 0-.135.065-.143.158l-.001.02v1.833q0 .008.003.013l.002.004.288.31c.225.241.233.62.023.872l-.023.026-.288.31-.004.01v3.837c0 .097.06.169.129.178h.015l1.78.003c.07 0 .135-.065.143-.158l.001-.02v-1.833q0-.008-.002-.013l-.003-.004-.288-.31a.665.665 0 0 1-.023-.872l.023-.026.288-.31.004-.01.001-.007v-3.83c0-.097-.06-.169-.13-.178z"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/Oracle.svg
var _path$17;
function _extends$18() {
	return _extends$18 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$18.apply(null, arguments);
}
var SvgOracle = function SvgOracle(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$18({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$17 || (_path$17 = /*#__PURE__*/ React.createElement("path", {
		fill: "#E30613",
		d: "M6.902 15.444A5.3 5.3 0 0 1 1.6 10.142a5.3 5.3 0 0 1 5.302-5.303h6.196a5.3 5.3 0 0 1 5.302 5.303 5.3 5.3 0 0 1-5.302 5.302zm6.084-1.898a3.48 3.48 0 0 0 3.46-3.46 3.48 3.48 0 0 0-3.46-3.46H7.07a3.48 3.48 0 0 0-3.46 3.46 3.48 3.48 0 0 0 3.46 3.46z"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/Personio.svg
var _path$16;
function _extends$17() {
	return _extends$17 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$17.apply(null, arguments);
}
var SvgPersonio = function SvgPersonio(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$17({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$16 || (_path$16 = /*#__PURE__*/ React.createElement("path", {
		fill: "#000",
		d: "M9.878 12.317c-.653 2.324-1.192 4.276-1.236 4.54a.554.554 0 0 1-.554.485h-.062a.554.554 0 0 1-.486-.61c.024-.218.461-1.825.995-3.736-.755.351-1.376.579-1.759.626a1.4 1.4 0 0 1-.186.013c-.375 0-.564-.178-.657-.336a.553.553 0 0 1 .723-.774c.33-.046 1.173-.392 2.28-.966q.704-2.494 1.417-4.985a.554.554 0 0 1 1.064.304c-.34 1.188-.735 2.576-1.12 3.932A34 34 0 0 0 11.79 9.9c2.768-1.788 4.653-3.497 5.033-4.587.143-.406.039-.594-.163-.75-.485-.376-1.976-.423-4.707.573-4.092 1.491-8.416 4.388-8.828 5.899a.6.6 0 0 0 .128.011.55.55 0 0 1 .545.74.55.55 0 0 1-.495.365c-.117.005-.722.014-1.074-.402a1.01 1.01 0 0 1-.197-.894c.275-1.29 2.037-2.702 3.466-3.666 1.9-1.263 3.94-2.301 6.08-3.093 1.952-.715 4.537-1.36 5.765-.408.573.447.78 1.087.585 1.81-.251.937-1.36 2.585-5.211 5.12a39 39 0 0 1-2.84 1.7"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/PingIdentity.svg
var _path$15;
var _path2$9;
function _extends$16() {
	return _extends$16 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$16.apply(null, arguments);
}
var SvgPingIdentity = function SvgPingIdentity(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$16({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$15 || (_path$15 = /*#__PURE__*/ React.createElement("path", {
		fill: "#B8232F",
		fillRule: "evenodd",
		d: "M2.75 17.442h14.5v-14.5H2.75z",
		clipRule: "evenodd"
	})), _path2$9 || (_path2$9 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		fillRule: "evenodd",
		d: "M7.055 5.972c1.374 0 1.793.148 2.248.42.756.443 1.163 1.232 1.163 2.22 0 1.133-.512 2.046-1.396 2.49-.373.184-.723.283-1.619.283h-.896v3.157h-1.63v-8.57zm-.5 1.393H7.59c.688 0 1.095.481 1.095 1.282 0 .408-.058.655-.198.888-.22.358-.419.444-1.082.444h-.85z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/Quip.svg
var _path$14;
var _path2$8;
var _path3$4;
function _extends$15() {
	return _extends$15 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$15.apply(null, arguments);
}
var SvgQuip = function SvgQuip(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$15({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$14 || (_path$14 = /*#__PURE__*/ React.createElement("path", {
		fill: "#F27557",
		fillRule: "evenodd",
		d: "M15.493 10.142c0 .357-.29.646-.647.646H5.153a.646.646 0 1 1 0-1.292h9.693c.356 0 .646.289.646.646m-2.586 3.553H7.092a.648.648 0 0 1-.47-1.11.65.65 0 0 1 .47-.182h5.816a.646.646 0 0 1 0 1.293M7.092 6.588h5.816a.646.646 0 0 1 0 1.293H7.092a.646.646 0 1 1 0-1.293m7.775-1.626a7.04 7.04 0 0 0-4.862-1.927q-.228 0-.46.013a7.1 7.1 0 0 0-6.638 6.64 7.06 7.06 0 0 0 1.913 5.32A7.04 7.04 0 0 0 10 17.25h7.108v-7.108a7.04 7.04 0 0 0-2.24-5.18",
		clipRule: "evenodd"
	})), _path2$8 || (_path2$8 = /*#__PURE__*/ React.createElement("path", {
		fill: "#C34027",
		fillRule: "evenodd",
		d: "M17.108 17.25H10a7.04 7.04 0 0 1-5.18-2.241 7.06 7.06 0 0 1-1.913-5.322 7.1 7.1 0 0 1 7.098-6.652 7.04 7.04 0 0 1 4.862 1.927 7.04 7.04 0 0 1 2.24 5.18zM15.75 4.02a8.32 8.32 0 0 0-6.286-2.26 8.4 8.4 0 0 0-7.849 7.847 8.34 8.34 0 0 0 2.262 6.287A8.44 8.44 0 0 0 10 18.542h7.754a.646.646 0 0 0 .646-.646v-7.754a8.43 8.43 0 0 0-2.648-6.122",
		clipRule: "evenodd"
	})), _path3$4 || (_path3$4 = /*#__PURE__*/ React.createElement("path", {
		fill: "#FEFEFE",
		fillRule: "evenodd",
		d: "M12.908 12.403H7.092a.646.646 0 0 0 0 1.293h5.816a.646.646 0 0 0 0-1.293M7.092 7.88h5.816a.646.646 0 0 0 0-1.292H7.092a.646.646 0 1 0 0 1.292M5.154 9.496a.646.646 0 0 0 0 1.292h9.692a.646.646 0 0 0 0-1.292z",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/Ramp.svg
var _rect;
var _path$13;
function _extends$14() {
	return _extends$14 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$14.apply(null, arguments);
}
var SvgRamp = function SvgRamp(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$14({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 20,
		fill: "none",
		viewBox: "0 0 20 20"
	}, props), _rect || (_rect = /*#__PURE__*/ React.createElement("rect", {
		width: 20,
		height: 20,
		fill: "#E7F256",
		rx: 10
	})), _path$13 || (_path$13 = /*#__PURE__*/ React.createElement("path", {
		fill: "#000",
		d: "M15.714 13.94v.042l-6.225.002v-.045a9.7 9.7 0 0 0 2.075-1.562h2.556zM14.17 5.832l-1.577-1.547h-.046s.027 2.884-2.622 5.507c-2.593 2.567-5.64 2.573-5.64 2.573v.045l1.606 1.574s3.004.03 5.658-2.573c2.644-2.594 2.621-5.579 2.621-5.579"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/ReactNativeExpo.svg
var _path$12;
function _extends$13() {
	return _extends$13 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$13.apply(null, arguments);
}
var SvgReactNativeExpo = function SvgReactNativeExpo(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$13({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$12 || (_path$12 = /*#__PURE__*/ React.createElement("path", {
		fill: "#000",
		d: "M10.385 8.492a.44.44 0 0 0-.383-.188h-.004a.44.44 0 0 0-.383.188c-1.487 2.027-4.569 7.373-4.854 7.664-.422.43-1.001.162-1.337-.327-.332-.481-.424-.82-.424-1.18 0-.245 4.8-9.11 5.284-9.848.465-.71.616-.89 1.411-.89h.61c.795 0 .946.18 1.41.89C12.2 5.539 17 14.404 17 14.649c0 .36-.092.699-.423 1.18-.337.49-.916.758-1.338.327-.285-.291-3.367-5.637-4.854-7.664"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/Rippling.svg
var _path$11;
var _path2$7;
function _extends$12() {
	return _extends$12 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$12.apply(null, arguments);
}
var SvgRippling = function SvgRippling(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$12({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$11 || (_path$11 = /*#__PURE__*/ React.createElement("path", {
		fill: "#FDB71C",
		d: "M1.6 1.742h16.8v16.8H1.6z"
	})), _path2$7 || (_path2$7 = /*#__PURE__*/ React.createElement("path", {
		fill: "#292929",
		d: "M8.443 8.535c0-.673-.307-1.274-.814-1.67H6.198c.614.459.945 1.008.945 1.67 0 .663-.33 1.209-.945 1.67.556.25.867.714.867 1.369v1.312h1.3v-1.312c0-.69-.266-1.171-.731-1.369.503-.395.81-.997.81-1.67zM14.07 8.535c0-.673-.308-1.274-.81-1.67h-1.433c.614.459.945 1.008.945 1.67h-.003c0 .663-.331 1.209-.946 1.67.556.25.867.714.867 1.369v1.312h1.3v-1.312c0-.69-.265-1.171-.73-1.369.502-.395.81-.997.81-1.67M11.259 8.535c0-.673-.308-1.274-.81-1.67H9.015c.614.459.945 1.008.945 1.67h-.003c0 .663-.331 1.209-.946 1.67.556.25.867.714.867 1.369v1.312h1.3v-1.312c0-.69-.265-1.171-.73-1.369.502-.395.81-.997.81-1.67"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/Salesforce.svg
var _path$10;
function _extends$11() {
	return _extends$11 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$11.apply(null, arguments);
}
var SvgSalesforce = function SvgSalesforce(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$11({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$10 || (_path$10 = /*#__PURE__*/ React.createElement("path", {
		fill: "#00A1E0",
		fillRule: "evenodd",
		d: "M8.59 5.542a2.95 2.95 0 0 1 2.13-.914c1.112 0 2.075.617 2.593 1.537a3.6 3.6 0 0 1 1.463-.311c2 0 3.624 1.635 3.624 3.654s-1.624 3.655-3.624 3.655q-.365-.001-.716-.071a2.65 2.65 0 0 1-3.47 1.091 3.017 3.017 0 0 1-5.612-.136q-.284.06-.575.06c-1.55 0-2.803-1.271-2.803-2.833 0-1.05.564-1.963 1.401-2.457A3.262 3.262 0 0 1 5.998 4.26c1.056 0 2 .503 2.593 1.284",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/Sentry.svg
function _extends$10() {
	return _extends$10 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$10.apply(null, arguments);
}
var SvgSentry = function SvgSentry(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$10({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 20,
		fill: "none",
		viewBox: "0 0 20 20"
	}, props), /*#__PURE__*/ React.createElement("path", {
		fill: "#000",
		d: "M11.591 1.905a1.87 1.87 0 0 0-3.203 0L5.753 6.418a12.9 12.9 0 0 1 7.108 10.675h-1.85a11.08 11.08 0 0 0-6.19-9.098l-2.44 4.217a6.37 6.37 0 0 1 3.696 4.873H1.83a.303.303 0 0 1-.248-.445l1.177-2.002a4.3 4.3 0 0 0-1.345-.76L.247 15.88a1.817 1.817 0 0 0 .677 2.498c.276.156.588.239.905.24h5.818a7.77 7.77 0 0 0-3.203-6.93l.925-1.603a9.56 9.56 0 0 1 4.124 8.534h4.93A14.37 14.37 0 0 0 7.85 5.885l1.87-3.203a.31.31 0 0 1 .42-.108c.213.116 8.125 13.922 8.273 14.083a.304.304 0 0 1-.272.452h-1.906q.036.765 0 1.526h1.914a1.838 1.838 0 0 0 1.602-2.76z",
		style: {
			fill: "#000",
			fillOpacity: 1
		}
	}));
};

//#endregion
//#region src/ServiceIcon/icons/Shibboleth.svg
var _path$9;
var _path2$6;
var _path3$3;
var _g;
var _path4$1;
var _path5;
var _g2;
var _path6;
var _path7;
var _path8;
var _path9;
var _path0;
var _path1;
var _g3;
var _path10;
var _g4;
var _path11;
var _g5;
var _path12;
var _g6;
var _path13;
var _g7;
var _path14;
var _g8;
var _path15;
var _g9;
var _path16;
var _g0;
var _path17;
var _g1;
var _path18;
var _g10;
var _path19;
var _g11;
var _path20;
var _g12;
var _path21;
var _g13;
var _path22;
var _g14;
var _path23;
var _g15;
var _path24;
var _g16;
var _path25;
var _g17;
var _path26;
var _g18;
var _path27;
var _path28;
var _path29;
var _path30;
var _g19;
var _path31;
var _path32;
var _path33;
var _g20;
var _path34;
var _path35;
var _path36;
var _path37;
var _g21;
var _path38;
var _path39;
var _path40;
var _path41;
var _g22;
var _path42;
var _path43;
var _g23;
var _path44;
var _path45;
var _g24;
var _path46;
var _path47;
var _g25;
var _path48;
var _g26;
var _path49;
var _g27;
var _path50;
var _g28;
var _path51;
var _g29;
var _path52;
var _g30;
var _path53;
var _g31;
var _defs$2;
function _extends$9() {
	return _extends$9 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$9.apply(null, arguments);
}
var SvgShibboleth = function SvgShibboleth(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$9({
		xmlns: "http://www.w3.org/2000/svg",
		xmlnsXlink: "http://www.w3.org/1999/xlink",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$9 || (_path$9 = /*#__PURE__*/ React.createElement("path", {
		fill: "#231F20",
		d: "M11.548 12.468s-1.79 1.466-2.023 1.523c-.23.058-1.102.026-1.102.026l.886-1.517zM6.428 10.708s-.197.971-.67 1.549c-.44.537-.76.683-.76.683s-1.038-.275-1.378.079c-.272.283-.25.446-.25.446s-.082.011-.171.131c-.079.106-.026.21-.026.21s.005-.05.119-.079c.052-.013.105-.013.105-.013s.024.116.157.172c.157.065.237.053.237.053s-.053.04-.053.118c0 .115.026.144.026.144l.144-.106c.09-.065.13-.053.13-.053s.145.13.382.145c.643.04.955-.287 1.208-.356.29-.078.801-.13.801-.13s-.214-.158-.262-.447c-.072-.432 1.654-1.181 1.654-1.181L6.43 10.708"
	})), /*#__PURE__*/ React.createElement("mask", {
		id: "a",
		width: 5,
		height: 3,
		x: 3,
		y: 11,
		maskUnits: "userSpaceOnUse",
		style: { maskType: "luminance" }
	}, _path2$6 || (_path2$6 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M6.69 11.351s-.597.895-.827 1.156c-.39.441-.565.499-.565.499l.144.197s-1.102-.381-1.536-.132c-.246.143-.315.354-.315.354s-.016-.01.013.105c.028.116-.013.119-.013.119s-.003.064.078.091c.079.026.171.04.171.04s.087-.31.224-.406c.223-.157.736-.056.736-.056s-.47.05-.577.201c-.131.184-.079.355-.079.355s.487.172.893-.052c.525-.288.984-.263.984-.263s-.201-.232-.144-.433c.13-.458 1.38-1.34 1.38-1.34l-.565-.433"
	}))), /*#__PURE__*/ React.createElement("g", { mask: "url(#a)" }, /*#__PURE__*/ React.createElement("mask", {
		id: "b",
		width: 7,
		height: 7,
		x: 2,
		y: 9,
		maskUnits: "userSpaceOnUse",
		style: { maskType: "luminance" }
	}, _path3$3 || (_path3$3 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M6.334 9.76 2.41 12.024l2.085 3.61 3.924-2.265z"
	}))), _g || (_g = /*#__PURE__*/ React.createElement("g", { mask: "url(#b)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "url(#c)",
		d: "M2.389 9.722h6.067v5.914H2.389z"
	})))), _path4$1 || (_path4$1 = /*#__PURE__*/ React.createElement("path", {
		fill: "#231F20",
		d: "M10.608 1.308s.245.275.376.92c.064.312.066.8.066.8l.525-.486s.073.539.013.945c-.053.355-.263.933-.263.933l.42-.184-.125 1.37-1.068 2.364-2.22-.75 1.275-3.496s.34-.578.617-1.22c.2-.466.386-1.196.386-1.196"
	})), /*#__PURE__*/ React.createElement("mask", {
		id: "d",
		width: 4,
		height: 7,
		x: 8,
		y: 1,
		maskUnits: "userSpaceOnUse",
		style: { maskType: "luminance" }
	}, _path5 || (_path5 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M10.672 1.983s.072.203.101.522c.029.317.008.94.008.94l.583-.375s.019.27-.04.617c-.04.239-.106.421-.256.999l.403-.144s-.087.865-.23 1.412c-.145.548-.809 1.76-.809 1.76s-1.788-.49-1.788-.577c0-.088.739-2.275.94-2.824.202-.547.634-1.256.82-1.647.09-.19.267-.681.267-.681"
	}))), _g2 || (_g2 = /*#__PURE__*/ React.createElement("g", { mask: "url(#d)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "url(#e)",
		d: "M11.474 1.983H8.647v5.728h2.827z"
	}))), _path6 || (_path6 = /*#__PURE__*/ React.createElement("path", {
		fill: "#EE2E2F",
		d: "M10.733 12.6s-.945.97-1.208 1.076c-.262.106-.603-.053-.603-.053l1.102-1.13z"
	})), _path7 || (_path7 = /*#__PURE__*/ React.createElement("path", {
		fill: "#231F20",
		d: "M4.119 15.065s1.467-.68 2.361.186c.855.827.436 1.459.436 1.459s2.624 2.537 5.883.635c2.681-1.566 1.854-4.032.875-4.378-2.107-.744-3.965.525-6.325-.755-2.246-1.22-2.336-4.384-2.019-5.768.24-1.046.704-2.088.704-2.088s-.325-.154-.63-.774c-.205-.418-.421-1.32-.421-1.32s.734.308 1.523.361c.734.05 2.422-.245 2.862-.053.421.184.49.586.49.586s.806.29.938.746c.164.57-.072 1.1-.072 1.1s-.167-.155-.357-.278c-.184-.118-.335-.126-.335-.126s-.968.69-.894 1.528c.202 2.278 4.984.457 7.032 4.006 1.323 2.293.971 6.931-3.542 8.483-3.866 1.328-6.173-1.441-6.173-1.441s-.53.184-.92-.084c-.458-.313-.559-1.191-.696-1.446-.202-.374-.722-.576-.722-.576"
	})), /*#__PURE__*/ React.createElement("mask", {
		id: "f",
		width: 12,
		height: 17,
		x: 5,
		y: 2,
		maskUnits: "userSpaceOnUse",
		style: { maskType: "luminance" }
	}, _path8 || (_path8 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M9.59 3.225s-.13-.394-.454-.389c-.23.003-2.132.131-2.508.115-.7-.029-1.24-.288-1.24-.288s.225.877.606 1.24c.386.37.795.407.882.503.118.13.128.363.128.363s-.143-.147-.287-.205-.377-.083-.377-.083-.684 1.325-.75 2.71c-.087 1.818.246 3.754 2.124 4.698 2.098 1.054 4.144.006 5.54.394 2.825.784 2.143 4.302-.945 5.592-2.073.867-3.755.13-4.305-.132a5 5 0 0 1-1.234-.867l-.106.157s1.077 1.422 3.252 1.606c2.734.232 4.73-1.212 5.65-2.683 1.177-1.883 1.446-5.336-1.065-6.922-2.043-1.29-5.03-.764-5.579-2.385-.262-.775.066-1.22.066-1.22s-.268-.105-.48-.356c-.25-.296-.27-.5-.27-.5s.089-.45.526-.932c.345-.38.827-.42.827-.42"
	}))), /*#__PURE__*/ React.createElement("g", { mask: "url(#f)" }, _path9 || (_path9 = /*#__PURE__*/ React.createElement("path", {
		fill: "#EE2E2F",
		d: "m6.244 17.324.63-.875s1.506 1.61 3.326 1.54c1.821-.068 3.43-.84 4.202-2.415.422-.864.14-1.645.14-1.645l2.59-1.155s-.538 2.475-1.297 3.536c-.524.734-2.87 3.185-5.951 2.66s-3.642-1.644-3.642-1.644"
	})), /*#__PURE__*/ React.createElement("mask", {
		id: "g",
		width: 15,
		height: 14,
		x: 3,
		y: 1,
		maskUnits: "userSpaceOnUse",
		style: { maskType: "luminance" }
	}, _path0 || (_path0 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M15.767 9.063c-1.541-1.365-3.783-1.155-4.411-1.296-.416-.093-.618-.216-.708-.288l-.657-.817.91-1.45-1.19-3.36-5.216-.106-.84 6.301.629.63-.42.21 1.996 2.906.206-.173c.214.215.587.435 1.229.594 1.715.42 4.9.21 5.601.454s1.436 1.786 1.436 1.786l3.046-1.436s-.07-2.59-1.61-3.955"
	}))), /*#__PURE__*/ React.createElement("g", { mask: "url(#g)" }, /*#__PURE__*/ React.createElement("mask", {
		id: "h",
		width: 25,
		height: 26,
		x: -2,
		y: -5,
		maskUnits: "userSpaceOnUse",
		style: { maskType: "luminance" }
	}, _path1 || (_path1 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "m13.946-4.196-15.795 9.12 8.934 15.473 15.795-9.12z"
	}))), _g3 || (_g3 = /*#__PURE__*/ React.createElement("g", { mask: "url(#h)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "url(#i)",
		d: "M-1.873-4.217h24.768v24.614H-1.873z"
	}))))), /*#__PURE__*/ React.createElement("mask", {
		id: "j",
		width: 1,
		height: 2,
		x: 6,
		y: 6,
		maskUnits: "userSpaceOnUse",
		style: { maskType: "luminance" }
	}, _path10 || (_path10 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M6.664 6.218c.341.026.184.856.079.84-.104-.016-.475-.87-.079-.84"
	}))), _g4 || (_g4 = /*#__PURE__*/ React.createElement("g", { mask: "url(#j)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "url(#k)",
		d: "m6.23 7.068.042-.989.77.114-.042.99z"
	}))), /*#__PURE__*/ React.createElement("mask", {
		id: "l",
		width: 1,
		height: 2,
		x: 6,
		y: 7,
		maskUnits: "userSpaceOnUse",
		style: { maskType: "luminance" }
	}, _path11 || (_path11 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M6.27 7.242c.636-.116.478 1.084.242 1.048-.235-.035-.616-.979-.241-1.048"
	}))), _g5 || (_g5 = /*#__PURE__*/ React.createElement("g", { mask: "url(#l)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "url(#m)",
		d: "m5.847 8.318.056-1.341 1.054.157-.057 1.34z"
	}))), /*#__PURE__*/ React.createElement("mask", {
		id: "n",
		width: 2,
		height: 2,
		x: 7,
		y: 8,
		maskUnits: "userSpaceOnUse",
		style: { maskType: "luminance" }
	}, _path12 || (_path12 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M7.741 8.11c.683-.237.735.984.472.97-.262-.012-.88-.83-.472-.97"
	}))), _g6 || (_g6 = /*#__PURE__*/ React.createElement("g", { mask: "url(#n)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "url(#o)",
		d: "m7.282 9.086.057-1.381 1.188.176-.06 1.38z"
	}))), /*#__PURE__*/ React.createElement("mask", {
		id: "p",
		width: 2,
		height: 2,
		x: 6,
		y: 8,
		maskUnits: "userSpaceOnUse",
		style: { maskType: "luminance" }
	}, _path13 || (_path13 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M7.426 9.29c-.128.024-.928-.884-.446-.97.734-.132.684.927.446.97"
	}))), _g7 || (_g7 = /*#__PURE__*/ React.createElement("g", { mask: "url(#p)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "url(#q)",
		d: "m6.45 9.306.056-1.297 1.256.185-.056 1.3z"
	}))), /*#__PURE__*/ React.createElement("mask", {
		id: "r",
		width: 1,
		height: 2,
		x: 6,
		y: 8,
		maskUnits: "userSpaceOnUse",
		style: { maskType: "luminance" }
	}, _path14 || (_path14 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M6.167 8.372c.629-.018.645.942.384.957-.263.014-.762-.946-.384-.957"
	}))), _g8 || (_g8 = /*#__PURE__*/ React.createElement("g", { mask: "url(#r)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "url(#s)",
		d: "m5.79 9.342-.062-1.04 1.084.05.06 1.04z"
	}))), /*#__PURE__*/ React.createElement("mask", {
		id: "t",
		width: 1,
		height: 2,
		x: 6,
		y: 9,
		maskUnits: "userSpaceOnUse",
		style: { maskType: "luminance" }
	}, _path15 || (_path15 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M6.848 10.682c-.145.063-1.163-.995-.63-1.155.787-.237.814 1.077.63 1.155"
	}))), _g9 || (_g9 = /*#__PURE__*/ React.createElement("g", { mask: "url(#t)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "url(#u)",
		d: "M7.032 9.29H5.685v1.453h1.347z"
	}))), /*#__PURE__*/ React.createElement("mask", {
		id: "v",
		width: 2,
		height: 2,
		x: 6,
		y: 9,
		maskUnits: "userSpaceOnUse",
		style: { maskType: "luminance" }
	}, _path16 || (_path16 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M6.98 9.447c.892-.29.865 1.155.683 1.155-.183 0-1.221-.98-.683-1.155"
	}))), _g0 || (_g0 = /*#__PURE__*/ React.createElement("g", { mask: "url(#v)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "url(#w)",
		d: "M7.87 9.16H6.44v1.444h1.43z"
	}))), /*#__PURE__*/ React.createElement("mask", {
		id: "x",
		width: 2,
		height: 2,
		x: 7,
		y: 9,
		maskUnits: "userSpaceOnUse",
		style: { maskType: "luminance" }
	}, _path17 || (_path17 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M8.501 10.34c-.131.024-1.041-.835-.499-.998.787-.237.787.945.5.998"
	}))), _g1 || (_g1 = /*#__PURE__*/ React.createElement("g", { mask: "url(#x)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "url(#y)",
		d: "M8.79 9.106H7.46v1.258h1.33z"
	}))), /*#__PURE__*/ React.createElement("mask", {
		id: "z",
		width: 2,
		height: 2,
		x: 6,
		y: 5,
		maskUnits: "userSpaceOnUse",
		style: { maskType: "luminance" }
	}, _path18 || (_path18 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M6.901 5.351c-.342.023-.104.869.026.787.21-.13.368-.814-.026-.787"
	}))), _g10 || (_g10 = /*#__PURE__*/ React.createElement("g", { mask: "url(#z)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "url(#A)",
		d: "M7.295 5.326h-.736v.894h.736z"
	}))), /*#__PURE__*/ React.createElement("mask", {
		id: "B",
		width: 1,
		height: 2,
		x: 7,
		y: 6,
		maskUnits: "userSpaceOnUse",
		style: { maskType: "luminance" }
	}, _path19 || (_path19 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M7.242 6.244c.5-.078.446.867.237.867s-.523-.82-.237-.867"
	}))), _g11 || (_g11 = /*#__PURE__*/ React.createElement("g", { mask: "url(#B)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "url(#C)",
		d: "M7.741 6.166h-.785v.945h.785z"
	}))), /*#__PURE__*/ React.createElement("mask", {
		id: "D",
		width: 2,
		height: 2,
		x: 6,
		y: 7,
		maskUnits: "userSpaceOnUse",
		style: { maskType: "luminance" }
	}, _path20 || (_path20 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M7.295 8.188c-.221-.01-.746-1.003-.237-1.05.66-.06.5 1.063.237 1.05"
	}))), _g12 || (_g12 = /*#__PURE__*/ React.createElement("g", { mask: "url(#D)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "url(#E)",
		d: "m6.501 8.193.056-1.288 1.208.18-.054 1.287z"
	}))), /*#__PURE__*/ React.createElement("mask", {
		id: "F",
		width: 2,
		height: 2,
		x: 5,
		y: 6,
		maskUnits: "userSpaceOnUse",
		style: { maskType: "luminance" }
	}, _path21 || (_path21 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M5.981 6.218c.277-.084.263.815.106.815s-.447-.709-.106-.815"
	}))), _g13 || (_g13 = /*#__PURE__*/ React.createElement("g", { mask: "url(#F)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "url(#G)",
		d: "M6.26 6.134h-.62v.899h.62z"
	}))), /*#__PURE__*/ React.createElement("mask", {
		id: "H",
		width: 1,
		height: 2,
		x: 5,
		y: 7,
		maskUnits: "userSpaceOnUse",
		style: { maskType: "luminance" }
	}, _path22 || (_path22 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M5.744 7.452c.232-.051.237.603.132.656-.106.053-.368-.603-.132-.656"
	}))), _g14 || (_g14 = /*#__PURE__*/ React.createElement("g", { mask: "url(#H)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "url(#I)",
		d: "M5.981 7.4H5.51v.76h.472z"
	}))), /*#__PURE__*/ React.createElement("mask", {
		id: "J",
		width: 2,
		height: 1,
		x: 7,
		y: 7,
		maskUnits: "userSpaceOnUse",
		style: { maskType: "luminance" }
	}, _path23 || (_path23 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M7.792 7.111c.368-.053.316.787.184.787-.13 0-.464-.747-.184-.787"
	}))), _g15 || (_g15 = /*#__PURE__*/ React.createElement("g", { mask: "url(#J)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "url(#K)",
		d: "M8.16 7.058h-.648v.84h.648z"
	}))), /*#__PURE__*/ React.createElement("mask", {
		id: "L",
		width: 1,
		height: 2,
		x: 6,
		y: 5,
		maskUnits: "userSpaceOnUse",
		style: { maskType: "luminance" }
	}, _path24 || (_path24 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M6.296 5.378c.181-.036.132.656-.025.656s-.237-.603.025-.656"
	}))), _g16 || (_g16 = /*#__PURE__*/ React.createElement("g", { mask: "url(#L)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "url(#M)",
		d: "M6.477 5.342h-.443v.692h.443z"
	}))), /*#__PURE__*/ React.createElement("mask", {
		id: "N",
		width: 1,
		height: 1,
		x: 7,
		y: 5,
		maskUnits: "userSpaceOnUse",
		style: { maskType: "luminance" }
	}, _path25 || (_path25 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M7.61 5.51c.126-.037.131.393 0 .446s-.184-.394 0-.446"
	}))), _g17 || (_g17 = /*#__PURE__*/ React.createElement("g", { mask: "url(#N)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "url(#O)",
		d: "M7.741 5.473h-.315v.534h.315z"
	}))), /*#__PURE__*/ React.createElement("mask", {
		id: "P",
		width: 3,
		height: 2,
		x: 8,
		y: 3,
		maskUnits: "userSpaceOnUse",
		style: { maskType: "luminance" }
	}, _path26 || (_path26 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M8.413 4.518s.168-.544.575-.898c.356-.312.668-.291.668-.291s.652.206.83.475c.223.34.09.814.09.814s-.243-.196-.715-.25c-.353-.04-.835.074-1.05.124-.259.06-.398.026-.398.026"
	}))), _g18 || (_g18 = /*#__PURE__*/ React.createElement("g", { mask: "url(#P)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "url(#Q)",
		d: "M10.708 3.308H8.413v1.309h2.295z"
	}))), _path27 || (_path27 = /*#__PURE__*/ React.createElement("path", {
		fill: "#F6EB00",
		d: "M9.796 4.538s-.375.25-.519.434c-.104.133-.197.288-.197.288s-.118-.027-.38-.229c-.172-.131-.29-.361-.29-.361s.144.016.29-.013l.512-.106c.308-.059.584-.013.584-.013"
	})), _path28 || (_path28 = /*#__PURE__*/ React.createElement("path", {
		fill: "#231F20",
		d: "M5.877 3.068s0 .029.26.115c.259.087.777.066 1.038.344.241.258.288.637.173.695-.116.057-.36-.392-.476-.536s-.534-.258-.707-.328c-.224-.092-.288-.288-.288-.288M7.714 3.33s.082-.084.184-.137c.134-.069.437-.026.627-.018l.39.018-.143.125-.144.012s-.095.213-.276.23c-.26.026-.296-.23-.296-.23h-.34"
	})), /*#__PURE__*/ React.createElement("mask", {
		id: "R",
		width: 3,
		height: 2,
		x: 4,
		y: 15,
		maskUnits: "userSpaceOnUse",
		style: { maskType: "luminance" }
	}, _path29 || (_path29 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M4.637 15.124s.922-.16 1.442.173c.584.374.837 1.269.345 1.528-.49.259-.83-.115-.916-.288s-.252-.784-.341-.971c-.149-.314-.53-.442-.53-.442"
	}))), /*#__PURE__*/ React.createElement("g", { mask: "url(#R)" }, /*#__PURE__*/ React.createElement("mask", {
		id: "S",
		width: 5,
		height: 6,
		x: 3,
		y: 13,
		maskUnits: "userSpaceOnUse",
		style: { maskType: "luminance" }
	}, _path30 || (_path30 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M6.347 13.978 3.72 15.494l1.488 2.578 2.627-1.517z"
	}))), _g19 || (_g19 = /*#__PURE__*/ React.createElement("g", { mask: "url(#S)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "url(#T)",
		d: "M3.695 13.946h4.147v4.147H3.695z"
	})))), _path31 || (_path31 = /*#__PURE__*/ React.createElement("path", {
		fill: "#231F20",
		d: "M9.504 11.46s-.508 1.067-.739 1.414c-.23.346-.63.746-.774.775s-1.05-.026-1.327.237c-.216.206-.17.368-.17.368s-.087-.003-.145.17.013.369.013.369.024-.093.106-.157c.065-.053.105-.053.105-.053s.018.058.091.131a.4.4 0 0 0 .157.079s-.065.078-.078.197a.6.6 0 0 0 .013.21s.062-.097.144-.157c.081-.061.118-.053.118-.053s.107.067.222.09c.184.04.25-.025.25-.025s-.078.04-.078.184.04.197.04.197.104-.066.144-.105.148-.034.148-.034.077.022.26.006c.313-.027.441-.39.63-.577.25-.25.814-.394.814-.394s-.353-.171-.34-.355c.014-.197 1.37-1.392 1.601-1.536s.234-.434.263-.578-.14-.374-.14-.374l.26-.087s-.173-.116-.383-.273c-.18-.134-.368-.262-.368-.262l-.837.595"
	})), /*#__PURE__*/ React.createElement("mask", {
		id: "U",
		width: 4,
		height: 6,
		x: 7,
		y: 10,
		maskUnits: "userSpaceOnUse",
		style: { maskType: "luminance" }
	}, _path32 || (_path32 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M10.392 10.892s-.008.058.079.21c.105.184.29.275.29.275l-.218.083s.086.144.029.374c-.058.23-1.444 1.719-1.586 1.933-.272.407.122.525.122.525s-.472.106-.67.283c-.106.098-.316.519-.518.49-.201-.029-.256-.275-.137-.538.056-.125.25-.368.25-.368s-.13.053-.303.197-.237.5-.237.5-.136.002-.222-.026c-.087-.03-.144-.132-.144-.132s-.09-.299.171-.472c.26-.172.563-.224.827-.34.354-.159.95-1.04 1.152-1.474.202-.432.136-1.165.359-1.442.42-.524.761-.078.761-.078"
	}))), /*#__PURE__*/ React.createElement("g", { mask: "url(#U)" }, /*#__PURE__*/ React.createElement("mask", {
		id: "V",
		width: 6,
		height: 7,
		x: 6,
		y: 9,
		maskUnits: "userSpaceOnUse",
		style: { maskType: "luminance" }
	}, _path33 || (_path33 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "m10.648 9.808-4.408.777.908 5.146 4.407-.777z"
	}))), _g20 || (_g20 = /*#__PURE__*/ React.createElement("g", { mask: "url(#V)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "url(#W)",
		d: "M6.229 9.799h5.338v5.952H6.229z"
	})))), _path34 || (_path34 = /*#__PURE__*/ React.createElement("path", {
		fill: "#FAF397",
		d: "M7.636 13.898s-.59-.012-.775.184c-.133.141-.158.296-.091.407.04.065.118.105.118.105s-.04-.236.184-.42c.194-.16.565-.276.565-.276"
	})), _path35 || (_path35 = /*#__PURE__*/ React.createElement("path", {
		fill: "#231F20",
		d: "M12.424 9.615s-1.126 1.173-.824 2.42a1.3 1.3 0 0 0 1.024 1.01l-.21.369s-.826-.026-1.26.315c-.384.302-.315.63-.315.63s-.061.29.197.46c.137.09.302.1.302.1s.171.123.38.175c.26.065.526-.053.526-.053s.564.144.958-.184c.363-.303.67-1.155.814-1.445.144-.288.999-1.286.861-1.606a6 6 0 0 0-.317-.607c-.057-.086-.115-.547-.115-.547l-2.019-1.038"
	})), /*#__PURE__*/ React.createElement("mask", {
		id: "X",
		width: 4,
		height: 6,
		x: 11,
		y: 9,
		maskUnits: "userSpaceOnUse",
		style: { maskType: "luminance" }
	}, _path36 || (_path36 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M12.781 9.29c-.648.308-1.155 2.023-.63 2.836.668 1.037 1.629.17 1.629.17s-.015.198-.237.407c-.181.17-.434.303-.434.303l-.302.512.158.13s-.993-.105-1.505.185a.65.65 0 0 0-.35.552c0 .21.191.22.191.22s.037-.347.21-.49c.173-.145.358-.124.358-.124s-.201.159-.28.324c-.088.184-.06.35-.06.35s.082.106.254.131c.17.026.376-.043.376-.043s-.002-.262.123-.429c.118-.157.34-.227.34-.227s-.172.267-.2.411a.5.5 0 0 0 0 .227s.393.06.594-.113c.202-.173.627-1.117.815-1.445.345-.605.74-1.03.709-1.314-.034-.307-.21-.38-.21-.683 0-.38.157-.656.157-.656s-.157-1.97-1.707-1.234"
	}))), /*#__PURE__*/ React.createElement("g", { mask: "url(#X)" }, /*#__PURE__*/ React.createElement("mask", {
		id: "Y",
		width: 10,
		height: 10,
		x: 8,
		y: 7,
		maskUnits: "userSpaceOnUse",
		style: { maskType: "luminance" }
	}, _path37 || (_path37 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "m13.706 7.057-5.31 3.066 3.579 6.199 5.31-3.066z"
	}))), _g21 || (_g21 = /*#__PURE__*/ React.createElement("g", { mask: "url(#Y)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "url(#Z)",
		d: "M8.38 7.034h8.909v9.293H8.38z"
	})))), _path38 || (_path38 = /*#__PURE__*/ React.createElement("path", {
		fill: "#EE2E2F",
		d: "M8.352 3.353a.083.083 0 0 1-.083.083.083.083 0 0 1-.083-.083c0-.047.037-.083.083-.083s.083.036.083.083"
	})), _path39 || (_path39 = /*#__PURE__*/ React.createElement("path", {
		fill: "#231F20",
		d: "M6.312 6.292s.128.472.224.602c.112.148.175.224.175.224s-.192.078-.3-.11c-.107-.191-.099-.714-.099-.714M6.799 7.409s.256.448.344.579c.099.147.241.18.241.18s-.064.142-.25.042c-.246-.128-.335-.801-.335-.801M6.076 7.42s.142.434.288.65c.099.147.227.204.227.204s-.17.127-.327-.06c-.15-.181-.19-.794-.19-.794M7.602 8.447s.285.373.483.46c.199.087.3.057.3.057s-.012.25-.22.205c-.286-.06-.563-.722-.563-.722M6.837 8.59s.434.619.594.563c.075-.026.144-.14.144-.14s.069.369-.103.39c-.292.035-.635-.815-.635-.815M6.008 8.6s.39.618.56.588c.114-.02.165-.096.165-.096s.082.314-.112.334c-.34.037-.613-.825-.613-.825M7.82 9.578s.42.71.686.632c.08-.022.168-.401.168-.401s.096.725-.128.737c-.542.03-.726-.97-.726-.97M7.664 10.758c-.244-.002-.579-.407-.579-.407s-.102.527-.29.472c-.441-.128-.767-1.022-.767-1.022s.107.118.313.33c.248.254.38.383.5.353.12-.029.108-.342.108-.342l-.152-.487s.211.282.397.47c.198.202.354.345.478.28.125-.066.096-.367.096-.367s.261.723-.104.72M8.733 8.778s.36-.118.808-.894c.176-.306.78-1.789 1.154-2.163.374-.375 2.585-1.931 2.585-1.931l-.048.403s.628-.359 1.098-.719c.552-.42 1.642-1.33 1.642-1.33s-.03.574-.303 1.12c-.197.394-.361.582-.361.582l.768-.412s-.124.672-.354 1.077c-.23.403-.368.5-.368.5l.29-.053s-.159.656-.594 1.108c-.389.404-.64.559-.64.559l.302.025s-.13.276-.512.644c-.248.24-.419.33-.419.33l.394-.015s-.415.84-1.352 1.142c-.607.195-1.493.17-1.493.17s-.346.213-.635.328c-.288.115-.693.104-.693.104l-1.269-.578"
	})), /*#__PURE__*/ React.createElement("mask", {
		id: "aa",
		width: 5,
		height: 6,
		x: 8,
		y: 4,
		maskUnits: "userSpaceOnUse",
		style: { maskType: "luminance" }
	}, _path40 || (_path40 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M8.685 8.766s.171.09.696-.303c.44-.33 1.226-2.107 1.487-2.454.26-.347 2.076-1.674 2.076-1.674s-.123.472-.476.95c-.525.71-.75.591-1.012 1.037-.184.316-.184.88-.761 2.167-.312.696-.323 1.037-1.09 1.037-.709 0-.918-.762-.918-.762"
	}))), /*#__PURE__*/ React.createElement("g", { mask: "url(#aa)" }, /*#__PURE__*/ React.createElement("mask", {
		id: "ab",
		width: 10,
		height: 10,
		x: 6,
		y: 2,
		maskUnits: "userSpaceOnUse",
		style: { maskType: "luminance" }
	}, _path41 || (_path41 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "m11.748 2.423-5.395 3.37L9.88 11.44l5.395-3.371z"
	}))), _g22 || (_g22 = /*#__PURE__*/ React.createElement("g", { mask: "url(#ab)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "url(#ac)",
		d: "M6.344 2.388h8.947v9.062H6.344z"
	})))), /*#__PURE__*/ React.createElement("mask", {
		id: "ad",
		width: 4,
		height: 4,
		x: 12,
		y: 2,
		maskUnits: "userSpaceOnUse",
		style: { maskType: "luminance" }
	}, _path42 || (_path42 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M12.794 5.26s.117-.21.237-.434c.099-.185.156-.368.156-.368s.644-.302 1.024-.552c.421-.275 1.274-1.01 1.274-1.01s-.305 1.055-1.233 1.68c-.722.486-1.458.682-1.458.682"
	}))), /*#__PURE__*/ React.createElement("g", { mask: "url(#ad)" }, /*#__PURE__*/ React.createElement("mask", {
		id: "ae",
		width: 4,
		height: 4,
		x: 12,
		y: 2,
		maskUnits: "userSpaceOnUse",
		style: { maskType: "luminance" }
	}, _path43 || (_path43 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "m15.405 2.436-3.014.532.485 2.751 3.014-.531z"
	}))), _g23 || (_g23 = /*#__PURE__*/ React.createElement("g", { mask: "url(#ae)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "url(#af)",
		d: "M12.373 2.426h3.533v3.302h-3.533z"
	})))), /*#__PURE__*/ React.createElement("mask", {
		id: "ag",
		width: 4,
		height: 4,
		x: 12,
		y: 3,
		maskUnits: "userSpaceOnUse",
		style: { maskType: "luminance" }
	}, _path44 || (_path44 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M13.096 5.444s.736-.262 1.183-.538c.368-.227.886-.742.886-.742l.578-.317s-.451 1.15-1.714 1.874c-.984.565-1.51.577-1.51.577s.264-.232.355-.368c.106-.156.222-.486.222-.486"
	}))), /*#__PURE__*/ React.createElement("g", { mask: "url(#ag)" }, /*#__PURE__*/ React.createElement("mask", {
		id: "ah",
		width: 5,
		height: 4,
		x: 12,
		y: 3,
		maskUnits: "userSpaceOnUse",
		style: { maskType: "luminance" }
	}, _path45 || (_path45 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "m15.645 3.294-3.546.626.517 2.927 3.545-.625z"
	}))), _g24 || (_g24 = /*#__PURE__*/ React.createElement("g", { mask: "url(#ah)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "url(#ai)",
		d: "M12.066 3.271h4.109v3.61h-4.109z"
	})))), /*#__PURE__*/ React.createElement("mask", {
		id: "aj",
		width: 4,
		height: 3,
		x: 12,
		y: 5,
		maskUnits: "userSpaceOnUse",
		style: { maskType: "luminance" }
	}, _path46 || (_path46 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M12.874 6.534s.714-.239 1.155-.487c.447-.25 1.077-.801 1.077-.801l.237-.026s-.315.867-1.36 1.394c-.98.494-1.687.587-1.687.587s.156-.131.29-.275c.184-.197.29-.394.29-.394"
	}))), /*#__PURE__*/ React.createElement("g", { mask: "url(#aj)" }, /*#__PURE__*/ React.createElement("mask", {
		id: "ak",
		width: 5,
		height: 4,
		x: 11,
		y: 4,
		maskUnits: "userSpaceOnUse",
		style: { maskType: "luminance" }
	}, _path47 || (_path47 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "m15.25 4.7-3.293.58.431 2.445 3.294-.581z"
	}))), _g25 || (_g25 = /*#__PURE__*/ React.createElement("g", { mask: "url(#ak)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "url(#al)",
		d: "M11.951 4.692h3.763v3.034h-3.763z"
	})))), /*#__PURE__*/ React.createElement("mask", {
		id: "am",
		width: 3,
		height: 3,
		x: 12,
		y: 6,
		maskUnits: "userSpaceOnUse",
		style: { maskType: "luminance" }
	}, _path48 || (_path48 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M12.453 7.423s.427-.069.722-.166c.393-.131.777-.323.777-.323l.317-.058s-.635.606-1.182.837-1.039.317-1.039.317.104-.114.22-.287c.115-.173.183-.318.183-.318"
	}))), _g26 || (_g26 = /*#__PURE__*/ React.createElement("g", { mask: "url(#am)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "url(#an)",
		d: "M14.27 6.874h-2.22v1.154h2.22z"
	}))), /*#__PURE__*/ React.createElement("mask", {
		id: "ao",
		width: 3,
		height: 2,
		x: 11,
		y: 7,
		maskUnits: "userSpaceOnUse",
		style: { maskType: "luminance" }
	}, _path49 || (_path49 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M11.935 8.287s.505-.08.795-.166a9 9 0 0 0 .763-.296l.23.029s-.52.49-1.01.635c-.489.144-1.037.115-1.037.115z"
	}))), _g27 || (_g27 = /*#__PURE__*/ React.createElement("g", { mask: "url(#ao)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "url(#ap)",
		d: "m11.69 7.65-.085.978 2.102.184.085-.979z"
	}))), /*#__PURE__*/ React.createElement("mask", {
		id: "aq",
		width: 2,
		height: 2,
		x: 10,
		y: 8,
		maskUnits: "userSpaceOnUse",
		style: { maskType: "luminance" }
	}, _path50 || (_path50 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M10.839 8.647s.19-.04.38-.118c.223-.091.399-.213.399-.213s-.227.33-.582.528c-.226.125-.456.194-.456.194z"
	}))), _g28 || (_g28 = /*#__PURE__*/ React.createElement("g", { mask: "url(#aq)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "url(#ar)",
		d: "m10.7 7.984-.352.97 1.148.418.353-.97z"
	}))), /*#__PURE__*/ React.createElement("mask", {
		id: "as",
		width: 2,
		height: 2,
		x: 11,
		y: 7,
		maskUnits: "userSpaceOnUse",
		style: { maskType: "luminance" }
	}, _path51 || (_path51 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M11.18 7.898s.184-.052.379-.158c.144-.078.448-.275.448-.275l.216-.015s-.23.346-.578.578c-.345.23-.635.26-.635.26l.168-.39"
	}))), _g29 || (_g29 = /*#__PURE__*/ React.createElement("g", { mask: "url(#as)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "url(#at)",
		d: "m11.021 7.346-.082.935 1.275.112.082-.936z"
	}))), /*#__PURE__*/ React.createElement("mask", {
		id: "au",
		width: 2,
		height: 2,
		x: 11,
		y: 6,
		maskUnits: "userSpaceOnUse",
		style: { maskType: "luminance" }
	}, _path52 || (_path52 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "m11.3 7.51.182-.477s.218-.069.42-.184.438-.32.438-.32l.259.029s-.432.49-.693.664c-.26.172-.606.288-.606.288"
	}))), _g30 || (_g30 = /*#__PURE__*/ React.createElement("g", { mask: "url(#au)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "url(#av)",
		d: "M12.597 6.529H11.3v.98h1.297z"
	}))), /*#__PURE__*/ React.createElement("mask", {
		id: "aw",
		width: 2,
		height: 2,
		x: 11,
		y: 5,
		maskUnits: "userSpaceOnUse",
		style: { maskType: "luminance" }
	}, _path53 || (_path53 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M11.573 6.705s.024-.218.079-.328c.052-.106.302-.263.54-.482.234-.214.403-.464.403-.464h.23s-.141.43-.506.815c-.357.377-.75.459-.75.459"
	}))), _g31 || (_g31 = /*#__PURE__*/ React.createElement("g", { mask: "url(#aw)" }, /*#__PURE__*/ React.createElement("path", {
		fill: "url(#ax)",
		d: "m12.79 5.216-1.434.253.256 1.45 1.434-.253z"
	}))), _defs$2 || (_defs$2 = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
		id: "e",
		x1: 10.581,
		x2: 10.581,
		y1: 7.724,
		y2: 1.996,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#EE3030" }), /*#__PURE__*/ React.createElement("stop", {
		offset: .13,
		stopColor: "#EF402B"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .39,
		stopColor: "#F46C1F"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .75,
		stopColor: "#FCB30B"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .86,
		stopColor: "#FFCA05"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .87,
		stopColor: "#FECD12"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .89,
		stopColor: "#FDDB42"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .92,
		stopColor: "#FCE567"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .94,
		stopColor: "#FBEC82"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .97,
		stopColor: "#FBF192"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .98,
		stopColor: "#FBF398"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#FBF398"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "k",
		x1: 4.008,
		x2: 4.043,
		y1: 79.704,
		y2: 78.881,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#FFCA05" }), /*#__PURE__*/ React.createElement("stop", {
		offset: .15,
		stopColor: "#FFCA05"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .26,
		stopColor: "#FECD10"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .45,
		stopColor: "#FDD52D"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .71,
		stopColor: "#FCE25D"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .98,
		stopColor: "#FBF398"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#FBF398"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "m",
		x1: 2.951,
		x2: 2.994,
		y1: 99.112,
		y2: 98.082,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#F26728" }), /*#__PURE__*/ React.createElement("stop", {
		offset: .03,
		stopColor: "#F36F25"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .18,
		stopColor: "#F89617"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .32,
		stopColor: "#FBB20D"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .44,
		stopColor: "#FEC307"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .53,
		stopColor: "#FFCA05"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .59,
		stopColor: "#FECD10"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .7,
		stopColor: "#FDD52D"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .84,
		stopColor: "#FCE25D"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .98,
		stopColor: "#FBF398"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#FBF398"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "o",
		x1: 4.228,
		x2: 4.268,
		y1: 80.725,
		y2: 79.769,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#F26728" }), /*#__PURE__*/ React.createElement("stop", {
		offset: .03,
		stopColor: "#F36F25"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .18,
		stopColor: "#F89617"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .32,
		stopColor: "#FBB20D"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .44,
		stopColor: "#FEC307"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .53,
		stopColor: "#FFCA05"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .59,
		stopColor: "#FECD10"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .7,
		stopColor: "#FDD52D"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .84,
		stopColor: "#FCE25D"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .98,
		stopColor: "#FBF398"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#FBF398"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "q",
		x1: 3.536,
		x2: 3.576,
		y1: 79.504,
		y2: 78.567,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#F26728" }), /*#__PURE__*/ React.createElement("stop", {
		offset: .03,
		stopColor: "#F36F25"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .18,
		stopColor: "#F89617"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .32,
		stopColor: "#FBB20D"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .44,
		stopColor: "#FEC307"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .53,
		stopColor: "#FFCA05"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .59,
		stopColor: "#FECD10"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .7,
		stopColor: "#FDD52D"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .84,
		stopColor: "#FCE25D"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .98,
		stopColor: "#FBF398"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#FBF398"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "s",
		x1: 9.803,
		x2: 9.748,
		y1: 80.13,
		y2: 79.186,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#F26728" }), /*#__PURE__*/ React.createElement("stop", {
		offset: .03,
		stopColor: "#F36F25"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .18,
		stopColor: "#F89617"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .32,
		stopColor: "#FBB20D"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .44,
		stopColor: "#FEC307"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .53,
		stopColor: "#FFCA05"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .59,
		stopColor: "#FECD10"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .7,
		stopColor: "#FDD52D"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .84,
		stopColor: "#FCE25D"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .98,
		stopColor: "#FBF398"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#FBF398"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "u",
		x1: 5.79,
		x2: 5.79,
		y1: 10.698,
		y2: 9.511,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#F26728" }), /*#__PURE__*/ React.createElement("stop", {
		offset: .19,
		stopColor: "#F37323"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .53,
		stopColor: "#F79318"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .98,
		stopColor: "#FEC706"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#FFCA05"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "w",
		x1: 7.01,
		x2: 7.01,
		y1: 10.609,
		y2: 9.415,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#F26728" }), /*#__PURE__*/ React.createElement("stop", {
		offset: .06,
		stopColor: "#F36F25"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .34,
		stopColor: "#F89617"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .6,
		stopColor: "#FBB20D"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .83,
		stopColor: "#FEC307"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#FFCA05"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "y",
		x1: 8.711,
		x2: 8.711,
		y1: 10.335,
		y2: 9.306,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#F26728" }), /*#__PURE__*/ React.createElement("stop", {
		offset: .06,
		stopColor: "#F36F25"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .34,
		stopColor: "#F89617"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .6,
		stopColor: "#FBB20D"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .83,
		stopColor: "#FEC307"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#FFCA05"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "A",
		x1: 7.189,
		x2: 7.189,
		y1: 6.144,
		y2: 5.351,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#FFCA05" }), /*#__PURE__*/ React.createElement("stop", {
		offset: .01,
		stopColor: "#FFCA05"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .14,
		stopColor: "#FECD10"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .37,
		stopColor: "#FDD52D"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .67,
		stopColor: "#FCE25D"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .98,
		stopColor: "#FBF398"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#FBF398"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "C",
		x1: 7.951,
		x2: 7.951,
		y1: 7.105,
		y2: 6.234,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#FFCA05" }), /*#__PURE__*/ React.createElement("stop", {
		offset: .14,
		stopColor: "#FECD10"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .36,
		stopColor: "#FDD52D"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .66,
		stopColor: "#FCE25D"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .98,
		stopColor: "#FBF398"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#FBF398"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "E",
		x1: 3.401,
		x2: 3.445,
		y1: 85.034,
		y2: 84.01,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#F26728" }), /*#__PURE__*/ React.createElement("stop", {
		offset: .03,
		stopColor: "#F36F25"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .18,
		stopColor: "#F89617"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .32,
		stopColor: "#FBB20D"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .44,
		stopColor: "#FEC307"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .53,
		stopColor: "#FFCA05"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .59,
		stopColor: "#FECD10"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .7,
		stopColor: "#FDD52D"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .84,
		stopColor: "#FCE25D"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .98,
		stopColor: "#FBF398"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#FBF398"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "G",
		x1: 6.363,
		x2: 6.363,
		y1: 7.029,
		y2: 6.209,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#FFCA05" }), /*#__PURE__*/ React.createElement("stop", {
		offset: .14,
		stopColor: "#FECD10"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .36,
		stopColor: "#FDD52D"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .66,
		stopColor: "#FCE25D"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .98,
		stopColor: "#FBF398"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#FBF398"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "I",
		x1: 5.623,
		x2: 5.623,
		y1: 8.115,
		y2: 7.453,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#FFCA05" }), /*#__PURE__*/ React.createElement("stop", {
		offset: .14,
		stopColor: "#FECD10"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .36,
		stopColor: "#FDD52D"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .66,
		stopColor: "#FCE25D"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .98,
		stopColor: "#FBF398"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#FBF398"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "K",
		x1: 7.46,
		x2: 7.46,
		y1: 7.907,
		y2: 7.117,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#FFCA05" }), /*#__PURE__*/ React.createElement("stop", {
		offset: .14,
		stopColor: "#FECD10"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .36,
		stopColor: "#FDD52D"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .66,
		stopColor: "#FCE25D"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .98,
		stopColor: "#FBF398"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#FBF398"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "M",
		x1: 6.415,
		x2: 6.415,
		y1: 6.035,
		y2: 5.377,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#FFCA05" }), /*#__PURE__*/ React.createElement("stop", {
		offset: .14,
		stopColor: "#FECD10"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .36,
		stopColor: "#FDD52D"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .66,
		stopColor: "#FCE25D"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .98,
		stopColor: "#FBF398"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#FBF398"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "O",
		x1: 7.535,
		x2: 7.535,
		y1: 5.963,
		y2: 5.51,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#FFCA05" }), /*#__PURE__*/ React.createElement("stop", {
		offset: .14,
		stopColor: "#FECD10"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .36,
		stopColor: "#FDD52D"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .66,
		stopColor: "#FCE25D"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .98,
		stopColor: "#FBF398"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#FBF398"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "Q",
		x1: 9.719,
		x2: 9.719,
		y1: 4.62,
		y2: 3.33,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#F7EC00" }), /*#__PURE__*/ React.createElement("stop", {
		offset: .42,
		stopColor: "#FAF472"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .81,
		stopColor: "#FDFCD7"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .98,
		stopColor: "#fff"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#fff"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "an",
		x1: 13.222,
		x2: 13.222,
		y1: 8.032,
		y2: 6.878,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#EE3030" }), /*#__PURE__*/ React.createElement("stop", {
		offset: .1,
		stopColor: "#EF402B"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .3,
		stopColor: "#F46C1F"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .58,
		stopColor: "#FCB30B"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .66,
		stopColor: "#FFCA05"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#FFCA05"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "ap",
		x1: 12.387,
		x2: 12.468,
		y1: 8.674,
		y2: 7.743,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#EE3030" }), /*#__PURE__*/ React.createElement("stop", {
		offset: .1,
		stopColor: "#EF402B"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .3,
		stopColor: "#F46C1F"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .58,
		stopColor: "#FCB30B"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .66,
		stopColor: "#FFCA05"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#FFCA05"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "ar",
		x1: 11.51,
		x2: 11.863,
		y1: 9.37,
		y2: 8.401,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#EE3030" }), /*#__PURE__*/ React.createElement("stop", {
		offset: .11,
		stopColor: "#EF402B"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .33,
		stopColor: "#F46C1F"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .64,
		stopColor: "#FCB30B"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .74,
		stopColor: "#FFCA05"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#FFCA05"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "at",
		x1: 11.327,
		x2: 11.409,
		y1: 8.323,
		y2: 7.387,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#EE3030" }), /*#__PURE__*/ React.createElement("stop", {
		offset: .11,
		stopColor: "#EF402B"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .33,
		stopColor: "#F46C1F"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .64,
		stopColor: "#FCB30B"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .74,
		stopColor: "#FFCA05"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#FFCA05"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "av",
		x1: 11.299,
		x2: 12.597,
		y1: 7.24,
		y2: 7.24,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#EE3030" }), /*#__PURE__*/ React.createElement("stop", {
		offset: .11,
		stopColor: "#EF402B"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .33,
		stopColor: "#F46C1F"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .64,
		stopColor: "#FCB30B"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .74,
		stopColor: "#FFCA05"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#FFCA05"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "ax",
		x1: 11.899,
		x2: 11.712,
		y1: 6.657,
		y2: 5.597,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#EE3030" }), /*#__PURE__*/ React.createElement("stop", {
		offset: .11,
		stopColor: "#EF402B"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .33,
		stopColor: "#F46C1F"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .64,
		stopColor: "#FCB30B"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: .74,
		stopColor: "#FFCA05"
	}), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#FFCA05"
	})), /*#__PURE__*/ React.createElement("pattern", {
		id: "c",
		width: 1,
		height: 1,
		patternContentUnits: "objectBoundingBox"
	}, /*#__PURE__*/ React.createElement("use", {
		xlinkHref: "#ay",
		transform: "scale(.00637 .0065)"
	})), /*#__PURE__*/ React.createElement("pattern", {
		id: "i",
		width: 1,
		height: 1,
		patternContentUnits: "objectBoundingBox"
	}, /*#__PURE__*/ React.createElement("use", {
		xlinkHref: "#az",
		transform: "scale(.00155 .00156)"
	})), /*#__PURE__*/ React.createElement("pattern", {
		id: "T",
		width: 1,
		height: 1,
		patternContentUnits: "objectBoundingBox"
	}, /*#__PURE__*/ React.createElement("use", {
		xlinkHref: "#aA",
		transform: "scale(.00935 .00943)"
	})), /*#__PURE__*/ React.createElement("pattern", {
		id: "W",
		width: 1,
		height: 1,
		patternContentUnits: "objectBoundingBox"
	}, /*#__PURE__*/ React.createElement("use", {
		xlinkHref: "#aB",
		transform: "scale(.00725 .00654)"
	})), /*#__PURE__*/ React.createElement("pattern", {
		id: "Z",
		width: 1,
		height: 1,
		patternContentUnits: "objectBoundingBox"
	}, /*#__PURE__*/ React.createElement("use", {
		xlinkHref: "#aC",
		transform: "scale(.00439 .00418)"
	})), /*#__PURE__*/ React.createElement("pattern", {
		id: "ac",
		width: 1,
		height: 1,
		patternContentUnits: "objectBoundingBox"
	}, /*#__PURE__*/ React.createElement("use", {
		xlinkHref: "#aD",
		transform: "scale(.00433 .0043)"
	})), /*#__PURE__*/ React.createElement("pattern", {
		id: "af",
		width: 1,
		height: 1,
		patternContentUnits: "objectBoundingBox"
	}, /*#__PURE__*/ React.createElement("use", {
		xlinkHref: "#aE",
		transform: "scale(.01087 .0119)"
	})), /*#__PURE__*/ React.createElement("pattern", {
		id: "ai",
		width: 1,
		height: 1,
		patternContentUnits: "objectBoundingBox"
	}, /*#__PURE__*/ React.createElement("use", {
		xlinkHref: "#aF",
		transform: "scale(.00962 .01075)"
	})), /*#__PURE__*/ React.createElement("pattern", {
		id: "al",
		width: 1,
		height: 1,
		patternContentUnits: "objectBoundingBox"
	}, /*#__PURE__*/ React.createElement("use", {
		xlinkHref: "#aG",
		transform: "scale(.01042 .01299)"
	})), /*#__PURE__*/ React.createElement("image", {
		xlinkHref: "data:image/png;base64,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",
		id: "ay",
		width: 157,
		height: 154,
		preserveAspectRatio: "none"
	}), /*#__PURE__*/ React.createElement("image", {
		xlinkHref: "data:image/png;base64,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",
		id: "az",
		width: 645,
		height: 641,
		preserveAspectRatio: "none"
	}), /*#__PURE__*/ React.createElement("image", {
		xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGsAAABqCAYAAAC746+pAAAACXBIWXMAAC4jAAAuIwF4pT92AAAQpUlEQVR4nO1dW6wdVRn+1ux9Ts+xp0h5AWnRSgC5tJRyEVFAaolBwZdGIwmXkLQKQUKJvmiQB8ODAjEGYuQil5iqCYQYFS8E0SKKBumFUmKgQAOWQ9QHIe257L1n1lo+rPua++yZfTnlT3bOzOzZc/aeb/7/+9b3rz2bcM45jsCIejvBwl2pz08uv36A76ZYBMN+A4MORmcRdp7IBAoQYI5atIf9BgYZYecJcPpOoX1ZuBOsdRyC1uqG31XxOCLAyit5bhhWoOGu98EaVDA6i6jzmxKvsOibc/BoFiw6iKB9Qu3vrUosSbAYnQUNdxcueT5IYp0DnIH2XhgZsMhSU4NleMkBCdwAxTkAJjczBJPnoz11Qb1vtEIsmcyqyksCHPWXwWSVWmdgnb8CIwDW2GdWv7yUCBKY2MYZiHq+tRoTR11d63svG2ObWXXyklsCFUjMWqdAeACsdwDB5Il1f5TCMZZg9VfykniJC0DAAM4FUNx+UIBzsPkd74NVNJrkJZ1N3MomBRYYCKdA7zXw3msgkyfX+8EKxlhwVi0lT2eSnV3U5SWVUYyK5xmVAFIDHovQXnV3zZ+wWIw0WH2BlCHFnYyxeMrOJsJtkOSDUQAUwYrPI/jgFXV+1EIxsmD1X/KYJyQUL3Gv5FHYvAQwEAmKBsgBLQIYRXvNI7V+3iIxcmA1L8WZ2cYSeMnOKBYBcAEjchuZPA3Bqm/X9rmLxMgIjOZ4SZx8osFT3GMJC5uT7AzyMovobSH4wgvgC/tAPrCu5jORHiORWU1YROV5iUmAmAdUJMGMZAkMARaCgALLNiBY891az0VWDDWzmuGlJClelpdECSScAohEOeSh3GaWMfcsMLcbmDm7ztOSGkPJrMHykpdNjhQ3Ck9lkdpGNEgSHBqBINTAER4BrCeW1++r8eykx0Aza3AWURovpQEVxQQEWJiQTaFZ5j25TweYvQ9YdUOt5yopBpZZjfFSjkVEVNZo9ZcsILR4kKCIbWo5kkBZIKEDwrpyvQec/CRwdLPOfOOZNTiLiCImLDznQYyzLI7SvJSWSTZIEigegvBFWQK7EkgC/OtHjYPVWGY1I8UTWhcFLSIjJiK9jYAaUHgE0FDwks4kyUsIAdYD4V1R9lhPZhQBaCD+8gA447fAMc0BVntm1cdLCpyc1oWVTVkWkQHK4iUFhpNNFERmkCl5XRDWketdwYWsBbBAPgg4C4A37gVpEKxaM2tYrQvBSwy+2+Bzk8NLPJIg2bwUSaAUSD3JSwooqsERYAFcLVMBGPnIN0FO3VbXKXWiFrCG3rpQ25X8dnhJgqR5ibo8xCRIiETWaF5SAHUML6mSxwKAE3CqsqolnxeAtb5wsN9Tmhh9gTW81gWTfGMDZfOSJSA0LxmlR5zMkiBJXgL3uIkRA5Bd8hgRWWUDRsV+wcm3gKy9peppTY1KYI1q68KxiJh0HxyLSIkJO7u6Fi8pKd4R/4+2AG6XOQEG1+DZIKnnATCC9kXbgQ9dWPbUZkZpgTHqrQvHx9NS3IydHJCkiNAg8Y7FS+1kXuKBBY6VaRQSWCJwfukBtGoGq3BmDbd1ke88GIvIgCLKYE9Lc2MRdT1eSpHiLIWXNGCBrtJggXj71AA2uekRYPVFJc5ZduSC1axFVKR1kVD2uAuU3brIt4i6Fi8pKY6SvETAOTEgMYjtnBjwuNi+bMv+spikRiZYzVpEGbyksktJ8rKti0IWUUe8N1uKK16SmcNzeEkvc3u7nW0EE+uvR/CJr5fFJTESwRq8RVSUl2yLKKN1EbOIuiKTbIuIpoyXGGJS3OUlWICYkideF8jn5Ta5/9RNr1aExw0HrKXWuhDlbrEEL3mA+bzEU0qew1ew9hdgBseei8krt/cFFCDV4FJtXbi8lGIR+bzEs0qelUl2hlG5j6r4XsbRt3eCH3gG5MRL+gKL9BZ/zZdW66IHwuxsyreIEsWDAqAAL9nLZl8XuOD4DVh27U/7AqtdDKg6eMm3iFSWFbGIlMFqW0RqkOu1LrTiUxZRywMp2SJSalAN+dJ4SZdCB6SE/VQmytNC39oD/vozICddUhks0p27L2ecVZdFlNe6KGMRSWvIsYisbEriJSYVHk+2iOKlrQAvcQsk6q6rUwJ9qsSxln/n5cpgBcHEORkgcbNsA6BkjuXLEe6BwZQQEHxDLHkNFgK0Z0obFSeZ0K5wvVkXoF2ALoLQjmhPUPk8WwTYAsAWATYPwuZA2GGAzgNRF4gCIJLZRFvgkXoE4LQFRC1w2gaP2kAUgFOZTZSIfSKI7QoAau0TEf3xQInYT24DE/uCEt19gQKdEnlcIHryzspgEc45783f74FkLWdaRNm8hMIWUWTW8ywip3WhLKJIlro8XpJlkcNIcWZnkF3KfL6C2T+Fl2yx66xbr+OMYOaul6qDJST7E+4zA5zdOqjWhealxNJWgZe4BZKzzS5AMtO04wG01qzD9M0/Kw1WGwCC1iqQ1vFCuhed3erwklweeOsiQCmLSHJJYV5KkeIqG1XV93nJzSSzLP5y0P37wP75JwSnf6Y8WADQmjgbUfS2BxTc8jbirQsXsOoWkS/FDciQ/8dcp0ZUIOEYLkhgXG/v/u5BTJcEy3EwosVfgkUHDWCNty6U2+CVQG6ZrcxvXaTwklR9yRYR8U5gjkWkwUmX4ibDgHg2yderrFOnihKxIPdddvmVmNz8rWpgAUDv0N3mssnlJS+bilhEunWRZhHZzkMNrQvbIkpyHxKyQvAeYLLG56UEIPW1a7gpxmWUu8eiwFHb9xYGK3ajrWDyPMSleARQtyVBmCfF1eCVqrFOCEJ7QorTrihhVLjehKtlKcvZAsDmATYHwubFOp0HaGikOPWkOA3Ao5aQ03KbK8XlciQlNlUS297uSXEq99OyO9Cym8vrUFwoREt5cwwi5bx0PyL7uABCmGNF8rWUoPdY8S82JLru4eGfA9FbHjcNcHarbxFR5bs1ZxG5vJQhxVN5yTzMdu7u60h/k10zt30frfWbcsFKbOu3pj4JeugNl5f8cqcutb5mtya0LkpaRJVaFx4PNcJLjMtleaosUPWx5XXfefzHWF4VrGBiDWiwGggPpLculCy3eYlbPSbVuvBnt2a2LiQYA2pdFOKl2KDWPvEme3gGLznZRO2LRewT7n4FdM/TaG24tDxYANCeuRj0f/tTgIpMydPjKMVdOa2LorNb7fESz5PixJxYu+Spspg2XpLZmC3FiZc1MNlDuSUquFaeBpD0bDLvSTwWH30QMzlgZbb16eGnwA//3uWmYbUuPIuoEC95WVHYIirCSwlS3AAS5yX9Wj+7qHl+6rovYeq6W6uBBQDR7NeQ3rrwxkfaIlINQNsi6sJtXQQapEIWUQ4vVW1dJPJSgkWUKh4cXkoAXL9vuO9L7R9BKkmxbeXze1KxyL1HbrD8MihnnEhRIKS4dMXZIoQsF04D0Y74AsAWQNgcwOakFKeeFCfgtAUepklx5ZZLkJTkppYUpwE4s6S4vJa0FFeuODVjNSPXDbi2nObqBKpt0jEXxyZAxF3ZHkKvKzpXr9Hum1oPrUePgIdELMvnOw/dnopFoXmD9J3vAZ29urw5XCS9PXdCv7KIVDYxKR4CxGcOeWovyyJSgiGp5CVlUhmLSA0PfF6KZVM58QA/m+T4jHMJmJ+BFFjx8B1on/fZGA6FZuQGK68Am30e5VsXipdSZrfqMlfGImqudeFKce7xEncvioq8ZJc8GyB9YQHobH8IM1XBItNrQSbXAgt/hzu7Na91oXpMA2xdpErxuHjItYgYEB8v2RdGTjZR6692PSyAPJBUhDv2I3rhqVh2FZ4+zef3gr95kyXF1WDWnt3asU7U+LUuzLGVFE8BySmD8DI1BST/OfXIiJX7XLFR+Cb8ZPl6kGO2QPt2uqU+B9DDAF0U4oEGAG0bcaA8OyUYYi11ReqBJvDclroWE9aJUC11JQQU6FZLXZ047ePpksTN9ghaQCSKB+3twYgHata1sFDvL7K2hdY+OUABQOdBV2yU/soPf/GkGme3pvES4haR5zY02bpweMmX3SoznP9ngVWQl4qGnV3lv5916B/A/stQe+sipvKSOKeCRZTCS0YZElSxiPrlpaIxsfEUzNzzKIAqv0Vy1MeB6cuLtS5oUuuCxFsXDHBbGgmtC1VS5L79ti701Z/SutAlzhoD6fGSep09XuoR8B5MqVOvU2BWDCU2gKo/HHP8jYaX5MA2kZdCf8CqBrXWiaWBNQUsj5eIvEisq93npcge1BqAQLk32M3gJXsQq0ubtW4DmMRLarkPkOzobH8IQB/fKea7rwHeezJe8ka1dZFqEXkKL4+XOGIWUb+8VCRWPHxHn18A/8OxCVK8gdmtebyUJcWr8lIDUrzfqFYGZZATbk2Q4rCkOEme3eqXPHt2q8dL2mtTINgkro6heEaXPUuK27ykyxsxF4pd8szMhbgU93mpghTvJ6a3be7/Phj0Vx9G2uzWgbYuikpxu7zZWVHGIrLLXsNhq8H+b1ryn+cQPXtVKi+Val34llCB2a2JcjrGS+r/ebyU07oAs1z8mqR40ZjYeAqmrtniWE7937vp2E+BHH0x2H+fK8dLSeLBPhFlLKI0XsrJplHkJaBP1z0vWmd8FfTff0sueUmZ1E/rQoPELfC4+//KDGrtkpfTumg6prdtxtTW21Kfr+1GW2znDxDuvTc1KwrxUhMWkc9LsSxCMi81LMXtsHkpK2q9K1r3gY/FeSl3dmtcPBRrXcDwUtlsatgiKhpJvJQVtd5vcOLM69HbdX8yL1VtXcjs6bt1IQezo8JLeSUvKWq/k2f42NWIZndZvORlUxIvxaS4Jx4q8FK6FLftK8TLXsNRBSQV9d929c0/Y/HxGwxITbQuylpEI8JLZUpeUtR/Q+M1n0bruHNAD+4p2bqowSLK4yVfWIwJSCoaufv0xAVfQfTmjQkCgnhZAyt7Ss5u9XnJzqQ0kNT2MSh5SdHY3aejp+9C7y8/ybaInIxI4CWl+JJkdyYvJZS8MQZJRaM34Z+/dW06LyWBVMQiSuOlIbUu7Kiz5CVFozfhX3bhtejs2F4vL42ZRVRnNP7zFp0fXoXo9ZeTx0tVxYNd8qKlxUtZ0fjPW0xu2oro1W2Dmd06QJCKWkR1RuNgBadtROujaxHtfxlZ7kMsc9KkuGpdjIlFVGcM7Fd+Dm9d74K0hFoXg4q+2vplYtnnrnRnETHEZhHlzm4dYkt95b49QwUKGPAv0x266qzEQe24ty4GFQMFi770R8zd/o1yFtERxktZMdCfEWyduQnt009F9OIrS6p1MagYGGepmNq8NWV2a//fuugnFC+NKlDAEH76trX+UrTXnYpo5ysjw0ujWPKSYmg/Kv3exrOWTOtiUDHwMqhi6tovJktxBVyDMb1tM2bueXSsgAKG/HPt7567YclbRHXG0DILAFbcd6cpfw3GxMZTsOLhO8YaKGDImQUAczd/GeGO+n62yI9hW0R1xlAzCwCmrtnSyHFHxSKqM4aeWYD4Vvri3b+o5VjjzktZMRJgAcC76zb09fpxlOJlY+CD4rSY3ra5cnYtJV7KipHJLKC82BhlH6+JGLrAsKOo2FBS/EgCChixzAKys+tI4KWsGKnMAtKza1wtojpj5DILcKX8kcZLWTEyatAOBU57/flHdCa9H2Mc/wcYkaY2V9WlrQAAAABJRU5ErkJggg==",
		id: "aA",
		width: 107,
		height: 106,
		preserveAspectRatio: "none"
	}), /*#__PURE__*/ React.createElement("image", {
		xlinkHref: "data:image/png;base64,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",
		id: "aB",
		width: 138,
		height: 153,
		preserveAspectRatio: "none"
	}), /*#__PURE__*/ React.createElement("image", {
		xlinkHref: "data:image/png;base64,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",
		id: "aC",
		width: 228,
		height: 239,
		preserveAspectRatio: "none"
	}), /*#__PURE__*/ React.createElement("image", {
		xlinkHref: "data:image/png;base64,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",
		id: "aD",
		width: 231,
		height: 233,
		preserveAspectRatio: "none"
	}), /*#__PURE__*/ React.createElement("image", {
		xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFwAAABUCAYAAAAPvFA1AAAACXBIWXMAAC4jAAAuIwF4pT92AAAISElEQVR4nO2dTYgcRRTH/9U7u8kaCYle3IiiRiNR4ypmiR8X48GbCjko6FXwIizoTfHqUfAk3vUqgnpRQVAhCbsh5AtNwK9EjR6MkkSz2e6u56G7ql9VV09X79TM9Ezvg6G7q6qrq3/1+rc9nyuIiDDlIdPfINOLAACSF0Hp78H6ntv2SqP2vWBHbkkk66sAwoMNFRMLXIEFABkfG+NImoVou1KGqYMQEc0+gt7cfu/2rcrwtusgRIwF+KTqIEQMFXjbdRAiZHwMGIdSuqCDENEYeJd1UBUy/Q3RzK1ebSuBd0EHoUKmF5sB39RB09j4nXQvXvtkE3Jl1IDNn8JQ+isAvz+ckYgWBhzUNARVPFg9EUCyeMg0X09ByQXvI7Xqic9owi9ri3aUr/Jystr6Ry+aWYCMG+83AdEUrCpzgLXb83YkAQAy/hnR7B21o+r5/nVtb9RlmZ2hsGBb4MmV2Rxy9hBWe0ouAD7Aa1u0KoakAwumsU2AEGS2cy0p9TqDHgCImV0tu1MZrQ5UeV+wTth5HwKgq18ANzxZe2YZ8GhhTMDboQMNnmQ1WDUpIAB2O+lxLlmMUCmD6KAKLEowN6QDDRC6TAie2dLqVxZL4mX1od+AWP/3fa8d6qNlOqiEnPWhwRr1km1bUIkAkS+tdtH2ZxHteLbv6Q+Q4VOmgxJAtg0bsJnhQtXLpJaaJ/AO6EDvY9cX7YR6lilUvWT1qRdwrZRkfRUyXu3feop1YJdlWasyPLXq86f1eXnWNluP9n7ZF2FFhndQB2AwdT1fzx4CCjS/Ali210QB3BhUHVi1PogOOCAGdkN3B1X1DXTAX5giCSF4VqtJS/W20JmeZvurLL+8Amxfqgfe27KE9fXDZbAb1QGRuyzvo6wDR/ZuVAc625rpoMhWNgmQEDrTc7i8DyT5MZNs+/KqH3AAgOTZ0j0dZGDVvmoSWBZTBthoR7E1tv5P8Q3gIroFlJyffB1A1TfUgZokJAClRdbytvoKV2CjAiABuHIUwKt+wKPeLsj4BwatpTrIwQTXga5PrISQZbBqm4RJ9MrHlbBLwCFTIF0vem2qA56xg+rAgEyWDnhfAXXgBJvDtcHqNqyc3E0qgUdzt4OuxmiXDizPBtMBA6thVWRtP7BGeb5+6TBw02P1wMXsbkCuobM68AWrt4W7/T8rfsABAOl1B8xh6KCA3SodNAGr1lkdESCqjgcHcNG7E7R2Bm4dMLD25T4tOiBX33CCzSZTtRG6HV1agdhdHgbgAj53F/DfykA6ECWQDXSg72PHpANHphNxsMj3Ze1JFFUUAZe+QFWOl5UiYyD5bwAdlL0rkMDI1DbowAkWRYarrHVkOOltR1vrSrDD+Q0I+d3BIejAAZafuHXyzrIR6IBPhAZrty21i0pl0e7XIe5fLp2O89VCkVyt0UGa35FwHcQwXmeZVB242vJ2PKtJmMckgPQ+pTwGUPXybHoZXdYB6fGzfavA6v6sY6ncs8L9papf3wP+eBNd1YENmYwJ4eNSfQr7tT4AwOxLP5aQuDOcUoDW2XY+cDWgUvsR68AGCwTWgTUuGywvV3WSTbLbJgAqgQOQHdSBLPojfeXxNoL1YdW5JsUR1d/TPLK9WO+gDtQVU8pavR6Z9whGtmercw+9gujR1ww01e/aSwfYLumAgc0ynpWzK0FPirT3FUBazuVq4NueA658WnRgLDugA3sMfD8js4VxfGLgk/PHMfeEibUa+I37gX8+05uj1gERADEkHVDUJ9sdEwIUVzxPENekyWKZ/nK8hLUaOAGUKjc30IGRXROsAxdY1VaP3Ro3P1bFfXg18J37gZ8iPYagOuAnpwfXLh2U+xDGeJ0JwI+nlue+gthzUGOtBn7z43mGm2CzY0y/Dnj7Ult7IqVVzt6nSX9YQc8LOJABH5YOPG67xq4D48pjY+D78kmW7IpRfSaq0yz6Ao+2PwX519dlsDa8SdGBDbYqazlclfFGppvAnROX1yVnT2D2GU/g2PEI6M9vzMF1SAdOuMY+KN5pVOXWFRCfOYN5hrQ/cAlQwpVSgGulDkrtB9NBqZ00y3R/gPkanxTmubGo/Qmm+IO7TUAG2OnWgbksrjTjwwnSvKpIkglcAltfeB5bXnwDgMcH8tWnDoLpwDVpLdWBrlflfF9JVqarfYRZlsL4w+kBPCrrwAY7LB0Yl3wZYK0O1ATYdb46IICITIB6UoXVF/QbYNnrKCjejWSvqdQqRR55B+vH3jfBMiihdEA2qBHroMhYUwd6QoxJyR+pMD5GUwBny5zVzlPZ0/z67/ikBCS5q6daB8Lax4InhfH+eQYcxYdo+Xj6RL1SUoBipYIO6oDDtRNgA+H1Q5HX3r5/uDooTQ5fjlgHHCwwEFwe88uHsPXlt/y+NphlOByqaK4DcpVPiA5ChBfwaGER6c8nO6+DQSI5eRqAJ/DebYtIzp3qrwMbbGMdwISr7oBaoIMQEX91DoAncEoIuL6pgxDhBXxm9xLo+odhdGD/UZwAHYSKZOVzT4ff9xRoTbmzezoIFcmJo/6/JkFr8NeBBjxdOggR3sB79+5FfPx7tw7yrJ9mHYSI5ORpf+Az9+xD/O3ZzupgozF7cA96Dz4AAOgtHmjwAzUJgfJPMQPYzFpHzC8f0utbX37L2abR/4D4e9/Dg49qCsIHbFVM2O8WjjZKOlh6euA+N4HnobI2FNiqaAR8fvkQrr370bDGMpIYRAchYmozfBg6CBFTAXxUOggRjf9T1TjvVMatgxDRygxvqw5CxNiBT5IOQkRj4Bu9U5kGHYSI4Bk+zToIEY2B9xYPAMgyvGs62IwJjP8BY6MMGIjsbyIAAAAASUVORK5CYII=",
		id: "aE",
		width: 92,
		height: 84,
		preserveAspectRatio: "none"
	}), /*#__PURE__*/ React.createElement("image", {
		xlinkHref: "data:image/png;base64,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",
		id: "aF",
		width: 104,
		height: 93,
		preserveAspectRatio: "none"
	}), /*#__PURE__*/ React.createElement("image", {
		xlinkHref: "data:image/png;base64,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",
		id: "aG",
		width: 96,
		height: 77,
		preserveAspectRatio: "none"
	}))));
};

//#endregion
//#region src/ServiceIcon/icons/SimpleSAMLPHP.svg
var _path$8;
var _path2$5;
function _extends$8() {
	return _extends$8 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$8.apply(null, arguments);
}
var SvgSimpleSamlphp = function SvgSimpleSamlphp(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$8({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$8 || (_path$8 = /*#__PURE__*/ React.createElement("path", {
		fill: "#505050",
		fillRule: "evenodd",
		d: "M13.424 1.67a3.7 3.7 0 0 0-1.599-.418c-.437-.007-1.083.058-1.636.296-.557.24-1.09.692-1.104 1.471-.006.343.049.615.142.847.091.228.214.404.318.548l.018.027c.163.227.282.395.312.678A5.4 5.4 0 0 0 8.08 6.306a5.35 5.35 0 0 0-1.224 1.89.7.7 0 0 1-.25-.075c-.082-.044-.149-.1-.25-.185l-.053-.045a2 2 0 0 0-.504-.32 2.1 2.1 0 0 0-.84-.146c-.791 0-1.294.5-1.58 1.045a3.7 3.7 0 0 0-.39 1.605c0 .438.077 1.083.325 1.632.249.552.71 1.078 1.49 1.078.343 0 .614-.06.844-.157.227-.096.4-.222.543-.328l.026-.019c.211-.157.37-.273.621-.316.26.708.675 1.37 1.242 1.938A5.4 5.4 0 0 0 9.85 15.08a.7.7 0 0 1-.081.336c-.044.082-.1.15-.185.25l-.025.03-.02.024a2 2 0 0 0-.319.504 2.1 2.1 0 0 0-.147.839c0 .792.5 1.294 1.045 1.581.54.283 1.174.389 1.605.389.438 0 1.083-.077 1.632-.324.552-.25 1.078-.71 1.078-1.49 0-.343-.06-.614-.157-.845a2.6 2.6 0 0 0-.328-.542l-.019-.026c-.155-.21-.271-.367-.314-.615a5.35 5.35 0 0 0 2.064-1.287 5.35 5.35 0 0 0 1.315-2.147.335.335 0 0 0-.253-.432 2.5 2.5 0 0 0-.488-.047c-.619 0-.956.251-1.237.46l-.002.002-.03.022a2 2 0 0 1-.404.248c-.142.06-.324.105-.584.105-.408 0-.685-.254-.878-.683-.196-.434-.265-.976-.265-1.356 0-.346.089-.87.312-1.293.219-.417.533-.686.987-.686.275 0 .454.042.58.095.129.054.224.125.333.216l.046.038.004.003c.095.081.217.184.367.264.188.101.408.162.693.162q.315-.001.595-.124a.336.336 0 0 0 .183-.418 5.35 5.35 0 0 0-1.274-2.026 5.35 5.35 0 0 0-2.017-1.27.6.6 0 0 1 .056-.134c.045-.081.102-.147.188-.246l.047-.054c.105-.122.231-.277.328-.498.096-.221.155-.489.161-.836.014-.792-.477-1.303-1.017-1.599m3.005 6.696-.012.003q-.118.03-.243.03a1 1 0 0 1-.443-.093 1.6 1.6 0 0 1-.312-.222l-.003-.003c-.122-.103-.262-.22-.46-.31-.202-.092-.455-.151-.805-.151-.694 0-1.141.432-1.408.94a3.5 3.5 0 0 0-.367 1.515c0 .421.075 1.036.307 1.551.233.517.641.963 1.312.963.33 0 .58-.06.79-.15.204-.09.362-.208.506-.315l.004-.003c.266-.198.498-.369.957-.369a2 2 0 0 1 .212.01l.023.003-.01.027a4.9 4.9 0 0 1-1.135 1.775 4.9 4.9 0 0 1-2.12 1.248.14.14 0 0 0-.102.134v.012c0 .553.218.846.422 1.122l.002.002c.109.146.21.283.285.456.075.17.127.383.127.677 0 .515-.332.847-.798 1.056-.467.21-1.039.282-1.435.282-.372 0-.927-.094-1.385-.334-.455-.239-.79-.608-.79-1.16 0-.317.052-.53.124-.69a1.7 1.7 0 0 1 .273-.398l.004-.005c.088-.103.184-.217.256-.363.074-.152.12-.331.12-.567q0-.112-.018-.22a.14.14 0 0 0-.09-.108 4.9 4.9 0 0 1-1.8-1.144 4.9 4.9 0 0 1-1.21-1.996.14.14 0 0 0-.133-.098h-.012c-.553 0-.847.218-1.122.422l-.002.002a2.3 2.3 0 0 1-.456.285c-.17.075-.383.127-.677.127-.516 0-.847-.332-1.057-.798-.21-.467-.282-1.039-.282-1.436 0-.371.094-.927.335-1.384.238-.455.608-.791 1.16-.791.317 0 .53.053.69.125s.274.169.398.273l.005.004c.103.087.217.184.363.256.151.074.33.12.567.12q.062 0 .123-.005a.14.14 0 0 0 .12-.096 4.9 4.9 0 0 1 1.19-1.935 4.9 4.9 0 0 1 1.845-1.16.14.14 0 0 0 .093-.127l.002-.056c.01-.554-.203-.851-.403-1.13l-.001-.002a2.3 2.3 0 0 1-.278-.46 1.6 1.6 0 0 1-.115-.68c.01-.515.347-.84.816-1.042.471-.203 1.044-.264 1.44-.257.372.006.926.11 1.38.358.45.247.78.622.77 1.174-.006.317-.062.53-.137.687-.076.16-.174.272-.28.394l-.004.005c-.09.101-.187.214-.262.358-.077.15-.126.327-.13.563a.14.14 0 0 0 .1.137 4.9 4.9 0 0 1 2.09 1.238c.504.504.875 1.091 1.113 1.717l-.022.006z",
		clipRule: "evenodd"
	})), _path2$5 || (_path2$5 = /*#__PURE__*/ React.createElement("path", {
		fill: "#505050",
		d: "M14.027 7.141a.387.387 0 1 0 0-.773.387.387 0 0 0 0 .773"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/Slack.svg
var _path$7;
var _path2$4;
var _path3$2;
var _path4;
function _extends$7() {
	return _extends$7 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$7.apply(null, arguments);
}
var SvgSlack = function SvgSlack(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$7({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$7 || (_path$7 = /*#__PURE__*/ React.createElement("path", {
		fill: "#E01E5A",
		fillRule: "evenodd",
		d: "M3.365 14.123a1.77 1.77 0 0 0 1.765-1.765v-1.765H3.365A1.77 1.77 0 0 0 1.6 12.358a1.77 1.77 0 0 0 1.765 1.765m4.419-3.53a1.77 1.77 0 0 0-1.765 1.765v4.419a1.77 1.77 0 0 0 1.765 1.765 1.77 1.77 0 0 0 1.765-1.765v-4.419a1.77 1.77 0 0 0-1.765-1.765",
		clipRule: "evenodd"
	})), _path2$4 || (_path2$4 = /*#__PURE__*/ React.createElement("path", {
		fill: "#ECB22E",
		fillRule: "evenodd",
		d: "M10.451 12.358a1.77 1.77 0 0 0 1.765 1.765h4.42a1.77 1.77 0 0 0 1.764-1.765 1.77 1.77 0 0 0-1.765-1.765h-4.419a1.77 1.77 0 0 0-1.765 1.765m3.53 4.419a1.77 1.77 0 0 0-1.765-1.765h-1.765v1.765a1.77 1.77 0 0 0 1.765 1.765 1.77 1.77 0 0 0 1.765-1.765",
		clipRule: "evenodd"
	})), _path3$2 || (_path3$2 = /*#__PURE__*/ React.createElement("path", {
		fill: "#2EB67D",
		fillRule: "evenodd",
		d: "M12.216 9.69a1.77 1.77 0 0 0 1.765-1.764v-4.42a1.77 1.77 0 0 0-1.765-1.764 1.77 1.77 0 0 0-1.765 1.765v4.419a1.77 1.77 0 0 0 1.765 1.764m4.42-3.53a1.77 1.77 0 0 0-1.766 1.766V9.69h1.765A1.77 1.77 0 0 0 18.4 7.926a1.77 1.77 0 0 0-1.765-1.765",
		clipRule: "evenodd"
	})), _path4 || (_path4 = /*#__PURE__*/ React.createElement("path", {
		fill: "#36C5F0",
		fillRule: "evenodd",
		d: "M6.019 3.507A1.77 1.77 0 0 0 7.784 5.27h1.765V3.507a1.77 1.77 0 0 0-1.765-1.765 1.77 1.77 0 0 0-1.765 1.765m3.53 4.419A1.77 1.77 0 0 0 7.784 6.16h-4.42A1.77 1.77 0 0 0 1.6 7.926 1.77 1.77 0 0 0 3.365 9.69h4.419a1.77 1.77 0 0 0 1.765-1.764",
		clipRule: "evenodd"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/Splunk.svg
var _path$6;
function _extends$6() {
	return _extends$6 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$6.apply(null, arguments);
}
var SvgSplunk = function SvgSplunk(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$6({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$6 || (_path$6 = /*#__PURE__*/ React.createElement("path", {
		fill: "#0B1724",
		d: "M16.972 11.59V8.74L3.028 1.742V4.88l10.806 5.261-10.806 5.333v3.067z"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/Supabase.svg
var _path$5;
var _path2$3;
var _path3$1;
var _defs$1;
function _extends$5() {
	return _extends$5 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$5.apply(null, arguments);
}
var SvgSupabase = function SvgSupabase(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$5({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$5 || (_path$5 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#a)",
		d: "M11.38 18.263c-.429.54-1.3.244-1.31-.446L9.92 7.723h6.786c1.23 0 1.915 1.42 1.15 2.383z"
	})), _path2$3 || (_path2$3 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#b)",
		fillOpacity: .2,
		d: "M11.38 18.263c-.429.54-1.3.244-1.31-.446L9.92 7.723h6.786c1.23 0 1.915 1.42 1.15 2.383z"
	})), _path3$1 || (_path3$1 = /*#__PURE__*/ React.createElement("path", {
		fill: "#3ECF8E",
		d: "M8.62 2.021c.43-.54 1.3-.244 1.31.446l.066 10.093H3.294c-1.23 0-1.915-1.42-1.15-2.382z"
	})), _defs$1 || (_defs$1 = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
		id: "a",
		x1: 9.919,
		x2: 15.951,
		y1: 9.961,
		y2: 12.491,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#249361" }), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#3ECF8E"
	})), /*#__PURE__*/ React.createElement("linearGradient", {
		id: "b",
		x1: 7.245,
		x2: 9.996,
		y1: 6.3,
		y2: 11.478,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", null), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopOpacity: 0
	})))));
};

//#endregion
//#region src/ServiceIcon/icons/Twitter.svg
var _path$4;
function _extends$4() {
	return _extends$4 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$4.apply(null, arguments);
}
var SvgTwitter = function SvgTwitter(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$4({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$4 || (_path$4 = /*#__PURE__*/ React.createElement("path", {
		fill: "#1D9BF0",
		d: "M16.68 6.715c.01.148.01.296.01.445 0 4.555-3.467 9.807-9.807 9.807v-.002A9.76 9.76 0 0 1 1.6 15.419q.409.05.82.05a6.92 6.92 0 0 0 4.281-1.478 3.45 3.45 0 0 1-3.22-2.394c.517.1 1.049.08 1.556-.059A3.45 3.45 0 0 1 2.272 8.16v-.044c.48.267 1.016.415 1.565.431A3.45 3.45 0 0 1 2.77 3.945a9.78 9.78 0 0 0 7.103 3.601 3.449 3.449 0 0 1 5.874-3.144 6.9 6.9 0 0 0 2.189-.836 3.46 3.46 0 0 1-1.515 1.906 6.9 6.9 0 0 0 1.979-.543 7 7 0 0 1-1.72 1.786"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/Vercel.svg
var _path$3;
function _extends$3() {
	return _extends$3 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$3.apply(null, arguments);
}
var SvgVercel = function SvgVercel(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$3({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 20,
		fill: "none",
		viewBox: "0 0 20 20"
	}, props), _path$3 || (_path$3 = /*#__PURE__*/ React.createElement("path", {
		fill: "#000",
		d: "m10 1 9.987 17.297H.014z"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/VMWare.svg
var _path$2;
var _path2$2;
var _defs;
function _extends$2() {
	return _extends$2 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$2.apply(null, arguments);
}
var SvgVmWare = function SvgVmWare(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$2({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$2 || (_path$2 = /*#__PURE__*/ React.createElement("path", {
		fill: "url(#a)",
		d: "M17.25 2.892H2.75v14.5h14.5z"
	})), _path2$2 || (_path2$2 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M5.863 8.275c-.121-.302-.464-.423-.766-.302a.537.537 0 0 0-.261.765l1.288 2.8c.202.442.423.684.826.684.423 0 .604-.262.826-.684 0 0 1.128-2.457 1.148-2.478.02-.02.04-.1.16-.1.102 0 .162.08.162.18v2.377c0 .363.201.685.584.685.403 0 .604-.302.604-.685V9.584c0-.383.282-.624.624-.624.363 0 .605.261.605.624v1.954c0 .362.201.684.584.684.402 0 .604-.302.604-.684V9.583c0-.383.282-.624.624-.624.363 0 .604.261.604.624v1.954c0 .362.202.684.584.684.403 0 .604-.302.604-.684V9.322c0-.826-.644-1.39-1.45-1.39s-1.288.544-1.288.544c-.282-.342-.625-.543-1.249-.543-.644 0-1.228.543-1.228.543-.262-.342-.726-.543-1.068-.543-.564 0-1.027.261-1.309.886l-.826 1.933z"
	})), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
		id: "a",
		x1: 2.75,
		x2: 17.25,
		y1: 17.392,
		y2: 2.892,
		gradientUnits: "userSpaceOnUse"
	}, /*#__PURE__*/ React.createElement("stop", { stopColor: "#204A91" }), /*#__PURE__*/ React.createElement("stop", {
		offset: 1,
		stopColor: "#008CD5"
	})))));
};

//#endregion
//#region src/ServiceIcon/icons/Workday.svg
var _path$1;
var _path2$1;
var _path3;
function _extends$1() {
	return _extends$1 = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends$1.apply(null, arguments);
}
var SvgWorkday = function SvgWorkday(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends$1({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path$1 || (_path$1 = /*#__PURE__*/ React.createElement("path", {
		fill: "#225FAC",
		d: "M1.6 1.742h16.8v16.8H1.6z"
	})), _path2$1 || (_path2$1 = /*#__PURE__*/ React.createElement("path", {
		fill: "#F18B21",
		d: "M13.215 7.75C12.669 6.373 11.439 5.52 10 5.52c-1.439 0-2.671.854-3.214 2.23a.37.37 0 0 0 .03.35.43.43 0 0 0 .354.177.43.43 0 0 0 .406-.272c.407-1.028 1.335-1.666 2.424-1.666s2.016.638 2.422 1.666a.43.43 0 0 0 .405.272.43.43 0 0 0 .355-.177.37.37 0 0 0 .03-.35"
	})), _path3 || (_path3 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M12.159 13.692c-.033.1-.109.163-.248.163h-.785c-.128 0-.193-.037-.224-.163l-.742-2.767c-.075-.28-.107-.606-.151-.933-.031.327-.074.66-.15.933l-.74 2.767c-.022.1-.107.163-.247.163h-.795c-.129 0-.194-.037-.226-.163L6.77 9.712c-.032-.136.053-.218.171-.218h.504c.14 0 .215.046.247.181l.687 2.84c.075.326.097.662.13.969.054-.299.096-.65.182-.96l.763-2.858c.032-.117.129-.172.257-.172h.622c.129 0 .237.064.27.181l.772 2.85c.086.307.13.652.172.959.042-.299.086-.65.15-.96l.634-2.858c.022-.117.127-.172.257-.172h.472c.119 0 .205.073.172.21l-1.073 3.988"
	})));
};

//#endregion
//#region src/ServiceIcon/icons/Zoom.svg
var _path;
var _path2;
function _extends() {
	return _extends = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends.apply(null, arguments);
}
var SvgZoom = function SvgZoom(props) {
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		width: 20,
		height: 21,
		fill: "none",
		viewBox: "0 0 20 21"
	}, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
		fill: "#4A8CFF",
		d: "M1.6 9.092c0-3.465 0-5.197 1.076-6.274s2.81-1.076 6.274-1.076h2.1c3.465 0 5.197 0 6.274 1.076S18.4 5.627 18.4 9.092v2.1c0 3.465 0 5.197-1.076 6.273-1.077 1.077-2.81 1.077-6.274 1.077h-2.1c-3.465 0-5.197 0-6.274-1.077S1.6 14.657 1.6 11.192z"
	})), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M5.14 7.77v3.56c.002.805.66 1.453 1.462 1.45h5.19a.265.265 0 0 0 .266-.263v-3.56a1.457 1.457 0 0 0-1.463-1.45h-5.19a.265.265 0 0 0-.266.263m7.248 1.389 2.142-1.566c.186-.153.33-.115.33.164v4.773c0 .317-.176.279-.33.163l-2.142-1.562z"
	})));
};

//#endregion
//#region src/ServiceIcon/index.ts
const ServiceIconSVG = {
	AccessPeopleHR: SvgAccessPeopleHr,
	ADP: SvgAdp,
	Apple: SvgApple,
	Asana: SvgAsana,
	Auth0: SvgAuth0,
	Azure: SvgAzure,
	BambooHR: SvgBambooHr,
	BreatheHR: SvgBreatheHr,
	CAS: SvgCas,
	CezanneHR: SvgCezanneHr,
	Chrome: SvgChrome,
	ClassLink: SvgClassLink,
	Cloudflare: SvgCloudflare,
	CyberArk: SvgCyberArk,
	Datadog: SvgDatadog,
	Docusign: SvgDocusign,
	Duo: SvgDuo,
	Figma: SvgFigma,
	Firebase: SvgFirebase,
	Firefox: SvgFirefox,
	Fourth: SvgFourth,
	Github: SvgGithub,
	GoDaddy: SvgGoDaddy,
	Google: SvgGoogle,
	GoogleCloud: SvgGoogleCloud,
	Greenhouse: SvgGreenhouse,
	HiBob: SvgHiBob,
	JIRA: SvgJira,
	JumpCloud: SvgJumpCloud,
	Keycloak: SvgKeycloak,
	Kisi: SvgKisi,
	LastPass: SvgLastPass,
	Linear: SvgLinear,
	LoginGOV: SvgLoginGov,
	Loom: SvgLoom,
	Microsoft: SvgMicrosoft,
	MiniOrange: SvgMiniOrange,
	NetIQ: SvgNetIq,
	Notion: SvgNotion,
	Okta: SvgOkta,
	OneLogin: SvgOneLogin,
	OnePassword: SvgOnePassword,
	Oracle: SvgOracle,
	Personio: SvgPersonio,
	PingIdentity: SvgPingIdentity,
	Quip: SvgQuip,
	Ramp: SvgRamp,
	ReactNativeExpo: SvgReactNativeExpo,
	Rippling: SvgRippling,
	Salesforce: SvgSalesforce,
	Sentry: SvgSentry,
	Shibboleth: SvgShibboleth,
	SimpleSAMLPHP: SvgSimpleSamlphp,
	Slack: SvgSlack,
	Splunk: SvgSplunk,
	Supabase: SvgSupabase,
	Twitter: SvgTwitter,
	Vercel: SvgVercel,
	VMWare: SvgVmWare,
	Workday: SvgWorkday,
	Zoom: SvgZoom,
	Airtable: SvgAirtable
};

//#endregion
export { BrandIconSVG, BrandingSVG, FavIconSVG, HardwareIconSVG, IconSVG, LogoSVG, ManufacturerIconSVG, PortIconSVG, ProductIconSVG, ProviderIconSVG, ServiceIconSVG };
//# sourceMappingURL=index.mjs.map